/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 388);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(724)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(723)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(604);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(40);
var hide = __webpack_require__(32);
var redefine = __webpack_require__(33);
var ctx = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(607)();
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _reactDatetime = __webpack_require__(732);

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _emailValidation = __webpack_require__(739);

var _Select = __webpack_require__(740);

var _Select2 = _interopRequireDefault(_Select);

var _regexps = __webpack_require__(741);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** [Note! This is from newloyalty. Change it?]
 *
 *  DataTypes for user profile field as defined in the backend's UserFieldDataType enum. (And used in the DB)
 *
 *  Never write to any of the fields in the exported object. Consider them immutable!
 *
 *  IMPORTANT!!
 *  This file and the UserFieldDataType enum on the backend MUST be in sync!
 */

var UserFieldDataType = {

    string: {
        id: 1,
        displayName: "string",
        getErrorMessage: function getErrorMessage() {
            return "Skal være tekst.";
        }, // "Must be a string.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            return true;
        },
        createInputElement: function createInputElement(props, options) {
            return _react2.default.createElement('input', _extends({ type: 'text' }, props));
        }
    },
    text: {
        id: 2,
        displayName: "text",
        getErrorMessage: function getErrorMessage() {
            return "Skal være tekst.";
        }, // "Must be a text.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a text
            return true;
        },
        createInputElement: function createInputElement(props, options) {
            return _react2.default.createElement(
                'textarea',
                props,
                props.value
            );
        }
    },
    int: {
        id: 3,
        displayName: "integer",
        getErrorMessage: function getErrorMessage() {
            return "Skal være et tal.";
        }, // "Must be an integer.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            var i = ~~Number(value); // convert string to number and number to integer
            return String(i) === value; // http://stackoverflow.com/questions/10834796/validate-that-a-string-is-a-positive-integer
        },
        createInputElement: function createInputElement(props, options) {
            // TODO: Maybe have an onChange (wrapping the given on change) disallowing non-number input?
            return _react2.default.createElement('input', _extends({ type: 'text', pattern: '[0-9]' }, props));
        }
    },
    float: {
        id: 4,
        displayName: "float",
        getErrorMessage: function getErrorMessage() {
            return "Skal være et tal.";
        }, // "Must be a number.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            var i = Number(value.replace(',', '.')); // convert string to number and number to integer
            return !isNaN(i);
        },
        createInputElement: function createInputElement(props, options) {
            // TODO: Maybe have an onChange (wrapping the given on change) disallowing non-number input?
            return _react2.default.createElement('input', _extends({ type: 'text', pattern: '([0-9]*[.])?[0-9]' }, props));
        }
    },
    date: {
        id: 5,
        displayName: "date",
        getErrorMessage: function getErrorMessage() {
            return "Skal være en gyldig dato i formatet " + _config2.default.formats.dateFormat + ".";
        }, //"Must be a valid date in the format YYYY-MM-DD.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            return (0, _moment2.default)(value, _config2.default.formats.dateFormat, true).isValid(); // http://momentjs.com/docs/
        },
        createInputElement: function createInputElement(props, options) {
            return createDateInputElement(props, _config2.default.formats.dateFormat, false);
        }
    },
    datetime: {
        id: 6,
        displayName: "datetime",
        getErrorMessage: function getErrorMessage() {
            return "Skal være et gyldigt tidspunkt i formatet " + _config2.default.formats.dateTimeFormat + ".";
        }, //"Must be a valid date and time in the format YYYY-MM-DD HH:mm:ss.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            return _moment2.default.utc(value, _config2.default.formats.dateTimeFormat, true).tz("Europe/Copenhagen").isValid(); // http://momentjs.com/docs/
        },
        createInputElement: function createInputElement(props, options) {
            return createDateInputElement(props, _config2.default.formats.dateFormat, _config2.default.formats.timeFormat);
        }
    },
    enum: {
        id: 7,
        displayName: "selector",
        getErrorMessage: function getErrorMessage() {
            return "Skal vælge en af værdierne.";
        }, //"Must select one of the values.",
        requiresOptions: true,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            if (typeof options === "undefined") throw new Error("'options' was undefined for the enum data-type!");
            return options.findIndex(function (o) {
                return o.key === value;
            }) != -1;
        },
        createInputElement: function createInputElement(props, options) {
            if (typeof options === "undefined") throw new Error("'options' was undefined for the enum data-type!");
            var optionsHtml = options.map(function (option) {
                return _react2.default.createElement(
                    'option',
                    { value: option.key, key: option.key },
                    option.value
                );
            });
            return _react2.default.createElement(
                _Select2.default,
                props,
                props.placeholder === false || props.placeholder === 'false' ? null : _react2.default.createElement(
                    'option',
                    { disabled: true, value: '', key: '', className: 'select-placeholder-option' },
                    props.placeholder ? props.placeholder : "Select value"
                ),
                optionsHtml
            );
        }
    },
    regex: {
        id: 8,
        displayName: "regex",
        getErrorMessage: function getErrorMessage() {
            return "Ikke i korrekt format.";
        }, //"Not in correct format.",
        requiresOptions: true,
        REGEX_OPTION_KEY: "regex",
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            if (typeof options === "undefined") throw new Error("'options' was undefined for the regex data-type!");
            var regexOption = options.find(function (o) {
                return o.key === UserFieldDataType.regex.REGEX_OPTION_KEY;
            });
            if (!regexOption) return false; // if the regex-option is missing, return false (should never happen)
            var regex = "^(" + regexOption.value + ")$";
            return value.match(new RegExp(regex, "g")) !== null;
        },
        createInputElement: function createInputElement(props, options) {
            return _react2.default.createElement('input', _extends({ type: 'text' }, props));
        }
    },
    options: {
        id: 9,
        displayName: "option buttons",
        getErrorMessage: function getErrorMessage() {
            return "Skal vælge en af værdierne.";
        }, //"Must select one of the values.",
        requiresOptions: true,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            if (typeof options === "undefined") throw new Error("'options' was undefined for the options data-type!");
            return options.findIndex(function (o) {
                return o.key === value;
            }) != -1;
        },
        createInputElement: function createInputElement(props, options) {
            var name = props.name;
            var value = props.value;
            var _onChange = props.onChange;
            delete props.name;
            delete props.value;
            delete props.onChange;
            if (typeof options === "undefined") throw new Error("'options' was undefined for the options data-type!");
            var optionsHtml = options.map(function (option) {
                return _react2.default.createElement(
                    'span',
                    { className: 'option-container', key: option.key },
                    _react2.default.createElement(
                        'span',
                        { className: 'option-button' },
                        _react2.default.createElement('input', { type: 'radio', id: name + '|' + option.key, name: name, onChange: function onChange(e) {
                                e.target.value = option.key;
                                _onChange(e);
                            }, checked: option.key === value, disabled: option.disabled === true })
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: "option-title" + (option.disabled === true ? ' disabled' : '') },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: name + '|' + option.key },
                            option.value
                        )
                    )
                );
            });
            return _react2.default.createElement(
                'div',
                props,
                optionsHtml
            );
        }
    },

    /** Data types used only at front end */
    password: {
        id: 1000,
        displayName: "password",
        getErrorMessage: function getErrorMessage() {
            return "Mindst 6 tegn";
        }, //"Must be a password.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must be a string
            return new RegExp(_regexps.passwordRegex).test(value);
        },
        createInputElement: function createInputElement(props, options) {
            return _react2.default.createElement('input', _extends({ type: 'password' }, props));
        }
    },
    email: {
        id: 1001,
        displayName: "email",
        getErrorMessage: function getErrorMessage() {
            return "Skal være en e-mail adresse.";
        }, //"Must be a valid email address.",
        requiresOptions: false,
        isCompatibleValue: function isCompatibleValue(value, options) {
            // "value" must contain the @ character
            return (0, _emailValidation.isValidEmail)(value); //return /.@./.test(value);
        },
        createInputElement: function createInputElement(props, options) {
            return _react2.default.createElement('input', _extends({ type: 'email' }, props));
        }
    },

    /** Get list of all data-types */
    values: function values() {
        var getAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var values = [];
        for (var datatypeName in UserFieldDataType) {
            if (UserFieldDataType.hasOwnProperty(datatypeName)) {
                var datatype = UserFieldDataType[datatypeName]; // <- "datatypeName" from the for..in loop is a string, not the object itself, so need to lookup corresponding object...
                if (typeof datatype !== "function" && (getAll || datatype.id < 1000)) // <- don't include this method for example - only the data-type definitions
                    values.push(datatype);
            }
        }
        return _immutable2.default.List(values);
    },

    /** Get data-type by id */
    getById: function getById(id) {
        if (typeof id === "string") id = parseInt(id);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = UserFieldDataType.values(true)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var datatype = _step.value;

                if (datatype.id == id) return datatype;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        throw new Error("The datatype-id " + id + " does not correspond to an existing datatype");
    }
};

// Private helper method to create the input-element of date or datetime types (to avoid duplication above)
function createDateInputElement(props, dateFormat, timeFormat) {

    var dateTimeFormat = timeFormat != false ? dateFormat + " " + timeFormat : dateFormat; // "timeFormat = false" means no time, only date.

    // https://github.com/YouCanBookMe/react-datetime
    var inputProps = Object.assign({}, props); // copy of props - these are the props given to the "inputProps"-prop of <DateTimeField> (will be put on the <input> element)
    var directProps = Object.assign({}, props); // copy of props - these are the props directly sat as props on <DateTimeField>

    delete inputProps.onChange; // delete "onChange", "value" from inputProps - keep everything else
    delete inputProps.value;
    delete inputProps.onFocus; // and also delete onFocus and onBlur
    delete inputProps.onBlur;
    delete inputProps.viewMode;
    Object.keys(directProps).forEach(function (k) {
        if (k != "onChange" && k != "value" && k != "onBlur" && k != "onFocus" && k != "viewMode") delete directProps[k];
    }); // delete everything but "onChange", "value", etc

    if (directProps.onChange) {
        // The parameter given to onChange from the datatime picker is different to how it is for normal input fields (the value instead of the event), so here i try to convert it to the "event" format (only what's necessary), so the same onChange can be used for Dates as for the other types...
        var oldOnChange = directProps.onChange;
        directProps.onChange = function (newValue) {
            if ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) == "object") {
                // it is a moment object - convert it to a string
                newValue = (0, _moment2.default)(newValue).format(dateTimeFormat);
            }
            var e = {
                target: {
                    value: newValue,
                    name: props.name
                }
            };
            oldOnChange(e);
        };
    }

    return _react2.default.createElement(_reactDatetime2.default, _extends({ showToday: true, input: true, closeOnSelect: true, locale: 'da', dateFormat: dateFormat, timeFormat: timeFormat, defaultText: '', inputProps: inputProps }, directProps));
}

exports.default = UserFieldDataType;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBubble = __webpack_require__(742);

var _reactBubble2 = _interopRequireDefault(_reactBubble);

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** Just a component made as a simple wrapper around UserFieldDataTypeEnum.js's createInputElement, so that the syntax gets a bit prettier
 *  for the callers (a JSX-tag instead of a method call).
 *
 *  In addition to this, it has some additional simple capabilities, such as being able to automatically validate and show error message if validation error.
 *  (Again, just using the UserFieldDataType-enum methods).
 *
 *  Props:
 *      dataType             = one of the entries in the UserFieldDataType-enum (from UserFieldDataTypeEnum.js)
 *      options              = (optional for some dataTypes) the options to the dataType
 *      isError              = (optional if autoCheckErrors is true)
 *      autoCheckErrors      = (optional is isError is given) (assumes value-prop contains the value) (is false by default, since the caller might want to synchronize the error variable with this one.... perhaps it should always be autodetect, but this makes the callers error very visible...)
 *      errorMessageOverride = (optional) If you want to use a different error message than the default.
 *      required             = (optional) If true, a field value must be provided.
 *      hideErrWhenFocused   = (optional) If true, the field is not validated while focused (to avoid fields being highlighted as invalid until fully entered). Do not use for date and datetime fields as calendar will be hidden.
 *      hideErrUntilFocused  = (optional) If true, the field is not validated until after first focus (to avoid initial blank fields to be highlighted as invalid). Do not use for date and datetime fields as calendar will be hidden.
 *      resetStateKey        = (optional) Used to reset the "focused" and "visited" state. When this value changes, we reset the focused and visited values to default. This allows to reset the form, if we're not navigating away from the page, without "field must have a value" error messages.
 *      ...the rest...       = will be given to the component from UserFieldDataType.createInputElement()
 *
 *  TODO: I just quickly selected the "react-bubble" library to show the errors. Perhaps that is not the prettiest or best. (forcing to set width/height for example...)
 */
var UserFieldElement = function (_React$Component) {
    _inherits(UserFieldElement, _React$Component);

    function UserFieldElement(props) {
        _classCallCheck(this, UserFieldElement);

        var _this = _possibleConstructorReturn(this, (UserFieldElement.__proto__ || Object.getPrototypeOf(UserFieldElement)).call(this, props));

        _this.isValid = function () {
            var result = _this.props.autoCheckErrors ? _this.props.required && (_this.props.value === null || _this.props.value == "") ? false : _this.props.required == false && (_this.props.value === null || _this.props.value == "") ? true : _this.props.pattern && !new RegExp(_this.props.pattern).test(_this.props.value) ? false : _this.props.isError ? false : _this.props.dataType.isCompatibleValue(_this.props.value, _this.props.options) : !_this.props.isError;
            return result;
        };

        _this.state = {
            focused: false,
            visited: false
        };
        return _this;
    }

    _createClass(UserFieldElement, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.resetStateKey && nextProps.resetStateKey !== this.props.resetStateKey) this.setState({ focused: false, visited: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var dataType = this.props.dataType;
            var options = this.props.options;
            var errorMessageOverride = this.props.errorMessageOverride;
            var isError = this.props.hideErrUntilFocused && !this.state.visited ? false : this.props.hideErrWhenFocused && this.state.focused ? false : !this.isValid();
            var propsToPassAlong = Object.assign({}, this.props);
            delete propsToPassAlong.dataType;
            delete propsToPassAlong.options;
            delete propsToPassAlong.isError;
            delete propsToPassAlong.errorMessageOverride;
            delete propsToPassAlong.autoCheckErrors;
            delete propsToPassAlong.required;
            delete propsToPassAlong.hideErrWhenFocused;
            delete propsToPassAlong.hideErrUntilFocused;
            delete propsToPassAlong.resetStateKey;
            delete propsToPassAlong.errorWidth;
            delete propsToPassAlong.errorHeight;
            delete propsToPassAlong.errorStyle;
            delete propsToPassAlong.containerClassName;

            if (typeof propsToPassAlong.onFocus == "undefined" && this.props.hideErrWhenFocused) propsToPassAlong.onFocus = function () {
                _this2.setState({ focused: true });
            };
            if (typeof propsToPassAlong.onBlur == "undefined" && (this.props.hideErrWhenFocused || this.props.hideErrUntilFocused)) propsToPassAlong.onBlur = function () {
                _this2.setState({ focused: false, visited: true });
            };

            if (isError) {
                if (typeof propsToPassAlong.className == "undefined") propsToPassAlong.className = "";
                propsToPassAlong.className += " validation-error";
            }

            var element = dataType.createInputElement(propsToPassAlong, options);
            var errorTextElement = !isError || this.props.disabled === true && this.props.hideErrorIfDisabled === true ? "" : _react2.default.createElement(
                _reactBubble2.default,
                { width: this.props.errorWidth ? this.props.errorWidth : 256, height: "auto", style: this.props.errorStyle ? this.props.errorStyle : { container: { zIndex: 99, minHeight: 45 } } },
                _react2.default.createElement(
                    'div',
                    { style: { padding: 10 } },
                    this.props.autoCheckErrors && this.props.required && (this.props.value === null || this.props.value == "") ? "Skal være udfyldt." //"Must have a value."
                    : errorMessageOverride ? errorMessageOverride : dataType.getErrorMessage()
                )
            );

            return _react2.default.createElement(
                'div',
                { className: "user-field-element" + (this.props.containerClassName ? ' ' + this.props.containerClassName : '') },
                element,
                errorTextElement
            );
        }
    }]);

    return UserFieldElement;
}(_react2.default.Component);

UserFieldElement.propTypes = {
    dataType: _propTypes2.default.object.isRequired,
    options: _propTypes2.default.array, //.isRequired,
    isError: _propTypes2.default.bool, // optional if autoCheckErrors is given and is true
    autoCheckErrors: _propTypes2.default.bool, // optional if isError is given
    errorMessageOverride: _propTypes2.default.string, // optional
    required: _propTypes2.default.bool, // optional
    hideErrWhenFocused: _propTypes2.default.bool, // optional
    hideErrUntilFocused: _propTypes2.default.bool, // optional
    resetStateKey: _propTypes2.default.number, // optional
    errorWidth: _propTypes2.default.string, // optional
    errorHeight: _propTypes2.default.string, // optional
    errorStyle: _propTypes2.default.object, // optional
    containerClassName: _propTypes2.default.string, // optional
    hideErrorIfDisabled: _propTypes2.default.bool
};
UserFieldElement.defaultProps = {
    required: false,
    hideErrorIfDisabled: false
};
exports.default = UserFieldElement;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * User roles with IDs as defined in the DB.
 *
 * Never change or reuse an ID!
 * Consider this object immutable - never modify it at runtime!
 */
var UserRoles = {

    // Define role id's as 1, 2, 4, 8, 16.... allowing users to have multiple roles using a single database field
    USER: { id: 1 },
    CLUB_ADMIN: { id: 2 },
    SECTION_ADMIN: { id: 4 },
    MAIN_ADMIN: { id: 8 },
    ALLOW_ANONYMOUS: null, // <- a special entry which is not a real role, but rather a lack of role. Used in controllers to signal anonymous access is allowed. (Perhaps remove it from here?)


    /** Get list of all user roles (not including ALLOW_ANONYMOUS)*/
    values: function values() {
        var values = [];
        for (var userRoleName in UserRoles) {
            if (UserRoles.hasOwnProperty(userRoleName)) {
                var userRole = UserRoles[userRoleName];
                if (typeof userRole !== "function" && userRole !== UserRoles.ALLOW_ANONYMOUS) values.push(userRole);
            }
        }
        return Immutable.List(values);
    },

    /** Get user role by id */
    getById: function getById(id) {
        if (typeof id === "string") id = parseInt(id);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = UserRoles.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var userRole = _step.value;

                if (userRole.id === id) return userRole;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        throw new Error("The User Role id " + id + " does not correspond to an existing User Role.");
    }
};

exports.default = UserRoles;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Notifications", {
  enumerable: true,
  get: function get() {
    return _Notifications.default;
  }
});
Object.defineProperty(exports, "NotificationContainer", {
  enumerable: true,
  get: function get() {
    return _NotificationContainer.default;
  }
});
Object.defineProperty(exports, "NotificationManager", {
  enumerable: true,
  get: function get() {
    return _NotificationManager.default;
  }
});
exports.default = void 0;

var _Notifications = _interopRequireDefault(__webpack_require__(227));

var _NotificationContainer = _interopRequireDefault(__webpack_require__(683));

var _NotificationManager = _interopRequireDefault(__webpack_require__(232));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Notifications.default;
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBasics = getBasics;
exports.getClubs = getClubs;
exports.getClub = getClub;
exports.getMembers = getMembers;
exports.getMember = getMember;
exports.getPigeonHole = getPigeonHole;
exports.createClub = createClub;
exports.updateClub = updateClub;
exports.deleteClub = deleteClub;
exports.createMember = createMember;
exports.updateMember = updateMember;
exports.deleteMember = deleteMember;
exports.createPigeonHole = createPigeonHole;
exports.updatePigeonHole = updatePigeonHole;
exports.deletePigeonHole = deletePigeonHole;
exports.createPigeon = createPigeon;
exports.updatePigeon = updatePigeon;
exports.deletePigeon = deletePigeon;
exports.createPigeons = createPigeons;
exports.updatePigeons = updatePigeons;
exports.deletePigeons = deletePigeons;
exports.createRingSerie = createRingSerie;
exports.updateRingSerie = updateRingSerie;
exports.deleteRingSerie = deleteRingSerie;
exports.getStationSelections = getStationSelections;
exports.selectStations = selectStations;
exports.unselectStations = unselectStations;
exports.calculateDistances = calculateDistances;
exports.setWebPublishing = setWebPublishing;
exports.setWebPublishingForClub = setWebPublishingForClub;
exports.resetBeginners = resetBeginners;
exports.resetBeginnersForClub = resetBeginnersForClub;
exports.setJuniorPensioner = setJuniorPensioner;
exports.setJuniorPensionerForClub = setJuniorPensionerForClub;
exports.resetUpdateMarkings = resetUpdateMarkings;
exports.getSections = getSections;
exports.getSection = getSection;
exports.createSection = createSection;
exports.updateSection = updateSection;
exports.deleteSection = deleteSection;
exports.getListItems = getListItems;
exports.createListItemItem = createListItemItem;
exports.updateListItem = updateListItem;
exports.deleteListItem = deleteListItem;
exports.exportRaceData = exportRaceData;
exports.importSectionStat = importSectionStat;
exports.invoiceRaces = invoiceRaces;
exports.startSeason = startSeason;
exports.getDashboardData = getDashboardData;
exports.selectUserRole = selectUserRole;
exports.selectDatabase = selectDatabase;
exports.getErrorListItems = getErrorListItems;
exports.updateErrorListItem = updateErrorListItem;
exports.deleteErrorListItem = deleteErrorListItem;
exports.acceptErrorListItem = acceptErrorListItem;
exports.reloadImportFile = reloadImportFile;
exports.getGeneral = getGeneral;
exports.updateGeneral = updateGeneral;
exports.createDeposit = createDeposit;
exports.updateDeposit = updateDeposit;
exports.createMarking = createMarking;
exports.updateMarking = updateMarking;
exports.getSectionPrizes = getSectionPrizes;
exports.createSectionPrize = createSectionPrize;
exports.updateSectionPrize = updateSectionPrize;
exports.deleteSectionPrize = deleteSectionPrize;
exports.getKilometers = getKilometers;
exports.createKilometer = createKilometer;
exports.updateKilometer = updateKilometer;
exports.deleteKilometer = deleteKilometer;
exports.getChampionships = getChampionships;
exports.getChampionship = getChampionship;
exports.createChampionship = createChampionship;
exports.updateChampionship = updateChampionship;
exports.deleteChampionship = deleteChampionship;
exports.createChampionshipRace = createChampionshipRace;
exports.updateChampionshipRace = updateChampionshipRace;
exports.deleteChampionshipRace = deleteChampionshipRace;
exports.createChampionshipRaces = createChampionshipRaces;
exports.updateChampionshipRaces = updateChampionshipRaces;
exports.createChampionshipPigeon = createChampionshipPigeon;
exports.deleteChampionshipPigeons = deleteChampionshipPigeons;
exports.deleteChampionshipPigeon = deleteChampionshipPigeon;
exports.createChampionshipDistZone = createChampionshipDistZone;
exports.updateChampionshipDistZone = updateChampionshipDistZone;
exports.deleteChampionshipDistZone = deleteChampionshipDistZone;
exports.calcChampionships = calcChampionships;
exports.calcSeats = calcSeats;

var _actionconstants = __webpack_require__(35);

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

var _confirmDialog = __webpack_require__(12);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBasics() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getBasicsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/basics'
        }).then(function (response) {
            dispatch(getBasicsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning fra databasen", response));
            dispatch(getBasicsFailure(response));
        });
    };
}

function getBasicsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_BASICS_REQUEST
    };
}

function getBasicsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_BASICS_SUCCESS,
        payload: data
    };
}

function getBasicsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_BASICS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getClubs() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getClubsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/clubs'
        }).then(function (response) {
            dispatch(getClubsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af foreninger fra databasen", response));
            dispatch(getClubsFailure(response));
        });
    };
}

function getClubsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_CLUBS_REQUEST
    };
}

function getClubsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_CLUBS_SUCCESS,
        payload: data
    };
}

function getClubsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_CLUBS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getClub(clubNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getClubRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/club/' + clubNo
        }).then(function (response) {
            dispatch(getClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af forening fra databasen", response));
            dispatch(getClubFailure(response));
        });
    };
}

function getClubRequest() {
    return {
        type: _actionconstants.ADMIN_GET_CLUB_REQUEST
    };
}

function getClubSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_CLUB_SUCCESS,
        payload: data
    };
}

function getClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getMembers() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getMembersRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/members'
        }).then(function (response) {
            dispatch(getMembersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af medlemmer fra databasen", response));
            dispatch(getMembersFailure(response));
        });
    };
}

function getMembersRequest() {
    return {
        type: _actionconstants.ADMIN_GET_MEMBERS_REQUEST
    };
}

function getMembersSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_MEMBERS_SUCCESS,
        payload: data
    };
}

function getMembersFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_MEMBERS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getMember(memberNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getMemberRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/member/' + memberNo
        }).then(function (response) {
            dispatch(getMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af medlem fra databasen", response));
            dispatch(getMemberFailure(response));
        });
    };
}

function getMemberRequest() {
    return {
        type: _actionconstants.ADMIN_GET_MEMBER_REQUEST
    };
}

function getMemberSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_MEMBER_SUCCESS,
        payload: data
    };
}

function getMemberFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_MEMBER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getPigeonHole(clubNo, holeNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(getPigeonHoleRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/pigeon-hole/' + clubNo + '/' + holeNo
        }).then(function (response) {
            dispatch(getPigeonHoleSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af slag fra databasen", response));
            dispatch(getPigeonHoleFailure(response));
        });
    };
}

function getPigeonHoleRequest() {
    return {
        type: _actionconstants.ADMIN_GET_PIGEON_HOLE_REQUEST
    };
}

function getPigeonHoleSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_PIGEON_HOLE_SUCCESS,
        payload: data
    };
}

function getPigeonHoleFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_PIGEON_HOLE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createClub(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createClubRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/club',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Foreningsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af forening", response));
            dispatch(createClubFailure(response));
        });
    };
}

function createClubRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CLUB_REQUEST
    };
}

function createClubSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CLUB_SUCCESS,
        payload: entity
    };
}

function createClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateClub(clubNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateClubRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/club/' + clubNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            response.entity.originalClubNo = clubNo;
            dispatch(updateClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof entity.Foreningsnr === "undefined" ? clubNo : entity.Foreningsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af forening", response));
            dispatch(updateClubFailure(response));
        });
    };
}

function updateClubRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_CLUB_REQUEST
    };
}

function updateClubSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CLUB_SUCCESS,
        payload: entity
    };
}

function updateClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteClub(clubNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteClubRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/club/' + clubNo
        }).then(function (response) {
            dispatch(deleteClubSuccess(clubNo));
            if (onSuccess !== null) onSuccess(clubNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forening", response));
            dispatch(deleteClubFailure(response));
        });
    };
}

function deleteClubRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CLUB_REQUEST
    };
}

function deleteClubSuccess(clubNo) {
    return {
        type: _actionconstants.ADMIN_DELETE_CLUB_SUCCESS,
        payload: clubNo
    };
}

function deleteClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createMember(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createMemberRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/member',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Foreningsnr, typeof entity.Medlemsnr === 'undefined' ? response.entity.newMemberId : entity.Medlemsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af medlem", response));
            dispatch(createMemberFailure(response));
        });
    };
}

function createMemberRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_MEMBER_REQUEST
    };
}

function createMemberSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_MEMBER_SUCCESS,
        payload: entity
    };
}

function createMemberFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_MEMBER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateMember(clubNo, memberNo, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateMemberRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/member/' + clubNo + '/' + memberNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof entity.Foreningsnr === "undefined" ? clubNo : entity.Foreningsnr, typeof entity.Medlemsnr === "undefined" ? memberNo : entity.Medlemsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af medlem", response));
            dispatch(updateMemberFailure(response));
        });
    };
}

function updateMemberRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_MEMBER_REQUEST
    };
}

function updateMemberSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_MEMBER_SUCCESS,
        payload: entity
    };
}

function updateMemberFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_MEMBER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteMember(clubNo, memberNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteMemberRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/member/' + clubNo + '/' + memberNo
        }).then(function (response) {
            dispatch(deleteMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(memberNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af medlem", response));
            dispatch(deleteMemberFailure(response));
        });
    };
}

function deleteMemberRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_MEMBER_REQUEST
    };
}

function deleteMemberSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_MEMBER_SUCCESS,
        payload: entity
    };
}

function deleteMemberFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_MEMBER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createPigeonHole(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createPigeonHoleRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/pigeonhole',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonHoleSuccess(response.entity));
            if (onSuccess !== null) {
                onSuccess(entity.Foreningsnr, entity.Slagnr);
            }
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af slag", response));
            dispatch(createPigeonHoleFailure(response));
        });
    };
}

function createPigeonHoleRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONHOLE_REQUEST
    };
}

function createPigeonHoleSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONHOLE_SUCCESS,
        payload: entity
    };
}

function createPigeonHoleFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONHOLE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updatePigeonHole(clubNo, holeNo, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updatePigeonHoleRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/pigeonhole/' + clubNo + '/' + holeNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updatePigeonHoleSuccess(response.entity));
            if (onSuccess !== null) {
                onSuccess(typeof entity.Foreningsnr === "undefined" ? clubNo : entity.Foreningsnr, typeof entity.Slagnr === "undefined" ? holeNo : entity.Slagnr);
            }
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af slag", response));
            dispatch(updatePigeonHoleFailure(response));
        });
    };
}

function updatePigeonHoleRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONHOLE_REQUEST
    };
}

function updatePigeonHoleSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONHOLE_SUCCESS,
        payload: entity
    };
}

function updatePigeonHoleFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONHOLE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deletePigeonHole(clubNo, holeNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deletePigeonHoleRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/pigeonhole/' + clubNo + '/' + holeNo
        }).then(function (response) {
            dispatch(deletePigeonHoleSuccess(response.entity));
            if (onSuccess !== null) onSuccess(holeNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af slag", response));
            dispatch(deletePigeonHoleFailure(response));
        });
    };
}

function deletePigeonHoleRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONHOLE_REQUEST
    };
}

function deletePigeonHoleSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONHOLE_SUCCESS,
        payload: entity
    };
}

function deletePigeonHoleFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONHOLE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createPigeon(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createPigeonRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/pigeon',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            if (response.status.code === 409) {
                (0, _confirmDialog.confirm)("Flyt due til nyt slag", _react2.default.createElement(
                    'span',
                    null,
                    response.entity.userMessage
                ), function () {
                    entity.ConfirmWarnings = true;
                    dispatch(createPigeon(entity, onSuccess));
                });
            } else dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af due", response));
            dispatch(createPigeonFailure(response));
        });
    };
}

function createPigeonRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEON_REQUEST
    };
}

function createPigeonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEON_SUCCESS,
        payload: entity
    };
}

function createPigeonFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updatePigeon(ring, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updatePigeonRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/pigeon/' + ring,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af due", response));
            dispatch(updatePigeonFailure(response));
        });
    };
}

function updatePigeonRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEON_REQUEST
    };
}

function updatePigeonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEON_SUCCESS,
        payload: entity
    };
}

function updatePigeonFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deletePigeon(ring) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deletePigeonRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/pigeon/' + ring,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af due", response));
            dispatch(deletePigeonFailure(response));
        });
    };
}

function deletePigeonRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEON_REQUEST
    };
}

function deletePigeonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEON_SUCCESS,
        payload: entity
    };
}

function deletePigeonFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createPigeons(club, pigeonHole, from, to) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(createPigeonsRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/create-pigeons/' + club + "/" + pigeonHole + "/" + from + "/" + to,
            entity: {},
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af duer", response));
            dispatch(createPigeonsFailure(response));
        });
    };
}

function createPigeonsRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONS_REQUEST
    };
}

function createPigeonsSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONS_SUCCESS,
        payload: entity
    };
}

function createPigeonsFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_PIGEONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updatePigeons(club, pigeonHole, input) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updatePigeonsRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/update-pigeons/' + club + "/" + pigeonHole,
            entity: input,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af duer", response));
            dispatch(updatePigeonsFailure(response));
        });
    };
}

function updatePigeonsRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONS_REQUEST
    };
}

function updatePigeonsSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONS_SUCCESS,
        payload: entity
    };
}

function updatePigeonsFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_PIGEONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deletePigeons(club, pigeonHole, input) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(deletePigeonsRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/delete-pigeons/' + club + "/" + pigeonHole,
            entity: input,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af due", response));
            dispatch(deletePigeonsFailure(response));
        });
    };
}

function deletePigeonsRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONS_REQUEST
    };
}

function deletePigeonsSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONS_SUCCESS,
        payload: entity
    };
}

function deletePigeonsFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_PIGEONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createRingSerie(clubNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createRingSerieRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/ring-serie/' + clubNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createRingSerieSuccess({ club: clubNo, rings: response.entity }));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af fodringserie", response));
            dispatch(createRingSerieFailure(response));
        });
    };
}

function createRingSerieRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_RINGSERIE_REQUEST
    };
}

function createRingSerieSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_RINGSERIE_SUCCESS,
        payload: entity
    };
}

function createRingSerieFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_RINGSERIE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateRingSerie(clubNo, ringSerieID, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateRingSerieRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/ring-serie/' + clubNo + '/' + ringSerieID,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateRingSerieSuccess({ club: clubNo, rings: response.entity }));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af fodringserie", response));
            dispatch(updateRingSerieFailure(response));
        });
    };
}

function updateRingSerieRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_RINGSERIE_REQUEST
    };
}

function updateRingSerieSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_RINGSERIE_SUCCESS,
        payload: entity
    };
}

function updateRingSerieFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_RINGSERIE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteRingSerie(clubNo, ringSerieID) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteRingSerieRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/ring-serie/' + clubNo + '/' + ringSerieID
        }).then(function (response) {
            dispatch(deleteRingSerieSuccess({ club: clubNo, rings: response.entity }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af fodringserie", response));
            dispatch(deleteRingSerieFailure(response));
        });
    };
}

function deleteRingSerieRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_RINGSERIE_REQUEST
    };
}

function deleteRingSerieSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_RINGSERIE_SUCCESS,
        payload: entity
    };
}

function deleteRingSerieFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_RINGSERIE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getStationSelections(id) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getStationSelectionsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/station-selections/' + id
        }).then(function (response) {
            dispatch(getStationSelectionsSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af stationsvalg fra serveren", response));
            dispatch(getStationSelectionsFailure(response));
        });
    };
}

function getStationSelectionsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_STATION_SELECTIONS_REQUEST
    };
}

function getStationSelectionsSuccess(response) {
    return {
        type: _actionconstants.ADMIN_GET_STATION_SELECTIONS_SUCCESS,
        payload: response
    };
}

function getStationSelectionsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_STATION_SELECTIONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function selectStations(id, stations) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(selectStationsRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/station-selections/' + id,
            entity: stations,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(selectStationsSuccess(id, stations));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved overførsel af stationsvalg til serveren", response));
            dispatch(selectStationsFailure(response));
        });
    };
}

function selectStationsRequest() {
    return {
        type: _actionconstants.ADMIN_SELECT_STATIONS_REQUEST
    };
}

function selectStationsSuccess(id, stations) {
    return {
        type: _actionconstants.ADMIN_SELECT_STATIONS_SUCCESS,
        payload: stations.map(function (station) {
            return {
                target: id,
                station: station
            };
        })
    };
}

function selectStationsFailure(error) {
    return {
        type: _actionconstants.ADMIN_SELECT_STATIONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function unselectStations(id, stations) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(unselectStationsRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/station-selections/' + id,
            entity: stations,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(unselectStationsSuccess(id, stations));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved fjernelse af stationsvalg", response));
            dispatch(unselectStationsFailure(response));
        });
    };
}

function unselectStationsRequest() {
    return {
        type: _actionconstants.ADMIN_UNSELECT_STATIONS_REQUEST
    };
}

function unselectStationsSuccess(id, stations) {
    return {
        type: _actionconstants.ADMIN_UNSELECT_STATIONS_SUCCESS,
        payload: stations.map(function (station) {
            return {
                target: id,
                station: station
            };
        })
    };
}

function unselectStationsFailure(error) {
    return {
        type: _actionconstants.ADMIN_UNSELECT_STATIONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function calculateDistances(id) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(calculateDistancesRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/calc-distances/' + id,
            entity: {},
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(calculateDistancesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af afstande", response));
            dispatch(calculateDistancesFailure(response));
        });
    };
}

function calculateDistancesRequest() {
    return {
        type: _actionconstants.ADMIN_CALC_DISTANCES_REQUEST
    };
}

function calculateDistancesSuccess(response) {
    return {
        type: _actionconstants.ADMIN_CALC_DISTANCES_SUCCESS,
        payload: response
    };
}

function calculateDistancesFailure(error) {
    return {
        type: _actionconstants.ADMIN_CALC_DISTANCES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function setWebPublishing(publicitySelections) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(setWebPublishingRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/set-web-publishing',
            entity: publicitySelections,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(setWebPublishingSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved kopiering af WEB-publiseringsvalg", response));
            dispatch(setWebPublishingFailure(response));
        });
    };
}

function setWebPublishingRequest() {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST
    };
}

function setWebPublishingSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS,
        payload: entity
    };
}

function setWebPublishingFailure(error) {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function setWebPublishingForClub(clubNo, publicitySelections) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(setWebPublishingForClubRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/set-web-publishing/' + clubNo,
            entity: publicitySelections,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(setWebPublishingForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved kopiering af WEB-publiseringsvalg", response));
            dispatch(setWebPublishingForClubFailure(response));
        });
    };
}

function setWebPublishingForClubRequest() {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST
    };
}

function setWebPublishingForClubSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS,
        payload: entity
    };
}

function setWebPublishingForClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function resetBeginners() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(resetBeginnersRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/reset-beginners'
        }).then(function (response) {
            dispatch(resetBeginnersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af begyndere", response));
            dispatch(resetBeginnersFailure(response));
        });
    };
}

function resetBeginnersRequest() {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST
    };
}

function resetBeginnersSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS,
        payload: entity
    };
}

function resetBeginnersFailure(error) {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function resetBeginnersForClub(clubNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(resetBeginnersForClubRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/reset-beginners/' + clubNo
        }).then(function (response) {
            dispatch(resetBeginnersForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af begyndere", response));
            dispatch(resetBeginnersForClubFailure(response));
        });
    };
}

function resetBeginnersForClubRequest() {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST
    };
}

function resetBeginnersForClubSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS,
        payload: entity
    };
}

function resetBeginnersForClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function setJuniorPensioner() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(setJuniorPensionerRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/set-junior-pens'
        }).then(function (response) {
            dispatch(setJuniorPensionerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved markering af juniorer og pensionister", response));
            dispatch(setJuniorPensionerFailure(response));
        });
    };
}

function setJuniorPensionerRequest() {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST
    };
}

function setJuniorPensionerSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS,
        payload: entity
    };
}

function setJuniorPensionerFailure(error) {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function setJuniorPensionerForClub(clubNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(setJuniorPensionerForClubRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/set-junior-pens/' + clubNo
        }).then(function (response) {
            dispatch(setJuniorPensionerForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved markering af juniorer og pensionister", response));
            dispatch(setJuniorPensionerForClubFailure(response));
        });
    };
}

function setJuniorPensionerForClubRequest() {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST
    };
}

function setJuniorPensionerForClubSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS,
        payload: entity
    };
}

function setJuniorPensionerForClubFailure(error) {
    return {
        type: _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function resetUpdateMarkings() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(resetUpdateMarkingsRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/reset-update-markings'
        }).then(function (response) {
            dispatch(resetUpdateMarkingsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af adresseændringer og tilmeldinger/afmeldinger", response));
            dispatch(resetUpdateMarkingsFailure(response));
        });
    };
}

function resetUpdateMarkingsRequest() {
    return {
        type: _actionconstants.ADMIN_RESET_UPDATE_MARKINGS_REQUEST
    };
}

function resetUpdateMarkingsSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_RESET_UPDATE_MARKINGS_SUCCESS,
        payload: entity
    };
}

function resetUpdateMarkingsFailure(error) {
    return {
        type: _actionconstants.ADMIN_RESET_UPDATE_MARKINGS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getSections() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getSectionsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/sections'
        }).then(function (response) {
            dispatch(getSectionsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektioner fra databasen", response));
            dispatch(getSectionsFailure(response));
        });
    };
}

function getSectionsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_SECTIONS_REQUEST
    };
}

function getSectionsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_SECTIONS_SUCCESS,
        payload: data
    };
}

function getSectionsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_SECTIONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getSection(sectionNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getSectionRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/section/' + sectionNo
        }).then(function (response) {
            dispatch(getSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            console.log("ERRORTEST", response);
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektion fra databasen", response));
            dispatch(getSectionFailure(response));
        });
    };
}

function getSectionRequest() {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_REQUEST
    };
}

function getSectionSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_SUCCESS,
        payload: data
    };
}

function getSectionFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createSection(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createSectionRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/section',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Sektionsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af sektion", response));
            dispatch(createSectionFailure(response));
        });
    };
}

function createSectionRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_REQUEST
    };
}

function createSectionSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_SUCCESS,
        payload: entity
    };
}

function createSectionFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateSection(sectionNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateSectionRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/section/' + sectionNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            response.entity.originalSectionNo = sectionNo;
            dispatch(updateSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof entity.Sektionsnr === "undefined" ? sectionNo : entity.Sektionsnr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af sektion", response));
            dispatch(updateSectionFailure(response));
        });
    };
}

function updateSectionRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_REQUEST
    };
}

function updateSectionSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_SUCCESS,
        payload: entity
    };
}

function updateSectionFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteSection(sectionNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteSectionRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/section/' + sectionNo
        }).then(function (response) {
            dispatch(deleteSectionSuccess(sectionNo));
            if (onSuccess !== null) onSuccess(sectionNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af sektion", response));
            dispatch(deleteSectionFailure(response));
        });
    };
}

function deleteSectionRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_REQUEST
    };
}

function deleteSectionSuccess(clubNo) {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_SUCCESS,
        payload: clubNo
    };
}

function deleteSectionFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getListItems(model) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getListItemsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/list/' + model
        }).then(function (response) {
            dispatch(getListItemsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af data fra databasen", response));
            dispatch(getListItemsFailure(response));
        });
    };
}

function getListItemsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_LIST_ITEMS_REQUEST
    };
}

function getListItemsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_LIST_ITEMS_SUCCESS,
        payload: data
    };
}

function getListItemsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_LIST_ITEMS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createListItemItem(model, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createListItemRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/list/' + model,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.entity[response.entity.key]);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af entitet", response));
            dispatch(createListItemFailure(response));
        });
    };
}

function createListItemRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_LIST_ITEM_REQUEST
    };
}

function createListItemSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_LIST_ITEM_SUCCESS,
        payload: entity
    };
}

function createListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateListItem(model, id, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateListItemRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/list/' + model + '/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.entity[response.entity.key]);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af entitet", response));
            dispatch(updateListItemFailure(response));
        });
    };
}

function updateListItemRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_LIST_ITEM_REQUEST
    };
}

function updateListItemSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_LIST_ITEM_SUCCESS,
        payload: entity
    };
}

function updateListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteListItem(model, id) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteListItemRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/list/' + model + '/' + id
        }).then(function (response) {
            dispatch(deleteListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af entitet", response));
            dispatch(deleteListItemFailure(response));
        });
    };
}

function deleteListItemRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_LIST_ITEM_REQUEST
    };
}

function deleteListItemSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_LIST_ITEM_SUCCESS,
        payload: entity
    };
}

function deleteListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function exportRaceData(filters, exportOption) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(exportRaceDataRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/club-program/export-' + exportOption,
            entity: filters,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(exportRaceDataSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved eksport af kapflyvningsdata", response));
            dispatch(exportRaceDataFailure(response));
        });
    };
}

function exportRaceDataRequest() {
    return {
        type: _actionconstants.ADMIN_EXPORT_RACE_DATE_REQUEST
    };
}

function exportRaceDataSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_EXPORT_RACE_DATE_SUCCESS,
        payload: entity
    };
}

function exportRaceDataFailure(error) {
    return {
        type: _actionconstants.ADMIN_EXPORT_RACE_DATE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function importSectionStat(data) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(importSectionStatRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/club-program/section-stats',
            entity: data,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(importSectionStatSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved import af sektionsstatistik", response));
            dispatch(importSectionStatFailure(response));
        });
    };
}

function importSectionStatRequest() {
    return {
        type: _actionconstants.ADMIN_IMPORT_SECTION_STAT_REQUEST
    };
}

function importSectionStatSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_IMPORT_SECTION_STAT_SUCCESS,
        payload: entity
    };
}

function importSectionStatFailure(error) {
    return {
        type: _actionconstants.ADMIN_IMPORT_SECTION_STAT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function invoiceRaces(data) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(invoiceRacesRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/invoice-races',
            entity: data,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(invoiceRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved generering af fakturaer", response));
            dispatch(invoiceRacesFailure(response));
        });
    };
}

function invoiceRacesRequest() {
    return {
        type: _actionconstants.ADMIN_INVOICE_RACES_REQUEST
    };
}

function invoiceRacesSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_INVOICE_RACES_SUCCESS,
        payload: entity
    };
}

function invoiceRacesFailure(error) {
    return {
        type: _actionconstants.ADMIN_INVOICE_RACES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function startSeason(options) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(startSeasonRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/start-season',
            entity: options,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(startSeasonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af ny sæson", response));
            dispatch(startSeasonFailure(response));
        });
    };
}

function startSeasonRequest() {
    return {
        type: _actionconstants.ADMIN_START_SEASON_REQUEST
    };
}

function startSeasonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_START_SEASON_SUCCESS,
        payload: entity
    };
}

function startSeasonFailure(error) {
    return {
        type: _actionconstants.ADMIN_START_SEASON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getDashboardData() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getDashboardDataRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/get-dashboard-data'
        }).then(function (response) {
            dispatch(getDashboardDataSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af dashboard-data", response));
            dispatch(getDashboardDataFailure(response));
        });
    };
}

function getDashboardDataRequest() {
    return {
        type: _actionconstants.ADMIN_GET_DASHBOARD_REQUEST
    };
}

function getDashboardDataSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_GET_DASHBOARD_SUCCESS,
        payload: entity
    };
}

function getDashboardDataFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_DASHBOARD_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function selectUserRole(role) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(selectUserRoleRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/select-user-role/' + role
        }).then(function (response) {
            dispatch(selectUserRoleSuccess(role));
            if (onSuccess !== null) onSuccess(role);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved rolleskift", response));
            dispatch(selectUserRoleFailure(response));
        });
    };
}

function selectUserRoleRequest() {
    return {
        type: _actionconstants.ADMIN_SELECT_USER_ROLE_REQUEST
    };
}

function selectUserRoleSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SELECT_USER_ROLE_SUCCESS,
        payload: entity
    };
}

function selectUserRoleFailure(error) {
    return {
        type: _actionconstants.ADMIN_SELECT_USER_ROLE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function selectDatabase(db) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(selectDatabaseRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/select-database/' + db
        }).then(function (response) {
            dispatch(selectDatabaseSuccess(db));
            if (onSuccess !== null) onSuccess(db);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved valg af database", response));
            dispatch(selectDatabaseFailure(response));
        });
    };
}

function selectDatabaseRequest() {
    return {
        type: _actionconstants.ADMIN_SELECT_DATABASE_REQUEST
    };
}

function selectDatabaseSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_SELECT_DATABASE_SUCCESS,
        payload: entity
    };
}

function selectDatabaseFailure(error) {
    return {
        type: _actionconstants.ADMIN_SELECT_DATABASE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getErrorListItems(model, week, club) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(getErrorListItemsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/error-list/' + model + '/' + week + '/' + club
        }).then(function (response) {
            dispatch(getErrorListItemsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af data fra databasen", response));
            dispatch(getErrorListItemsFailure(response));
        });
    };
}

function getErrorListItemsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_ERROR_LIST_ITEMS_REQUEST
    };
}

function getErrorListItemsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS,
        payload: data
    };
}

function getErrorListItemsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_ERROR_LIST_ITEMS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateErrorListItem(model, key, updates) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateErrorListItemRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/error-list/update/' + model,
            entity: {
                key: key,
                updates: updates
            },
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.data);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af fejlentitet", response));
            dispatch(updateErrorListItemFailure(response));
        });
    };
}

function updateErrorListItemRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST
    };
}

function updateErrorListItemSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS,
        payload: entity
    };
}

function updateErrorListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteErrorListItem(model, keys) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteErrorListItemRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/error-list/delete/' + model,
            entity: keys,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(deleteErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af fejlentiteter", response));
            dispatch(deleteErrorListItemFailure(response));
        });
    };
}

function deleteErrorListItemRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST
    };
}

function deleteErrorListItemSuccess(entities) {
    return {
        type: _actionconstants.ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS,
        payload: entities
    };
}

function deleteErrorListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function acceptErrorListItem(model, keys) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(acceptErrorListItemRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/error-list/accept/' + model,
            entity: keys,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(acceptErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved accept af fejlentiteter", response));
            dispatch(acceptErrorListItemFailure(response));
        });
    };
}

function acceptErrorListItemRequest() {
    return {
        type: _actionconstants.ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST
    };
}

function acceptErrorListItemSuccess(entities) {
    return {
        type: _actionconstants.ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS,
        payload: entities
    };
}

function acceptErrorListItemFailure(error) {
    return {
        type: _actionconstants.ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function reloadImportFile(fileType, club, week) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var successText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(reloadImportFileRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/club-program/' + fileType + '/' + club + '/' + week,
            entity: {},
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(reloadImportFileSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity, successText, club, week);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved upload af fil", response));
            dispatch(reloadImportFileFailure(response));
        });
    };
}

function reloadImportFileRequest() {
    return {
        type: _actionconstants.ADMIN_RELOAD_IMPORT_FILE_REQUEST
    };
}

function reloadImportFileSuccess(response) {
    return {
        type: _actionconstants.ADMIN_RELOAD_IMPORT_FILE_SUCCESS,
        payload: response
    };
}

function reloadImportFileFailure(error) {
    return {
        type: _actionconstants.ADMIN_RELOAD_IMPORT_FILE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getGeneral() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getGeneralRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/general'
        }).then(function (response) {
            dispatch(getGeneralSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektion fra databasen", response));
            dispatch(getGeneralFailure(response));
        });
    };
}

function getGeneralRequest() {
    return {
        type: _actionconstants.ADMIN_GET_GENERAL_REQUEST
    };
}

function getGeneralSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_GENERAL_SUCCESS,
        payload: data
    };
}

function getGeneralFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_GENERAL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateGeneral(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(updateGeneralRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/general',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateGeneralSuccess(response.entity));
            if (onSuccess !== null) onSuccess('ddb');
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af DDB", response));
            dispatch(updateGeneralFailure(response));
        });
    };
}

function updateGeneralRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_GENERAL_REQUEST
    };
}

function updateGeneralSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_GENERAL_SUCCESS,
        payload: entity
    };
}

function updateGeneralFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_GENERAL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createDeposit(id, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createDepositRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/deposit/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createDepositSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af indskud", response));
            dispatch(createDepositFailure(response));
        });
    };
}

function createDepositRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_DEPOSIT_REQUEST
    };
}

function createDepositSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_DEPOSIT_SUCCESS,
        payload: entity
    };
}

function createDepositFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_DEPOSIT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateDeposit(id, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateDepositRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/deposit/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateDepositSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af indskud", response));
            dispatch(updateDepositFailure(response));
        });
    };
}

function updateDepositRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_DEPOSIT_REQUEST
    };
}

function updateDepositSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_DEPOSIT_SUCCESS,
        payload: entity
    };
}

function updateDepositFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_DEPOSIT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createMarking(id, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createMarkingRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/marking/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createMarkingSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createMarkingSuccess(response));
        });
    };
}

function createMarkingRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_MARKING_REQUEST
    };
}

function createMarkingSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_MARKING_SUCCESS,
        payload: entity
    };
}

function createMarkingFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_MARKING_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateMarking(id, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateMarkingRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/marking/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateMarkingSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmie", response));
            dispatch(updateMarkingFailure(response));
        });
    };
}

function updateMarkingRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_MARKING_REQUEST
    };
}

function updateMarkingSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_MARKING_SUCCESS,
        payload: entity
    };
}

function updateMarkingFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_MARKING_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getSectionPrizes(sectionNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getSectionPrizesRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/section-prizes/' + sectionNo
        }).then(function (response) {
            dispatch(getSectionPrizesSuccess(response.entity, sectionNo));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af præmier fra databasen", response));
            dispatch(getSectionPrizesFailure(response));
        });
    };
}

function getSectionPrizesRequest() {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_PRIZE_REQUEST
    };
}

function getSectionPrizesSuccess(data, id) {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_PRIZE_SUCCESS,
        payload: {
            data: data,
            id: id
        }
    };
}

function getSectionPrizesFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_SECTION_PRIZE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createSectionPrize(id, type, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(createSectionPrizeRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/section-prize/' + id + '/' + type,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createSectionPrizeFailure(response));
        });
    };
}

function createSectionPrizeRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_PRIZE_REQUEST
    };
}

function createSectionPrizeSuccess(entity, id) {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_PRIZE_SUCCESS,
        payload: {
            data: entity,
            id: id
        }
    };
}

function createSectionPrizeFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_SECTION_PRIZE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateSectionPrize(id, type, oldSectionNo, oldValue, entity) {
    var onSuccess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch) {
        dispatch(updateSectionPrizeRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/section-prize/' + id + '/' + type + '/' + oldSectionNo + '/' + oldValue,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(updateSectionPrizeFailure(response));
        });
    };
}

function updateSectionPrizeRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_PRIZE_REQUEST
    };
}

function updateSectionPrizeSuccess(entity, id) {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_PRIZE_SUCCESS,
        payload: {
            data: entity,
            id: id
        }
    };
}

function updateSectionPrizeFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_SECTION_PRIZE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteSectionPrize(id, type, sectionNo, value) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(deleteSectionPrizeRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/section-prize/' + id + '/' + type + '/' + sectionNo + '/' + value
        }).then(function (response) {
            dispatch(deleteSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(sectionNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af sektion", response));
            dispatch(deleteSectionPrizeFailure(response));
        });
    };
}

function deleteSectionPrizeRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_PRIZE_REQUEST
    };
}

function deleteSectionPrizeSuccess(entity, id) {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_PRIZE_SUCCESS,
        payload: {
            data: entity,
            id: id
        }
    };
}

function deleteSectionPrizeFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_SECTION_PRIZE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getKilometers() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getKilometersRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/kilometers'
        }).then(function (response) {
            dispatch(getKilometersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kilometer-tillæg fra databasen", response));
            dispatch(getKilometersFailure(response));
        });
    };
}

function getKilometersRequest() {
    return {
        type: _actionconstants.ADMIN_GET_KILOMETERS_REQUEST
    };
}

function getKilometersSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_KILOMETERS_SUCCESS,
        payload: data
    };
}

function getKilometersFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_KILOMETERS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createKilometer(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createKilometerRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/kilometer',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kilometer-tillæg", response));
            dispatch(createKilometerFailure(response));
        });
    };
}

function createKilometerRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_KILOMETER_REQUEST
    };
}

function createKilometerSuccess(data) {
    return {
        type: _actionconstants.ADMIN_CREATE_KILOMETER_SUCCESS,
        payload: data
    };
}

function createKilometerFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_KILOMETER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateKilometer(oldKM, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateKilometerRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/kilometer/' + oldKM,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kilometer-tillæg", response));
            dispatch(updateKilometerFailure(response));
        });
    };
}

function updateKilometerRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_KILOMETER_REQUEST
    };
}

function updateKilometerSuccess(data) {
    return {
        type: _actionconstants.ADMIN_UPDATE_KILOMETER_SUCCESS,
        payload: data
    };
}

function updateKilometerFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_KILOMETER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteKilometer(kilometer) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteKilometerRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/kilometer/' + kilometer
        }).then(function (response) {
            dispatch(deleteKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kilometer-tillæg", response));
            dispatch(deleteKilometerFailure(response));
        });
    };
}

function deleteKilometerRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_KILOMETER_REQUEST
    };
}

function deleteKilometerSuccess(data) {
    return {
        type: _actionconstants.ADMIN_DELETE_KILOMETER_SUCCESS,
        payload: data
    };
}

function deleteKilometerFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_KILOMETER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getChampionships() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getChampionshipsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/championships'
        }).then(function (response) {
            dispatch(getChampionshipsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af mesterskaber fra databasen", response));
            dispatch(getChampionshipsFailure(response));
        });
    };
}

function getChampionshipsRequest() {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIPS_REQUEST
    };
}

function getChampionshipsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIPS_SUCCESS,
        payload: data
    };
}

function getChampionshipsFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIPS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getChampionship(championshipNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getChampionshipRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/admin/championship/' + championshipNo
        }).then(function (response) {
            dispatch(getChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af mesterskab fra databasen", response));
            dispatch(getChampionshipFailure(response));
        });
    };
}

function getChampionshipRequest() {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIP_REQUEST
    };
}

function getChampionshipSuccess(data) {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIP_SUCCESS,
        payload: data
    };
}

function getChampionshipFailure(error) {
    return {
        type: _actionconstants.ADMIN_GET_CHAMPIONSHIP_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createChampionship(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createChampionshipRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/championship',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.RecNr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskab", response));
            dispatch(createChampionshipFailure(response));
        });
    };
}

function createChampionshipRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_REQUEST
    };
}

function createChampionshipSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_SUCCESS,
        payload: entity
    };
}

function createChampionshipFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateChampionship(id, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateChampionshipRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/championship/' + id,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskab", response));
            dispatch(updateChampionshipFailure(response));
        });
    };
}

function updateChampionshipRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_REQUEST
    };
}

function updateChampionshipSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS,
        payload: entity
    };
}

function updateChampionshipFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteChampionship(championshipNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteChampionshipRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/championship/' + championshipNo
        }).then(function (response) {
            dispatch(deleteChampionshipSuccess(championshipNo));
            if (onSuccess !== null) onSuccess(championshipNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forening", response));
            dispatch(deleteChampionshipFailure(response));
        });
    };
}

function deleteChampionshipRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_REQUEST
    };
}

function deleteChampionshipSuccess(championshipNo) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_SUCCESS,
        payload: championshipNo
    };
}

function deleteChampionshipFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createChampionshipRace(championshipNo, raceNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createChampionshipRaceRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/championship-race/' + championshipNo + '/' + raceNo
        }).then(function (response) {
            dispatch(createChampionshipRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabskapflyvning", response));
            dispatch(createChampionshipRaceFailure(response));
        });
    };
}

function createChampionshipRaceRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST
    };
}

function createChampionshipRaceSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS,
        payload: entity
    };
}

function createChampionshipRaceFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateChampionshipRace(championshipNo, raceNo, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateChampionshipRaceRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/championship-race/' + championshipNo + '/' + raceNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateChampionshipRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskabskapflyvning", response));
            dispatch(updateChampionshipRaceFailure(response));
        });
    };
}

function updateChampionshipRaceRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST
    };
}

function updateChampionshipRaceSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS,
        payload: entity
    };
}

function updateChampionshipRaceFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteChampionshipRace(championshipNo, raceNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteChampionshipRaceRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/championship-race/' + championshipNo + '/' + raceNo
        }).then(function (response) {
            var entity = {
                championshipNo: championshipNo,
                raceNo: raceNo
            };
            dispatch(deleteChampionshipRaceSuccess(entity));
            if (onSuccess !== null) onSuccess(entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabskapflyvning", response));
            dispatch(deleteChampionshipRaceFailure(response));
        });
    };
}

function deleteChampionshipRaceRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST
    };
}

function deleteChampionshipRaceSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS,
        payload: entity
    };
}

function deleteChampionshipRaceFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createChampionshipRaces(championshipNo, type) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createChampionshipRacesRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/championship-races/' + championshipNo + '/' + type
        }).then(function (response) {
            dispatch(createChampionshipRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabskapflyvning", response));
            dispatch(createChampionshipRacesFailure(response));
        });
    };
}

function createChampionshipRacesRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST
    };
}

function createChampionshipRacesSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS,
        payload: entity
    };
}

function createChampionshipRacesFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateChampionshipRaces(championshipNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(updateChampionshipRacesRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/championship-races/' + championshipNo
        }).then(function (response) {
            dispatch(updateChampionshipRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskabskapflyvning", response));
            dispatch(updateChampionshipRacesFailure(response));
        });
    };
}

function updateChampionshipRacesRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST
    };
}

function updateChampionshipRacesSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS,
        payload: entity
    };
}

function updateChampionshipRacesFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createChampionshipPigeon(championshipNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createChampionshipPigeonRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/championship-pigeon/' + championshipNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createChampionshipPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabsdue", response));
            dispatch(createChampionshipPigeonFailure(response));
        });
    };
}

function createChampionshipPigeonRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST
    };
}

function createChampionshipPigeonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS,
        payload: entity
    };
}

function createChampionshipPigeonFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteChampionshipPigeons(championshipNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteChampionshipPigeonsRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/championship-pigeons/' + championshipNo
        }).then(function (response) {
            dispatch(deleteChampionshipPigeonsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabsduer", response));
            dispatch(deleteChampionshipPigeonsFailure(response));
        });
    };
}

function deleteChampionshipPigeonsRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST
    };
}

function deleteChampionshipPigeonsSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS,
        payload: entity
    };
}

function deleteChampionshipPigeonsFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteChampionshipPigeon(championshipNo, ringNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteChampionshipPigeonRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/championship-pigeon/' + championshipNo + '/' + ringNo
        }).then(function (response) {
            var entity = {
                championshipNo: championshipNo,
                ringNo: ringNo
            };
            dispatch(deleteChampionshipPigeonSuccess(entity));
            if (onSuccess !== null) onSuccess(entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabsdue", response));
            dispatch(deleteChampionshipPigeonFailure(response));
        });
    };
}

function deleteChampionshipPigeonRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST
    };
}

function deleteChampionshipPigeonSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS,
        payload: entity
    };
}

function deleteChampionshipPigeonFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createChampionshipDistZone(championshipNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createChampionshipDistZoneRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/championship-dist-zone/' + championshipNo,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af afstandszone", response));
            dispatch(createChampionshipDistZoneFailure(response));
        });
    };
}

function createChampionshipDistZoneRequest() {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    };
}

function createChampionshipDistZoneSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload: entity
    };
}

function createChampionshipDistZoneFailure(error) {
    return {
        type: _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateChampionshipDistZone(championshipNo, zone, entity) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updateChampionshipDistZoneRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/admin/championship-dist-zone/' + championshipNo + '/' + zone,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af afstandszone", response));
            dispatch(updateChampionshipDistZoneFailure(response));
        });
    };
}

function updateChampionshipDistZoneRequest() {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    };
}

function updateChampionshipDistZoneSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload: entity
    };
}

function updateChampionshipDistZoneFailure(error) {
    return {
        type: _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteChampionshipDistZone(championshipNo, zone) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(deleteChampionshipDistZoneRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/admin/championship-dist-zone/' + championshipNo + '/' + zone
        }).then(function (response) {
            dispatch(deleteChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af afstandszone", response));
            dispatch(deleteChampionshipDistZoneFailure(response));
        });
    };
}

function deleteChampionshipDistZoneRequest() {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    };
}

function deleteChampionshipDistZoneSuccess(entity) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload: entity
    };
}

function deleteChampionshipDistZoneFailure(error) {
    return {
        type: _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function calcChampionships(championships) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(calcChampionshipsRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/calc-championships',
            timeout: 0,
            entity: championships,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(calcChampionshipsSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af mesterskaber", response));
            dispatch(calcChampionshipsFailure(response));
        });
    };
}

function calcChampionshipsRequest() {
    return {
        type: _actionconstants.ADMIN_CALC_CHAMPIONSHIPS_REQUEST
    };
}

function calcChampionshipsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_CALC_CHAMPIONSHIPS_SUCCESS,
        payload: data
    };
}

function calcChampionshipsFailure(error) {
    return {
        type: _actionconstants.ADMIN_CALC_CHAMPIONSHIPS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function calcSeats(seats) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(calcSeatsRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/admin/calc-seats',
            entity: seats,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(calcSeatsSuccess({
                AntalMandaterSektioner: seats.seatsForSection,
                AntalMandaterHovedbestyrelse: seats.seatsForMainBoard
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af mandatfordeling", response));
            dispatch(calcSeatsFailure(response));
        });
    };
}

function calcSeatsRequest() {
    return {
        type: _actionconstants.ADMIN_CALC_SEATS_REQUEST
    };
}

function calcSeatsSuccess(data) {
    return {
        type: _actionconstants.ADMIN_CALC_SEATS_SUCCESS,
        payload: data
    };
}

function calcSeatsFailure(error) {
    return {
        type: _actionconstants.ADMIN_CALC_SEATS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ROUTE_APP = exports.ROUTE_APP = '/';
var ROUTE_HOME = exports.ROUTE_HOME = ROUTE_APP;
var ROUTE_SIGNIN = exports.ROUTE_SIGNIN = '/signin';
var ROUTE_SIGNUP = exports.ROUTE_SIGNUP = '/signup';
var ROUTE_RESET_PASSWORD = exports.ROUTE_RESET_PASSWORD = '/resetpassword';
var ROUTE_PROFILE = exports.ROUTE_PROFILE = '/profile/:userId';
var ROUTE_PROFILE_CURRENT = exports.ROUTE_PROFILE_CURRENT = '/profile';
var ROUTE_EDIT_PROFILE = exports.ROUTE_EDIT_PROFILE = '/edit-profile/:userId';
var ROUTE_EDIT_PROFILE_CURRENT = exports.ROUTE_EDIT_PROFILE_CURRENT = '/edit-profile';

var ROUTE_DASHBOARD = exports.ROUTE_DASHBOARD = '/home';
var ROUTE_REPORTING = exports.ROUTE_REPORTING = '/reports/:category/:report';

var ROUTE_CLUBS = exports.ROUTE_CLUBS = '/clubs';
var ROUTE_CLUB = exports.ROUTE_CLUB = '/club/:clubNo/:subpage/:mode';
var ROUTE_CHAMPIONSHIPS = exports.ROUTE_CHAMPIONSHIPS = '/championships';
var ROUTE_CHAMPIONSHIP = exports.ROUTE_CHAMPIONSHIP = '/championships/:championshipNo/:subpage/:mode';
var ROUTE_MEMBERS = exports.ROUTE_MEMBERS = '/members';
var ROUTE_MEMBER = exports.ROUTE_MEMBER = '/member/:clubNo/:memberNo/:subpage/:mode';
var ROUTE_PIGEON_HOLE = exports.ROUTE_PIGEON_HOLE = '/pigeon-hole/:clubNo/:holeNo/:subpage/:mode';

var ROUTE_RACES = exports.ROUTE_RACES = '/races';
var ROUTE_RACE = exports.ROUTE_RACE = '/races/:raceNo/:subpage/:mode';

var ROUTE_SECTIONS = exports.ROUTE_SECTIONS = '/sections';
var ROUTE_SECTION = exports.ROUTE_SECTION = '/section/:sectionNo/:subpage/:mode';
var ROUTE_STATIONS = exports.ROUTE_STATIONS = '/stations';
var ROUTE_RANGES = exports.ROUTE_RANGES = '/ranges';
var ROUTE_ZIPS = exports.ROUTE_ZIPS = '/zip-codes';
var ROUTE_NIGHT_TIMES = exports.ROUTE_NIGHT_TIMES = '/night-times';
var ROUTE_DERBYS = exports.ROUTE_DERBYS = '/derbys';

var ROUTE_SETTINGS = exports.ROUTE_SETTINGS = '/settings/:subpage/:sectionNo/:mode';
var ROUTE_ERROR_LISTS = exports.ROUTE_ERROR_LISTS = '/error-lists/:subpage';
var ROUTE_IMPORT_FILE = exports.ROUTE_IMPORT_FILE = '/api/club-program/:fileType/:club/:week';
var ROUTE_DEVICES_EXPORT = exports.ROUTE_DEVICES_EXPORT = '/api/device-export/:club/:pigeonhole/eleksyst';

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.confirmGeneral = confirmGeneral;
exports.confirm = confirm;

var _reactConfirm = __webpack_require__(88);

var _ConfirmDialog = __webpack_require__(720);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Taken from the react-confirm manual: https://www.npmjs.com/package/react-confirm

// create confirm function
var confirmation = (0, _reactConfirm.createConfirmation)(_ConfirmDialog2.default);

// This is optional. But I recommend to define your confirm function easy to call.
function confirmGeneral(title, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirmation({ title: title, text: text, options: options });
}

// A version of the confirm function, which is a little easier to use in the normal use-case (We don't have to write ".then(...)").
function confirm(title, text, onOk) {
    var onCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    if (onCancel == null) onCancel = function onCancel() {};
    return confirmGeneral(title, text, options).then(onOk, onCancel);
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(222);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(223);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(661);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(662);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var env = __webpack_require__(379);

// Note: Seems that library code assumes NODE_ENV can only be "development" or "production", not "staging" etc, so we have defined our own APP_ENV which can take on more values.
var config = function () {
    var app_env = process.env.APP_ENV || 'development';
    var config = env[app_env];
    if (typeof config === "undefined") throw "No config exists for " + app_env + " in environment-config.js! Check your APP_ENV environment variable!";
    return config;
}();

module.exports = config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceDotsWithCommas = exports.renderDDMMYYYY = exports.removeNonDigits = exports.removeCommaWhitespace = exports.mergeFunction = exports.fullfillTime = exports.fullfillDate = exports.CompressList = exports.SimpleList = exports.scanPropsAsync = exports.scanProps = exports.getRegi = exports.currentWeek = exports.isSetAndTrue = exports.isSet = exports.blankToNull = exports.zeroToNull = exports.nullAndZeroToFalse = exports.nullToHtmlBlank = exports.nullToBlank = exports.nullToZero = exports.undefinedToNull = exports.isDefined = undefined;

var _bluebird = __webpack_require__(161);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _bluebird2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _bluebird2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var isDefined = exports.isDefined = function isDefined(val) {
    return typeof val !== 'undefined';
};
var undefinedToNull = exports.undefinedToNull = function undefinedToNull(val) {
    return typeof val === 'undefined' ? null : val;
};
var nullToZero = exports.nullToZero = function nullToZero(val) {
    return val === null ? 0 : val;
};
var nullToBlank = exports.nullToBlank = function nullToBlank(val) {
    return val === null ? '' : val;
};
var nullToHtmlBlank = exports.nullToHtmlBlank = function nullToHtmlBlank(val) {
    return val === null ? _react2.default.createElement(
        "span",
        null,
        "\xA0"
    ) : val;
};
var nullAndZeroToFalse = exports.nullAndZeroToFalse = function nullAndZeroToFalse(val) {
    return val !== null && val !== 0;
};
var zeroToNull = exports.zeroToNull = function zeroToNull(val) {
    return val === 0 ? null : val;
};
var blankToNull = exports.blankToNull = function blankToNull(val) {
    return val === '' ? null : val;
};
var isSet = exports.isSet = function isSet(obj, prop) {
    return typeof obj[prop] !== 'undefined';
};
var isSetAndTrue = exports.isSetAndTrue = function isSetAndTrue(prop) {
    return typeof prop !== 'undefined' && prop;
};

var currentWeek = exports.currentWeek = function currentWeek() {
    var now = new Date();
    var week = (0, _moment2.default)(now).isoWeekday() > 3 ? (0, _moment2.default)(now).isoWeek() : (0, _moment2.default)(now).isoWeek() - 1;
    return week;
};

var getRegi = exports.getRegi = function getRegi(kfk) {
    if (!/^[0-9]{2}/.test(kfk)) return null;
    if (kfk >= '97' || kfk < '88') return 'Privat';
    if (kfk >= '95' && kfk < '97') return 'Sektion';
    return 'DdB';
};

// Scan all properties with a specified prefix of an object.
var scanProps = exports.scanProps = function scanProps(obj, prefix, cb) {
    for (var propName in obj) {
        if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) cb(obj[propName], propName);
    }
};
var scanPropsAsync = exports.scanPropsAsync = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(obj, prefix, cb) {
        var props, propName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        props = [];

                        for (propName in obj) {
                            if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) props.push({
                                name: propName,
                                value: obj[propName]
                            });
                        }
                        _context2.next = 4;
                        return _bluebird2.default.all(props.map(function () {
                            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(prop) {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _context.next = 2;
                                                return cb(prop.value, prop.name);

                                            case 2:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, undefined);
                            }));

                            return function (_x4) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));

                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function scanPropsAsync(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

// Create a simple list of numbers (n1-nx replaced n1, n2... nx) from a compressed list.
var SimpleList = exports.SimpleList = function SimpleList(txt) {
    var allowDuplicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var validateItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var allowRanges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var result = [];
    var isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        var items = txt.split(',');
        items.forEach(function (item) {
            var endPoints = item.split('-');
            switch (endPoints.length) {
                case 1:
                    var n = item.trim();
                    if (/^[0-9]+$/.test(n)) {
                        if (!allowDuplicates && result.indexOf(n) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(n)) isErrors = true;else result.push(n);
                    } else isErrors = true;
                    break;
                case 2:
                    if (allowRanges) {
                        var n1 = endPoints[0].trim();
                        var n2 = endPoints[1].trim();
                        if (/^[0-9]+$/.test(n1) && /^[0-9]+$/.test(n2)) {
                            if (Number(n1) > Number(n2)) isErrors = true;else for (var _n = Number(n1); _n <= Number(n2); _n++) {
                                if (!allowDuplicates && result.indexOf(String(_n)) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(String(_n))) isErrors = true;else result.push(String(_n));
                            }
                        } else isErrors = true;
                    } else isErrors = true;
                    break;
                default:
                    isErrors = true;
            }
        });
    }
    return {
        items: result.sort(function (n1, n2) {
            return Number(n1) - Number(n2);
        }),
        isErrors: isErrors
    };
};

// Create a compressed list (n1, n2... nx replaced by n1-nx) from a simple list of numbers.
var CompressList = exports.CompressList = function CompressList(txt) {
    var result = [];
    var isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        var items = txt.split(',').map(function (item) {
            return item.trim();
        });
        if (items.findIndex(function (item) {
            return !/^[0-9]+$/.test(item);
        }) >= 0) isErrors = true;else {
            var n1 = null;
            items.sort(function (n1, n2) {
                return Number(n1) - Number(n2);
            }).filter(function (item, ix, items) {
                return ix === 0 || items[ix] !== items[ix - 1];
            }).forEach(function (item, ix) {
                var n = Number(item);
                if (ix === 0 || n !== Number(items[ix - 1]) + 1) n1 = n;
                if (ix === items.length - 1 || n !== Number(items[ix + 1]) - 1) {
                    if (n1 === n) result.push(String(n));else result.push(String(n1) + '-' + String(n));
                }
            });
        }
    }
    return {
        items: result,
        isErrors: isErrors
    };
};

// Fullfill date entry.
var fullfillDate = exports.fullfillDate = function fullfillDate(txt) {
    if (txt === null || txt === '') return txt;
    var now = new Date();
    var yr = String(now.getFullYear());
    var d = '';
    var m = '';
    var y = '';
    if (txt.indexOf('-') >= 0) {
        var parts = txt.split('-');
        d = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        y = parts.length > 2 ? parts[2].trim() : '';
    } else {
        var trimTxt = txt.trim();
        if (/^[0-9]{2}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 1);
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 2);
        } else if (/^[0-9]{7}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 4);
        } else if (/^[0-9]{8}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 4);
        }
    }
    if (/^[0-9]{1}$/.test(d)) d = '0' + d;
    if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (y === '') y = yr;else if (/^[0-9]{2}$/.test(y)) y = yr.substr(0, 2) + y;
    if (!/^[0-9]{2}$/.test(d) || !/^[0-9]{2}$/.test(m) || !/^[0-9]{4}$/.test(y)) return 'error';
    if (!(0, _moment2.default)(d + '-' + m + '-' + y, _config2.default.formats.dateFormat, true).isValid()) return 'error';
    return d + '-' + m + '-' + y;
};

// Fullfill time entry.
var fullfillTime = exports.fullfillTime = function fullfillTime(txt) {
    var includeSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (txt === null || txt === '') return txt;
    var h = '';
    var m = '';
    var s = '';
    if (txt.indexOf(':') >= 0) {
        var parts = txt.split(':');
        h = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        s = parts.length > 2 ? parts[2].trim() : '';
    } else {
        var trimTxt = txt.trim();
        if (/^[0-9]{1}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{2}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
            s = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            s = trimTxt.substr(4, 2);
        }
    }
    if (/^[0-9]{1}$/.test(h)) h = '0' + h;
    if (m === '') m = '00';else if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (s === '') s = '00';else if (/^[0-9]{1}$/.test(s)) s = '0' + s;
    if (!/^([0-1][0-9]|20|21|22|23)$/.test(h) || !/^[0-5][0-9]$/.test(m) || !/^[0-5][0-9]$/.test(s)) return 'error';
    return includeSeconds ? h + ':' + m + ':' + s : h + ':' + m;
};

// Default reducer merge function to combine original entity with new properties read or updated from database.
var mergeFunction = exports.mergeFunction = function mergeFunction(original, updated) {
    var result = Object.assign({}, original);
    for (var prop in updated) {
        if (updated.hasOwnProperty(prop)) {
            result[prop] = updated[prop];
        }
    }
    return result;
};

var removeCommaWhitespace = exports.removeCommaWhitespace = function removeCommaWhitespace(string) {
    // removing all white space between a comma and any letter
    return string.replace(/\s*,\s*/g, ",");
};

var removeNonDigits = exports.removeNonDigits = function removeNonDigits(string) {
    return string.replace(/\D/g, '');
};

var renderDDMMYYYY = exports.renderDDMMYYYY = function renderDDMMYYYY(date) {
    if (date === null) return null;
    var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return da + "-" + mo + "-" + ye;
};

var replaceDotsWithCommas = exports.replaceDotsWithCommas = function replaceDotsWithCommas(float) {
    return float.toString().replace('.', ',');
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(91)('wks');
var uid = __webpack_require__(65);
var Symbol = __webpack_require__(13).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(16)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRaces = getRaces;
exports.getRace = getRace;
exports.createRace = createRace;
exports.updateRace = updateRace;
exports.deleteRace = deleteRace;
exports.getRacePigeons = getRacePigeons;
exports.createRacePigeon = createRacePigeon;
exports.updateRacePigeon = updateRacePigeon;
exports.deleteRacePigeon = deleteRacePigeon;
exports.createWatch = createWatch;
exports.updateWatch = updateWatch;
exports.deleteWatch = deleteWatch;
exports.addMemberGames = addMemberGames;
exports.removeMemberGames = removeMemberGames;
exports.addDecays = addDecays;
exports.removeDecays = removeDecays;
exports.getPrices = getPrices;
exports.createPrice = createPrice;
exports.updatePrice = updatePrice;
exports.deletePrice = deletePrice;
exports.updatePriceAdditions = updatePriceAdditions;
exports.resetPrices = resetPrices;
exports.calcPrices = calcPrices;
exports.calcRaces = calcRaces;
exports.getBasics = getBasics;
exports.startDeviceImport = startDeviceImport;
exports.updateDeviceImport = updateDeviceImport;
exports.checkDeviceImport = checkDeviceImport;
exports.sendFromClub = sendFromClub;
exports.getFromMember = getFromMember;

var _actionconstants = __webpack_require__(35);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

var _lib = __webpack_require__(18);

var _reactNotifications = __webpack_require__(8);

var _alertDialog = __webpack_require__(89);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRaces() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getRacesRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/all'
        }).then(function (response) {
            dispatch(getRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kapflyvninger fra databasen", response));
            dispatch(getRacesFailure(response));
        });
    };
}

function getRacesRequest() {
    return {
        type: _actionconstants.RACE_GET_ALL_REQUEST
    };
}

function getRacesSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_ALL_SUCCESS,
        payload: data
    };
}

function getRacesFailure(error) {
    return {
        type: _actionconstants.RACE_GET_ALL_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getRace(raceNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getRaceRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/race/' + raceNo.toString()
        }).then(function (response) {
            dispatch(getRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kapflyvning fra databasen", response));
            dispatch(getRaceFailure(response));
        });
    };
}

function getRaceRequest() {
    return {
        type: _actionconstants.RACE_GET_DETAILS_REQUEST
    };
}

function getRaceSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_DETAILS_SUCCESS,
        payload: data
    };
}

function getRaceFailure(error) {
    return {
        type: _actionconstants.RACE_GET_DETAILS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createRace(entity) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(createRaceRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/races/race',
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.race.Nr);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kapflyvning", response));
            dispatch(createRaceFailure(response));
        });
    };
}

function createRaceRequest() {
    return {
        type: _actionconstants.RACE_CREATE_REQUEST
    };
}

function createRaceSuccess(entity) {
    return {
        type: _actionconstants.RACE_CREATE_SUCCESS,
        payload: entity
    };
}

function createRaceFailure(error) {
    return {
        type: _actionconstants.RACE_CREATE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateRace(raceNo, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateRaceRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/race/' + raceNo.toString(),
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(raceNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kapflyvning", response));
            dispatch(updateRaceFailure(response));
        });
    };
}

function updateRaceRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_REQUEST
    };
}

function updateRaceSuccess(entity) {
    return {
        type: _actionconstants.RACE_UPDATE_SUCCESS,
        payload: entity
    };
}

function updateRaceFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteRace(raceNo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(deleteRaceRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/races/race/' + raceNo
        }).then(function (response) {
            dispatch(deleteRaceSuccess(raceNo));
            if (onSuccess !== null) onSuccess(raceNo);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvning", response));
            dispatch(deleteRaceFailure(response));
        });
    };
}

function deleteRaceRequest() {
    return {
        type: _actionconstants.RACE_DELETE_REQUEST
    };
}

function deleteRaceSuccess(raceNo) {
    return {
        type: _actionconstants.RACE_DELETE_SUCCESS,
        payload: raceNo
    };
}

function deleteRaceFailure(error) {
    return {
        type: _actionconstants.RACE_DELETE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getRacePigeons(raceNo, clubNo) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(getRacePigeonsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/pigeons/' + raceNo + '/' + clubNo
        }).then(function (response) {
            dispatch(getRacePigeonsSuccess({
                key: raceNo + '/' + clubNo,
                racePigeons: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af foreningsdeltagelse fra databasen", response));
            dispatch(getRacePigeonsFailure(response));
        });
    };
}

function getRacePigeonsRequest() {
    return {
        type: _actionconstants.RACE_GET_PIGEONS_REQUEST
    };
}

function getRacePigeonsSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_PIGEONS_SUCCESS,
        payload: data
    };
}

function getRacePigeonsFailure(error) {
    return {
        type: _actionconstants.RACE_GET_PIGEONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createRacePigeon(race, club, pigeonhole, entity) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(createRacePigeonRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/races/pigeon',
            entity: Object.assign(entity, {
                Foreningsnr: club,
                Slagnr: pigeonhole
            }),
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                pigeon: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kapflyvningsdeltager", response));
            dispatch(createRacePigeonFailure(response));
        });
    };
}

function createRacePigeonRequest() {
    return {
        type: _actionconstants.RACE_CREATE_PIGEON_REQUEST
    };
}

function createRacePigeonSuccess(data) {
    return {
        type: _actionconstants.RACE_CREATE_PIGEON_SUCCESS,
        payload: data
    };
}

function createRacePigeonFailure(error) {
    return {
        type: _actionconstants.RACE_CREATE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateRacePigeon(race, club, pigeonhole, ring, entity) {
    var onSuccess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch) {
        dispatch(updateRacePigeonRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/pigeon/' + race + '/' + ring,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                originalRing: ring,
                pigeon: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kapflyvningsdeltager", response));
            dispatch(updateRacePigeonFailure(response));
        });
    };
}

function updateRacePigeonRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_PIGEON_REQUEST
    };
}

function updateRacePigeonSuccess(data) {
    return {
        type: _actionconstants.RACE_UPDATE_PIGEON_SUCCESS,
        payload: data
    };
}

function updateRacePigeonFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteRacePigeon(race, club, pigeonhole, ring) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(deleteRacePigeonRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/races/pigeon/' + race + '/' + ring
        }).then(function (response) {
            dispatch(deleteRacePigeonSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                ring: ring
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvningsdeltager", response));
            dispatch(deleteRacePigeonFailure(response));
        });
    };
}

function deleteRacePigeonRequest() {
    return {
        type: _actionconstants.RACE_DELETE_PIGEON_REQUEST
    };
}

function deleteRacePigeonSuccess(data) {
    return {
        type: _actionconstants.RACE_DELETE_PIGEON_SUCCESS,
        payload: data
    };
}

function deleteRacePigeonFailure(error) {
    return {
        type: _actionconstants.RACE_DELETE_PIGEON_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createWatch(race, club, pigeonhole, entity) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(createWatchRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/races/watch',
            entity: Object.assign(entity),
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createWatchSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                watch: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af uroplysninger", response));
            dispatch(createWatchFailure(response));
        });
    };
}

function createWatchRequest() {
    return {
        type: _actionconstants.RACE_CREATE_WATCH_REQUEST
    };
}

function createWatchSuccess(data) {
    return {
        type: _actionconstants.RACE_CREATE_WATCH_SUCCESS,
        payload: data
    };
}

function createWatchFailure(error) {
    return {
        type: _actionconstants.RACE_CREATE_WATCH_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateWatch(race, week, club, pigeonhole, watch, entity) {
    var onSuccess = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    return function (dispatch) {
        dispatch(updateWatchRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/watch/' + week + '/' + club + '/' + pigeonhole + '/' + watch,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateWatchSuccess({
                key: race + '/' + club,
                originalPigeonhole: pigeonhole,
                pigeonhole: (0, _lib.isDefined)(entity.Slagnr) ? entity.Slagnr : pigeonhole,
                originalWatch: watch,
                watch: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af uroplysninger", response));
            dispatch(updateWatchFailure(response));
        });
    };
}

function updateWatchRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_WATCH_REQUEST
    };
}

function updateWatchSuccess(data) {
    return {
        type: _actionconstants.RACE_UPDATE_WATCH_SUCCESS,
        payload: data
    };
}

function updateWatchFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_WATCH_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deleteWatch(race, week, club, pigeonhole, watch) {
    var onSuccess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch) {
        dispatch(deleteWatchRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/races/watch/' + week + '/' + club + '/' + pigeonhole + '/' + watch
        }).then(function (response) {
            dispatch(deleteWatchSuccess({
                key: race + '/' + club,
                pigeonhole: pigeonhole,
                watch: watch
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af kapflyvningsdeltager", response));
            dispatch(deleteWatchFailure(response));
        });
    };
}

function deleteWatchRequest() {
    return {
        type: _actionconstants.RACE_DELETE_WATCH_REQUEST
    };
}

function deleteWatchSuccess(data) {
    return {
        type: _actionconstants.RACE_DELETE_WATCH_SUCCESS,
        payload: data
    };
}

function deleteWatchFailure(error) {
    return {
        type: _actionconstants.RACE_DELETE_WATCH_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function addMemberGames(race, club, pigeonholes) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(addMemberGamesRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/member-games/add/' + race + '/' + club,
            entity: pigeonholes,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(addMemberGamesSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved tilmelding til slagspil", response));
            dispatch(addMemberGamesFailure(response));
        });
    };
}

function addMemberGamesRequest() {
    return {
        type: _actionconstants.RACE_ADD_MEMBER_GAMES_REQUEST
    };
}

function addMemberGamesSuccess(data) {
    return {
        type: _actionconstants.RACE_ADD_MEMBER_GAMES_SUCCESS,
        payload: data
    };
}

function addMemberGamesFailure(error) {
    return {
        type: _actionconstants.RACE_ADD_MEMBER_GAMES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function removeMemberGames(race, club, pigeonholes) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(removeMemberGamesRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/member-games/remove/' + race + '/' + club,
            entity: pigeonholes,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(removeMemberGamesSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved afmelding af slagspil", response));
            dispatch(removeMemberGamesFailure(response));
        });
    };
}

function removeMemberGamesRequest() {
    return {
        type: _actionconstants.RACE_REMOVE_MEMBER_GAMES_REQUEST
    };
}

function removeMemberGamesSuccess(data) {
    return {
        type: _actionconstants.RACE_REMOVE_MEMBER_GAMES_SUCCESS,
        payload: data
    };
}

function removeMemberGamesFailure(error) {
    return {
        type: _actionconstants.RACE_REMOVE_MEMBER_GAMES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function addDecays(week, race, club, pigeonholes) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(addDecaysRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/decays/add/' + week + '/' + club,
            entity: pigeonholes,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(addDecaysSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved registrering af forfald", response));
            dispatch(addDecaysFailure(response));
        });
    };
}

function addDecaysRequest() {
    return {
        type: _actionconstants.RACE_ADD_DECAYS_REQUEST
    };
}

function addDecaysSuccess(data) {
    return {
        type: _actionconstants.RACE_ADD_DECAYS_SUCCESS,
        payload: data
    };
}

function addDecaysFailure(error) {
    return {
        type: _actionconstants.RACE_ADD_DECAYS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function removeDecays(week, race, club, pigeonholes) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(removeDecaysRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/decays/remove/' + week + '/' + club,
            entity: pigeonholes,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(removeDecaysSuccess({
                key: race + '/' + club,
                pigeonholes: pigeonholes
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forfald", response));
            dispatch(removeDecaysFailure(response));
        });
    };
}

function removeDecaysRequest() {
    return {
        type: _actionconstants.RACE_REMOVE_DECAYS_REQUEST
    };
}

function removeDecaysSuccess(data) {
    return {
        type: _actionconstants.RACE_REMOVE_DECAYS_SUCCESS,
        payload: data
    };
}

function removeDecaysFailure(error) {
    return {
        type: _actionconstants.RACE_REMOVE_DECAYS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getPrices(race) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(getPricesRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/prices/' + race
        }).then(function (response) {
            dispatch(getPricesSuccess({
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af præmier", response));
            dispatch(getPricesFailure(response));
        });
    };
}

function getPricesRequest() {
    return {
        type: _actionconstants.RACE_GET_PRICES_REQUEST
    };
}

function getPricesSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_PRICES_SUCCESS,
        payload: data
    };
}

function getPricesFailure(error) {
    return {
        type: _actionconstants.RACE_GET_PRICES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function createPrice(priceType, entity) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(createPriceRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/races/price/' + priceType,
            entity: Object.assign(entity),
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(createPriceSuccess({
                type: priceType,
                race: entity.Kapflyvningsnr,
                price: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createPriceFailure(response));
        });
    };
}

function createPriceRequest() {
    return {
        type: _actionconstants.RACE_CREATE_PRICE_REQUEST
    };
}

function createPriceSuccess(data) {
    return {
        type: _actionconstants.RACE_CREATE_PRICE_SUCCESS,
        payload: data
    };
}

function createPriceFailure(error) {
    return {
        type: _actionconstants.RACE_CREATE_PRICE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updatePrice(priceType, race, section, value, entity) {
    var onSuccess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch) {
        dispatch(updatePriceRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/price/' + priceType + '/' + race + '/' + (section === '' ? 'ddb' : section) + '/' + value,
            entity: entity,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updatePriceSuccess({
                type: priceType,
                race: race,
                originalSection: section,
                originalValue: value,
                price: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmie", response));
            dispatch(updatePriceFailure(response));
        });
    };
}

function updatePriceRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_REQUEST
    };
}

function updatePriceSuccess(data) {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_SUCCESS,
        payload: data
    };
}

function updatePriceFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function deletePrice(priceType, race, section, value) {
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return function (dispatch) {
        dispatch(deletePriceRequest());
        (0, _client2.default)({
            method: 'DELETE',
            path: '/api/races/price/' + priceType + '/' + race + '/' + (section === '' ? 'ddb' : section) + '/' + value
        }).then(function (response) {
            dispatch(deletePriceSuccess({
                type: priceType,
                race: race,
                section: section,
                value: value
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af præmie", response));
            dispatch(deletePriceFailure(response));
        });
    };
}

function deletePriceRequest() {
    return {
        type: _actionconstants.RACE_DELETE_PRICE_REQUEST
    };
}

function deletePriceSuccess(data) {
    return {
        type: _actionconstants.RACE_DELETE_PRICE_SUCCESS,
        payload: data
    };
}

function deletePriceFailure(error) {
    return {
        type: _actionconstants.RACE_DELETE_PRICE_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updatePriceAdditions(priceType, race, additionals) {
    var onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(updatePriceAdditionsRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/races/price-additions/' + priceType + '/' + race,
            entity: additionals,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updatePriceAdditionsSuccess({
                type: priceType,
                race: race,
                prices: additionals
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmietillæg", response));
            dispatch(updatePriceAdditionsFailure(response));
        });
    };
}

function updatePriceAdditionsRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_ADDITIONS_REQUEST
    };
}

function updatePriceAdditionsSuccess(data) {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_ADDITIONS_SUCCESS,
        payload: data
    };
}

function updatePriceAdditionsFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_PRICE_ADDITIONS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function resetPrices(priceType, race) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(resetPricesRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/reset-prices/' + priceType + '/' + race
        }).then(function (response) {
            dispatch(resetPricesSuccess({
                type: priceType,
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmier", response));
            dispatch(resetPricesFailure(response));
        });
    };
}

function resetPricesRequest() {
    return {
        type: _actionconstants.RACE_RESET_PRICES_REQUEST
    };
}

function resetPricesSuccess(data) {
    return {
        type: _actionconstants.RACE_RESET_PRICES_SUCCESS,
        payload: data
    };
}

function resetPricesFailure(error) {
    return {
        type: _actionconstants.RACE_RESET_PRICES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function calcPrices(priceType, race) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(calcPricesRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/calc-prices/' + priceType + '/' + race
        }).then(function (response) {
            dispatch(calcPricesSuccess({
                type: priceType,
                race: race,
                prices: response.entity
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af præmier", response));
            dispatch(calcPricesFailure(response));
        });
    };
}

function calcPricesRequest() {
    return {
        type: _actionconstants.RACE_CALC_PRICES_REQUEST
    };
}

function calcPricesSuccess(data) {
    return {
        type: _actionconstants.RACE_CALC_PRICES_SUCCESS,
        payload: data
    };
}

function calcPricesFailure(error) {
    return {
        type: _actionconstants.RACE_CALC_PRICES_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function calcRaces(races) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(calcRacesRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/races/calc-races',
            entity: races,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(calcRacesSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af kapflyvninger", response));
            dispatch(calcRacesFailure(response));
        });
    };
}

function calcRacesRequest() {
    return {
        type: _actionconstants.RACE_CALC_REQUEST
    };
}

function calcRacesSuccess(data) {
    return {
        type: _actionconstants.RACE_CALC_SUCCESS,
        payload: data
    };
}

function calcRacesFailure(error) {
    return {
        type: _actionconstants.RACE_CALC_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getBasics() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch) {
        dispatch(getBasicsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/races/basics'
        }).then(function (response) {
            dispatch(getBasicsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af grunddata", response));
            dispatch(getBasicsFailure(response));
        });
    };
}

function getBasicsRequest() {
    return {
        type: _actionconstants.RACE_GET_BASICS_REQUEST
    };
}

function getBasicsSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_BASICS_SUCCESS,
        payload: data
    };
}

function getBasicsFailure(error) {
    return {
        type: _actionconstants.RACE_GET_BASICS_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function startDeviceImport(id, input) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(startDeviceImportRequest({
            id: id,
            input: input
        }));
        (0, _client2.default)({
            method: 'POST',
            path: '/api/device-import/' + id,
            entity: input,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(startDeviceImportSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af import", response));
            dispatch(startDeviceImportFailure(response));
        });
    };
}

function startDeviceImportRequest(data) {
    return {
        type: _actionconstants.RACE_START_DEVICE_IMPORT_REQUEST,
        payload: data
    };
}

function startDeviceImportSuccess(data) {
    return {
        type: _actionconstants.RACE_START_DEVICE_IMPORT_SUCCESS,
        payload: data
    };
}

function startDeviceImportFailure(error) {
    return {
        type: _actionconstants.RACE_START_DEVICE_IMPORT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function updateDeviceImport(id, input) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateDeviceImportRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/device-import/' + id,
            entity: input,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateDeviceImportSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af import", response));
            dispatch(updateDeviceImportFailure(response));
        });
    };
}

function updateDeviceImportRequest() {
    return {
        type: _actionconstants.RACE_UPDATE_DEVICE_IMPORT_REQUEST
    };
}

function updateDeviceImportSuccess(data) {
    return {
        type: _actionconstants.RACE_UPDATE_DEVICE_IMPORT_SUCCESS,
        payload: data
    };
}

function updateDeviceImportFailure(error) {
    return {
        type: _actionconstants.RACE_UPDATE_DEVICE_IMPORT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function checkDeviceImport(id) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(checkDeviceImportRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/device-import/' + id,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            response.id = id;
            dispatch(checkDeviceImportSuccess(response.entity));
            if (response.entity.requestType === "signups" || response.entity.requestType === "results") {
                if (response.entity.info === "success") {
                    var msg = ["Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + (response.entity.reference !== null ? " for " + response.entity.reference : "") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er gennemført."];
                    var messages = response.entity.messages.split('|');
                    if (messages.length > 0) msg.push('');
                    (0, _alertDialog.alert)("Info", msg.concat(messages).map(function (line, ix) {
                        return [line, _react2.default.createElement('br', null)];
                    }), function () {}, { textAlign: "left" });
                    //NotificationManager.success("Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + (response.entity.reference !== null ? " for " + response.entity.reference : "") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er gennemført.", "Indlæsning", 4000);
                }
                if (response.entity.info === "timed out") _reactNotifications.NotificationManager.warning("Indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + " er udløbet.", "Timeout", 4000);
                //if (response.entity.info === "error") NotificationManager.error("Fejl ved indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + (response.entity.data !== null ? ": " + response.entity.data : "") + ".", "Fejl", 4000);
                if (response.entity.info === "error") (0, _alertDialog.alert)("Fejl", _react2.default.createElement(
                    'span',
                    null,
                    "Fejl ved indlæsning af " + (response.entity.requestType === "signups" ? "anmeldelser" : "resultater") + " fra " + (response.entity.deviceType === "unikon" ? "Unikon" : "Tauris") + " på " + response.entity.commPort.toUpperCase() + (response.entity.data !== null ? ": " + response.entity.data : "") + "."
                ), function () {});
            }
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af import", response));
            dispatch(checkDeviceImportFailure(response, id));
        });
    };
}

function checkDeviceImportRequest() {
    return {
        type: _actionconstants.RACE_CHECK_DEVICE_IMPORT_REQUEST
    };
}

function checkDeviceImportSuccess(data) {
    return {
        type: _actionconstants.RACE_CHECK_DEVICE_IMPORT_SUCCESS,
        payload: data
    };
}

function checkDeviceImportFailure(error, id) {
    return {
        type: _actionconstants.RACE_CHECK_DEVICE_IMPORT_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity,
            id: id
        }
    };
}

function sendFromClub(type, input) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(sendFromClubRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: type === 'signup' ? '/api/export/send-signups' : '/api/export/send-results',
            entity: input,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(sendFromClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            if (response.entity.userMessage.includes('\r\n')) {
                //const msg = response.entity.userMessage.split('\r\n').map((line, ix) => <div key={"msgline" + ix}>{line}</div>);
                var msg = response.entity.userMessage.split('\r\n').map(function (line, ix) {
                    return [line, _react2.default.createElement('br', null)];
                });
                (0, _alertDialog.alert)("Fejl", msg, function () {}, { textAlign: "left" });
            } else dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl", response));
            dispatch(sendFromClubFailure(response));
        });
    };
}

function sendFromClubRequest() {
    return {
        type: _actionconstants.RACE_SEND_FROM_CLUB_REQUEST
    };
}

function sendFromClubSuccess(data) {
    return {
        type: _actionconstants.RACE_SEND_FROM_CLUB_SUCCESS,
        payload: data
    };
}

function sendFromClubFailure(error) {
    return {
        type: _actionconstants.RACE_SEND_FROM_CLUB_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

function getFromMember(club, week, pigeonHole, reset, overwrite) {
    var onSuccess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch) {
        dispatch(getFromMemberRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/import/get-signups/' + club + '/' + week + '/' + pigeonHole + '/' + (reset ? 'reset' : overwrite ? 'overwrite' : 'keep'),
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(getFromMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning fra medlemsprogrammet", response));
            dispatch(getFromMemberFailure(response));
        });
    };
}

function getFromMemberRequest() {
    return {
        type: _actionconstants.RACE_GET_FROM_MEMBER_REQUEST
    };
}

function getFromMemberSuccess(data) {
    return {
        type: _actionconstants.RACE_GET_FROM_MEMBER_SUCCESS,
        payload: data
    };
}

function getFromMemberFailure(error) {
    return {
        type: _actionconstants.RACE_GET_FROM_MEMBER_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(164);
var toPrimitive = __webpack_require__(47);
var dP = Object.defineProperty;

exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(48);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(606);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(665);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addGlobalError = addGlobalError;
exports.removeGlobalError = removeGlobalError;
exports.removeAllGlobalErrors = removeAllGlobalErrors;
exports.addGlobalErrorFromResponse = addGlobalErrorFromResponse;

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _actionconstants = __webpack_require__(35);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inspired by: http://stackoverflow.com/questions/34403269/what-is-the-best-way-to-deal-with-a-fetch-error-in-react-redux
// Also see (for how to override them): http://stackoverflow.com/questions/35417507/how-to-make-a-global-error-handler-in-redux-and-override-it-when-needed

var nextErrorId = 0; // This is to create a handle for each global error which lets you remove a specific error again. All global errors get an id created from this field.

function addGlobalError(errorTitle, errorMessage) {
    var serverErrorId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

    return function (dispatch) {
        dispatch({
            type: _actionconstants.ADD_GLOBAL_ERROR,
            payload: {
                errorId: nextErrorId++,
                errorTitle: errorTitle,
                errorMessage: errorMessage,
                serverErrorId: serverErrorId
            }
        });
    };
}

function removeGlobalError(errorId) {
    return function (dispatch) {
        dispatch({
            type: _actionconstants.REMOVE_GLOBAL_ERROR,
            payload: {
                errorId: errorId
            }
        });
    };
}

function removeAllGlobalErrors() {
    return function (dispatch) {
        dispatch({
            type: _actionconstants.REMOVE_ALL_GLOBAL_ERRORS,
            payload: {}
        });
    };
}

function addGlobalErrorFromResponse(errorTitle, response) {

    return function (dispatch, getState) {
        var statusCode = response.status ? response.status.code : -1;
        var isAuthenticated = getState().auth.isAuthenticated;

        var payload = response.entity;

        if (typeof payload == "undefined") payload = {}; // happens...

        if (isAuthenticated && (statusCode == 401 || statusCode == 403) && !payload.userMessage) {
            // note: if there is a userMessage in the request, the 403 must have been a custom FORBIDDEN error, not related to authentication.
            dispatch(AuthActions.setForceAuthRecheck(true));
            return; // <- This will hide the error causing this from the user - since it is probably him being logged out by the backend that that caused the error, this is a better user-experience (rather than getting 100 random error messages).
            //    TODO: Should only show one of these errors at a time - not one per ajax call! (Think i fixed this by checking isAuthenticating in requireAuth)
        }

        // Check if payload-JSON corresponds to the standard format of the server-side error function. If so, show the error message from the server. If not, show a generic error message.
        var message = payload.userMessage ? payload.userMessage : "An error has occured - please try again later. (" + statusCode + ")";
        var errorId = payload.errorId ? payload.errorId : -1;

        dispatch(addGlobalError(errorTitle, message, errorId));
    };
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(64);
module.exports = __webpack_require__(22) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(32);
var has = __webpack_require__(36);
var SRC = __webpack_require__(65)('src');
var $toString = __webpack_require__(393);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(40).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(16);
var defined = __webpack_require__(48);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN_USER_REQUEST = exports.LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
var LOGIN_USER_FAILURE = exports.LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
var LOGIN_USER_SUCCESS = exports.LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
var LOGOUT_USER = exports.LOGOUT_USER = "LOGOUT_USER";
var FORCE_AUTH_RECHECK = exports.FORCE_AUTH_RECHECK = "FORCE_AUTH_RECHECK";

var USER_CREATE_REQUEST = exports.USER_CREATE_REQUEST = "USER_CREATE_REQUEST";
var USER_CREATE_SUCCESS = exports.USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
var USER_CREATE_FAILURE = exports.USER_CREATE_FAILURE = "USER_CREATE_FAILURE";
var USER_GET_REQUEST = exports.USER_GET_REQUEST = "USER_GET_REQUEST";
var USER_GET_SUCCESS = exports.USER_GET_SUCCESS = "USER_GET_SUCCESS";
var USER_GET_FAILURE = exports.USER_GET_FAILURE = "USER_GET_FAILURE";
var USER_UPDATE_REQUEST = exports.USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
var USER_UPDATE_SUCCESS = exports.USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
var USER_UPDATE_FAILURE = exports.USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE";
var USER_PROFILE_GET_REQUEST = exports.USER_PROFILE_GET_REQUEST = "USER_PROFILE_GET_REQUEST";
var USER_PROFILE_GET_SUCCESS = exports.USER_PROFILE_GET_SUCCESS = "USER_PROFILE_GET_SUCCESS";
var USER_PROFILE_GET_FAILURE = exports.USER_PROFILE_GET_FAILURE = "USER_PROFILE_GET_FAILURE";
var USER_PROFILE_UPDATE_REQUEST = exports.USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
var USER_PROFILE_UPDATE_SUCCESS = exports.USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
var USER_PROFILE_UPDATE_FAILURE = exports.USER_PROFILE_UPDATE_FAILURE = "USER_PROFILE_UPDATE_FAILURE";
var USER_CHANGE_PASSWORD_REQUEST = exports.USER_CHANGE_PASSWORD_REQUEST = "USER_CHANGE_PASSWORD_REQUEST";
var USER_CHANGE_PASSWORD_SUCCESS = exports.USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
var USER_CHANGE_PASSWORD_FAILURE = exports.USER_CHANGE_PASSWORD_FAILURE = "USER_CHANGE_PASSWORD_FAILURE";
var USER_RESET_PASSWORD_REQUEST = exports.USER_RESET_PASSWORD_REQUEST = "USER_RESET_PASSWORD_REQUEST";
var USER_RESET_PASSWORD_SUCCESS = exports.USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
var USER_RESET_PASSWORD_FAILURE = exports.USER_RESET_PASSWORD_FAILURE = "USER_RESET_PASSWORD_FAILURE";

var ADMIN_GET_BASICS_REQUEST = exports.ADMIN_GET_BASICS_REQUEST = "ADMIN_GET_BASICS_REQUEST";
var ADMIN_GET_BASICS_SUCCESS = exports.ADMIN_GET_BASICS_SUCCESS = "ADMIN_GET_BASICS_SUCCESS";
var ADMIN_GET_BASICS_FAILURE = exports.ADMIN_GET_BASICS_FAILURE = "ADMIN_GET_BASICS_FAILURE";

var ADMIN_GET_SECTIONS_REQUEST = exports.ADMIN_GET_SECTIONS_REQUEST = "ADMIN_GET_SECTIONS_REQUEST";
var ADMIN_GET_SECTIONS_SUCCESS = exports.ADMIN_GET_SECTIONS_SUCCESS = "ADMIN_GET_SECTIONS_SUCCESS";
var ADMIN_GET_SECTIONS_FAILURE = exports.ADMIN_GET_SECTIONS_FAILURE = "ADMIN_GET_SECTIONS_FAILURE";
var ADMIN_GET_SECTION_REQUEST = exports.ADMIN_GET_SECTION_REQUEST = "ADMIN_GET_SECTION_REQUEST";
var ADMIN_GET_SECTION_SUCCESS = exports.ADMIN_GET_SECTION_SUCCESS = "ADMIN_GET_SECTION_SUCCESS";
var ADMIN_GET_SECTION_FAILURE = exports.ADMIN_GET_SECTION_FAILURE = "ADMIN_GET_SECTION_FAILURE";
var ADMIN_UPDATE_SECTION_REQUEST = exports.ADMIN_UPDATE_SECTION_REQUEST = "ADMIN_UPDATE_SECTION_REQUEST";
var ADMIN_UPDATE_SECTION_SUCCESS = exports.ADMIN_UPDATE_SECTION_SUCCESS = "ADMIN_UPDATE_SECTION_SUCCESS";
var ADMIN_UPDATE_SECTION_FAILURE = exports.ADMIN_UPDATE_SECTION_FAILURE = "ADMIN_UPDATE_SECTION_FAILURE";
var ADMIN_DELETE_SECTION_REQUEST = exports.ADMIN_DELETE_SECTION_REQUEST = "ADMIN_DELETE_SECTION_REQUEST";
var ADMIN_DELETE_SECTION_SUCCESS = exports.ADMIN_DELETE_SECTION_SUCCESS = "ADMIN_DELETE_SECTION_SUCCESS";
var ADMIN_DELETE_SECTION_FAILURE = exports.ADMIN_DELETE_SECTION_FAILURE = "ADMIN_DELETE_SECTION_FAILURE";
var ADMIN_CREATE_SECTION_REQUEST = exports.ADMIN_CREATE_SECTION_REQUEST = "ADMIN_CREATE_SECTION_REQUEST";
var ADMIN_CREATE_SECTION_SUCCESS = exports.ADMIN_CREATE_SECTION_SUCCESS = "ADMIN_CREATE_SECTION_SUCCESS";
var ADMIN_CREATE_SECTION_FAILURE = exports.ADMIN_CREATE_SECTION_FAILURE = "ADMIN_CREATE_SECTION_FAILURE";
var ADMIN_UPDATE_GENERAL_REQUEST = exports.ADMIN_UPDATE_GENERAL_REQUEST = "ADMIN_UPDATE_GENERAL_REQUEST";
var ADMIN_UPDATE_GENERAL_SUCCESS = exports.ADMIN_UPDATE_GENERAL_SUCCESS = "ADMIN_UPDATE_GENERAL_SUCCESS";
var ADMIN_UPDATE_GENERAL_FAILURE = exports.ADMIN_UPDATE_GENERAL_FAILURE = "ADMIN_UPDATE_GENERAL_FAILURE";
var ADMIN_GET_GENERAL_REQUEST = exports.ADMIN_GET_GENERAL_REQUEST = "ADMIN_GET_GENERAL_REQUEST";
var ADMIN_GET_GENERAL_SUCCESS = exports.ADMIN_GET_GENERAL_SUCCESS = "ADMIN_GET_GENERAL_SUCCESS";
var ADMIN_GET_GENERAL_FAILURE = exports.ADMIN_GET_GENERAL_FAILURE = "ADMIN_GET_GENERAL_FAILURE";

var ADMIN_CREATE_DEPOSIT_REQUEST = exports.ADMIN_CREATE_DEPOSIT_REQUEST = "ADMIN_GET_GENERAL_REQUEST";
var ADMIN_CREATE_DEPOSIT_SUCCESS = exports.ADMIN_CREATE_DEPOSIT_SUCCESS = "ADMIN_CREATE_DEPOSIT_SUCCESS";
var ADMIN_CREATE_DEPOSIT_FAILURE = exports.ADMIN_CREATE_DEPOSIT_FAILURE = "ADMIN_CREATE_DEPOSIT_FAILURE";

var ADMIN_UPDATE_DEPOSIT_REQUEST = exports.ADMIN_UPDATE_DEPOSIT_REQUEST = "ADMIN_UPDATE_DEPOSIT_REQUEST";
var ADMIN_UPDATE_DEPOSIT_SUCCESS = exports.ADMIN_UPDATE_DEPOSIT_SUCCESS = "ADMIN_UPDATE_DEPOSIT_SUCCESS";
var ADMIN_UPDATE_DEPOSIT_FAILURE = exports.ADMIN_UPDATE_DEPOSIT_FAILURE = "ADMIN_UPDATE_DEPOSIT_FAILURE";

var ADMIN_CREATE_MARKING_REQUEST = exports.ADMIN_CREATE_MARKING_REQUEST = "ADMIN_GET_MARKING_REQUEST";
var ADMIN_CREATE_MARKING_SUCCESS = exports.ADMIN_CREATE_MARKING_SUCCESS = "ADMIN_CREATE_MARKING_SUCCESS";
var ADMIN_CREATE_MARKING_FAILURE = exports.ADMIN_CREATE_MARKING_FAILURE = "ADMIN_CREATE_MARKING_FAILURE";

var ADMIN_UPDATE_MARKING_REQUEST = exports.ADMIN_UPDATE_MARKING_REQUEST = "ADMIN_UPDATE_MARKING_REQUEST";
var ADMIN_UPDATE_MARKING_SUCCESS = exports.ADMIN_UPDATE_MARKING_SUCCESS = "ADMIN_UPDATE_MARKING_SUCCESS";
var ADMIN_UPDATE_MARKING_FAILURE = exports.ADMIN_UPDATE_MARKING_FAILURE = "ADMIN_UPDATE_MARKING_FAILURE";

var ADMIN_GET_SECTION_PRIZE_REQUEST = exports.ADMIN_GET_SECTION_PRIZE_REQUEST = "ADMIN_GET_SECTION_PRIZE_REQUEST";
var ADMIN_GET_SECTION_PRIZE_SUCCESS = exports.ADMIN_GET_SECTION_PRIZE_SUCCESS = "ADMIN_GET_SECTION_PRIZE_SUCCESS";
var ADMIN_GET_SECTION_PRIZE_FAILURE = exports.ADMIN_GET_SECTION_PRIZE_FAILURE = "ADMIN_GET_SECTION_PRIZE_FAILURE";
var ADMIN_CREATE_SECTION_PRIZE_REQUEST = exports.ADMIN_CREATE_SECTION_PRIZE_REQUEST = "ADMIN_CREATE_SECTION_PRIZE_REQUEST";
var ADMIN_CREATE_SECTION_PRIZE_SUCCESS = exports.ADMIN_CREATE_SECTION_PRIZE_SUCCESS = "ADMIN_CREATE_SECTION_PRIZE_SUCCESS";
var ADMIN_CREATE_SECTION_PRIZE_FAILURE = exports.ADMIN_CREATE_SECTION_PRIZE_FAILURE = "ADMIN_CREATE_SECTION_PRIZE_FAILURE";
var ADMIN_UPDATE_SECTION_PRIZE_REQUEST = exports.ADMIN_UPDATE_SECTION_PRIZE_REQUEST = "ADMIN_UPDATE_SECTION_PRIZE_REQUEST";
var ADMIN_UPDATE_SECTION_PRIZE_SUCCESS = exports.ADMIN_UPDATE_SECTION_PRIZE_SUCCESS = "ADMIN_UPDATE_SECTION_PRIZE_SUCCESS";
var ADMIN_UPDATE_SECTION_PRIZE_FAILURE = exports.ADMIN_UPDATE_SECTION_PRIZE_FAILURE = "ADMIN_UPDATE_SECTION_PRIZE_FAILURE";
var ADMIN_DELETE_SECTION_PRIZE_REQUEST = exports.ADMIN_DELETE_SECTION_PRIZE_REQUEST = "ADMIN_DELETE_SECTION_PRIZE_REQUEST";
var ADMIN_DELETE_SECTION_PRIZE_SUCCESS = exports.ADMIN_DELETE_SECTION_PRIZE_SUCCESS = "ADMIN_DELETE_SECTION_PRIZE_SUCCESS";
var ADMIN_DELETE_SECTION_PRIZE_FAILURE = exports.ADMIN_DELETE_SECTION_PRIZE_FAILURE = "ADMIN_DELETE_SECTION_PRIZE_FAILURE";

var ADMIN_GET_CLUBS_REQUEST = exports.ADMIN_GET_CLUBS_REQUEST = "ADMIN_GET_CLUBS_REQUEST";
var ADMIN_GET_CLUBS_SUCCESS = exports.ADMIN_GET_CLUBS_SUCCESS = "ADMIN_GET_CLUBS_SUCCESS";
var ADMIN_GET_CLUBS_FAILURE = exports.ADMIN_GET_CLUBS_FAILURE = "ADMIN_GET_CLUBS_FAILURE";
var ADMIN_GET_CLUB_REQUEST = exports.ADMIN_GET_CLUB_REQUEST = "ADMIN_GET_CLUB_REQUEST";
var ADMIN_GET_CLUB_SUCCESS = exports.ADMIN_GET_CLUB_SUCCESS = "ADMIN_GET_CLUB_SUCCESS";
var ADMIN_GET_CLUB_FAILURE = exports.ADMIN_GET_CLUB_FAILURE = "ADMIN_GET_CLUB_FAILURE";
var ADMIN_GET_MEMBERS_REQUEST = exports.ADMIN_GET_MEMBERS_REQUEST = "ADMIN_GET_MEMBERS_REQUEST";
var ADMIN_GET_MEMBERS_SUCCESS = exports.ADMIN_GET_MEMBERS_SUCCESS = "ADMIN_GET_MEMBERS_SUCCESS";
var ADMIN_GET_MEMBERS_FAILURE = exports.ADMIN_GET_MEMBERS_FAILURE = "ADMIN_GET_MEMBERS_FAILURE";
var ADMIN_GET_MEMBER_REQUEST = exports.ADMIN_GET_MEMBER_REQUEST = "ADMIN_GET_MEMBER_REQUEST";
var ADMIN_GET_MEMBER_SUCCESS = exports.ADMIN_GET_MEMBER_SUCCESS = "ADMIN_GET_MEMBER_SUCCESS";
var ADMIN_GET_MEMBER_FAILURE = exports.ADMIN_GET_MEMBER_FAILURE = "ADMIN_GET_MEMBER_FAILURE";
var ADMIN_GET_PIGEON_HOLE_REQUEST = exports.ADMIN_GET_PIGEON_HOLE_REQUEST = "ADMIN_GET_PIGEON_HOLE_REQUEST";
var ADMIN_GET_PIGEON_HOLE_SUCCESS = exports.ADMIN_GET_PIGEON_HOLE_SUCCESS = "ADMIN_GET_PIGEON_HOLE_SUCCESS";
var ADMIN_GET_PIGEON_HOLE_FAILURE = exports.ADMIN_GET_PIGEON_HOLE_FAILURE = "ADMIN_GET_PIGEON_HOLE_FAILURE";
var ADMIN_CREATE_CLUB_REQUEST = exports.ADMIN_CREATE_CLUB_REQUEST = "ADMIN_CREATE_CLUB_REQUEST";
var ADMIN_CREATE_CLUB_SUCCESS = exports.ADMIN_CREATE_CLUB_SUCCESS = "ADMIN_CREATE_CLUB_SUCCESS";
var ADMIN_CREATE_CLUB_FAILURE = exports.ADMIN_CREATE_CLUB_FAILURE = "ADMIN_CREATE_CLUB_FAILURE";
var ADMIN_UPDATE_CLUB_REQUEST = exports.ADMIN_UPDATE_CLUB_REQUEST = "ADMIN_UPDATE_CLUB_REQUEST";
var ADMIN_UPDATE_CLUB_SUCCESS = exports.ADMIN_UPDATE_CLUB_SUCCESS = "ADMIN_UPDATE_CLUB_SUCCESS";
var ADMIN_UPDATE_CLUB_FAILURE = exports.ADMIN_UPDATE_CLUB_FAILURE = "ADMIN_UPDATE_CLUB_FAILURE";
var ADMIN_DELETE_CLUB_REQUEST = exports.ADMIN_DELETE_CLUB_REQUEST = "ADMIN_DELETE_CLUB_REQUEST";
var ADMIN_DELETE_CLUB_SUCCESS = exports.ADMIN_DELETE_CLUB_SUCCESS = "ADMIN_DELETE_CLUB_SUCCESS";
var ADMIN_DELETE_CLUB_FAILURE = exports.ADMIN_DELETE_CLUB_FAILURE = "ADMIN_DELETE_CLUB_FAILURE";
var ADMIN_CREATE_MEMBER_REQUEST = exports.ADMIN_CREATE_MEMBER_REQUEST = "ADMIN_CREATE_MEMBER_REQUEST";
var ADMIN_CREATE_MEMBER_SUCCESS = exports.ADMIN_CREATE_MEMBER_SUCCESS = "ADMIN_CREATE_MEMBER_SUCCESS";
var ADMIN_CREATE_MEMBER_FAILURE = exports.ADMIN_CREATE_MEMBER_FAILURE = "ADMIN_CREATE_MEMBER_FAILURE";
var ADMIN_UPDATE_MEMBER_REQUEST = exports.ADMIN_UPDATE_MEMBER_REQUEST = "ADMIN_UPDATE_MEMBER_REQUEST";
var ADMIN_UPDATE_MEMBER_SUCCESS = exports.ADMIN_UPDATE_MEMBER_SUCCESS = "ADMIN_UPDATE_MEMBER_SUCCESS";
var ADMIN_UPDATE_MEMBER_FAILURE = exports.ADMIN_UPDATE_MEMBER_FAILURE = "ADMIN_UPDATE_MEMBER_FAILURE";
var ADMIN_DELETE_MEMBER_REQUEST = exports.ADMIN_DELETE_MEMBER_REQUEST = "ADMIN_DELETE_MEMBER_REQUEST";
var ADMIN_DELETE_MEMBER_SUCCESS = exports.ADMIN_DELETE_MEMBER_SUCCESS = "ADMIN_DELETE_MEMBER_SUCCESS";
var ADMIN_DELETE_MEMBER_FAILURE = exports.ADMIN_DELETE_MEMBER_FAILURE = "ADMIN_DELETE_MEMBER_FAILURE";
var ADMIN_CREATE_PIGEONHOLE_REQUEST = exports.ADMIN_CREATE_PIGEONHOLE_REQUEST = "ADMIN_CREATE_PIGEONHOLE_REQUEST";
var ADMIN_CREATE_PIGEONHOLE_SUCCESS = exports.ADMIN_CREATE_PIGEONHOLE_SUCCESS = "ADMIN_CREATE_PIGEONHOLE_SUCCESS";
var ADMIN_CREATE_PIGEONHOLE_FAILURE = exports.ADMIN_CREATE_PIGEONHOLE_FAILURE = "ADMIN_CREATE_PIGEONHOLE_FAILURE";
var ADMIN_UPDATE_PIGEONHOLE_REQUEST = exports.ADMIN_UPDATE_PIGEONHOLE_REQUEST = "ADMIN_UPDATE_PIGEONHOLE_REQUEST";
var ADMIN_UPDATE_PIGEONHOLE_SUCCESS = exports.ADMIN_UPDATE_PIGEONHOLE_SUCCESS = "ADMIN_UPDATE_PIGEONHOLE_SUCCESS";
var ADMIN_UPDATE_PIGEONHOLE_FAILURE = exports.ADMIN_UPDATE_PIGEONHOLE_FAILURE = "ADMIN_UPDATE_PIGEONHOLE_FAILURE";
var ADMIN_DELETE_PIGEONHOLE_REQUEST = exports.ADMIN_DELETE_PIGEONHOLE_REQUEST = "ADMIN_DELETE_PIGEONHOLE_REQUEST";
var ADMIN_DELETE_PIGEONHOLE_SUCCESS = exports.ADMIN_DELETE_PIGEONHOLE_SUCCESS = "ADMIN_DELETE_PIGEONHOLE_SUCCESS";
var ADMIN_DELETE_PIGEONHOLE_FAILURE = exports.ADMIN_DELETE_PIGEONHOLE_FAILURE = "ADMIN_DELETE_PIGEONHOLE_FAILURE";

var ADMIN_CREATE_PIGEON_REQUEST = exports.ADMIN_CREATE_PIGEON_REQUEST = "ADMIN_CREATE_PIGEON_REQUEST";
var ADMIN_CREATE_PIGEON_SUCCESS = exports.ADMIN_CREATE_PIGEON_SUCCESS = "ADMIN_CREATE_PIGEON_SUCCESS";
var ADMIN_CREATE_PIGEON_FAILURE = exports.ADMIN_CREATE_PIGEON_FAILURE = "ADMIN_CREATE_PIGEON_FAILURE";
var ADMIN_UPDATE_PIGEON_REQUEST = exports.ADMIN_UPDATE_PIGEON_REQUEST = "ADMIN_UPDATE_PIGEON_REQUEST";
var ADMIN_UPDATE_PIGEON_SUCCESS = exports.ADMIN_UPDATE_PIGEON_SUCCESS = "ADMIN_UPDATE_PIGEON_SUCCESS";
var ADMIN_UPDATE_PIGEON_FAILURE = exports.ADMIN_UPDATE_PIGEON_FAILURE = "ADMIN_UPDATE_PIGEON_FAILURE";
var ADMIN_DELETE_PIGEON_REQUEST = exports.ADMIN_DELETE_PIGEON_REQUEST = "ADMIN_DELETE_PIGEON_REQUEST";
var ADMIN_DELETE_PIGEON_SUCCESS = exports.ADMIN_DELETE_PIGEON_SUCCESS = "ADMIN_DELETE_PIGEON_SUCCESS";
var ADMIN_DELETE_PIGEON_FAILURE = exports.ADMIN_DELETE_PIGEON_FAILURE = "ADMIN_DELETE_PIGEON_FAILURE";
var ADMIN_CREATE_PIGEONS_REQUEST = exports.ADMIN_CREATE_PIGEONS_REQUEST = "ADMIN_CREATE_PIGEONS_REQUEST";
var ADMIN_CREATE_PIGEONS_SUCCESS = exports.ADMIN_CREATE_PIGEONS_SUCCESS = "ADMIN_CREATE_PIGEONS_SUCCESS";
var ADMIN_CREATE_PIGEONS_FAILURE = exports.ADMIN_CREATE_PIGEONS_FAILURE = "ADMIN_CREATE_PIGEONS_FAILURE";
var ADMIN_UPDATE_PIGEONS_REQUEST = exports.ADMIN_UPDATE_PIGEONS_REQUEST = "ADMIN_UPDATE_PIGEONS_REQUEST";
var ADMIN_UPDATE_PIGEONS_SUCCESS = exports.ADMIN_UPDATE_PIGEONS_SUCCESS = "ADMIN_UPDATE_PIGEONS_SUCCESS";
var ADMIN_UPDATE_PIGEONS_FAILURE = exports.ADMIN_UPDATE_PIGEONS_FAILURE = "ADMIN_UPDATE_PIGEONS_FAILURE";
var ADMIN_DELETE_PIGEONS_REQUEST = exports.ADMIN_DELETE_PIGEONS_REQUEST = "ADMIN_DELETE_PIGEONS_REQUEST";
var ADMIN_DELETE_PIGEONS_SUCCESS = exports.ADMIN_DELETE_PIGEONS_SUCCESS = "ADMIN_DELETE_PIGEONS_SUCCESS";
var ADMIN_DELETE_PIGEONS_FAILURE = exports.ADMIN_DELETE_PIGEONS_FAILURE = "ADMIN_DELETE_PIGEONS_FAILURE";

var ADMIN_CREATE_RINGSERIE_REQUEST = exports.ADMIN_CREATE_RINGSERIE_REQUEST = "ADMIN_CREATE_RINGSERIE_REQUEST";
var ADMIN_CREATE_RINGSERIE_SUCCESS = exports.ADMIN_CREATE_RINGSERIE_SUCCESS = "ADMIN_CREATE_RINGSERIE_SUCCESS";
var ADMIN_CREATE_RINGSERIE_FAILURE = exports.ADMIN_CREATE_RINGSERIE_FAILURE = "ADMIN_CREATE_RINGSERIE_FAILURE";
var ADMIN_UPDATE_RINGSERIE_REQUEST = exports.ADMIN_UPDATE_RINGSERIE_REQUEST = "ADMIN_UPDATE_RINGSERIE_REQUEST";
var ADMIN_UPDATE_RINGSERIE_SUCCESS = exports.ADMIN_UPDATE_RINGSERIE_SUCCESS = "ADMIN_UPDATE_RINGSERIE_SUCCESS";
var ADMIN_UPDATE_RINGSERIE_FAILURE = exports.ADMIN_UPDATE_RINGSERIE_FAILURE = "ADMIN_UPDATE_RINGSERIE_FAILURE";
var ADMIN_DELETE_RINGSERIE_REQUEST = exports.ADMIN_DELETE_RINGSERIE_REQUEST = "ADMIN_DELETE_RINGSERIE_REQUEST";
var ADMIN_DELETE_RINGSERIE_SUCCESS = exports.ADMIN_DELETE_RINGSERIE_SUCCESS = "ADMIN_DELETE_RINGSERIE_SUCCESS";
var ADMIN_DELETE_RINGSERIE_FAILURE = exports.ADMIN_DELETE_RINGSERIE_FAILURE = "ADMIN_DELETE_RINGSERIE_FAILURE";

var ADMIN_GET_STATION_SELECTIONS_REQUEST = exports.ADMIN_GET_STATION_SELECTIONS_REQUEST = "ADMIN_GET_STATION_SELECTIONS_REQUEST";
var ADMIN_GET_STATION_SELECTIONS_SUCCESS = exports.ADMIN_GET_STATION_SELECTIONS_SUCCESS = "ADMIN_GET_STATION_SELECTIONS_SUCCESS";
var ADMIN_GET_STATION_SELECTIONS_FAILURE = exports.ADMIN_GET_STATION_SELECTIONS_FAILURE = "ADMIN_GET_STATION_SELECTIONS_FAILURE";
var ADMIN_SELECT_STATIONS_REQUEST = exports.ADMIN_SELECT_STATIONS_REQUEST = "ADMIN_SELECT_STATIONS_REQUEST";
var ADMIN_SELECT_STATIONS_SUCCESS = exports.ADMIN_SELECT_STATIONS_SUCCESS = "ADMIN_SELECT_STATIONS_SUCCESS";
var ADMIN_SELECT_STATIONS_FAILURE = exports.ADMIN_SELECT_STATIONS_FAILURE = "ADMIN_SELECT_STATIONS_FAILURE";
var ADMIN_UNSELECT_STATIONS_REQUEST = exports.ADMIN_UNSELECT_STATIONS_REQUEST = "ADMIN_UNSELECT_STATIONS_REQUEST";
var ADMIN_UNSELECT_STATIONS_SUCCESS = exports.ADMIN_UNSELECT_STATIONS_SUCCESS = "ADMIN_UNSELECT_STATIONS_SUCCESS";
var ADMIN_UNSELECT_STATIONS_FAILURE = exports.ADMIN_UNSELECT_STATIONS_FAILURE = "ADMIN_UNSELECT_STATIONS_FAILURE";
var ADMIN_CALC_DISTANCES_REQUEST = exports.ADMIN_CALC_DISTANCES_REQUEST = "ADMIN_CALC_DISTANCES_REQUEST";
var ADMIN_CALC_DISTANCES_SUCCESS = exports.ADMIN_CALC_DISTANCES_SUCCESS = "ADMIN_CALC_DISTANCES_SUCCESS";
var ADMIN_CALC_DISTANCES_FAILURE = exports.ADMIN_CALC_DISTANCES_FAILURE = "ADMIN_CALC_DISTANCES_FAILURE";

var ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST = exports.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST";
var ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS = exports.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS";
var ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE = exports.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE = "ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE";
var ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST = exports.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST";
var ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS = exports.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS";
var ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE = exports.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE = "ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE";
var ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST = exports.ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST = "ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST";
var ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS = exports.ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS = "ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS";
var ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE = exports.ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE = "ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE";
var ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST = exports.ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST = "ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST";
var ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS = exports.ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS = "ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS";
var ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE = exports.ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE = "ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE = "ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS";
var ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE = exports.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE = "ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE";
var ADMIN_RESET_UPDATE_MARKINGS_REQUEST = exports.ADMIN_RESET_UPDATE_MARKINGS_REQUEST = "ADMIN_RESET_UPDATE_MARKINGS_REQUEST";
var ADMIN_RESET_UPDATE_MARKINGS_SUCCESS = exports.ADMIN_RESET_UPDATE_MARKINGS_SUCCESS = "ADMIN_RESET_UPDATE_MARKINGS_SUCCESS";
var ADMIN_RESET_UPDATE_MARKINGS_FAILURE = exports.ADMIN_RESET_UPDATE_MARKINGS_FAILURE = "ADMIN_RESET_UPDATE_MARKINGS_FAILURE";

var ADMIN_GET_LIST_ITEMS_REQUEST = exports.ADMIN_GET_LIST_ITEMS_REQUEST = "ADMIN_GET_LIST_ITEMS_REQUEST";
var ADMIN_GET_LIST_ITEMS_SUCCESS = exports.ADMIN_GET_LIST_ITEMS_SUCCESS = "ADMIN_GET_LIST_ITEMS_SUCCESS";
var ADMIN_GET_LIST_ITEMS_FAILURE = exports.ADMIN_GET_LIST_ITEMS_FAILURE = "ADMIN_GET_LIST_ITEMS_FAILURE";
var ADMIN_CREATE_LIST_ITEM_REQUEST = exports.ADMIN_CREATE_LIST_ITEM_REQUEST = "ADMIN_CREATE_LIST_ITEM_REQUEST";
var ADMIN_CREATE_LIST_ITEM_SUCCESS = exports.ADMIN_CREATE_LIST_ITEM_SUCCESS = "ADMIN_CREATE_LIST_ITEM_SUCCESS";
var ADMIN_CREATE_LIST_ITEM_FAILURE = exports.ADMIN_CREATE_LIST_ITEM_FAILURE = "ADMIN_CREATE_LIST_ITEM_FAILURE";
var ADMIN_UPDATE_LIST_ITEM_REQUEST = exports.ADMIN_UPDATE_LIST_ITEM_REQUEST = "ADMIN_UPDATE_LIST_ITEM_REQUEST";
var ADMIN_UPDATE_LIST_ITEM_SUCCESS = exports.ADMIN_UPDATE_LIST_ITEM_SUCCESS = "ADMIN_UPDATE_LIST_ITEM_SUCCESS";
var ADMIN_UPDATE_LIST_ITEM_FAILURE = exports.ADMIN_UPDATE_LIST_ITEM_FAILURE = "ADMIN_UPDATE_LIST_ITEM_FAILURE";
var ADMIN_DELETE_LIST_ITEM_REQUEST = exports.ADMIN_DELETE_LIST_ITEM_REQUEST = "ADMIN_DELETE_LIST_ITEM_REQUEST";
var ADMIN_DELETE_LIST_ITEM_SUCCESS = exports.ADMIN_DELETE_LIST_ITEM_SUCCESS = "ADMIN_DELETE_LIST_ITEM_SUCCESS";
var ADMIN_DELETE_LIST_ITEM_FAILURE = exports.ADMIN_DELETE_LIST_ITEM_FAILURE = "ADMIN_DELETE_LIST_ITEM_FAILURE";
var ADMIN_EXPORT_RACE_DATE_REQUEST = exports.ADMIN_EXPORT_RACE_DATE_REQUEST = "ADMIN_EXPORT_RACE_DATE_REQUEST";
var ADMIN_EXPORT_RACE_DATE_SUCCESS = exports.ADMIN_EXPORT_RACE_DATE_SUCCESS = "ADMIN_EXPORT_RACE_DATE_SUCCESS";
var ADMIN_EXPORT_RACE_DATE_FAILURE = exports.ADMIN_EXPORT_RACE_DATE_FAILURE = "ADMIN_EXPORT_RACE_DATE_FAILURE";

var ADMIN_IMPORT_SECTION_STAT_REQUEST = exports.ADMIN_IMPORT_SECTION_STAT_REQUEST = "ADMIN_IMPORT_SECTION_STAT_REQUEST";
var ADMIN_IMPORT_SECTION_STAT_SUCCESS = exports.ADMIN_IMPORT_SECTION_STAT_SUCCESS = "ADMIN_IMPORT_SECTION_STAT_SUCCESS";
var ADMIN_IMPORT_SECTION_STAT_FAILURE = exports.ADMIN_IMPORT_SECTION_STAT_FAILURE = "ADMIN_IMPORT_SECTION_STAT_FAILURE";
var ADMIN_INVOICE_RACES_REQUEST = exports.ADMIN_INVOICE_RACES_REQUEST = "ADMIN_INVOICE_RACES_REQUEST";
var ADMIN_INVOICE_RACES_SUCCESS = exports.ADMIN_INVOICE_RACES_SUCCESS = "ADMIN_INVOICE_RACES_SUCCESS";
var ADMIN_INVOICE_RACES_FAILURE = exports.ADMIN_INVOICE_RACES_FAILURE = "ADMIN_INVOICE_RACES_FAILURE";
var ADMIN_START_SEASON_REQUEST = exports.ADMIN_START_SEASON_REQUEST = "ADMIN_START_SEASON_REQUEST";
var ADMIN_START_SEASON_SUCCESS = exports.ADMIN_START_SEASON_SUCCESS = "ADMIN_START_SEASON_SUCCESS";
var ADMIN_START_SEASON_FAILURE = exports.ADMIN_START_SEASON_FAILURE = "ADMIN_START_SEASON_FAILURE";
var ADMIN_GET_DASHBOARD_REQUEST = exports.ADMIN_GET_DASHBOARD_REQUEST = "ADMIN_GET_DASHBOARD_REQUEST";
var ADMIN_GET_DASHBOARD_SUCCESS = exports.ADMIN_GET_DASHBOARD_SUCCESS = "ADMIN_GET_DASHBOARD_SUCCESS";
var ADMIN_GET_DASHBOARD_FAILURE = exports.ADMIN_GET_DASHBOARD_FAILURE = "ADMIN_GET_DASHBOARD_FAILURE";
var ADMIN_SELECT_USER_ROLE_REQUEST = exports.ADMIN_SELECT_USER_ROLE_REQUEST = "ADMIN_SELECT_USER_ROLE_REQUEST";
var ADMIN_SELECT_USER_ROLE_SUCCESS = exports.ADMIN_SELECT_USER_ROLE_SUCCESS = "ADMIN_SELECT_USER_ROLE_SUCCESS";
var ADMIN_SELECT_USER_ROLE_FAILURE = exports.ADMIN_SELECT_USER_ROLE_FAILURE = "ADMIN_SELECT_USER_ROLE_FAILURE";
var ADMIN_SELECT_DATABASE_REQUEST = exports.ADMIN_SELECT_DATABASE_REQUEST = "ADMIN_SELECT_DATABASE_REQUEST";
var ADMIN_SELECT_DATABASE_SUCCESS = exports.ADMIN_SELECT_DATABASE_SUCCESS = "ADMIN_SELECT_DATABASE_SUCCESS";
var ADMIN_SELECT_DATABASE_FAILURE = exports.ADMIN_SELECT_DATABASE_FAILURE = "ADMIN_SELECT_DATABASE_FAILURE";

var ADMIN_GET_ERROR_LIST_ITEMS_REQUEST = exports.ADMIN_GET_ERROR_LIST_ITEMS_REQUEST = "ADMIN_GET_ERROR_LIST_ITEMS_REQUEST";
var ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS = exports.ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS = "ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS";
var ADMIN_GET_ERROR_LIST_ITEMS_FAILURE = exports.ADMIN_GET_ERROR_LIST_ITEMS_FAILURE = "ADMIN_GET_ERROR_LIST_ITEMS_FAILURE";
var ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST = exports.ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST = "ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST";
var ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS = exports.ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS = "ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS";
var ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE = exports.ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE = "ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE";
var ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST = exports.ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST = "ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST";
var ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS = exports.ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS = "ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS";
var ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE = exports.ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE = "ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE";
var ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST = exports.ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST = "ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST";
var ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS = exports.ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS = "ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS";
var ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE = exports.ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE = "ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE";
var ADMIN_RELOAD_IMPORT_FILE_REQUEST = exports.ADMIN_RELOAD_IMPORT_FILE_REQUEST = "ADMIN_RELOAD_IMPORT_FILE_REQUEST";
var ADMIN_RELOAD_IMPORT_FILE_SUCCESS = exports.ADMIN_RELOAD_IMPORT_FILE_SUCCESS = "ADMIN_RELOAD_IMPORT_FILE_SUCCESS";
var ADMIN_RELOAD_IMPORT_FILE_FAILURE = exports.ADMIN_RELOAD_IMPORT_FILE_FAILURE = "ADMIN_RELOAD_IMPORT_FILE_FAILURE";

var RACE_GET_ALL_REQUEST = exports.RACE_GET_ALL_REQUEST = "RACE_GET_ALL_REQUEST";
var RACE_GET_ALL_SUCCESS = exports.RACE_GET_ALL_SUCCESS = "RACE_GET_ALL_SUCCESS";
var RACE_GET_ALL_FAILURE = exports.RACE_GET_ALL_FAILURE = "RACE_GET_ALL_FAILURE";
var RACE_GET_DETAILS_REQUEST = exports.RACE_GET_DETAILS_REQUEST = "RACE_GET_DETAILS_REQUEST";
var RACE_GET_DETAILS_SUCCESS = exports.RACE_GET_DETAILS_SUCCESS = "RACE_GET_DETAILS_SUCCESS";
var RACE_GET_DETAILS_FAILURE = exports.RACE_GET_DETAILS_FAILURE = "RACE_GET_DETAILS_FAILURE";
var RACE_CREATE_REQUEST = exports.RACE_CREATE_REQUEST = "RACE_CREATE_REQUEST";
var RACE_CREATE_SUCCESS = exports.RACE_CREATE_SUCCESS = "RACE_CREATE_SUCCESS";
var RACE_CREATE_FAILURE = exports.RACE_CREATE_FAILURE = "RACE_CREATE_FAILURE";
var RACE_UPDATE_REQUEST = exports.RACE_UPDATE_REQUEST = "RACE_UPDATE_REQUEST";
var RACE_UPDATE_SUCCESS = exports.RACE_UPDATE_SUCCESS = "RACE_UPDATE_SUCCESS";
var RACE_UPDATE_FAILURE = exports.RACE_UPDATE_FAILURE = "RACE_UPDATE_FAILURE";
var RACE_DELETE_REQUEST = exports.RACE_DELETE_REQUEST = "RACE_DELETE_REQUEST";
var RACE_DELETE_SUCCESS = exports.RACE_DELETE_SUCCESS = "RACE_DELETE_SUCCESS";
var RACE_DELETE_FAILURE = exports.RACE_DELETE_FAILURE = "RACE_DELETE_FAILURE";
var RACE_GET_PIGEONS_REQUEST = exports.RACE_GET_PIGEONS_REQUEST = "RACE_GET_PIGEONS_REQUEST";
var RACE_GET_PIGEONS_SUCCESS = exports.RACE_GET_PIGEONS_SUCCESS = "RACE_GET_PIGEONS_SUCCESS";
var RACE_GET_PIGEONS_FAILURE = exports.RACE_GET_PIGEONS_FAILURE = "RACE_GET_PIGEONS_FAILURE";
var RACE_CREATE_PIGEON_REQUEST = exports.RACE_CREATE_PIGEON_REQUEST = "RACE_CREATE_PIGEON_REQUEST";
var RACE_CREATE_PIGEON_SUCCESS = exports.RACE_CREATE_PIGEON_SUCCESS = "RACE_CREATE_PIGEON_SUCCESS";
var RACE_CREATE_PIGEON_FAILURE = exports.RACE_CREATE_PIGEON_FAILURE = "RACE_CREATE_PIGEON_FAILURE";
var RACE_UPDATE_PIGEON_REQUEST = exports.RACE_UPDATE_PIGEON_REQUEST = "RACE_UPDATE_PIGEON_REQUEST";
var RACE_UPDATE_PIGEON_SUCCESS = exports.RACE_UPDATE_PIGEON_SUCCESS = "RACE_UPDATE_PIGEON_SUCCESS";
var RACE_UPDATE_PIGEON_FAILURE = exports.RACE_UPDATE_PIGEON_FAILURE = "RACE_UPDATE_PIGEON_FAILURE";
var RACE_DELETE_PIGEON_REQUEST = exports.RACE_DELETE_PIGEON_REQUEST = "RACE_DELETE_PIGEON_REQUEST";
var RACE_DELETE_PIGEON_SUCCESS = exports.RACE_DELETE_PIGEON_SUCCESS = "RACE_DELETE_PIGEON_SUCCESS";
var RACE_DELETE_PIGEON_FAILURE = exports.RACE_DELETE_PIGEON_FAILURE = "RACE_DELETE_PIGEON_FAILURE";
var RACE_CREATE_WATCH_REQUEST = exports.RACE_CREATE_WATCH_REQUEST = "RACE_CREATE_WATCH_REQUEST";
var RACE_CREATE_WATCH_SUCCESS = exports.RACE_CREATE_WATCH_SUCCESS = "RACE_CREATE_WATCH_SUCCESS";
var RACE_CREATE_WATCH_FAILURE = exports.RACE_CREATE_WATCH_FAILURE = "RACE_CREATE_WATCH_FAILURE";
var RACE_UPDATE_WATCH_REQUEST = exports.RACE_UPDATE_WATCH_REQUEST = "RACE_UPDATE_WATCH_REQUEST";
var RACE_UPDATE_WATCH_SUCCESS = exports.RACE_UPDATE_WATCH_SUCCESS = "RACE_UPDATE_WATCH_SUCCESS";
var RACE_UPDATE_WATCH_FAILURE = exports.RACE_UPDATE_WATCH_FAILURE = "RACE_UPDATE_WATCH_FAILURE";
var RACE_DELETE_WATCH_REQUEST = exports.RACE_DELETE_WATCH_REQUEST = "RACE_DELETE_WATCH_REQUEST";
var RACE_DELETE_WATCH_SUCCESS = exports.RACE_DELETE_WATCH_SUCCESS = "RACE_DELETE_WATCH_SUCCESS";
var RACE_DELETE_WATCH_FAILURE = exports.RACE_DELETE_WATCH_FAILURE = "RACE_DELETE_WATCH_FAILURE";
var RACE_ADD_MEMBER_GAMES_REQUEST = exports.RACE_ADD_MEMBER_GAMES_REQUEST = "RACE_ADD_MEMBER_GAMES_REQUEST";
var RACE_ADD_MEMBER_GAMES_SUCCESS = exports.RACE_ADD_MEMBER_GAMES_SUCCESS = "RACE_ADD_MEMBER_GAMES_SUCCESS";
var RACE_ADD_MEMBER_GAMES_FAILURE = exports.RACE_ADD_MEMBER_GAMES_FAILURE = "RACE_ADD_MEMBER_GAMES_FAILURE";
var RACE_REMOVE_MEMBER_GAMES_REQUEST = exports.RACE_REMOVE_MEMBER_GAMES_REQUEST = "RACE_REMOVE_MEMBER_GAMES_REQUEST";
var RACE_REMOVE_MEMBER_GAMES_SUCCESS = exports.RACE_REMOVE_MEMBER_GAMES_SUCCESS = "RACE_REMOVE_MEMBER_GAMES_SUCCESS";
var RACE_REMOVE_MEMBER_GAMES_FAILURE = exports.RACE_REMOVE_MEMBER_GAMES_FAILURE = "RACE_REMOVE_MEMBER_GAMES_FAILURE";
var RACE_ADD_DECAYS_REQUEST = exports.RACE_ADD_DECAYS_REQUEST = "RACE_ADD_DECAYS_REQUEST";
var RACE_ADD_DECAYS_SUCCESS = exports.RACE_ADD_DECAYS_SUCCESS = "RACE_ADD_DECAYS_SUCCESS";
var RACE_ADD_DECAYS_FAILURE = exports.RACE_ADD_DECAYS_FAILURE = "RACE_ADD_DECAYS_FAILURE";
var RACE_REMOVE_DECAYS_REQUEST = exports.RACE_REMOVE_DECAYS_REQUEST = "RACE_REMOVE_DECAYS_REQUEST";
var RACE_REMOVE_DECAYS_SUCCESS = exports.RACE_REMOVE_DECAYS_SUCCESS = "RACE_REMOVE_DECAYS_SUCCESS";
var RACE_REMOVE_DECAYS_FAILURE = exports.RACE_REMOVE_DECAYS_FAILURE = "RACE_REMOVE_DECAYS_FAILURE";
var RACE_GET_PRICES_REQUEST = exports.RACE_GET_PRICES_REQUEST = "RACE_GET_PRICES_REQUEST";
var RACE_GET_PRICES_SUCCESS = exports.RACE_GET_PRICES_SUCCESS = "RACE_GET_PRICES_SUCCESS";
var RACE_GET_PRICES_FAILURE = exports.RACE_GET_PRICES_FAILURE = "RACE_GET_PRICES_FAILURE";
var RACE_CREATE_PRICE_REQUEST = exports.RACE_CREATE_PRICE_REQUEST = "RACE_CREATE_PRICE_REQUEST";
var RACE_CREATE_PRICE_SUCCESS = exports.RACE_CREATE_PRICE_SUCCESS = "RACE_CREATE_PRICE_SUCCESS";
var RACE_CREATE_PRICE_FAILURE = exports.RACE_CREATE_PRICE_FAILURE = "RACE_CREATE_PRICE_FAILURE";
var RACE_UPDATE_PRICE_REQUEST = exports.RACE_UPDATE_PRICE_REQUEST = "RACE_UPDATE_PRICE_REQUEST";
var RACE_UPDATE_PRICE_SUCCESS = exports.RACE_UPDATE_PRICE_SUCCESS = "RACE_UPDATE_PRICE_SUCCESS";
var RACE_UPDATE_PRICE_FAILURE = exports.RACE_UPDATE_PRICE_FAILURE = "RACE_UPDATE_PRICE_FAILURE";
var RACE_DELETE_PRICE_REQUEST = exports.RACE_DELETE_PRICE_REQUEST = "RACE_DELETE_PRICE_REQUEST";
var RACE_DELETE_PRICE_SUCCESS = exports.RACE_DELETE_PRICE_SUCCESS = "RACE_DELETE_PRICE_SUCCESS";
var RACE_DELETE_PRICE_FAILURE = exports.RACE_DELETE_PRICE_FAILURE = "RACE_DELETE_PRICE_FAILURE";
var RACE_UPDATE_PRICE_ADDITIONS_REQUEST = exports.RACE_UPDATE_PRICE_ADDITIONS_REQUEST = "RACE_UPDATE_PRICE_ADDITIONS_REQUEST";
var RACE_UPDATE_PRICE_ADDITIONS_SUCCESS = exports.RACE_UPDATE_PRICE_ADDITIONS_SUCCESS = "RACE_UPDATE_PRICE_ADDITIONS_SUCCESS";
var RACE_UPDATE_PRICE_ADDITIONS_FAILURE = exports.RACE_UPDATE_PRICE_ADDITIONS_FAILURE = "RACE_UPDATE_PRICE_ADDITIONS_FAILURE";
var RACE_RESET_PRICES_REQUEST = exports.RACE_RESET_PRICES_REQUEST = "RACE_RESET_PRICES_REQUEST";
var RACE_RESET_PRICES_SUCCESS = exports.RACE_RESET_PRICES_SUCCESS = "RACE_RESET_PRICES_SUCCESS";
var RACE_RESET_PRICES_FAILURE = exports.RACE_RESET_PRICES_FAILURE = "RACE_RESET_PRICES_FAILURE";
var RACE_CALC_PRICES_REQUEST = exports.RACE_CALC_PRICES_REQUEST = "RACE_CALC_PRICES_REQUEST";
var RACE_CALC_PRICES_SUCCESS = exports.RACE_CALC_PRICES_SUCCESS = "RACE_CALC_PRICES_SUCCESS";
var RACE_CALC_PRICES_FAILURE = exports.RACE_CALC_PRICES_FAILURE = "RACE_CALC_PRICES_FAILURE";
var RACE_CALC_REQUEST = exports.RACE_CALC_REQUEST = "RACE_CALC_REQUEST";
var RACE_CALC_SUCCESS = exports.RACE_CALC_SUCCESS = "RACE_CALC_SUCCESS";
var RACE_CALC_FAILURE = exports.RACE_CALC_FAILURE = "RACE_CALC_FAILURE";
var RACE_GET_BASICS_REQUEST = exports.RACE_GET_BASICS_REQUEST = "RACE_GET_BASICS_REQUEST";
var RACE_GET_BASICS_SUCCESS = exports.RACE_GET_BASICS_SUCCESS = "RACE_GET_BASICS_SUCCESS";
var RACE_GET_BASICS_FAILURE = exports.RACE_GET_BASICS_FAILURE = "RACE_GET_BASICS_FAILURE";
var RACE_START_DEVICE_IMPORT_REQUEST = exports.RACE_START_DEVICE_IMPORT_REQUEST = "RACE_START_DEVICE_IMPORT_REQUEST";
var RACE_START_DEVICE_IMPORT_SUCCESS = exports.RACE_START_DEVICE_IMPORT_SUCCESS = "RACE_START_DEVICE_IMPORT_SUCCESS";
var RACE_START_DEVICE_IMPORT_FAILURE = exports.RACE_START_DEVICE_IMPORT_FAILURE = "RACE_START_DEVICE_IMPORT_FAILURE";
var RACE_UPDATE_DEVICE_IMPORT_REQUEST = exports.RACE_UPDATE_DEVICE_IMPORT_REQUEST = "RACE_UPDATE_DEVICE_IMPORT_REQUEST";
var RACE_UPDATE_DEVICE_IMPORT_SUCCESS = exports.RACE_UPDATE_DEVICE_IMPORT_SUCCESS = "RACE_UPDATE_DEVICE_IMPORT_SUCCESS";
var RACE_UPDATE_DEVICE_IMPORT_FAILURE = exports.RACE_UPDATE_DEVICE_IMPORT_FAILURE = "RACE_UPDATE_DEVICE_IMPORT_FAILURE";
var RACE_CHECK_DEVICE_IMPORT_REQUEST = exports.RACE_CHECK_DEVICE_IMPORT_REQUEST = "RACE_CHECK_DEVICE_IMPORT_REQUEST";
var RACE_CHECK_DEVICE_IMPORT_SUCCESS = exports.RACE_CHECK_DEVICE_IMPORT_SUCCESS = "RACE_CHECK_DEVICE_IMPORT_SUCCESS";
var RACE_CHECK_DEVICE_IMPORT_FAILURE = exports.RACE_CHECK_DEVICE_IMPORT_FAILURE = "RACE_CHECK_DEVICE_IMPORT_FAILURE";
var RACE_SEND_FROM_CLUB_REQUEST = exports.RACE_SEND_FROM_CLUB_REQUEST = "RACE_SEND_FROM_CLUB_REQUEST";
var RACE_SEND_FROM_CLUB_SUCCESS = exports.RACE_SEND_FROM_CLUB_SUCCESS = "RACE_SEND_FROM_CLUB_SUCCESS";
var RACE_SEND_FROM_CLUB_FAILURE = exports.RACE_SEND_FROM_CLUB_FAILURE = "RACE_SEND_FROM_CLUB_FAILURE";
var RACE_GET_FROM_MEMBER_REQUEST = exports.RACE_GET_FROM_MEMBER_REQUEST = "RACE_GET_FROM_MEMBER_REQUEST";
var RACE_GET_FROM_MEMBER_SUCCESS = exports.RACE_GET_FROM_MEMBER_SUCCESS = "RACE_GET_FROM_MEMBER_SUCCESS";
var RACE_GET_FROM_MEMBER_FAILURE = exports.RACE_GET_FROM_MEMBER_FAILURE = "RACE_GET_FROM_MEMBER_FAILURE";

var CHECK_EMAIL_EXISTS_REQUEST = exports.CHECK_EMAIL_EXISTS_REQUEST = "CHECK_EMAIL_EXISTS_REQUEST";
var CHECK_EMAIL_EXISTS_SUCCESS = exports.CHECK_EMAIL_EXISTS_SUCCESS = "CHECK_EMAIL_EXISTS_SUCCESS";
var CHECK_EMAIL_EXISTS_FAILURE = exports.CHECK_EMAIL_EXISTS_FAILURE = "CHECK_EMAIL_EXISTS_FAILURE";

var ADMIN_GET_KILOMETERS_REQUEST = exports.ADMIN_GET_KILOMETERS_REQUEST = "ADMIN_GET_KILOMETERS_REQUEST";
var ADMIN_GET_KILOMETERS_SUCCESS = exports.ADMIN_GET_KILOMETERS_SUCCESS = "ADMIN_GET_KILOMETERS_SUCCESS";
var ADMIN_GET_KILOMETERS_FAILURE = exports.ADMIN_GET_KILOMETERS_FAILURE = "ADMIN_GET_KILOMETERS_FAILURE";

var ADMIN_CREATE_KILOMETER_REQUEST = exports.ADMIN_CREATE_KILOMETER_REQUEST = "ADMIN_CREATE_KILOMETER_REQUEST";
var ADMIN_CREATE_KILOMETER_SUCCESS = exports.ADMIN_CREATE_KILOMETER_SUCCESS = "ADMIN_CREATE_KILOMETER_SUCCESS";
var ADMIN_CREATE_KILOMETER_FAILURE = exports.ADMIN_CREATE_KILOMETER_FAILURE = "ADMIN_CREATE_KILOMETER_FAILURE";

var ADMIN_UPDATE_KILOMETER_REQUEST = exports.ADMIN_UPDATE_KILOMETER_REQUEST = "ADMIN_UPDATE_KILOMETER_REQUEST";
var ADMIN_UPDATE_KILOMETER_SUCCESS = exports.ADMIN_UPDATE_KILOMETER_SUCCESS = "ADMIN_UPDATE_KILOMETER_SUCCESS";
var ADMIN_UPDATE_KILOMETER_FAILURE = exports.ADMIN_UPDATE_KILOMETER_FAILURE = "ADMIN_UPDATE_KILOMETER_FAILURE";

var ADMIN_DELETE_KILOMETER_REQUEST = exports.ADMIN_DELETE_KILOMETER_REQUEST = "ADMIN_DELETE_KILOMETER_REQUEST";
var ADMIN_DELETE_KILOMETER_SUCCESS = exports.ADMIN_DELETE_KILOMETER_SUCCESS = "ADMIN_DELETE_KILOMETER_SUCCESS";
var ADMIN_DELETE_KILOMETER_FAILURE = exports.ADMIN_DELETE_KILOMETER_FAILURE = "ADMIN_DELETE_KILOMETER_FAILURE";

var ADMIN_GET_CHAMPIONSHIPS_REQUEST = exports.ADMIN_GET_CHAMPIONSHIPS_REQUEST = "ADMIN_GET_CHAMPIONSHIPS_REQUEST";
var ADMIN_GET_CHAMPIONSHIPS_SUCCESS = exports.ADMIN_GET_CHAMPIONSHIPS_SUCCESS = "ADMIN_GET_CHAMPIONSHIPS_SUCCESS";
var ADMIN_GET_CHAMPIONSHIPS_FAILURE = exports.ADMIN_GET_CHAMPIONSHIPS_FAILURE = "ADMIN_GET_CHAMPIONSHIPS_FAILURE";

var ADMIN_GET_CHAMPIONSHIP_REQUEST = exports.ADMIN_GET_CHAMPIONSHIP_REQUEST = "ADMIN_GET_CHAMPIONSHIP_REQUEST";
var ADMIN_GET_CHAMPIONSHIP_SUCCESS = exports.ADMIN_GET_CHAMPIONSHIP_SUCCESS = "ADMIN_GET_CHAMPIONSHIP_SUCCESS";
var ADMIN_GET_CHAMPIONSHIP_FAILURE = exports.ADMIN_GET_CHAMPIONSHIP_FAILURE = "ADMIN_GET_CHAMPIONSHIP_FAILURE";
var ADMIN_CREATE_CHAMPIONSHIP_REQUEST = exports.ADMIN_CREATE_CHAMPIONSHIP_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_REQUEST";
var ADMIN_CREATE_CHAMPIONSHIP_SUCCESS = exports.ADMIN_CREATE_CHAMPIONSHIP_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_SUCCESS";
var ADMIN_CREATE_CHAMPIONSHIP_FAILURE = exports.ADMIN_CREATE_CHAMPIONSHIP_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_FAILURE";
var ADMIN_UPDATE_CHAMPIONSHIP_REQUEST = exports.ADMIN_UPDATE_CHAMPIONSHIP_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_REQUEST";
var ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS = exports.ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS";
var ADMIN_UPDATE_CHAMPIONSHIP_FAILURE = exports.ADMIN_UPDATE_CHAMPIONSHIP_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_FAILURE";
var ADMIN_DELETE_CHAMPIONSHIP_REQUEST = exports.ADMIN_DELETE_CHAMPIONSHIP_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_REQUEST";
var ADMIN_DELETE_CHAMPIONSHIP_SUCCESS = exports.ADMIN_DELETE_CHAMPIONSHIP_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_SUCCESS";
var ADMIN_DELETE_CHAMPIONSHIP_FAILURE = exports.ADMIN_DELETE_CHAMPIONSHIP_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_FAILURE";

var ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST = exports.ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST";
var ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS = exports.ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS";
var ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE = exports.ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE";
var ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST";
var ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS";
var ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE";
var ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST = exports.ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST";
var ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS = exports.ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS";
var ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE = exports.ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE";

var ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST = exports.ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST";
var ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS = exports.ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS";
var ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE = exports.ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE";
var ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST";
var ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS";
var ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE = exports.ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE";

var ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST = exports.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST";
var ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS = exports.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS";
var ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE = exports.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS";
var ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE = exports.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE";

var ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = exports.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
var ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = exports.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
var ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = exports.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE";
var ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = exports.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
var ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = exports.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
var ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = exports.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE";
var ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST = exports.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST";
var ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = exports.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS";
var ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE = exports.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE = "ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE";

var ADMIN_CALC_CHAMPIONSHIPS_REQUEST = exports.ADMIN_CALC_CHAMPIONSHIPS_REQUEST = "ADMIN_CALC_CHAMPIONSHIPS_REQUEST";
var ADMIN_CALC_CHAMPIONSHIPS_SUCCESS = exports.ADMIN_CALC_CHAMPIONSHIPS_SUCCESS = "ADMIN_CALC_CHAMPIONSHIPS_SUCCESS";
var ADMIN_CALC_CHAMPIONSHIPS_FAILURE = exports.ADMIN_CALC_CHAMPIONSHIPS_FAILURE = "ADMIN_CALC_CHAMPIONSHIPS_FAILURE";

var ADMIN_CALC_SEATS_REQUEST = exports.ADMIN_CALC_SEATS_REQUEST = "ADMIN_CALC_SEATS_REQUEST";
var ADMIN_CALC_SEATS_SUCCESS = exports.ADMIN_CALC_SEATS_SUCCESS = "ADMIN_CALC_SEATS_SUCCESS";
var ADMIN_CALC_SEATS_FAILURE = exports.ADMIN_CALC_SEATS_FAILURE = "ADMIN_CALC_SEATS_FAILURE";

var ADD_GLOBAL_ERROR = exports.ADD_GLOBAL_ERROR = "ADD_GLOBAL_ERROR";
var REMOVE_GLOBAL_ERROR = exports.REMOVE_GLOBAL_ERROR = "REMOVE_GLOBAL_ERROR";
var REMOVE_ALL_GLOBAL_ERRORS = exports.REMOVE_ALL_GLOBAL_ERRORS = "REMOVE_ALL_GLOBAL_ERRORS";

var SYSTEM_LOCATION_CHANGED = exports.SYSTEM_LOCATION_CHANGED = "SYSTEM_LOCATION_CHANGED";
var SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE = exports.SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE = "SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE";

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(92);
var defined = __webpack_require__(48);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(93);
var createDesc = __webpack_require__(64);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(47);
var has = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(164);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(36);
var toObject = __webpack_require__(25);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(27);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(16);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatNullable = exports.formatNullable = function formatNullable(value) {
    var nullValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blank';

    if (value === null) return nullValue;
    return value;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(40);
var fails = __webpack_require__(16);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(41);
var IObject = __webpack_require__(92);
var toObject = __webpack_require__(25);
var toLength = __webpack_require__(21);
var asc = __webpack_require__(135);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(22)) {
  var LIBRARY = __webpack_require__(54);
  var global = __webpack_require__(13);
  var fails = __webpack_require__(16);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(109);
  var $buffer = __webpack_require__(143);
  var ctx = __webpack_require__(41);
  var anInstance = __webpack_require__(71);
  var propertyDesc = __webpack_require__(64);
  var hide = __webpack_require__(32);
  var redefineAll = __webpack_require__(73);
  var toInteger = __webpack_require__(43);
  var toLength = __webpack_require__(21);
  var toIndex = __webpack_require__(192);
  var toAbsoluteIndex = __webpack_require__(67);
  var toPrimitive = __webpack_require__(47);
  var has = __webpack_require__(36);
  var classof = __webpack_require__(81);
  var isObject = __webpack_require__(17);
  var toObject = __webpack_require__(25);
  var isArrayIter = __webpack_require__(132);
  var create = __webpack_require__(68);
  var getPrototypeOf = __webpack_require__(39);
  var gOPN = __webpack_require__(69).f;
  var getIterFn = __webpack_require__(134);
  var uid = __webpack_require__(65);
  var wks = __webpack_require__(20);
  var createArrayMethod = __webpack_require__(50);
  var createArrayIncludes = __webpack_require__(99);
  var speciesConstructor = __webpack_require__(95);
  var ArrayIterators = __webpack_require__(137);
  var Iterators = __webpack_require__(83);
  var $iterDetect = __webpack_require__(104);
  var setSpecies = __webpack_require__(70);
  var arrayFill = __webpack_require__(136);
  var arrayCopyWithin = __webpack_require__(181);
  var $DP = __webpack_require__(24);
  var $GOPD = __webpack_require__(38);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(187);
var $export = __webpack_require__(2);
var shared = __webpack_require__(91)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(190))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(65)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(36);
var setDesc = __webpack_require__(24).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(20)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(32)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var defaultClient, mixin, responsePromise, client;

defaultClient = __webpack_require__(233);
mixin = __webpack_require__(116);
responsePromise = __webpack_require__(159);
client = __webpack_require__(158);

/**
 * Interceptors have the ability to intercept the request and/org response
 * objects.  They may augment, prune, transform or replace the
 * request/response as needed.  Clients may be composed by wrapping
 * together multiple interceptors.
 *
 * Configured interceptors are functional in nature.  Wrapping a client in
 * an interceptor will not affect the client, merely the data that flows in
 * and out of that client.  A common configuration can be created once and
 * shared; specialization can be created by further wrapping that client
 * with custom interceptors.
 *
 * @param {Client} [target] client to wrap
 * @param {Object} [config] configuration for the interceptor, properties will be specific to the interceptor implementation
 * @returns {Client} A client wrapped with the interceptor
 *
 * @class Interceptor
 */

function defaultInitHandler(config) {
	return config;
}

function defaultRequestHandler(request /*, config, meta */) {
	return request;
}

function defaultResponseHandler(response /*, config, meta */) {
	return response;
}

/**
 * Alternate return type for the request handler that allows for more complex interactions.
 *
 * @param properties.request the traditional request return object
 * @param {Promise} [properties.abort] promise that resolves if/when the request is aborted
 * @param {Client} [properties.client] override the defined client with an alternate client
 * @param [properties.response] response for the request, short circuit the request
 */
function ComplexRequest(properties) {
	if (!(this instanceof ComplexRequest)) {
		// in case users forget the 'new' don't mix into the interceptor
		return new ComplexRequest(properties);
	}
	mixin(this, properties);
}

/**
 * Create a new interceptor for the provided handlers.
 *
 * @param {Function} [handlers.init] one time intialization, must return the config object
 * @param {Function} [handlers.request] request handler
 * @param {Function} [handlers.response] response handler regardless of error state
 * @param {Function} [handlers.success] response handler when the request is not in error
 * @param {Function} [handlers.error] response handler when the request is in error, may be used to 'unreject' an error state
 * @param {Function} [handlers.client] the client to use if otherwise not specified, defaults to platform default client
 *
 * @returns {Interceptor}
 */
function interceptor(handlers) {

	var initHandler, requestHandler, successResponseHandler, errorResponseHandler;

	handlers = handlers || {};

	initHandler            = handlers.init    || defaultInitHandler;
	requestHandler         = handlers.request || defaultRequestHandler;
	successResponseHandler = handlers.success || handlers.response || defaultResponseHandler;
	errorResponseHandler   = handlers.error   || function () {
		// Propagate the rejection, with the result of the handler
		return Promise.resolve((handlers.response || defaultResponseHandler).apply(this, arguments))
			.then(Promise.reject.bind(Promise));
	};

	return function (target, config) {

		if (typeof target === 'object') {
			config = target;
		}
		if (typeof target !== 'function') {
			target = handlers.client || defaultClient;
		}

		config = initHandler(config || {});

		function interceptedClient(request) {
			var context, meta;
			context = {};
			meta = { 'arguments': Array.prototype.slice.call(arguments), client: interceptedClient };
			request = typeof request === 'string' ? { path: request } : request || {};
			request.originator = request.originator || interceptedClient;
			return responsePromise(
				requestHandler.call(context, request, config, meta),
				function (request) {
					var response, abort, next;
					next = target;
					if (request instanceof ComplexRequest) {
						// unpack request
						abort = request.abort;
						next = request.client || next;
						response = request.response;
						// normalize request, must be last
						request = request.request;
					}
					response = response || Promise.resolve(request).then(function (request) {
						return Promise.resolve(next(request)).then(
							function (response) {
								return successResponseHandler.call(context, response, config, meta);
							},
							function (response) {
								return errorResponseHandler.call(context, response, config, meta);
							}
						);
					});
					return abort ? Promise.race([response, abort]) : response;
				},
				function (error) {
					return Promise.reject({ request: request, error: error });
				}
			);
		}

		return client(interceptedClient, target);
	};
}

interceptor.ComplexRequest = ComplexRequest;

module.exports = interceptor;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.loginUserSuccessFromServer = loginUserSuccessFromServer;
exports.setForceAuthRecheck = setForceAuthRecheck;
exports.loginCheckSession = loginCheckSession;
exports.logoutAndRedirect = logoutAndRedirect;
exports.loginUser = loginUser;
exports.getProfile = getProfile;
exports.updateProfile = updateProfile;
exports.changePassword = changePassword;
exports.resetPassword = resetPassword;
exports.requestPasswordReset = requestPasswordReset;

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _actionconstants = __webpack_require__(35);

var _routeconstants = __webpack_require__(11);

var _reactRouterRedux = __webpack_require__(14);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loginUserSuccess(user) {
    return {
        type: _actionconstants.LOGIN_USER_SUCCESS,
        payload: user
    };
}

function loginUserSuccessFromServer(user) {
    // exported, since this action is also called from backend.
    user = _extends({}, user, {
        photo: null, // <- photo doesn't work from server yet (is a Buffer object - is in session but not serializable)
        photoMimeType: null
    });
    return loginUserSuccess(user);
}

function loginUserFailure(error) {
    return {
        type: _actionconstants.LOGIN_USER_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText
        }
    };
}

function loginUserRequest() {
    return {
        type: _actionconstants.LOGIN_USER_REQUEST
    };
}

function logout() {
    return {
        type: _actionconstants.LOGOUT_USER
    };
}

function setForceAuthRecheck(mustRecheck) {
    // This is sat by the timer in app.js, and read by requireAuth.js, to make requireAuth.js periodically recheck whether the user is still logged in (or has been logged out by the backend)
    return {
        type: _actionconstants.FORCE_AUTH_RECHECK,
        payload: {
            mustRecheck: mustRecheck
        }
    };
}

function loginCheckSession() {
    var onNotAuthenticated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, state) {
        dispatch(loginUserRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/me'
        }).then(function (response) {
            if (true) console.log("User", response.entity.id, response.entity.email, response.entity.roleId, response.entity.firstName, response.entity.lastName);
            dispatch(loginUserSuccess(response.entity));
        }).catch(function (response) {
            // TODO: TEMP FIX: According to the rest.js-docs this should be a response object, but it sometimes is missing response.status... and reading response.status.code makes the _server_ crash. (To make it happen: after having logged in, reload the page you are on)
            // TODO: (Seems to happen only serverside. Why does the server call this code???)
            if (typeof response.status === "undefined") response.status = { code: -1 };

            if (response.status.code === 404 || response.status.code === 401) {
                dispatch(loginUserFailure({
                    response: {
                        status: 404,
                        statusText: 'Invalid Session'
                    }
                }));

                if (onNotAuthenticated !== null) onNotAuthenticated();
            } else {
                console.log("********ERROR!", response);

                dispatch(loginUserFailure({
                    response: {
                        status: response.status.code,
                        statusText: 'Server error'
                    }
                }));
                dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Server error (" + response.status.code + ")", response));

                // To avoid infinite loops from requireAuth.js on server error (for example if server is down and we are at a page protected by requireAuth.js) this redirects to signin.
                // (Try it to see what i mean: uncomment the redirect, shut down the backend and wait for the timer in app.js to call loginCheckSession)
                // (Seen from the frontend's point of view, the user has been logged out - loginUserFailure takes care of that - so it makes sense going to the login page)
                dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_SIGNIN));
            }
        });
    };
}

function logoutAndRedirect() {
    return function (dispatch, state) {
        (0, _client2.default)({
            // method : 'DELETE',
            // path : '/web/session'
            method: 'POST',
            path: '/logout'
        }).then(function (response) {
            dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_SIGNIN)); // <- must be done BEFORE the logout() call
            dispatch(logout()); // <- this MUST be after redirecting to signin-page (push(ROUTE_SIGNIN)), since if this is called AND the page we're at is wrapped by requireAuth (See approute.js), requireAuth's props will change, and it will
            //    send a /web/session request, which will WRONGLY append the "?next=xxx" query-parameter to the URL. That will make the next user logging in go to that page (which he might not have access to and will result in errors!).
            //    (Yes, dispatch IS synchronous)
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while logging out", response));
        });
    };
}

function loginUser(username, password) {
    var redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/";
    var onInvalidCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch) {
        dispatch(loginUserRequest());

        (0, _client2.default)({
            method: "POST",
            path: "/login",
            entity: {
                username: username,
                password: password
            },
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            if (true) console.log("User", response.entity.id, response.entity.email, response.entity.roleId, response.entity.firstName, response.entity.lastName);
            dispatch(loginUserSuccess(response.entity));
            dispatch((0, _reactRouterRedux.push)(redirect));
            if (true) console.log('********LOGGED IN********');
        }).catch(function (response) {
            if (true) console.log('********LOGIN FAILED (' + response.status.code + ')********');

            if (response.status.code === 401) {

                dispatch(loginUserFailure({
                    response: {
                        status: response.status.code,
                        statusText: 'Invalid Credentials'
                    }
                }));

                if (onInvalidCredentials !== null) onInvalidCredentials();else dispatch(GlobalErrorActions.addGlobalError("Invalid credentials - please try again", ""));
            } else {

                dispatch(loginUserFailure({
                    response: {
                        status: response.status.code,
                        statusText: 'Server error'
                    }
                }));
                console.log("server error: " + response.status.code);

                dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while logging in - please try again later", response));
            }
        });
    };
}

function getProfile() {
    var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    // is in this file, rather than actions/user.js, since it gets the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(getProfileRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/user/current'
        }).then(function (response) {
            dispatch(getProfileSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while retrieving your profile", response));
            dispatch(getProfileFailure(response));
            if (onError !== null) onError();
        });
    };
}

function getProfileRequest() {
    return {
        type: _actionconstants.USER_PROFILE_GET_REQUEST
    };
}

function getProfileSuccess(response) {
    return {
        payload: response.entity,
        type: _actionconstants.USER_PROFILE_GET_SUCCESS
    };
}

function getProfileFailure(response) {
    return {
        type: _actionconstants.USER_PROFILE_GET_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

function updateProfile(userProfile) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    // is in this file, rather than actions/user.js, since it updates the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(updateProfileRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/user/current',
            entity: userProfile,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateProfileSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while updating your profile", response));
            dispatch(updateProfileFailure(response));
        });
    };
}

function updateProfileRequest() {
    return {
        type: _actionconstants.USER_PROFILE_UPDATE_REQUEST
    };
}

function updateProfileSuccess(response) {
    return {
        payload: response.entity,
        type: _actionconstants.USER_PROFILE_UPDATE_SUCCESS
    };
}

function updateProfileFailure(response) {
    return {
        type: _actionconstants.USER_PROFILE_UPDATE_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

function changePassword(changePasswordInfo) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    // is in this file, rather than actions/user.js, since it updates the currently logged in user, and thus uses the auth part of the store.
    return function (dispatch) {
        dispatch(changePasswordRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/user/current/change-password',
            entity: changePasswordInfo,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(changePasswordSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while changing your password", response));
            dispatch(changePasswordFailure(response));
        });
    };
}

function resetPassword(newPassword) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(changePasswordRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/user/reset-password',
            entity: newPassword,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(changePasswordSuccess(response));
            if (onSuccess != null) onSuccess();
            dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_SIGNIN));
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while resetting your password", response));
            dispatch(changePasswordFailure(response));
        });
    };
}

function changePasswordRequest() {
    return {
        type: _actionconstants.USER_CHANGE_PASSWORD_REQUEST
    };
}

function changePasswordSuccess(response) {
    return {
        //payload: response.entity,
        type: _actionconstants.USER_CHANGE_PASSWORD_SUCCESS
    };
}

function changePasswordFailure(response) {
    return {
        type: _actionconstants.USER_CHANGE_PASSWORD_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

function requestPasswordReset(email) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch) {
        dispatch(requestPasswordResetRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/user/request-reset-password',
            entity: {
                email: email
            },
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(requestPasswordResetSuccess(response));
            if (onSuccess != null) onSuccess(response.entity.email);
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred while resetting your password", response));
            dispatch(requestPasswordResetFailure(response));
        });
    };
}

function requestPasswordResetRequest() {
    return {
        type: _actionconstants.USER_RESET_PASSWORD_REQUEST
    };
}

function requestPasswordResetSuccess(response) {
    return {
        //payload: response.entity,
        type: _actionconstants.USER_RESET_PASSWORD_SUCCESS
    };
}

function requestPasswordResetFailure(response) {
    return {
        type: _actionconstants.USER_RESET_PASSWORD_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasCommonProps = undefined;

var _momentTimezone = __webpack_require__(787);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasCommonProps = exports.hasCommonProps = function hasCommonProps(object1, object2) {
    for (var field in object1) {
        if (object1.hasOwnProperty(field) && object2.hasOwnProperty(field)) return true;
    }
    return false;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is the initial client-side state of the entire store. (May be merged with server-side state __REDUX_STATE__ in index.js)
var initialStoreState = {
    //...reduxState,
    auth: { // info about currently logged in user
        isAuthenticated: false,
        isAuthenticating: false,
        forceAuthRecheck: false, // a signal to requireauth.js that it should recheck auth, and if user is logged out from the backend, a dialog should be displayed informing the user he has been logged out.
        statusText: null,
        // From Drupal passport strategy.
        id: null,
        displayName: null,
        emails: [],
        isMainAdmin: false,
        isSectionAdmin: false,
        isClubAdmin: false,
        clubNumber: null,
        adminSections: null,
        adminClubs: null,
        currentRole: null,
        currentEntity: null,
        // Only for local passport strategy. Not in use, as Drupal is used for single signon.
        userId: null,
        email: null,
        roleId: null,
        firstName: null,
        lastName: null,
        photo: null,
        photoMimeType: null,
        database: 'standard'
    },
    // Actually not used for this project.
    user: {
        isCreating: false,
        isCreated: false,
        statusText: null,
        username: null, // this is the user which was created during the signup process... not the logged in user. See auth for that.
        isFetching: false,
        isFetched: false,
        users: new _immutable2.default.Map(),
        user: {}, // user to view (can be any user - not necessarily the currently logged in user)
        emailExists: { name: null, exists: false },
        isSaving: false
    },
    admin: {
        isBasicsRead: false,
        isClubsRead: false,
        isMembersRead: false,
        isChampionshipsRead: false,
        clubs: new _immutable2.default.Map(),
        championships: new _immutable2.default.Map(),
        pigeonHoles: new _immutable2.default.Map(),
        members: new _immutable2.default.Map(),
        sections: new _immutable2.default.Map(),
        ranges: new _immutable2.default.Map(),
        stations: new _immutable2.default.Map(),
        zipCodes: new _immutable2.default.Map(),
        nightTimes: new _immutable2.default.Map(),
        derby: new _immutable2.default.Map(),
        stationSelections: new _immutable2.default.Map(),
        errorLists: {
            files: new _immutable2.default.Map(),
            rings: new _immutable2.default.Map(),
            pigeons: new _immutable2.default.Map(),
            dm: new _immutable2.default.Map(),
            signups: new _immutable2.default.Map(),
            watches: new _immutable2.default.Map(),
            membergames: new _immutable2.default.Map(),
            financials: new _immutable2.default.Map(),
            submissions: new _immutable2.default.Map(),
            memberprogramusers: new _immutable2.default.Map(),
            status: new _immutable2.default.Map()
        },
        userRoles: [],
        archives: []
    },
    race: {
        isRacesRead: false,
        races: new _immutable2.default.Map(),
        racePigeons: new _immutable2.default.Map(),
        activePigeons: new _immutable2.default.Map(),
        racePrices: new _immutable2.default.Map(),
        deposits: new _immutable2.default.Map(),
        markings: new _immutable2.default.Map(),
        deviceImports: new _immutable2.default.Map(),
        deviceImporterVersion: null,
        deviceComPorts: ''
    },
    globalError: { // The errors added in here, are global and opens and shows the error to the user in the main error-dialog (Could be extended so not all of them did that).
        // Purpose: To show an error to the user on ajax calls which unexpectedly fails, instead of not giving the user any feedback (instead of silently ignoring it).
        errors: new _immutable2.default.List() // <- When this list is non-empty, we have errors we need to display to the user.
    },
    system: {
        locationPath: "/",
        imageCacheBreaker: 0 // This value is added to image-URLs, so that when a user/organisation/etc updates his own image, the change is visible immediately without a page-load (works around browser *in-memory* caches (not HTTP-caches - that works fine)).
        // Example: When a user has updated his profile, this variable is set to a new random value (which are added to the <img>-src URLs, so that all his images will update immediately).
        //          This is better than a usual random value, in that: 1) it only breaks the cache when needed, 2) since this variable is in the store, all image-components can rerender exactly when it's changed.
        //          And 3) since it always start at 0, caching works normally until a user/organisation/etc edits his profile.
        //          (Of course, if another user updates his profile on his computer, you would still have to reload the page to see the changes. Acceptable i think. (One COULD fetch all user-objects for all images to show, but that seems really slow - could also use a setTimeout()))
    }
};

exports.default = initialStoreState;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(166);
var enumBugKeys = __webpack_require__(120);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(167);
var enumBugKeys = __webpack_require__(120);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(117)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(121).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(166);
var hiddenKeys = __webpack_require__(120).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var dP = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(22);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(41);
var call = __webpack_require__(179);
var isArrayIter = __webpack_require__(132);
var anObject = __webpack_require__(10);
var toLength = __webpack_require__(21);
var getIterFn = __webpack_require__(134);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(33);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(633);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(637);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rest = __webpack_require__(686);
var defaultRequest = __webpack_require__(688);
var timeout = __webpack_require__(689);
var mime = __webpack_require__(690);
var params = __webpack_require__(700);
//import uriTemplateInterceptor from './api/uriTemplateInterceptor';
var errorCode = __webpack_require__(701);
var baseRegistry = __webpack_require__(236);

var interceptor = __webpack_require__(60);
var when = __webpack_require__(702);

var registry = baseRegistry.child();

registry.register('text/uri-list', __webpack_require__(717));
registry.register('application/hal+json', __webpack_require__(237));

var acceptOnly2xx = interceptor({
    response: function response(_response, config) {
        if (!_response || !_response.status || _response.status.code < 200 || _response.status.code > 299) return when.reject(_response);
        return _response;
    }
});

exports.default = rest.wrap(mime, { registry: registry }).wrap(params)
//.wrap(uriTemplateInterceptor)
//.wrap(errorCode, { code: 500 }) // <- Reject only status codes 500+
.wrap(acceptOnly2xx).wrap(timeout, { timeout: 2 * 60 * 1000 }).wrap(defaultRequest, { headers: { 'Accept': 'application/hal+json' } });

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceList = function (_React$Component) {
    _inherits(RaceList, _React$Component);

    function RaceList(props) {
        _classCallCheck(this, RaceList);

        var _this = _possibleConstructorReturn(this, (RaceList.__proto__ || Object.getPrototypeOf(RaceList)).call(this, props));

        _this.fields = [];

        _this.state = Object.assign({
            initialized: false
        });
        return _this;
    }

    _createClass(RaceList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(RaceActions.getRaces());
            this.props.dispatch(AdminActions.getListItems('station'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var week = (0, _lib.isDefined)(this.props.location) && (0, _lib.isDefined)(this.props.location.query.week) && /^[0-9]{1,2}$/.test(this.props.location.query.week) ? Number(this.props.location.query.week) : (0, _moment2.default)(new Date()).isoWeek();
            var raceWeek = null;
            var raceId = null;
            var result = this.props.race.isRacesRead ? _react2.default.createElement(
                'table',
                { className: 'data-table row-clickable' },
                _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement('th', { scope: 'row', onClick: function onClick(e) {
                                e.stopPropagation();
                                _this2.props.updateSelection(_this2.props.race.races.map(function (race) {
                                    return race.Nr;
                                }).toArray(), _this2.props.selectedRaces.length < _this2.props.race.races.count());
                            } }),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Uge'
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Farvekode'
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'th',
                            null,
                            'Grupper'
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'th',
                            null,
                            'Sektioner'
                        ) : null,
                        _react2.default.createElement(
                            'th',
                            null,
                            'Station'
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Navn'
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Slipdato'
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Sliptid'
                        )
                    )
                ),
                _react2.default.createElement(
                    'tbody',
                    null,
                    this.props.race.races.filter(function (race) {
                        return typeof _this2.props.filterRaces === "undefined" ? true : _this2.props.filterRaces(race);
                    }).sort(function (r1, r2) {
                        if (r1.Uge < r2.Uge) return -1;
                        if (r1.Uge > r2.Uge) return 1;
                        if (r1.Farvekode < r2.Farvekode) return -1;
                        if (r1.Farvekode > r2.Farvekode) return 1;
                        if ((0, _lib.nullToBlank)(r1.Sektion) < (0, _lib.nullToBlank)(r2.Sektion)) return -1;
                        if ((0, _lib.nullToBlank)(r1.Sektion) > (0, _lib.nullToBlank)(r2.Sektion)) return 1;
                        if ((0, _lib.nullToBlank)(r1.Sektionsgrupper) < (0, _lib.nullToBlank)(r2.Sektionsgrupper)) return -1;
                        if ((0, _lib.nullToBlank)(r1.Sektionsgrupper) > (0, _lib.nullToBlank)(r2.Sektionsgrupper)) return 1;
                        if ((0, _lib.nullToBlank)(r1.Sektioner) < (0, _lib.nullToBlank)(r2.Sektioner)) return -1;
                        if ((0, _lib.nullToBlank)(r1.Sektioner) > (0, _lib.nullToBlank)(r2.Sektioner)) return 1;
                        return 0;
                    }).toArray().map(function (race) {
                        if (raceWeek === null || race.Uge <= week) {
                            raceWeek = race.Uge;
                            raceId = race.Nr;
                        }
                        var kfk = race.Farvekode.substr(0, 2);
                        var sections = (0, _lib.CompressList)(race.Sektioner);
                        var groups = (0, _lib.CompressList)(race.Sektionsgrupper);
                        var station = _this2.props.admin.stations.get(race.Station);
                        return _react2.default.createElement(
                            'tr',
                            { key: race.Nr, id: 'row-' + race.Nr, onClick: function onClick() {
                                    _this2.props.updateSelection([race.Nr], _this2.props.selectedRaces.indexOf(race.Nr) < 0);
                                } },
                            _react2.default.createElement(
                                'th',
                                { scope: 'row' },
                                _react2.default.createElement('input', { type: 'checkbox', checked: _this2.props.selectedRaces.indexOf(race.Nr) >= 0 })
                            ),
                            _react2.default.createElement(
                                'td',
                                { onClick: function onClick(e) {
                                        e.stopPropagation();
                                        _this2.props.updateSelection(_this2.props.race.races.filter(function (otherRace) {
                                            return otherRace.Uge === race.Uge;
                                        }).map(function (race) {
                                            return race.Nr;
                                        }).toArray(), _this2.props.selectedRaces.indexOf(race.Nr) < 0);
                                    } },
                                _react2.default.createElement(
                                    'a',
                                    { href: 'javascript:void(0)' },
                                    race.Uge
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { onClick: function onClick(e) {
                                        e.stopPropagation();
                                        _this2.props.updateSelection(_this2.props.race.races.filter(function (otherRace) {
                                            return otherRace.Uge === race.Uge && otherRace.Farvekode === race.Farvekode;
                                        }).map(function (race) {
                                            return race.Nr;
                                        }).toArray(), _this2.props.selectedRaces.indexOf(race.Nr) < 0);
                                    } },
                                _react2.default.createElement(
                                    'a',
                                    { href: 'javascript:void(0)' },
                                    race.Farvekode
                                )
                            ),
                            _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                null,
                                groups.items.join(',')
                            ) : null,
                            _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                null,
                                sections.items.join(',')
                            ) : null,
                            _react2.default.createElement(
                                'td',
                                null,
                                race.Station
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                station ? station.Navn : null
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                race.SlipDato === null ? null : (0, _moment2.default)(race.SlipDato).format(_config2.default.formats.dateFormat)
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                race.Sliptid
                            )
                        );
                    })
                )
            ) : null;

            // Scroll to relevant week.
            if (!this.state.initialized && raceId !== null) setTimeout(function () {
                var currentRow = document.getElementById("row-" + raceId);
                currentRow.scrollIntoView(false);
                this.setState({ initialized: true });
            }.bind(this));

            return result;
        }
    }]);

    return RaceList;
}(_react2.default.Component);

RaceList.propTypes = {
    selectedRaces: _propTypes2.default.array.isRequired,
    updateSelection: _propTypes2.default.func.isRequired,
    filterRaces: _propTypes2.default.func
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            stations: state.admin.stations
        },
        race: {
            isRacesRead: state.race.isRacesRead,
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceList);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(24).f;
var has = __webpack_require__(36);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(42);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(48);
var fails = __webpack_require__(16);
var spaces = __webpack_require__(123);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(28);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(59);

var _Actions = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfirmation = exports.confirmable = undefined;

var _confirmable = __webpack_require__(718);

var _confirmable2 = _interopRequireDefault(_confirmable);

var _createConfirmation = __webpack_require__(719);

var _createConfirmation2 = _interopRequireDefault(_createConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.confirmable = _confirmable2.default;
exports.createConfirmation = _createConfirmation2.default;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alertGeneral = alertGeneral;
exports.alert = alert;

var _reactConfirm = __webpack_require__(88);

var _AlertDialog = __webpack_require__(725);

var _AlertDialog2 = _interopRequireDefault(_AlertDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Taken from the react-confirm manual: https://www.npmjs.com/package/react-confirm

// create confirm function
var confirmation = (0, _reactConfirm.createConfirmation)(_AlertDialog2.default);

// This is optional. But I recommend to define your confirm function easy to call.
function alertGeneral(title, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirmation({ title: title, text: text, options: options });
}

// A version of the confirm function, which is a little easier to use in the normal use-case (We don't have to write ".then(...)").
function alert(title, text, onOk) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var onCancel = function onCancel() {};
    return alertGeneral(title, text, options).then(onOk, onCancel);
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (initialState, reducerMap) {
    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];

        //console.log("ACTION", action, state);
        var reducer = reducerMap[action.type];
        return reducer ? reducer(state, action.payload) : state;
    };
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(40);
var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(54) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(42);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(10);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(27);
var SPECIES = __webpack_require__(20)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userCreate = userCreate;
exports.updateUser = updateUser;
exports.checkEmailExists = checkEmailExists;
exports.getUser = getUser;

var _actionconstants = __webpack_require__(35);

var _routeconstants = __webpack_require__(11);

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _reactRouterRedux = __webpack_require__(14);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

var _auth = __webpack_require__(61);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function userCreate(userProfile) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var redirectTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _routeconstants.ROUTE_HOME;

    return function (dispatch) {
        dispatch(userCreateRequest());
        (0, _client2.default)({
            method: 'POST',
            path: '/api/user',
            entity: userProfile,
            params: {
                autoLogin: true
            },
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(userCreateSuccess(response.entity.username));
            if (redirectTo != null) dispatch((0, _reactRouterRedux.push)(redirectTo)); // dispatch(push(ROUTE_SIGNIN));
            dispatch((0, _auth.setForceAuthRecheck)(true)); // <- in case browser was already logged in as a different user, force rechecking with the server who is logged in.
            if (onSuccess != null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred during sign up - please try again later.", response));
            dispatch(userCreateFailure(response));
        });
    };
}

function userCreateRequest() {
    return {
        type: _actionconstants.USER_CREATE_REQUEST
    };
}

function userCreateSuccess(username) {
    return {
        type: _actionconstants.USER_CREATE_SUCCESS,
        payload: {
            username: username
        }
    };
}

function userCreateFailure(error) {
    return {
        type: _actionconstants.USER_CREATE_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText
        }
    };
}

function updateUser(id, userProfile) {
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(updateUserRequest());
        (0, _client2.default)({
            method: 'PUT',
            path: '/api/user/' + id,
            entity: userProfile,
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            dispatch(updateUserSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occured while updating the user", response));
            dispatch(updateUserFailure(response));
        });
    };
}

function updateUserRequest() {
    return {
        type: _actionconstants.USER_UPDATE_REQUEST
    };
}

function updateUserSuccess(response) {
    return {
        payload: response.entity,
        type: _actionconstants.USER_UPDATE_SUCCESS
    };
}

function updateUserFailure(response) {
    return {
        type: _actionconstants.USER_UPDATE_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

function checkEmailExists(email) {
    var excludedUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch) {
        dispatch(checkEmailExistsRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/user/check-exists',
            params: {
                email: email,
                exclude: excludedUserId
            }
        }).then(function (response) {
            dispatch(checkEmailExistsSuccess(response, email));
            if (onSuccess !== null) onSuccess();
        }).catch(function (response) {
            //dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Error checking username with server", response));
            dispatch(checkEmailExistsFailure(response));
        });
    };
}

function checkEmailExistsRequest() {
    return {
        type: _actionconstants.CHECK_EMAIL_EXISTS_REQUEST
    };
}

function checkEmailExistsSuccess(response, email) {
    return {
        type: _actionconstants.CHECK_EMAIL_EXISTS_SUCCESS,
        payload: {
            name: email,
            exists: response.entity.exists
        }
    };
}

function checkEmailExistsFailure(response) {
    return {
        type: _actionconstants.CHECK_EMAIL_EXISTS_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

function getUser(userId) {
    var includeImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch) {
        dispatch(getUserRequest());
        (0, _client2.default)({
            method: 'GET',
            path: '/api/user/' + userId,
            params: {
                includeImages: includeImages
            }
        }).then(function (response) {
            dispatch(getUserSuccess(response.entity));
        }).catch(function (response) {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Error retrieving user", response));
            dispatch(getUserFailure(response));
        });
    };
}

function getUserRequest() {
    return {
        type: _actionconstants.USER_GET_REQUEST
    };
}

function getUserSuccess(user) {
    return {
        type: _actionconstants.USER_GET_SUCCESS,
        payload: user
    };
}

function getUserFailure(error) {
    return {
        type: _actionconstants.USER_GET_FAILURE,
        payload: {
            status: error.status.code,
            statusText: error.entity
        }
    };
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(67);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(42);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(48);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(17);
var cof = __webpack_require__(42);
var MATCH = __webpack_require__(20)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(81);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(183);
var redefine = __webpack_require__(33);
var hide = __webpack_require__(32);
var fails = __webpack_require__(16);
var defined = __webpack_require__(48);
var wks = __webpack_require__(20);
var regexpExec = __webpack_require__(138);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(33);
var redefineAll = __webpack_require__(73);
var meta = __webpack_require__(55);
var forOf = __webpack_require__(72);
var anInstance = __webpack_require__(71);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(16);
var $iterDetect = __webpack_require__(104);
var setToStringTag = __webpack_require__(80);
var inheritIfRequired = __webpack_require__(124);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(32);
var uid = __webpack_require__(65);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(54) || !__webpack_require__(16)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(13)[K];
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(27);
var ctx = __webpack_require__(41);
var forOf = __webpack_require__(72);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var empty = {};

/**
 * Mix the properties from the source object into the destination object.
 * When the same property occurs in more then one object, the right most
 * value wins.
 *
 * @param {Object} dest the object to copy properties to
 * @param {Object} sources the objects to copy properties from.  May be 1 to N arguments, but not an Array.
 * @return {Object} the destination object
 */
function mixin(dest /*, sources... */) {
	var i, l, source, name;

	if (!dest) { dest = {}; }
	for (i = 1, l = arguments.length; i < l; i += 1) {
		source = arguments[i];
		for (name in source) {
			if (!(name in dest) || (dest[name] !== source[name] && (!(name in empty) || empty[name] !== source[name]))) {
				dest[name] = source[name];
			}
		}
	}

	return dest; // Object
}

module.exports = mixin;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(40);
var LIBRARY = __webpack_require__(54);
var wksExt = __webpack_require__(165);
var defineProperty = __webpack_require__(24).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(91)('keys');
var uid = __webpack_require__(65);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(13).document;
module.exports = document && document.documentElement;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(10);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(41)(Function.call, __webpack_require__(38).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var setPrototypeOf = __webpack_require__(122).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(48);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(54);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(33);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(83);
var $iterCreate = __webpack_require__(129);
var setToStringTag = __webpack_require__(80);
var getPrototypeOf = __webpack_require__(39);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(68);
var descriptor = __webpack_require__(64);
var setToStringTag = __webpack_require__(80);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(32)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(103);
var defined = __webpack_require__(48);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(20)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(83);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(24);
var createDesc = __webpack_require__(64);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(81);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(83);
module.exports = __webpack_require__(40).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(482);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(21);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(56);
var step = __webpack_require__(182);
var Iterators = __webpack_require__(83);
var toIObject = __webpack_require__(37);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(128)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(94);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(102)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(41);
var invoke = __webpack_require__(172);
var html = __webpack_require__(121);
var cel = __webpack_require__(117);
var global = __webpack_require__(13);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(42)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var macrotask = __webpack_require__(140).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(42)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(22);
var LIBRARY = __webpack_require__(54);
var $typed = __webpack_require__(109);
var hide = __webpack_require__(32);
var redefineAll = __webpack_require__(73);
var fails = __webpack_require__(16);
var anInstance = __webpack_require__(71);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(21);
var toIndex = __webpack_require__(192);
var gOPN = __webpack_require__(69).f;
var dP = __webpack_require__(24).f;
var arrayFill = __webpack_require__(136);
var setToStringTag = __webpack_require__(80);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !Object(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(614);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef !== 'undefined';

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(625);

var _PathUtils = __webpack_require__(59);

var _runTransitionHook = __webpack_require__(149);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(114);

var _LocationUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(86);

var _DOMUtils = __webpack_require__(115);

var _DOMStateStorage = __webpack_require__(210);

var _PathUtils = __webpack_require__(59);

var _ExecutionEnvironment = __webpack_require__(151);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(670);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(157);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["d"] = (Transition);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/**
 * Add common helper methods to a client impl
 *
 * @param {function} impl the client implementation
 * @param {Client} [target] target of this client, used when wrapping other clients
 * @returns {Client} the client impl with additional methods
 */
module.exports = function client(impl, target) {

	if (target) {

		/**
		 * @returns {Client} the target client
		 */
		impl.skip = function skip() {
			return target;
		};

	}

	/**
	 * Allow a client to easily be wrapped by an interceptor
	 *
	 * @param {Interceptor} interceptor the interceptor to wrap this client with
	 * @param [config] configuration for the interceptor
	 * @returns {Client} the newly wrapped client
	 */
	impl.wrap = function wrap(interceptor, config) {
		return interceptor(impl, config);
	};

	/**
	 * @deprecated
	 */
	impl.chain = function chain() {
		if (typeof console !== 'undefined') {
			console.log('rest.js: client.chain() is deprecated, use client.wrap() instead');
		}

		return impl.wrap.apply(this, arguments);
	};

	return impl;

};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/*jshint latedef: nofunc */

var normalizeHeaderName = __webpack_require__(234);

function property(promise, name) {
	return promise.then(
		function (value) {
			return value && value[name];
		},
		function (value) {
			return Promise.reject(value && value[name]);
		}
	);
}

/**
 * Obtain the response entity
 *
 * @returns {Promise} for the response entity
 */
function entity() {
	/*jshint validthis:true */
	return property(this, 'entity');
}

/**
 * Obtain the response status
 *
 * @returns {Promise} for the response status
 */
function status() {
	/*jshint validthis:true */
	return property(property(this, 'status'), 'code');
}

/**
 * Obtain the response headers map
 *
 * @returns {Promise} for the response headers map
 */
function headers() {
	/*jshint validthis:true */
	return property(this, 'headers');
}

/**
 * Obtain a specific response header
 *
 * @param {String} headerName the header to retrieve
 * @returns {Promise} for the response header's value
 */
function header(headerName) {
	/*jshint validthis:true */
	headerName = normalizeHeaderName(headerName);
	return property(this.headers(), headerName);
}

/**
 * Follow a related resource
 *
 * The relationship to follow may be define as a plain string, an object
 * with the rel and params, or an array containing one or more entries
 * with the previous forms.
 *
 * Examples:
 *   response.follow('next')
 *
 *   response.follow({ rel: 'next', params: { pageSize: 100 } })
 *
 *   response.follow([
 *       { rel: 'items', params: { projection: 'noImages' } },
 *       'search',
 *       { rel: 'findByGalleryIsNull', params: { projection: 'noImages' } },
 *       'items'
 *   ])
 *
 * @param {String|Object|Array} rels one, or more, relationships to follow
 * @returns ResponsePromise<Response> related resource
 */
function follow(rels) {
	/*jshint validthis:true */
	rels = [].concat(rels);

	return make(rels.reduce(function (response, rel) {
		return response.then(function (response) {
			if (typeof rel === 'string') {
				rel = { rel: rel };
			}
			if (typeof response.entity.clientFor !== 'function') {
				throw new Error('Hypermedia response expected');
			}
			var client = response.entity.clientFor(rel.rel);
			return client({ params: rel.params });
		});
	}, this));
}

/**
 * Wrap a Promise as an ResponsePromise
 *
 * @param {Promise<Response>} promise the promise for an HTTP Response
 * @returns {ResponsePromise<Response>} wrapped promise for Response with additional helper methods
 */
function make(promise) {
	promise.status = status;
	promise.headers = headers;
	promise.header = header;
	promise.entity = entity;
	promise.follow = follow;
	return promise;
}

function responsePromise(obj, callback, errback) {
	return make(Promise.resolve(obj).then(callback, errback));
}

responsePromise.make = make;
responsePromise.reject = function (val) {
	return make(Promise.reject(val));
};
responsePromise.promise = function (func) {
	return make(new Promise(func));
};

module.exports = responsePromise;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_RESULT__;var require;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

/*global process,document,setTimeout,clearTimeout,MutationObserver,WebKitMutationObserver*/
(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require) {
	/*jshint maxcomplexity:6*/

	// Sniff "best" async scheduling option
	// Prefer process.nextTick or MutationObserver, then check for
	// setTimeout, and finally vertx, since its the only env that doesn't
	// have setTimeout

	var MutationObs;
	var capturedSetTimeout = typeof setTimeout !== 'undefined' && setTimeout;

	// Default env
	var setTimer = function(f, ms) { return setTimeout(f, ms); };
	var clearTimer = function(t) { return clearTimeout(t); };
	var asap = function (f) { return capturedSetTimeout(f, 0); };

	// Detect specific env
	if (isNode()) { // Node
		asap = function (f) { return process.nextTick(f); };

	} else if (MutationObs = hasMutationObserver()) { // Modern browser
		asap = initMutationObserver(MutationObs);

	} else if (!capturedSetTimeout) { // vert.x
		var vertxRequire = require;
		var vertx = __webpack_require__(704);
		setTimer = function (f, ms) { return vertx.setTimer(ms, f); };
		clearTimer = vertx.cancelTimer;
		asap = vertx.runOnLoop || vertx.runOnContext;
	}

	return {
		setTimer: setTimer,
		clearTimer: clearTimer,
		asap: asap
	};

	function isNode () {
		return typeof process !== 'undefined' &&
			Object.prototype.toString.call(process) === '[object process]';
	}

	function hasMutationObserver () {
	    return (typeof MutationObserver !== 'undefined' && MutationObserver) ||
			(typeof WebKitMutationObserver !== 'undefined' && WebKitMutationObserver);
	}

	function initMutationObserver(MutationObserver) {
		var scheduled;
		var node = document.createTextNode('');
		var o = new MutationObserver(run);
		o.observe(node, { characterData: true });

		function run() {
			var f = scheduled;
			scheduled = void 0;
			f();
		}

		var i = 0;
		return function (f) {
			scheduled = f;
			node.data = (i ^= 1);
		};
	}
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

Async.prototype.invokeLater = AsyncInvokeLater;
Async.prototype.invoke = AsyncInvoke;
Async.prototype.settlePromises = AsyncSettlePromises;


function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context,
    enableAsyncHooks, disableAsyncHooks) {
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

var deferUnhandledRejectionCheck;
(function() {
    var promises = [];

    function unhandledRejectionCheck() {
        for (var i = 0; i < promises.length; ++i) {
            promises[i]._notifyUnhandledRejection();
        }
        unhandledRejectionClear();
    }

    function unhandledRejectionClear() {
        promises.length = 0;
    }

    deferUnhandledRejectionCheck = function(promise) {
        promises.push(promise);
        setTimeout(unhandledRejectionCheck, 1);
    };

    es5.defineProperty(Promise, "_unhandledRejectionCheck", {
        value: unhandledRejectionCheck
    });
    es5.defineProperty(Promise, "_unhandledRejectionClear", {
        value: unhandledRejectionClear
    });
})();

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    deferUnhandledRejectionCheck(this);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var context = Promise._getContext();
    possiblyUnhandledRejection = util.contextBind(context, fn);
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var context = Promise._getContext();
    unhandledRejectionHandled = util.contextBind(context, fn);
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};


var legacyHandlers = {
    unhandledrejection: {
        before: function() {
            var ret = util.global.onunhandledrejection;
            util.global.onunhandledrejection = null;
            return ret;
        },
        after: function(fn) {
            util.global.onunhandledrejection = fn;
        }
    },
    rejectionhandled: {
        before: function() {
            var ret = util.global.onrejectionhandled;
            util.global.onrejectionhandled = null;
            return ret;
        },
        after: function(fn) {
            util.global.onrejectionhandled = fn;
        }
    }
};

var fireDomEvent = (function() {
    var dispatch = function(legacy, e) {
        if (legacy) {
            var fn;
            try {
                fn = legacy.before();
                return !util.global.dispatchEvent(e);
            } finally {
                legacy.after(fn);
            }
        } else {
            return !util.global.dispatchEvent(e);
        }
    };
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                var domEvent = new CustomEvent(name, eventData);
                es5.defineProperty(
                    domEvent, "promise", {value: event.promise});
                es5.defineProperty(
                    domEvent, "reason", {value: event.reason});

                return dispatch(legacyHandlers[name], domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = new Event(name, {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return dispatch(legacyHandlers[name], domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name, false, true,
                    event);
                return dispatch(legacyHandlers[name], domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
        var prev = config.asyncHooks;
        var cur = !!opts.asyncHooks;
        if (prev !== cur) {
            config.asyncHooks = cur;
            if (cur) {
                enableAsyncHooks();
            } else {
                disableAsyncHooks();
            }
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = (firstLineError.stack || "").split("\n");
    var lastStackLines = (lastLineError.stack || "").split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false,
    asyncHooks: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    asyncHooks: function() {
        return config.asyncHooks;
    },
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var context = Promise._getContext();
                        holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var context = Promise._getContext();
    this._callback = util.contextBind(context, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
    if (util.isArray(promises)) {
        for (var i = 0; i < promises.length; ++i) {
            var maybePromise = promises[i];
            if (maybePromise instanceof Promise) {
                maybePromise.suppressUnhandledRejections();
            }
        }
    }
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");
util.setReflectHandler(reflectHandler);

var getDomain = function() {
    var domain = process.domain;
    if (domain === undefined) {
        return null;
    }
    return domain;
};
var getContextDefault = function() {
    return null;
};
var getContextDomain = function() {
    return {
        domain: getDomain(),
        async: null
    };
};
var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ?
    _dereq_("async_hooks").AsyncResource : null;
var getContextAsyncHooks = function() {
    return {
        domain: getDomain(),
        async: new AsyncResource("Bluebird::Promise")
    };
};
var getContext = util.isNode ? getContextDomain : getContextDefault;
util.notEnumerableProp(Promise, "_getContext", getContext);
var enableAsyncHooks = function() {
    getContext = getContextAsyncHooks;
    util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
};
var disableAsyncHooks = function() {
    getContext = getContextDomain;
    util.notEnumerableProp(Promise, "_getContext", getContextDomain);
};

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;

var debug = _dereq_("./debuggability")(Promise, Context,
    enableAsyncHooks, disableAsyncHooks);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];

        if (typeof fn !== "function") {
            throw new TypeError("The last argument to .catch() " +
                "must be a function, got " + util.toString(fn));
        }
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var context = getContext();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: util.contextBind(context, handler),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise,
                receiver, context);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    var bitField = this._bitField;
    this._bitField = bitField |
        (((bitField & 536870912) >> 2) ^
        134217728);
};

Promise.prototype._setNoAsyncGuarantee = function() {
    this._bitField = (this._bitField | 536870912) &
        (~134217728);
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    context
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 = util.contextBind(context, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                util.contextBind(context, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);


    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(maybePromise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
        get: function () {
            return "Object";
        }
    });
}

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
Promise.Promise = Promise;
Promise.version = "3.7.2";
_dereq_('./call_get.js')(Promise);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,"async_hooks":undefined}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
        values.suppressUnhandledRejections();
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var context = Promise._getContext();
    this._fn = util.contextBind(context, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined &&
        this._eachValues !== null &&
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    for (var j = i; j < length; ++j) {
        var maybePromise = values[j];
        if (maybePromise instanceof Promise) {
            maybePromise.suppressUnhandledRejections();
        }
    }

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };

            value = value._then(gotAccum, undefined, undefined, ctx, undefined);

            if ((i & 127) === 0) {
                value._setNoAsyncGuarantee();
            }
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova)) &&
          ("classList" in document.documentElement)) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.allSettled = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if (classString(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

var reflectHandler;
function contextBind(ctx, cb) {
    if (ctx === null ||
        typeof cb !== "function" ||
        cb === reflectHandler) {
        return cb;
    }

    if (ctx.domain !== null) {
        cb = ctx.domain.bind(cb);
    }

    var async = ctx.async;
    if (async !== null) {
        var old = cb;
        cb = function() {
            var args = (new Array(2)).concat([].slice.call(arguments));;
            args[0] = old;
            args[1] = this;
            return async.runInAsyncScope.apply(async, args);
        };
    }
    return cb;
}

var ret = {
    setReflectHandler: function(fn) {
        reflectHandler = fn;
    },
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    contextBind: contextBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version;
    if (process.versions && process.versions.node) {
        version = process.versions.node.split(".").map(Number);
    } else if (process.version) {
        version = process.version.split(".").map(Number);
    }
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();
ret.nodeSupportsAsyncResource = ret.isNode && (function() {
    var supportsAsync = false;
    try {
        var res = _dereq_("async_hooks").AsyncResource;
        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
    } catch (e) {
        supportsAsync = false;
    }
    return supportsAsync;
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13,"async_hooks":undefined}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87), __webpack_require__(53), __webpack_require__(721).setImmediate))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(746);

var _uuid2 = _interopRequireDefault(_uuid);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactFileReader = function (_React$Component) {
  _inherits(ReactFileReader, _React$Component);

  function ReactFileReader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactFileReader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactFileReader.__proto__ || Object.getPrototypeOf(ReactFileReader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      elementId: _this.props.elementId || (0, _uuid2.default)()
    }, _this.clickInput = function () {
      var element = document.getElementById(_this.state.elementId);
      element.value = '';
      element.click();
    }, _this.handleFiles = function (event) {
      if (_this.props.base64) {
        _this.convertFilesToBase64(event.target.files);
      } else {
        _this.props.handleFiles(event.target.files);
      }
    }, _this.convertFilesToBase64 = function (files) {
      var ef = files;

      if (_this.props.multipleFiles) {
        var i, len;

        (function () {
          var files = { base64: [], fileList: ef };

          var _loop = function _loop() {
            var reader = new FileReader();
            var f = ef[i];

            reader.onloadend = function (e) {
              files.base64.push(reader.result);

              if (files.base64.length === ef.length) {
                _this.props.handleFiles(files);
              }
            };

            reader.readAsDataURL(f);
          };

          for (i = 0, len = ef.length; i < len; i++) {
            _loop();
          }
        })();
      } else {
        var _files = { base64: '', fileList: ef };
        var f = ef[0];
        var _reader = new FileReader();

        _reader.onloadend = function (e) {
          _files.base64 = _reader.result;
          _this.props.handleFiles(_files);
        };

        _reader.readAsDataURL(f);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactFileReader, [{
    key: 'render',
    value: function render() {
      var hideInput = {
        width: '0px',
        opacity: '0',
        position: 'fixed'
      };

      return _react2.default.createElement(
        'div',
        { className: 'react-file-reader' },
        _react2.default.createElement('input', { type: 'file',
          onChange: this.handleFiles,
          accept: Array.isArray(this.props.fileTypes) ? this.props.fileTypes.join(',') : this.props.fileTypes,
          className: 'react-file-reader-input',
          id: this.state.elementId,
          multiple: this.props.multipleFiles,
          style: hideInput,
          disabled: this.props.disabled
        }),
        _react2.default.createElement(
          'div',
          { className: 'react-file-reader-button', onClick: this.clickInput },
          this.props.children
        )
      );
    }
  }]);

  return ReactFileReader;
}(_react2.default.Component);

exports.default = ReactFileReader;


ReactFileReader.defaultProps = {
  fileTypes: 'image/*',
  multipleFiles: false,
  base64: false,
  disabled: false
};

ReactFileReader.propTypes = {
  multipleFiles: _propTypes2.default.bool,
  handleFiles: _propTypes2.default.func.isRequired,
  fileTypes: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  base64: _propTypes2.default.bool,
  children: _propTypes2.default.element.isRequired,
  disabled: _propTypes2.default.bool
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactFileReader = __webpack_require__(162);

var _reactFileReader2 = _interopRequireDefault(_reactFileReader);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _alertDialog = __webpack_require__(89);

var _user = __webpack_require__(98);

var UserActions = _interopRequireWildcard(_user);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _base64Util = __webpack_require__(780);

var _Image = __webpack_require__(381);

var _Image2 = _interopRequireDefault(_Image);

var _reactNotifications = __webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** This form is used both on the sign-up page and on the profile-edit page.
 *  (So it must work on both - in particular when the user is not logged in.)
 */
var ProfileForm = function (_React$Component) {
    _inherits(ProfileForm, _React$Component);

    function ProfileForm(props) {
        _classCallCheck(this, ProfileForm);

        var _this = _possibleConstructorReturn(this, (ProfileForm.__proto__ || Object.getPrototypeOf(ProfileForm)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = Object.assign({}, {
            id: null,
            oldPassword: "",
            password: "",
            repeatPassword: "",
            isBasicFieldsValid: false, // Used to rerender when validity changes after rendering UserField components
            isPasswordFieldsValid: false // as above
        }, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(ProfileForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.profile && nextProps.profile.id !== this.state.id) this.setState(this.getStateFromStore(nextProps));
        }

        // Copies the values from the store to the state - in other words, copies the current values to the editor. (Useful when editing your profile)

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkFieldValidity();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.checkFieldValidity();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var repeatPasswordErr = this.state.password !== "" && this.state.repeatPassword !== "" && this.state.password !== this.state.repeatPassword;

            return _react2.default.createElement(
                'form',
                { className: 'user-form' },
                _react2.default.createElement(
                    'div',
                    { className: 'content-box editor-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sub-container' },
                        !this.props.resetPassword ? _react2.default.createElement(
                            'div',
                            { className: 'user-fields' },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Basic information'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'email' },
                                        'Email *'
                                    ),
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.email, placeholder: 'Enter email', className: 'field-1',
                                        name: 'email', id: 'email', maxLength: '128', value: this.state.email,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        isError: this.props.user.emailExists.exists, errorMessageOverride: this.props.user.emailExists.exists ? "The email " + this.props.user.emailExists.name + " is already in use" : null,
                                        onChange: this.onEmailChange,
                                        disabled: this.props.profile !== null,
                                        ref: function ref(instance) {
                                            _this2.basicFields[0] = instance;
                                        }
                                    }),
                                    ' '
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'firstName' },
                                    'First name *'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Enter first name', className: 'field-1',
                                        name: 'firstName', id: 'firstName', maxLength: '64', value: this.state.firstName,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.basicFields[1] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'lastName' },
                                        'Last name *'
                                    ),
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Enter last name', className: 'field-1',
                                        name: 'lastName', id: 'lastName', maxLength: '64', value: this.state.lastName,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.basicFields[2] = instance;
                                        }
                                    })
                                )
                            ),
                            this.props.profile !== null ? _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn-primary', onClick: this.onSubmit, disabled: !this.state.isBasicFieldsValid },
                                        this.props.submitButtonText
                                    )
                                )
                            ) : null
                        ) : '',
                        this.props.profile === null || this.props.profile.id == this.props.auth.userId ? _react2.default.createElement(
                            'div',
                            { className: 'user-fields' },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Password'
                            ),
                            this.props.profile !== null ? _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'oldPassword' },
                                        'Old password'
                                    ),
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.password,
                                        placeholder: 'Enter your old password', className: 'field-1',
                                        name: 'oldPassword', id: 'oldPassword',
                                        value: this.state.oldPassword,
                                        autoCheckErrors: true, hideErrWhenFocused: false,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.passwordFields[0] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'password' },
                                        this.props.profile === null ? 'Password *' : 'New password'
                                    ),
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.password,
                                        placeholder: 'Minimum 6 character incl. digits and letters',
                                        className: 'field-1',
                                        name: 'password', id: 'password', value: this.state.password,
                                        autoCheckErrors: true, required: true,
                                        hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.passwordFields[1] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'repeatPassword' },
                                        'Repeat password *'
                                    ),
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.password,
                                        placeholder: 'Repeat password', className: 'field-1',
                                        name: 'repeatPassword', id: 'repeatPassword',
                                        value: this.state.repeatPassword,
                                        autoCheckErrors: !repeatPasswordErr,
                                        isError: repeatPasswordErr,
                                        errorMessageOverride: 'Not correctly repeated', required: true,
                                        hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.passwordFields[2] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    this.props.profile === null ? _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn-primary', onClick: this.onSubmit,
                                            disabled: !this.state.isBasicFieldsValid || !this.state.isPasswordFieldsValid },
                                        this.props.submitButtonText
                                    ) : _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn-primary',
                                            onClick: this.onChangePassword,
                                            disabled: !this.state.isPasswordFieldsValid },
                                        'Change password'
                                    )
                                )
                            )
                        ) : ''
                    ),
                    !this.props.resetPassword ? _react2.default.createElement(
                        'div',
                        { className: 'sub-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'user-fields' },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Photo'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'user-avatar' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'react-file-reader-container' },
                                    _react2.default.createElement(
                                        _reactFileReader2.default,
                                        { id: 'photo2', base64: true, multipleFiles: false,
                                            handleFiles: this.onPhotoChange },
                                        _react2.default.createElement(
                                            'button',
                                            { onClick: function onClick(e) {
                                                    return e.preventDefault();
                                                },
                                                className: 'btn-primary profile-imgbutton-upload' },
                                            'Upload'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: this.onPhotoRemove,
                                            className: 'btn-secondary profile-imgbutton-delete' },
                                        'Delete'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { style: { clear: "both" }, className: 'profile-imginfo-text' },
                                        'Max 1MB'
                                    ),
                                    _react2.default.createElement(_Image2.default, { src: "data:" + this.state.photoMimeType + ";base64," + this.state.photo,
                                        size: 'big', circle: true, whiteIfNoImage: true })
                                )
                            )
                        )
                    ) : ''
                )
            );
        }
    }]);

    return ProfileForm;
}(_react2.default.Component);

ProfileForm.propTypes = {
    onSubmit: _propTypes2.default.func.isRequired,
    submitButtonText: _propTypes2.default.string,
    resetPassword: _propTypes2.default.bool,
    profile: _propTypes2.default.object,
    params: _propTypes2.default.object
};
ProfileForm.defaultProps = {
    profile: null,
    submitButtonText: "Save",
    resetPassword: false
};
ProfileForm.emailCheckTimeout = null;

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.getStateFromStore = function (props) {
        var user = props.profile;
        return {
            id: user === null ? null : user.id,
            firstName: user === null || user.firstName === null ? "" : user.firstName,
            lastName: user === null || user.lastName === null ? "" : user.lastName,
            email: user === null || user.email === null ? props.params && props.params.email ? props.params.email : "" : user.email,
            photo: user === null || user.photo === null ? "" : user.photo,
            photoMimeType: user === null || user.photoMimeType === null ? "" : user.photoMimeType
        };
    };

    this.checkFieldValidity = function () {
        var test = true;
        _this3.basicFields.forEach(function (field) {
            if (!field.isValid()) test = false;
        });
        var basicValid = test && (_this3.props.user.emailExists.name !== _this3.state.email || !_this3.props.user.emailExists.exists);

        test = true;
        _this3.passwordFields.forEach(function (field) {
            if (!field.isValid()) test = false;
        });
        var passwordValid = test && _this3.state.password === _this3.state.repeatPassword;

        if (_this3.state.isBasicFieldsValid !== basicValid || _this3.state.isPasswordFieldsValid !== passwordValid) _this3.setState({
            isBasicFieldsValid: basicValid,
            isPasswordFieldsValid: passwordValid
        });
    };

    this.basicFields = [];
    this.passwordFields = [];

    this.onStandardFieldChange = function (e) {
        var stateVariable = e.target.name; // assuming the "name" attribute and the state variable has the same name.
        _this3.setState(_defineProperty({}, stateVariable, e.target.value));
    };

    this.onCheckboxChange = function (e) {
        var stateVariable = e.target.name; // assuming the "name" attribute and the state variable has the same name.
        _this3.setState(_defineProperty({}, stateVariable, e.target.checked));
    };

    this.onPhotoChange = function (file) {
        var base64 = file.base64;
        var imageBytesBase64 = base64.substr(base64.indexOf(",") + 1); // remove the initial "data:image/png;base64," part.
        var mimeType = base64.substring(base64.indexOf(":") + 1, base64.indexOf(";"));

        if ((0, _base64Util.base64StringToByteSize)(imageBytesBase64) > 1024 * 1024) {
            (0, _alertDialog.alert)("The image is to big", "The profile image may not exceed 1MB. Try upload a smaller image.");
            return;
        }

        _this3.setState({ photo: imageBytesBase64, photoMimeType: mimeType });
    };

    this.onPhotoRemove = function (e) {
        e.preventDefault();
        _this3.setState({ photo: "", photoMimeType: "" });
    };

    this.onEmailChange = function (e) {
        var value = e.target.value;
        var dispatch = _this3.props.dispatch;

        // check if name already exists (and for another user) - delay a while before sending off the ajax request to avoid spamming the server while typing.
        if (ProfileForm.emailCheckTimeout !== null) clearTimeout(ProfileForm.emailCheckTimeout);
        ProfileForm.emailCheckTimeout = setTimeout(function () {
            return dispatch(UserActions.checkEmailExists(value, _this3.props.profile === null ? null : _this3.props.profile.id));
        }, 1000);

        _this3.onStandardFieldChange(e);
    };

    this.onSubmit = function (e) {
        e.preventDefault();

        if (!_this3.state.isBasicFieldsValid || _this3.props.profile === null && !_this3.state.isPasswordFieldsValid) {
            // Set visited to ensure error messages being shown
            _this3.basicFields.forEach(function (field) {
                field.setState({ visited: true });
            });
            if (_this3.props.profile === null) _this3.passwordFields.forEach(function (field) {
                field.setState({ visited: true });
            });
            return;
        }

        if (_this3.props.resetPassword) _this3.props.onSubmit(_this3.state.password);else _this3.props.onSubmit({
            email: _this3.state.email,
            firstName: _this3.state.firstName,
            lastName: _this3.state.lastName,
            password: _this3.props.profile === null ? _this3.state.password : undefined,
            photo: _this3.state.photo || null
        });
    };

    this.onChangePassword = function (e) {
        e.preventDefault();

        if (!_this3.state.isPasswordFieldsValid) {
            // Set visited to ensure error messages being shown
            _this3.passwordFields.forEach(function (field) {
                field.setState({ visited: true });
            });
            return;
        }

        _this3.props.dispatch(AuthActions.changePassword({
            oldPassword: _this3.state.oldPassword,
            newPassword: _this3.state.password
        }, function () {
            _reactNotifications.NotificationManager.success("Your password has been updated.", "Password changed", 4000);
            _this3.passwordFields.forEach(function (field) {
                field.setState({ visited: false });
            });
            _this3.setState({
                oldPassword: "",
                password: "",
                repeatPassword: ""
            });
        }));
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            userId: state.auth.userId
        },
        user: {
            emailExists: state.user.emailExists
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProfileForm);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(22) && !__webpack_require__(16)(function () {
  return Object.defineProperty(__webpack_require__(117)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(36);
var toIObject = __webpack_require__(37);
var arrayIndexOf = __webpack_require__(99)(false);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(66);

module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(37);
var gOPN = __webpack_require__(69).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(100);
var pIE = __webpack_require__(93);
var toObject = __webpack_require__(25);
var IObject = __webpack_require__(92);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(16)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(27);
var isObject = __webpack_require__(17);
var invoke = __webpack_require__(172);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(13).parseInt;
var $trim = __webpack_require__(82).trim;
var ws = __webpack_require__(123);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(13).parseFloat;
var $trim = __webpack_require__(82).trim;

module.exports = 1 / $parseFloat(__webpack_require__(123) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(42);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(17);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(126);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(25);
var IObject = __webpack_require__(92);
var toLength = __webpack_require__(21);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(21);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(138);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(22) && /./g.flags != 'g') __webpack_require__(24).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(94)
});


/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(142);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(188);
var validate = __webpack_require__(74);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(108)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(24).f;
var create = __webpack_require__(68);
var redefineAll = __webpack_require__(73);
var ctx = __webpack_require__(41);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var $iterDefine = __webpack_require__(128);
var step = __webpack_require__(182);
var setSpecies = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(22);
var fastKey = __webpack_require__(55).fastKey;
var validate = __webpack_require__(74);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(188);
var validate = __webpack_require__(74);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(108)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var each = __webpack_require__(50)(0);
var redefine = __webpack_require__(33);
var meta = __webpack_require__(55);
var assign = __webpack_require__(169);
var weak = __webpack_require__(191);
var isObject = __webpack_require__(17);
var validate = __webpack_require__(74);
var NATIVE_WEAK_MAP = __webpack_require__(74);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(108)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(73);
var getWeak = __webpack_require__(55).getWeak;
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var createArrayMethod = __webpack_require__(50);
var $has = __webpack_require__(36);
var validate = __webpack_require__(74);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(21);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(69);
var gOPS = __webpack_require__(100);
var anObject = __webpack_require__(10);
var Reflect = __webpack_require__(13).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(101);
var isObject = __webpack_require__(17);
var toLength = __webpack_require__(21);
var ctx = __webpack_require__(41);
var IS_CONCAT_SPREADABLE = __webpack_require__(20)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(21);
var repeat = __webpack_require__(125);
var defined = __webpack_require__(48);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(66);
var toIObject = __webpack_require__(37);
var isEnum = __webpack_require__(93).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(81);
var from = __webpack_require__(198);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(72);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(613);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(147);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ current: __WEBPACK_IMPORTED_MODULE_2_prop_types__["elementType"] })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(146);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(96);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(622);

var _runTransitionHook = __webpack_require__(149);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(86);

var _PathUtils = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(149);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(209);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(212);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(650);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(649);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(643);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(221);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(153);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
    // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(669);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports.default = portalOpenInstances;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactTransitionGroup = __webpack_require__(674);

var _classnames = _interopRequireDefault(__webpack_require__(231));

var _Notification = _interopRequireDefault(__webpack_require__(682));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notifications = /*#__PURE__*/function (_React$Component) {
  _inherits(Notifications, _React$Component);

  var _super = _createSuper(Notifications);

  function Notifications() {
    var _this;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
      return function () {
        var onRequestHide = _this.props.onRequestHide;

        if (onRequestHide) {
          onRequestHide(notification);
        }
      };
    });

    return _this;
  }

  _createClass(Notifications, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          notifications = _this$props.notifications,
          enterTimeout = _this$props.enterTimeout,
          leaveTimeout = _this$props.leaveTimeout;
      var className = (0, _classnames.default)('notification-container', {
        'notification-container-empty': notifications.length === 0
      });
      var items = notifications.map(function (notification, i) {
        var key = notification.id || new Date().getTime();
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: i,
          classNames: "notification",
          timeout: {
            enter: enterTimeout,
            exit: leaveTimeout
          }
        }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
          key: key,
          type: notification.type,
          title: notification.title,
          message: notification.message,
          timeOut: notification.timeOut,
          onClick: notification.onClick,
          onRequestHide: _this2.handleRequestHide(notification)
        }));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, items));
    }
  }]);

  return Notifications;
}(_react.default.Component);

_defineProperty(Notifications, "propTypes", {
  notifications: _propTypes.default.array,
  onRequestHide: _propTypes.default.func,
  enterTimeout: _propTypes.default.number,
  leaveTimeout: _propTypes.default.number
});

_defineProperty(Notifications, "defaultProps", {
  notifications: [],
  onRequestHide: function onRequestHide() {},
  enterTimeout: 400,
  leaveTimeout: 400
});

var _default = Notifications;
exports.default = _default;

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(680);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getInitialChildMapping */])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = __webpack_require__(684);

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var createUUID = function createUUID() {
  var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var Constants = {
  CHANGE: 'change',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

var NotificationManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(NotificationManager, _EventEmitter);

  var _super = _createSuper(NotificationManager);

  function NotificationManager() {
    var _this;

    _classCallCheck(this, NotificationManager);

    _this = _super.call(this);
    _this.listNotify = [];
    return _this;
  }

  _createClass(NotificationManager, [{
    key: "create",
    value: function create(notify) {
      var defaultNotify = {
        id: createUUID(),
        type: 'info',
        title: null,
        message: null,
        timeOut: 5000
      };

      if (notify.priority) {
        this.listNotify.unshift(Object.assign(defaultNotify, notify));
      } else {
        this.listNotify.push(Object.assign(defaultNotify, notify));
      }

      this.emitChange();
    }
  }, {
    key: "info",
    value: function info(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.INFO,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "success",
    value: function success(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.SUCCESS,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "warning",
    value: function warning(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.WARNING,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "error",
    value: function error(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.ERROR,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "remove",
    value: function remove(notification) {
      this.listNotify = this.listNotify.filter(function (n) {
        return notification.id !== n.id;
      });
      this.emitChange();
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      this.emit(Constants.CHANGE, this.listNotify);
    }
  }, {
    key: "addChangeListener",
    value: function addChangeListener(callback) {
      this.addListener(Constants.CHANGE, callback);
    }
  }, {
    key: "removeChangeListener",
    value: function removeChangeListener(callback) {
      this.removeListener(Constants.CHANGE, callback);
    }
  }]);

  return NotificationManager;
}(_events.EventEmitter);

var _default = new NotificationManager();

exports.default = _default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/**
 * Plain JS Object containing properties that represent an HTTP request.
 *
 * Depending on the capabilities of the underlying client, a request
 * may be cancelable. If a request may be canceled, the client will add
 * a canceled flag and cancel function to the request object. Canceling
 * the request will put the response into an error state.
 *
 * @field {string} [method='GET'] HTTP method, commonly GET, POST, PUT, DELETE or HEAD
 * @field {string|UrlBuilder} [path=''] path template with optional path variables
 * @field {Object} [params] parameters for the path template and query string
 * @field {Object} [headers] custom HTTP headers to send, in addition to the clients default headers
 * @field [entity] the HTTP entity, common for POST or PUT requests
 * @field {boolean} [canceled] true if the request has been canceled, set by the client
 * @field {Function} [cancel] cancels the request if invoked, provided by the client
 * @field {Client} [originator] the client that first handled this request, provided by the interceptor
 *
 * @class Request
 */

/**
 * Plain JS Object containing properties that represent an HTTP response
 *
 * @field {Object} [request] the request object as received by the root client
 * @field {Object} [raw] the underlying request object, like XmlHttpRequest in a browser
 * @field {number} [status.code] status code of the response (i.e. 200, 404)
 * @field {string} [status.text] status phrase of the response
 * @field {Object] [headers] response headers hash of normalized name, value pairs
 * @field [entity] the response body
 *
 * @class Response
 */

/**
 * HTTP client particularly suited for RESTful operations.
 *
 * @field {function} wrap wraps this client with a new interceptor returning the wrapped client
 *
 * @param {Request} the HTTP request
 * @returns {ResponsePromise<Response>} a promise the resolves to the HTTP response
 *
 * @class Client
 */

 /**
  * Extended when.js Promises/A+ promise with HTTP specific helpers
  *q
  * @method entity promise for the HTTP entity
  * @method status promise for the HTTP status code
  * @method headers promise for the HTTP response headers
  * @method header promise for a specific HTTP response header
  *
  * @class ResponsePromise
  * @extends Promise
  */

var client, target, platformDefault;

client = __webpack_require__(158);

if (typeof Promise !== 'function' && console && console.log) {
	console.log('An ES6 Promise implementation is required to use rest.js. See https://github.com/cujojs/when/blob/master/docs/es6-promise-shim.md for using when.js as a Promise polyfill.');
}

/**
 * Make a request with the default client
 * @param {Request} the HTTP request
 * @returns {Promise<Response>} a promise the resolves to the HTTP response
 */
function defaultClient() {
	return target.apply(void 0, arguments);
}

/**
 * Change the default client
 * @param {Client} client the new default client
 */
defaultClient.setDefaultClient = function setDefaultClient(client) {
	target = client;
};

/**
 * Obtain a direct reference to the current default client
 * @returns {Client} the default client
 */
defaultClient.getDefaultClient = function getDefaultClient() {
	return target;
};

/**
 * Reset the default client to the platform default
 */
defaultClient.resetDefaultClient = function resetDefaultClient() {
	target = platformDefault;
};

/**
 * @private
 */
defaultClient.setPlatformDefaultClient = function setPlatformDefaultClient(client) {
	if (platformDefault) {
		throw new Error('Unable to redefine platformDefaultClient');
	}
	target = platformDefault = client;
};

module.exports = client(defaultClient);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/**
 * Normalize HTTP header names using the pseudo camel case.
 *
 * For example:
 *   content-type         -> Content-Type
 *   accepts              -> Accepts
 *   x-custom-header-name -> X-Custom-Header-Name
 *
 * @param {string} name the raw header name
 * @return {string} the normalized header name
 */
function normalizeHeaderName(name) {
	return name.toLowerCase()
		.split('-')
		.map(function (chunk) { return chunk.charAt(0).toUpperCase() + chunk.slice(1); })
		.join('-');
}

module.exports = normalizeHeaderName;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
* Copyright 2014-2016 the original author or authors
* @license MIT, see LICENSE.txt for details
*
* @author Scott Andrews
*/



/**
 * Parse a MIME type into it's constituent parts
 *
 * @param {string} mime MIME type to parse
 * @return {{
 *   {string} raw the original MIME type
 *   {string} type the type and subtype
 *   {string} [suffix] mime suffix, including the plus, if any
 *   {Object} params key/value pair of attributes
 * }}
 */
function parse(mime) {
	var params, type;

	params = mime.split(';');
	type = params[0].trim().split('+');

	return {
		raw: mime,
		type: type[0],
		suffix: type[1] ? '+' + type[1] : '',
		params: params.slice(1).reduce(function (params, pair) {
			pair = pair.split('=');
			params[pair[0].trim()] = pair[1] ? pair[1].trim() : void 0;
			return params;
		}, {})
	};
}

module.exports = {
	parse: parse
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var mime, registry;

mime = __webpack_require__(235);

function Registry(mimes) {

	/**
	 * Lookup the converter for a MIME type
	 *
	 * @param {string} type the MIME type
	 * @return a promise for the converter
	 */
	this.lookup = function lookup(type) {
		var parsed;

		parsed = typeof type === 'string' ? mime.parse(type) : type;

		if (mimes[parsed.raw]) {
			return mimes[parsed.raw];
		}
		if (mimes[parsed.type + parsed.suffix]) {
			return mimes[parsed.type + parsed.suffix];
		}
		if (mimes[parsed.type]) {
			return mimes[parsed.type];
		}
		if (mimes[parsed.suffix]) {
			return mimes[parsed.suffix];
		}

		return Promise.reject(new Error('Unable to locate converter for mime "' + parsed.raw + '"'));
	};

	/**
	 * Create a late dispatched proxy to the target converter.
	 *
	 * Common when a converter is registered under multiple names and
	 * should be kept in sync if updated.
	 *
	 * @param {string} type mime converter to dispatch to
	 * @returns converter whose read/write methods target the desired mime converter
	 */
	this.delegate = function delegate(type) {
		return {
			read: function () {
				var args = arguments;
				return this.lookup(type).then(function (converter) {
					return converter.read.apply(this, args);
				}.bind(this));
			}.bind(this),
			write: function () {
				var args = arguments;
				return this.lookup(type).then(function (converter) {
					return converter.write.apply(this, args);
				}.bind(this));
			}.bind(this)
		};
	};

	/**
	 * Register a custom converter for a MIME type
	 *
	 * @param {string} type the MIME type
	 * @param converter the converter for the MIME type
	 * @return a promise for the converter
	 */
	this.register = function register(type, converter) {
		mimes[type] = Promise.resolve(converter);
		return mimes[type];
	};

	/**
	 * Create a child registry whoes registered converters remain local, while
	 * able to lookup converters from its parent.
	 *
	 * @returns child MIME registry
	 */
	this.child = function child() {
		return new Registry(Object.create(mimes));
	};

}

registry = new Registry({});

// include provided serializers
registry.register('application/hal', __webpack_require__(237));
registry.register('application/json', __webpack_require__(697));
registry.register('application/x-www-form-urlencoded', __webpack_require__(239));
registry.register('multipart/form-data', __webpack_require__(698));
registry.register('text/plain', __webpack_require__(699));

registry.register('+json', registry.delegate('application/json'));

module.exports = registry;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2013-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var pathPrefix, template, find, lazyPromise, responsePromise;

pathPrefix = __webpack_require__(691);
template = __webpack_require__(692);
find = __webpack_require__(695);
lazyPromise = __webpack_require__(696);
responsePromise = __webpack_require__(159);

function defineProperty(obj, name, value) {
	Object.defineProperty(obj, name, {
		value: value,
		configurable: true,
		enumerable: false,
		writeable: true
	});
}

/**
 * Hypertext Application Language serializer
 *
 * Implemented to https://tools.ietf.org/html/draft-kelly-json-hal-06
 *
 * As the spec is still a draft, this implementation will be updated as the
 * spec evolves
 *
 * Objects are read as HAL indexing links and embedded objects on to the
 * resource. Objects are written as plain JSON.
 *
 * Embedded relationships are indexed onto the resource by the relationship
 * as a promise for the related resource.
 *
 * Links are indexed onto the resource as a lazy promise that will GET the
 * resource when a handler is first registered on the promise.
 *
 * A `requestFor` method is added to the entity to make a request for the
 * relationship.
 *
 * A `clientFor` method is added to the entity to get a full Client for a
 * relationship.
 *
 * The `_links` and `_embedded` properties on the resource are made
 * non-enumerable.
 */
module.exports = {

	read: function (str, opts) {
		var client, console;

		opts = opts || {};
		client = opts.client;
		console = opts.console || console;

		function deprecationWarning(relationship, deprecation) {
			if (deprecation && console && console.warn || console.log) {
				(console.warn || console.log).call(console, 'Relationship \'' + relationship + '\' is deprecated, see ' + deprecation);
			}
		}

		return opts.registry.lookup(opts.mime.suffix).then(function (converter) {
			return converter.read(str, opts);
		}).then(function (root) {
			find.findProperties(root, '_embedded', function (embedded, resource, name) {
				Object.keys(embedded).forEach(function (relationship) {
					if (relationship in resource) { return; }
					var related = responsePromise({
						entity: embedded[relationship]
					});
					defineProperty(resource, relationship, related);
				});
				defineProperty(resource, name, embedded);
			});
			find.findProperties(root, '_links', function (links, resource, name) {
				Object.keys(links).forEach(function (relationship) {
					var link = links[relationship];
					if (relationship in resource) { return; }
					defineProperty(resource, relationship, responsePromise.make(lazyPromise(function () {
						if (link.deprecation) { deprecationWarning(relationship, link.deprecation); }
						if (link.templated === true) {
							return template(client)({ path: link.href });
						}
						return client({ path: link.href });
					})));
				});
				defineProperty(resource, name, links);
				defineProperty(resource, 'clientFor', function (relationship, clientOverride) {
					var link = links[relationship];
					if (!link) {
						throw new Error('Unknown relationship: ' + relationship);
					}
					if (link.deprecation) { deprecationWarning(relationship, link.deprecation); }
					if (link.templated === true) {
						return template(
							clientOverride || client,
							{ template: link.href }
						);
					}
					return pathPrefix(
						clientOverride || client,
						{ prefix: link.href }
					);
				});
				defineProperty(resource, 'requestFor', function (relationship, request, clientOverride) {
					var client = this.clientFor(relationship, clientOverride);
					return client(request);
				});
			});

			return root;
		});

	},

	write: function (obj, opts) {
		return opts.registry.lookup(opts.mime.suffix).then(function (converter) {
			return converter.write(obj, opts);
		});
	}

};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var mixin, xWWWFormURLEncoder, origin, urlRE, absoluteUrlRE, fullyQualifiedUrlRE;

mixin = __webpack_require__(116);
xWWWFormURLEncoder = __webpack_require__(239);

urlRE = /([a-z][a-z0-9\+\-\.]*:)\/\/([^@]+@)?(([^:\/]+)(:([0-9]+))?)?(\/[^?#]*)?(\?[^#]*)?(#\S*)?/i;
absoluteUrlRE = /^([a-z][a-z0-9\-\+\.]*:\/\/|\/)/i;
fullyQualifiedUrlRE = /([a-z][a-z0-9\+\-\.]*:)\/\/([^@]+@)?(([^:\/]+)(:([0-9]+))?)?\//i;

/**
 * Apply params to the template to create a URL.
 *
 * Parameters that are not applied directly to the template, are appended
 * to the URL as query string parameters.
 *
 * @param {string} template the URI template
 * @param {Object} params parameters to apply to the template
 * @return {string} the resulting URL
 */
function buildUrl(template, params) {
	// internal builder to convert template with params.
	var url, name, queryStringParams, queryString, re;

	url = template;
	queryStringParams = {};

	if (params) {
		for (name in params) {
			/*jshint forin:false */
			re = new RegExp('\\{' + name + '\\}');
			if (re.test(url)) {
				url = url.replace(re, encodeURIComponent(params[name]), 'g');
			}
			else {
				queryStringParams[name] = params[name];
			}
		}

		queryString = xWWWFormURLEncoder.write(queryStringParams);
		if (queryString) {
			url += url.indexOf('?') === -1 ? '?' : '&';
			url += queryString;
		}
	}
	return url;
}

function startsWith(str, test) {
	return str.indexOf(test) === 0;
}

/**
 * Create a new URL Builder
 *
 * @param {string|UrlBuilder} template the base template to build from, may be another UrlBuilder
 * @param {Object} [params] base parameters
 * @constructor
 */
function UrlBuilder(template, params) {
	if (!(this instanceof UrlBuilder)) {
		// invoke as a constructor
		return new UrlBuilder(template, params);
	}

	if (template instanceof UrlBuilder) {
		this._template = template.template;
		this._params = mixin({}, this._params, params);
	}
	else {
		this._template = (template || '').toString();
		this._params = params || {};
	}
}

UrlBuilder.prototype = {

	/**
	 * Create a new UrlBuilder instance that extends the current builder.
	 * The current builder is unmodified.
	 *
	 * @param {string} [template] URL template to append to the current template
	 * @param {Object} [params] params to combine with current params.  New params override existing params
	 * @return {UrlBuilder} the new builder
	 */
	append: function (template,  params) {
		// TODO consider query strings and fragments
		return new UrlBuilder(this._template + template, mixin({}, this._params, params));
	},

	/**
	 * Create a new UrlBuilder with a fully qualified URL based on the
	 * window's location or base href and the current templates relative URL.
	 *
	 * Path variables are preserved.
	 *
	 * *Browser only*
	 *
	 * @return {UrlBuilder} the fully qualified URL template
	 */
	fullyQualify: function () {
		if (typeof location === 'undefined') { return this; }
		if (this.isFullyQualified()) { return this; }

		var template = this._template;

		if (startsWith(template, '//')) {
			template = origin.protocol + template;
		}
		else if (startsWith(template, '/')) {
			template = origin.origin + template;
		}
		else if (!this.isAbsolute()) {
			template = origin.origin + origin.pathname.substring(0, origin.pathname.lastIndexOf('/') + 1);
		}

		if (template.indexOf('/', 8) === -1) {
			// default the pathname to '/'
			template = template + '/';
		}

		return new UrlBuilder(template, this._params);
	},

	/**
	 * True if the URL is absolute
	 *
	 * @return {boolean}
	 */
	isAbsolute: function () {
		return absoluteUrlRE.test(this.build());
	},

	/**
	 * True if the URL is fully qualified
	 *
	 * @return {boolean}
	 */
	isFullyQualified: function () {
		return fullyQualifiedUrlRE.test(this.build());
	},

	/**
	 * True if the URL is cross origin. The protocol, host and port must not be
	 * the same in order to be cross origin,
	 *
	 * @return {boolean}
	 */
	isCrossOrigin: function () {
		if (!origin) {
			return true;
		}
		var url = this.parts();
		return url.protocol !== origin.protocol ||
		       url.hostname !== origin.hostname ||
		       url.port !== origin.port;
	},

	/**
	 * Split a URL into its consituent parts following the naming convention of
	 * 'window.location'. One difference is that the port will contain the
	 * protocol default if not specified.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/DOM/window.location
	 *
	 * @returns {Object} a 'window.location'-like object
	 */
	parts: function () {
		/*jshint maxcomplexity:20 */
		var url, parts;
		url = this.fullyQualify().build().match(urlRE);
		parts = {
			href: url[0],
			protocol: url[1],
			host: url[3] || '',
			hostname: url[4] || '',
			port: url[6],
			pathname: url[7] || '',
			search: url[8] || '',
			hash: url[9] || ''
		};
		parts.origin = parts.protocol + '//' + parts.host;
		parts.port = parts.port || (parts.protocol === 'https:' ? '443' : parts.protocol === 'http:' ? '80' : '');
		return parts;
	},

	/**
	 * Expand the template replacing path variables with parameters
	 *
	 * @param {Object} [params] params to combine with current params.  New params override existing params
	 * @return {string} the expanded URL
	 */
	build: function (params) {
		return buildUrl(this._template, mixin({}, this._params, params));
	},

	/**
	 * @see build
	 */
	toString: function () {
		return this.build();
	}

};

origin = typeof location !== 'undefined' ? new UrlBuilder(location.href).parts() : void 0;

module.exports = UrlBuilder;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var encodedSpaceRE, urlEncodedSpaceRE;

encodedSpaceRE = /%20/g;
urlEncodedSpaceRE = /\+/g;

function urlEncode(str) {
	str = encodeURIComponent(str);
	// spec says space should be encoded as '+'
	return str.replace(encodedSpaceRE, '+');
}

function urlDecode(str) {
	// spec says space should be encoded as '+'
	str = str.replace(urlEncodedSpaceRE, ' ');
	return decodeURIComponent(str);
}

function append(str, name, value) {
	if (Array.isArray(value)) {
		value.forEach(function (value) {
			str = append(str, name, value);
		});
	}
	else {
		if (str.length > 0) {
			str += '&';
		}
		str += urlEncode(name);
		if (value !== undefined && value !== null) {
			str += '=' + urlEncode(value);
		}
	}
	return str;
}

module.exports = {

	read: function (str) {
		var obj = {};
		str.split('&').forEach(function (entry) {
			var pair, name, value;
			pair = entry.split('=');
			name = urlDecode(pair[0]);
			if (pair.length === 2) {
				value = urlDecode(pair[1]);
			}
			else {
				value = null;
			}
			if (name in obj) {
				if (!Array.isArray(obj[name])) {
					// convert to an array, perserving currnent value
					obj[name] = [obj[name]];
				}
				obj[name].push(value);
			}
			else {
				obj[name] = value;
			}
		});
		return obj;
	},

	write: function (obj) {
		var str = '';
		Object.keys(obj).forEach(function (name) {
			str = append(str, name, obj[name]);
		});
		return str;
	}

};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/**
 * Attempt to invoke a function capturing the resulting value as a Promise
 *
 * If the method throws, the caught value used to reject the Promise.
 *
 * @param {function} work function to invoke
 * @returns {Promise} Promise for the output of the work function
 */
function attempt(work) {
	try {
		return Promise.resolve(work());
	}
	catch (e) {
		return Promise.reject(e);
	}
}

module.exports = attempt;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	/**
	 * Custom error type for promises rejected by promise.timeout
	 * @param {string} message
	 * @constructor
	 */
	function TimeoutError (message) {
		Error.call(this);
		this.message = message;
		this.name = TimeoutError.name;
		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, TimeoutError);
		}
	}

	TimeoutError.prototype = Object.create(Error.prototype);
	TimeoutError.prototype.constructor = TimeoutError;

	return TimeoutError;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return {
		pending: toPendingState,
		fulfilled: toFulfilledState,
		rejected: toRejectedState,
		inspect: inspect
	};

	function toPendingState() {
		return { state: 'pending' };
	}

	function toRejectedState(e) {
		return { state: 'rejected', reason: e };
	}

	function toFulfilledState(x) {
		return { state: 'fulfilled', value: x };
	}

	function inspect(handler) {
		var state = handler.state();
		return state === 0 ? toPendingState()
			 : state > 0   ? toFulfilledState(handler.value)
			               : toRejectedState(handler.value);
	}

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	makeApply.tryCatchResolve = tryCatchResolve;

	return makeApply;

	function makeApply(Promise, call) {
		if(arguments.length < 2) {
			call = tryCatchResolve;
		}

		return apply;

		function apply(f, thisArg, args) {
			var p = Promise._defer();
			var l = args.length;
			var params = new Array(l);
			callAndResolve({ f:f, thisArg:thisArg, args:args, params:params, i:l-1, call:call }, p._handler);

			return p;
		}

		function callAndResolve(c, h) {
			if(c.i < 0) {
				return call(c.f, c.thisArg, c.params, h);
			}

			var handler = Promise._handler(c.args[c.i]);
			handler.fold(callAndResolveNext, c, void 0, h);
		}

		function callAndResolveNext(c, x, h) {
			c.params[c.i] = x;
			c.i -= 1;
			callAndResolve(c, h);
		}
	}

	function tryCatchResolve(f, thisArg, args, resolver) {
		try {
			resolver.resolve(f.apply(thisArg, args));
		} catch(e) {
			resolver.reject(e);
		}
	}

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));




/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file contains the settings which varies between the various environments (dev, prod, etc).
// Idea from: http://himanshu.gilani.info/blog/2012/09/26/bootstraping-a-node-dot-js-app-for-dev-slash-prod-environment/
module.exports = {
    development: {
        port: 3000,
        use_webpack_dev_server: true,
        sequelize_logging: true,
        debug_show_expected_exceptions: true,
        client: { // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: true
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "brevduen",
            password: "qwerty123",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "brevdue_drupal",
            drupalUsername: "brevduen",
            drupalPassword: "qwerty123"
        },
        drupal: {
            consumerKey: "RfC5PEK2atpL6x84ZFuYFNWtHcVnYeoj",
            consumerSecret: "A9voxBcJxhFbxBQM9jFAHkTULTx59Ldw",
            providerURL: "http://localhost/brevdue_drupal",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1"
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIK7OUNOX2TQT7OEQ', // <- ITK-time username
                    pass: 'AhCZbmaL8ekV6z9JPJe0T86GBH7l4D+YZgYtJE7htolG'
                }
            }
        },
        payment: {
            quickPay: {
                merchantId: 44335, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 171333, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "5777a88d9ef7ca991b588d42e70d154ce06f55e0ef27c2a9d1f14cb5b2eb1669", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "94f0b98218486b6ebcc3c4f679f1152aa3762f7ef5e23e379e0c20ae2df6ccf9",
                orderPrefix: "" // TODO: Make it something different from dev to dev
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss"
        },
        files: {
            importFileLocation: "/home/jakob/test/ddb-files"
        }
    },
    test: {
        port: 3002,
        use_webpack_dev_server: false,
        sequelize_logging: true,
        debug_show_expected_exceptions: true,
        client: { // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: true
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "ddb-user",
            password: "3CTFO?U+sK*O5&K!",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "drupal",
            drupalUsername: "ddb-user",
            drupalPassword: "3CTFO?U+sK*O5&K!"
        },
        drupal: {
            consumerKey: "gAvZrwwETsZikA4jj5JPNhnVEqc2vnh3",
            consumerSecret: "U4NF2vSAEdE6TuKGBM3MenbqUADfKc6e",
            providerURL: "https://brevduen.dk/",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1"
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIK7OUNOX2TQT7OEQ', // <- ITK-time username
                    pass: 'AhCZbmaL8ekV6z9JPJe0T86GBH7l4D+YZgYtJE7htolG'
                }
            }
        },
        payment: {
            quickPay: {
                merchantId: 44174, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 170722, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "c6ddc724d3833ad27fbd4aefc4afec190a3125b5886b613891df47f770c6a1f0", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "b27e0a94e0f3a645421b0b809f1832cb109e61abdbbb7f7c6ad3ea18ae6382e6",
                orderPrefix: "test"
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss"
        },
        files: {
            importFileLocation: "/var/www/data/ddb-files"
        }
    },
    prod: {
        port: 3002,
        use_webpack_dev_server: false,
        sequelize_logging: false,
        debug_show_expected_exceptions: false,
        client: { // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: false
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            //host: "web",
            //port: 3306,
            //database: "ddb-dk",
            //username: "dba",
            //password: "9njamaster"
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "ddb-user",
            password: "3CTFO?U+sK*O5&K!",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "drupal",
            drupalUsername: "ddb-user",
            drupalPassword: "3CTFO?U+sK*O5&K!"
        },
        drupal: {
            consumerKey: "RfC5PEK2atpL6x84ZFuYFNWtHcVnYeoj",
            consumerSecret: "A9voxBcJxhFbxBQM9jFAHkTULTx59Ldw",
            providerURL: "https://brevduen.dk/",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1"
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIUD2U55CUK63YJ2A',
                    pass: 'AnwP06Y4jleDmdrjDNnWM8voYtcLk/v24Yd3quRD0niJ'
                }
            }
        },
        payment: {
            quickPay: {
                merchantId: 44174, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 170722, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "c6ddc724d3833ad27fbd4aefc4afec190a3125b5886b613891df47f770c6a1f0", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "b27e0a94e0f3a645421b0b809f1832cb109e61abdbbb7f7c6ad3ea18ae6382e6",
                orderPrefix: ""
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss"
        },
        files: {
            importFileLocation: "/var/www/data/ddb-files"
        }
    }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(19);

var _routeconstants = __webpack_require__(11);

var _Image = __webpack_require__(381);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultImage = typeof window === "undefined" ? null // <- don't require the image on the server (it will crash - no webpack).
: __webpack_require__(727); // file-loader = get image as path, url-loader = get image as "data:" + base64 encoded data.

// An alias for Image, which is easier to use for avatars (user-photos). Also optionally links to the users profile.

var Avatar = function (_React$Component) {
    _inherits(Avatar, _React$Component);

    function Avatar() {
        _classCallCheck(this, Avatar);

        return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
    }

    _createClass(Avatar, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                userId = _props.userId,
                size = _props.size,
                link = _props.link;


            var imageElem = _react2.default.createElement(_Image2.default, { src: "/api/user/" + userId + "/photo", size: size, circle: true, srcIfNoImage: defaultImage });

            return link ? _react2.default.createElement(
                _reactRouter.Link,
                { to: _routeconstants.ROUTE_PROFILE.replace(":userId", userId), onClick: function onClick(e) {
                        return e.stopPropagation();
                    } },
                imageElem
            ) : imageElem;
        }
    }]);

    return Avatar;
}(_react2.default.Component);

Avatar.propTypes = {
    userId: _propTypes2.default.number.isRequired,
    size: _propTypes2.default.string.isRequired,
    link: _propTypes2.default.bool
};
Avatar.defaultProps = {
    link: true
};
exports.default = Avatar;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Scales image to COVER the area and still maintain aspect ratio. (Part of the image might be hidden)
var Image = function (_React$Component) {
    _inherits(Image, _React$Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.determineImageSize = function (newestProps) {
            // Create an in-memory image to determine its width and height
            var src = newestProps.src;
            var imageCacheBreaker = newestProps.system.imageCacheBreaker;
            var src_cache = _this.addCacheBreakerToSrc(src, imageCacheBreaker);

            var img = document.createElement("img");
            img.onload = function () {
                if (_this.props.src !== src || _this.props.system.imageCacheBreaker !== imageCacheBreaker) return; // abort if src was changed while loading (or the cacheBreaker)
                _this.setState({ isImageLoaded: true, isLoadError: false, width: img.naturalWidth, height: img.naturalHeight });
            };
            img.onerror = function (error) {
                if (_this.props.src !== src || _this.props.system.imageCacheBreaker !== imageCacheBreaker) return; // abort if src was changed while loading (or the cacheBreaker)
                _this.setState({ isImageLoaded: false, isLoadError: true, width: -1, height: -1 });
            };
            img.src = src_cache; // just to be safe: setting it after onload
        };

        _this.sizeNameToPixels = function () {
            // Contains the standard sizes we use
            switch (_this.props.size) {
                case "big":
                    return 182;
                //case "normal": return 100;
                case "small":
                    return 50;
                case "tiny":
                    return 25;
                default:
                    console.error("illegal size " + _this.props.size);return 0;
            }
        };

        _this.addCacheBreakerToSrc = function (src, imageCacheBreaker) {
            if (!src || src.substr(0, Math.min(5, src.length)) === "data:") // if src contains a "data:" url, don't add anything to it.
                return src;
            var separator = src.indexOf("?") === -1 ? "?" : "&";
            return src + separator + imageCacheBreaker;
        };

        _this.state = {
            isImageLoaded: false, // whether image dimensions has been determined
            isLoadError: false, // true if no image
            width: -1, // original image width
            height: -1 // original image height
        };
        return _this;
    }

    _createClass(Image, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var isOnServer = typeof window === "undefined";
            if (!isOnServer) this.determineImageSize(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.src !== this.props.src || nextProps.system.imageCacheBreaker !== this.props.system.imageCacheBreaker) this.determineImageSize(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isImageLoaded = _state.isImageLoaded,
                isLoadError = _state.isLoadError,
                width = _state.width,
                height = _state.height;
            var _props = this.props,
                src = _props.src,
                circle = _props.circle,
                whiteIfNoImage = _props.whiteIfNoImage,
                srcIfNoImage = _props.srcIfNoImage;


            var sizePixels = this.sizeNameToPixels();

            var imgStyle = {
                visibility: isImageLoaded ? "visible" : "hidden"
            };

            var containerStyle = {
                width: sizePixels,
                height: sizePixels,
                //backgroundColor:"green",
                borderRadius: circle ? sizePixels / 2 : 0
            };

            if (isLoadError && whiteIfNoImage) containerStyle.backgroundColor = "white";

            var src_cache = this.addCacheBreakerToSrc(src, this.props.system.imageCacheBreaker);

            var imageElement = width < height ? _react2.default.createElement('img', { src: src_cache, width: sizePixels, className: 'image-box-center-y', style: imgStyle }) : _react2.default.createElement('img', { src: src_cache, height: sizePixels, className: 'image-box-center-x', style: imgStyle });

            var noImageElement = srcIfNoImage === null ? [] : _react2.default.createElement('img', { src: srcIfNoImage, width: sizePixels });

            return _react2.default.createElement(
                'div',
                { className: 'image-box', style: containerStyle },
                isLoadError ? noImageElement : imageElement
            );
        }
    }]);

    return Image;
}(_react2.default.Component);

Image.propTypes = {
    src: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.string.isRequired,
    circle: _propTypes2.default.bool,
    whiteIfNoImage: _propTypes2.default.bool,
    srcIfNoImage: _propTypes2.default.string
};
Image.defaultProps = {
    circle: false,
    whiteIfNoImage: false,
    srcIfNoImage: null
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        system: {
            imageCacheBreaker: state.system.imageCacheBreaker
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Image);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var k = 1.856593992;

var calcDistance = exports.calcDistance = function calcDistance(from, to) {
    var a = from.Laengde_grader + from.Laengde_min / 60 + from.Laengde_sek / 3600 + from.Laengde_100_dele_sek / 360000;
    var b = to.Laengde_grader + to.Laengde_min / 60 + to.Laengde_sek / 3600 + to.Laengde_100_dele_sek / 360000;
    var c = from.Bredde_grader + from.Bredde_min / 60 + from.Bredde_sek / 3600 + from.Bredde_100_dele_sek / 360000;
    var d = to.Bredde_grader + to.Bredde_min / 60 + to.Bredde_sek / 3600 + to.Bredde_100_dele_sek / 360000;
    var a1 = a * (Math.PI / 180);
    var b1 = b * (Math.PI / 180);
    var c1 = c * (Math.PI / 180);
    var d1 = d * (Math.PI / 180);
    var s1 = Math.sin(c1) * Math.sin(d1);
    var s2 = Math.cos(c1) * Math.cos(d1) * Math.cos(a1 - b1);
    var s3 = s1 + s2;
    var s4 = -Math.atan(s3 / Math.sqrt(1 - Math.pow(s3, 2))) + Math.PI / 2;
    var s5 = s4 * (180 / Math.PI);
    return Math.round(1000 * (s5 * 60) * k) / 1000;
};

// Parameters:
// distance: float
// releaseDate: date
// releaseTime: string, HH:MM
// homeDay: integer
// homeTime: date/time, ignore date part
// nightStart: integer (number of minutes to sunrise)
// nightEnd: integer (number of minutes to sunset)
// watchStartDate: date
// watchStartTime: string, HH:MM:SS
// watchControlDate: date
// watchControlTime: string, HH:MM:SS
// watchError: float
var calcMpm = exports.calcMpm = function calcMpm(distance, releaseDate, releaseTime, homeDay, homeTime, nightStart, nightEnd, watchStartDate, watchStartTime, watchControlDate, watchControlTime, watchError) {
    // Initialize and validate.
    var result = {
        duration: null,
        mpm: null,
        correctedHomeTime: null,
        msg: null,
        status: -1
    };
    if (homeDay === null || homeTime === null) return result;
    if (distance === null) {
        result.status = 6;
        result.msg = 'Afstand ikke fundet.';
        return result;
    }
    if (releaseDate === null || releaseTime === null) {
        result.status = 1;
        result.msg = 'Der er ikke angivet sliptid eller slipdato.';
        return result;
    }
    if (watchStartDate === null || watchStartTime === null || watchControlDate === null || watchControlTime === null || watchError === null) {
        result.status = 2;
        result.msg = 'Der mangler uroplysninger for slag.';
        return result;
    }

    // Calculate corrected home.
    var h1 = Number(watchStartTime.substr(0, 2));
    var m1 = Number(watchStartTime.substr(3, 2));
    var s1 = Number(watchStartTime.substr(6, 2));
    var h2 = homeTime.getHours();
    var m2 = homeTime.getMinutes();
    var s2 = homeTime.getSeconds();
    var homeSecond = 3600 * h2 + 60 * m2 + s2;
    var duration = homeSecond - 3600 * h1 - 60 * m1 - s1 + (releaseDate.getTime() - watchStartDate.getTime()) / 1000 + homeDay - 1;
    if (duration < 0) {
        result.status = 3;
        result.msg = 'Hjemkomst ligger før urstart.';
        return result;
    }
    h1 = Number(watchControlTime.substr(0, 2));
    m1 = Number(watchControlTime.substr(3, 2));
    s1 = Number(watchControlTime.substr(6, 2));
    if (3600 * h1 + 60 * m1 + s1 - homeSecond + (watchControlDate.getTime() - releaseDate.getTime()) / 1000 - homeDay + 1 < 0) {
        result.status = 4;
        result.msg = 'Hjemkomst efter kontrol - Tjek om radiouret er fanget efter duestempling.';
        return result;
    }
    var correction = duration * watchError;
    var homeSecond2 = homeSecond + correction;
    homeSecond = homeSecond + Math.round(correction);
    if (homeSecond < 0) homeSecond = 0;else if (homeSecond >= 86400) homeSecond = 86399;
    s2 = homeSecond % 60;
    var rest = (homeSecond - s2) / 60;
    m2 = rest % 60;
    h2 = (rest - m2) / 60;
    result.correctedHomeTime = String(h2).padStart(2, '0') + ':' + String(m2).padStart(2, '0') + ':' + String(s2).padStart(2, '0');

    // Correct for night time.
    h1 = Number(releaseTime.substr(0, 2));
    m1 = Number(releaseTime.substr(3, 2));
    if (homeSecond2 > nightStart * 60) homeSecond2 = nightStart * 60;else if (homeSecond2 < nightEnd * 60) homeSecond2 = nightEnd * 60;
    var nightDuration = 60 * (1440 - nightStart + nightEnd);
    duration = homeSecond2 - 3600 * h1 - 60 * m1 + (86400 - nightDuration) * (homeDay - 1);
    if (duration <= 0) {
        result.status = 5;
        result.msg = 'Hjemkomst ligger før sliptid. Check sliptid og -dato.';
        return result;
    }
    s1 = Math.round(duration) % 60;
    rest = (Math.round(duration) - s1) / 60;
    m1 = rest % 60;
    h1 = (rest - m1) / 60;
    result.duration = String(h1).padStart(2, '0') + ':' + String(m1).padStart(2, '0') + ':' + String(s1).padStart(2, '0');

    // Calculate speed.
    result.mpm = 60 * distance * 1000 / duration;
    return result;
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.locationChanged = locationChanged;
exports.updateImageCacheBreakerValue = updateImageCacheBreakerValue;

var _actionconstants = __webpack_require__(35);

function locationChanged(location) {
    return function (dispatch) {
        dispatch({
            type: _actionconstants.SYSTEM_LOCATION_CHANGED,
            payload: {
                location: location
            }
        });
    };
}

function updateImageCacheBreakerValue() {
    return function (dispatch) {
        dispatch({
            type: _actionconstants.SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE,
            payload: {
                value: new Date().getTime()
            }
        });
    };
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Foreningsnr: '',
    Medlemsnr: '',
    Efternavn: '',
    Fornavn: '',
    Kontaktnavn: '',
    C_O_adresse: '',
    Adr: '',
    Husnr: '',
    Husbogstav: '',
    Etage: '',
    Placering: '',
    Postboks: '',
    Postnr: '',
    Tlf: '',
    Email: '',
    Slagnr: '',
    Slagnavn: '',
    Slagadr: '',
    Slagtlf: ''
};

var MemberGeneral = function (_React$Component) {
    _inherits(MemberGeneral, _React$Component);

    function MemberGeneral(props) {
        _classCallCheck(this, MemberGeneral);

        var _this = _possibleConstructorReturn(this, (MemberGeneral.__proto__ || Object.getPrototypeOf(MemberGeneral)).call(this, props));

        _this.fields = [];

        _this.updatePigeonHole = function (clubNo, holeNo) {
            if (holeNo.length === 3) {
                var hole = _this.props.admin.pigeonHoles.get(clubNo + '-' + holeNo) || null;
                if (hole === null) {
                    var club = _this.props.admin.clubs.get(clubNo) || null;
                    if (club !== null) hole = club.UpdateRequests.find(function (req) {
                        return req.type === 'pigeonhole' && req.newKey === holeNo;
                    }) || null;
                    if (hole !== null && hole.updates !== null) hole = JSON.parse(hole.updates);
                }
                if (hole === null) _this.setState({ Slagnavn: '' });else _this.setState({ Slagnavn: typeof hole.Slagnavn === 'undefined' || hole.Slagnavn === null ? '' : hole.Slagnavn });
            } else if (holeNo === '') _this.setState({ Slagnavn: '' });
        };

        _this.onClubNumberFieldChange = function (e) {
            if (e.target.value.length === 3) {
                var club = _this.props.admin.clubs.get(e.target.value) || null;
                if (club === null || typeof club.isFullLoaded === 'undefined') _this.props.dispatch(AdminActions.getClub(e.target.value, function () {
                    _this.updatePigeonHole(_this.state.Foreningsnr, _this.state.Slagnr);
                }));else _this.updatePigeonHole(e.target.value, _this.state.Slagnr);
            }
            _this.onStandardFieldChange(e);
        };

        _this.onPigeonHoleNumberFieldChange = function (e) {
            _this.updatePigeonHole(_this.state.Foreningsnr, e.target.value);
            _this.onStandardFieldChange(e);
        };

        _this.onLowerCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toLowerCase()));
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Foreningsnr: _this.state.Foreningsnr,
                    Efternavn: _this.state.Efternavn === '' ? null : _this.state.Efternavn,
                    Fornavn: _this.state.Fornavn === '' ? null : _this.state.Fornavn,
                    Kontaktnavn: _this.state.Kontaktnavn === '' ? null : _this.state.Kontaktnavn,
                    C_O_adresse: _this.state.C_O_adresse === '' ? null : _this.state.C_O_adresse,
                    Adr: _this.state.Adr === '' ? null : _this.state.Adr,
                    Husnr: _this.state.Husnr === '' ? null : _this.state.Husnr,
                    Husbogstav: _this.state.Husbogstav === '' ? null : _this.state.Husbogstav,
                    Etage: _this.state.Etage === '' ? null : _this.state.Etage,
                    Placering: _this.state.Placering === '' ? null : _this.state.Placering,
                    Postboks: _this.state.Postboks === '' ? null : Number(_this.state.Postboks),
                    Postnr: _this.state.Postnr === '' ? null : _this.state.Postnr,
                    Tlf: _this.state.Tlf === '' ? null : _this.state.Tlf,
                    Email: _this.state.Email === '' ? null : _this.state.Email,
                    Slagnr: _this.state.Slagnr === '' ? null : _this.state.Slagnr,
                    Slagnavn: _this.state.Slagnavn === '' ? null : _this.state.Slagnavn,
                    Slagadr: _this.state.Slagadr === '' ? null : _this.state.Slagadr,
                    Slagtlf: _this.state.Slagtlf === '' ? null : _this.state.Slagtlf
                };
                if (_this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) entity.Medlemsnr = _this.state.Medlemsnr;

                // Check for new pigeon hole.
                if (_this.state.Slagnr !== '') {
                    var pigeonHole = _this.props.admin.pigeonHoles.find(function (hole) {
                        return hole.Foreningsnr === _this.state.Foreningsnr && hole.Slagnr === _this.state.Slagnr;
                    }) || null;
                    if (pigeonHole === null) {
                        var club = _this.props.admin.clubs.find(function (club) {
                            return club.Foreningsnr === _this.state.Foreningsnr;
                        }) || null;
                        pigeonHole = club === null ? null : club.UpdateRequests.find(function (req) {
                            return req.type === 'pigeonhole' && req.newKey === _this.state.Slagnr;
                        }) || null;
                    }
                    if (pigeonHole === null) (0, _confirmDialog.confirm)("Opret slag", _react2.default.createElement(
                        'span',
                        null,
                        'Slag ',
                        _react2.default.createElement(
                            'b',
                            null,
                            _this.state.Slagnr
                        ),
                        ' er ikke oprettet i forening ',
                        _react2.default.createElement(
                            'b',
                            null,
                            _this.state.Foreningsnr
                        ),
                        '. \xD8nsker du at oprette slaget?'
                    ), function () {
                        entity.OpretSlag = true;
                        if (_this.props.member === null) _this.props.dispatch(AdminActions.createMember(entity, onSuccess));else _this.props.dispatch(AdminActions.updateMember(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + (typeof _this.props.member.Medlemsnr === 'undefined' ? _this.props.newMemberNumber : _this.props.member.Medlemsnr), entity, onSuccess));
                    });else {
                        if (_this.props.member === null) _this.props.dispatch(AdminActions.createMember(entity, onSuccess));else _this.props.dispatch(AdminActions.updateMember(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + (typeof _this.props.member.Medlemsnr === 'undefined' ? _this.props.newMemberNumber : _this.props.member.Medlemsnr), entity, onSuccess));
                    }
                } else {
                    if (_this.props.member === null) _this.props.dispatch(AdminActions.createMember(entity, onSuccess));else _this.props.dispatch(AdminActions.updateMember(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + (typeof _this.props.member.Medlemsnr === 'undefined' ? _this.props.newMemberNumber : _this.props.member.Medlemsnr), entity, onSuccess));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(MemberGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.club === null && this.props.club !== null || nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr) || nextProps.member === null && this.props.member !== null || nextProps.member !== null && (this.props.member === null || this.props.member.Medlemsnr !== nextProps.member.Medlemsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.member === null) return Object.assign({}, defaultState, {
                Foreningsnr: props.club && props.club.Foreningsnr !== null ? props.club.Foreningsnr : ''
            });else {
                var club = props.club;
                var member = props.member;
                var updateReq = props.isNew || club === null ? null : club.UpdateRequests.find(function (req) {
                    return req.type === 'member' && req.key === props.member.Medlemsnr;
                }) || null;
                var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
                var forenNr = isUndefined(updates.Foreningsnr) ? isUndefined(member.Foreningsnr) || member.Foreningsnr === null ? '' : member.Foreningsnr : updates.Foreningsnr === null ? '' : updates.Foreningsnr;
                var slagNr = isUndefined(updates.Slagnr) ? isUndefined(member.Slagnr) || member.Slagnr === null ? '' : member.Slagnr : updates.Slagnr === null ? '' : updates.Slagnr;
                var slagNavn = '';
                if (forenNr !== '' && slagNr !== '') {
                    var pigeonHole = club === null ? null : club.UpdateRequests.find(function (req) {
                        return req.type === 'pigeonhole' && req.key === slagNr;
                    }) || null;
                    if (pigeonHole !== null && pigeonHole.updates !== null && typeof JSON.parse(pigeonHole.updates).Slagnavn !== 'undefined') slagNavn = JSON.parse(pigeonHole.updates).Slagnavn === null ? '' : JSON.parse(pigeonHole.updates).Slagnavn;else {
                        pigeonHole = props.admin.pigeonHoles.find(function (hole) {
                            return hole.Foreningsnr === forenNr && hole.Slagnr === slagNr;
                        }) || null;
                        if (pigeonHole === null) {
                            pigeonHole = club === null ? null : club.UpdateRequests.find(function (req) {
                                return req.type === 'pigeonhole' && req.newKey === slagNr;
                            }) || null;
                            if (pigeonHole !== null && pigeonHole.updates !== null && typeof JSON.parse(pigeonHole.updates).Slagnavn !== 'undefined') slagNavn = JSON.parse(pigeonHole.updates).Slagnavn === null ? '' : JSON.parse(pigeonHole.updates).Slagnavn;
                        } else slagNavn = pigeonHole.Slagnavn === null ? '' : pigeonHole.Slagnavn;
                    }
                }
                return {
                    Foreningsnr: forenNr,
                    Medlemsnr: isUndefined(member.Medlemsnr) || member.Medlemsnr === null ? '' : member.Medlemsnr,
                    Efternavn: isUndefined(updates.Efternavn) ? isUndefined(member.Efternavn) || member.Efternavn === null ? '' : member.Efternavn : updates.Efternavn === null ? '' : updates.Efternavn,
                    Fornavn: isUndefined(updates.Fornavn) ? isUndefined(member.Fornavn) || member.Fornavn === null ? '' : member.Fornavn : updates.Fornavn === null ? '' : updates.Fornavn,
                    Kontaktnavn: isUndefined(updates.Kontaktnavn) ? isUndefined(member.Kontaktnavn) || member.Kontaktnavn === null ? '' : member.Kontaktnavn : updates.Kontaktnavn === null ? '' : updates.Kontaktnavn,
                    C_O_adresse: isUndefined(updates.C_O_adresse) ? isUndefined(member.C_O_adresse) || member.C_O_adresse === null ? '' : member.C_O_adresse : updates.C_O_adresse === null ? '' : updates.C_O_adresse,
                    Adr: isUndefined(updates.Adr) ? isUndefined(member.Adr) || member.Adr === null ? '' : member.Adr : updates.Adr === null ? '' : updates.Adr,
                    Husnr: isUndefined(updates.Husnr) ? isUndefined(member.Husnr) || member.Husnr === null ? '' : String(member.Husnr) : updates.Husnr === null ? '' : String(updates.Husnr),
                    Husbogstav: isUndefined(updates.Husbogstav) ? isUndefined(member.Husbogstav) || member.Husbogstav === null ? '' : member.Husbogstav : updates.Husbogstav === null ? '' : updates.Husbogstav,
                    Etage: isUndefined(updates.Etage) ? isUndefined(member.Etage) || member.Etage === null ? '' : member.Etage : updates.Etage === null ? '' : updates.Etage,
                    Placering: isUndefined(updates.Placering) ? isUndefined(member.Placering) || member.Placering === null ? '' : member.Placering : updates.Placering === null ? '' : updates.Placering,
                    Postboks: isUndefined(updates.Postboks) ? isUndefined(member.Postboks) || member.Postboks === null ? '' : String(member.Postboks) : updates.Postboks === null ? '' : String(updates.Postboks),
                    Postnr: isUndefined(updates.Postnr) ? isUndefined(member.Postnr) || member.Postnr === null ? '' : member.Postnr : updates.Postnr === null ? '' : updates.Postnr,
                    Tlf: isUndefined(updates.Tlf) ? isUndefined(member.Tlf) || member.Tlf === null ? '' : member.Tlf : updates.Tlf === null ? '' : updates.Tlf,
                    Email: isUndefined(updates.Email) ? isUndefined(member.Email) || member.Email === null ? '' : member.Email : updates.Email === null ? '' : updates.Email,
                    Slagnr: slagNr,
                    Slagnavn: slagNavn,
                    Slagadr: isUndefined(updates.Slagadr) ? isUndefined(member.Slagadr) || member.Slagadr === null ? '' : member.Slagadr : updates.Slagadr === null ? '' : updates.Slagadr,
                    Slagtlf: isUndefined(updates.Slagtlf) ? isUndefined(member.Slagtlf) || member.Slagtlf === null ? '' : member.Slagtlf : updates.Slagtlf === null ? '' : updates.Slagtlf
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var updateReq = this.props.isNew || this.props.club === null || this.props.member === null ? null : this.props.club.UpdateRequests.find(function (req) {
                return req.type === 'member' && req.key === _this2.props.member.Medlemsnr;
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            var editMode = this.props.editMode;
            var club = this.state.Foreningsnr === '' ? null : this.props.admin.clubs.get(this.state.Foreningsnr) || null;
            var pigeonHoleName = null;
            if (club !== null) {
                var pigeonHoleUpdates = club.UpdateRequests.find(function (req) {
                    return req.type === 'pigeonhole' && req.key === _this2.state.Slagnr;
                }) || null;
                if (pigeonHoleUpdates !== null) {
                    var holeUpdates = pigeonHoleUpdates.updates === null ? {} : JSON.parse(pigeonHoleUpdates.updates);
                    if (typeof holeUpdates.Slagnavn !== 'undefined') {
                        updates.Slagnavn = holeUpdates.Slagnavn;
                        var pigeonHole = this.props.admin.pigeonHoles.get(this.state.Foreningsnr + '-' + this.state.Slagnr) || null;
                        if (pigeonHole !== null) pigeonHoleName = pigeonHole.Slagnavn;
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                { className: "form-page member-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Foreningsnr' },
                                        'Foreningsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                editMode && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Foreningsnr,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onClubNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Foreningsnr
                                ),
                                isUndefined(updates.Foreningsnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Foreningsnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.props.admin.clubs.get(this.state.Foreningsnr) ? this.props.admin.clubs.get(this.state.Foreningsnr).Navn : null
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Medlemsnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Medlemsnr' },
                                        'Medlemsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Medlemsnr) ? "" : " updated") },
                                editMode && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Medlemsnr', id: 'Medlemsnr', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Medlemsnr,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Medlemsnr
                                ),
                                isUndefined(updates.Medlemsnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Medlemsnr) + ')'
                                )]
                            ),
                            _react2.default.createElement('td', null),
                            _react2.default.createElement('td', null)
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Fornavn) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Fornavn' },
                                        'Fornavn'
                                    ),
                                    '/',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Efternavn' },
                                        'Efternavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3 },
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Fornavn) ? "" : " updated"), style: { width: '50%' } },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                                    name: 'Fornavn', id: 'Fornavn', maxLength: '20', value: this.state.Fornavn,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Fornavn
                                                ),
                                                isUndefined(updates.Fornavn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Fornavn) + ')'
                                                )]
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Efternavn) ? "" : " updated"), style: { width: '50%' } },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                                    name: 'Efternavn', id: 'Efternavn', maxLength: '20', value: this.state.Efternavn,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[3] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Efternavn
                                                ),
                                                isUndefined(updates.Efternavn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Efternavn) + ')'
                                                )]
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Kontaktnavn) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kontaktnavn' },
                                        'Kontaktnavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Kontaktnavn) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Kontaktnavn', id: 'Kontaktnavn', maxLength: '40', value: this.state.Kontaktnavn,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kontaktnavn
                                ),
                                isUndefined(updates.Kontaktnavn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Kontaktnavn) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.C_O_adresse) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'C_O_adresse' },
                                        'CO/Stednavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.C_O_adresse) ? "" : " updated"), colSpan: 2 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'C_O_adresse', id: 'C_O_adresse', maxLength: '34', value: this.state.C_O_adresse,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.C_O_adresse
                                ),
                                isUndefined(updates.C_O_adresse) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.C_O_adresse) + ')'
                                )]
                            ),
                            _react2.default.createElement('td', null)
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Adr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Adr' },
                                        'Gade'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Adr) ? "" : " updated"), colSpan: 2 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Adr', id: 'Adr', maxLength: '34', value: this.state.Adr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Adr
                                ),
                                isUndefined(updates.Adr) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Adr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    { className: 'field-list-sub-table address-fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            { className: 'label-row' },
                                            _react2.default.createElement(
                                                'td',
                                                { className: "label-cell" + (isUndefined(updates.Husnr) ? "" : " updated") },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'label-text' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'Husnr' },
                                                        'Husnr'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "label-cell" + (isUndefined(updates.Husbogstav) ? "" : " updated") },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'label-text' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'Husbogstav' },
                                                        'Bogstav'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "label-cell" + (isUndefined(updates.Etage) ? "" : " updated") },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'label-text' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'Etage' },
                                                        'Etage'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "label-cell" + (isUndefined(updates.Placering) ? "" : " updated") },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'label-text' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'Placering' },
                                                        'Plac.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "label-cell" + (isUndefined(updates.Postboks) ? "" : " updated") },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'label-text' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'Postboks' },
                                                        'Postboks'
                                                    )
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            { className: 'field-row' },
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Husnr) ? "" : " updated") },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field',
                                                    name: 'Husnr', id: 'Husnr', maxLength: '6', value: this.state.Husnr,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[7] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Husnr
                                                ),
                                                isUndefined(updates.Husnr) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (this.props.member.Husnr === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.member.Husnr)) + ')'
                                                )]
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Husbogstav) ? "" : " updated") },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 very-small-field',
                                                    name: 'Husbogstav', id: 'Husbogstav', maxLength: '1', value: this.state.Husbogstav,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[8] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Husbogstav
                                                ),
                                                isUndefined(updates.Husbogstav) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Husbogstav) + ')'
                                                )]
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Etage) ? "" : " updated") },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', title: 'kl, mz, st eller etagenummer',
                                                    name: 'Etage', id: 'Etage', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "kl|mz|st|[0-9]{1,2}" }], value: this.state.Etage,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true, errorMessageOverride: 'Tilladte v\xE6rdier er kl, mz, st eller et tal',
                                                    onChange: this.onLowerCaseFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[9] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Etage
                                                ),
                                                isUndefined(updates.Etage) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Etage) + ')'
                                                )]
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Placering) ? "" : " updated") },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', title: 'tv, th eller mf',
                                                    name: 'Placering', id: 'Placering', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "tv|th|mf" }], value: this.state.Placering,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true, errorMessageOverride: 'Tilladte v\xE6rdier er tv, th eller mf',
                                                    onChange: this.onLowerCaseFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[10] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Placering
                                                ),
                                                isUndefined(updates.Placering) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Placering) + ')'
                                                )]
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: "data-cell" + (isUndefined(updates.Postboks) ? "" : " updated") },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field',
                                                    name: 'Postboks', id: 'Postboks', maxLength: '6', value: this.state.Postboks,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[11] = instance;
                                                    }
                                                }) : _react2.default.createElement(
                                                    'span',
                                                    { className: 'value-text' },
                                                    this.state.Postboks
                                                ),
                                                isUndefined(updates.Postboks) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                                    'span',
                                                    { className: 'original-value', key: 'original' },
                                                    '(' + (this.props.member.Postboks === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.member.Postboks)) + ')'
                                                )]
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Postnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Postnr' },
                                        'Postnr/By'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Postnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Postnr', id: 'Postnr', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: this.state.Postnr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[12] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Postnr
                                ),
                                isUndefined(updates.Postnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'value-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Postnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.props.admin.zipCodes.get(this.state.Postnr) ? this.props.admin.zipCodes.get(this.state.Postnr).By : null
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Tlf) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Tlf' },
                                        'Telefon'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Tlf) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Tlf', id: 'Tlf', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{8}" }], value: this.state.Tlf,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[13] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Tlf
                                ),
                                isUndefined(updates.Tlf) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Tlf) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Email) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Email' },
                                        'Email'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Email) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Email', id: 'Email', maxLength: '50', value: this.state.Email,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[14] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Email
                                ),
                                isUndefined(updates.Email) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Email) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagnr' },
                                        'Slagnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Slagnr', id: 'Slagnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Slagnr,
                                    autoCheckErrors: true, required: this.state.Slagnavn !== '', hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onPigeonHoleNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[15] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagnr
                                ),
                                isUndefined(updates.Slagnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Slagnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagnavn) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagnavn' },
                                        'Slagnavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagnavn) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Slagnavn', id: 'Slagnavn', maxLength: '50', value: this.state.Slagnavn,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[16] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagnavn
                                ),
                                isUndefined(updates.Slagnavn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(pigeonHoleName) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagtlf) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagtlf' },
                                        'Slagtelefon'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagtlf) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Slagtlf', id: 'Slagtlf', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{8}" }], value: this.state.Slagtlf,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[17] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagtlf
                                ),
                                isUndefined(updates.Slagtlf) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Slagtlf) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagadr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagadr' },
                                        'Slagadresse'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagadr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Slagadr', id: 'Slagadr', maxLength: '50', value: this.state.Slagadr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[18] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagadr
                                ),
                                isUndefined(updates.Slagadr) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Slagadr) + ')'
                                )]
                            )
                        )
                    )
                )
            );
        }
    }]);

    return MemberGeneral;
}(_react2.default.Component);

MemberGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    club: _propTypes2.default.object,
    member: _propTypes2.default.object,
    isNew: _propTypes2.default.bool,
    newMemberNumber: _propTypes2.default.string
};
MemberGeneral.defaultProps = {
    editMode: false,
    isNew: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            pigeonHoles: state.admin.pigeonHoles,
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(MemberGeneral);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _reactNotifications = __webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var margin = '50px';
var sectionWidth = '40%';
var buttonWidth = '80%';
var headerHeight = '60px';
var footerHeight = '60px';

var StationSelection = function (_React$Component) {
    _inherits(StationSelection, _React$Component);

    function StationSelection(props) {
        _classCallCheck(this, StationSelection);

        var _this = _possibleConstructorReturn(this, (StationSelection.__proto__ || Object.getPrototypeOf(StationSelection)).call(this, props));

        _this.loadStations = function (newestProps) {
            newestProps.dispatch(AdminActions.getStationSelections(newestProps.targetId));
            _this.setState({
                viewMode: /^[0-9]{3}$/.test(newestProps.targetId) ? '3' : /^[0-9]{2}$/.test(newestProps.targetId) ? '2' : /^[0-9]$/.test(newestProps.targetId) ? '1' : '0'
            });
        };

        _this.state = {
            selectedStations: [],
            selectedSelections: [],
            viewMode: '0' // 0: country wide selections, 1: group selections, 2: section selections, 3: club selections.
        };
        return _this;
    }

    _createClass(StationSelection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadStations(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.targetId !== nextProps.targetId) this.loadStations(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var viewModes = [{ key: '0', value: 'hele landet' }];
            var groupId = null;
            var sectionId = null;
            var clubId = null;
            if (/^[0-9]{3}$/.test(this.props.targetId)) {
                clubId = this.props.targetId;
                var club = this.props.admin.clubs.get(this.props.targetId) || null;
                if (club !== null) {
                    groupId = club.Sektionsnr.substr(0, 1);
                    sectionId = club.Sektionsnr;
                    viewModes.push({ key: '1', value: 'sektionsgruppe ' + club.Sektionsnr.substr(0, 1) });
                    viewModes.push({ key: '2', value: 'sektion ' + club.Sektionsnr });
                }
                viewModes.push({ key: '3', value: 'forening ' + this.props.targetId + (club !== null && club.Navn !== null ? ' (' + club.Navn + ')' : '') });
            } else if (/^[0-9]{2}$/.test(this.props.targetId)) {
                groupId = this.props.targetId.substr(0, 1);
                sectionId = this.props.targetId;
                viewModes.push({ key: '1', value: 'sektionsgruppe ' + this.props.targetId.substr(0, 1) });
                viewModes.push({ key: '2', value: 'sektion ' + this.props.targetId });
            } else if (/^[0-9]$/.test(this.props.targetId)) {
                groupId = this.props.targetId;
                viewModes.push({ key: '1', value: 'sektionsgruppe ' + this.props.targetId });
            }
            var allStations = this.props.admin.stations.toArray();
            var filteredSelections = this.props.admin.stationSelections.filter(function (selection) {
                return allStations.findIndex(function (station) {
                    return station.Stationsnr === selection.station;
                }) >= 0 && (selection.target === 'A' || _this2.state.viewMode >= '1' && groupId !== null && selection.target === groupId || _this2.state.viewMode >= '2' && sectionId !== null && selection.target === sectionId || _this2.state.viewMode >= '3' && clubId !== null && selection.target === clubId);
            }).toArray();
            var selectedStations = filteredSelections.filter(function (selection, ix) {
                return filteredSelections.findIndex(function (selection2) {
                    return selection2.station === selection.station;
                }) === ix;
            }).map(function (station) {
                return {
                    Stationsnr: station.station,
                    Navn: allStations[allStations.findIndex(function (station2) {
                        return station2.Stationsnr === station.station;
                    })].Navn,
                    Levels: filteredSelections.filter(function (selection) {
                        return selection.station === station.station;
                    }).map(function (selection) {
                        return selection.target === 'A' ? 0 : selection.target === groupId ? 1 : selection.target === sectionId ? 2 : 3;
                    }).sort(function (l1, l2) {
                        return l1 - l2;
                    }).map(function (lvl) {
                        return String(lvl);
                    })
                };
            });
            return _react2.default.createElement(
                'div',
                { style: { position: 'absolute', top: margin, left: margin, bottom: margin, right: margin } },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'viewMode' },
                        'Stationsvalg for'
                    ),
                    ' ',
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: false, className: 'field450', containerClassName: 'display-inline-block',
                        name: 'viewMode', id: 'viewMode', value: this.state.viewMode, options: viewModes,
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            _this2.setState({
                                viewMode: e.target.value,
                                selectedStations: [],
                                selectedSelections: []
                            });
                        }
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { style: { position: 'absolute', top: headerHeight, bottom: footerHeight, left: 0, right: 0 } },
                    _react2.default.createElement(
                        'div',
                        { style: { position: 'absolute', top: 0, bottom: 0, left: 0, width: sectionWidth, overflow: 'auto' } },
                        _react2.default.createElement(
                            'table',
                            { className: 'row-clickable' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                allStations.sort(function (s1, s2) {
                                    if (s1.Navn < s2.Navn) return -1;
                                    if (s1.Navn > s2.Navn) return 1;
                                    if (s1.Stationsnr < s2.Stationsnr) return -1;
                                    if (s1.Stationsnr > s2.Stationsnr) return 1;
                                    return 0;
                                }).map(function (station) {
                                    var ix = _this2.state.selectedStations.indexOf(station.Stationsnr);
                                    var selectedIx = selectedStations.findIndex(function (station2) {
                                        return station2.Stationsnr === station.Stationsnr;
                                    });
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: station.Stationsnr, className: selectedIx >= 0 && selectedStations[selectedIx].Levels.indexOf(_this2.state.viewMode) >= 0 ? 'disabled' : '', onClick: function onClick() {
                                                if (selectedIx < 0 || selectedStations[selectedIx].Levels.indexOf(_this2.state.viewMode) < 0) {
                                                    if (ix < 0) _this2.state.selectedStations.push(station.Stationsnr);else _this2.state.selectedStations.splice(ix, 1);
                                                    _this2.forceUpdate();
                                                }
                                            } },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { type: 'checkbox', checked: ix >= 0, disabled: selectedIx >= 0 && selectedStations[selectedIx].Levels.indexOf(_this2.state.viewMode) >= 0, onChange: function onChange() {
                                                    //if (ix < 0) this.state.selectedStations.push(station.Stationsnr);
                                                    //else this.state.selectedStations.splice(ix, 1);
                                                    //this.forceUpdate();
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            station.Stationsnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            station.Navn
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            selectedIx < 0 ? null : selectedStations[selectedIx].Levels.map(function (lvl) {
                                                return lvl === '0' ? 'A' : lvl === '1' ? 'G' : lvl === '2' ? 'S' : 'F';
                                            }).join('')
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: { position: 'absolute', top: 0, bottom: 0, left: sectionWidth, right: sectionWidth } },
                        _react2.default.createElement(
                            'div',
                            { style: { width: '100%', textAlign: 'center', position: 'absolute', top: '50%', transform: 'translateY(-50%)' } },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', disabled: this.state.selectedStations.length < 1, style: { width: buttonWidth }, onClick: function onClick() {
                                            _this2.props.dispatch(AdminActions.selectStations(_this2.state.viewMode === '0' ? 'A' : _this2.state.viewMode === '1' ? groupId : _this2.state.viewMode === '2' ? sectionId : clubId, _this2.state.selectedStations, function () {
                                                _reactNotifications.NotificationManager.success("De markerede stationer er udvalgt til " + (_this2.state.viewMode === '0' ? 'alle foreninger' : _this2.state.viewMode === '1' ? 'gruppe ' + groupId : _this2.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId) + ".", "Tilvalg", 4000);
                                                _this2.setState({
                                                    selectedStations: [],
                                                    selectedSelections: _this2.state.selectedStations
                                                });
                                            }));
                                        } },
                                    'Tilf\xF8j'
                                )
                            ),
                            _react2.default.createElement('div', { style: { height: '25px' } }),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-secondary', disabled: this.state.selectedSelections.length < 1, style: { width: buttonWidth }, onClick: function onClick() {
                                            _this2.props.dispatch(AdminActions.unselectStations(_this2.state.viewMode === '0' ? 'A' : _this2.state.viewMode === '1' ? groupId : _this2.state.viewMode === '2' ? sectionId : clubId, _this2.state.selectedSelections, function () {
                                                _reactNotifications.NotificationManager.success("De markerede stationer er fravalgt " + (_this2.state.viewMode === '0' ? 'alle foreninger' : _this2.state.viewMode === '1' ? 'gruppe ' + groupId : _this2.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId) + ".", "Fravalg", 4000);
                                                _this2.setState({
                                                    selectedStations: _this2.state.selectedSelections,
                                                    selectedSelections: []
                                                });
                                            }));
                                        } },
                                    'Fjern'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: { position: 'absolute', top: 0, bottom: 0, right: 0, width: sectionWidth, overflow: 'auto' } },
                        _react2.default.createElement(
                            'table',
                            { className: 'row-clickable' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                selectedStations.sort(function (s1, s2) {
                                    if (s1.Navn < s2.Navn) return -1;
                                    if (s1.Navn > s2.Navn) return 1;
                                    if (s1.Stationsnr < s2.Stationsnr) return -1;
                                    if (s1.Stationsnr > s2.Stationsnr) return 1;
                                    return 0;
                                }).map(function (station) {
                                    var ix = _this2.state.selectedSelections.indexOf(station.Stationsnr);
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: station.Stationsnr, className: station.Levels.indexOf(_this2.state.viewMode) < 0 ? 'disabled' : '', onClick: function onClick() {
                                                if (station.Levels.indexOf(_this2.state.viewMode) >= 0) {
                                                    if (ix < 0) _this2.state.selectedSelections.push(station.Stationsnr);else _this2.state.selectedSelections.splice(ix, 1);
                                                    _this2.forceUpdate();
                                                }
                                            } },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { type: 'checkbox', checked: ix >= 0, disabled: station.Levels.indexOf(_this2.state.viewMode) < 0, onChange: function onChange() {
                                                    //if (ix < 0) this.state.selectedSelections.push(station.Stationsnr);
                                                    //else this.state.selectedSelections.splice(ix, 1);
                                                    //this.forceUpdate();
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            station.Stationsnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            station.Navn
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            station.Levels.map(function (lvl) {
                                                return lvl === '0' ? 'A' : lvl === '1' ? 'G' : lvl === '2' ? 'S' : 'F';
                                            }).join('')
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { style: { position: 'absolute', bottom: 0, left: 0, right: 0, height: footerHeight } },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn-primary', style: { position: 'absolute', bottom: 0, left: 0, width: sectionWidth }, onClick: function onClick() {
                                _this2.props.dispatch(AdminActions.calculateDistances(_this2.state.viewMode === '0' ? 'A' : _this2.state.viewMode === '1' ? groupId : _this2.state.viewMode === '2' ? sectionId : clubId, function () {
                                    _reactNotifications.NotificationManager.success("Afstande er genberegnet for " + (_this2.state.viewMode === '0' ? 'alle foreninger' : _this2.state.viewMode === '1' ? 'gruppe ' + groupId : _this2.state.viewMode === '2' ? 'sektion ' + sectionId : 'forening ' + clubId) + ".", "Genberegning", 4000);
                                }));
                            } },
                        'Beregn afstande for ',
                        this.state.viewMode === '0' ? 'alle foreninger' : this.state.viewMode === '1' ? 'gruppen' : this.state.viewMode === '2' ? 'sektionen' : 'foreningen'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn-secondary', style: { position: 'absolute', bottom: 0, right: 0, width: sectionWidth }, onClick: function onClick() {
                                _this2.props.dispatch(AdminActions.calculateDistances('A', function () {
                                    _reactNotifications.NotificationManager.success("Afstande er genberegnet for alle foreninger.", "Genberegning", 4000);
                                }));
                            } },
                        'Beregn afstande for alle foreninger'
                    )
                )
            );
        }
    }]);

    return StationSelection;
}(_react2.default.Component);

StationSelection.propTypes = {
    targetId: _propTypes2.default.string // Section (two digits) or club (three digits) number
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            clubNumber: state.auth.clubNumber,
            isClubAdmin: state.auth.isClubAdmin,
            isMainAdmin: state.auth.isMainAdmin
        },
        admin: {
            clubs: state.admin.clubs,
            stations: state.admin.stations,
            stationSelections: state.admin.stationSelections
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(StationSelection);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Flatten n-dimensional array to 1-dimensional array. Taken from https://stackoverflow.com/a/15030117.
var flatten = exports.flatten = function flatten(arr) {
    return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(389);
__webpack_require__(390);
module.exports = __webpack_require__(592);


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function(window){'use strict';
  /* jshint loopfunc: true, noempty: false*/
  // http://www.w3.org/TR/dom/#element

  function createDocumentFragment() {
    return document.createDocumentFragment();
  }

  function createElement(nodeName) {
    return document.createElement(nodeName);
  }

  function enoughArguments(length, name) {
    if (!length) throw new Error(
      'Failed to construct ' +
        name +
      ': 1 argument required, but only 0 present.'
    );
  }

  function mutationMacro(nodes) {
    if (nodes.length === 1) {
      return textNodeIfPrimitive(nodes[0]);
    }
    for (var
      fragment = createDocumentFragment(),
      list = slice.call(nodes),
      i = 0; i < nodes.length; i++
    ) {
      fragment.appendChild(textNodeIfPrimitive(list[i]));
    }
    return fragment;
  }

  function textNodeIfPrimitive(node) {
    return typeof node === 'object' ? node : document.createTextNode(node);
  }

  for(var
    head,
    property,
    TemporaryPrototype,
    TemporaryTokenList,
    wrapVerifyToken,
    document = window.document,
    hOP = Object.prototype.hasOwnProperty,
    defineProperty = Object.defineProperty || function (object, property, descriptor) {
      if (hOP.call(descriptor, 'value')) {
        object[property] = descriptor.value;
      } else {
        if (hOP.call(descriptor, 'get'))
          object.__defineGetter__(property, descriptor.get);
        if (hOP.call(descriptor, 'set'))
          object.__defineSetter__(property, descriptor.set);
      }
      return object;
    },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    // http://www.w3.org/TR/domcore/#domtokenlist
    verifyToken = function (token) {
      if (!token) {
        throw 'SyntaxError';
      } else if (spaces.test(token)) {
        throw 'InvalidCharacterError';
      }
      return token;
    },
    DOMTokenList = function (node) {
      var
        noClassName = typeof node.className === 'undefined',
        className = noClassName ?
          (node.getAttribute('class') || '') : node.className,
        isSVG = noClassName || typeof className === 'object',
        value = (isSVG ?
          (noClassName ? className : className.baseVal) :
          className
        ).replace(trim, '')
      ;
      if (value.length) {
        properties.push.apply(
          this,
          value.split(spaces)
        );
      }
      this._isSVG = isSVG;
      this._ = node;
    },
    classListDescriptor = {
      get: function get() {
        return new DOMTokenList(this);
      },
      set: function(){}
    },
    trim = /^\s+|\s+$/g,
    spaces = /\s+/,
    SPACE = '\x20',
    CLASS_LIST = 'classList',
    toggle = function toggle(token, force) {
      if (this.contains(token)) {
        if (!force) {
          // force is not true (either false or omitted)
          this.remove(token);
        }
      } else if(force === undefined || force) {
        force = true;
        this.add(token);
      }
      return !!force;
    },
    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
    Node = window.Node,
    NodePrototype = (Node || Element).prototype,
    CharacterData = window.CharacterData || Node,
    CharacterDataPrototype = CharacterData && CharacterData.prototype,
    DocumentType = window.DocumentType,
    DocumentTypePrototype = DocumentType && DocumentType.prototype,
    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
    selectRemove = HTMLSelectElement.prototype.remove,
    SVGElement = window.SVGElement,
    properties = [
      'matches', (
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.khtmlMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.oMatchesSelector ||
        function matches(selector) {
          var parentNode = this.parentNode;
          return !!parentNode && -1 < indexOf.call(
            parentNode.querySelectorAll(selector),
            this
          );
        }
      ),
      'closest', function closest(selector) {
        var parentNode = this, matches;
        while (
          // document has no .matches
          (matches = parentNode && parentNode.matches) &&
          !parentNode.matches(selector)
        ) {
          parentNode = parentNode.parentNode;
        }
        return matches ? parentNode : null;
      },
      'prepend', function prepend() {
        var firstChild = this.firstChild,
            node = mutationMacro(arguments);
        if (firstChild) {
          this.insertBefore(node, firstChild);
        } else {
          this.appendChild(node);
        }
      },
      'append', function append() {
        this.appendChild(mutationMacro(arguments));
      },
      'before', function before() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.insertBefore(
            mutationMacro(arguments), this
          );
        }
      },
      'after', function after() {
        var parentNode = this.parentNode,
            nextSibling = this.nextSibling,
            node = mutationMacro(arguments);
        if (parentNode) {
          if (nextSibling) {
            parentNode.insertBefore(node, nextSibling);
          } else {
            parentNode.appendChild(node);
          }
        }
      },
      // https://dom.spec.whatwg.org/#dom-element-toggleattribute
      'toggleAttribute', function toggleAttribute(name, force) {
        var had = this.hasAttribute(name);
        if (1 < arguments.length) {
          if (had && !force)
            this.removeAttribute(name);
          else if (force && !had)
            this.setAttribute(name, "");
        }
        else if (had)
          this.removeAttribute(name);
        else
          this.setAttribute(name, "");
        return this.hasAttribute(name);
      },
      // WARNING - DEPRECATED - use .replaceWith() instead
      'replace', function replace() {
        this.replaceWith.apply(this, arguments);
      },
      'replaceWith', function replaceWith() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.replaceChild(
            mutationMacro(arguments),
            this
          );
        }
      },
      'remove', function remove() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.removeChild(this);
        }
      }
    ],
    slice = properties.slice,
    i = properties.length; i; i -= 2
  ) {
    property = properties[i - 2];
    if (!(property in ElementPrototype)) {
      ElementPrototype[property] = properties[i - 1];
    }
    // avoid unnecessary re-patch when the script is included
    // gazillion times without any reason whatsoever
    // https://github.com/WebReflection/dom4/pull/48
    if (property === 'remove' && !selectRemove._dom4) {
      // see https://github.com/WebReflection/dom4/issues/19
      (HTMLSelectElement.prototype[property] = function () {
        return 0 < arguments.length ?
          selectRemove.apply(this, arguments) :
          ElementPrototype.remove.call(this);
      })._dom4 = true;
    }
    // see https://github.com/WebReflection/dom4/issues/18
    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
      if (CharacterData && !(property in CharacterDataPrototype)) {
        CharacterDataPrototype[property] = properties[i - 1];
      }
      if (DocumentType && !(property in DocumentTypePrototype)) {
        DocumentTypePrototype[property] = properties[i - 1];
      }
    }
    // see https://github.com/WebReflection/dom4/pull/26
    if (/^(?:append|prepend)$/.test(property)) {
      if (DocumentFragmentPrototype) {
        if (!(property in DocumentFragmentPrototype)) {
          DocumentFragmentPrototype[property] = properties[i - 1];
        }
      } else {
        try {
          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
        } catch(o_O) {}
      }
    }
  }

  // most likely an IE9 only issue
  // see https://github.com/WebReflection/dom4/issues/6
  if (!createElement('a').matches('a')) {
    ElementPrototype[property] = function(matches){
      return function (selector) {
        return matches.call(
          this.parentNode ?
            this :
            createDocumentFragment().appendChild(this),
          selector
        );
      };
    }(ElementPrototype[property]);
  }

  // used to fix both old webkit and SVG
  DOMTokenList.prototype = {
    length: 0,
    add: function add() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(!this.contains(token)) {
          properties.push.call(this, property);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    contains: (function(indexOf){
      return function contains(token) {
        i = indexOf.call(this, property = verifyToken(token));
        return -1 < i;
      };
    }([].indexOf || function (token) {
      i = this.length;
      while(i-- && this[i] !== token){}
      return i;
    })),
    item: function item(i) {
      return this[i] || null;
    },
    remove: function remove() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(this.contains(token)) {
          properties.splice.call(this, i, 1);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    toggle: toggle,
    toString: function toString() {
      return properties.join.call(this, SPACE);
    }
  };

  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
  }

  // http://www.w3.org/TR/dom/#domtokenlist
  // iOS 5.1 has completely screwed this property
  // classList in ElementPrototype is false
  // but it's actually there as getter
  if (!(CLASS_LIST in document.documentElement)) {
    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
  } else {
    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
    // trying to detect and fix that in here
    TemporaryTokenList = createElement('div')[CLASS_LIST];
    TemporaryTokenList.add('a', 'b', 'a');
    if ('a\x20b' != TemporaryTokenList) {
      // no other way to reach original methods in iOS 5.1
      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
      if (!('add' in TemporaryPrototype)) {
        // ASHA double fails in here
        TemporaryPrototype = window.TemporaryTokenList.prototype;
      }
      wrapVerifyToken = function (original) {
        return function () {
          var i = 0;
          while (i < arguments.length) {
            original.call(this, arguments[i++]);
          }
        };
      };
      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
      // toggle is broken too ^_^ ... let's fix it
      TemporaryPrototype.toggle = toggle;
    }
  }

  if (!('contains' in NodePrototype)) {
    defineProperty(NodePrototype, 'contains', {
      value: function (el) {
        while (el && el !== this) el = el.parentNode;
        return this === el;
      }
    });
  }

  if (!('head' in document)) {
    defineProperty(document, 'head', {
      get: function () {
        return head || (
          head = document.getElementsByTagName('head')[0]
        );
      }
    });
  }

  // requestAnimationFrame partial polyfill
  (function () {
    for (var
      raf,
      rAF = window.requestAnimationFrame,
      cAF = window.cancelAnimationFrame,
      prefixes = ['o', 'ms', 'moz', 'webkit'],
      i = prefixes.length;
      !cAF && i--;
    ) {
      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
            window[prefixes[i] + 'CancelRequestAnimationFrame'];
    }
    if (!cAF) {
      // some FF apparently implemented rAF but no cAF 
      if (rAF) {
        raf = rAF;
        rAF = function (callback) {
          var goOn = true;
          raf(function () {
            if (goOn) callback.apply(this, arguments);
          });
          return function () {
            goOn = false;
          };
        };
        cAF = function (id) {
          id();
        };
      } else {
        rAF = function (callback) {
          return setTimeout(callback, 15, 15);
        };
        cAF = function (id) {
          clearTimeout(id);
        };
      }
    }
    window.requestAnimationFrame = rAF;
    window.cancelAnimationFrame = cAF;
  }());

  // http://www.w3.org/TR/dom/#customevent
  try{new window.CustomEvent('?');}catch(o_O){
    window.CustomEvent = function(
      eventName,
      defaultInitDict
    ){

      // the infamous substitute
      function CustomEvent(type, eventInitDict) {
        /*jshint eqnull:true */
        var event = document.createEvent(eventName);
        if (typeof type != 'string') {
          throw new Error('An event name must be provided');
        }
        if (eventName == 'Event') {
          event.initCustomEvent = initCustomEvent;
        }
        if (eventInitDict == null) {
          eventInitDict = defaultInitDict;
        }
        event.initCustomEvent(
          type,
          eventInitDict.bubbles,
          eventInitDict.cancelable,
          eventInitDict.detail
        );
        return event;
      }

      // attached at runtime
      function initCustomEvent(
        type, bubbles, cancelable, detail
      ) {
        /*jshint validthis:true*/
        this.initEvent(type, bubbles, cancelable);
        this.detail = detail;
      }

      // that's it
      return CustomEvent;
    }(
      // is this IE9 or IE10 ?
      // where CustomEvent is there
      // but not usable as construtor ?
      window.CustomEvent ?
        // use the CustomEvent interface in such case
        'CustomEvent' : 'Event',
        // otherwise the common compatible one
      {
        bubbles: false,
        cancelable: false,
        detail: null
      }
    );
  }

  // window.Event as constructor
  try { new Event('_'); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($Event) {
      function Event(type, init) {
        enoughArguments(arguments.length, 'Event');
        var out = document.createEvent('Event');
        if (!init) init = {};
        out.initEvent(
          type,
          !!init.bubbles,
          !!init.cancelable
        );
        return out;
      }
      Event.prototype = $Event.prototype;
      return Event;
    }(window.Event || function Event() {}));
    defineProperty(window, 'Event', {value: o_O});
    // Android 4 gotcha
    if (Event !== o_O) Event = o_O;
  }

  // window.KeyboardEvent as constructor
  try { new KeyboardEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($KeyboardEvent) {
      // code inspired by https://gist.github.com/termi/4654819
      var
        initType = 0,
        defaults = {
          char: '',
          key: '',
          location: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          altGraphKey: false,
          repeat: false,
          locale: navigator.language,
          detail: 0,
          bubbles: false,
          cancelable: false,
          keyCode: 0,
          charCode: 0,
          which: 0
        },
        eventType
      ;
      try {
        var e = document.createEvent('KeyboardEvent');
        e.initKeyboardEvent(
          'keyup', false, false, window, '+', 3,
          true, false, true, false, false
        );
        initType = (
          (e.keyIdentifier || e.key) == '+' &&
          (e.keyLocation || e.location) == 3
        ) && (
          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
        ) || 9;
      } catch(o_O) {}
      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

      function getModifier(init) {
        for (var
          out = [],
          keys = [
            'ctrlKey',
            'Control',
            'shiftKey',
            'Shift',
            'altKey',
            'Alt',
            'metaKey',
            'Meta',
            'altGraphKey',
            'AltGraph'
          ],
          i = 0; i < keys.length; i += 2
        ) {
          if (init[keys[i]])
            out.push(keys[i + 1]);
        }
        return out.join(' ');
      }

      function withDefaults(target, source) {
        for (var key in source) {
          if (
            source.hasOwnProperty(key) &&
            !source.hasOwnProperty.call(target, key)
          ) target[key] = source[key];
        }
        return target;
      }

      function withInitValues(key, out, init) {
        try {
          out[key] = init[key];
        } catch(o_O) {}
      }

      function KeyboardEvent(type, init) {
        enoughArguments(arguments.length, 'KeyboardEvent');
        init = withDefaults(init || {}, defaults);
        var
          out = document.createEvent(eventType),
          ctrlKey = init.ctrlKey,
          shiftKey = init.shiftKey,
          altKey = init.altKey,
          metaKey = init.metaKey,
          altGraphKey = init.altGraphKey,
          modifiers = initType > 3 ? getModifier(init) : null,
          key = String(init.key),
          chr = String(init.char),
          location = init.location,
          keyCode = init.keyCode || (
            (init.keyCode = key) &&
            key.charCodeAt(0)
          ) || 0,
          charCode = init.charCode || (
            (init.charCode = chr) &&
            chr.charCodeAt(0)
          ) || 0,
          bubbles = init.bubbles,
          cancelable = init.cancelable,
          repeat = init.repeat,
          locale = init.locale,
          view = init.view || window,
          args
        ;
        if (!init.which) init.which = init.keyCode;
        if ('initKeyEvent' in out) {
          out.initKeyEvent(
            type, bubbles, cancelable, view,
            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
          );
        } else if (0 < initType && 'initKeyboardEvent' in out) {
          args = [type, bubbles, cancelable, view];
          switch (initType) {
            case 1:
              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
              break;
            case 2:
              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
              break;
            case 3:
              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
              break;
            case 4:
              args.push(key, location, modifiers, repeat, locale);
              break;
            default:
              args.push(char, key, location, modifiers, repeat, locale);
          }
          out.initKeyboardEvent.apply(out, args);
        } else {
          out.initEvent(type, bubbles, cancelable);
        }
        for (key in out) {
          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
            withInitValues(key, out, init);
          }
        }
        return out;
      }
      KeyboardEvent.prototype = $KeyboardEvent.prototype;
      return KeyboardEvent;
    }(window.KeyboardEvent || function KeyboardEvent() {}));
    defineProperty(window, 'KeyboardEvent', {value: o_O});
    // Android 4 gotcha
    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
  }

  // window.MouseEvent as constructor
  try { new MouseEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($MouseEvent) {
      function MouseEvent(type, init) {
        enoughArguments(arguments.length, 'MouseEvent');
        var out = document.createEvent('MouseEvent');
        if (!init) init = {};
        out.initMouseEvent(
          type,
          !!init.bubbles,
          !!init.cancelable,
          init.view || window,
          init.detail || 1,
          init.screenX || 0,
          init.screenY || 0,
          init.clientX || 0,
          init.clientY || 0,
          !!init.ctrlKey,
          !!init.altKey,
          !!init.shiftKey,
          !!init.metaKey,
          init.button || 0,
          init.relatedTarget || null
        );
        return out;
      }
      MouseEvent.prototype = $MouseEvent.prototype;
      return MouseEvent;
    }(window.MouseEvent || function MouseEvent() {}));
    defineProperty(window, 'MouseEvent', {value: o_O});
    // Android 4 gotcha
    if (MouseEvent !== o_O) MouseEvent = o_O;
  }

  if (!document.querySelectorAll('*').forEach) {
    (function () {
      function patch(what) {
        var querySelectorAll = what.querySelectorAll;
        what.querySelectorAll = function qSA(css) {
          var result = querySelectorAll.call(this, css);
          result.forEach = Array.prototype.forEach;
          return result;
        };
      }
      patch(document);
      patch(Element.prototype);
    }());
  }

  try {
    // https://drafts.csswg.org/selectors-4/#the-scope-pseudo
    document.querySelector(':scope *');
  } catch(o_O) {
    (function () {
      var dataScope = 'data-scope-' + (Math.random() * 1e9 >>> 0);
      var proto = Element.prototype;
      var querySelector = proto.querySelector;
      var querySelectorAll = proto.querySelectorAll;
      proto.querySelector = function qS(css) {
        return find(this, querySelector, css);
      };
      proto.querySelectorAll = function qSA(css) {
        return find(this, querySelectorAll, css);
      };
      function find(node, method, css) {
        if (node.type != document.ELEMENT_NODE) return method.call(node, css);
        node.setAttribute(dataScope, null);
        var result = method.call(
          node,
          String(css).replace(
            /(^|,\s*)(:scope([ >]|$))/g,
            function ($0, $1, $2, $3) {
              return $1 + '[' + dataScope + ']' + ($3 || ' ');
            }
          )
        );
        node.removeAttribute(dataScope);
        return result;
      }
    }());
  }
}(window));
(function (global){'use strict';

  // a WeakMap fallback for DOM nodes only used as key
  var DOMMap = global.WeakMap || (function () {

    var
      counter = 0,
      dispatched = false,
      drop = false,
      value
    ;

    function dispatch(key, ce, shouldDrop) {
      drop = shouldDrop;
      dispatched = false;
      value = undefined;
      key.dispatchEvent(ce);
    }

    function Handler(value) {
      this.value = value;
    }

    Handler.prototype.handleEvent = function handleEvent(e) {
      dispatched = true;
      if (drop) {
        e.currentTarget.removeEventListener(e.type, this, false);
      } else {
        value = this.value;
      }
    };

    function DOMMap() {
      counter++;  // make id clashing highly improbable
      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
    }

    DOMMap.prototype = {
      'constructor': DOMMap,
      'delete': function del(key) {
        return dispatch(key, this.__ce__, true), dispatched;
      },
      'get': function get(key) {
        dispatch(key, this.__ce__, false);
        var v = value;
        value = undefined;
        return v;
      },
      'has': function has(key) {
        return dispatch(key, this.__ce__, false), dispatched;
      },
      'set': function set(key, value) {
        dispatch(key, this.__ce__, true);
        key.addEventListener(this.__ce__.type, new Handler(value), false);
        return this;
      },
    };

    return DOMMap;

  }());

  function Dict() {}
  Dict.prototype = (Object.create || Object)(null);

  // https://dom.spec.whatwg.org/#interface-eventtarget

  function createEventListener(type, callback, options) {
    function eventListener(e) {
      if (eventListener.once) {
        e.currentTarget.removeEventListener(
          e.type,
          callback,
          eventListener
        );
        eventListener.removed = true;
      }
      if (eventListener.passive) {
        e.preventDefault = createEventListener.preventDefault;
      }
      if (typeof eventListener.callback === 'function') {
        /* jshint validthis: true */
        eventListener.callback.call(this, e);
      } else if (eventListener.callback) {
        eventListener.callback.handleEvent(e);
      }
      if (eventListener.passive) {
        delete e.preventDefault;
      }
    }
    eventListener.type = type;
    eventListener.callback = callback;
    eventListener.capture = !!options.capture;
    eventListener.passive = !!options.passive;
    eventListener.once = !!options.once;
    // currently pointless but specs say to use it, so ...
    eventListener.removed = false;
    return eventListener;
  }

  createEventListener.preventDefault = function preventDefault() {};

  var
    Event = global.CustomEvent,
    dE = global.dispatchEvent,
    aEL = global.addEventListener,
    rEL = global.removeEventListener,
    counter = 0,
    increment = function () { counter++; },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    getListenerKey = function (options) {
      return ''.concat(
        options.capture ? '1' : '0',
        options.passive ? '1' : '0',
        options.once ? '1' : '0'
      );
    },
    augment
  ;

  try {
    aEL('_', increment, {once: true});
    dE(new Event('_'));
    dE(new Event('_'));
    rEL('_', increment, {once: true});
  } catch(o_O) {}

  if (counter !== 1) {
    (function () {
      var dm = new DOMMap();
      function createAEL(aEL) {
        return function addEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key = getListenerKey(options),
              i, tmp, wrap
            ;
            if (!info) dm.set(this, (info = new Dict()));
            if (!(type in info)) info[type] = {
              handler: [],
              wrap: []
            };
            tmp = info[type];
            i = indexOf.call(tmp.handler, handler);
            if (i < 0) {
              i = tmp.handler.push(handler) - 1;
              tmp.wrap[i] = (wrap = new Dict());
            } else {
              wrap = tmp.wrap[i];
            }
            if (!(key in wrap)) {
              wrap[key] = createEventListener(type, handler, options);
              aEL.call(this, type, wrap[key], wrap[key].capture);
            }
          } else {
            aEL.call(this, type, handler, options);
          }
        };
      }
      function createREL(rEL) {
        return function removeEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key, i, tmp, wrap
            ;
            if (info && (type in info)) {
              tmp = info[type];
              i = indexOf.call(tmp.handler, handler);
              if (-1 < i) {
                key = getListenerKey(options);
                wrap = tmp.wrap[i];
                if (key in wrap) {
                  rEL.call(this, type, wrap[key], wrap[key].capture);
                  delete wrap[key];
                  // return if there are other wraps
                  for (key in wrap) return;
                  // otherwise remove all the things
                  tmp.handler.splice(i, 1);
                  tmp.wrap.splice(i, 1);
                  // if there are no other handlers
                  if (tmp.handler.length === 0)
                    // drop the info[type] entirely
                    delete info[type];
                }
              }
            }
          } else {
            rEL.call(this, type, handler, options);
          }
        };
      }

      augment = function (Constructor) {
        if (!Constructor) return;
        var proto = Constructor.prototype;
        proto.addEventListener = createAEL(proto.addEventListener);
        proto.removeEventListener = createREL(proto.removeEventListener);
      };

      if (global.EventTarget) {
        augment(EventTarget);
      } else {
        augment(global.Text);
        augment(global.Element || global.HTMLElement);
        augment(global.HTMLDocument);
        augment(global.Window || {prototype:global});
        augment(global.XMLHttpRequest);
      }

    }());
  }

}(self));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(391);

__webpack_require__(588);

__webpack_require__(589);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(392);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(137);
__webpack_require__(496);
__webpack_require__(183);
__webpack_require__(497);
__webpack_require__(184);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(187);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
module.exports = __webpack_require__(40);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(13);
var has = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(22);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(33);
var META = __webpack_require__(55).KEY;
var $fails = __webpack_require__(16);
var shared = __webpack_require__(91);
var setToStringTag = __webpack_require__(80);
var uid = __webpack_require__(65);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(165);
var wksDefine = __webpack_require__(118);
var enumKeys = __webpack_require__(394);
var isArray = __webpack_require__(101);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var toObject = __webpack_require__(25);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(47);
var createDesc = __webpack_require__(64);
var _create = __webpack_require__(68);
var gOPNExt = __webpack_require__(168);
var $GOPD = __webpack_require__(38);
var $GOPS = __webpack_require__(100);
var $DP = __webpack_require__(24);
var $keys = __webpack_require__(66);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(69).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(93).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(54)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(32)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(91)('native-function-to-string', Function.toString);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(100);
var pIE = __webpack_require__(93);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(68) });


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperties: __webpack_require__(167) });


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(37);
var $getOwnPropertyDescriptor = __webpack_require__(38).f;

__webpack_require__(49)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(25);
var $getPrototypeOf = __webpack_require__(39);

__webpack_require__(49)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(25);
var $keys = __webpack_require__(66);

__webpack_require__(49)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(49)('getOwnPropertyNames', function () {
  return __webpack_require__(168).f;
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(55).onFreeze;

__webpack_require__(49)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(55).onFreeze;

__webpack_require__(49)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(55).onFreeze;

__webpack_require__(49)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(17);

__webpack_require__(49)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(17);

__webpack_require__(49)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(17);

__webpack_require__(49)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(169) });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(170) });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(122).set });


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(81);
var test = {};
test[__webpack_require__(20)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(33)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(171) });


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(22) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(17);
var getPrototypeOf = __webpack_require__(39);
var HAS_INSTANCE = __webpack_require__(20)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(24).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(173);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(174);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var has = __webpack_require__(36);
var cof = __webpack_require__(42);
var inheritIfRequired = __webpack_require__(124);
var toPrimitive = __webpack_require__(47);
var fails = __webpack_require__(16);
var gOPN = __webpack_require__(69).f;
var gOPD = __webpack_require__(38).f;
var dP = __webpack_require__(24).f;
var $trim = __webpack_require__(82).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(68)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(22) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(33)(global, NUMBER, $Number);
}


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(43);
var aNumberValue = __webpack_require__(175);
var repeat = __webpack_require__(125);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(16)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(16);
var aNumberValue = __webpack_require__(175);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(13).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(176) });


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(176);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(174);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(173);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(177);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(126);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(127);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(178) });


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(177) });


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(126) });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(127);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(127);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(67);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(21);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(82)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(102)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(128)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(102)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(21);
var context = __webpack_require__(130);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(131)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(130);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(131)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(125)
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(21);
var context = __webpack_require__(130);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(131)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(34)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(34)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(34)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(34)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(34)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(34)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(34)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(34)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(34)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(34)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(34)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(34)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(34)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(47);

$export($export.P + $export.F * __webpack_require__(16)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(471);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(16);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(33)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(20)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(32)(proto, TO_PRIMITIVE, __webpack_require__(474));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(47);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(101) });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(41);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var call = __webpack_require__(179);
var isArrayIter = __webpack_require__(132);
var toLength = __webpack_require__(21);
var createProperty = __webpack_require__(133);
var getIterFn = __webpack_require__(134);

$export($export.S + $export.F * !__webpack_require__(104)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(133);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(16)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(37);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(92) != Object || !__webpack_require__(44)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(121);
var cof = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(21);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(16)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(25);
var fails = __webpack_require__(16);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(44)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(50)(0);
var STRICT = __webpack_require__(44)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var isArray = __webpack_require__(101);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(50)(1);

$export($export.P + $export.F * !__webpack_require__(44)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(50)(2);

$export($export.P + $export.F * !__webpack_require__(44)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(50)(3);

$export($export.P + $export.F * !__webpack_require__(44)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(50)(4);

$export($export.P + $export.F * !__webpack_require__(44)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(180);

$export($export.P + $export.F * !__webpack_require__(44)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(180);

$export($export.P + $export.F * !__webpack_require__(44)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(99)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(37);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(21);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(181) });

__webpack_require__(56)('copyWithin');


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(136) });

__webpack_require__(56)('fill');


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(50)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(56)(KEY);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(50)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(56)(KEY);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70)('Array');


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var inheritIfRequired = __webpack_require__(124);
var dP = __webpack_require__(24).f;
var gOPN = __webpack_require__(69).f;
var isRegExp = __webpack_require__(103);
var $flags = __webpack_require__(94);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(22) && (!CORRECT_NEW || __webpack_require__(16)(function () {
  re2[__webpack_require__(20)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(33)(global, 'RegExp', $RegExp);
}

__webpack_require__(70)('RegExp');


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(184);
var anObject = __webpack_require__(10);
var $flags = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(22);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(33)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(16)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toLength = __webpack_require__(21);
var advanceStringIndex = __webpack_require__(139);
var regExpExec = __webpack_require__(105);

// @@match logic
__webpack_require__(106)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toObject = __webpack_require__(25);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(43);
var advanceStringIndex = __webpack_require__(139);
var regExpExec = __webpack_require__(105);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(106)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var sameValue = __webpack_require__(170);
var regExpExec = __webpack_require__(105);

// @@search logic
__webpack_require__(106)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(103);
var anObject = __webpack_require__(10);
var speciesConstructor = __webpack_require__(95);
var advanceStringIndex = __webpack_require__(139);
var toLength = __webpack_require__(21);
var callRegExpExec = __webpack_require__(105);
var regexpExec = __webpack_require__(138);
var fails = __webpack_require__(16);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(106)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(54);
var global = __webpack_require__(13);
var ctx = __webpack_require__(41);
var classof = __webpack_require__(81);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(27);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var speciesConstructor = __webpack_require__(95);
var task = __webpack_require__(140).set;
var microtask = __webpack_require__(141)();
var newPromiseCapabilityModule = __webpack_require__(142);
var perform = __webpack_require__(185);
var userAgent = __webpack_require__(107);
var promiseResolve = __webpack_require__(186);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(20)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(73)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(80)($Promise, PROMISE);
__webpack_require__(70)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(104)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(191);
var validate = __webpack_require__(74);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(108)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(109);
var buffer = __webpack_require__(143);
var anObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(21);
var isObject = __webpack_require__(17);
var ArrayBuffer = __webpack_require__(13).ArrayBuffer;
var speciesConstructor = __webpack_require__(95);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(16)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(70)(ARRAY_BUFFER);


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(109).ABV, {
  DataView: __webpack_require__(143).DataView
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(10);
var rApply = (__webpack_require__(13).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(16)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(68);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(16);
var bind = __webpack_require__(171);
var rConstruct = (__webpack_require__(13).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(24);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(47);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(16)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(38).f;
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(10);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(129)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(39);
var has = __webpack_require__(36);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(10);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(38);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(39);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(10);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(193) });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(10);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(24);
var gOPD = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(39);
var has = __webpack_require__(36);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(64);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(122);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(99)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(56)('includes');


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(194);
var toObject = __webpack_require__(25);
var toLength = __webpack_require__(21);
var aFunction = __webpack_require__(27);
var arraySpeciesCreate = __webpack_require__(135);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(56)('flatMap');


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(194);
var toObject = __webpack_require__(25);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(43);
var arraySpeciesCreate = __webpack_require__(135);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(56)('flatten');


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(2);
var $at = __webpack_require__(102)(true);
var $fails = __webpack_require__(16);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(195);
var userAgent = __webpack_require__(107);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(195);
var userAgent = __webpack_require__(107);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(82)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(82)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(2);
var defined = __webpack_require__(48);
var toLength = __webpack_require__(21);
var isRegExp = __webpack_require__(103);
var getFlags = __webpack_require__(94);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(129)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('asyncIterator');


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('observable');


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(193);
var toIObject = __webpack_require__(37);
var gOPD = __webpack_require__(38);
var createProperty = __webpack_require__(133);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(196)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(196)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(24);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(24);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(39);
var getOwnPropertyDescriptor = __webpack_require__(38).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(39);
var getOwnPropertyDescriptor = __webpack_require__(38).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(197)('Map') });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(197)('Set') });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(111)('Map');


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(111)('Set');


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(111)('WeakMap');


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(111)('WeakSet');


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(112)('Map');


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(112)('Set');


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(112)('WeakMap');


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(112)('WeakSet');


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.G, { global: __webpack_require__(13) });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.S, 'System', { global: __webpack_require__(13) });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(2);
var cof = __webpack_require__(42);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var scale = __webpack_require__(199);
var fround = __webpack_require__(178);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { scale: __webpack_require__(199) });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(2);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(40);
var global = __webpack_require__(13);
var speciesConstructor = __webpack_require__(95);
var promiseResolve = __webpack_require__(186);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(142);
var perform = __webpack_require__(185);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(39);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(189);
var from = __webpack_require__(198);
var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(39);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(39);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(52);
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(27);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(2);
var microtask = __webpack_require__(141)();
var process = __webpack_require__(13).process;
var isNode = __webpack_require__(42)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(2);
var global = __webpack_require__(13);
var core = __webpack_require__(40);
var microtask = __webpack_require__(141)();
var OBSERVABLE = __webpack_require__(20)('observable');
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(10);
var anInstance = __webpack_require__(71);
var redefineAll = __webpack_require__(73);
var hide = __webpack_require__(32);
var forOf = __webpack_require__(72);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(70)('Observable');


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(13);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(107);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(140);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(137);
var getKeys = __webpack_require__(66);
var redefine = __webpack_require__(33);
var global = __webpack_require__(13);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(83);
var wks = __webpack_require__(20);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(590);
module.exports = __webpack_require__(40).RegExp.escape;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(2);
var $re = __webpack_require__(591)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(593);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _reactRouter = __webpack_require__(19);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _approute = __webpack_require__(663);

var _approute2 = _interopRequireDefault(_approute);

var _configurestore = __webpack_require__(844);

var _configurestore2 = _interopRequireDefault(_configurestore);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

var _system = __webpack_require__(384);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(854);


var reduxState = void 0;
//Server side generated store __REDUX_STATE__
if (window.__REDUX_STATE__) {
    try {
        reduxState = JSON.parse(decodeURI(__REDUX_STATE__));
    } catch (e) {
        console.log('error', e);
    }
}

// console.log('Redux state', reduxState);

// The state variable contains the state of our store.
// This initialStoreState is the initial client-side state of the entire store.
// (May be merged with server-side state from above in __REDUX_STATE__) TODO: The merging does not work yet. (update: i do a bit just below for translations, but is not generic)
var state = Object.assign({}, reduxState, _initialstorestate2.default);

// Merge translations from server-side store, to client side store, so that they're available immediately upon loading (so that we never get "empty" texts (unless the node-server didn't get them))
if (reduxState && reduxState.i18n && reduxState.i18n.translation && Object.keys(reduxState.i18n.translation).length > 0) {
    state.i18n.translation = reduxState.i18n.translation;
    state.i18n.translationLocale = reduxState.i18n.translationLocale;
}

// Merge auth from server-side store, to client side store, so that they're available immediately upon loading (in case of server-side login)
if (reduxState && reduxState.auth && reduxState.auth.userId) {
    Object.assign(state.auth, reduxState.auth); // copy from server-side auth to client-side auth
}

if (true) console.log("*****************************INITIAL STORE STATE:", state);

//Can pass in initial state
/*  state*/
var store = (0, _configurestore2.default)(_reactRouter.browserHistory, state);
//const history = syncHistoryWithStore(browserHistory, store);

if (true) console.log('Store', store);

_reactRouter.browserHistory.listen(function (location) {
    //console.log('location', location);
    store.dispatch((0, _system.locationChanged)(location));
});

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    (0, _approute2.default)(_reactRouter.browserHistory)
), document.getElementById('root'));

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(602)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./notifications.css", function() {
			var newContent = require("!!../../css-loader/index.js!./notifications.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(595);
exports = module.exports = __webpack_require__(596)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:Notification;src:url(" + escape(__webpack_require__(597)) + ");src:url(" + escape(__webpack_require__(598)) + "?#iefixs3g3t9) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(599)) + ") format(\"woff\"),url(" + escape(__webpack_require__(600)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(601)) + "#notification) format(\"svg\");font-weight:400;font-style:normal}.notification-container{box-sizing:border-box;position:fixed;top:0;right:0;z-index:999999;width:320px;padding:0 15px;max-height:calc(100% - 30px);overflow-x:hidden;overflow-y:auto}.notification{box-sizing:border-box;padding:15px 15px 15px 58px;border-radius:2px;color:#fff;background-color:#ccc;box-shadow:0 0 12px #999;cursor:pointer;font-size:1em;line-height:1.2em;position:relative;opacity:.9;margin-top:15px}.notification .title{font-size:1em;line-height:1.2em;font-weight:700;margin:0 0 5px}.notification:focus,.notification:hover{opacity:1}.notification-enter{visibility:hidden;transform:translate3d(100%,0,0)}.notification-enter.notification-enter-active{visibility:visible;transform:translateZ(0);transition:all .4s}.notification-leave{visibility:visible;transform:translateZ(0)}.notification-leave.notification-leave-active{visibility:hidden;transform:translate3d(100%,0,0);transition:all .4s}.notification:before{position:absolute;top:50%;left:15px;margin-top:-14px;display:block;font-family:Notification;width:28px;height:28px;font-size:28px;text-align:center;line-height:28px}.notification-info{background-color:#2f96b4}.notification-info:before{content:\"\\F05A\"}.notification-success{background-color:#51a351}.notification-success:before{content:\"\\F058\"}.notification-warning{background-color:#f89406}.notification-warning:before{content:\"\\F06A\"}.notification-error{background-color:#bd362f}.notification-error:before{content:\"\\F057\"}", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 596 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0d3c94cd6112550c51d7d1ed13b9da1.eot";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0d3c94cd6112550c51d7d1ed13b9da1.eot";

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b4ac1dc75df35e169b70d7719afe4cc.ttf";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bee74caefdf9d0a834915f6c8eeb259.svg";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(603);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 603 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(113),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== 'undefined';

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(113);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(608);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(85);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(144);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(85);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(201);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(85);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(96);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(96);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(96);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(202);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(623);
var objectAssign = __webpack_require__(113);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(28);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(86);

var _PathUtils = __webpack_require__(59);

var _createHistory = __webpack_require__(150);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(211);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(28);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(151);

var _BrowserProtocol = __webpack_require__(152);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(629);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(115);

var _createHistory = __webpack_require__(150);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(152);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(86);

var _PathUtils = __webpack_require__(59);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(211);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(28);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(151);

var _DOMUtils = __webpack_require__(115);

var _HashProtocol = __webpack_require__(632);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(150);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(152);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(86);

var _DOMUtils = __webpack_require__(115);

var _DOMStateStorage = __webpack_require__(210);

var _PathUtils = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),n=__webpack_require__(113),r=__webpack_require__(634);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(635);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(153);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(659);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(220);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(646);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(644);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(53)))

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(217);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(648);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(652);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(53), __webpack_require__(651)(module)))

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(218);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(219);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(220);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(221);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(660);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(153);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(222);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(223);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (history) {
    return _react2.default.createElement(
        _reactRouter.Router,
        { history: history },
        _react2.default.createElement(
            _reactRouter.Route,
            { path: _routeconstants.ROUTE_APP, component: _app2.default },
            _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _requireauth.requireAuthentication)(_Home2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_SIGNIN, component: _SignInPage2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_DASHBOARD, component: (0, _requireauth.requireAuthentication)(_Dashboard2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_REPORTING, component: (0, _requireauth.requireAuthentication)(_Reporting2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_CLUBS, component: (0, _requireauth.requireAuthentication)(_ClubsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_CLUB, component: (0, _requireauth.requireAuthentication)(_ClubPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_MEMBERS, component: (0, _requireauth.requireAuthentication)(_MembersPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_MEMBER, component: (0, _requireauth.requireAuthentication)(_MemberPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_PIGEON_HOLE, component: (0, _requireauth.requireAuthentication)(_PigeonHolePage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_SECTIONS, component: (0, _requireauth.requireAuthentication)(_SectionsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_SECTION, component: (0, _requireauth.requireAuthentication)(_SectionPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_RACES, component: (0, _requireauth.requireAuthentication)(_RacesPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_RACE, component: (0, _requireauth.requireAuthentication)(_RacePage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_STATIONS, component: (0, _requireauth.requireAuthentication)(_StationsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_RANGES, component: (0, _requireauth.requireAuthentication)(_RangesPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_ZIPS, component: (0, _requireauth.requireAuthentication)(_ZipCodesPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_NIGHT_TIMES, component: (0, _requireauth.requireAuthentication)(_NightTimesPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_DERBYS, component: (0, _requireauth.requireAuthentication)(_DerbysPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_ERROR_LISTS, component: (0, _requireauth.requireAuthentication)(_ErrorListsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_SETTINGS, component: (0, _requireauth.requireAuthentication)(_SettingsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_CHAMPIONSHIPS, component: (0, _requireauth.requireAuthentication)(_ChampionshipsPage2.default) }),
            _react2.default.createElement(_reactRouter.Route, { path: _routeconstants.ROUTE_CHAMPIONSHIP, component: (0, _requireauth.requireAuthentication)(_ChampionshipPage2.default) })
        )
    );
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _app = __webpack_require__(664);

var _app2 = _interopRequireDefault(_app);

var _Home = __webpack_require__(729);

var _Home2 = _interopRequireDefault(_Home);

var _Dashboard = __webpack_require__(730);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Reporting = __webpack_require__(755);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _SignInPage = __webpack_require__(778);

var _SignInPage2 = _interopRequireDefault(_SignInPage);

var _SignUpPage = __webpack_require__(779);

var _SignUpPage2 = _interopRequireDefault(_SignUpPage);

var _ProfilePage = __webpack_require__(781);

var _ProfilePage2 = _interopRequireDefault(_ProfilePage);

var _EditProfilePage = __webpack_require__(782);

var _EditProfilePage2 = _interopRequireDefault(_EditProfilePage);

var _ResetPasswordForm = __webpack_require__(783);

var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);

var _ClubsPage = __webpack_require__(784);

var _ClubsPage2 = _interopRequireDefault(_ClubsPage);

var _ClubPage = __webpack_require__(785);

var _ClubPage2 = _interopRequireDefault(_ClubPage);

var _MembersPage = __webpack_require__(791);

var _MembersPage2 = _interopRequireDefault(_MembersPage);

var _MemberPage = __webpack_require__(792);

var _MemberPage2 = _interopRequireDefault(_MemberPage);

var _PigeonHolePage = __webpack_require__(796);

var _PigeonHolePage2 = _interopRequireDefault(_PigeonHolePage);

var _SectionsPage = __webpack_require__(800);

var _SectionsPage2 = _interopRequireDefault(_SectionsPage);

var _SectionPage = __webpack_require__(801);

var _SectionPage2 = _interopRequireDefault(_SectionPage);

var _RacesPage = __webpack_require__(804);

var _RacesPage2 = _interopRequireDefault(_RacesPage);

var _RacePage = __webpack_require__(805);

var _RacePage2 = _interopRequireDefault(_RacePage);

var _StationsPage = __webpack_require__(817);

var _StationsPage2 = _interopRequireDefault(_StationsPage);

var _RangesPage = __webpack_require__(818);

var _RangesPage2 = _interopRequireDefault(_RangesPage);

var _ZipCodesPage = __webpack_require__(819);

var _ZipCodesPage2 = _interopRequireDefault(_ZipCodesPage);

var _NightTimesPage = __webpack_require__(820);

var _NightTimesPage2 = _interopRequireDefault(_NightTimesPage);

var _DerbysPage = __webpack_require__(821);

var _DerbysPage2 = _interopRequireDefault(_DerbysPage);

var _ErrorListsPage = __webpack_require__(822);

var _ErrorListsPage2 = _interopRequireDefault(_ErrorListsPage);

var _SettingsPage = __webpack_require__(832);

var _SettingsPage2 = _interopRequireDefault(_SettingsPage);

var _ChampionshipsPage = __webpack_require__(838);

var _ChampionshipsPage2 = _interopRequireDefault(_ChampionshipsPage);

var _ChampionshipPage = __webpack_require__(839);

var _ChampionshipPage2 = _interopRequireDefault(_ChampionshipPage);

var _requireauth = __webpack_require__(843);

var _routeconstants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _routeconstants = __webpack_require__(11);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _GlobalErrorDialog = __webpack_require__(685);

var _GlobalErrorDialog2 = _interopRequireDefault(_GlobalErrorDialog);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

var _user = __webpack_require__(98);

var UserActions = _interopRequireWildcard(_user);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _Footer = __webpack_require__(726);

var _Footer2 = _interopRequireDefault(_Footer);

var _Avatar = __webpack_require__(380);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _raceUtil = __webpack_require__(382);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logo = typeof window === "undefined" ? null // <- don't require the image on the server (it will crash - no webpack).
: __webpack_require__(728); // file-loader = get image as path, url-loader = get image as "data:" + base64 encoded data.


var App = function (_React$Component) {
    _inherits(App, _React$Component);

    _createClass(App, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_APP;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return []; // empty means allowed for all
        }
    }]);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.state = {
            logoSrc: null
        };
        return _this;
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _reactModal2.default.setAppElement('body'); // To prevent stupid warning turning up in the console when using modals
            var dispatch = this.props.dispatch;

            dispatch(AuthActions.loginCheckSession()); // to make the frontend notice the user is logged in, in case the user reloads a page not requiring login (where requireAuth.js is not called) - can probably be done more elegantly (to save this extra request)
            App.keepAliveIntervalHandle = setInterval(function () {
                if (_this2.props.auth.isAuthenticated) {
                    _this2.props.dispatch(AuthActions.setForceAuthRecheck(true));
                }
            }, 5 * 60 * 1000);
            App.checkImportsIntervalHandle = setInterval(function () {
                _this2.props.race.deviceImports.forEach(function (outstanding, id) {
                    dispatch(RaceActions.checkDeviceImport(id));
                });
            }, 5 * 1000);
            this.setState({
                logoSrc: logo
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (App.keepAliveIntervalHandle !== null) clearInterval(App.keepAliveIntervalHandle);
            if (App.checkImportsIntervalHandle !== null) clearInterval(App.checkImportsIntervalHandle);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.admin.isBasicsRead && nextProps.auth.isAuthenticated) {
                this.props.dispatch(AdminActions.getBasics());
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var headerLoggedInHtml = []; /*!this.props.auth.isAuthenticated ? [] : (
                                         <div className="header-user-info inline">
                                         <Link className="header-user-name" to={ROUTE_PROFILE_CURRENT} onClick={e => e.stopPropagation()}>
                                         {this.props.auth.firstName + " " + this.props.auth.lastName}
                                         </Link>
                                         <div className="header-user-icon"><Avatar userId={this.props.auth.userId} size="small" /></div>
                                         </div>
                                         );*/
            var currentRole = typeof this.props.auth.currentRole === 'undefined' || typeof this.props.admin.userRoles === 'undefined' || this.props.auth.currentRole === null || this.props.admin.userRoles === null ? [] : this.props.admin.userRoles.filter(function (role) {
                return _this3.props.auth.currentRole === role.level && _this3.props.auth.currentEntity === role.id;
            });
            var currentRoleTxt = currentRole.length === 0 ? null : currentRole[0].level === _UserRoles2.default.MAIN_ADMIN.id ? "DDB" : currentRole[0].id + " - " + currentRole[0].name;

            return _react2.default.createElement(
                'div',
                { className: "document" },
                _react2.default.createElement(_reactNotifications.NotificationContainer, null),
                _react2.default.createElement(_GlobalErrorDialog2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'page-header' },
                    _react2.default.createElement(
                        'div',
                        { className: 'logo inline' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/' },
                            _react2.default.createElement('img', { src: this.state.logoSrc })
                        )
                    ),
                    _react2.default.createElement('div', { className: 'navigation inline' }),
                    typeof this.props.auth === 'undefined' || typeof this.props.auth.database === 'undefined' || this.props.auth.database === 'standard' ? null : _react2.default.createElement(
                        'div',
                        { className: 'archive' },
                        'ARKIVDATABASE ',
                        this.props.auth.database
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'login inline' },
                        _react2.default.createElement(
                            'div',
                            { className: 'header-user-info inline' },
                            this.props.auth.isAuthenticated ? this.props.auth.displayName : '',
                            currentRoleTxt === null ? '' : [_react2.default.createElement('br', null), currentRoleTxt]
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'header-login-link' },
                            _react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
                            function () {
                                if (!_this3.props.auth.isAuthenticated) {
                                    return _react2.default.createElement(
                                        _reactRouter.Link,
                                        { className: 'inline btn-login', to: _routeconstants.ROUTE_SIGNIN, activeClassName: 'breadcrumb-active', onlyActiveOnIndex: true, onClick: function onClick(event) {
                                                event.preventDefault();
                                                window.location = '/login/drupal';
                                            } },
                                        'Log in'
                                    );
                                } else {
                                    return _react2.default.createElement(
                                        'a',
                                        { className: 'inline btn-login', to: 'sign out', onClick: function onClick() {
                                                return _this3.props.dispatch(AuthActions.logoutAndRedirect());
                                            }, href: '#' },
                                        'Log out'
                                    );
                                }
                            }()
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'page-content' },
                    this.props.children
                ),
                _react2.default.createElement(_Footer2.default, null)
            );
        }
    }]);

    return App;
}(_react2.default.Component);

App.contextTypes = {
    router: _propTypes2.default.object.isRequired
};
App.keepAliveIntervalHandle = null;
App.checkImportsIntervalHandle = null;


var mapStateToPros = function mapStateToPros(state) {
    return {
        auth: {
            isAuthenticated: state.auth.isAuthenticated,
            isAuthenticating: state.auth.isAuthenticating,
            id: state.auth.id,
            displayName: state.auth.displayName,
            database: state.auth.database,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isBasicsRead: state.admin.isBasicsRead,
            userRoles: state.admin.userRoles
        },
        race: {
            deviceImports: state.race.deviceImports
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToPros)(App);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(666);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(225);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(155);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(673);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {
  Modal.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

exports.default = Modal;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(667);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(668);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(225);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(671);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(155);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(226);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(672);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(224);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(224);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(226);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CSSTransition", function() { return __WEBPACK_IMPORTED_MODULE_0__CSSTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaceTransition", function() { return __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SwitchTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transition", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_5__config__["a"]; });







/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(229);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* harmony default export */ __webpack_exports__["a"] = (CSSTransition);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(677);

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(230);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ReplaceTransition);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(157);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */]:
        component = current;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ __webpack_exports__["a"] = (SwitchTransition);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(231));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notification = /*#__PURE__*/function (_React$Component) {
  _inherits(Notification, _React$Component);

  var _super = _createSuper(Notification);

  function Notification() {
    var _this;

    _classCallCheck(this, Notification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var timeOut = _this.props.timeOut;

      if (timeOut !== 0) {
        _this.timer = setTimeout(_this.requestHide, timeOut);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }

      _this.requestHide();
    });

    _defineProperty(_assertThisInitialized(_this), "requestHide", function () {
      var onRequestHide = _this.props.onRequestHide;

      if (onRequestHide) {
        onRequestHide();
      }
    });

    return _this;
  }

  _createClass(Notification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          message = _this$props.message;
      var title = this.props.title;
      var className = (0, _classnames.default)(['notification', "notification-".concat(type)]);
      title = title ? /*#__PURE__*/_react.default.createElement("h4", {
        className: "title"
      }, title) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "notification-message",
        role: "alert"
      }, title, /*#__PURE__*/_react.default.createElement("div", {
        className: "message"
      }, message)));
    }
  }]);

  return Notification;
}(_react.default.Component);

_defineProperty(Notification, "propTypes", {
  type: _propTypes.default.oneOf(['info', 'success', 'warning', 'error']),
  title: _propTypes.default.node,
  message: _propTypes.default.node,
  timeOut: _propTypes.default.number,
  onClick: _propTypes.default.func,
  onRequestHide: _propTypes.default.func
});

_defineProperty(Notification, "defaultProps", {
  type: 'info',
  title: null,
  message: null,
  timeOut: 5000,
  onClick: function onClick() {},
  onRequestHide: function onRequestHide() {}
});

var _default = Notification;
exports.default = _default;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _NotificationManager = _interopRequireDefault(__webpack_require__(232));

var _Notifications = _interopRequireDefault(__webpack_require__(227));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationContainer, _React$Component);

  var _super = _createSuper(NotificationContainer);

  function NotificationContainer() {
    var _this;

    _classCallCheck(this, NotificationContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      notifications: []
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _NotificationManager.default.addChangeListener(_this.handleStoreChange);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _NotificationManager.default.removeChangeListener(_this.handleStoreChange);
    });

    _defineProperty(_assertThisInitialized(_this), "handleStoreChange", function (notifications) {
      _this.setState({
        notifications: notifications
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
      _NotificationManager.default.remove(notification);
    });

    return _this;
  }

  _createClass(NotificationContainer, [{
    key: "render",
    value: function render() {
      var notifications = this.state.notifications;
      var _this$props = this.props,
          enterTimeout = _this$props.enterTimeout,
          leaveTimeout = _this$props.leaveTimeout;
      return /*#__PURE__*/_react.default.createElement(_Notifications.default, {
        enterTimeout: enterTimeout,
        leaveTimeout: leaveTimeout,
        notifications: notifications,
        onRequestHide: this.handleRequestHide
      });
    }
  }]);

  return NotificationContainer;
}(_react.default.Component);

_defineProperty(NotificationContainer, "propTypes", {
  enterTimeout: _propTypes.default.number,
  leaveTimeout: _propTypes.default.number
});

_defineProperty(NotificationContainer, "defaultProps", {
  enterTimeout: 400,
  leaveTimeout: 400
});

var _default = NotificationContainer;
exports.default = _default;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalErrorDialog = function (_React$Component) {
    _inherits(GlobalErrorDialog, _React$Component);

    function GlobalErrorDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GlobalErrorDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalErrorDialog.__proto__ || Object.getPrototypeOf(GlobalErrorDialog)).call.apply(_ref, [this].concat(args))), _this), _this.closeSingleError = function (errorId) {
            _this.props.dispatch(GlobalErrorActions.removeGlobalError(errorId));
        }, _this.closeAllErrors = function () {
            _this.props.dispatch(GlobalErrorActions.removeAllGlobalErrors());
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GlobalErrorDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errors = this.props.globalError.errors;

            var errorsHtml = errors.map(function (e, i) {
                var errorNumberHtml = e.serverErrorId == -1 ? "" : _react2.default.createElement(
                    'div',
                    { style: { fontStyle: "italic", paddingBottom: "20px" } },
                    'Error ID: ',
                    e.serverErrorId
                );
                var dividerHtml = i < errors.count() - 1 ? _react2.default.createElement('hr', null) : "";
                return _react2.default.createElement(
                    'div',
                    { key: e.errorId },
                    _react2.default.createElement(
                        'h2',
                        null,
                        e.errorTitle
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: { paddingTop: "14px", paddingBottom: "14px" } },
                        e.errorMessage
                    ),
                    errorNumberHtml,
                    dividerHtml
                );
            });

            var modalDialogHtml = _react2.default.createElement(
                _reactModal2.default,
                { isOpen: !errors.isEmpty(), shouldCloseOnOverlayClick: false, style: GlobalErrorDialog.modalDialogStyles },
                _react2.default.createElement(
                    'div',
                    { className: 'modalDialogContent' },
                    errorsHtml,
                    _react2.default.createElement(
                        'button',
                        { type: 'submit', className: 'btn-primary', onClick: function onClick() {
                                return _this2.closeAllErrors();
                            } },
                        'OK'
                    )
                )
            );

            return _react2.default.createElement(
                'div',
                null,
                modalDialogHtml
            );
        }
    }]);

    return GlobalErrorDialog;
}(_react2.default.Component);

GlobalErrorDialog.modalDialogStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 99999
    },
    content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: "0px",
        background: "none",
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '0px',
        outline: 'none',
        padding: '20px',
        textAlign: "center"
    }
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        globalError: {
            errors: state.globalError.errors
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GlobalErrorDialog);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var rest = __webpack_require__(233),
    browser = __webpack_require__(687);

rest.setPlatformDefaultClient(browser);

module.exports = rest;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var normalizeHeaderName, responsePromise, client, headerSplitRE;

normalizeHeaderName = __webpack_require__(234);
responsePromise = __webpack_require__(159);
client = __webpack_require__(158);

// according to the spec, the line break is '\r\n', but doesn't hold true in practice
headerSplitRE = /[\r|\n]+/;

function parseHeaders(raw) {
	// Note: Set-Cookie will be removed by the browser
	var headers = {};

	if (!raw) { return headers; }

	raw.trim().split(headerSplitRE).forEach(function (header) {
		var boundary, name, value;
		boundary = header.indexOf(':');
		name = normalizeHeaderName(header.substring(0, boundary).trim());
		value = header.substring(boundary + 1).trim();
		if (headers[name]) {
			if (Array.isArray(headers[name])) {
				// add to an existing array
				headers[name].push(value);
			}
			else {
				// convert single value to array
				headers[name] = [headers[name], value];
			}
		}
		else {
			// new, single value
			headers[name] = value;
		}
	});

	return headers;
}

function safeMixin(target, source) {
	Object.keys(source || {}).forEach(function (prop) {
		// make sure the property already exists as
		// IE 6 will blow up if we add a new prop
		if (source.hasOwnProperty(prop) && prop in target) {
			try {
				target[prop] = source[prop];
			}
			catch (e) {
				// ignore, expected for some properties at some points in the request lifecycle
			}
		}
	});

	return target;
}

module.exports = client(function xhr(request) {
	return responsePromise.promise(function (resolve, reject) {
		/*jshint maxcomplexity:20 */

		var client, method, url, headers, entity, headerName, response, XHR;

		request = typeof request === 'string' ? { path: request } : request || {};
		response = { request: request };

		if (request.canceled) {
			response.error = 'precanceled';
			reject(response);
			return;
		}

		XHR = request.engine || XMLHttpRequest;
		if (!XHR) {
			reject({ request: request, error: 'xhr-not-available' });
			return;
		}

		entity = request.entity;
		request.method = request.method || (entity ? 'POST' : 'GET');
		method = request.method;
		url = response.url = request.path || '';

		try {
			client = response.raw = new XHR();

			// mixin extra request properties before and after opening the request as some properties require being set at different phases of the request
			safeMixin(client, request.mixin);
			client.open(method, url, true);
			safeMixin(client, request.mixin);

			headers = request.headers;
			for (headerName in headers) {
				/*jshint forin:false */
				if (headerName === 'Content-Type' && headers[headerName] === 'multipart/form-data') {
					// XMLHttpRequest generates its own Content-Type header with the
					// appropriate multipart boundary when sending multipart/form-data.
					continue;
				}

				client.setRequestHeader(headerName, headers[headerName]);
			}

			request.canceled = false;
			request.cancel = function cancel() {
				request.canceled = true;
				client.abort();
				reject(response);
			};

			client.onreadystatechange = function (/* e */) {
				if (request.canceled) { return; }
				if (client.readyState === (XHR.DONE || 4)) {
					response.status = {
						code: client.status,
						text: client.statusText
					};
					response.headers = parseHeaders(client.getAllResponseHeaders());
					response.entity = client.responseText;

					// #125 -- Sometimes IE8-9 uses 1223 instead of 204
					// http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
					if (response.status.code === 1223) {
						response.status.code = 204;
					}

					if (response.status.code > 0) {
						// check status code as readystatechange fires before error event
						resolve(response);
					}
					else {
						// give the error callback a chance to fire before resolving
						// requests for file:// URLs do not have a status code
						setTimeout(function () {
							resolve(response);
						}, 0);
					}
				}
			};

			try {
				client.onerror = function (/* e */) {
					response.error = 'loaderror';
					reject(response);
				};
			}
			catch (e) {
				// IE 6 will not support error handling
			}

			client.send(entity);
		}
		catch (e) {
			response.error = 'loaderror';
			reject(response);
		}

	});
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2013-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor, mixinUtil, defaulter;

interceptor = __webpack_require__(60);
mixinUtil = __webpack_require__(116);

defaulter = (function () {

	function mixin(prop, target, defaults) {
		if (prop in target || prop in defaults) {
			target[prop] = mixinUtil({}, defaults[prop], target[prop]);
		}
	}

	function copy(prop, target, defaults) {
		if (prop in defaults && !(prop in target)) {
			target[prop] = defaults[prop];
		}
	}

	var mappings = {
		method: copy,
		path: copy,
		params: mixin,
		headers: mixin,
		entity: copy,
		mixin: mixin
	};

	return function (target, defaults) {
		for (var prop in mappings) {
			/*jshint forin: false */
			mappings[prop](prop, target, defaults);
		}
		return target;
	};

}());

/**
 * Provide default values for a request. These values will be applied to the
 * request if the request object does not already contain an explicit value.
 *
 * For 'params', 'headers', and 'mixin', individual values are mixed in with the
 * request's values. The result is a new object representiing the combined
 * request and config values. Neither input object is mutated.
 *
 * @param {Client} [client] client to wrap
 * @param {string} [config.method] the default method
 * @param {string} [config.path] the default path
 * @param {Object} [config.params] the default params, mixed with the request's existing params
 * @param {Object} [config.headers] the default headers, mixed with the request's existing headers
 * @param {Object} [config.mixin] the default "mixins" (http/https options), mixed with the request's existing "mixins"
 *
 * @returns {Client}
 */
module.exports = interceptor({
	request: function handleRequest(request, config) {
		return defaulter(request, config);
	}
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Jeremy Grelle
 * @author Scott Andrews
 */



var interceptor;

interceptor = __webpack_require__(60);

/**
 * Cancels a request if it takes longer then the timeout value.
 *
 * @param {Client} [client] client to wrap
 * @param {number} [config.timeout=0] duration in milliseconds before canceling the request. Non-positive values disable the timeout
 * @param {boolean} [config.transient=false] if true, timed out requests will not be marked as canceled so that it may be retried
 *
 * @returns {Client}
 */
module.exports = interceptor({
	init: function (config) {
		config.timeout = config.timeout || 0;
		config.transient = !!config.transient;
		return config;
	},
	request: function (request, config) {
		var timeout, abort, triggerAbort, transient;
		timeout = 'timeout' in request ? request.timeout : config.timeout;
		transient = 'transient' in request ? request.transient : config.transient;
		if (timeout <= 0) {
			return request;
		}
		abort = new Promise(function (resolve, reject) {
			triggerAbort = reject;
		});
		this.timeout = setTimeout(function () {
			triggerAbort({ request: request, error: 'timeout' });
			if (request.cancel) {
				request.cancel();
				if (transient) {
					// unmark request as canceled for future requests
					request.canceled = false;
				}
			}
			else if (!transient) {
				request.canceled = true;
			}
		}, timeout);
		return new interceptor.ComplexRequest({ request: request, abort: abort });
	},
	response: function (response) {
		if (this.timeout) {
			clearTimeout(this.timeout);
			delete this.timeout;
		}
		return response;
	}
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor, mime, registry, noopConverter, missingConverter, attempt;

interceptor = __webpack_require__(60);
mime = __webpack_require__(235);
registry = __webpack_require__(236);
attempt = __webpack_require__(240);

noopConverter = {
	read: function (obj) { return obj; },
	write: function (obj) { return obj; }
};

missingConverter = {
	read: function () { throw 'No read method found on converter'; },
	write: function () { throw 'No write method found on converter'; }
};

/**
 * MIME type support for request and response entities.  Entities are
 * (de)serialized using the converter for the MIME type.
 *
 * Request entities are converted using the desired converter and the
 * 'Accept' request header prefers this MIME.
 *
 * Response entities are converted based on the Content-Type response header.
 *
 * @param {Client} [client] client to wrap
 * @param {string} [config.mime='text/plain'] MIME type to encode the request
 *   entity
 * @param {string} [config.accept] Accept header for the request
 * @param {Client} [config.client=<request.originator>] client passed to the
 *   converter, defaults to the client originating the request
 * @param {Registry} [config.registry] MIME registry, defaults to the root
 *   registry
 * @param {boolean} [config.permissive] Allow an unkown request MIME type
 *
 * @returns {Client}
 */
module.exports = interceptor({
	init: function (config) {
		config.registry = config.registry || registry;
		return config;
	},
	request: function (request, config) {
		var type, headers;

		headers = request.headers || (request.headers = {});
		type = mime.parse(headers['Content-Type'] || config.mime || 'text/plain');
		headers.Accept = headers.Accept || config.accept || type.raw + ', application/json;q=0.8, text/plain;q=0.5, */*;q=0.2';

		if (!('entity' in request)) {
			return request;
		}

		headers['Content-Type'] = type.raw;

		return config.registry.lookup(type)['catch'](function () {
			// failed to resolve converter
			if (config.permissive) {
				return noopConverter;
			}
			throw 'mime-unknown';
		}).then(function (converter) {
			var client = config.client || request.originator,
				write = converter.write || missingConverter.write;

			return attempt(write.bind(void 0, request.entity, { client: client, request: request, mime: type, registry: config.registry }))
				['catch'](function() {
					throw 'mime-serialization';
				})
				.then(function(entity) {
					request.entity = entity;
					return request;
				});
		});
	},
	response: function (response, config) {
		if (!(response.headers && response.headers['Content-Type'] && response.entity)) {
			return response;
		}

		var type = mime.parse(response.headers['Content-Type']);

		return config.registry.lookup(type)['catch'](function () { return noopConverter; }).then(function (converter) {
			var client = config.client || response.request && response.request.originator,
				read = converter.read || missingConverter.read;

			return attempt(read.bind(void 0, response.entity, { client: client, response: response, mime: type, registry: config.registry }))
				['catch'](function (e) {
					response.error = 'mime-deserialization';
					response.cause = e;
					throw response;
				})
				.then(function (entity) {
					response.entity = entity;
					return response;
				});
		});
	}
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor, UrlBuilder;

interceptor = __webpack_require__(60);
UrlBuilder = __webpack_require__(238);

function startsWith(str, prefix) {
	return str.indexOf(prefix) === 0;
}

function endsWith(str, suffix) {
	return str.lastIndexOf(suffix) + suffix.length === str.length;
}

/**
 * Prefixes the request path with a common value.
 *
 * @param {Client} [client] client to wrap
 * @param {number} [config.prefix] path prefix
 *
 * @returns {Client}
 */
module.exports = interceptor({
	request: function (request, config) {
		var path;

		if (config.prefix && !(new UrlBuilder(request.path).isFullyQualified())) {
			path = config.prefix;
			if (request.path) {
				if (!endsWith(path, '/') && !startsWith(request.path, '/')) {
					// add missing '/' between path sections
					path += '/';
				}
				path += request.path;
			}
			request.path = path;
		}

		return request;
	}
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor, uriTemplate, mixin;

interceptor = __webpack_require__(60);
uriTemplate = __webpack_require__(693);
mixin = __webpack_require__(116);

/**
 * Applies request params to the path as a URI Template
 *
 * Params are removed from the request object, as they have been consumed.
 *
 * @see https://tools.ietf.org/html/rfc6570
 *
 * @param {Client} [client] client to wrap
 * @param {Object} [config.params] default param values
 * @param {string} [config.template] default template
 *
 * @returns {Client}
 */
module.exports = interceptor({
	init: function (config) {
		config.params = config.params || {};
		config.template = config.template || '';
		return config;
	},
	request: function (request, config) {
		var template, params;

		template = request.path || config.template;
		params = mixin({}, request.params, config.params);

		request.path = uriTemplate.expand(template, params);
		delete request.params;

		return request;
	}
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var uriEncoder, operations, prefixRE;

uriEncoder = __webpack_require__(694);

prefixRE = /^([^:]*):([0-9]+)$/;
operations = {
	'':  { first: '',  separator: ',', named: false, empty: '',  encoder: uriEncoder.encode },
	'+': { first: '',  separator: ',', named: false, empty: '',  encoder: uriEncoder.encodeURL },
	'#': { first: '#', separator: ',', named: false, empty: '',  encoder: uriEncoder.encodeURL },
	'.': { first: '.', separator: '.', named: false, empty: '',  encoder: uriEncoder.encode },
	'/': { first: '/', separator: '/', named: false, empty: '',  encoder: uriEncoder.encode },
	';': { first: ';', separator: ';', named: true,  empty: '',  encoder: uriEncoder.encode },
	'?': { first: '?', separator: '&', named: true,  empty: '=', encoder: uriEncoder.encode },
	'&': { first: '&', separator: '&', named: true,  empty: '=', encoder: uriEncoder.encode },
	'=': { reserved: true },
	',': { reserved: true },
	'!': { reserved: true },
	'@': { reserved: true },
	'|': { reserved: true }
};

function apply(operation, expression, params) {
	/*jshint maxcomplexity:11 */
	return expression.split(',').reduce(function (result, variable) {
		var opts, value;

		opts = {};
		if (variable.slice(-1) === '*') {
			variable = variable.slice(0, -1);
			opts.explode = true;
		}
		if (prefixRE.test(variable)) {
			var prefix = prefixRE.exec(variable);
			variable = prefix[1];
			opts.maxLength = parseInt(prefix[2]);
		}

		variable = uriEncoder.decode(variable);
		value = params[variable];

		if (value === void 0 || value === null) {
			return result;
		}
		if (Array.isArray(value)) {
			result = value.reduce(function (result, value) {
				if (result.length) {
					result += opts.explode ? operation.separator : ',';
					if (operation.named && opts.explode) {
						result += operation.encoder(variable);
						result += value.length ? '=' : operation.empty;
					}
				}
				else {
					result += operation.first;
					if (operation.named) {
						result += operation.encoder(variable);
						result += value.length ? '=' : operation.empty;
					}
				}
				result += operation.encoder(value);
				return result;
			}, result);
		}
		else if (typeof value === 'object') {
			result = Object.keys(value).reduce(function (result, name) {
				if (result.length) {
					result += opts.explode ? operation.separator : ',';
				}
				else {
					result += operation.first;
					if (operation.named && !opts.explode) {
						result += operation.encoder(variable);
						result += value[name].length ? '=' : operation.empty;
					}
				}
				result += operation.encoder(name);
				result += opts.explode ? '=' : ',';
				result += operation.encoder(value[name]);
				return result;
			}, result);
		}
		else {
			value = String(value);
			if (opts.maxLength) {
				value = value.slice(0, opts.maxLength);
			}
			result += result.length ? operation.separator : operation.first;
			if (operation.named) {
				result += operation.encoder(variable);
				result += value.length ? '=' : operation.empty;
			}
			result += operation.encoder(value);
		}

		return result;
	}, '');
}

function expandExpression(expression, params) {
	var operation;

	operation = operations[expression.slice(0,1)];
	if (operation) {
		expression = expression.slice(1);
	}
	else {
		operation = operations[''];
	}

	if (operation.reserved) {
		throw new Error('Reserved expression operations are not supported');
	}

	return apply(operation, expression, params);
}

function expandTemplate(template, params) {
	var start, end, uri;

	uri = '';
	end = 0;
	while (true) {
		start = template.indexOf('{', end);
		if (start === -1) {
			// no more expressions
			uri += template.slice(end);
			break;
		}
		uri += template.slice(end, start);
		end = template.indexOf('}', start) + 1;
		uri += expandExpression(template.slice(start + 1, end - 1), params);
	}

	return uri;
}

module.exports = {

	/**
	 * Expand a URI Template with parameters to form a URI.
	 *
	 * Full implementation (level 4) of rfc6570.
	 * @see https://tools.ietf.org/html/rfc6570
	 *
	 * @param {string} template URI template
	 * @param {Object} [params] params to apply to the template durring expantion
	 * @returns {string} expanded URI
	 */
	expand: expandTemplate

};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var charMap;

charMap = (function () {
	var strings = {
		alpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
		digit: '0123456789'
	};

	strings.genDelims = ':/?#[]@';
	strings.subDelims = '!$&\'()*+,;=';
	strings.reserved = strings.genDelims + strings.subDelims;
	strings.unreserved = strings.alpha + strings.digit + '-._~';
	strings.url = strings.reserved + strings.unreserved;
	strings.scheme = strings.alpha + strings.digit + '+-.';
	strings.userinfo = strings.unreserved + strings.subDelims + ':';
	strings.host = strings.unreserved + strings.subDelims;
	strings.port = strings.digit;
	strings.pchar = strings.unreserved + strings.subDelims + ':@';
	strings.segment = strings.pchar;
	strings.path = strings.segment + '/';
	strings.query = strings.pchar + '/?';
	strings.fragment = strings.pchar + '/?';

	return Object.keys(strings).reduce(function (charMap, set) {
		charMap[set] = strings[set].split('').reduce(function (chars, myChar) {
			chars[myChar] = true;
			return chars;
		}, {});
		return charMap;
	}, {});
}());

function encode(str, allowed) {
	if (typeof str !== 'string') {
		throw new Error('String required for URL encoding');
	}
	return str.split('').map(function (myChar) {
		if (allowed.hasOwnProperty(myChar)) {
			return myChar;
		}
		var code = myChar.charCodeAt(0);
		if (code <= 127) {
			var encoded = code.toString(16).toUpperCase();
 			return '%' + (encoded.length % 2 === 1 ? '0' : '') + encoded;
		}
		else {
			return encodeURIComponent(myChar).toUpperCase();
		}
	}).join('');
}

function makeEncoder(allowed) {
	allowed = allowed || charMap.unreserved;
	return function (str) {
		return encode(str, allowed);
	};
}

function decode(str) {
	return decodeURIComponent(str);
}

module.exports = {

	/*
	 * Decode URL encoded strings
	 *
	 * @param {string} URL encoded string
	 * @returns {string} URL decoded string
	 */
	decode: decode,

	/*
	 * URL encode a string
	 *
	 * All but alpha-numerics and a very limited set of punctuation - . _ ~ are
	 * encoded.
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encode: makeEncoder(),

	/*
	* URL encode a URL
	*
	* All character permitted anywhere in a URL are left unencoded even
	* if that character is not permitted in that portion of a URL.
	*
	* Note: This method is typically not what you want.
	*
	* @param {string} string to encode
	* @returns {string} URL encoded string
	*/
	encodeURL: makeEncoder(charMap.url),

	/*
	 * URL encode the scheme portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodeScheme: makeEncoder(charMap.scheme),

	/*
	 * URL encode the user info portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodeUserInfo: makeEncoder(charMap.userinfo),

	/*
	 * URL encode the host portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodeHost: makeEncoder(charMap.host),

	/*
	 * URL encode the port portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodePort: makeEncoder(charMap.port),

	/*
	 * URL encode a path segment portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodePathSegment: makeEncoder(charMap.segment),

	/*
	 * URL encode the path portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodePath: makeEncoder(charMap.path),

	/*
	 * URL encode the query portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodeQuery: makeEncoder(charMap.query),

	/*
	 * URL encode the fragment portion of a URL
	 *
	 * @param {string} string to encode
	 * @returns {string} URL encoded string
	 */
	encodeFragment: makeEncoder(charMap.fragment)

};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2013-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



module.exports = {

	/**
	 * Find objects within a graph the contain a property of a certain name.
	 *
	 * NOTE: this method will not discover object graph cycles.
	 *
	 * @param {*} obj object to search on
	 * @param {string} prop name of the property to search for
	 * @param {Function} callback function to receive the found properties and their parent
	 */
	findProperties: function findProperties(obj, prop, callback) {
		if (typeof obj !== 'object' || obj === null) { return; }
		if (prop in obj) {
			callback(obj[prop], obj, prop);
		}
		Object.keys(obj).forEach(function (key) {
			findProperties(obj[key], prop, callback);
		});
	}

};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2013-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var attempt = __webpack_require__(240);

/**
 * Create a promise whose work is started only when a handler is registered.
 *
 * The work function will be invoked at most once. Thrown values will result
 * in promise rejection.
 *
 * @param {Function} work function whose ouput is used to resolve the
 *   returned promise.
 * @returns {Promise} a lazy promise
 */
function lazyPromise(work) {
	var started, resolver, promise, then;

	started = false;

	promise = new Promise(function (resolve, reject) {
		resolver = {
			resolve: resolve,
			reject: reject
		};
	});
	then = promise.then;

	promise.then = function () {
		if (!started) {
			started = true;
			attempt(work).then(resolver.resolve, resolver.reject);
		}
		return then.apply(promise, arguments);
	};

	return promise;
}

module.exports = lazyPromise;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



/**
 * Create a new JSON converter with custom reviver/replacer.
 *
 * The extended converter must be published to a MIME registry in order
 * to be used. The existing converter will not be modified.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON
 *
 * @param {function} [reviver=undefined] custom JSON.parse reviver
 * @param {function|Array} [replacer=undefined] custom JSON.stringify replacer
 */
function createConverter(reviver, replacer) {
	return {

		read: function (str) {
			return JSON.parse(str, reviver);
		},

		write: function (obj) {
			return JSON.stringify(obj, replacer);
		},

		extend: createConverter

	};
}

module.exports = createConverter();


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Michael Jackson
 */

/* global FormData, File, Blob */



function isFormElement(object) {
	return object &&
		object.nodeType === 1 && // Node.ELEMENT_NODE
		object.tagName === 'FORM';
}

function createFormDataFromObject(object) {
	var formData = new FormData();

	var value;
	for (var property in object) {
		if (object.hasOwnProperty(property)) {
			value = object[property];

			if (value instanceof File) {
				formData.append(property, value, value.name);
			} else if (value instanceof Blob) {
				formData.append(property, value);
			} else {
				formData.append(property, String(value));
			}
		}
	}

	return formData;
}

module.exports = {

	write: function (object) {
		if (typeof FormData === 'undefined') {
			throw new Error('The multipart/form-data mime serializer requires FormData support');
		}

		// Support FormData directly.
		if (object instanceof FormData) {
			return object;
		}

		// Support <form> elements.
		if (isFormElement(object)) {
			return new FormData(object);
		}

		// Support plain objects, may contain File/Blob as value.
		if (typeof object === 'object' && object !== null) {
			return createFormDataFromObject(object);
		}

		throw new Error('Unable to create FormData from object ' + object);
	}

};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



module.exports = {

	read: function (str) {
		return str;
	},

	write: function (obj) {
		return obj.toString();
	}

};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor, UrlBuilder;

interceptor = __webpack_require__(60);
UrlBuilder = __webpack_require__(238);

/**
 * Applies request params to the path by token replacement
 *
 * Params not applied as a token are appended to the query string. Params
 * are removed from the request object, as they have been consumed.
 *
 * @deprecated The template interceptor `rest/interceptor/template` is a
 * much richer way to apply paramters to a template. This interceptor is
 * available as a bridge to users who previousled depended on this
 * functionality being available directly on clients.
 *
 * @param {Client} [client] client to wrap
 * @param {Object} [config.params] default param values
 *
 * @returns {Client}
 */
module.exports = interceptor({
	init: function (config) {
		config.params = config.params || {};
		return config;
	},
	request: function (request, config) {
		var path, params;

		path = request.path || '';
		params = request.params || {};

		request.path = new UrlBuilder(path, config.params).append('', params).build();
		delete request.params;

		return request;
	}
});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */



var interceptor;

interceptor = __webpack_require__(60);

/**
 * Rejects the response promise based on the status code.
 *
 * Codes greater than or equal to the provided value are rejected.  Default
 * value 400.
 *
 * @param {Client} [client] client to wrap
 * @param {number} [config.code=400] code to indicate a rejection
 *
 * @returns {Client}
 */
module.exports = interceptor({
	init: function (config) {
		config.code = config.code || 400;
		return config;
	},
	response: function (response, config) {
		if (response.status && response.status.code >= config.code) {
			return Promise.reject(response);
		}
		return response;
	}
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */

/**
 * Promises/A+ and when() implementation
 * when is part of the cujoJS family of libraries (http://cujojs.com/)
 * @author Brian Cavalier
 * @author John Hann
 */
(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

	var timed = __webpack_require__(703);
	var array = __webpack_require__(705);
	var flow = __webpack_require__(706);
	var fold = __webpack_require__(707);
	var inspect = __webpack_require__(708);
	var generate = __webpack_require__(709);
	var progress = __webpack_require__(710);
	var withThis = __webpack_require__(711);
	var unhandledRejection = __webpack_require__(712);
	var TimeoutError = __webpack_require__(241);

	var Promise = [array, flow, fold, generate, progress,
		inspect, withThis, timed, unhandledRejection]
		.reduce(function(Promise, feature) {
			return feature(Promise);
		}, __webpack_require__(714));

	var apply = __webpack_require__(243)(Promise);

	// Public API

	when.promise     = promise;              // Create a pending promise
	when.resolve     = Promise.resolve;      // Create a resolved promise
	when.reject      = Promise.reject;       // Create a rejected promise

	when.lift        = lift;                 // lift a function to return promises
	when['try']      = attempt;              // call a function and return a promise
	when.attempt     = attempt;              // alias for when.try

	when.iterate     = Promise.iterate;      // DEPRECATED (use cujojs/most streams) Generate a stream of promises
	when.unfold      = Promise.unfold;       // DEPRECATED (use cujojs/most streams) Generate a stream of promises

	when.join        = join;                 // Join 2 or more promises

	when.all         = all;                  // Resolve a list of promises
	when.settle      = settle;               // Settle a list of promises

	when.any         = lift(Promise.any);    // One-winner race
	when.some        = lift(Promise.some);   // Multi-winner race
	when.race        = lift(Promise.race);   // First-to-settle race

	when.map         = map;                  // Array.map() for promises
	when.filter      = filter;               // Array.filter() for promises
	when.reduce      = lift(Promise.reduce);       // Array.reduce() for promises
	when.reduceRight = lift(Promise.reduceRight);  // Array.reduceRight() for promises

	when.isPromiseLike = isPromiseLike;      // Is something promise-like, aka thenable

	when.Promise     = Promise;              // Promise constructor
	when.defer       = defer;                // Create a {promise, resolve, reject} tuple

	// Error types

	when.TimeoutError = TimeoutError;

	/**
	 * Get a trusted promise for x, or by transforming x with onFulfilled
	 *
	 * @param {*} x
	 * @param {function?} onFulfilled callback to be called when x is
	 *   successfully fulfilled.  If promiseOrValue is an immediate value, callback
	 *   will be invoked immediately.
	 * @param {function?} onRejected callback to be called when x is
	 *   rejected.
	 * @param {function?} onProgress callback to be called when progress updates
	 *   are issued for x. @deprecated
	 * @returns {Promise} a new promise that will fulfill with the return
	 *   value of callback or errback or the completion value of promiseOrValue if
	 *   callback and/or errback is not supplied.
	 */
	function when(x, onFulfilled, onRejected, onProgress) {
		var p = Promise.resolve(x);
		if (arguments.length < 2) {
			return p;
		}

		return p.then(onFulfilled, onRejected, onProgress);
	}

	/**
	 * Creates a new promise whose fate is determined by resolver.
	 * @param {function} resolver function(resolve, reject, notify)
	 * @returns {Promise} promise whose fate is determine by resolver
	 */
	function promise(resolver) {
		return new Promise(resolver);
	}

	/**
	 * Lift the supplied function, creating a version of f that returns
	 * promises, and accepts promises as arguments.
	 * @param {function} f
	 * @returns {Function} version of f that returns promises
	 */
	function lift(f) {
		return function() {
			for(var i=0, l=arguments.length, a=new Array(l); i<l; ++i) {
				a[i] = arguments[i];
			}
			return apply(f, this, a);
		};
	}

	/**
	 * Call f in a future turn, with the supplied args, and return a promise
	 * for the result.
	 * @param {function} f
	 * @returns {Promise}
	 */
	function attempt(f /*, args... */) {
		/*jshint validthis:true */
		for(var i=0, l=arguments.length-1, a=new Array(l); i<l; ++i) {
			a[i] = arguments[i+1];
		}
		return apply(f, this, a);
	}

	/**
	 * Creates a {promise, resolver} pair, either or both of which
	 * may be given out safely to consumers.
	 * @return {{promise: Promise, resolve: function, reject: function, notify: function}}
	 */
	function defer() {
		return new Deferred();
	}

	function Deferred() {
		var p = Promise._defer();

		function resolve(x) { p._handler.resolve(x); }
		function reject(x) { p._handler.reject(x); }
		function notify(x) { p._handler.notify(x); }

		this.promise = p;
		this.resolve = resolve;
		this.reject = reject;
		this.notify = notify;
		this.resolver = { resolve: resolve, reject: reject, notify: notify };
	}

	/**
	 * Determines if x is promise-like, i.e. a thenable object
	 * NOTE: Will return true for *any thenable object*, and isn't truly
	 * safe, since it may attempt to access the `then` property of x (i.e.
	 *  clever/malicious getters may do weird things)
	 * @param {*} x anything
	 * @returns {boolean} true if x is promise-like
	 */
	function isPromiseLike(x) {
		return x && typeof x.then === 'function';
	}

	/**
	 * Return a promise that will resolve only once all the supplied arguments
	 * have resolved. The resolution value of the returned promise will be an array
	 * containing the resolution values of each of the arguments.
	 * @param {...*} arguments may be a mix of promises and values
	 * @returns {Promise}
	 */
	function join(/* ...promises */) {
		return Promise.all(arguments);
	}

	/**
	 * Return a promise that will fulfill once all input promises have
	 * fulfilled, or reject when any one input promise rejects.
	 * @param {array|Promise} promises array (or promise for an array) of promises
	 * @returns {Promise}
	 */
	function all(promises) {
		return when(promises, Promise.all);
	}

	/**
	 * Return a promise that will always fulfill with an array containing
	 * the outcome states of all input promises.  The returned promise
	 * will only reject if `promises` itself is a rejected promise.
	 * @param {array|Promise} promises array (or promise for an array) of promises
	 * @returns {Promise} promise for array of settled state descriptors
	 */
	function settle(promises) {
		return when(promises, Promise.settle);
	}

	/**
	 * Promise-aware array map function, similar to `Array.prototype.map()`,
	 * but input array may contain promises or values.
	 * @param {Array|Promise} promises array of anything, may contain promises and values
	 * @param {function(x:*, index:Number):*} mapFunc map function which may
	 *  return a promise or value
	 * @returns {Promise} promise that will fulfill with an array of mapped values
	 *  or reject if any input promise rejects.
	 */
	function map(promises, mapFunc) {
		return when(promises, function(promises) {
			return Promise.map(promises, mapFunc);
		});
	}

	/**
	 * Filter the provided array of promises using the provided predicate.  Input may
	 * contain promises and values
	 * @param {Array|Promise} promises array of promises and values
	 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
	 *  Must return truthy (or promise for truthy) for items to retain.
	 * @returns {Promise} promise that will fulfill with an array containing all items
	 *  for which predicate returned truthy.
	 */
	function filter(promises, predicate) {
		return when(promises, function(promises) {
			return Promise.filter(promises, predicate);
		});
	}

	return when;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
})(__webpack_require__(26));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require) {

	var env = __webpack_require__(160);
	var TimeoutError = __webpack_require__(241);

	function setTimeout(f, ms, x, y) {
		return env.setTimer(function() {
			f(x, y, ms);
		}, ms);
	}

	return function timed(Promise) {
		/**
		 * Return a new promise whose fulfillment value is revealed only
		 * after ms milliseconds
		 * @param {number} ms milliseconds
		 * @returns {Promise}
		 */
		Promise.prototype.delay = function(ms) {
			var p = this._beget();
			this._handler.fold(handleDelay, ms, void 0, p._handler);
			return p;
		};

		function handleDelay(ms, x, h) {
			setTimeout(resolveDelay, ms, x, h);
		}

		function resolveDelay(x, h) {
			h.resolve(x);
		}

		/**
		 * Return a new promise that rejects after ms milliseconds unless
		 * this promise fulfills earlier, in which case the returned promise
		 * fulfills with the same value.
		 * @param {number} ms milliseconds
		 * @param {Error|*=} reason optional rejection reason to use, defaults
		 *   to a TimeoutError if not provided
		 * @returns {Promise}
		 */
		Promise.prototype.timeout = function(ms, reason) {
			var p = this._beget();
			var h = p._handler;

			var t = setTimeout(onTimeout, ms, reason, p._handler);

			this._handler.visit(h,
				function onFulfill(x) {
					env.clearTimer(t);
					this.resolve(x); // this = h
				},
				function onReject(x) {
					env.clearTimer(t);
					this.reject(x); // this = h
				},
				h.notify);

			return p;
		};

		function onTimeout(reason, h, ms) {
			var e = typeof reason === 'undefined'
				? new TimeoutError('timed out after ' + ms + 'ms')
				: reason;
			h.reject(e);
		}

		return Promise;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require) {

	var state = __webpack_require__(242);
	var applier = __webpack_require__(243);

	return function array(Promise) {

		var applyFold = applier(Promise);
		var toPromise = Promise.resolve;
		var all = Promise.all;

		var ar = Array.prototype.reduce;
		var arr = Array.prototype.reduceRight;
		var slice = Array.prototype.slice;

		// Additional array combinators

		Promise.any = any;
		Promise.some = some;
		Promise.settle = settle;

		Promise.map = map;
		Promise.filter = filter;
		Promise.reduce = reduce;
		Promise.reduceRight = reduceRight;

		/**
		 * When this promise fulfills with an array, do
		 * onFulfilled.apply(void 0, array)
		 * @param {function} onFulfilled function to apply
		 * @returns {Promise} promise for the result of applying onFulfilled
		 */
		Promise.prototype.spread = function(onFulfilled) {
			return this.then(all).then(function(array) {
				return onFulfilled.apply(this, array);
			});
		};

		return Promise;

		/**
		 * One-winner competitive race.
		 * Return a promise that will fulfill when one of the promises
		 * in the input array fulfills, or will reject when all promises
		 * have rejected.
		 * @param {array} promises
		 * @returns {Promise} promise for the first fulfilled value
		 */
		function any(promises) {
			var p = Promise._defer();
			var resolver = p._handler;
			var l = promises.length>>>0;

			var pending = l;
			var errors = [];

			for (var h, x, i = 0; i < l; ++i) {
				x = promises[i];
				if(x === void 0 && !(i in promises)) {
					--pending;
					continue;
				}

				h = Promise._handler(x);
				if(h.state() > 0) {
					resolver.become(h);
					Promise._visitRemaining(promises, i, h);
					break;
				} else {
					h.visit(resolver, handleFulfill, handleReject);
				}
			}

			if(pending === 0) {
				resolver.reject(new RangeError('any(): array must not be empty'));
			}

			return p;

			function handleFulfill(x) {
				/*jshint validthis:true*/
				errors = null;
				this.resolve(x); // this === resolver
			}

			function handleReject(e) {
				/*jshint validthis:true*/
				if(this.resolved) { // this === resolver
					return;
				}

				errors.push(e);
				if(--pending === 0) {
					this.reject(errors);
				}
			}
		}

		/**
		 * N-winner competitive race
		 * Return a promise that will fulfill when n input promises have
		 * fulfilled, or will reject when it becomes impossible for n
		 * input promises to fulfill (ie when promises.length - n + 1
		 * have rejected)
		 * @param {array} promises
		 * @param {number} n
		 * @returns {Promise} promise for the earliest n fulfillment values
		 *
		 * @deprecated
		 */
		function some(promises, n) {
			/*jshint maxcomplexity:7*/
			var p = Promise._defer();
			var resolver = p._handler;

			var results = [];
			var errors = [];

			var l = promises.length>>>0;
			var nFulfill = 0;
			var nReject;
			var x, i; // reused in both for() loops

			// First pass: count actual array items
			for(i=0; i<l; ++i) {
				x = promises[i];
				if(x === void 0 && !(i in promises)) {
					continue;
				}
				++nFulfill;
			}

			// Compute actual goals
			n = Math.max(n, 0);
			nReject = (nFulfill - n + 1);
			nFulfill = Math.min(n, nFulfill);

			if(n > nFulfill) {
				resolver.reject(new RangeError('some(): array must contain at least '
				+ n + ' item(s), but had ' + nFulfill));
			} else if(nFulfill === 0) {
				resolver.resolve(results);
			}

			// Second pass: observe each array item, make progress toward goals
			for(i=0; i<l; ++i) {
				x = promises[i];
				if(x === void 0 && !(i in promises)) {
					continue;
				}

				Promise._handler(x).visit(resolver, fulfill, reject, resolver.notify);
			}

			return p;

			function fulfill(x) {
				/*jshint validthis:true*/
				if(this.resolved) { // this === resolver
					return;
				}

				results.push(x);
				if(--nFulfill === 0) {
					errors = null;
					this.resolve(results);
				}
			}

			function reject(e) {
				/*jshint validthis:true*/
				if(this.resolved) { // this === resolver
					return;
				}

				errors.push(e);
				if(--nReject === 0) {
					results = null;
					this.reject(errors);
				}
			}
		}

		/**
		 * Apply f to the value of each promise in a list of promises
		 * and return a new list containing the results.
		 * @param {array} promises
		 * @param {function(x:*, index:Number):*} f mapping function
		 * @returns {Promise}
		 */
		function map(promises, f) {
			return Promise._traverse(f, promises);
		}

		/**
		 * Filter the provided array of promises using the provided predicate.  Input may
		 * contain promises and values
		 * @param {Array} promises array of promises and values
		 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
		 *  Must return truthy (or promise for truthy) for items to retain.
		 * @returns {Promise} promise that will fulfill with an array containing all items
		 *  for which predicate returned truthy.
		 */
		function filter(promises, predicate) {
			var a = slice.call(promises);
			return Promise._traverse(predicate, a).then(function(keep) {
				return filterSync(a, keep);
			});
		}

		function filterSync(promises, keep) {
			// Safe because we know all promises have fulfilled if we've made it this far
			var l = keep.length;
			var filtered = new Array(l);
			for(var i=0, j=0; i<l; ++i) {
				if(keep[i]) {
					filtered[j++] = Promise._handler(promises[i]).value;
				}
			}
			filtered.length = j;
			return filtered;

		}

		/**
		 * Return a promise that will always fulfill with an array containing
		 * the outcome states of all input promises.  The returned promise
		 * will never reject.
		 * @param {Array} promises
		 * @returns {Promise} promise for array of settled state descriptors
		 */
		function settle(promises) {
			return all(promises.map(settleOne));
		}

		function settleOne(p) {
			// Optimize the case where we get an already-resolved when.js promise
			//  by extracting its state:
			var handler;
			if (p instanceof Promise) {
				// This is our own Promise type and we can reach its handler internals:
				handler = p._handler.join();
			}
			if((handler && handler.state() === 0) || !handler) {
				// Either still pending, or not a Promise at all:
				return toPromise(p).then(state.fulfilled, state.rejected);
			}

			// The promise is our own, but it is already resolved. Take a shortcut.
			// Since we're not actually handling the resolution, we need to disable
			// rejection reporting.
			handler._unreport();
			return state.inspect(handler);
		}

		/**
		 * Traditional reduce function, similar to `Array.prototype.reduce()`, but
		 * input may contain promises and/or values, and reduceFunc
		 * may return either a value or a promise, *and* initialValue may
		 * be a promise for the starting value.
		 * @param {Array|Promise} promises array or promise for an array of anything,
		 *      may contain a mix of promises and values.
		 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
		 * @returns {Promise} that will resolve to the final reduced value
		 */
		function reduce(promises, f /*, initialValue */) {
			return arguments.length > 2 ? ar.call(promises, liftCombine(f), arguments[2])
					: ar.call(promises, liftCombine(f));
		}

		/**
		 * Traditional reduce function, similar to `Array.prototype.reduceRight()`, but
		 * input may contain promises and/or values, and reduceFunc
		 * may return either a value or a promise, *and* initialValue may
		 * be a promise for the starting value.
		 * @param {Array|Promise} promises array or promise for an array of anything,
		 *      may contain a mix of promises and values.
		 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
		 * @returns {Promise} that will resolve to the final reduced value
		 */
		function reduceRight(promises, f /*, initialValue */) {
			return arguments.length > 2 ? arr.call(promises, liftCombine(f), arguments[2])
					: arr.call(promises, liftCombine(f));
		}

		function liftCombine(f) {
			return function(z, x, i) {
				return applyFold(f, void 0, [z,x,i]);
			};
		}
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function flow(Promise) {

		var resolve = Promise.resolve;
		var reject = Promise.reject;
		var origCatch = Promise.prototype['catch'];

		/**
		 * Handle the ultimate fulfillment value or rejection reason, and assume
		 * responsibility for all errors.  If an error propagates out of result
		 * or handleFatalError, it will be rethrown to the host, resulting in a
		 * loud stack track on most platforms and a crash on some.
		 * @param {function?} onResult
		 * @param {function?} onError
		 * @returns {undefined}
		 */
		Promise.prototype.done = function(onResult, onError) {
			this._handler.visit(this._handler.receiver, onResult, onError);
		};

		/**
		 * Add Error-type and predicate matching to catch.  Examples:
		 * promise.catch(TypeError, handleTypeError)
		 *   .catch(predicate, handleMatchedErrors)
		 *   .catch(handleRemainingErrors)
		 * @param onRejected
		 * @returns {*}
		 */
		Promise.prototype['catch'] = Promise.prototype.otherwise = function(onRejected) {
			if (arguments.length < 2) {
				return origCatch.call(this, onRejected);
			}

			if(typeof onRejected !== 'function') {
				return this.ensure(rejectInvalidPredicate);
			}

			return origCatch.call(this, createCatchFilter(arguments[1], onRejected));
		};

		/**
		 * Wraps the provided catch handler, so that it will only be called
		 * if the predicate evaluates truthy
		 * @param {?function} handler
		 * @param {function} predicate
		 * @returns {function} conditional catch handler
		 */
		function createCatchFilter(handler, predicate) {
			return function(e) {
				return evaluatePredicate(e, predicate)
					? handler.call(this, e)
					: reject(e);
			};
		}

		/**
		 * Ensures that onFulfilledOrRejected will be called regardless of whether
		 * this promise is fulfilled or rejected.  onFulfilledOrRejected WILL NOT
		 * receive the promises' value or reason.  Any returned value will be disregarded.
		 * onFulfilledOrRejected may throw or return a rejected promise to signal
		 * an additional error.
		 * @param {function} handler handler to be called regardless of
		 *  fulfillment or rejection
		 * @returns {Promise}
		 */
		Promise.prototype['finally'] = Promise.prototype.ensure = function(handler) {
			if(typeof handler !== 'function') {
				return this;
			}

			return this.then(function(x) {
				return runSideEffect(handler, this, identity, x);
			}, function(e) {
				return runSideEffect(handler, this, reject, e);
			});
		};

		function runSideEffect (handler, thisArg, propagate, value) {
			var result = handler.call(thisArg);
			return maybeThenable(result)
				? propagateValue(result, propagate, value)
				: propagate(value);
		}

		function propagateValue (result, propagate, x) {
			return resolve(result).then(function () {
				return propagate(x);
			});
		}

		/**
		 * Recover from a failure by returning a defaultValue.  If defaultValue
		 * is a promise, it's fulfillment value will be used.  If defaultValue is
		 * a promise that rejects, the returned promise will reject with the
		 * same reason.
		 * @param {*} defaultValue
		 * @returns {Promise} new promise
		 */
		Promise.prototype['else'] = Promise.prototype.orElse = function(defaultValue) {
			return this.then(void 0, function() {
				return defaultValue;
			});
		};

		/**
		 * Shortcut for .then(function() { return value; })
		 * @param  {*} value
		 * @return {Promise} a promise that:
		 *  - is fulfilled if value is not a promise, or
		 *  - if value is a promise, will fulfill with its value, or reject
		 *    with its reason.
		 */
		Promise.prototype['yield'] = function(value) {
			return this.then(function() {
				return value;
			});
		};

		/**
		 * Runs a side effect when this promise fulfills, without changing the
		 * fulfillment value.
		 * @param {function} onFulfilledSideEffect
		 * @returns {Promise}
		 */
		Promise.prototype.tap = function(onFulfilledSideEffect) {
			return this.then(onFulfilledSideEffect)['yield'](this);
		};

		return Promise;
	};

	function rejectInvalidPredicate() {
		throw new TypeError('catch predicate must be a function');
	}

	function evaluatePredicate(e, predicate) {
		return isError(predicate) ? e instanceof predicate : predicate(e);
	}

	function isError(predicate) {
		return predicate === Error
			|| (predicate != null && predicate.prototype instanceof Error);
	}

	function maybeThenable(x) {
		return (typeof x === 'object' || typeof x === 'function') && x !== null;
	}

	function identity(x) {
		return x;
	}

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */
/** @author Jeff Escalante */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function fold(Promise) {

		Promise.prototype.fold = function(f, z) {
			var promise = this._beget();

			this._handler.fold(function(z, x, to) {
				Promise._handler(z).fold(function(x, z, to) {
					to.resolve(f.call(this, z, x));
				}, x, this, to);
			}, z, promise._handler.receiver, promise._handler);

			return promise;
		};

		return Promise;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require) {

	var inspect = __webpack_require__(242).inspect;

	return function inspection(Promise) {

		Promise.prototype.inspect = function() {
			return inspect(Promise._handler(this));
		};

		return Promise;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function generate(Promise) {

		var resolve = Promise.resolve;

		Promise.iterate = iterate;
		Promise.unfold = unfold;

		return Promise;

		/**
		 * @deprecated Use github.com/cujojs/most streams and most.iterate
		 * Generate a (potentially infinite) stream of promised values:
		 * x, f(x), f(f(x)), etc. until condition(x) returns true
		 * @param {function} f function to generate a new x from the previous x
		 * @param {function} condition function that, given the current x, returns
		 *  truthy when the iterate should stop
		 * @param {function} handler function to handle the value produced by f
		 * @param {*|Promise} x starting value, may be a promise
		 * @return {Promise} the result of the last call to f before
		 *  condition returns true
		 */
		function iterate(f, condition, handler, x) {
			return unfold(function(x) {
				return [x, f(x)];
			}, condition, handler, x);
		}

		/**
		 * @deprecated Use github.com/cujojs/most streams and most.unfold
		 * Generate a (potentially infinite) stream of promised values
		 * by applying handler(generator(seed)) iteratively until
		 * condition(seed) returns true.
		 * @param {function} unspool function that generates a [value, newSeed]
		 *  given a seed.
		 * @param {function} condition function that, given the current seed, returns
		 *  truthy when the unfold should stop
		 * @param {function} handler function to handle the value produced by unspool
		 * @param x {*|Promise} starting value, may be a promise
		 * @return {Promise} the result of the last value produced by unspool before
		 *  condition returns true
		 */
		function unfold(unspool, condition, handler, x) {
			return resolve(x).then(function(seed) {
				return resolve(condition(seed)).then(function(done) {
					return done ? seed : resolve(unspool(seed)).spread(next);
				});
			});

			function next(item, newSeed) {
				return resolve(handler(item)).then(function() {
					return unfold(unspool, condition, handler, newSeed);
				});
			}
		}
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function progress(Promise) {

		/**
		 * @deprecated
		 * Register a progress handler for this promise
		 * @param {function} onProgress
		 * @returns {Promise}
		 */
		Promise.prototype.progress = function(onProgress) {
			return this.then(void 0, void 0, onProgress);
		};

		return Promise;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function addWith(Promise) {
		/**
		 * Returns a promise whose handlers will be called with `this` set to
		 * the supplied receiver.  Subsequent promises derived from the
		 * returned promise will also have their handlers called with receiver
		 * as `this`. Calling `with` with undefined or no arguments will return
		 * a promise whose handlers will again be called in the usual Promises/A+
		 * way (no `this`) thus safely undoing any previous `with` in the
		 * promise chain.
		 *
		 * WARNING: Promises returned from `with`/`withThis` are NOT Promises/A+
		 * compliant, specifically violating 2.2.5 (http://promisesaplus.com/#point-41)
		 *
		 * @param {object} receiver `this` value for all handlers attached to
		 *  the returned promise.
		 * @returns {Promise}
		 */
		Promise.prototype['with'] = Promise.prototype.withThis = function(receiver) {
			var p = this._beget();
			var child = p._handler;
			child.receiver = receiver;
			this._handler.chain(child, receiver);
			return p;
		};

		return Promise;
	};

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));



/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require) {

	var setTimer = __webpack_require__(160).setTimer;
	var format = __webpack_require__(713);

	return function unhandledRejection(Promise) {

		var logError = noop;
		var logInfo = noop;
		var localConsole;

		if(typeof console !== 'undefined') {
			// Alias console to prevent things like uglify's drop_console option from
			// removing console.log/error. Unhandled rejections fall into the same
			// category as uncaught exceptions, and build tools shouldn't silence them.
			localConsole = console;
			logError = typeof localConsole.error !== 'undefined'
				? function (e) { localConsole.error(e); }
				: function (e) { localConsole.log(e); };

			logInfo = typeof localConsole.info !== 'undefined'
				? function (e) { localConsole.info(e); }
				: function (e) { localConsole.log(e); };
		}

		Promise.onPotentiallyUnhandledRejection = function(rejection) {
			enqueue(report, rejection);
		};

		Promise.onPotentiallyUnhandledRejectionHandled = function(rejection) {
			enqueue(unreport, rejection);
		};

		Promise.onFatalRejection = function(rejection) {
			enqueue(throwit, rejection.value);
		};

		var tasks = [];
		var reported = [];
		var running = null;

		function report(r) {
			if(!r.handled) {
				reported.push(r);
				logError('Potentially unhandled rejection [' + r.id + '] ' + format.formatError(r.value));
			}
		}

		function unreport(r) {
			var i = reported.indexOf(r);
			if(i >= 0) {
				reported.splice(i, 1);
				logInfo('Handled previous rejection [' + r.id + '] ' + format.formatObject(r.value));
			}
		}

		function enqueue(f, x) {
			tasks.push(f, x);
			if(running === null) {
				running = setTimer(flush, 0);
			}
		}

		function flush() {
			running = null;
			while(tasks.length > 0) {
				tasks.shift()(tasks.shift());
			}
		}

		return Promise;
	};

	function throwit(e) {
		throw e;
	}

	function noop() {}

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return {
		formatError: formatError,
		formatObject: formatObject,
		tryStringify: tryStringify
	};

	/**
	 * Format an error into a string.  If e is an Error and has a stack property,
	 * it's returned.  Otherwise, e is formatted using formatObject, with a
	 * warning added about e not being a proper Error.
	 * @param {*} e
	 * @returns {String} formatted string, suitable for output to developers
	 */
	function formatError(e) {
		var s = typeof e === 'object' && e !== null && (e.stack || e.message) ? e.stack || e.message : formatObject(e);
		return e instanceof Error ? s : s + ' (WARNING: non-Error used)';
	}

	/**
	 * Format an object, detecting "plain" objects and running them through
	 * JSON.stringify if possible.
	 * @param {Object} o
	 * @returns {string}
	 */
	function formatObject(o) {
		var s = String(o);
		if(s === '[object Object]' && typeof JSON !== 'undefined') {
			s = tryStringify(o, s);
		}
		return s;
	}

	/**
	 * Try to return the result of JSON.stringify(x).  If that fails, return
	 * defaultValue
	 * @param {*} x
	 * @param {*} defaultValue
	 * @returns {String|*} JSON.stringify(x) or defaultValue
	 */
	function tryStringify(x, defaultValue) {
		try {
			return JSON.stringify(x);
		} catch(e) {
			return defaultValue;
		}
	}

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

	var makePromise = __webpack_require__(715);
	var Scheduler = __webpack_require__(716);
	var async = __webpack_require__(160).asap;

	return makePromise({
		scheduler: new Scheduler(async)
	});

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
})(__webpack_require__(26));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	return function makePromise(environment) {

		var tasks = environment.scheduler;
		var emitRejection = initEmitRejection();

		var objectCreate = Object.create ||
			function(proto) {
				function Child() {}
				Child.prototype = proto;
				return new Child();
			};

		/**
		 * Create a promise whose fate is determined by resolver
		 * @constructor
		 * @returns {Promise} promise
		 * @name Promise
		 */
		function Promise(resolver, handler) {
			this._handler = resolver === Handler ? handler : init(resolver);
		}

		/**
		 * Run the supplied resolver
		 * @param resolver
		 * @returns {Pending}
		 */
		function init(resolver) {
			var handler = new Pending();

			try {
				resolver(promiseResolve, promiseReject, promiseNotify);
			} catch (e) {
				promiseReject(e);
			}

			return handler;

			/**
			 * Transition from pre-resolution state to post-resolution state, notifying
			 * all listeners of the ultimate fulfillment or rejection
			 * @param {*} x resolution value
			 */
			function promiseResolve (x) {
				handler.resolve(x);
			}
			/**
			 * Reject this promise with reason, which will be used verbatim
			 * @param {Error|*} reason rejection reason, strongly suggested
			 *   to be an Error type
			 */
			function promiseReject (reason) {
				handler.reject(reason);
			}

			/**
			 * @deprecated
			 * Issue a progress event, notifying all progress listeners
			 * @param {*} x progress event payload to pass to all listeners
			 */
			function promiseNotify (x) {
				handler.notify(x);
			}
		}

		// Creation

		Promise.resolve = resolve;
		Promise.reject = reject;
		Promise.never = never;

		Promise._defer = defer;
		Promise._handler = getHandler;

		/**
		 * Returns a trusted promise. If x is already a trusted promise, it is
		 * returned, otherwise returns a new trusted Promise which follows x.
		 * @param  {*} x
		 * @return {Promise} promise
		 */
		function resolve(x) {
			return isPromise(x) ? x
				: new Promise(Handler, new Async(getHandler(x)));
		}

		/**
		 * Return a reject promise with x as its reason (x is used verbatim)
		 * @param {*} x
		 * @returns {Promise} rejected promise
		 */
		function reject(x) {
			return new Promise(Handler, new Async(new Rejected(x)));
		}

		/**
		 * Return a promise that remains pending forever
		 * @returns {Promise} forever-pending promise.
		 */
		function never() {
			return foreverPendingPromise; // Should be frozen
		}

		/**
		 * Creates an internal {promise, resolver} pair
		 * @private
		 * @returns {Promise}
		 */
		function defer() {
			return new Promise(Handler, new Pending());
		}

		// Transformation and flow control

		/**
		 * Transform this promise's fulfillment value, returning a new Promise
		 * for the transformed result.  If the promise cannot be fulfilled, onRejected
		 * is called with the reason.  onProgress *may* be called with updates toward
		 * this promise's fulfillment.
		 * @param {function=} onFulfilled fulfillment handler
		 * @param {function=} onRejected rejection handler
		 * @param {function=} onProgress @deprecated progress handler
		 * @return {Promise} new promise
		 */
		Promise.prototype.then = function(onFulfilled, onRejected, onProgress) {
			var parent = this._handler;
			var state = parent.join().state();

			if ((typeof onFulfilled !== 'function' && state > 0) ||
				(typeof onRejected !== 'function' && state < 0)) {
				// Short circuit: value will not change, simply share handler
				return new this.constructor(Handler, parent);
			}

			var p = this._beget();
			var child = p._handler;

			parent.chain(child, parent.receiver, onFulfilled, onRejected, onProgress);

			return p;
		};

		/**
		 * If this promise cannot be fulfilled due to an error, call onRejected to
		 * handle the error. Shortcut for .then(undefined, onRejected)
		 * @param {function?} onRejected
		 * @return {Promise}
		 */
		Promise.prototype['catch'] = function(onRejected) {
			return this.then(void 0, onRejected);
		};

		/**
		 * Creates a new, pending promise of the same type as this promise
		 * @private
		 * @returns {Promise}
		 */
		Promise.prototype._beget = function() {
			return begetFrom(this._handler, this.constructor);
		};

		function begetFrom(parent, Promise) {
			var child = new Pending(parent.receiver, parent.join().context);
			return new Promise(Handler, child);
		}

		// Array combinators

		Promise.all = all;
		Promise.race = race;
		Promise._traverse = traverse;

		/**
		 * Return a promise that will fulfill when all promises in the
		 * input array have fulfilled, or will reject when one of the
		 * promises rejects.
		 * @param {array} promises array of promises
		 * @returns {Promise} promise for array of fulfillment values
		 */
		function all(promises) {
			return traverseWith(snd, null, promises);
		}

		/**
		 * Array<Promise<X>> -> Promise<Array<f(X)>>
		 * @private
		 * @param {function} f function to apply to each promise's value
		 * @param {Array} promises array of promises
		 * @returns {Promise} promise for transformed values
		 */
		function traverse(f, promises) {
			return traverseWith(tryCatch2, f, promises);
		}

		function traverseWith(tryMap, f, promises) {
			var handler = typeof f === 'function' ? mapAt : settleAt;

			var resolver = new Pending();
			var pending = promises.length >>> 0;
			var results = new Array(pending);

			for (var i = 0, x; i < promises.length && !resolver.resolved; ++i) {
				x = promises[i];

				if (x === void 0 && !(i in promises)) {
					--pending;
					continue;
				}

				traverseAt(promises, handler, i, x, resolver);
			}

			if(pending === 0) {
				resolver.become(new Fulfilled(results));
			}

			return new Promise(Handler, resolver);

			function mapAt(i, x, resolver) {
				if(!resolver.resolved) {
					traverseAt(promises, settleAt, i, tryMap(f, x, i), resolver);
				}
			}

			function settleAt(i, x, resolver) {
				results[i] = x;
				if(--pending === 0) {
					resolver.become(new Fulfilled(results));
				}
			}
		}

		function traverseAt(promises, handler, i, x, resolver) {
			if (maybeThenable(x)) {
				var h = getHandlerMaybeThenable(x);
				var s = h.state();

				if (s === 0) {
					h.fold(handler, i, void 0, resolver);
				} else if (s > 0) {
					handler(i, h.value, resolver);
				} else {
					resolver.become(h);
					visitRemaining(promises, i+1, h);
				}
			} else {
				handler(i, x, resolver);
			}
		}

		Promise._visitRemaining = visitRemaining;
		function visitRemaining(promises, start, handler) {
			for(var i=start; i<promises.length; ++i) {
				markAsHandled(getHandler(promises[i]), handler);
			}
		}

		function markAsHandled(h, handler) {
			if(h === handler) {
				return;
			}

			var s = h.state();
			if(s === 0) {
				h.visit(h, void 0, h._unreport);
			} else if(s < 0) {
				h._unreport();
			}
		}

		/**
		 * Fulfill-reject competitive race. Return a promise that will settle
		 * to the same state as the earliest input promise to settle.
		 *
		 * WARNING: The ES6 Promise spec requires that race()ing an empty array
		 * must return a promise that is pending forever.  This implementation
		 * returns a singleton forever-pending promise, the same singleton that is
		 * returned by Promise.never(), thus can be checked with ===
		 *
		 * @param {array} promises array of promises to race
		 * @returns {Promise} if input is non-empty, a promise that will settle
		 * to the same outcome as the earliest input promise to settle. if empty
		 * is empty, returns a promise that will never settle.
		 */
		function race(promises) {
			if(typeof promises !== 'object' || promises === null) {
				return reject(new TypeError('non-iterable passed to race()'));
			}

			// Sigh, race([]) is untestable unless we return *something*
			// that is recognizable without calling .then() on it.
			return promises.length === 0 ? never()
				 : promises.length === 1 ? resolve(promises[0])
				 : runRace(promises);
		}

		function runRace(promises) {
			var resolver = new Pending();
			var i, x, h;
			for(i=0; i<promises.length; ++i) {
				x = promises[i];
				if (x === void 0 && !(i in promises)) {
					continue;
				}

				h = getHandler(x);
				if(h.state() !== 0) {
					resolver.become(h);
					visitRemaining(promises, i+1, h);
					break;
				} else {
					h.visit(resolver, resolver.resolve, resolver.reject);
				}
			}
			return new Promise(Handler, resolver);
		}

		// Promise internals
		// Below this, everything is @private

		/**
		 * Get an appropriate handler for x, without checking for cycles
		 * @param {*} x
		 * @returns {object} handler
		 */
		function getHandler(x) {
			if(isPromise(x)) {
				return x._handler.join();
			}
			return maybeThenable(x) ? getHandlerUntrusted(x) : new Fulfilled(x);
		}

		/**
		 * Get a handler for thenable x.
		 * NOTE: You must only call this if maybeThenable(x) == true
		 * @param {object|function|Promise} x
		 * @returns {object} handler
		 */
		function getHandlerMaybeThenable(x) {
			return isPromise(x) ? x._handler.join() : getHandlerUntrusted(x);
		}

		/**
		 * Get a handler for potentially untrusted thenable x
		 * @param {*} x
		 * @returns {object} handler
		 */
		function getHandlerUntrusted(x) {
			try {
				var untrustedThen = x.then;
				return typeof untrustedThen === 'function'
					? new Thenable(untrustedThen, x)
					: new Fulfilled(x);
			} catch(e) {
				return new Rejected(e);
			}
		}

		/**
		 * Handler for a promise that is pending forever
		 * @constructor
		 */
		function Handler() {}

		Handler.prototype.when
			= Handler.prototype.become
			= Handler.prototype.notify // deprecated
			= Handler.prototype.fail
			= Handler.prototype._unreport
			= Handler.prototype._report
			= noop;

		Handler.prototype._state = 0;

		Handler.prototype.state = function() {
			return this._state;
		};

		/**
		 * Recursively collapse handler chain to find the handler
		 * nearest to the fully resolved value.
		 * @returns {object} handler nearest the fully resolved value
		 */
		Handler.prototype.join = function() {
			var h = this;
			while(h.handler !== void 0) {
				h = h.handler;
			}
			return h;
		};

		Handler.prototype.chain = function(to, receiver, fulfilled, rejected, progress) {
			this.when({
				resolver: to,
				receiver: receiver,
				fulfilled: fulfilled,
				rejected: rejected,
				progress: progress
			});
		};

		Handler.prototype.visit = function(receiver, fulfilled, rejected, progress) {
			this.chain(failIfRejected, receiver, fulfilled, rejected, progress);
		};

		Handler.prototype.fold = function(f, z, c, to) {
			this.when(new Fold(f, z, c, to));
		};

		/**
		 * Handler that invokes fail() on any handler it becomes
		 * @constructor
		 */
		function FailIfRejected() {}

		inherit(Handler, FailIfRejected);

		FailIfRejected.prototype.become = function(h) {
			h.fail();
		};

		var failIfRejected = new FailIfRejected();

		/**
		 * Handler that manages a queue of consumers waiting on a pending promise
		 * @constructor
		 */
		function Pending(receiver, inheritedContext) {
			Promise.createContext(this, inheritedContext);

			this.consumers = void 0;
			this.receiver = receiver;
			this.handler = void 0;
			this.resolved = false;
		}

		inherit(Handler, Pending);

		Pending.prototype._state = 0;

		Pending.prototype.resolve = function(x) {
			this.become(getHandler(x));
		};

		Pending.prototype.reject = function(x) {
			if(this.resolved) {
				return;
			}

			this.become(new Rejected(x));
		};

		Pending.prototype.join = function() {
			if (!this.resolved) {
				return this;
			}

			var h = this;

			while (h.handler !== void 0) {
				h = h.handler;
				if (h === this) {
					return this.handler = cycle();
				}
			}

			return h;
		};

		Pending.prototype.run = function() {
			var q = this.consumers;
			var handler = this.handler;
			this.handler = this.handler.join();
			this.consumers = void 0;

			for (var i = 0; i < q.length; ++i) {
				handler.when(q[i]);
			}
		};

		Pending.prototype.become = function(handler) {
			if(this.resolved) {
				return;
			}

			this.resolved = true;
			this.handler = handler;
			if(this.consumers !== void 0) {
				tasks.enqueue(this);
			}

			if(this.context !== void 0) {
				handler._report(this.context);
			}
		};

		Pending.prototype.when = function(continuation) {
			if(this.resolved) {
				tasks.enqueue(new ContinuationTask(continuation, this.handler));
			} else {
				if(this.consumers === void 0) {
					this.consumers = [continuation];
				} else {
					this.consumers.push(continuation);
				}
			}
		};

		/**
		 * @deprecated
		 */
		Pending.prototype.notify = function(x) {
			if(!this.resolved) {
				tasks.enqueue(new ProgressTask(x, this));
			}
		};

		Pending.prototype.fail = function(context) {
			var c = typeof context === 'undefined' ? this.context : context;
			this.resolved && this.handler.join().fail(c);
		};

		Pending.prototype._report = function(context) {
			this.resolved && this.handler.join()._report(context);
		};

		Pending.prototype._unreport = function() {
			this.resolved && this.handler.join()._unreport();
		};

		/**
		 * Wrap another handler and force it into a future stack
		 * @param {object} handler
		 * @constructor
		 */
		function Async(handler) {
			this.handler = handler;
		}

		inherit(Handler, Async);

		Async.prototype.when = function(continuation) {
			tasks.enqueue(new ContinuationTask(continuation, this));
		};

		Async.prototype._report = function(context) {
			this.join()._report(context);
		};

		Async.prototype._unreport = function() {
			this.join()._unreport();
		};

		/**
		 * Handler that wraps an untrusted thenable and assimilates it in a future stack
		 * @param {function} then
		 * @param {{then: function}} thenable
		 * @constructor
		 */
		function Thenable(then, thenable) {
			Pending.call(this);
			tasks.enqueue(new AssimilateTask(then, thenable, this));
		}

		inherit(Pending, Thenable);

		/**
		 * Handler for a fulfilled promise
		 * @param {*} x fulfillment value
		 * @constructor
		 */
		function Fulfilled(x) {
			Promise.createContext(this);
			this.value = x;
		}

		inherit(Handler, Fulfilled);

		Fulfilled.prototype._state = 1;

		Fulfilled.prototype.fold = function(f, z, c, to) {
			runContinuation3(f, z, this, c, to);
		};

		Fulfilled.prototype.when = function(cont) {
			runContinuation1(cont.fulfilled, this, cont.receiver, cont.resolver);
		};

		var errorId = 0;

		/**
		 * Handler for a rejected promise
		 * @param {*} x rejection reason
		 * @constructor
		 */
		function Rejected(x) {
			Promise.createContext(this);

			this.id = ++errorId;
			this.value = x;
			this.handled = false;
			this.reported = false;

			this._report();
		}

		inherit(Handler, Rejected);

		Rejected.prototype._state = -1;

		Rejected.prototype.fold = function(f, z, c, to) {
			to.become(this);
		};

		Rejected.prototype.when = function(cont) {
			if(typeof cont.rejected === 'function') {
				this._unreport();
			}
			runContinuation1(cont.rejected, this, cont.receiver, cont.resolver);
		};

		Rejected.prototype._report = function(context) {
			tasks.afterQueue(new ReportTask(this, context));
		};

		Rejected.prototype._unreport = function() {
			if(this.handled) {
				return;
			}
			this.handled = true;
			tasks.afterQueue(new UnreportTask(this));
		};

		Rejected.prototype.fail = function(context) {
			this.reported = true;
			emitRejection('unhandledRejection', this);
			Promise.onFatalRejection(this, context === void 0 ? this.context : context);
		};

		function ReportTask(rejection, context) {
			this.rejection = rejection;
			this.context = context;
		}

		ReportTask.prototype.run = function() {
			if(!this.rejection.handled && !this.rejection.reported) {
				this.rejection.reported = true;
				emitRejection('unhandledRejection', this.rejection) ||
					Promise.onPotentiallyUnhandledRejection(this.rejection, this.context);
			}
		};

		function UnreportTask(rejection) {
			this.rejection = rejection;
		}

		UnreportTask.prototype.run = function() {
			if(this.rejection.reported) {
				emitRejection('rejectionHandled', this.rejection) ||
					Promise.onPotentiallyUnhandledRejectionHandled(this.rejection);
			}
		};

		// Unhandled rejection hooks
		// By default, everything is a noop

		Promise.createContext
			= Promise.enterContext
			= Promise.exitContext
			= Promise.onPotentiallyUnhandledRejection
			= Promise.onPotentiallyUnhandledRejectionHandled
			= Promise.onFatalRejection
			= noop;

		// Errors and singletons

		var foreverPendingHandler = new Handler();
		var foreverPendingPromise = new Promise(Handler, foreverPendingHandler);

		function cycle() {
			return new Rejected(new TypeError('Promise cycle'));
		}

		// Task runners

		/**
		 * Run a single consumer
		 * @constructor
		 */
		function ContinuationTask(continuation, handler) {
			this.continuation = continuation;
			this.handler = handler;
		}

		ContinuationTask.prototype.run = function() {
			this.handler.join().when(this.continuation);
		};

		/**
		 * Run a queue of progress handlers
		 * @constructor
		 */
		function ProgressTask(value, handler) {
			this.handler = handler;
			this.value = value;
		}

		ProgressTask.prototype.run = function() {
			var q = this.handler.consumers;
			if(q === void 0) {
				return;
			}

			for (var c, i = 0; i < q.length; ++i) {
				c = q[i];
				runNotify(c.progress, this.value, this.handler, c.receiver, c.resolver);
			}
		};

		/**
		 * Assimilate a thenable, sending it's value to resolver
		 * @param {function} then
		 * @param {object|function} thenable
		 * @param {object} resolver
		 * @constructor
		 */
		function AssimilateTask(then, thenable, resolver) {
			this._then = then;
			this.thenable = thenable;
			this.resolver = resolver;
		}

		AssimilateTask.prototype.run = function() {
			var h = this.resolver;
			tryAssimilate(this._then, this.thenable, _resolve, _reject, _notify);

			function _resolve(x) { h.resolve(x); }
			function _reject(x)  { h.reject(x); }
			function _notify(x)  { h.notify(x); }
		};

		function tryAssimilate(then, thenable, resolve, reject, notify) {
			try {
				then.call(thenable, resolve, reject, notify);
			} catch (e) {
				reject(e);
			}
		}

		/**
		 * Fold a handler value with z
		 * @constructor
		 */
		function Fold(f, z, c, to) {
			this.f = f; this.z = z; this.c = c; this.to = to;
			this.resolver = failIfRejected;
			this.receiver = this;
		}

		Fold.prototype.fulfilled = function(x) {
			this.f.call(this.c, this.z, x, this.to);
		};

		Fold.prototype.rejected = function(x) {
			this.to.reject(x);
		};

		Fold.prototype.progress = function(x) {
			this.to.notify(x);
		};

		// Other helpers

		/**
		 * @param {*} x
		 * @returns {boolean} true iff x is a trusted Promise
		 */
		function isPromise(x) {
			return x instanceof Promise;
		}

		/**
		 * Test just enough to rule out primitives, in order to take faster
		 * paths in some code
		 * @param {*} x
		 * @returns {boolean} false iff x is guaranteed *not* to be a thenable
		 */
		function maybeThenable(x) {
			return (typeof x === 'object' || typeof x === 'function') && x !== null;
		}

		function runContinuation1(f, h, receiver, next) {
			if(typeof f !== 'function') {
				return next.become(h);
			}

			Promise.enterContext(h);
			tryCatchReject(f, h.value, receiver, next);
			Promise.exitContext();
		}

		function runContinuation3(f, x, h, receiver, next) {
			if(typeof f !== 'function') {
				return next.become(h);
			}

			Promise.enterContext(h);
			tryCatchReject3(f, x, h.value, receiver, next);
			Promise.exitContext();
		}

		/**
		 * @deprecated
		 */
		function runNotify(f, x, h, receiver, next) {
			if(typeof f !== 'function') {
				return next.notify(x);
			}

			Promise.enterContext(h);
			tryCatchReturn(f, x, receiver, next);
			Promise.exitContext();
		}

		function tryCatch2(f, a, b) {
			try {
				return f(a, b);
			} catch(e) {
				return reject(e);
			}
		}

		/**
		 * Return f.call(thisArg, x), or if it throws return a rejected promise for
		 * the thrown exception
		 */
		function tryCatchReject(f, x, thisArg, next) {
			try {
				next.become(getHandler(f.call(thisArg, x)));
			} catch(e) {
				next.become(new Rejected(e));
			}
		}

		/**
		 * Same as above, but includes the extra argument parameter.
		 */
		function tryCatchReject3(f, x, y, thisArg, next) {
			try {
				f.call(thisArg, x, y, next);
			} catch(e) {
				next.become(new Rejected(e));
			}
		}

		/**
		 * @deprecated
		 * Return f.call(thisArg, x), or if it throws, *return* the exception
		 */
		function tryCatchReturn(f, x, thisArg, next) {
			try {
				next.notify(f.call(thisArg, x));
			} catch(e) {
				next.notify(e);
			}
		}

		function inherit(Parent, Child) {
			Child.prototype = objectCreate(Parent.prototype);
			Child.prototype.constructor = Child;
		}

		function snd(x, y) {
			return y;
		}

		function noop() {}

		function hasCustomEvent() {
			if(typeof CustomEvent === 'function') {
				try {
					var ev = new CustomEvent('unhandledRejection');
					return ev instanceof CustomEvent;
				} catch (ignoredException) {}
			}
			return false;
		}

		function hasInternetExplorerCustomEvent() {
			if(typeof document !== 'undefined' && typeof document.createEvent === 'function') {
				try {
					// Try to create one event to make sure it's supported
					var ev = document.createEvent('CustomEvent');
					ev.initCustomEvent('eventType', false, true, {});
					return true;
				} catch (ignoredException) {}
			}
			return false;
		}

		function initEmitRejection() {
			/*global process, self, CustomEvent*/
			if(typeof process !== 'undefined' && process !== null
				&& typeof process.emit === 'function') {
				// Returning falsy here means to call the default
				// onPotentiallyUnhandledRejection API.  This is safe even in
				// browserify since process.emit always returns falsy in browserify:
				// https://github.com/defunctzombie/node-process/blob/master/browser.js#L40-L46
				return function(type, rejection) {
					return type === 'unhandledRejection'
						? process.emit(type, rejection.value, rejection)
						: process.emit(type, rejection);
				};
			} else if(typeof self !== 'undefined' && hasCustomEvent()) {
				return (function (self, CustomEvent) {
					return function (type, rejection) {
						var ev = new CustomEvent(type, {
							detail: {
								reason: rejection.value,
								key: rejection
							},
							bubbles: false,
							cancelable: true
						});

						return !self.dispatchEvent(ev);
					};
				}(self, CustomEvent));
			} else if(typeof self !== 'undefined' && hasInternetExplorerCustomEvent()) {
				return (function(self, document) {
					return function(type, rejection) {
						var ev = document.createEvent('CustomEvent');
						ev.initCustomEvent(type, false, true, {
							reason: rejection.value,
							key: rejection
						});

						return !self.dispatchEvent(ev);
					};
				}(self, document));
			}

			return noop;
		}

		return Promise;
	};
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function(define) { 'use strict';
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {

	// Credit to Twisol (https://github.com/Twisol) for suggesting
	// this type of extensible queue + trampoline approach for next-tick conflation.

	/**
	 * Async task scheduler
	 * @param {function} async function to schedule a single async function
	 * @constructor
	 */
	function Scheduler(async) {
		this._async = async;
		this._running = false;

		this._queue = this;
		this._queueLen = 0;
		this._afterQueue = {};
		this._afterQueueLen = 0;

		var self = this;
		this.drain = function() {
			self._drain();
		};
	}

	/**
	 * Enqueue a task
	 * @param {{ run:function }} task
	 */
	Scheduler.prototype.enqueue = function(task) {
		this._queue[this._queueLen++] = task;
		this.run();
	};

	/**
	 * Enqueue a task to run after the main task queue
	 * @param {{ run:function }} task
	 */
	Scheduler.prototype.afterQueue = function(task) {
		this._afterQueue[this._afterQueueLen++] = task;
		this.run();
	};

	Scheduler.prototype.run = function() {
		if (!this._running) {
			this._running = true;
			this._async(this.drain);
		}
	};

	/**
	 * Drain the handler queue entirely, and then the after queue
	 */
	Scheduler.prototype._drain = function() {
		var i = 0;
		for (; i < this._queueLen; ++i) {
			this._queue[i].run();
			this._queue[i] = void 0;
		}

		this._queueLen = 0;
		this._running = false;

		for (i = 0; i < this._afterQueueLen; ++i) {
			this._afterQueue[i].run();
			this._afterQueue[i] = void 0;
		}

		this._afterQueueLen = 0;
	};

	return Scheduler;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(26)));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	'use strict';

	/* Convert a single or array of resources into "URI1\nURI2\nURI3..." */

	return {
		read: function read(str /*, opts */) {
			return str.split('\n');
		},
		write: function write(obj /*, opts */) {
			// If this is an Array, extract the self URI and then join using a newline
			if (obj instanceof Array) {
				return obj.map(function (resource) {
					return resource._links.self.href;
				}).join('\n');
			} else {
				// otherwise, just return the self URI
				return obj._links.self.href;
			}
		}
	};
};

;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var confirmable = function confirmable(Component) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.state = {
        show: true
      };
      return _this;
    }

    _createClass(_class, [{
      key: 'dismiss',
      value: function dismiss() {
        var _this2 = this;

        this.setState({
          show: false
        }, function () {
          _this2.props.dispose();
        });
      }
    }, {
      key: 'cancel',
      value: function cancel(value) {
        var _this3 = this;

        this.setState({
          show: false
        }, function () {
          _this3.props.reject(value);
        });
      }
    }, {
      key: 'proceed',
      value: function proceed(value) {
        var _this4 = this;

        this.setState({
          show: false
        }, function () {
          _this4.props.resolve(value);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({ proceed: this.proceed.bind(this), cancel: this.cancel.bind(this), dismiss: this.dismiss.bind(this), show: this.state.show }, this.props));
      }
    }]);

    return _class;
  }(_react2.default.Component);
};

exports.default = confirmable;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createConfirmation = function createConfirmation(Component) {
  var unmountDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var mountingNode = arguments[2];

  return function (props) {
    var wrapper = (mountingNode || document.body).appendChild(document.createElement('div'));

    var promise = new Promise(function (resolve, reject) {
      try {
        _reactDom2.default.render(_react2.default.createElement(Component, _extends({
          reject: reject,
          resolve: resolve,
          dispose: dispose
        }, props)), wrapper);
      } catch (e) {
        console.error(e);
        throw e;
      }
    });

    function dispose() {
      setTimeout(function () {
        _reactDom2.default.unmountComponentAtNode(wrapper);
        setTimeout(function () {
          if (document.body.contains(wrapper)) {
            document.body.removeChild(wrapper);
          }
        });
      }, unmountDelay);
    }

    return promise.then(function (result) {
      dispose();
      return result;
    }, function (result) {
      dispose();
      return Promise.reject(result);
    });
  };
};

exports.default = createConfirmation;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactConfirm = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Do not use this component directly. Use it with utils/confirmDialog.js instead.
 *  (This might not be the redux way of doing it, but in this case i think it is ok, since the redux way seems overly complex (can't put callbacks in the store, so how to react to ok/cancel, for example).
 */

// See the react-confirm manual: https://www.npmjs.com/package/react-confirm. (Note: This function is a *stateless* react component).
var ConfirmDialog = function ConfirmDialog(_ref) {
    var show = _ref.show,
        proceed = _ref.proceed,
        dismiss = _ref.dismiss,
        cancel = _ref.cancel,
        title = _ref.title,
        text = _ref.text,
        options = _ref.options;
    return _react2.default.createElement(
        _reactModal2.default,
        { isOpen: show, shouldCloseOnOverlayClick: false, style: modalDialogStyles },
        _react2.default.createElement(
            'div',
            { className: 'modalDialogContent' },
            _react2.default.createElement(
                'h2',
                null,
                title
            ),
            _react2.default.createElement(
                'p',
                { style: Object.assign({ paddingTop: "14px", paddingBottom: "20px", maxHeight: "400px", overflowY: "auto" }, options.textAlign ? { textAlign: options.textAlign } : {}) },
                text
            ),
            _react2.default.createElement(
                'button',
                { type: 'submit', className: options.okClass ? options.okClass : "btn-primary", onClick: function onClick() {
                        return proceed('this is is an arguments for the proceed callback!');
                    } },
                options.okText ? options.okText : "OK"
            ),
            _react2.default.createElement('span', { style: { paddingLeft: "14px" } }),
            _react2.default.createElement(
                'button',
                { type: 'submit', className: options.cancelClass ? options.cancelClass : "btn-secondary", onClick: function onClick() {
                        return cancel('this is is an arguments for the cancel callback!');
                    } },
                options.cancelText ? options.cancelText : "Cancel"
            )
        )
    );
};

ConfirmDialog.propTypes = {
    show: _propTypes2.default.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: _propTypes2.default.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: _propTypes2.default.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: _propTypes2.default.func, // from confirmable. call to only close the dialog.
    title: _propTypes2.default.string, // arguments of your confirm function
    text: _propTypes2.default.node, // arguments of your confirm function
    options: _propTypes2.default.object // arguments of your confirm function
};

var modalDialogStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 99999
    },
    content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: "0px",
        background: "none",
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '0px',
        outline: 'none',
        padding: '20px',
        textAlign: "center"
    }
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
exports.default = (0, _reactConfirm.confirmable)(ConfirmDialog);

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(722);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53), __webpack_require__(87)))

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 244,
	"./af.js": 244,
	"./ar": 245,
	"./ar-dz": 246,
	"./ar-dz.js": 246,
	"./ar-kw": 247,
	"./ar-kw.js": 247,
	"./ar-ly": 248,
	"./ar-ly.js": 248,
	"./ar-ma": 249,
	"./ar-ma.js": 249,
	"./ar-sa": 250,
	"./ar-sa.js": 250,
	"./ar-tn": 251,
	"./ar-tn.js": 251,
	"./ar.js": 245,
	"./az": 252,
	"./az.js": 252,
	"./be": 253,
	"./be.js": 253,
	"./bg": 254,
	"./bg.js": 254,
	"./bm": 255,
	"./bm.js": 255,
	"./bn": 256,
	"./bn-bd": 257,
	"./bn-bd.js": 257,
	"./bn.js": 256,
	"./bo": 258,
	"./bo.js": 258,
	"./br": 259,
	"./br.js": 259,
	"./bs": 260,
	"./bs.js": 260,
	"./ca": 261,
	"./ca.js": 261,
	"./cs": 262,
	"./cs.js": 262,
	"./cv": 263,
	"./cv.js": 263,
	"./cy": 264,
	"./cy.js": 264,
	"./da": 265,
	"./da.js": 265,
	"./de": 266,
	"./de-at": 267,
	"./de-at.js": 267,
	"./de-ch": 268,
	"./de-ch.js": 268,
	"./de.js": 266,
	"./dv": 269,
	"./dv.js": 269,
	"./el": 270,
	"./el.js": 270,
	"./en-au": 271,
	"./en-au.js": 271,
	"./en-ca": 272,
	"./en-ca.js": 272,
	"./en-gb": 273,
	"./en-gb.js": 273,
	"./en-ie": 274,
	"./en-ie.js": 274,
	"./en-il": 275,
	"./en-il.js": 275,
	"./en-in": 276,
	"./en-in.js": 276,
	"./en-nz": 277,
	"./en-nz.js": 277,
	"./en-sg": 278,
	"./en-sg.js": 278,
	"./eo": 279,
	"./eo.js": 279,
	"./es": 280,
	"./es-do": 281,
	"./es-do.js": 281,
	"./es-mx": 282,
	"./es-mx.js": 282,
	"./es-us": 283,
	"./es-us.js": 283,
	"./es.js": 280,
	"./et": 284,
	"./et.js": 284,
	"./eu": 285,
	"./eu.js": 285,
	"./fa": 286,
	"./fa.js": 286,
	"./fi": 287,
	"./fi.js": 287,
	"./fil": 288,
	"./fil.js": 288,
	"./fo": 289,
	"./fo.js": 289,
	"./fr": 290,
	"./fr-ca": 291,
	"./fr-ca.js": 291,
	"./fr-ch": 292,
	"./fr-ch.js": 292,
	"./fr.js": 290,
	"./fy": 293,
	"./fy.js": 293,
	"./ga": 294,
	"./ga.js": 294,
	"./gd": 295,
	"./gd.js": 295,
	"./gl": 296,
	"./gl.js": 296,
	"./gom-deva": 297,
	"./gom-deva.js": 297,
	"./gom-latn": 298,
	"./gom-latn.js": 298,
	"./gu": 299,
	"./gu.js": 299,
	"./he": 300,
	"./he.js": 300,
	"./hi": 301,
	"./hi.js": 301,
	"./hr": 302,
	"./hr.js": 302,
	"./hu": 303,
	"./hu.js": 303,
	"./hy-am": 304,
	"./hy-am.js": 304,
	"./id": 305,
	"./id.js": 305,
	"./is": 306,
	"./is.js": 306,
	"./it": 307,
	"./it-ch": 308,
	"./it-ch.js": 308,
	"./it.js": 307,
	"./ja": 309,
	"./ja.js": 309,
	"./jv": 310,
	"./jv.js": 310,
	"./ka": 311,
	"./ka.js": 311,
	"./kk": 312,
	"./kk.js": 312,
	"./km": 313,
	"./km.js": 313,
	"./kn": 314,
	"./kn.js": 314,
	"./ko": 315,
	"./ko.js": 315,
	"./ku": 316,
	"./ku.js": 316,
	"./ky": 317,
	"./ky.js": 317,
	"./lb": 318,
	"./lb.js": 318,
	"./lo": 319,
	"./lo.js": 319,
	"./lt": 320,
	"./lt.js": 320,
	"./lv": 321,
	"./lv.js": 321,
	"./me": 322,
	"./me.js": 322,
	"./mi": 323,
	"./mi.js": 323,
	"./mk": 324,
	"./mk.js": 324,
	"./ml": 325,
	"./ml.js": 325,
	"./mn": 326,
	"./mn.js": 326,
	"./mr": 327,
	"./mr.js": 327,
	"./ms": 328,
	"./ms-my": 329,
	"./ms-my.js": 329,
	"./ms.js": 328,
	"./mt": 330,
	"./mt.js": 330,
	"./my": 331,
	"./my.js": 331,
	"./nb": 332,
	"./nb.js": 332,
	"./ne": 333,
	"./ne.js": 333,
	"./nl": 334,
	"./nl-be": 335,
	"./nl-be.js": 335,
	"./nl.js": 334,
	"./nn": 336,
	"./nn.js": 336,
	"./oc-lnc": 337,
	"./oc-lnc.js": 337,
	"./pa-in": 338,
	"./pa-in.js": 338,
	"./pl": 339,
	"./pl.js": 339,
	"./pt": 340,
	"./pt-br": 341,
	"./pt-br.js": 341,
	"./pt.js": 340,
	"./ro": 342,
	"./ro.js": 342,
	"./ru": 343,
	"./ru.js": 343,
	"./sd": 344,
	"./sd.js": 344,
	"./se": 345,
	"./se.js": 345,
	"./si": 346,
	"./si.js": 346,
	"./sk": 347,
	"./sk.js": 347,
	"./sl": 348,
	"./sl.js": 348,
	"./sq": 349,
	"./sq.js": 349,
	"./sr": 350,
	"./sr-cyrl": 351,
	"./sr-cyrl.js": 351,
	"./sr.js": 350,
	"./ss": 352,
	"./ss.js": 352,
	"./sv": 353,
	"./sv.js": 353,
	"./sw": 354,
	"./sw.js": 354,
	"./ta": 355,
	"./ta.js": 355,
	"./te": 356,
	"./te.js": 356,
	"./tet": 357,
	"./tet.js": 357,
	"./tg": 358,
	"./tg.js": 358,
	"./th": 359,
	"./th.js": 359,
	"./tk": 360,
	"./tk.js": 360,
	"./tl-ph": 361,
	"./tl-ph.js": 361,
	"./tlh": 362,
	"./tlh.js": 362,
	"./tr": 363,
	"./tr.js": 363,
	"./tzl": 364,
	"./tzl.js": 364,
	"./tzm": 365,
	"./tzm-latn": 366,
	"./tzm-latn.js": 366,
	"./tzm.js": 365,
	"./ug-cn": 367,
	"./ug-cn.js": 367,
	"./uk": 368,
	"./uk.js": 368,
	"./ur": 369,
	"./ur.js": 369,
	"./uz": 370,
	"./uz-latn": 371,
	"./uz-latn.js": 371,
	"./uz.js": 370,
	"./vi": 372,
	"./vi.js": 372,
	"./x-pseudo": 373,
	"./x-pseudo.js": 373,
	"./yo": 374,
	"./yo.js": 374,
	"./zh-cn": 375,
	"./zh-cn.js": 375,
	"./zh-hk": 376,
	"./zh-hk.js": 376,
	"./zh-mo": 377,
	"./zh-mo.js": 377,
	"./zh-tw": 378,
	"./zh-tw.js": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactConfirm = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Do not use this component directly. Use it with utils/alertDialog.js instead.
 *  (This might not be the redux way of doing it, but in this case i think it is ok, since the redux way seems overly complex (can't put callbacks in the store, so how to react to ok/cancel, for example).
 */

// See the react-confirm manual: https://www.npmjs.com/package/react-confirm. (Note: This function is a *stateless* react component).
var AlertDialog = function AlertDialog(_ref) {
    var show = _ref.show,
        proceed = _ref.proceed,
        dismiss = _ref.dismiss,
        cancel = _ref.cancel,
        title = _ref.title,
        text = _ref.text,
        options = _ref.options;

    console.log(options);
    return _react2.default.createElement(
        _reactModal2.default,
        { isOpen: show, shouldCloseOnOverlayClick: false, style: modalDialogStyles },
        _react2.default.createElement(
            'div',
            { className: 'modalDialogContent' },
            _react2.default.createElement(
                'h2',
                null,
                title
            ),
            _react2.default.createElement(
                'p',
                { style: Object.assign({ paddingTop: "14px", paddingBottom: "20px", maxHeight: "400px", overflowY: "auto" }, options.textAlign ? { textAlign: options.textAlign } : {}) },
                text
            ),
            _react2.default.createElement(
                'button',
                { type: 'submit', className: 'btn-primary', onClick: function onClick() {
                        return proceed('this is an arguments for the proceed callback!');
                    } },
                'OK'
            )
        )
    );
};

AlertDialog.propTypes = {
    show: _propTypes2.default.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: _propTypes2.default.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: _propTypes2.default.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: _propTypes2.default.func, // from confirmable. call to only close the dialog.
    title: _propTypes2.default.string, // arguments of your confirm function
    text: _propTypes2.default.node, // arguments of your confirm function
    options: _propTypes2.default.object // arguments of your confirm function
};

var modalDialogStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 99999
    },
    content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: "0px",
        background: "none",
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '0px',
        outline: 'none',
        padding: '20px',
        textAlign: "center"
    }
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
exports.default = (0, _reactConfirm.confirmable)(AlertDialog);

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _routeconstants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer(props) {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
    }

    _createClass(Footer, [{
        key: 'render',
        value: function render() {

            return _react2.default.createElement('div', { className: 'page-footer' });
        }
    }]);

    return Footer;
}(_react2.default.Component);

Footer.propTypes = {};
exports.default = Footer;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1048d71b039ca7283d87eec6a529b0a0.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b77cf4ae733730c058451132f80c5b12.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_React$Component) {
    _inherits(Home, _React$Component);

    _createClass(Home, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_HOME;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.USER, _UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function Home(props) {
        _classCallCheck(this, Home);

        return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
    }

    _createClass(Home, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.isAuthenticated && (this.props.auth.isClubAdmin || this.props.auth.isSectionAdmin || this.props.auth.isMainAdmin)) this.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_DASHBOARD));else this.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SIGNIN));
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'sub-page-title' }),
                _react2.default.createElement('div', { className: 'sub-page-content' })
            );
        }
    }]);

    return Home;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isAuthenticated: state.auth.isAuthenticated,
            isMainAdmin: state.auth.isMainAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Home);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _ExportDialog = __webpack_require__(731);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _ImportFilesDialog = __webpack_require__(745);

var _ImportFilesDialog2 = _interopRequireDefault(_ImportFilesDialog);

var _RacesInvoiceDialog = __webpack_require__(747);

var _RacesInvoiceDialog2 = _interopRequireDefault(_RacesInvoiceDialog);

var _RestoreFromBackupDialog = __webpack_require__(748);

var _RestoreFromBackupDialog2 = _interopRequireDefault(_RestoreFromBackupDialog);

var _StartSeasonDialog = __webpack_require__(749);

var _StartSeasonDialog2 = _interopRequireDefault(_StartSeasonDialog);

var _ImportDevicesDialog = __webpack_require__(750);

var _ImportDevicesDialog2 = _interopRequireDefault(_ImportDevicesDialog);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _confirmDialog = __webpack_require__(12);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _ExportSignupsAndResultsDialog = __webpack_require__(752);

var _ExportSignupsAndResultsDialog2 = _interopRequireDefault(_ExportSignupsAndResultsDialog);

var _ImportMemberProgramDialog = __webpack_require__(753);

var _ImportMemberProgramDialog2 = _interopRequireDefault(_ImportMemberProgramDialog);

var _ExportDevicesDialog = __webpack_require__(754);

var _ExportDevicesDialog2 = _interopRequireDefault(_ExportDevicesDialog);

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dashboard = function (_React$Component) {
    _inherits(Dashboard, _React$Component);

    _createClass(Dashboard, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_DASHBOARD;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.USER, _UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function Dashboard(props) {
        _classCallCheck(this, Dashboard);

        var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

        _this.state = {
            showExportDevicesDialog: false,
            showExportDialog: false,
            showImportDialog: false,
            showRacesInvoiceDialog: false,
            showRestoreFromBackupDialog: false,
            showStartSeasonDialog: false,
            showImportMemberProgramDialog: false,
            showImportDevicesDialog: false,
            showSendDialog: false
        };
        return _this;
    }

    _createClass(Dashboard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.auth.isAuthenticated) this.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_HOME));else this.props.dispatch(AdminActions.getDashboardData());
            if (typeof this.props.location.query.message !== 'undefined') {
                var title = typeof this.props.location.query.title === 'undefined' ? 'Info' : this.props.location.query.title;
                if (typeof this.props.location.query.status !== 'undefined' && this.props.location.query.status === 'error') _reactNotifications.NotificationManager.error(this.props.location.query.message, title, 0);else if (typeof this.props.location.query.status !== 'undefined' && this.props.location.query.status === 'warning') _reactNotifications.NotificationManager.warning(this.props.location.query.message, title, 10000);else _reactNotifications.NotificationManager.success(this.props.location.query.message, title, 4000);
                this.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_DASHBOARD));
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if ((this.props.auth.currentRole === null || this.props.auth.currentRole === _UserRoles2.default.USER.id) && this.props.admin.userRoles.length === 1 && prevProps.admin.userRoles.length === 0) {
                var role = this.props.admin.userRoles[0];
                var roleId = role.level === _UserRoles2.default.MAIN_ADMIN.id ? "m" : role.level === _UserRoles2.default.SECTION_ADMIN.id ? "s" + role.id : "c" + role.id;
                this.props.dispatch(AdminActions.selectUserRole(roleId));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'dashboard-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'display-inline-block' },
                        'Hovedmenu'
                    ),
                    !this.props.admin.userRoles || this.props.admin.userRoles.length < 1 || this.props.admin.userRoles.length === 1 && (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) ? null : _react2.default.createElement(
                        'div',
                        { className: 'float-right display-inline-block' },
                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: this.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id && this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id ? "-- Vælg --" : false, className: 'field300',
                            name: 'select-user-role', id: 'select-user-role',
                            value: this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? "m" : this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? "s" + this.props.auth.currentEntity : this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? "c" + this.props.auth.currentEntity : '',
                            options: this.props.admin.userRoles.map(function (role) {
                                return {
                                    key: role.level === _UserRoles2.default.MAIN_ADMIN.id ? "m" : role.level === _UserRoles2.default.SECTION_ADMIN.id ? "s" + role.id : "c" + role.id,
                                    value: role.level === _UserRoles2.default.MAIN_ADMIN.id ? "DDB" : role.id + " - " + role.name
                                };
                            }),
                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                            onChange: function onChange(e) {
                                var role = e.target.value;
                                _this2.props.dispatch(AdminActions.selectUserRole(role, function () {
                                    _reactNotifications.NotificationManager.success('Du har nu skiftet rolle.', 'Ny rolle', 4000);
                                }));
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'dashboard-table dashboard-table-1' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'h3',
                                        null,
                                        'Administration'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'h3',
                                        null,
                                        'Kapflyvninger'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'h3',
                                        null,
                                        'S\xE6sonafslutning'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-primary', to: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _routeconstants.ROUTE_CLUB.replace(':clubNo', this.props.auth.currentEntity).replace(':subpage', 'general').replace(':mode', 'view') : _routeconstants.ROUTE_CLUBS,
                                                title: 'Administrer foreningsdata' },
                                            'Foreninger'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-primary', to: _routeconstants.ROUTE_MEMBERS,
                                                title: 'Administrer medlemsdata og s\xF8g p\xE5 medlemmer' },
                                            'Medlemmer'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-secondary', to: _routeconstants.ROUTE_SETTINGS.replace(":subpage", this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? "deposits" : "general").replace(":sectionNo", this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? "ddb" : this.props.auth.currentEntity).replace(":mode", "view"), title: 'Vedligehold indskud, markeringer og pr\xE6mier' },
                                            'Indstillinger'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('div', { className: 'link-separator' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Udl\xE6s duebestand til elektroniske udstyr',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.props.dispatch(AdminActions.getClub(_this2.props.auth.currentEntity));
                                                    _this2.setState({ showExportDevicesDialog: true });
                                                } },
                                            'Eksporter til udstyr'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_SECTIONS,
                                                title: 'Vedligehold sektionsdatadata' },
                                            'Sektioner'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_RANGES,
                                                title: 'Vedligehold omr\xE5der' },
                                            'Omr\xE5der'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_STATIONS,
                                                title: 'Vedligehold stationer' },
                                            'Stationer'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_ZIPS,
                                                title: 'Vedligehold postnumre' },
                                            'Postnumre'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_NIGHT_TIMES,
                                                title: 'Vedligehold nattider' },
                                            'Nattider'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'dashboard-link', to: _routeconstants.ROUTE_DERBYS,
                                                title: 'Vedligehold derby' },
                                            'Derby'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('div', { className: 'link-separator' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'form',
                                            { id: 'get-backup-form', action: "/api/admin/download-backup",
                                                target: '_blank', method: 'post' },
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'dashboard-link', href: '#', title: 'Download databasebackup',
                                                    onClick: function onClick(e) {
                                                        if (_this2.props.auth.database === 'standard') {
                                                            e.preventDefault();
                                                            document.getElementById('get-backup-form').submit();
                                                        } else (0, _confirmDialog.confirm)("Backup", _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            'Du har i \xF8jeblikket \xE5bnet en arkivdatabase for s\xE6sonen ',
                                                            _this2.props.auth.database,
                                                            '. For at hente en backup af den prim\xE6re database, skal du f\xF8rst returnere til standarddatabasen. \xD8nsker du at hente en backup af ',
                                                            _react2.default.createElement(
                                                                'b',
                                                                null,
                                                                'arbivdatabase'
                                                            ),
                                                            '?'
                                                        ), function () {
                                                            e.preventDefault();
                                                            document.getElementById('get-backup-form').submit();
                                                        });
                                                    } },
                                                'Hent backup'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Gendan database fra backup',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.setState({ showRestoreFromBackupDialog: true });
                                                } },
                                            'Indl\xE6s backup'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('div', { className: 'link-separator' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Start ny s\xE6son',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.setState({ showStartSeasonDialog: true });
                                                } },
                                            'Start s\xE6son'
                                        )
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-primary', to: _routeconstants.ROUTE_RACES,
                                                title: 'Administrer kapflyvninger' },
                                            'Kapflyvninger'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-secondary',
                                                to: _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "signups"),
                                                title: 'H\xE5ndter fejllister' },
                                            'Fejllister'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement('div', { className: 'empty-container' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement('div', { className: 'link-separator' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Indl\xE6s anmeldelser fra medlemsprogram',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.props.dispatch(AdminActions.getClub(_this2.props.auth.currentEntity));
                                                    if (!_this2.props.race.isRacesRead) _this2.props.dispatch(RaceActions.getRaces());
                                                    _this2.setState({ showImportMemberProgramDialog: true });
                                                } },
                                            'Indl\xE6s fra medlemsprogram'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Indl\xE6s anmeldelser og resultater fra elektroniske udstyr',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    //if (this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-") {
                                                    var id = ((0, _moment2.default)().valueOf() + '-' + _this2.props.auth.id).slice(0, 25);
                                                    var cb = window.location.origin;
                                                    if (cb.slice(-1) !== '/') cb += '/';
                                                    cb += 'api/device-import/' + id;
                                                    _this2.props.dispatch(RaceActions.startDeviceImport(id, {
                                                        requestType: "version",
                                                        club: _this2.props.auth.currentEntity
                                                    }, function () {
                                                        window.location.href = _config2.default.commUtility.url + "?callback=" + encodeURIComponent(cb) + "&command=version&id=" + encodeURIComponent(id);
                                                    }));
                                                    //}
                                                    _this2.setState({ showImportDevicesDialog: true });
                                                } },
                                            'Indl\xE6s fra udstyr'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Send anmeldelser til DdB og sektion',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    if (!_this2.props.race.isRacesRead) _this2.props.dispatch(RaceActions.getRaces());
                                                    _this2.setState({ showSendDialog: 'signup' });
                                                } },
                                            'Send anmeldelser'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Send resultater til DdB og sektion',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    if (!_this2.props.race.isRacesRead) _this2.props.dispatch(RaceActions.getRaces());
                                                    _this2.setState({ showSendDialog: 'result' });
                                                } },
                                            'Send resultater'
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#',
                                                title: 'Fakturer foreningerne for deltagelse p\xE5 kapflyvninger',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.setState({ showRacesInvoiceDialog: true });
                                                } },
                                            'Fakturer kapflyvninger'
                                        )
                                    ) : null,
                                    0 > 1 && this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#',
                                                title: 'Benzing Basketing',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    (0, _client2.default)({
                                                        method: 'POST',
                                                        path: '/api/benzing/basketings',
                                                        entity: {
                                                            "race": {
                                                                "flight_id": 1767829001,
                                                                "race_number": 8,
                                                                "name": "0394",
                                                                "utc_offset": 7200,
                                                                "pigeon_count": {
                                                                    "basketing": 4,
                                                                    "arrival": 0
                                                                },
                                                                "release": {
                                                                    "time": "2026-01-13 21:38:07",
                                                                    "point": "Garlstorf",
                                                                    "distance": 0,
                                                                    "unit": "km",
                                                                    "latitude": 0,
                                                                    "longitude": 0
                                                                },
                                                                "devices": {
                                                                    "club": {
                                                                        "basketing": {
                                                                            "serial_number": "46900390",
                                                                            "name": "BENZING Live ClubSystem",
                                                                            "software_version": "4.4",
                                                                            "hardware_version": "2.3"
                                                                        }
                                                                    },
                                                                    "clock": {
                                                                        "serial_number": "402446",
                                                                        "name": "BENZING M3",
                                                                        "software_version": "1.18",
                                                                        "hardware_version": "2.5"
                                                                    }
                                                                },
                                                                "time_references": {
                                                                    "basketing": {
                                                                        "master_time": "2026-01-13 23:36:39",
                                                                        "clock_time": "2026-01-13 23:36:39"
                                                                    }
                                                                },
                                                                "fancier": {
                                                                    "name": "Tommy",
                                                                    "federation_id": "209001",
                                                                    "live_id": 226481,
                                                                    "country": "dk"
                                                                },
                                                                "pigeons": [{
                                                                    "country": "DK",
                                                                    "year": "2021",
                                                                    "sex": "f",
                                                                    "club": "209 ",
                                                                    "color": "    ",
                                                                    "ring_number": 2,
                                                                    "basketing": {
                                                                        "order": 1,
                                                                        "time": "2026-01-13T23:37:45+02:00",
                                                                        "electronic_chip_id": "DB030A22",
                                                                        "electronic_chip_uid": "9794BC1A",
                                                                        "nominated": 0,
                                                                        "meta_data": []
                                                                    }
                                                                }, {
                                                                    "country": "DK",
                                                                    "year": "2021",
                                                                    "sex": "f",
                                                                    "club": "209 ",
                                                                    "color": "    ",
                                                                    "ring_number": 3,
                                                                    "basketing": {
                                                                        "order": 2,
                                                                        "time": "2026-01-13T23:37:48+02:00",
                                                                        "electronic_chip_id": "DB030A1F",
                                                                        "electronic_chip_uid": "9794BC04",
                                                                        "nominated": 0,
                                                                        "meta_data": []
                                                                    }
                                                                }, {
                                                                    "country": "DK",
                                                                    "year": "2021",
                                                                    "sex": "m",
                                                                    "club": "209 ",
                                                                    "color": "    ",
                                                                    "ring_number": 9,
                                                                    "basketing": {
                                                                        "order": 3,
                                                                        "time": "2026-01-13T23:37:50+02:00",
                                                                        "electronic_chip_id": "DB030A05",
                                                                        "electronic_chip_uid": "9794BE47",
                                                                        "nominated": 0,
                                                                        "meta_data": []
                                                                    }
                                                                }, {
                                                                    "country": "DK",
                                                                    "year": "2021",
                                                                    "sex": "f",
                                                                    "club": "209 ",
                                                                    "color": "    ",
                                                                    "ring_number": 11,
                                                                    "basketing": {
                                                                        "order": 4,
                                                                        "time": "2026-01-13T23:37:54+02:00",
                                                                        "electronic_chip_id": "DB030A52",
                                                                        "electronic_chip_uid": "9794C02E",
                                                                        "nominated": 0,
                                                                        "meta_data": []
                                                                    }
                                                                }],
                                                                "files": {
                                                                    "basketing": {
                                                                        "pdf": "https://download.benzing.live/basketinglists/dk/226481_1767829001.pdf",
                                                                        "csv": "https://download.benzing.live/export/dk/basketing_226481_1767829001.csv"
                                                                    }
                                                                },
                                                                "meta_data": []
                                                            }
                                                        },
                                                        headers: { 'Content-Type': 'application/json' }
                                                    }).then(function (response) {
                                                        console.log('Success', response.entity);
                                                    }).catch(function (response) {
                                                        console.log('Error', response);
                                                    });
                                                } },
                                            'Benzing Basketing'
                                        )
                                    ) : null,
                                    0 > 1 && this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#',
                                                title: 'Benzing Arrival',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    (0, _client2.default)({
                                                        method: 'POST',
                                                        path: '/api/benzing/arrivals',
                                                        entity: {
                                                            "race": {
                                                                "flight_id": 1767652060,
                                                                "race_number": 5,
                                                                "name": "0394",
                                                                "fancier": {
                                                                    "name": "Tommy",
                                                                    "federation_id": "209001",
                                                                    "live_id": 226481,
                                                                    "country": "dk"
                                                                },
                                                                "pigeons": {
                                                                    "country": "DK",
                                                                    "year": "2021",
                                                                    "sex": "m",
                                                                    "club": "209 ",
                                                                    "color": "    ",
                                                                    "ring_number": 2,
                                                                    "arrival": {
                                                                        "order": 4,
                                                                        "time": "2026-01-13T23:26:12.087+02:00",
                                                                        "gps_time": 1767821171,
                                                                        "gps_latitude": 56.2155638,
                                                                        "gps_longitude": 9.8773805,
                                                                        "wrong_secret_number": false,
                                                                        "arrived_on": "Clock",
                                                                        "antenna_serial_number": "20501747",
                                                                        "meta_data": []
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        headers: { 'Content-Type': 'application/json' }
                                                    }).then(function (response) {
                                                        console.log('Success', response.entity);
                                                    }).catch(function (response) {
                                                        console.log('Error', response);
                                                    });
                                                } },
                                            'Benzing Arrival'
                                        )
                                    ) : null,
                                    0 > 1 && this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#',
                                                title: 'Benzing Evaluation',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    (0, _client2.default)({
                                                        method: 'POST',
                                                        path: '/api/benzing/strike-off',
                                                        entity: {
                                                            "race": {
                                                                "name": "0690",
                                                                "files": {
                                                                    "basketing": {
                                                                        "csv": "https://download.benzing.live/export/dk/basketing_226481_1770106269.csv",
                                                                        "pdf": "https://download.benzing.live/basketinglists/dk/226481_1770106269.pdf"
                                                                    },
                                                                    "evaluation": {
                                                                        "csv": "https://download.benzing.live/export/dk/evaluation_226481_1770106269.csv",
                                                                        "pdf": "https://download.benzing.live/evaluationlists/dk/226481_1770106269.pdf",
                                                                        "w_file": "https://download.benzing.live/w-file/dk/W0010205_226481_1770106269.d61",
                                                                        "winspeed": "https://download.benzing.live/winspeed/dk/W4020203446_1770106269_226481.d00"
                                                                    }
                                                                },
                                                                "devices": {
                                                                    "club": {
                                                                        "basketing": {
                                                                            "name": "BENZING Live ClubSystem",
                                                                            "serial_number": "46900390",
                                                                            "hardware_version": "2.3",
                                                                            "software_version": "4.5"
                                                                        },
                                                                        "evaluation": {
                                                                            "name": "BENZING Live ClubSystem",
                                                                            "serial_number": "46900390",
                                                                            "hardware_version": "2.3",
                                                                            "software_version": "4.5"
                                                                        }
                                                                    },
                                                                    "clock": {
                                                                        "name": "BENZING M3",
                                                                        "serial_number": "402446",
                                                                        "hardware_version": "2.5",
                                                                        "software_version": "1.18"
                                                                    }
                                                                },
                                                                "fancier": {
                                                                    "name": "HansHenrik Brøbech",
                                                                    "country": "dk",
                                                                    "live_id": 226481,
                                                                    "federation_id": "001026"
                                                                },
                                                                "pigeons": [{
                                                                    "sex": "f",
                                                                    "club": "073 ",
                                                                    "year": "2022",
                                                                    "color": "    ",
                                                                    "arrival": {
                                                                        "time": "2026-02-03T08:28:44.466+01:00",
                                                                        "order": 1,
                                                                        "gps_time": 1770103724,
                                                                        "meta_data": [],
                                                                        "arrived_on": "Clock",
                                                                        "gps_latitude": 56.2155277,
                                                                        "gps_longitude": 9.8774416,
                                                                        "wrong_secret_number": false,
                                                                        "antenna_serial_number": "20501747"
                                                                    },
                                                                    "country": "DK",
                                                                    "basketing": {
                                                                        "time": "2026-02-03T08:11:30+01:00",
                                                                        "order": 2,
                                                                        "nomination": 0,
                                                                        "electronic_chip_id": "DB030A52",
                                                                        "electronic_chip_uid": "9794C02E"
                                                                    },
                                                                    "ring_number": 770
                                                                }, {
                                                                    "sex": "f",
                                                                    "club": "073 ",
                                                                    "year": "2022",
                                                                    "color": "    ",
                                                                    "arrival": {
                                                                        "time": "2026-02-03T08:29:06.203+01:00",
                                                                        "order": 2,
                                                                        "gps_time": 1770103746,
                                                                        "meta_data": [],
                                                                        "arrived_on": "Clock",
                                                                        "gps_latitude": 56.2155277,
                                                                        "gps_longitude": 9.8774416,
                                                                        "wrong_secret_number": false,
                                                                        "antenna_serial_number": "20501747"
                                                                    },
                                                                    "country": "DK",
                                                                    "basketing": {
                                                                        "time": "2026-02-03T08:11:28+01:00",
                                                                        "order": 1,
                                                                        "nomination": 0,
                                                                        "electronic_chip_id": "DB030A22",
                                                                        "electronic_chip_uid": "9794BC1A"
                                                                    },
                                                                    "ring_number": 741
                                                                }],
                                                                "release": {
                                                                    "time": "2026-02-03 11:24:22",
                                                                    "unit": "km",
                                                                    "point": "Heide",
                                                                    "distance": 0,
                                                                    "latitude": 0,
                                                                    "longitude": 0
                                                                },
                                                                "flight_id": 1770106269,
                                                                "meta_data": [],
                                                                "utc_offset": 3600,
                                                                "race_number": 17,
                                                                "pigeon_count": {
                                                                    "arrival": 2,
                                                                    "basketing": 2
                                                                },
                                                                "time_references": {
                                                                    "basketing": {
                                                                        "clock_time": "2026-02-03 06:11:04",
                                                                        "master_time": "2026-02-03 06:11:04"
                                                                    },
                                                                    "evaluation": {
                                                                        "clock_time": "2026-02-03 20:11:04",
                                                                        "master_time": "2026-02-03 20:11:04"
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        headers: { 'Content-Type': 'application/json' }
                                                    }).then(function (response) {
                                                        console.log('Success', response.entity);
                                                    }).catch(function (response) {
                                                        console.log('Error', response);
                                                    });
                                                } },
                                            'Benzing Evaluation'
                                        )
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { className: 'btn-primary', to: _routeconstants.ROUTE_CHAMPIONSHIPS,
                                                title: 'Administrer mesterskaber' },
                                            'Mesterskaber'
                                        )
                                    ) : null,
                                    _react2.default.createElement('div', { className: 'empty-container' }),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('div', { className: 'empty-container' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('div', { className: 'link-separator' }) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'div',
                                        { className: 'link-container' },
                                        _react2.default.createElement(
                                            'a',
                                            { className: 'dashboard-link', href: '#', title: 'Eksporter statistik',
                                                onClick: function onClick(e) {
                                                    e.preventDefault();
                                                    _this2.setState({ showExportDialog: 'ddb-stat' });
                                                } },
                                            'Eksporter statistik'
                                        )
                                    ) : null
                                )
                            )
                        )
                    ),
                    /*(this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id) || */!this.props.admin.archives || this.props.admin.archives.length === 0 ? null : _react2.default.createElement(
                        'div',
                        { className: 'lower-left' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'select-database' },
                            'Database'
                        ),
                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: false, className: 'field100p',
                            name: 'select-database', id: 'select-database', value: this.props.auth.database,
                            options: [{ key: 'standard', value: 'Standard' }].concat(this.props.admin.archives.map(function (db) {
                                return { key: db, value: db };
                            })),
                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                            onChange: function onChange(e) {
                                var db = e.target.value;
                                _this2.props.dispatch(AdminActions.selectDatabase(db, function () {
                                    _reactNotifications.NotificationManager.success('Du har nu skiftet til ' + (db === 'standard' ? 'standarddatabasen.' : 'databasen for sæson ' + db + '.'), 'Database', 4000);
                                }));
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: _routeconstants.ROUTE_REPORTING.replace(":category", "general").replace(":report", "members"), className: 'lower-right dashboard-icon', title: 'Rapportgenerering' },
                        _react2.default.createElement('i', { className: 'fa fa-print' })
                    )
                ),
                this.state.showExportDevicesDialog !== false ? _react2.default.createElement(_ExportDevicesDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showExportDevicesDialog: false });
                    } }) : null,
                this.state.showExportDialog !== false ? _react2.default.createElement(_ExportDialog2.default, { exportType: this.state.showExportDialog, onClose: function onClose() {
                        _this2.setState({ showExportDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null,
                this.state.showImportDialog !== false ? _react2.default.createElement(_ImportFilesDialog2.default, { importType: this.state.showImportDialog, onClose: function onClose() {
                        _this2.setState({ showImportDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null,
                this.state.showRacesInvoiceDialog !== false ? _react2.default.createElement(_RacesInvoiceDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showRacesInvoiceDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null,
                this.state.showRestoreFromBackupDialog !== false ? _react2.default.createElement(_RestoreFromBackupDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showRestoreFromBackupDialog: false });
                    } }) : null,
                this.state.showStartSeasonDialog !== false ? _react2.default.createElement(_StartSeasonDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showStartSeasonDialog: false });
                    } }) : null,
                this.state.showImportMemberProgramDialog !== false ? _react2.default.createElement(_ImportMemberProgramDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showImportMemberProgramDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null,
                this.state.showImportDevicesDialog !== false ? _react2.default.createElement(_ImportDevicesDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showImportDevicesDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null,
                this.state.showSendDialog !== false ? _react2.default.createElement(_ExportSignupsAndResultsDialog2.default, { exportType: this.state.showSendDialog, onClose: function onClose() {
                        _this2.setState({ showSendDialog: false });
                    }, onSuccess: function onSuccess() {} }) : null
            );
        }
    }]);

    return Dashboard;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isAuthenticated: state.auth.isAuthenticated,
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            id: state.auth.id,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity,
            database: state.auth.database
        },
        admin: {
            archives: state.admin.archives,
            userRoles: state.admin.userRoles
        },
        race: {
            isRacesRead: state.race.isRacesRead,
            deviceImports: state.race.deviceImports,
            deviceImporterVersion: state.race.deviceImporterVersion
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Dashboard);

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportDialog = function (_React$Component) {
    _inherits(ExportDialog, _React$Component);

    function ExportDialog(props) {
        _classCallCheck(this, ExportDialog);

        var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this, props));

        _this.fields = [];

        _this.onExport = function () {
            if (_this.allInputValid()) {
                _this.props.dispatch(AdminActions.exportRaceData(Object.assign({
                    sectionFrom: _this.state.sectionFrom === '' ? null : _this.state.sectionFrom,
                    sectionTo: _this.state.sectionTo === '' ? null : _this.state.sectionTo,
                    clubFrom: _this.state.clubFrom === '' ? null : _this.state.clubFrom,
                    clubTo: _this.state.clubTo === '' ? null : _this.state.clubTo
                }, _this.state.exportOption === 'ddb-stat' || _this.state.exportOption === 'section-stat' ? { rangeStats: _this.state.rangeStats } : {}), _this.state.exportOption, function (status) {
                    _reactNotifications.NotificationManager.success("Eksportfiler er genereret til de valgte foreninger.", "Eksport", 4000);
                    status.messages.forEach(function (msg) {
                        _reactNotifications.NotificationManager.warning(msg, 'Advarsel', 0);
                    });
                    _this.props.onClose();
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            sectionFrom: '',
            sectionTo: '69',
            clubFrom: '',
            clubTo: '299',
            exportOption: props.exportType,
            rangeStats: false
        };
        return _this;
    }

    _createClass(ExportDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '500px',
                                width: '500px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Eksporter til foreninger'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'sectionFrom' },
                                                    'Fra sektion'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'sectionFrom', id: 'sectionFrom', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionFrom,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[0] = instance;
                                                    }
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'sectionTo' },
                                                    'Til sektion'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'sectionTo', id: 'sectionTo', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionTo,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'clubFrom' },
                                                    'Fra forening'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'clubFrom', id: 'clubFrom', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubFrom,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur() {
                                                        _this2.fields[2].setState({ focused: false, visited: true });
                                                        if (/^[0-9]{1,2}$/.test(_this2.state.clubFrom)) _this2.setState({ clubFrom: _this2.state.clubFrom.padStart(3, '0'), clubTo: _this2.state.clubTo === '' ? _this2.state.clubFrom.padStart(3, '0') : _this2.state.clubTo });else if (/^[0-9]{3}$/.test(_this2.state.clubFrom) && _this2.state.clubTo === '') _this2.setState({ clubTo: _this2.state.clubFrom });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'clubTo' },
                                                    'Til forening'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'clubTo', id: 'clubTo', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubTo,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur() {
                                                        _this2.fields[3].setState({ focused: false, visited: true });
                                                        if (/^[0-9]{1,2}$/.test(_this2.state.clubTo)) _this2.setState({ clubTo: _this2.state.clubTo.padStart(3, '0') });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[3] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 4, className: 'large-vertical-spacing' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'radio', id: 'optRaces', name: 'expOption', checked: this.state.exportOption === 'races', onClick: function onClick() {
                                                            return _this2.setState({ exportOption: 'races' });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'optRaces' },
                                                        'Eksporter s\xE6sonstart/justeringer'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'radio', id: 'optDdbStat', name: 'expOption', checked: this.state.exportOption === 'ddb-stat', onClick: function onClick() {
                                                            return _this2.setState({ exportOption: 'ddb-stat' });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'optDdbStat' },
                                                        'Eksporter DDB-statistik'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'radio', id: 'optSectionStat', name: 'expOption', checked: this.state.exportOption === 'section-stat', onClick: function onClick() {
                                                            return _this2.setState({ exportOption: 'section-stat' });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'optSectionStat' },
                                                        'Eksporter sektionsstatistik'
                                                    )
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 4 },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'checkbox', id: 'rangeStats', name: 'rangeStats', disabled: this.state.exportOption !== 'ddb-stat' && this.state.exportOption !== 'section-stat', checked: this.state.rangeStats, onClick: function onClick() {
                                                            return _this2.setState({ rangeStats: !_this2.state.rangeStats });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'rangeStats', className: this.state.exportOption !== 'ddb-stat' && this.state.exportOption !== 'section-stat' ? 'disabled' : '' },
                                                        'Tr\xE6k statistik omr\xE5devist'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', onClick: this.onExport },
                                'Eksporter'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ExportDialog;
}(_react2.default.Component);

ExportDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func,
    exportType: _propTypes2.default.string
};
ExportDialog.defaultProps = {
    onSuccess: null,
    exportType: 'races'
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportDialog);

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(383),
	PropTypes = __webpack_require__(4),
	createClass = __webpack_require__(29),
	moment = __webpack_require__(0),
	React = __webpack_require__(1),
	CalendarContainer = __webpack_require__(733),
	onClickOutside = __webpack_require__(738).default
	;

var viewModes = Object.freeze({
	YEARS: 'years',
	MONTHS: 'months',
	DAYS: 'days',
	TIME: 'time',
});

var TYPES = PropTypes;
var Datetime = createClass({
	displayName: 'DateTime',
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		// viewDate: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		onNavigateBack: TYPES.func,
		onNavigateForward: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		displayTimeZone: TYPES.string,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getInitialState: function() {
		this.checkTZ( this.props );
		
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ?
			(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;

		return state;
	},

	parseDate: function (date, formats) {
		var parsedDate;

		if (date && typeof date === 'string')
			parsedDate = this.localMoment(date, formats.datetime);
		else if (date)
			parsedDate = this.localMoment(date);

		if (parsedDate && !parsedDate.isValid())
			parsedDate = null;

		return parsedDate;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		selectedDate = this.parseDate(date, formats);

		viewDate = this.parseDate(props.viewDate, formats);

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return viewModes.DAYS;
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return viewModes.MONTHS;
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return viewModes.YEARS;
		}

		return viewModes.DAYS;
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else if ( nextProps.displayTimeZone ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
					updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}

		if ( nextProps.viewDate !== this.props.viewDate ) {
			updatedState.viewDate = moment(nextProps.viewDate);
		}

		this.checkTZ( nextProps );

		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: viewModes.DAYS,
				year: viewModes.MONTHS,
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	subtractTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateBack( amount, type );
			me.updateTime( 'subtract', amount, type, toSelected );
		};
	},

	addTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateForward( amount, type );
			me.updateTime( 'add', amount, type, toSelected );
		};
	},

	updateTime: function( op, amount, type, toSelected ) {
		var update = {},
			date = toSelected ? 'selectedDate' : 'viewDate';

		update[ date ] = this.state[ date ].clone()[ op ]( amount, type );

		this.setState( update );
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.currentTarget,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var m = null;

		if (props.utc) {
			m = moment.utc(date, format, props.strictParsing);
		} else if (props.displayTimeZone) {
			m = moment.tz(date, format, props.displayTimeZone);
		} else {
			m = moment(date, format, props.strictParsing);
		}

		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	checkTZ: function( props ) {
		var con = console;

		if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
			this.tzWarning = true;
			con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
		}
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	overrideEvent: function( handler, action ) {
		if ( !this.overridenEvents ) {
			this.overridenEvents = {};
		}

		if ( !this.overridenEvents[handler] ) {
			var me = this;
			this.overridenEvents[handler] = function( e ) {
				var result;
				if ( me.props.inputProps && me.props.inputProps[handler] ) {
					result = me.props.inputProps[handler]( e );
				}
				if ( result !== false ) {
					action( e );
				}
			};
		}

		return this.overridenEvents[handler];
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
									( Array.isArray( this.props.className ) ?
									' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign(
				{ type: 'text', className: 'form-control', value: this.state.inputValue },
				this.props.inputProps,
				{
					onClick: this.overrideEvent( 'onClick', this.openCalendar ),
					onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
					onChange: this.overrideEvent( 'onChange', this.onInputChange ),
					onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
				}
			);

			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.props.open || (this.props.open === undefined && this.state.open ) )
			className += ' rdtOpen';

		return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
			)
		));
	}
});

var ClickableWrapper = onClickOutside( createClass({
	render: function() {
		return React.createElement( 'div', { className: this.props.className }, this.props.children );
	},
	handleClickOutside: function( e ) {
		this.props.onClickOut( e );
	}
}));

Datetime.defaultProps = {
	className: '',
	defaultValue: '',
	inputProps: {},
	input: true,
	onFocus: function() {},
	onBlur: function() {},
	onChange: function() {},
	onViewModeChange: function() {},
	onNavigateBack: function() {},
	onNavigateForward: function() {},
	timeFormat: true,
	timeConstraints: {},
	dateFormat: true,
	strictParsing: true,
	closeOnSelect: false,
	closeOnTab: true,
	utc: false
};

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
	createClass = __webpack_require__(29),
	DaysView = __webpack_require__(734),
	MonthsView = __webpack_require__(735),
	YearsView = __webpack_require__(736),
	TimeView = __webpack_require__(737)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
	createClass = __webpack_require__(29),
	moment = __webpack_require__(0)
	;

var DateTimePickerDays = createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	}
});

module.exports = DateTimePickerDays;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
	createClass = __webpack_require__(29)
;

var DateTimePickerMonths = createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
	createClass = __webpack_require__(29)
;

var DateTimePickerYears = createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

module.exports = DateTimePickerYears;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
	createClass = __webpack_require__(29),
	assign = __webpack_require__(383)
	;

var DateTimePickerTime = createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );

		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				document.body.removeEventListener( 'touchend', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
			document.body.addEventListener( 'touchend', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},
});

module.exports = DateTimePickerTime;


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//import EmailValidator from 'isemail';
//import emailValidation from 'email-validation';

var isValidEmail = exports.isValidEmail = function isValidEmail(value) {
    //return emailValidation.valid(value);
    return new RegExp("^[^@\\s]+@[^@\\s]+\\\.[^@\\s]+$").test(value); // <- compile problems with all email-validation libs i've tried, so just using this for now.
};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Like <select> but supports different color on placeholder-text (like other input elements has).  (See: https://stackoverflow.com/questions/13154274/onchange-event-of-select-box )
 *
 *  (Yes, the WHOLE purpose of this component, is to be able to show the <select> in a different color, when the placeholder-option is selected)
 *
 *  All it does is: if a "disabled" <option> element is selected, it adds an extra class to the <select> element.
 */
var Select = function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.checkPlaceholderSelected = function () {
            var selectElem = _this.refs.select;

            if (selectElem.options.length == 0) // abort if no <option>-elements in the <select>
                return;

            if (selectElem.selectedIndex < 0 || selectElem.selectedIndex >= selectElem.options.length) // abort if selectedIndex is not within range (if it is -1 for example - can happen: https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/selectedIndex)
                return;

            var isPlaceholderSelected = selectElem.options[selectElem.selectedIndex].disabled;
            if (isPlaceholderSelected != _this.state.isPlaceholderSelected) {
                _this.setState({ isPlaceholderSelected: isPlaceholderSelected });
            }
        };

        _this.state = {
            isPlaceholderSelected: false
        };
        return _this;
    }

    _createClass(Select, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // This method is called after the FIRST render
            this.checkPlaceholderSelected();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            // This method is called after the each render, EXCEPT the first.
            this.checkPlaceholderSelected();
        }
    }, {
        key: "render",
        value: function render() {
            var className = this.props.className;

            if (this.state.isPlaceholderSelected) {
                className += " select-placeholder-selected";
            }

            var changedProps = Object.assign({}, this.props);
            changedProps.className = className;

            return _react2.default.createElement(
                "div",
                { className: "select-1" },
                _react2.default.createElement(
                    "select",
                    _extends({ ref: "select" }, changedProps),
                    this.props.children
                )
            );
        }
    }]);

    return Select;
}(_react2.default.Component);

exports.default = Select;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var phoneRegex = exports.phoneRegex = "^(\\+[0-9]{2}[ ]?)?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?$";

var zipRegex = exports.zipRegex = "^[0-9]{4}$";

var eanRegex = exports.eanRegex = "^[0-9]{13}$";

var cvrRegex = exports.cvrRegex = "^[0-9]{8}$";

var dateRegex = exports.dateRegex = "^[0-9]{4}-[0-9]{2}-[0-9]{2}$";

var timeRegex = exports.timeRegex = "^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}$";

var passwordRegex = exports.passwordRegex = "^.{6}.*$";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Bubble = __webpack_require__(743);

var _Bubble2 = _interopRequireDefault(_Bubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _Bubble2.default;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BubblePortal = __webpack_require__(744);

var _BubblePortal2 = _interopRequireDefault(_BubblePortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderSubtreeIntoContainer = _reactDom2.default.unstable_renderSubtreeIntoContainer;

var Bubble = function (_Component) {
  _inherits(Bubble, _Component);

  function Bubble() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bubble);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bubble.__proto__ || Object.getPrototypeOf(Bubble)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'Bubble', _this.handlerEvent = function () {
      _this.renderPortal(_this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Bubble, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Create the node and render the portal
      this.node = document.createElement('div');
      this.node.className = 'ReactBubble';
      document.body.appendChild(this.node);
      this.renderPortal(this.props);

      // Attach event using capture
      document.addEventListener('scroll', this.handlerEvent, true);
      window.addEventListener('resize', this.handlerEvent, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.renderPortal(newProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove event and destroy the node
      document.removeEventListener('scroll', this.handlerEvent, true);
      window.removeEventListener('resize', this.handlerEvent, true);
      _reactDom2.default.unmountComponentAtNode(this.node);
      document.body.removeChild(this.node);
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      var parentNode = _reactDom2.default.findDOMNode(this).parentNode;
      this.portal = renderSubtreeIntoContainer(this, _react2.default.createElement(_BubblePortal2.default, _extends({}, props, { parentNode: parentNode })), this.node);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('noscript', null);
    }
  }]);

  return Bubble;
}(_react.Component);

Bubble.propTypes = {
  /** Width of the bubble */
  width: _propTypes2.default.number.isRequired,
  /** Height of the bubble */
  height: _propTypes2.default.number.isRequired,
  /** Maximum distance between bubble border and window border before correcting position */
  maxDistanceBeforeCorrect: _propTypes2.default.number,
  /** Margin between the bubble and the sibling element */
  arrowMargin: _propTypes2.default.number,

  /** Custom event, can be used to maintain bubble visible on hover */
  onMouseEnter: _propTypes2.default.func,
  /** Custom event, can be used to maintain bubble visible on hover */
  onMouseLeave: _propTypes2.default.func,

  /** Custom functions */
  customArrowRenderWithDelta: _propTypes2.default.func,

  /** See the "style" part */
  style: _propTypes2.default.object,
  children: _propTypes2.default.any
};
Bubble.defaultProps = {
  maxDistanceBeforeCorrect: 10,
  arrowMargin: 15,
  style: {
    container: {},
    arrow: {
      left: {},
      right: {}
    }
  }
};
exports.default = Bubble;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STYLE_BASE_ARROW = {
  position: 'absolute',
  width: 0,
  height: 0,
  borderStyle: 'solid'
};

var STYLE_LEFT_ARROW = {
  right: '100%',
  top: 5,
  borderTopWidth: 0,
  borderTopColor: 'transparent',
  borderRightWidth: 10,
  borderRightColor: 'rgb(32,166,181)',
  borderBottomWidth: 10,
  borderBottomColor: 'transparent',
  borderLeftWidth: 0,
  borderLeftColor: 'transparent'
};

var STYLE_RIGHT_ARROW = {
  left: '100%',
  top: 5,
  borderTopWidth: 10,
  borderTopColor: 'rgb(32,166,181)',
  borderRightWidth: 10,
  borderRightColor: 'transparent',
  borderBottomWidth: 0,
  borderBottomColor: 'transparent',
  borderLeftWidth: 0,
  borderLeftColor: 'transparent'
};

var STYLE_ARROW = {
  left: _extends({}, STYLE_BASE_ARROW, STYLE_LEFT_ARROW),
  right: _extends({}, STYLE_BASE_ARROW, STYLE_RIGHT_ARROW)
};

var STYLE_CONTAINER = {
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: 'rgb(238, 238, 238)',
  minHeight: 70,
  display: 'flex',
  boxShadow: 'rgba(0, 0, 0, 0.2) 2px 0px 10px 2px',
  borderRadius: 2
};

var STYLE_BAR = {
  width: 10,
  backgroundColor: 'rgb(32,166,181)',
  position: 'relative'
};

var BubblePortal = function (_Component) {
  _inherits(BubblePortal, _Component);

  function BubblePortal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BubblePortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BubblePortal.__proto__ || Object.getPrototypeOf(BubblePortal)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'ReactBubblePortal', _this.state = {
      arrowType: 'left',
      containerStyle: {},
      arrowStyle: {}
    }, _this.componentWillMount = function () {
      _this.defineContainerPosition(_this.props);
    }, _this.getElementPosition = function (el) {
      var rect = el.getBoundingClientRect();
      var top = rect.top,
          left = rect.left,
          right = rect.right,
          bottom = rect.bottom,
          width = rect.width;

      var isBody = el.tagName === 'body';
      var offset = isBody ? { top: 0, left: 0 } : null;
      var scroll = isBody ? document.documentElement.scrollTop || document.body.scrollTop : el.scrollTop;
      var dimensions = isBody ? { width: window.width, height: window.height } : null;
      return _extends({
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        scroll: scroll
      }, dimensions, offset);
    }, _this.defineContainerPosition = function (props) {
      if (!_this.props.parentNode) return;

      var _this$calculateBubble = _this.calculateBubbleAndArrowPositions(props),
          containerStyle = _this$calculateBubble.containerStyle,
          arrowStyle = _this$calculateBubble.arrowStyle;

      _this.setState({
        containerStyle: containerStyle,
        arrowStyle: arrowStyle
      });
    }, _this.calculateBubbleAndArrowPositions = function (props) {
      var parentPosition = _this.getElementPosition(props.parentNode);

      // Initial container positionning (right of parent container)
      var containerStyle = _extends({}, STYLE_CONTAINER, props.style.container || {}, {
        top: parentPosition.top,
        left: parentPosition.left + parentPosition.width + props.arrowMargin,
        width: props.width,
        height: props.height
      });

      var arrowType = 'left';

      // Move the bubble to the correct place
      var rootPosition = _this.getElementPosition(document.body);

      // Move the bubble to the left
      if (parentPosition.right + _this.props.width + _this.props.maxDistanceBeforeCorrect >= rootPosition.right) {
        containerStyle.left = parentPosition.left - _this.props.width - _this.props.arrowMargin;
        containerStyle.flexDirection = 'row-reverse';
        arrowType = 'right';
      }

      // Initial arrow positionning (left, no delta)
      var arrowStyle = _extends({}, STYLE_ARROW[arrowType], (props.style.arrow || {})[arrowType]);

      // Delta top
      var deltaTop = parentPosition.top + _this.props.height + _this.props.maxDistanceBeforeCorrect - rootPosition.bottom;
      if (deltaTop >= 0) {
        var newTop = containerStyle.top - deltaTop;
        var bubbleFixedToParentBottom = newTop + _this.props.height < parentPosition.bottom;
        containerStyle.top = bubbleFixedToParentBottom ? parentPosition.bottom - _this.props.height : newTop;
        arrowStyle =
        // Custom arrow delta render
        _this.props.customArrowRenderWithDelta && typeof _this.props.customArrowRenderWithDelta === 'function' ? _this.props.customArrowRenderWithDelta(arrowStyle, deltaTop, arrowType, bubbleFixedToParentBottom) : _this.renderArrowWithDelta(arrowStyle, deltaTop, arrowType, bubbleFixedToParentBottom);
      }

      return { containerStyle: containerStyle, arrowStyle: arrowStyle };
    }, _this.reverseArrowProperties = function (arrowProperties, direction) {
      if (direction === 'left') {
        return _extends({}, arrowProperties, {
          // Reverse right/left width, both become transparent
          borderRightColor: 'transparent',
          borderRightWidth: arrowProperties.borderLeftWidth,
          borderLeftColor: 'transparent',
          borderLeftWidth: arrowProperties.borderRightWidth,
          // Bottom takes right color
          borderBottomColor: arrowProperties.borderRightColor
        });
      } else if (direction === 'right') {
        return _extends({}, arrowProperties, {
          borderTopColor: 'transparent',
          borderLeftWidth: arrowProperties.borderRightWidth,
          borderLeftColor: arrowProperties.borderTopColor,
          borderRightWidth: arrowProperties.borderLeftWidth
        });
      }
      return arrowProperties;
    }, _this.renderArrowWithDelta = function (arrowStyle, deltaTop, arrowType, bubbleFixedToParentBottom) {
      arrowStyle.top = bubbleFixedToParentBottom ? _this.props.height - 15 : deltaTop;

      // Revert arrow when the delta is more important than half height of bubble
      if (5 + deltaTop >= _this.props.height / 2) {
        arrowStyle = _this.reverseArrowProperties(arrowStyle, arrowType);
      }

      return arrowStyle;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BubblePortal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.defineContainerPosition(newProps);
    }

    /**
     * Compute the element position with scroll and offset
     */


    /**
     * Define the container position from the parent and check if the parent is still visible
     */


    /**
     * Calculate the bubble position
     * Multiple position fixes are made here
     */

  }, {
    key: 'render',
    value: function render() {
      var barStyle = _extends({}, STYLE_BAR, this.props.style.bar || {});
      return _react2.default.createElement(
        'div',
        {
          style: this.state.containerStyle,
          onMouseEnter: this.props.onMouseEnter,
          onMouseLeave: this.props.onMouseLeave },
        _react2.default.createElement(
          'div',
          { style: barStyle },
          _react2.default.createElement('div', { style: this.state.arrowStyle })
        ),
        this.props.children
      );
    }
  }]);

  return BubblePortal;
}(_react.Component);

BubblePortal.propTypes = {
  // Injected by Bubble
  parentNode: _propTypes2.default.object,

  // Component props
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  maxDistanceBeforeCorrect: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.any,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  customArrowRenderWithDelta: _propTypes2.default.func,
  arrowMargin: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object.isRequired
};
exports.default = BubblePortal;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(161);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactFileReader = __webpack_require__(162);

var _reactFileReader2 = _interopRequireDefault(_reactFileReader);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _bluebird2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _bluebird2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportFilesDialog = function (_React$Component) {
    _inherits(ImportFilesDialog, _React$Component);

    function ImportFilesDialog(props) {
        var _this2 = this;

        _classCallCheck(this, ImportFilesDialog);

        var _this = _possibleConstructorReturn(this, (ImportFilesDialog.__proto__ || Object.getPrototypeOf(ImportFilesDialog)).call(this, props));

        _this.onFilesSelect = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(filelist) {
                var fileIds, prop, isFilesSelected, messages;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                fileIds = [];

                                for (prop in filelist) {
                                    if (filelist.hasOwnProperty(prop) && /^[0-9]+$/.test(prop)) {
                                        fileIds.push(prop);
                                    }
                                }
                                isFilesSelected = false;
                                messages = [];
                                _context2.next = 6;
                                return _bluebird2.default.all(fileIds.map(function () {
                                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
                                        var file, _file;

                                        return regeneratorRuntime.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        if (!(_this.props.importType === 'section-stat')) {
                                                            _context.next = 24;
                                                            break;
                                                        }

                                                        if (!/^SEKSTA[0-9]{2}\.[0-9]{2}$/.test(filelist[id].name.toUpperCase())) {
                                                            _context.next = 21;
                                                            break;
                                                        }

                                                        isFilesSelected = true;
                                                        file = _this.state.files.find(function (file) {
                                                            return file.name === filelist[id].name.toUpperCase();
                                                        });

                                                        if (!file) {
                                                            _context.next = 10;
                                                            break;
                                                        }

                                                        _context.next = 7;
                                                        return filelist[id].text();

                                                    case 7:
                                                        file.content = _context.sent;
                                                        _context.next = 19;
                                                        break;

                                                    case 10:
                                                        _context.t0 = _this.state.files;
                                                        _context.t1 = filelist[id].name.toUpperCase();
                                                        _context.next = 14;
                                                        return filelist[id].text();

                                                    case 14:
                                                        _context.t2 = _context.sent;
                                                        _context.t3 = filelist[id].name.substr(6, 2);
                                                        _context.t4 = filelist[id].name.substr(9, 2);
                                                        _context.t5 = {
                                                            name: _context.t1,
                                                            content: _context.t2,
                                                            year: _context.t3,
                                                            section: _context.t4
                                                        };

                                                        _context.t0.push.call(_context.t0, _context.t5);

                                                    case 19:
                                                        _context.next = 22;
                                                        break;

                                                    case 21:
                                                        messages.push({
                                                            title: "Ugyldigt filnavn " + filelist[id].name,
                                                            description: "Filer med sektionsstatistik skal være navngivet SEKSTA(ÅÅ).(SS), hvor (ÅÅ) er årstal og (SS) er sektionsnummer."
                                                        });

                                                    case 22:
                                                        _context.next = 39;
                                                        break;

                                                    case 24:
                                                        isFilesSelected = true;
                                                        _file = _this.state.files.find(function (file) {
                                                            return file.name === filelist[id].name.toUpperCase();
                                                        });

                                                        if (!_file) {
                                                            _context.next = 32;
                                                            break;
                                                        }

                                                        _context.next = 29;
                                                        return filelist[id].text();

                                                    case 29:
                                                        _file.content = _context.sent;
                                                        _context.next = 39;
                                                        break;

                                                    case 32:
                                                        _context.t6 = _this.state.files;
                                                        _context.t7 = filelist[id].name.toUpperCase();
                                                        _context.next = 36;
                                                        return filelist[id].text();

                                                    case 36:
                                                        _context.t8 = _context.sent;
                                                        _context.t9 = {
                                                            name: _context.t7,
                                                            content: _context.t8
                                                        };

                                                        _context.t6.push.call(_context.t6, _context.t9);

                                                    case 39:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this2);
                                    }));

                                    return function (_x2) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));

                            case 6:
                                if (isFilesSelected) _this.forceUpdate();
                                messages.forEach(function (msg) {
                                    _reactNotifications.NotificationManager.error(msg.description, msg.title, 10000);
                                });

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.onImport = function () {
            if (_this.props.importType === 'section-stat') {
                if (_this.state.files.length) _this.props.dispatch(AdminActions.importSectionStat(_this.state.files.map(function (file) {
                    return {
                        section: file.section,
                        year: file.year,
                        content: file.content
                    };
                }), function () {
                    _reactNotifications.NotificationManager.success("De valgte statistikfiler er uploadet til databasen.", "Import", 4000);
                    _this.props.onClose();
                }));
            }
        };

        _this.state = {
            files: []
        };
        return _this;
    }

    _createClass(ImportFilesDialog, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var fileExtentions = [].concat(_toConsumableArray(Array(100).keys())).map(function (i) {
                return '.' + String(i).padStart(2, '0');
            });
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this3.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '500px',
                                width: '500px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Importer'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    _reactFileReader2.default,
                                    { id: 'import-files', fileTypes: fileExtentions, base64: false, multipleFiles: true, handleFiles: this.onFilesSelect },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick(e) {
                                                return e.preventDefault();
                                            }, className: 'btn-primary' },
                                        'V\xE6lg filer'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'scrollable section-files', style: { maxHeight: '310px', overflow: 'auto', marginTop: '25px' } },
                                    _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.state.files.map(function (file, ix) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        file.name
                                                    ),
                                                    _this3.props.importType === 'section-stat' ? [_react2.default.createElement(
                                                        'td',
                                                        { key: 'section' },
                                                        'Sektion ',
                                                        file.section
                                                    ), _react2.default.createElement(
                                                        'td',
                                                        { key: 'year' },
                                                        '20',
                                                        file.year
                                                    )] : null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        _react2.default.createElement('i', { className: 'fa fa-trash clickable', onClick: function onClick() {
                                                                _this3.state.files.splice(ix, 1);
                                                                _this3.forceUpdate();
                                                            } })
                                                    )
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', disabled: this.state.files.length === 0, onClick: this.onImport },
                                'Importer'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this3.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ImportFilesDialog;
}(_react2.default.Component);

ImportFilesDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func,
    importType: _propTypes2.default.string
};
ImportFilesDialog.defaultProps = {
    onSuccess: null,
    exportType: null
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportFilesDialog);

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  function getBytes() {
    try {
      // Modern Browser
      return Array.from(
        (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(16))
      );
    } catch (error) {
      // Legacy Browser, fallback to Math.random
      var ret = [];
      while (ret.length < 16) ret.push((Math.random() * 256) & 0xff);
      return ret;
    }
  }

  function m(v) {
    v = v.toString(16);
    if (v.length < 2) v = "0" + v;
    return v;
  }

  function genUUID() {
    var rnd = getBytes();
    rnd[6] = (rnd[6] & 0x0f) | 0x40;
    rnd[8] = (rnd[8] & 0x3f) | 0x80;
    rnd = rnd
      .map(m)
      .join("")
      .match(/(.{8})(.{4})(.{4})(.{4})(.{12})/);
    rnd.shift();
    return rnd.join("-");
  }

  var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  function isUUID(uuid) {
    return uuidPattern.test(uuid);
  }

  genUUID.valid = isUUID;

  // global
  if (window) {
    window.uuid4 = genUUID;
  }

  // Node-style CJS
  if (typeof module !== "undefined" && module.exports) {
    module.exports = genUUID;
  }

  // AMD - legacy
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return genUUID;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
})();


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _reactNotifications = __webpack_require__(8);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacesInvoiceDialog = function (_React$Component) {
    _inherits(RacesInvoiceDialog, _React$Component);

    function RacesInvoiceDialog(props) {
        _classCallCheck(this, RacesInvoiceDialog);

        var _this = _possibleConstructorReturn(this, (RacesInvoiceDialog.__proto__ || Object.getPrototypeOf(RacesInvoiceDialog)).call(this, props));

        _this.fields = [];

        _this.onExport = function () {
            if (_this.allInputValid()) {
                _this.props.dispatch(AdminActions.invoiceRaces({
                    week: Number(_this.state.week),
                    clubFrom: _this.state.clubFrom === '' ? null : _this.state.clubFrom,
                    clubTo: _this.state.clubTo === '' ? null : _this.state.clubTo
                }, function (result) {
                    _reactNotifications.NotificationManager.success("Fakturaer er oprettet for de valgte foreninger i uge " + _this.state.week + ". " + String(result.status.invoicesSend) + ' fakturaer er oprettet.' + (result.status.invoicesNotSend === 0 ? '' : ' Fakturering af ' + String(result.status.invoicesNotSend) + ' foreninger fejlede.'), "Fakturering", 4000);
                    if (result.messages) result.messages.forEach(function (msg) {
                        _reactNotifications.NotificationManager.warning(msg, 'Fejl', 0);
                    });
                    if (result.status.invoicesNotSend === 0) _this.props.onClose();
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            week: String((0, _moment2.default)(new Date()).isoWeek()),
            clubFrom: '',
            clubTo: '299'
        };
        return _this;
    }

    _createClass(RacesInvoiceDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '200px',
                                width: '500px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Fakturer til E-conomic'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'week' },
                                                    'Uge'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'week', id: 'week', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.week,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[0] = instance;
                                                    }
                                                })
                                            ),
                                            _react2.default.createElement('td', { colSpan: 2 })
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'clubFrom' },
                                                    'Fra forening'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'clubFrom', id: 'clubFrom', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubFrom,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur() {
                                                        _this2.fields[1].setState({ focused: false, visited: true });
                                                        if (/^[0-9]{1,2}$/.test(_this2.state.clubFrom)) _this2.setState({ clubFrom: _this2.state.clubFrom.padStart(3, '0'), clubTo: _this2.state.clubTo === '' ? _this2.state.clubFrom.padStart(3, '0') : _this2.state.clubTo });else if (/^[0-9]{3}$/.test(_this2.state.clubFrom) && _this2.state.clubTo === '') _this2.setState({ clubTo: _this2.state.clubFrom });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'clubTo' },
                                                    'Til forening'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'clubTo', id: 'clubTo', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubTo,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur() {
                                                        _this2.fields[2].setState({ focused: false, visited: true });
                                                        if (/^[0-9]{1,2}$/.test(_this2.state.clubTo)) _this2.setState({ clubTo: _this2.state.clubTo.padStart(3, '0') });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                })
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', onClick: this.onExport },
                                'Fakturer'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RacesInvoiceDialog;
}(_react2.default.Component);

RacesInvoiceDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func
};
RacesInvoiceDialog.defaultProps = {
    onSuccess: null
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RacesInvoiceDialog);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactFileReader = __webpack_require__(162);

var _reactFileReader2 = _interopRequireDefault(_reactFileReader);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestoreFromBackupDialog = function (_React$Component) {
    _inherits(RestoreFromBackupDialog, _React$Component);

    function RestoreFromBackupDialog(props) {
        _classCallCheck(this, RestoreFromBackupDialog);

        var _this = _possibleConstructorReturn(this, (RestoreFromBackupDialog.__proto__ || Object.getPrototypeOf(RestoreFromBackupDialog)).call(this, props));

        _this.fields = [];

        _this.onFileSelect = function (file) {
            var filelist = document.getElementById("backup-file-selecctbackup").files;
            if (filelist.length > 0) {
                if (/^.+\.SQL$/.test(filelist[0].name.toUpperCase()) || /^.+\.ZIP$/.test(filelist[0].name.toUpperCase())) _this.setState({ file: filelist[0] });else _reactNotifications.NotificationManager.error("Kun filer af typen .ZIP og .SQL kan bruges til at indlæse fra backup.", "Ugyldigt tiltype", 10000);
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.onRestore = function () {
            if (_this.allInputValid()) {
                if (_this.state.file !== null) document.getElementById('restore-backup-form').submit();
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            file: null,
            year: ''
        };
        return _this;
    }

    _createClass(RestoreFromBackupDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var fileExtentions = [].concat(_toConsumableArray(Array(100).keys())).map(function (i) {
                return '.' + String(i).padStart(2, '0');
            });
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: this.props.auth.database === 'standard' ? '320px' : '400px',
                                width: '500px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Indl\xE6s fra backup'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'form',
                                    { id: 'restore-backup-form', action: "/api/admin/restore-backup", method: 'post', enctype: 'multipart/form-data' },
                                    _react2.default.createElement('input', { type: 'file', accept: '.zip,.sql', id: 'backup-file-selecctbackup', name: 'backup-file-selecctbackup', caption: 'V\xE6lg fil', style: { display: 'none' }, onChange: this.onFileSelect }),
                                    _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { style: { width: '125px' } },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { className: 'btn-primary', onClick: function onClick(e) {
                                                                e.preventDefault();
                                                                document.getElementById("backup-file-selecctbackup").click();
                                                            } },
                                                        'V\xE6lg fil'
                                                    )
                                                ),
                                                this.state.file === null ? null : _react2.default.createElement(
                                                    'td',
                                                    { style: { paddingLeft: '10px' } },
                                                    _react2.default.createElement(
                                                        'div',
                                                        null,
                                                        this.state.file.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { style: { fontSize: '.8em' } },
                                                        (0, _moment2.default)(this.state.file.lastModifiedDate).format(_config2.default.formats.dateTimeFormat),
                                                        ', ',
                                                        this.state.file.size,
                                                        ' bytes'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { style: { width: '125px', paddingTop: '10px', verticalAlign: 'top' } },
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'year' },
                                                        '\xC5r'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: 'Aktuelt', className: 'field100', containerClassName: 'display-inline-block',
                                                        name: 'year', id: 'year', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: this.state.year,
                                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: this.onStandardFieldChange,
                                                        onBlur: function onBlur() {
                                                            _this2.fields[0].setState({ focused: false, visited: true });
                                                            if (/^[0-9]{2}$/.test(_this2.state.year)) _this2.setState({ year: '20' + _this2.state.year });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[0] = instance;
                                                        }
                                                    }),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { style: { fontSize: '.75em', marginTop: '5px', marginBottom: '0' } },
                                                        'Indtast et \xE5rstal for at oprette en ny database for det angivne \xE5r. Dette vil ikke \xE6ndre den aktuelle database.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { style: { fontSize: '.75em', marginTop: '10px', marginBottom: '0' } },
                                                        'Dette kan specielt v\xE6re nyttigt i forbindelse med s\xE6sonstart. F\xF8r s\xE6sonstart anbefales det at tage en backup af databasen. Indl\xE6ses denne backup til det relevante \xE5rstal, vil det siden v\xE6re muligt at skifte til arkivdatabasen for at tilg\xE5 data fra tidligere s\xE6soner.'
                                                    )
                                                )
                                            ),
                                            this.props.auth.database === 'standard' ? null : _react2.default.createElement(
                                                'tr',
                                                { className: 'warning-information' },
                                                _react2.default.createElement(
                                                    'td',
                                                    { colSpan: 2, style: { paddingTop: '10px' } },
                                                    'Du har i \xF8jeblikket \xE5bnet en arkivdatabase. Hvis du indl\xE6ser backup uden angivelse af \xE5rstal, vil du overskrive ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        'arkivdatabasen'
                                                    ),
                                                    '. For at gendanne den prim\xE6re database fra en backup, skal du f\xF8rst returnere til standarddatabasen.'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-dangerous', disabled: this.state.file === null, onClick: this.onRestore, title: 'Ved indl\xE6sning af backup overskrives ALLE data i den eksisterende database.' },
                                'Indl\xE6s backup'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RestoreFromBackupDialog;
}(_react2.default.Component);

RestoreFromBackupDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};
RestoreFromBackupDialog.defaultProps = {};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            database: state.auth.database
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RestoreFromBackupDialog);

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StartSeasonDialog = function (_React$Component) {
    _inherits(StartSeasonDialog, _React$Component);

    function StartSeasonDialog(props) {
        _classCallCheck(this, StartSeasonDialog);

        var _this = _possibleConstructorReturn(this, (StartSeasonDialog.__proto__ || Object.getPrototypeOf(StartSeasonDialog)).call(this, props));

        _this.onStartSeason = function () {
            if (_this.state.deleteRaces !== null) _this.props.dispatch(AdminActions.startSeason({
                deleteRaces: _this.state.deleteRaces
            }, function () {
                _reactNotifications.NotificationManager.success('Alle resultater er nu slettet, og en ny sæson er påbegyndt.', 'Sæsonstart', 4000);
                _this.props.onClose();
            }));
        };

        _this.state = {
            deleteRaces: null
        };
        return _this;
    }

    _createClass(StartSeasonDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var fileExtentions = [].concat(_toConsumableArray(Array(100).keys())).map(function (i) {
                return '.' + String(i).padStart(2, '0');
            });
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: this.props.auth.database === 'standard' ? '340px' : '425px',
                                width: '500px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Ny s\xE6son'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'small-vertical-spacing' },
                                    _react2.default.createElement('input', { type: 'radio', id: 'deleteRaces', name: 'raceDeleteOption', checked: this.state.deleteRaces === true, onClick: function onClick() {
                                            return _this2.setState({ deleteRaces: true });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'deleteRaces' },
                                        'Slet alle kapflyvninger'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'small-vertical-spacing' },
                                    _react2.default.createElement('input', { type: 'radio', id: 'retainRaces', name: 'raceDeleteOption', checked: this.state.deleteRaces === false, onClick: function onClick() {
                                            return _this2.setState({ deleteRaces: false });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'retainRaces' },
                                        'Bibehold kapflyvninger, men nulstil sliptider og pr\xE6mier'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'info' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Ved s\xE6sonstart nulstilles/slettes en r\xE6kke data s\xE5som sliptider, kapflyvningsresultater, mesterskabsresultater og fejllister.'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Det kan anbefales at ',
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'tage en backup'
                                        ),
                                        ' af databasen, inden den nye s\xE6son startes, og data nulstilles. En s\xE5dan backup vil endvidere kunne indl\xE6ses til en arkivdatabase ved indl\xE6sning af backup\'en med angivelse af et \xE5rstal.'
                                    ),
                                    this.props.auth.database === 'standard' ? null : _react2.default.createElement(
                                        'p',
                                        { className: 'warning-information' },
                                        'Du har i \xF8jeblikket \xE5bnet en arkivdatabase. Hvis du starter en ny s\xE6son nu, vil du nulstille ',
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'arkivdatabasen'
                                        ),
                                        '. For at starte en ny s\xE6son i den prim\xE6re database, skal du f\xF8rst returnere til standarddatabasen.'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-dangerous', disabled: this.state.deleteRaces === null, onClick: this.onStartSeason, title: 'Nulstiller en r\xE6kke data ved s\xE6sonstart. Det anbefales at sikre, at en databasebackup er tilg\xE6ngelig, inden den nye s\xE6son startes.' },
                                'Nulstil data'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return StartSeasonDialog;
}(_react2.default.Component);

StartSeasonDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func
};
StartSeasonDialog.defaultProps = {
    onSuccess: null
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            database: state.auth.database
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StartSeasonDialog);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var installer = typeof window === "undefined" ? null // <- don't require the installer on the server (it will crash - no webpack).
: __webpack_require__(751);

var ImportDevicesDialog = function (_React$Component) {
    _inherits(ImportDevicesDialog, _React$Component);

    function ImportDevicesDialog(props) {
        _classCallCheck(this, ImportDevicesDialog);

        var _this = _possibleConstructorReturn(this, (ImportDevicesDialog.__proto__ || Object.getPrototypeOf(ImportDevicesDialog)).call(this, props));

        _this.fields = [];

        _this.onImport = function (type) {
            if (_this.allInputValid()) {
                var id = ((0, _moment2.default)().valueOf() + '-' + _this.props.auth.id).slice(0, 25);
                var cb = window.location.origin;
                if (cb.slice(-1) !== '/') cb += '/';
                cb += 'api/device-import/' + id;
                _this.props.dispatch(RaceActions.startDeviceImport(id, {
                    requestType: type,
                    deviceType: _this.state.deviceType,
                    commPort: _this.state.commPort,
                    week: parseInt(_this.state.week),
                    reset: _this.state.reset,
                    overwrite: _this.state.overwrite,
                    club: _this.props.auth.currentEntity
                }, function () {
                    window.location.href = _config2.default.commUtility.url + "?callback=" + encodeURIComponent(cb) + "&command=read-data&id=" + encodeURIComponent(id) + "&device=" + _this.state.deviceType + "&port=" + _this.state.commPort;
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onCancelImport = function () {
            _this.props.race.deviceImports.filter(function (data) {
                var typ = data.get('requestType');
                return typ === 'signups' || typ === 'results';
            }).forEach(function (data, id) {
                _this.props.dispatch(RaceActions.updateDeviceImport(id, {
                    info: "cancelled"
                }));
            });
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            deviceType: 'unikon',
            commPort: 'com1',
            week: (0, _moment2.default)(new Date()).add(-3, 'days').isoWeek().toString(),
            reset: true,
            overwrite: true,
            installerSrc: null
        };
        return _this;
    }

    _createClass(ImportDevicesDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                installerSrc: installer
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this2 = this;

            this.props.race.deviceImports.forEach(function (outstanding, id) {
                _this2.props.dispatch(RaceActions.updateDeviceImport(id, {
                    info: "cancelled"
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var isBusy = this.props.race.deviceImports.some(function (data) {
                var typ = data.get('requestType');
                return typ === 'signups' || typ === 'results';
            });
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this3.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '450px',
                                width: '650px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title', onClick: function onClick() {
                                    return;
                                    // TODO: Remove this.
                                    console.log("Outstandings: ", _this3.props.race.deviceImports.count(), _this3.props.race.deviceImports.toJS());
                                    if (_this3.props.race.deviceImports.count() > 0) {
                                        var outstanding = _this3.props.race.deviceImports.keySeq().first();
                                        console.log("Outstanding send: ", _this3.props.race.deviceImports.get(outstanding).toJS());
                                        var data = '1';
                                        if (_this3.props.race.deviceImports.get(outstanding).toJS().deviceType === 'tauris') data = '\n2   001 24072015002907152000152005\n3   001  22 209  0640 93 2707161530\n3   001  22 209  0641 93 2707153334\n3   001  22 209  0642 93 2707161535\n                            ';else if (_this3.props.race.deviceImports.get(outstanding).toJS().deviceType === 'unikon') data = '\n    209001        230725143000290725151617      15161794 26/07\n 19  2090210            1545312707\n 19  2090214            1705122707\n 19  2090230\n';
                                        _this3.props.dispatch(RaceActions.updateDeviceImport(outstanding, {
                                            data: data,
                                            info: "success"
                                        }));
                                    }
                                } },
                            'Indl\xE6s fra elektronisk udstyr'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'large-vertical-spacing', style: { width: "50%" } },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    'System'
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'radio', id: 'deviveTypeUnikon', name: 'deviveType', checked: this.state.deviceType === 'unikon', onClick: function onClick() {
                                                            return _this3.setState({ deviceType: 'unikon' });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'deviveTypeUnikon' },
                                                        'Unikon'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    _react2.default.createElement('input', { type: 'radio', id: 'deviveTypeTauris', name: 'deviveType', checked: this.state.deviceType === 'tauris', onClick: function onClick() {
                                                            return _this3.setState({ deviceType: 'tauris' });
                                                        } }),
                                                    ' ',
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'deviveTypeTauris' },
                                                        'Tauris'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'large-vertical-spacing', style: { width: "50%" } },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'small-vertical-spacing' },
                                                    'Kommunikationsport'
                                                ),
                                                _react2.default.createElement(
                                                    'table',
                                                    null,
                                                    _react2.default.createElement(
                                                        'tbody',
                                                        null,
                                                        _react2.default.createElement(
                                                            'tr',
                                                            null,
                                                            _react2.default.createElement(
                                                                'td',
                                                                null,
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort1', name: 'commPort', checked: this.state.commPort === 'com1', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com1' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort1' },
                                                                        'COM1',
                                                                        this.props.race.deviceComPorts.includes(':com1:') ? '*' : ''
                                                                    )
                                                                ),
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort2', name: 'commPort', checked: this.state.commPort === 'com2', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com2' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort2' },
                                                                        'COM2',
                                                                        this.props.race.deviceComPorts.includes(':com2:') ? '*' : ''
                                                                    )
                                                                ),
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort3', name: 'commPort', checked: this.state.commPort === 'com3', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com3' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort3' },
                                                                        'COM3',
                                                                        this.props.race.deviceComPorts.includes(':com3:') ? '*' : ''
                                                                    )
                                                                )
                                                            ),
                                                            _react2.default.createElement(
                                                                'td',
                                                                null,
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort4', name: 'commPort', checked: this.state.commPort === 'com4', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com4' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort4' },
                                                                        'COM4',
                                                                        this.props.race.deviceComPorts.includes(':com4:') ? '*' : ''
                                                                    )
                                                                ),
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort5', name: 'commPort', checked: this.state.commPort === 'com5', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com5' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort5' },
                                                                        'COM5',
                                                                        this.props.race.deviceComPorts.includes(':com5:') ? '*' : ''
                                                                    )
                                                                ),
                                                                _react2.default.createElement(
                                                                    'div',
                                                                    { className: 'small-vertical-spacing' },
                                                                    _react2.default.createElement('input', { type: 'radio', id: 'commPort6', name: 'commPort', checked: this.state.commPort === 'com6', onClick: function onClick() {
                                                                            return _this3.setState({ commPort: 'com6' });
                                                                        } }),
                                                                    ' ',
                                                                    _react2.default.createElement(
                                                                        'label',
                                                                        { htmlFor: 'commPort6' },
                                                                        'COM6',
                                                                        this.props.race.deviceComPorts.includes(':com6:') ? '*' : ''
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'week' },
                                                    'Uge'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'week', id: 'week', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.week,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this3.fields[0] = instance;
                                                    }
                                                })
                                            )
                                        )
                                    )
                                ),
                                this.props.race.deviceImporterVersion !== null && this.props.race.deviceImporterVersion !== _config2.default.commUtility.version ? _react2.default.createElement(
                                    'div',
                                    { className: 'downloadCommInstaller' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        this.props.race.deviceImporterVersion === "-" ? "Programmet til kommunikation med anlæggene er ikke installeret" : "Der er kommet ny version af kommunikationsprogrammet for anlæggene"
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        'Klik ',
                                        _react2.default.createElement(
                                            'a',
                                            { href: this.state.installerSrc },
                                            'her'
                                        ),
                                        ' for at downloade kommunikationsprogrammet'
                                    )
                                ) : _react2.default.createElement(
                                    'div',
                                    { className: 'downloadCommInstaller' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        'Klik ',
                                        _react2.default.createElement(
                                            'a',
                                            { href: this.state.installerSrc },
                                            'her'
                                        ),
                                        ' for at downloade kommunikationsprogrammet'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            isBusy ? null : _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', name: 'signups', disabled: this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-", onClick: function onClick() {
                                        _this3.onImport('signups');
                                    } },
                                'Indl\xE6s anmeldelser'
                            ),
                            isBusy ? null : _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', name: 'results', disabled: this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-", onClick: function onClick() {
                                        _this3.onImport('results');
                                    } },
                                'Indl\xE6s resultater'
                            ),
                            isBusy ? _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', name: 'results', onClick: function onClick() {
                                        _this3.onCancelImport('results');
                                    } },
                                'Afbryd indl\xE6sning'
                            ) : null,
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this3.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ImportDevicesDialog;
}(_react2.default.Component);

ImportDevicesDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            id: state.auth.id,
            currentEntity: state.auth.currentEntity
        },
        race: {
            deviceImporterVersion: state.race.deviceImporterVersion,
            deviceImports: state.race.deviceImports,
            deviceComPorts: state.race.deviceComPorts
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportDevicesDialog);

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "BrevCommUtil.exe";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lib = __webpack_require__(18);

var _confirmDialog = __webpack_require__(12);

var _alertDialog = __webpack_require__(89);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportSignupsAndResultsDialog = function (_React$Component) {
    _inherits(ExportSignupsAndResultsDialog, _React$Component);

    function ExportSignupsAndResultsDialog(props) {
        _classCallCheck(this, ExportSignupsAndResultsDialog);

        var _this = _possibleConstructorReturn(this, (ExportSignupsAndResultsDialog.__proto__ || Object.getPrototypeOf(ExportSignupsAndResultsDialog)).call(this, props));

        _this.fields = [];

        _this.onSend = function () {
            if (_this.allInputValid()) {
                var letsGo = true;
                if (_this.props.race.races.filter(function (race) {
                    return race.Uge === Number(_this.state.week) && race.AntalDuer > 0 && (race.Sektion !== null || (0, _lib.getRegi)(race.Farvekode) === 'DdB') && (_this.state.raceType === 'country' && race.LMU === 'O' || _this.state.raceType === 'nonCountry' && race.LMU !== 'O' || _this.state.raceType !== 'country' && _this.state.raceType !== 'nonCountry');
                }).size === 0) (0, _confirmDialog.confirm)("Ingen duer", _react2.default.createElement(
                    'span',
                    null,
                    'Der optr\xE6der ingen duer i udl\xE6sningen. \xD8nsker du alligevel at sende data?'
                ), function () {}, function () {
                    letsGo = false;
                });
                if (letsGo) {
                    _this.props.dispatch(RaceActions.sendFromClub(_this.props.exportType, {
                        week: _this.state.week,
                        raceType: _this.state.raceType === null ? 'default' : _this.state.raceType,
                        longRaceStatus: _this.state.longRaceStatus
                    }, function (response) {
                        if (response !== '') {
                            var msg = [_this.props.exportType === 'signup' ? 'Anmeldelser' : 'Resultater', ' for uge ', _this.state.week, ' er sendt.', _react2.default.createElement('br', null), _react2.default.createElement('br', null), _react2.default.createElement(
                                'b',
                                null,
                                'F\xF8lgende meddelelser er modtaget:'
                            ), _react2.default.createElement('br', null)].concat(response.split('|').map(function (line, ix) {
                                return [line, _react2.default.createElement('br', null)];
                            }));
                            (0, _alertDialog.alert)("Info", msg, function () {}, { textAlign: "left" });
                        } else _reactNotifications.NotificationManager.success((_this.props.exportType === 'signup' ? 'Anmeldelser' : 'Resultater') + ' for uge ' + _this.state.week, ' er sendt.', "Info", 4000);
                        _this.props.onClose();
                    }));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            week: (0, _moment2.default)(new Date()).add(props.exportType === 'signup' ? 0 : -3, 'days').isoWeek().toString(),
            raceType: null,
            longRaceStatus: null
        };
        return _this;
    }

    _createClass(ExportSignupsAndResultsDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isRaces = this.props.race.races.filter(function (race) {
                return race.Uge === Number(_this2.state.week) && race.AntalDuer > 0;
            }).size > 0;
            var raceTypeEnabled = this.props.exportType === 'result' && this.props.race.races.filter(function (race) {
                return race.Uge === Number(_this2.state.week) && race.LMU === 'O' && race.AntalDuer > 0 && (race.Sektion !== null || (0, _lib.getRegi)(race.Farvekode) === 'DdB');
            }).size > 0;
            var longRacesIncluded = raceTypeEnabled && this.state.raceType === 'country' || raceTypeEnabled && this.state.raceType === 'all';
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '375px',
                                width: '350px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Overf\xF8r ',
                            this.props.exportType === 'signup' ? 'anmeldelser' : 'resultater'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'week' },
                                                    'Uge'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'week', id: 'week', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.week,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: function onChange(e) {
                                                        _this2.onStandardFieldChange(e);
                                                        _this2.setState({ raceType: null, longRaceStatus: null });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[0] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 2 },
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, className: 'field-option-lines large-vertical-spacing',
                                                    name: 'raceType', id: 'raceType', options: [{ key: 'all', value: 'Alle flyvninger', disabled: !raceTypeEnabled }, { key: 'nonCountry', value: 'Uden landsflyvninger', disabled: !raceTypeEnabled }, { key: 'country', value: 'Kun landsflyvninger', disabled: !raceTypeEnabled }], value: this.state.raceType,
                                                    autoCheckErrors: true, required: raceTypeEnabled, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: function onChange(e) {
                                                        _this2.onStandardFieldChange(e);
                                                        if (e.target.value === 'nonCountry') _this2.setState({ longRaceStatus: null });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 2 },
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, className: 'field-option-lines small-vertical-spacing',
                                                    name: 'longRaceStatus', id: 'longRaceStatus', options: [{ key: 'finished', value: 'Landsflyvninger færdigberegnede', disabled: !longRacesIncluded }, { key: 'not-finished', value: 'Landsflyvninger IKKE færdigberegnede', disabled: !longRacesIncluded }], value: this.state.longRaceStatus,
                                                    autoCheckErrors: true, required: longRacesIncluded, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                })
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', name: 'send', onClick: function onClick() {
                                        _this2.onSend();
                                    } },
                                'Send'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ExportSignupsAndResultsDialog;
}(_react2.default.Component);

ExportSignupsAndResultsDialog.propTypes = {
    exportType: _propTypes2.default.string.isRequired,
    onClose: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentEntity: state.auth.currentEntity
        },
        race: {
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportSignupsAndResultsDialog);

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _alertDialog = __webpack_require__(89);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportMemberProgramDialog = function (_React$Component) {
    _inherits(ImportMemberProgramDialog, _React$Component);

    function ImportMemberProgramDialog(props) {
        _classCallCheck(this, ImportMemberProgramDialog);

        var _this = _possibleConstructorReturn(this, (ImportMemberProgramDialog.__proto__ || Object.getPrototypeOf(ImportMemberProgramDialog)).call(this, props));

        _this.fields = [];

        _this.onSend = function () {
            if (_this.allInputValid()) {
                _this.props.dispatch(RaceActions.getFromMember(_this.props.auth.currentEntity, _this.state.week, _this.state.pigeonhole, _this.state.reset, _this.state.overwrite, function (response) {
                    var msg = response.map(function (line, ix) {
                        return [line, _react2.default.createElement('br', null)];
                    });
                    (0, _alertDialog.alert)("Info", msg, function () {}, { textAlign: "left" });
                    _this.props.onClose();
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            week: (0, _moment2.default)(new Date()).isoWeek().toString(),
            pigeonhole: 'all',
            reset: false,
            overwrite: false
        };
        return _this;
    }

    _createClass(ImportMemberProgramDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isRaces = this.props.race.races.filter(function (race) {
                return race.Uge === Number(_this2.state.week);
            }).size > 0;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '275px',
                                width: '450px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'L\xE6s anmeldelser fra medlemsprogram'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'week' },
                                                    'Uge'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'week', id: 'week', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.week,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[0] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'medium-vertical-spacing' },
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'pigeonhole' },
                                                    'Slag'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'medium-vertical-spacing' },
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: false, className: 'field100p', containerClassName: 'display-inline-block field100p',
                                                    name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: [{ key: 'all', value: 'Alle' }].concat(this.props.admin.pigeonHoles.filter(function (hole) {
                                                        return hole.Foreningsnr === _this2.props.auth.currentEntity;
                                                    }).sort(function (s1, s2) {
                                                        return s1.Slagnr < s2.Slagnr ? -1 : 1;
                                                    }).map(function (pigeonhole) {
                                                        return { key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn) };
                                                    }).toArray()),
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox', name: 'reset', id: 'reset', checked: this.state.reset, onChange: this.onCheckFieldChange })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'reset' },
                                                    'Nulstil alle anmeldelser'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox', name: 'overwrite', id: 'overwrite', disabled: this.state.reset, checked: this.state.overwrite, onChange: this.onCheckFieldChange })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'overwrite', className: this.state.reset ? 'disabled' : '' },
                                                    'Flyt duer hvis anmeldt p\xE5 andre flyvninger'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', name: 'send', disabled: !isRaces, onClick: function onClick() {
                                        _this2.onSend();
                                    } },
                                'Indl\xE6s'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ImportMemberProgramDialog;
}(_react2.default.Component);

ImportMemberProgramDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentEntity: state.auth.currentEntity
        },
        admin: {
            pigeonHoles: state.admin.pigeonHoles
        },
        race: {
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportMemberProgramDialog);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _alertDialog = __webpack_require__(89);

var _routeconstants = __webpack_require__(11);

var _reactRouter = __webpack_require__(19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportDevicesDialog = function (_React$Component) {
    _inherits(ExportDevicesDialog, _React$Component);

    function ExportDevicesDialog(props) {
        _classCallCheck(this, ExportDevicesDialog);

        var _this = _possibleConstructorReturn(this, (ExportDevicesDialog.__proto__ || Object.getPrototypeOf(ExportDevicesDialog)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = {
            pigeonhole: ''
        };
        return _this;
    }

    _createClass(ExportDevicesDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                height: '200px',
                                width: '450px',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Eksporter til elektroniske anl\xE6g'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields' },
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'medium-vertical-spacing' },
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'pigeonhole' },
                                                    'Slag'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'medium-vertical-spacing' },
                                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: this.state.pigeonhole === '' ? '-- Vælg --' : false, className: 'field100p', containerClassName: 'display-inline-block field100p',
                                                    name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: this.props.admin.pigeonHoles.filter(function (hole) {
                                                        return hole.Foreningsnr === _this2.props.auth.currentEntity;
                                                    }).sort(function (s1, s2) {
                                                        return s1.Slagnr < s2.Slagnr ? -1 : 1;
                                                    }).map(function (pigeonhole) {
                                                        return { key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn) };
                                                    }).toArray(),
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[0] = instance;
                                                    }
                                                })
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                _reactRouter.Link,
                                { className: "btn-primary" + (this.state.pigeonhole === '' ? ' disabled' : ''), to: this.state.pigeonhole === '' ? '' : _routeconstants.ROUTE_DEVICES_EXPORT.replace(':club', this.props.auth.currentEntity).replace(':pigeonhole', this.state.pigeonhole), target: '_blank', title: 'Hent duebestand' },
                                'Eksporter'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Luk'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ExportDevicesDialog;
}(_react2.default.Component);

ExportDevicesDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentEntity: state.auth.currentEntity
        },
        admin: {
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportDevicesDialog);

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _RaceParticipants = __webpack_require__(756);

var _RaceParticipants2 = _interopRequireDefault(_RaceParticipants);

var _RaceAccounting = __webpack_require__(757);

var _RaceAccounting2 = _interopRequireDefault(_RaceAccounting);

var _RaceResults = __webpack_require__(758);

var _RaceResults2 = _interopRequireDefault(_RaceResults);

var _RacePriceTransfers = __webpack_require__(759);

var _RacePriceTransfers2 = _interopRequireDefault(_RacePriceTransfers);

var _RaceUnawardedPrices = __webpack_require__(760);

var _RaceUnawardedPrices2 = _interopRequireDefault(_RaceUnawardedPrices);

var _RacePrices = __webpack_require__(761);

var _RacePrices2 = _interopRequireDefault(_RacePrices);

var _RaceControl = __webpack_require__(762);

var _RaceControl2 = _interopRequireDefault(_RaceControl);

var _GeneralMembers = __webpack_require__(763);

var _GeneralMembers2 = _interopRequireDefault(_GeneralMembers);

var _GeneralJuniors = __webpack_require__(764);

var _GeneralJuniors2 = _interopRequireDefault(_GeneralJuniors);

var _GeneralAddresses = __webpack_require__(765);

var _GeneralAddresses2 = _interopRequireDefault(_GeneralAddresses);

var _GeneralRings = __webpack_require__(766);

var _GeneralRings2 = _interopRequireDefault(_GeneralRings);

var _GeneralPigeons = __webpack_require__(767);

var _GeneralPigeons2 = _interopRequireDefault(_GeneralPigeons);

var _GeneralLabels = __webpack_require__(768);

var _GeneralLabels2 = _interopRequireDefault(_GeneralLabels);

var _GeneralLocations = __webpack_require__(769);

var _GeneralLocations2 = _interopRequireDefault(_GeneralLocations);

var _SeasonChampionships = __webpack_require__(770);

var _SeasonChampionships2 = _interopRequireDefault(_SeasonChampionships);

var _SeasonMemberStats = __webpack_require__(772);

var _SeasonMemberStats2 = _interopRequireDefault(_SeasonMemberStats);

var _SeasonRaceStats = __webpack_require__(773);

var _SeasonRaceStats2 = _interopRequireDefault(_SeasonRaceStats);

var _SeasonEquipStats = __webpack_require__(774);

var _SeasonEquipStats2 = _interopRequireDefault(_SeasonEquipStats);

var _SeasonSeats = __webpack_require__(775);

var _SeasonSeats2 = _interopRequireDefault(_SeasonSeats);

var _SeasonPrices = __webpack_require__(776);

var _SeasonPrices2 = _interopRequireDefault(_SeasonPrices);

var _SeasonDiplomas = __webpack_require__(777);

var _SeasonDiplomas2 = _interopRequireDefault(_SeasonDiplomas);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportingPage = function (_React$Component) {
    _inherits(ReportingPage, _React$Component);

    _createClass(ReportingPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_REPORTING;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function ReportingPage(props) {
        _classCallCheck(this, ReportingPage);

        var _this = _possibleConstructorReturn(this, (ReportingPage.__proto__ || Object.getPrototypeOf(ReportingPage)).call(this, props));

        _this.subForm = null;

        _this.state = {
            options: {}
        };
        return _this;
    }

    _createClass(ReportingPage, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var subPage = null;
            switch (this.props.params.category) {
                case 'general':
                    switch (this.props.params.report) {
                        case 'members':
                            subPage = _react2.default.createElement(_GeneralMembers2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'juniors':
                            subPage = _react2.default.createElement(_GeneralJuniors2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'addresses':
                            subPage = _react2.default.createElement(_GeneralAddresses2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'rings':
                            subPage = _react2.default.createElement(_GeneralRings2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'pigeons':
                            subPage = _react2.default.createElement(_GeneralPigeons2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'labels':
                            subPage = _react2.default.createElement(_GeneralLabels2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'locations':
                            subPage = _react2.default.createElement(_GeneralLocations2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                    }
                    break;
                case 'races':
                    switch (this.props.params.report) {
                        case 'participants':
                            subPage = _react2.default.createElement(_RaceParticipants2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'accounting':
                            subPage = _react2.default.createElement(_RaceAccounting2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'results':
                            subPage = _react2.default.createElement(_RaceResults2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'price-transfers':
                            subPage = _react2.default.createElement(_RacePriceTransfers2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'unawarded-prices':
                            subPage = _react2.default.createElement(_RaceUnawardedPrices2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'prices':
                            subPage = _react2.default.createElement(_RacePrices2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'control':
                            subPage = _react2.default.createElement(_RaceControl2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                    }
                    break;
                case 'season':
                    switch (this.props.params.report) {
                        case 'championships':
                            subPage = _react2.default.createElement(_SeasonChampionships2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'member-stats':
                            subPage = _react2.default.createElement(_SeasonMemberStats2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'race-stats':
                            subPage = _react2.default.createElement(_SeasonRaceStats2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'equip-stats':
                            subPage = _react2.default.createElement(_SeasonEquipStats2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'seats':
                            subPage = _react2.default.createElement(_SeasonSeats2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'prices':
                            subPage = _react2.default.createElement(_SeasonPrices2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'diplomas':
                            subPage = _react2.default.createElement(_SeasonDiplomas2.default, { ref: function ref(instance) {
                                    _this2.subForm = instance;
                                } });
                            break;
                        case 'performance-cards':
                            break;
                    }
                    break;
            }

            return _react2.default.createElement(
                'div',
                { className: 'reporting-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Rapportering'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.category === 'general' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", "general").replace(":report", "members") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.category === 'races' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", "races").replace(":report", this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? "participants" : "accounting") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Kapflyvninger'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.category === 'season' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", "season").replace(":report", "championships") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                '\xC5rsafslutning'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        _react2.default.createElement(
                            'div',
                            { className: 'report-left-tabs' },
                            this.props.params.category === 'general' ? _react2.default.createElement(
                                'div',
                                { className: 'vertical-tab-list' },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'members' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "members") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Medlemslister'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'juniors' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "juniors") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Juniorer'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'addresses' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "addresses") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Adresseliste'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? null : _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'rings' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "rings") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Fodringsserier'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? null : _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'pigeons' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "pigeons") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Duebestand'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'labels' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "labels") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Labels'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'locations' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "locations") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Afstande og placeringer'
                                    )
                                )
                            ) : this.props.params.category === 'races' ? _react2.default.createElement(
                                'div',
                                { className: 'vertical-tab-list' },
                                this.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'participants' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "participants") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Deltagerlister'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'accounting' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "accounting") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Regnskab'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'results' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "results") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Resultater'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'price-transfers' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "price-transfers") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Pr\xE6mieoverf\xF8rsler'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'unawarded-prices' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "unawarded-prices") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Ikke udbetalte pr\xE6mier'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'prices' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "prices") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Pr\xE6miekontoudtog'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'control' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "control") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Kontrollister'
                                    )
                                )
                            ) : this.props.params.category === 'season' ? _react2.default.createElement(
                                'div',
                                { className: 'vertical-tab-list' },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'championships' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "championships") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Mesterskaber'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'prices' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "prices") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        '\xC5rsregnskab'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'member-stats' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "member-stats") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Medlemsstatistik'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'race-stats' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "race-stats") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Kapflyvningsstatistik'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'equip-stats' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "equip-stats") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Anl\xE6gsstatistik'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'seats' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "seats") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Mandatfordeling'
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { className: this.props.params.report === 'diplomas' ? "tab-link active" : "tab-link", to: _routeconstants.ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "diplomas") },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'tab-text' },
                                        'Diplomer'
                                    )
                                )
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'report-page' },
                            _react2.default.createElement(
                                'div',
                                { className: 'page-content' },
                                subPage
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'span',
                        { className: 'left-buttons' },
                        _react2.default.createElement(
                            'form',
                            { id: 'html-report-form', action: "/api/report/" + this.props.params.category + '-' + this.props.params.report + "/html", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions();
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) _this2.setState({ options: reportOptions.options }, function () {
                                        document.getElementById('html-report-form').submit();
                                    });
                                }, value: 'HTML' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        ),
                        _react2.default.createElement(
                            'form',
                            { id: 'pdf-report-form', action: "/api/report/" + this.props.params.category + '-' + this.props.params.report + "/pdf", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions();
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) _this2.setState({ options: reportOptions.options }, function () {
                                        document.getElementById('pdf-report-form').submit();
                                    });
                                }, value: 'PDF' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        ),
                        _react2.default.createElement(
                            'form',
                            { id: 'csv-report-form', action: "/api/report/" + this.props.params.category + '-' + this.props.params.report + "/csv", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions();
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) _this2.setState({ options: reportOptions.options }, function () {
                                        document.getElementById('csv-report-form').submit();
                                    });
                                }, value: 'CSV' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        ),
                        _react2.default.createElement(
                            'form',
                            { id: 'excel-report-form', action: "/api/report/" + this.props.params.category + '-' + this.props.params.report + "/excel", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions();
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) _this2.setState({ options: reportOptions.options }, function () {
                                        document.getElementById('excel-report-form').submit();
                                    });
                                }, value: 'Excel' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'right-buttons' },
                        this.props.params.category === 'races' && this.props.params.report === 'results' ? [_react2.default.createElement(
                            'form',
                            { id: 'result-files-form', key: 0, action: "/api/report/race-result/files", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions({
                                        checkOnlyRaceSelection: true
                                    });
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) {
                                        reportOptions.options = Object.assign(reportOptions.options, {
                                            results: {
                                                country: false,
                                                region: false,
                                                group: false,
                                                section: false,
                                                range: true
                                            },
                                            allCalculated: true,
                                            resultSize: null,
                                            onlyJuniorsBeginners: false,
                                            onlySex: null,
                                            onlyYear: null,
                                            sectionsOrGroups: null,
                                            showPricesAndClasses: true,
                                            format: 'result-files'
                                        });
                                        _this2.setState({ options: reportOptions.options }, function () {
                                            document.getElementById('result-files-form').submit();
                                        });
                                    }
                                }, value: 'Resultatfiler' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        ), _react2.default.createElement(
                            'form',
                            { id: 'result-printing-form', key: 1, action: "/api/report/race-result/printing", target: '_blank', method: 'post' },
                            _react2.default.createElement('input', { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions({
                                        checkOnlyRaceSelection: true
                                    });
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) {
                                        reportOptions.options.format = 'printing';
                                        reportOptions.options = Object.assign(reportOptions.options, {
                                            results: {
                                                country: true,
                                                region: false,
                                                group: false,
                                                section: true,
                                                range: false
                                            },
                                            allCalculated: true,
                                            resultSize: null,
                                            onlyJuniorsBeginners: false,
                                            onlySex: null,
                                            onlyYear: null,
                                            sectionsOrGroups: null,
                                            showPricesAndClasses: true,
                                            format: 'printing'
                                        });
                                        _this2.setState({ options: reportOptions.options }, function () {
                                            document.getElementById('result-printing-form').submit();
                                        });
                                    }
                                }, value: 'Trykkeri' }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'options', value: JSON.stringify(this.state.options) })
                        ), _react2.default.createElement(
                            'button',
                            { key: 2, className: 'btn-primary', onClick: function onClick() {
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions({
                                        checkOnlyRaceSelection: true
                                    });
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) {
                                        _this2.props.dispatch(RaceActions.calcRaces(reportOptions.options.races, function () {
                                            _reactNotifications.NotificationManager.success("Kapflyvninger genberegnet", "Alle markerede kapflyvninger er genberegnet.", 4000);
                                        }));
                                    }
                                } },
                            'Beregn'
                        )] : null,
                        this.props.params.category === 'season' && this.props.params.report === 'championships' ? [_react2.default.createElement(
                            'button',
                            { key: 0, className: 'btn-primary', onClick: function onClick() {
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions({
                                        checkOnlyChampionshipSelection: true
                                    });
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) {
                                        _this2.props.dispatch(AdminActions.calcChampionships(reportOptions.options.championships, function () {
                                            _reactNotifications.NotificationManager.success("Mesterskaber genberegnet", "Alle markerede mesterskaber er genberegnet.", 4000);
                                        }));
                                    }
                                } },
                            'Beregn'
                        )] : null,
                        this.props.params.category === 'season' && this.props.params.report === 'seats' ? [_react2.default.createElement(
                            'button',
                            { key: 0, className: 'btn-primary', onClick: function onClick() {
                                    var reportOptions = _this2.subForm.getWrappedInstance().getReportOptions();
                                    if (typeof reportOptions.errors !== 'undefined' && reportOptions.errors.length > 0) {
                                        reportOptions.errors.forEach(function (error) {
                                            _reactNotifications.NotificationManager.error(error, 'Fejl', 10000);
                                        });
                                    } else if (typeof reportOptions.isErrors === 'undefined' || reportOptions.isErrors === false) {
                                        _this2.props.dispatch(AdminActions.calcSeats({
                                            seatsForSection: reportOptions.options.seatsForSection,
                                            seatsForMainBoard: reportOptions.options.seatsForMainBoard
                                        }, function () {
                                            _reactNotifications.NotificationManager.success("Mandatfordeling beregnet", "Antal aktive medlemmer og mandatfordeling er beregnet for hver forening/sektion.", 4000);
                                        }));
                                    }
                                } },
                            'Beregn'
                        )] : null
                    )
                )
            );
        }
    }]);

    return ReportingPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReportingPage);

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceParticipants = function (_React$Component) {
    _inherits(RaceParticipants, _React$Component);

    function RaceParticipants(props) {
        _classCallCheck(this, RaceParticipants);

        var _this = _possibleConstructorReturn(this, (RaceParticipants.__proto__ || Object.getPrototypeOf(RaceParticipants)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? true : false));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (races) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedRaces: add ? _this.state.selectedRaces.concat(races.filter(function (race) {
                    return _this.state.selectedRaces.indexOf(race) < 0;
                })) : _this.state.selectedRaces.filter(function (race) {
                    return races.indexOf(race) < 0;
                })
            });
        };

        _this.getReportOptions = function () {
            var errors = [];
            if (_this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
            return {
                errors: errors,
                options: {
                    races: _this.state.selectedRaces,
                    reportType: _this.state.reportType,
                    pigeonhole: _this.state.pigeonhole
                }
            };
        };

        _this.state = Object.assign({
            selectedRaces: [],
            reportType: 'participants',
            pigeonhole: 'all'
        });
        return _this;
    }

    _createClass(RaceParticipants, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "race-participants" },
                _react2.default.createElement(
                    'div',
                    { className: 'race-list' },
                    _react2.default.createElement(_RaceList2.default, { selectedRaces: this.state.selectedRaces, updateSelection: this.updateRaceSelection, filterRaces: function filterRaces(race) {
                            return _this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id || race.Sektion === _this2.props.auth.currentEntity;
                        } })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'report-options' },
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? [_react2.default.createElement(
                        'div',
                        { className: 'option-group', key: 'optionsLine1' },
                        _react2.default.createElement(
                            'span',
                            { className: 'option', style: { paddingRight: "25px" } },
                            _react2.default.createElement('input', { id: 'participants', name: 'participants', type: 'checkbox', checked: this.state.reportType === 'participants', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'participants' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'participants' },
                                ' Deltagerliste'
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'option' },
                            _react2.default.createElement('input', { id: 'corrections', name: 'corrections', type: 'checkbox', checked: this.state.reportType === 'corrections', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'corrections' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'corrections' },
                                ' Korrektionsskema'
                            )
                        )
                    ), _react2.default.createElement(
                        'div',
                        { className: 'option-group', key: 'optionsLine2' },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'pigeonhole' },
                                            'Slag'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.club === '',
                                            name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: [{ key: 'all', value: 'Alle' }].concat(this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(function (p) {
                                                return p.Foreningsnr === _this2.props.auth.currentEntity;
                                            }).sort(function (p1, p2) {
                                                return p1.Slagnr < p2.Slagnr ? -1 : p1.Slagnr > p2.Slagnr ? 1 : 0;
                                            }).map(function (pigeonHole) {
                                                return { key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn) };
                                            }).toArray() : []),
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    )
                                )
                            )
                        )
                    )] : null
                )
            );
        }
    }]);

    return RaceParticipants;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceParticipants);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceAccounting = function (_React$Component) {
    _inherits(RaceAccounting, _React$Component);

    function RaceAccounting(props) {
        _classCallCheck(this, RaceAccounting);

        var _this = _possibleConstructorReturn(this, (RaceAccounting.__proto__ || Object.getPrototypeOf(RaceAccounting)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? true : false));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (races) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedRaces: add ? _this.state.selectedRaces.concat(races.filter(function (race) {
                    return _this.state.selectedRaces.indexOf(race) < 0;
                })) : _this.state.selectedRaces.filter(function (race) {
                    return races.indexOf(race) < 0;
                })
            });
        };

        _this.getReportOptions = function () {
            var errors = [];
            if (_this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
            return {
                errors: errors,
                options: {
                    races: _this.state.selectedRaces,
                    showPigeons: _this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _this.state.showPigeons : false,
                    pigeonhole: _this.state.pigeonhole
                }
            };
        };

        _this.state = Object.assign({
            selectedRaces: [],
            showPigeons: true,
            pigeonhole: 'all'
        });
        return _this;
    }

    _createClass(RaceAccounting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? "race-accounting-club" : "race-accounting" },
                _react2.default.createElement(
                    'div',
                    { className: 'race-list' },
                    _react2.default.createElement(_RaceList2.default, { selectedRaces: this.state.selectedRaces, updateSelection: this.updateRaceSelection, filterRaces: function filterRaces(race) {
                            return _this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id || race.Sektion === _this2.props.auth.currentEntity;
                        } })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'report-options' },
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? [_react2.default.createElement(
                        'div',
                        { className: 'option-group', key: 'optionsLine1' },
                        _react2.default.createElement(
                            'span',
                            { className: 'option' },
                            _react2.default.createElement('input', { id: 'showPigeons', name: 'showPigeons', type: 'checkbox', checked: this.state.showPigeons, onChange: this.onCheckFieldChange }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'showPigeons' },
                                ' Vis duer'
                            )
                        )
                    ), _react2.default.createElement(
                        'div',
                        { className: 'option-group', key: 'optionsLine2' },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'pigeonhole' },
                                            'Slag'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.club === '',
                                            name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: [{ key: 'all', value: 'Alle' }].concat(this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(function (p) {
                                                return p.Foreningsnr === _this2.props.auth.currentEntity;
                                            }).sort(function (p1, p2) {
                                                return p1.Slagnr < p2.Slagnr ? -1 : p1.Slagnr > p2.Slagnr ? 1 : 0;
                                            }).map(function (pigeonHole) {
                                                return { key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn) };
                                            }).toArray() : []),
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    )
                                )
                            )
                        )
                    )] : null
                )
            );
        }
    }]);

    return RaceAccounting;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceAccounting);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceResults = function (_React$Component) {
    _inherits(RaceResults, _React$Component);

    function RaceResults(props) {
        _classCallCheck(this, RaceResults);

        var _this = _possibleConstructorReturn(this, (RaceResults.__proto__ || Object.getPrototypeOf(RaceResults)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? true : false));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (races) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedRaces: add ? _this.state.selectedRaces.concat(races.filter(function (race) {
                    return _this.state.selectedRaces.indexOf(race) < 0;
                })) : _this.state.selectedRaces.filter(function (race) {
                    return races.indexOf(race) < 0;
                })
            });
        };

        _this.getReportOptions = function (options) {
            var errors = [];
            var isValid = true;
            if (typeof options === 'undefined' || typeof options.checkOnlyRaceSelection === 'undefined' || options.checkOnlyRaceSelection !== true) {
                isValid = _this.allInputValid();
                if (!isValid) {
                    errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                    _this.fields.forEach(function (field) {
                        field.setState({ visited: true });
                    });
                }
            }
            if (_this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
            if ((typeof options === 'undefined' || typeof options.checkOnlyRaceSelection === 'undefined' || options.checkOnlyRaceSelection !== true) && (typeof options === 'undefined' || typeof options.checkResultsSelection === 'undefined' || options.checkResultsSelection !== false) && !_this.state.resultCountry && !_this.state.resultRegion && !_this.state.resultGroup && !_this.state.resultSection && !_this.state.resultRange) errors.push('Der er ikke valgt nogen opstilling(er).');
            return {
                errors: errors,
                isErrors: !isValid,
                options: {
                    races: _this.state.selectedRaces,
                    results: {
                        country: _this.state.resultCountry,
                        region: _this.state.resultRegion,
                        group: _this.state.resultGroup,
                        section: _this.state.resultSection,
                        range: _this.state.resultRange
                    },
                    allCalculated: _this.state.allCalculated,
                    resultSize: _this.state.resultSize === '' ? null : _this.state.resultSize,
                    onlyJuniorsBeginners: _this.state.onlyJuniorsBeginners,
                    onlySex: _this.state.onlySex === '' ? null : _this.state.onlySex,
                    onlyYear: _this.state.onlyYear === '' ? null : _this.state.onlyYear,
                    sectionsOrGroups: _this.state.sectionsOrGroups === '' ? null : _this.state.sectionsOrGroups,
                    showPricesAndClasses: _this.state.showPricesAndClasses,
                    format: 'default'
                }
            };
        };

        _this.state = Object.assign({
            selectedRaces: [],
            resultCountry: false,
            resultRegion: false,
            resultGroup: false,
            resultSection: props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id,
            resultRange: false,
            allCalculated: true,
            resultSize: '',
            onlyJuniorsBeginners: false,
            showPricesAndClasses: true,
            onlySex: '',
            onlyYear: '',
            sectionsOrGroups: ''
        });
        return _this;
    }

    _createClass(RaceResults, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'race-results' },
                _react2.default.createElement(
                    'div',
                    { className: 'race-list' },
                    _react2.default.createElement(_RaceList2.default, { selectedRaces: this.state.selectedRaces, updateSelection: this.updateRaceSelection })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'report-options' },
                    _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'result-size' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'allCalculated', name: 'allCalculated', type: 'checkbox', checked: this.state.allCalculated, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'allCalculated' },
                                    ' Alle beregnede'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultSize' },
                                    'Antal eller procent (afslut med %) duer '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                    name: 'resultSize', id: 'resultSize', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]+%?" }], value: this.state.resultSize,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'onlyJuniorsBeginners', name: 'onlyJuniorsBeginners', type: 'checkbox', checked: this.state.onlyJuniorsBeginners, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'onlyJuniorsBeginners' },
                                    ' Kun juniorer/begyndere'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'showPricesAndClasses', name: 'showPricesAndClasses', type: 'checkbox', checked: this.state.showPricesAndClasses, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'showPricesAndClasses' },
                                    ' Vis pr\xE6mier/klasser'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'result-criterias' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'onlySex' },
                                    'Kun k\xF8n '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                    name: 'onlySex', id: 'onlySex', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[AUX]" }], value: this.state.onlySex,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onUpperCaseFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'onlyYear' },
                                    'Kun \xE5rgang '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                    name: 'onlyYear', id: 'onlyYear', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.onlyYear,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'sectionsOrGroups' },
                                    'Sektion/Gruppe '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field150', containerClassName: 'display-inline-block',
                                    name: 'sectionsOrGroups', id: 'sectionsOrGroups', value: this.state.sectionsOrGroups,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            ) : null
                        )
                    ),
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Opstillinger'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'result-groupings' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'resultCountry', name: 'resultCountry', type: 'checkbox', checked: this.state.resultCountry, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultCountry' },
                                    ' Land'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'resultRegion', name: 'resultRegion', type: 'checkbox', checked: this.state.resultRegion, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultRegion' },
                                    ' Region'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'resultGroup', name: 'resultGroup', type: 'checkbox', checked: this.state.resultGroup, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultGroup' },
                                    ' Gruppe'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'resultSection', name: 'resultSection', type: 'checkbox', checked: this.state.resultSection, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultSection' },
                                    ' Sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'resultRange', name: 'resultRange', type: 'checkbox', checked: this.state.resultRange, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultRange' },
                                    ' Omr\xE5de'
                                )
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return RaceResults;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceResults);

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacePriceTransfers = function (_React$Component) {
    _inherits(RacePriceTransfers, _React$Component);

    function RacePriceTransfers(props) {
        _classCallCheck(this, RacePriceTransfers);

        var _this = _possibleConstructorReturn(this, (RacePriceTransfers.__proto__ || Object.getPrototypeOf(RacePriceTransfers)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (races) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedRaces: add ? _this.state.selectedRaces.concat(races.filter(function (race) {
                    return _this.state.selectedRaces.indexOf(race) < 0;
                })) : _this.state.selectedRaces.filter(function (race) {
                    return races.indexOf(race) < 0;
                })
            });
        };

        _this.getReportOptions = function () {
            var errors = [];
            if (_this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
            return {
                errors: errors,
                options: {
                    races: _this.state.selectedRaces
                }
            };
        };

        _this.state = Object.assign({
            selectedRaces: []
        });
        return _this;
    }

    _createClass(RacePriceTransfers, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'race-price-transfers' },
                _react2.default.createElement(
                    'div',
                    { className: 'race-list' },
                    _react2.default.createElement(_RaceList2.default, { selectedRaces: this.state.selectedRaces, updateSelection: this.updateRaceSelection, filterRaces: function filterRaces(race) {
                            return _this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id || race.Sektion === _this2.props.auth.currentEntity;
                        } })
                ),
                _react2.default.createElement('div', { className: 'report-options' })
            );
        }
    }]);

    return RacePriceTransfers;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RacePriceTransfers);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceUnawardedPrices = function (_React$Component) {
    _inherits(RaceUnawardedPrices, _React$Component);

    function RaceUnawardedPrices(props) {
        _classCallCheck(this, RaceUnawardedPrices);

        var _this = _possibleConstructorReturn(this, (RaceUnawardedPrices.__proto__ || Object.getPrototypeOf(RaceUnawardedPrices)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (races) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedRaces: add ? _this.state.selectedRaces.concat(races.filter(function (race) {
                    return _this.state.selectedRaces.indexOf(race) < 0;
                })) : _this.state.selectedRaces.filter(function (race) {
                    return races.indexOf(race) < 0;
                })
            });
        };

        _this.getReportOptions = function () {
            var errors = [];
            if (_this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
            return {
                errors: errors,
                options: {
                    races: _this.state.selectedRaces
                }
            };
        };

        _this.state = Object.assign({
            selectedRaces: []
        });
        return _this;
    }

    _createClass(RaceUnawardedPrices, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'race-unawarded-prices' },
                _react2.default.createElement(
                    'div',
                    { className: 'race-list' },
                    _react2.default.createElement(_RaceList2.default, { selectedRaces: this.state.selectedRaces, updateSelection: this.updateRaceSelection, filterRaces: function filterRaces(race) {
                            return _this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id || race.Sektion === _this2.props.auth.currentEntity;
                        } })
                ),
                _react2.default.createElement('div', { className: 'report-options' })
            );
        }
    }]);

    return RaceUnawardedPrices;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceUnawardedPrices);

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacePrices = function (_React$Component) {
    _inherits(RacePrices, _React$Component);

    function RacePrices(props) {
        _classCallCheck(this, RacePrices);

        var _this = _possibleConstructorReturn(this, (RacePrices.__proto__ || Object.getPrototypeOf(RacePrices)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
            return {
                errors: errors,
                options: {
                    raceType: _this.state.raceType,
                    reportType: _this.state.reportType,
                    sectionFrom: _this.state.sectionFrom === '' ? null : _this.state.sectionFrom,
                    sectionTo: _this.state.sectionTo === '' ? null : _this.state.sectionTo,
                    clubFrom: _this.state.clubFrom === '' ? null : _this.state.clubFrom,
                    clubTo: _this.state.clubTo === '' ? null : _this.state.clubTo,
                    weekFrom: _this.state.weekFrom === '' ? null : Number(_this.state.weekFrom),
                    weekTo: _this.state.weekTo === '' ? null : Number(_this.state.weekTo)
                }
            };
        };

        _this.state = Object.assign({
            raceType: 'ddb',
            reportType: 'club',
            sectionFrom: '',
            sectionTo: '69',
            clubFrom: '',
            clubTo: '299',
            weekFrom: '',
            weekTo: ''
        });
        return _this;
    }

    _createClass(RacePrices, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'race-prices report-options' },
                _react2.default.createElement(
                    'div',
                    { className: 'left-pane' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons-title' },
                            'Kapflyvningstype'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-type-ddb', type: 'radio', checked: this.state.raceType === 'ddb', onClick: function onClick() {
                                    return _this2.setState({ raceType: 'ddb', sectionFrom: /^[0-9]{2}$/.test(_this2.state.sectionFrom) ? _this2.state.sectionFrom : '', sectionTo: /^[0-9]{2}$/.test(_this2.state.sectionTo) ? _this2.state.sectionTo : '' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-type-ddb' },
                                'DDB-flyvninger'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-type-section', type: 'radio', checked: this.state.raceType === 'section', onClick: function onClick() {
                                    return _this2.setState({ raceType: 'section' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-type-section' },
                                'Sektionsflyvninger'
                            )
                        )
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons-title' },
                            'Layout'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-club', type: 'radio', checked: this.state.reportType === 'club', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'club' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-club' },
                                'Foreningstotaler'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-week', type: 'radio', checked: this.state.reportType === 'week', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'week' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-week' },
                                'Ugetotaler'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-member', type: 'radio', checked: this.state.reportType === 'member', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'member' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-member' },
                                'Medlemstotaler'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-member-page', type: 'radio', checked: this.state.reportType === 'member-page', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'member-page' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-member-page' },
                                'En side pr. medlem'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-club-summary', type: 'radio', checked: this.state.reportType === 'club-summary', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'club-summary' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-club-summary' },
                                'Foreningsoversigt'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'right-pane' },
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: this.state.raceType === 'section' ? '' : 'disabled' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'sectionFrom' },
                                        'Fra sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block', enabled: this.state.raceType === 'section',
                                        name: 'sectionFrom', id: 'sectionFrom', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionFrom,
                                        disabled: this.state.raceType !== 'section', autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[0].setState({ focused: false, visited: true });
                                            if (/^[0-9]{2}$/.test(_this2.state.sectionFrom) && _this2.state.sectionTo === '') _this2.setState({ sectionTo: _this2.state.sectionFrom });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: this.state.raceType === 'section' ? '' : 'disabled' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'sectionTo' },
                                        'Til sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block', enabled: this.state.raceType === 'section',
                                        name: 'sectionTo', id: 'sectionTo', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionTo,
                                        disabled: this.state.raceType !== 'section', autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            _react2.default.createElement(
                                'tr',
                                { className: 'separator' },
                                _react2.default.createElement('td', { colSpan: 2 })
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'clubFrom' },
                                        'Fra forening'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'clubFrom', id: 'clubFrom', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubFrom,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[2].setState({ focused: false, visited: true });
                                            if (/^[0-9]{1,2}$/.test(_this2.state.clubFrom)) _this2.setState({ clubFrom: _this2.state.clubFrom.padStart(3, '0'), clubTo: _this2.state.clubTo === '' ? _this2.state.clubFrom.padStart(3, '0') : _this2.state.clubTo });else if (/^[0-9]{3}$/.test(_this2.state.clubFrom) && _this2.state.clubTo === '') _this2.setState({ clubTo: _this2.state.clubFrom });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                )
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'clubTo' },
                                        'Til forening'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'clubTo', id: 'clubTo', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubTo,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[3].setState({ focused: false, visited: true });
                                            if (/^[0-9]{1,2}$/.test(_this2.state.clubTo)) _this2.setState({ clubTo: _this2.state.clubTo.padStart(3, '0') });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'separator' },
                                _react2.default.createElement('td', { colSpan: 2 })
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'weekFrom' },
                                        'Fra uge'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'weekFrom', id: 'weekFrom', value: this.state.weekFrom,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'weekTo' },
                                        'Til uge'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'weekTo', id: 'weekTo', value: this.state.weekTo,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RacePrices;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RacePrices);

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceControl = function (_React$Component) {
    _inherits(RaceControl, _React$Component);

    function RaceControl(props) {
        _classCallCheck(this, RaceControl);

        var _this = _possibleConstructorReturn(this, (RaceControl.__proto__ || Object.getPrototypeOf(RaceControl)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            var options = {
                report: _this.state.report,
                week: _this.state.week === '' ? null : Number(_this.state.week),
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                showClubs: _this.state.showClubs
            };
            if (_this.state.report === 'manReg') {
                options.manRegKfk = _this.state.manRegKfk === '' ? null : _this.state.manRegKfk;
                options.manRegType = _this.state.manRegType;
            }

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            week: ((0, _moment2.default)(new Date()).isoWeekday() > 3 ? (0, _moment2.default)(new Date()).isoWeek() : (0, _moment2.default)(new Date()).isoWeek() - 1).toString(),
            fromSection: '',
            toSection: '',
            fromClub: '',
            toClub: '',
            report: _this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'equipControl' : 'manReg',
            manRegKfk: '',
            manRegType: 'result'
        });
        return _this;
    }

    _createClass(RaceControl, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-equip-stats reports-inner-box report-options' },
                _react2.default.createElement(
                    'table',
                    { style: { maxWidth: '500px' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromWeek' },
                                    'Uge'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'week', id: 'week', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.week,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromSection' },
                                    'Fra sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromSection', id: 'fromSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.fromSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toSection' },
                                    'Til sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toSection', id: 'toSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.toSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            )
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromClub' },
                                    'Fra forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromClub', id: 'fromClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.fromClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[3].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toClub' },
                                    'Til forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toClub', id: 'toClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.toClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[4].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'reportEquipControl', name: 'report', type: 'radio', checked: this.state.report === 'equipControl', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'equipControl' });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportEquipControl' },
                                    'Kontrolliste for anl\xE6g'
                                )
                            )
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'reportForfald', name: 'report', type: 'radio', checked: this.state.report === 'forfald', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'forfald' });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportForfald' },
                                    'Forfaldsliste'
                                )
                            )
                        ) : null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'reportManReg', name: 'report', type: 'radio', checked: this.state.report === 'manReg', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'manReg' });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportManReg' },
                                    'Manuel registrering'
                                )
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        this.state.report === 'manReg' ? [_react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'kfk' },
                                    'KFK'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'manRegKfk', id: 'manRegKfk', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.manRegKfk,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[5].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1}$/.test(_this2.state.manRegKfk)) _this2.setState({ manRegKfk: _this2.state.manRegKfk.padStart(2, '9') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                })
                            )
                        ), _react2.default.createElement('tr', { className: 'options-separator' }), _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'manRegTypeSignup', name: 'manRegType', type: 'radio', checked: this.state.manRegType === 'signup', onClick: function onClick(e) {
                                        return _this2.setState({ manRegType: 'signup' });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'manRegTypeSignup' },
                                    'Regnskab'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'manRegTypeResult', name: 'manRegType', type: 'radio', checked: this.state.manRegType === 'result', onClick: function onClick(e) {
                                        return _this2.setState({ manRegType: 'result' });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'manRegTypeResult' },
                                    'Resultat'
                                )
                            )
                        )] : null
                    )
                )
            );
        }
    }]);

    return RaceControl;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceControl);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralMembers = function (_React$Component) {
    _inherits(GeneralMembers, _React$Component);

    function GeneralMembers(props) {
        _classCallCheck(this, GeneralMembers);

        var _this = _possibleConstructorReturn(this, (GeneralMembers.__proto__ || Object.getPrototypeOf(GeneralMembers)).call(this, props));

        _this.fields = [];

        _this.onSelectListType = function (e) {
            var listId = Number(e.target.id.substr(8));
            var ix = _this.state.selectedListTypes.indexOf(listId);
            if (ix < 0) _this.state.selectedListTypes.push(listId);else _this.state.selectedListTypes.splice(ix, 1);
            _this.forceUpdate();
        };

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromSection !== '' && _this.state.toSection !== '' && _this.state.fromSection > _this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
            if (_this.state.fromClub !== '' && _this.state.toClub !== '' && _this.state.fromClub > _this.state.toClub) errors.push('Fra forening kan ikke være større end Til forening.');
            if (_this.state.fromMember !== '' && _this.state.toMember !== '' && _this.state.fromMember > _this.state.toMember) errors.push('Fra medlem kan ikke være større end Til medlem.');

            if (_this.state.selectedListTypes.length === 0) errors.push('Vælg mindst én listetype.');

            var options = {
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                listTypes: _this.state.selectedListTypes
                //listType:   Number(this.state.listType),
            };

            if (_this.state.selectedListTypes.indexOf(1) >= 0 || _this.state.selectedListTypes.indexOf(9) >= 0 || _this.state.selectedListTypes.indexOf(10) >= 0) {
                //if (this.state.listType === '1' || this.state.listType === '9' || this.state.listType === '10') {
                options.fromMember = _this.state.fromMember === '' ? null : _this.state.fromMember;
                options.toMember = _this.state.toMember === '' ? null : _this.state.toMember;
            }

            if (_this.state.selectedListTypes.indexOf(13) >= 0) {
                options.includeMemberProgramUsers = _this.state.includeMemberProgramUsers;
                options.includeMemberProgramNonUsers = _this.state.includeMemberProgramNonUsers;
            }

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            fromMember: '',
            toMember: '',
            includeMemberProgramUsers: true,
            includeMemberProgramNonUsers: false,
            //listType: '',
            selectedListTypes: []
        });
        return _this;
    }

    _createClass(GeneralMembers, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-members' },
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Filtr\xE9ring (valgfrit)'
                ),
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromSection',
                                id: 'fromSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.fromSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toSection',
                                id: 'toSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.toSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            })
                        )
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromClub',
                                id: 'fromClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.fromClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[2].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[2] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toClub',
                                id: 'toClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.toClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[3].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[3] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Listetype'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'lower-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'list-type-container' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'table',
                                { style: { maxWidth: '600px' } },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype0', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(0) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype0' },
                                                'Foreningsvist efter nummer'
                                            )
                                        ),
                                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype1', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(1) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype1' },
                                                'Foreningsvist efter navn'
                                            )
                                        ) : null
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype2', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(2) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype2' },
                                                'Postnummer'
                                            )
                                        ),
                                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype3', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(3) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype3' },
                                                'Familiemedlemmer'
                                            )
                                        ) : null
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype4', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(4) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype4' },
                                                'Modtagere af Brevduen'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype11', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(11) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype11' },
                                                'Passive medlemmer'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype5', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(5) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype5' },
                                                'SMS-abonnementer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype6', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(6) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype6' },
                                                'SIM-kort-abonnementer'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype7', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(7) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype7' },
                                                'TAURIS-abonnementer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype8', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(8) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype8' },
                                                'UNIKON-abonnemente'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype9', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(9) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype9' },
                                                'Kontingent pr. sektion'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype10', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(10) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype10' },
                                                'Kontingent pr. forening'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype12', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(12) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype12' },
                                                'Dispensationer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype13', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(13) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype13' },
                                                'Brugere af medlemsprogrammet'
                                            )
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'listtype14', type: 'checkbox', checked: this.state.selectedListTypes.indexOf(14) >= 0, onClick: this.onSelectListType }),
                                            ' ',
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'listtype14' },
                                                'CHR'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            '\xA0'
                                        )
                                    ) : null
                                )
                            )
                        )
                    ),
                    //this.state.listType === '1' ||
                    //this.state.listType === '9' ||
                    //this.state.listType === '10' ?
                    this.state.selectedListTypes.indexOf(1) >= 0 || this.state.selectedListTypes.indexOf(9) >= 0 || this.state.selectedListTypes.indexOf(10) >= 0 ? _react2.default.createElement(
                        'div',
                        { className: 'subscription-container' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Filtr\xE9r beregning af kontingent (valgfrit)'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Fra medlemsnummer'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'fromMember',
                                    id: 'fromMember',
                                    maxLength: '6',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }],
                                    value: this.state.fromMember,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[4].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,5}$/.test(_this2.state.fromMember)) _this2.setState({ fromMember: _this2.state.fromMember.padStart(6, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Til medlemsnummer'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'toMember',
                                    id: 'toMember',
                                    maxLength: '6',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }],
                                    value: this.state.toMember,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[5].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,5}$/.test(_this2.state.toMember)) _this2.setState({ toMember: _this2.state.toMember.padStart(6, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                })
                            )
                        )
                    ) : null,
                    this.state.selectedListTypes.indexOf(13) >= 0 ? _react2.default.createElement(
                        'div',
                        { className: 'subscription-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('input', { id: 'memberProgramUsers', type: 'checkbox', checked: this.state.includeMemberProgramUsers, onClick: function onClick() {
                                            _this2.setState({ includeMemberProgramUsers: !_this2.state.includeMemberProgramUsers });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'memberProgramUsers' },
                                        'Inkluder brugere'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('input', { id: 'memberProgramNonUsers', type: 'checkbox', checked: this.state.includeMemberProgramNonUsers, onClick: function onClick() {
                                            _this2.setState({ includeMemberProgramNonUsers: !_this2.state.includeMemberProgramNonUsers });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'memberProgramNonUsers' },
                                        'Inkluder ikke-brugere'
                                    )
                                )
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return GeneralMembers;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralMembers);

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralJuniors = function (_React$Component) {
    _inherits(GeneralJuniors, _React$Component);

    function GeneralJuniors(props) {
        _classCallCheck(this, GeneralJuniors);

        var _this = _possibleConstructorReturn(this, (GeneralJuniors.__proto__ || Object.getPrototypeOf(GeneralJuniors)).call(this, props));

        _this.fields = [];

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromSection !== '' && _this.state.toSection !== '' && _this.state.fromSection > _this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
            if (_this.state.fromClub !== '' && _this.state.toClub !== '' && _this.state.fromClub > _this.state.toClub) errors.push('Fra forening kan ikke være større end Til forening.');

            var options = {
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub
            };
            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            fromSection: '',
            toSection: '',
            fromClub: '',
            toClub: ''
        });
        return _this;
    }

    _createClass(GeneralJuniors, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-juniors' },
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Filtr\xE9ring (valgfrit)'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromSection',
                                id: 'fromSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.fromSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toSection',
                                id: 'toSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.toSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            })
                        )
                    ) : null,
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromClub',
                                id: 'fromClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.fromClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[2].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[2] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toClub',
                                id: 'toClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.toClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[3].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[3] = instance;
                                }
                            })
                        )
                    )
                )
            );
        }
    }]);

    return GeneralJuniors;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralJuniors);

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultFilter = {
    fromFilter: '',
    toFilter: '299'
};

var GeneralAddresses = function (_React$Component) {
    _inherits(GeneralAddresses, _React$Component);

    function GeneralAddresses(props) {
        _classCallCheck(this, GeneralAddresses);

        var _this = _possibleConstructorReturn(this, (GeneralAddresses.__proto__ || Object.getPrototypeOf(GeneralAddresses)).call(this, props));

        _this.fields = [];

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromFilter !== '' && _this.state.toFilter !== '' && _this.state.fromFilter > _this.state.toFilter) errors.push('Fra ' + _this.getInputName() + ' kan ikke v\xE6re st\xF8rre end Til ' + _this.getInputName() + '.');

            var options = {
                isClub: _this.state.isClub ? 1 : 0,
                fromFilter: _this.state.fromFilter === '' ? null : _this.state.fromFilter,
                toFilter: _this.state.toFilter === '' ? null : _this.state.toFilter
            };
            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            isClub: true
        }, defaultFilter);
        return _this;
    }

    _createClass(GeneralAddresses, [{
        key: 'getInputName',
        value: function getInputName() {
            return this.state.isClub ? 'forening' : 'sektion';
        }
    }, {
        key: 'getInputLength',
        value: function getInputLength() {
            return this.state.isClub ? '3' : '2';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-addresses' },
                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                    'div',
                    { className: 'radio-buttons-container column-gap' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-button-container' },
                        _react2.default.createElement('input', { id: 'race-type-ddb', type: 'radio', checked: this.state.isClub, onChange: function onChange() {
                                return _this2.setState(Object.assign({ isClub: true }, { fromFilter: '', toFilter: '299' }));
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'race-type-ddb' },
                            'Foreninger'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-button-container' },
                        _react2.default.createElement('input', { id: 'race-type-section', type: 'radio', checked: !this.state.isClub, onChange: function onChange() {
                                return _this2.setState(Object.assign({ isClub: false }, { fromFilter: '', toFilter: '69' }));
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'race-type-section' },
                            'Sektioner'
                        )
                    )
                ) : null,
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'div',
                    { className: 'column-gap' },
                    _react2.default.createElement(
                        'div',
                        { className: 'attribute-pair' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Fra ',
                            this.getInputName()
                        ),
                        _react2.default.createElement(_UserFieldElement2.default, {
                            dataType: _UserFieldDataTypeEnum2.default.regex,
                            placeholder: '',
                            className: 'field-1 very-small-field',
                            containerClassName: 'display-inline-block',
                            name: 'fromFilter',
                            id: 'fromFilter',
                            maxLength: this.getInputLength(),
                            options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{' + this.getInputLength() + '}' }],
                            value: this.state.fromFilter,
                            autoCheckErrors: true,
                            hideErrWhenFocused: true,
                            hideErrUntilFocused: true,
                            onChange: this.onDigitInputFieldChange,
                            onBlur: function onBlur() {
                                if (_this2.state.isClub) {
                                    _this2.fields[0].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromFilter)) _this2.setState({ fromFilter: _this2.state.fromFilter.padStart(3, '0') });
                                }
                            },
                            ref: function ref(instance) {
                                _this2.fields[0] = instance;
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'attribute-pair' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Til ',
                            this.getInputName()
                        ),
                        _react2.default.createElement(_UserFieldElement2.default, {
                            dataType: _UserFieldDataTypeEnum2.default.regex,
                            placeholder: '',
                            className: 'field-1 very-small-field',
                            containerClassName: 'display-inline-block',
                            name: 'toFilter',
                            id: 'toFilter',
                            maxLength: this.getInputLength(),
                            options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{' + this.getInputLength() + '}' }],
                            value: this.state.toFilter,
                            autoCheckErrors: true,
                            hideErrWhenFocused: true,
                            hideErrUntilFocused: true,
                            onChange: this.onDigitInputFieldChange,
                            onBlur: function onBlur() {
                                if (_this2.state.isClub) {
                                    _this2.fields[1].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toFilter)) _this2.setState({ toFilter: _this2.state.toFilter.padStart(3, '0') });
                                }
                            },
                            ref: function ref(instance) {
                                _this2.fields[1] = instance;
                            }
                        })
                    )
                )
            );
        }
    }]);

    return GeneralAddresses;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralAddresses);

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralRings = function (_React$Component) {
    _inherits(GeneralRings, _React$Component);

    function GeneralRings(props) {
        _classCallCheck(this, GeneralRings);

        var _this = _possibleConstructorReturn(this, (GeneralRings.__proto__ || Object.getPrototypeOf(GeneralRings)).call(this, props));

        _this.fields = [];

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromClub !== '' && _this.state.toClub !== '' && _this.state.fromClub > _this.state.toClub) errors.push('Fra forening kan ikke v\xE6re st\xF8rre end Til forening.');

            var options = {
                listType: _this.state.listType,
                supplement: _this.state.supplement,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                year: _this.state.year === '' ? null : _this.state.year
            };
            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            listType: 0,
            supplement: 0,
            fromClub: '',
            toClub: '998',
            year: String(new Date().getFullYear())
        });
        return _this;
    }

    _createClass(GeneralRings, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-rings' },
                _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'column-gap left' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                '\xC5r'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 field60',
                                containerClassName: 'display-inline-block',
                                name: 'year',
                                id: 'year',
                                maxLength: 4,
                                required: true,
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{4}' }],
                                value: this.state.year,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[0].setState({ focused: false, visited: true });
                                    if (/^[0-9]{2}$/.test(_this2.state.year)) _this2.setState({ year: '20' + _this2.state.year });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'checkbox-span' },
                            _react2.default.createElement('input', {
                                id: 'only-supplement',
                                name: 'supplement',
                                type: 'checkbox',
                                checked: this.state.supplement,
                                onChange: function onChange() {
                                    _this2.setState({ supplement: _this2.state.supplement ? 0 : 1 });
                                }
                            }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'only-supplement' },
                                'Kun supplerende'
                            )
                        )
                    ),
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                        'div',
                        { className: 'column-gap right' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromClub',
                                id: 'fromClub',
                                maxLength: 3,
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{3}' }],
                                value: this.state.fromClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[1].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toClub',
                                id: 'toClub',
                                maxLength: 3,
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{3}' }],
                                value: this.state.toClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[2].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[2] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'lower-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container column-gap' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'reporting-list', type: 'radio', checked: this.state.listType === 0, onChange: function onChange() {
                                    return _this2.setState({ listType: 0 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'reporting-list' },
                                'Liste til indberetning af ringnummertildeling'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'control-list', type: 'radio', checked: this.state.listType === 1, onChange: function onChange() {
                                    return _this2.setState({ listType: 1 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'control-list' },
                                'Kontrolliste til fordeling af ringnumre'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'ring-list', type: 'radio', checked: this.state.listType === 2, onChange: function onChange() {
                                    return _this2.setState({ listType: 2 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'ring-list' },
                                'Ringliste til Brevduen'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GeneralRings;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralRings);

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralPigeons = function (_React$Component) {
    _inherits(GeneralPigeons, _React$Component);

    function GeneralPigeons(props) {
        _classCallCheck(this, GeneralPigeons);

        var _this = _possibleConstructorReturn(this, (GeneralPigeons.__proto__ || Object.getPrototypeOf(GeneralPigeons)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromSection !== '' && _this.state.toSection !== '' && _this.state.fromSection > _this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
            if (_this.state.fromClub !== '' && _this.state.toClub !== '' && _this.state.fromClub > _this.state.toClub) errors.push('Fra forening kan ikke være større end Til forening.');

            var options = {
                listType: _this.state.listType,
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                pigeonhole: _this.state.pigeonhole === '' ? null : _this.state.pigeonhole,
                onlyActive: _this.state.onlyActive,
                hideUnsigned: _this.state.hideUnsigned
            };

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            listType: 0,
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            pigeonhole: '',
            onlyActive: false,
            hideUnsigned: false
        });
        return _this;
    }

    _createClass(GeneralPigeons, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-members' },
                _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Filtr\xE9ring (valgfrit)'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromSection',
                                id: 'fromSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.fromSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toSection',
                                id: 'toSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.toSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            })
                        )
                    ) : null,
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromClub',
                                id: 'fromClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.fromClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[2].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[2] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toClub',
                                id: 'toClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.toClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[3].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[3] = instance;
                                }
                            })
                        )
                    ),
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Slag'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p',
                                name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(function (p) {
                                    return p.Foreningsnr === _this2.props.auth.currentEntity;
                                }).sort(function (p1, p2) {
                                    return p1.Slagnr < p2.Slagnr ? -1 : p1.Slagnr > p2.Slagnr ? 1 : 0;
                                }).map(function (pigeonHole) {
                                    return { key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn) };
                                }).toArray() : [],
                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                onChange: this.onStandardFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[4] = instance;
                                }
                            })
                        )
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'attribute-pair no-justify' },
                            _react2.default.createElement('input', { type: 'checkbox', id: 'onlyActive', name: 'onlyActive', checked: this.state.onlyActive, onClick: function onClick() {
                                    return _this2.setState({ onlyActive: !_this2.state.onlyActive });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'onlyActive' },
                                'Vis kun aktive'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'report-types' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons-container column-gap' },
                            _react2.default.createElement(
                                'div',
                                { className: 'radio-button-container' },
                                _react2.default.createElement('input', { id: 'reporting-list', type: 'radio', checked: this.state.listType === 0, onChange: function onChange() {
                                        return _this2.setState({ listType: 0 });
                                    } }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reporting-list' },
                                    'Bestandliste'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'radio-button-container' },
                                _react2.default.createElement('input', { id: 'vaccination', type: 'radio', checked: this.state.listType === 1, onChange: function onChange() {
                                        return _this2.setState({ listType: 1 });
                                    } }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'vaccination' },
                                    'Vaccination'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GeneralPigeons;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralPigeons);

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralLabels = function (_React$Component) {
    _inherits(GeneralLabels, _React$Component);

    function GeneralLabels(props) {
        _classCallCheck(this, GeneralLabels);

        var _this = _possibleConstructorReturn(this, (GeneralLabels.__proto__ || Object.getPrototypeOf(GeneralLabels)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            fromMember: '',
            toMember: '',
            showMemberNo: false,
            showLogo: false,
            clubChairman: false,
            clubCashier: false,
            clubItContact: false,
            clubReleas: false,
            sectionChairman: false,
            sectionCashier: false,
            members: false,
            magazineByPost: false,
            format: 'labels',
            leftMargin: _this.getLabelConfig(props, 'leftMargin'),
            topMargin: _this.getLabelConfig(props, 'topMargin'),
            labelLeftMargin: _this.getLabelConfig(props, 'labelLeftMargin'),
            labelTopMargin: _this.getLabelConfig(props, 'labelTopMargin'),
            labelHeight: _this.getLabelConfig(props, 'labelHeight'),
            labelWidth: _this.getLabelConfig(props, 'labelWidth'),
            rowCount: _this.getLabelConfig(props, 'rowCount'),
            columnCount: _this.getLabelConfig(props, 'columnCount'),
            lineHeight: _this.getLabelConfig(props, 'lineHeight'),
            fontSize: _this.getLabelConfig(props, 'fontSize')
        });
        return _this;
    }

    _createClass(GeneralLabels, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getGeneral());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                leftMargin: this.getLabelConfig(nextProps, 'leftMargin'),
                topMargin: this.getLabelConfig(nextProps, 'topMargin'),
                labelLeftMargin: this.getLabelConfig(nextProps, 'labelLeftMargin'),
                labelTopMargin: this.getLabelConfig(nextProps, 'labelTopMargin'),
                labelHeight: this.getLabelConfig(nextProps, 'labelHeight'),
                labelWidth: this.getLabelConfig(nextProps, 'labelWidth'),
                rowCount: this.getLabelConfig(nextProps, 'rowCount'),
                columnCount: this.getLabelConfig(nextProps, 'columnCount'),
                lineHeight: this.getLabelConfig(nextProps, 'lineHeight'),
                fontSize: this.getLabelConfig(nextProps, 'fontSize')
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-labels reports-inner-box report-options' },
                _react2.default.createElement(
                    'table',
                    { className: 'options-table', style: { maxWidth: '800px' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromSection' },
                                    'Fra sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromSection', id: 'fromSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.fromSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toSection' },
                                    'Til sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toSection', id: 'toSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.toSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            )
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromClub' },
                                    'Fra forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromClub', id: 'fromClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.fromClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[2].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0'), toClub: _this2.state.toClub === '' ? _this2.state.fromClub.padStart(3, '0') : _this2.state.toClub });else if (/^[0-9]{3}$/.test(_this2.state.fromClub) && _this2.state.toClub === '') _this2.setState({ toClub: _this2.state.fromClub });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toClub' },
                                    'Til forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toClub', id: 'toClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.toClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[3].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromMember' },
                                    'Fra medlem'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromMember', id: 'fromMember', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.fromMember,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[4].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,5}$/.test(_this2.state.fromMember)) _this2.setState({ fromMember: _this2.state.fromMember.padStart(6, '0'), toMember: _this2.state.toMember === '' ? _this2.state.fromMember.padStart(6, '0') : _this2.state.toMember });else if (/^[0-9]{6}$/.test(_this2.state.fromMember) && _this2.state.toMember === '') _this2.setState({ toMember: _this2.state.fromMember });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toMember' },
                                    'Til medlem'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toMember', id: 'toMember', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.toMember,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[5].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,5}$/.test(_this2.state.toMember)) _this2.setState({ toMember: _this2.state.toMember.padStart(6, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'showMemberNo', name: 'showMemberNo', type: 'checkbox', checked: this.state.showMemberNo, onClick: function onClick(e) {
                                        return _this2.setState({ showMemberNo: !_this2.state.showMemberNo });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'showMemberNo' },
                                    'Vis medlemsnumre'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'showLogo', name: 'showLogo', type: 'checkbox', checked: this.state.showLogo, disabled: this.state.format === 'labels', onClick: function onClick(e) {
                                        return _this2.setState({ showLogo: !_this2.state.showLogo });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'showLogo', className: this.state.format === 'labels' ? 'disabled' : '' },
                                    'Vis logo'
                                )
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 4 },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Personkategorier'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'clubChairman', name: 'clubChairman', type: 'checkbox', checked: this.state.clubChairman, onClick: function onClick(e) {
                                        return _this2.setState({ clubChairman: !_this2.state.clubChairman });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'clubChairman' },
                                    'Foreningsform\xE6nd'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'clubCashier', name: 'clubCashier', type: 'checkbox', checked: this.state.clubCashier, onClick: function onClick(e) {
                                        return _this2.setState({ clubCashier: !_this2.state.clubCashier });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'clubCashier' },
                                    'Foreningskasserere'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'clubItContact', name: 'clubItContact', type: 'checkbox', checked: this.state.clubItContact, onClick: function onClick(e) {
                                        return _this2.setState({ clubItContact: !_this2.state.clubItContact });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'clubItContact' },
                                    'Edb-kontakter'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'clubReleas', name: 'clubReleas', type: 'checkbox', checked: this.state.clubReleas, onClick: function onClick(e) {
                                        return _this2.setState({ clubReleas: !_this2.state.clubReleas });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'clubReleas' },
                                    'Kontrolform\xE6nd'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'sectionChairman', name: 'sectionChairman', type: 'checkbox', checked: this.state.sectionChairman, onClick: function onClick(e) {
                                        return _this2.setState({ sectionChairman: !_this2.state.sectionChairman });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'sectionChairman' },
                                    'Sektionsform\xE6nd'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'sectionCashier', name: 'sectionCashier', type: 'checkbox', checked: this.state.sectionCashier, onClick: function onClick(e) {
                                        return _this2.setState({ sectionCashier: !_this2.state.sectionCashier });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'sectionCashier' },
                                    'Sektionskasserere'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'members', name: 'members', type: 'checkbox', checked: this.state.members, onClick: function onClick(e) {
                                        return _this2.setState({ members: !_this2.state.members });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'members' },
                                    'Medlemmer'
                                )
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement('input', { id: 'magazineByPost', name: 'magazineByPost', type: 'checkbox', checked: this.state.magazineByPost, onClick: function onClick(e) {
                                        return _this2.setState({ magazineByPost: !_this2.state.magazineByPost });
                                    } }),
                                ' ',
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'magazineByPost' },
                                    'Brevduen med post'
                                )
                            ) : null
                        ),
                        _react2.default.createElement('tr', { className: 'separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'format' },
                                    'Format'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3 },
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: false, className: 'field100', containerClassName: 'display-inline-block',
                                    name: 'format', id: 'format', value: this.state.format,
                                    options: [{ key: 'labels', value: 'Labels' }, { key: 'c4', value: 'C4' }, { key: 'c5', value: 'C5' }],
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    },
                                    onChange: this.onStandardFieldChange
                                })
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'leftMargin', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Side venstre margen'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'leftMargin', id: 'leftMargin', value: this.state.leftMargin, disabled: this.state.format !== 'labels',
                                    title: 'Afstand fra venstre af arket til f\xF8rste label, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[7] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'topMargin', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Side topmargen'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'topMargin', id: 'topMargin', value: this.state.topMargin, disabled: this.state.format !== 'labels',
                                    title: 'Afstand fra toppen af arket til f\xF8rste label, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[8] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'labelLeftMargin', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Labels venstre margen'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'labelLeftMargin', id: 'labelLeftMargin', value: this.state.labelLeftMargin, disabled: this.state.format !== 'labels',
                                    title: 'Indrykning af tekst fra venstre p\xE5 label, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[9] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'labelTopMargin', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Labels topmargen'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'labelTopMargin', id: 'labelTopMargin', value: this.state.labelTopMargin, disabled: this.state.format !== 'labels',
                                    title: 'Afstand fra toppen af label til tekst, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[10] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'labelHeight', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Labelh\xF8jde'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'labelHeight', id: 'labelHeight', value: this.state.labelHeight, disabled: this.state.format !== 'labels',
                                    title: 'H\xF8jde af label inklusive afstand til n\xE6ste label, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[11] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'labelWidth', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Labelbredde'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'labelWidth', id: 'labelWidth', value: this.state.labelWidth, disabled: this.state.format !== 'labels',
                                    title: 'Bredde af label inklusive afstand til n\xE6ste label, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[12] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'rowCount', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'R\xE6kker pr. ark'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'rowCount', id: 'rowCount', value: this.state.rowCount, disabled: this.state.format !== 'labels',
                                    title: 'Antal label-r\xE6kker p\xE5 et ark, under hinanden',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[13] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'columnCount', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Kolonner pr. ark'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'columnCount', id: 'columnCount', value: this.state.columnCount, disabled: this.state.format !== 'labels',
                                    title: 'Antal label-kolonner p\xE5 et ark, ved siden af hinanden',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[14] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'lineHeight', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Linieh\xF8jde'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'lineHeight', id: 'lineHeight', value: this.state.lineHeight, disabled: this.state.format !== 'labels',
                                    title: 'H\xF8jde af tekstlinier, m\xE5lt i mm',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[13] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fontSize', className: this.state.format === 'labels' ? '' : 'disabled' },
                                    'Fontst\xF8rrelse'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fontSize', id: 'fontSize', value: this.state.fontSize, disabled: this.state.format !== 'labels',
                                    title: 'Fontst\xF8rrelse, m\xE5lt i pixels (px)',
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true, hideErrorIfDisabled: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[14] = instance;
                                    }
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GeneralLabels;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.getLabelConfig = function (props, config) {
        return props.admin.generalSection && props.admin.generalSection.Config && typeof props.admin.generalSection.Config.Labels !== 'undefined' && typeof props.admin.generalSection.Config.Labels[config] !== 'undefined' && props.admin.generalSection.Config.Labels[config] !== null ? String(props.admin.generalSection.Config.Labels[config]) : '';
    };

    this.fields = [];

    this.allInputValid = function () {
        var result = true;
        _this3.fields.forEach(function (field, ix) {
            if (field && field.props.disabled !== true && !field.isValid()) result = false;
        });
        return result;
    };

    this.onStandardFieldChange = function (e) {
        var stateVariable = e.target.name;
        _this3.setState(_defineProperty({}, stateVariable, e.target.value));
    };

    this.getReportOptions = function () {
        var errors = [];
        var isValid = _this3.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            _this3.fields.forEach(function (field) {
                field.setState({ visited: true });
            });
        }
        if (!_this3.state.clubChairman && !_this3.state.clubCashier && !_this3.state.clubItContact && !_this3.state.clubReleas && !_this3.state.sectionChairman && !_this3.state.sectionCashier && !_this3.state.members && !_this3.state.magazineByPost) errors.push('Vælg mindst en personkategori.');

        var options = Object.assign({}, {
            fromSection: _this3.state.fromSection === '' ? null : _this3.state.fromSection,
            toSection: _this3.state.toSection === '' ? null : _this3.state.toSection,
            fromClub: _this3.state.fromClub === '' ? null : _this3.state.fromClub,
            toClub: _this3.state.toClub === '' ? null : _this3.state.toClub,
            fromMember: _this3.state.fromMember === '' ? null : _this3.state.fromMember,
            toMember: _this3.state.toMember === '' ? null : _this3.state.toMember,
            showMemberNo: _this3.state.showMemberNo,
            showLogo: _this3.state.showLogo,
            clubChairman: _this3.state.clubChairman,
            clubCashier: _this3.state.clubCashier,
            clubItContact: _this3.state.clubItContact,
            clubReleas: _this3.state.clubReleas,
            sectionChairman: _this3.state.sectionChairman,
            sectionCashier: _this3.state.sectionCashier,
            members: _this3.state.members,
            magazineByPost: _this3.state.magazineByPost,
            format: _this3.state.format
        }, _this3.state.format === 'labels' ? {
            leftMargin: _this3.state.leftMargin === '' ? null : Number(_this3.state.leftMargin),
            topMargin: _this3.state.topMargin === '' ? null : Number(_this3.state.topMargin),
            labelLeftMargin: _this3.state.labelLeftMargin === '' ? null : Number(_this3.state.labelLeftMargin),
            labelTopMargin: _this3.state.labelTopMargin === '' ? null : Number(_this3.state.labelTopMargin),
            labelHeight: _this3.state.labelHeight === '' ? null : Number(_this3.state.labelHeight),
            labelWidth: _this3.state.labelWidth === '' ? null : Number(_this3.state.labelWidth),
            rowCount: _this3.state.rowCount === '' ? null : Number(_this3.state.rowCount),
            columnCount: _this3.state.columnCount === '' ? null : Number(_this3.state.columnCount),
            lineHeight: _this3.state.lineHeight === '' ? null : Number(_this3.state.lineHeight),
            fontSize: _this3.state.fontSize === '' ? null : Number(_this3.state.fontSize)
        } : {});

        return {
            errors: errors,
            options: options
        };
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            generalSection: state.admin.generalSection
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralLabels);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneralLocations = function (_React$Component) {
    _inherits(GeneralLocations, _React$Component);

    function GeneralLocations(props) {
        _classCallCheck(this, GeneralLocations);

        var _this = _possibleConstructorReturn(this, (GeneralLocations.__proto__ || Object.getPrototypeOf(GeneralLocations)).call(this, props));

        _this.fields = [];

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromSection !== '' && _this.state.toSection !== '' && _this.state.fromSection > _this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
            if (_this.state.fromClub !== '' && _this.state.toClub !== '' && _this.state.fromClub > _this.state.toClub) errors.push('Fra forening kan ikke være større end Til forening.');

            var options = {
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                report: _this.state.report
            };

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            report: 'dist'
        });
        return _this;
    }

    _createClass(GeneralLocations, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'general-members' },
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Filtr\xE9ring (valgfrit)'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromSection',
                                id: 'fromSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.fromSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til sektion'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toSection',
                                id: 'toSection',
                                maxLength: '2',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                value: this.state.toSection,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            })
                        )
                    ) : null,
                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                        'div',
                        { className: 'attribute-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Fra forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'fromClub',
                                id: 'fromClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.fromClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[2].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[2] = instance;
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-pair' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Til forening'
                            ),
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.regex,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'toClub',
                                id: 'toClub',
                                maxLength: '3',
                                options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }],
                                value: this.state.toClub,
                                autoCheckErrors: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: this.onDigitInputFieldChange,
                                onBlur: function onBlur() {
                                    _this2.fields[3].setState({ focused: false, visited: true });
                                    if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[3] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'label',
                    { className: 'header' },
                    'Listetype'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'lower-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'list-type-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'option-container' },
                            _react2.default.createElement('input', { id: 'listtype0', name: 'listtype', type: 'radio', checked: this.state.report === 'dist', onClick: function onClick() {
                                    return _this2.setState({ report: 'dist' });
                                } }),
                            ' ',
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'listtype0' },
                                'Afstandsliste'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'option-container' },
                            _react2.default.createElement('input', { id: 'listtype1', name: 'listtype', type: 'radio', checked: this.state.report === 'member-location', onClick: function onClick() {
                                    return _this2.setState({ report: 'member-location' });
                                } }),
                            ' ',
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'listtype1' },
                                'L\xE6ngde og breddekoordinater'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'option-container' },
                            _react2.default.createElement('input', { id: 'listtype2', name: 'listtype', type: 'radio', checked: this.state.report === 'member-control', onClick: function onClick() {
                                    return _this2.setState({ report: 'member-control' });
                                } }),
                            ' ',
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'listtype2' },
                                'GPS-registrering'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'option-container' },
                            _react2.default.createElement('input', { id: 'listtype3', name: 'listtype', type: 'radio', checked: this.state.report === 'stations', onClick: function onClick() {
                                    return _this2.setState({ report: 'stations' });
                                } }),
                            ' ',
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'listtype3' },
                                'Stationsliste'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GeneralLocations;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(GeneralLocations);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _ChampionshipList = __webpack_require__(771);

var _ChampionshipList2 = _interopRequireDefault(_ChampionshipList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonChampionships = function (_React$Component) {
    _inherits(SeasonChampionships, _React$Component);

    function SeasonChampionships(props) {
        _classCallCheck(this, SeasonChampionships);

        var _this = _possibleConstructorReturn(this, (SeasonChampionships.__proto__ || Object.getPrototypeOf(SeasonChampionships)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? true : false));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.updateRaceSelection = function (championships) {
            var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.setState({
                selectedChampionships: add ? _this.state.selectedChampionships.concat(championships.filter(function (championship) {
                    return _this.state.selectedChampionships.indexOf(championship) < 0;
                })) : _this.state.selectedChampionships.filter(function (championship) {
                    return championships.indexOf(championship) < 0;
                })
            });
        };

        _this.getReportOptions = function (options) {
            var errors = [];
            var isValid = true;
            if (typeof options === 'undefined' || typeof options.checkOnlyChampionshipSelection === 'undefined' || options.checkOnlyChampionshipSelection !== true) {
                isValid = _this.allInputValid();
                if (!isValid) {
                    errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                    _this.fields.forEach(function (field) {
                        field.setState({ visited: true });
                    });
                }
            }
            if (_this.state.selectedChampionships.length === 0) errors.push('Der er ikke valgt nogen mesterskaber(er).');
            return {
                errors: errors,
                isErrors: !isValid,
                options: {
                    championships: _this.state.selectedChampionships,
                    resultSize: _this.state.resultSize === '' ? null : _this.state.resultSize,
                    showRaceDetails: _this.state.showRaceDetails,
                    club: _this.state.club === '' ? null : _this.state.club,
                    member: _this.state.member === '' ? null : _this.state.member,
                    maleCount: _this.state.maleCount === '' ? null : Number(_this.state.maleCount),
                    femaleCount: _this.state.femaleCount === '' ? null : Number(_this.state.femaleCount),
                    sortBySex: _this.state.sortBySex,
                    sortBySection: _this.state.sortBySection
                }
            };
        };

        _this.state = Object.assign({
            selectedChampionships: [],
            resultSize: '',
            showRaceDetails: false,
            club: '',
            member: '',
            maleCount: '',
            femaleCount: '',
            sortBySex: false,
            sortBySection: false
        });
        return _this;
    }

    _createClass(SeasonChampionships, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-championships' },
                _react2.default.createElement(
                    'div',
                    { className: 'championship-list' },
                    _react2.default.createElement(_ChampionshipList2.default, { selectedRaces: this.state.selectedChampionships, updateSelection: this.updateRaceSelection })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'report-options' },
                    _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'result-size' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'resultSize' },
                                    'Antal eller procent (afslut med %) deltagere '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                    name: 'resultSize', id: 'resultSize', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]+%?" }], value: this.state.resultSize,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'showRaceDetails', name: 'showRaceDetails', type: 'checkbox', checked: this.state.showRaceDetails, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'showRaceDetails' },
                                    ' Specific\xE9r point'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'result-criterias' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'maleCount' },
                                    'Kun for due-mesterskaber: Antal hanner '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                    name: 'maleCount', id: 'maleCount', value: this.state.maleCount,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'femaleCount' },
                                    'Antal hunner '
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                    name: 'femaleCount', id: 'femaleCount', value: this.state.femaleCount,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'option-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'result-groupings' },
                            _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'sortBySex', name: 'sortBySex', type: 'checkbox', checked: this.state.sortBySex, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'sortBySex' },
                                    ' Udskriv k\xF8nsvist (kun for duemesterskaber)'
                                )
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'span',
                                { className: 'option' },
                                _react2.default.createElement('input', { id: 'sortBySection', name: 'sortBySection', type: 'checkbox', checked: this.state.sortBySection, onChange: this.onCheckFieldChange }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'sortBySection' },
                                    ' Udskriv sektionsvist'
                                )
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return SeasonChampionships;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonChampionships);

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChampionshipListList = function (_React$Component) {
    _inherits(ChampionshipListList, _React$Component);

    function ChampionshipListList(props) {
        _classCallCheck(this, ChampionshipListList);

        var _this = _possibleConstructorReturn(this, (ChampionshipListList.__proto__ || Object.getPrototypeOf(ChampionshipListList)).call(this, props));

        _this.fields = [];

        _this.state = Object.assign({
            initialized: false
        });
        return _this;
    }

    _createClass(ChampionshipListList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getChampionships());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var result = this.props.admin.isChampionshipsRead ? _react2.default.createElement(
                'table',
                { className: 'data-table row-clickable' },
                _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement('th', { scope: 'row' }),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Kode'
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            'Navn'
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'th',
                            null,
                            'Sektionsgrupper'
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'th',
                            null,
                            'Sektioner'
                        ) : null,
                        _react2.default.createElement(
                            'th',
                            null,
                            'Type'
                        ),
                        _react2.default.createElement(
                            'th',
                            { colSpan: 2 },
                            'Pointsystem'
                        )
                    )
                ),
                _react2.default.createElement(
                    'tbody',
                    null,
                    this.props.admin.championships.sort(function (c1, c2) {
                        if ((0, _lib.nullToBlank)(c1.Nr) < (0, _lib.nullToBlank)(c2.Nr)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Nr) > (0, _lib.nullToBlank)(c2.Nr)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Titel) < (0, _lib.nullToBlank)(c2.Titel)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Titel) > (0, _lib.nullToBlank)(c2.Titel)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Sektionsgrupper) < (0, _lib.nullToBlank)(c2.Sektionsgrupper)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Sektionsgrupper) > (0, _lib.nullToBlank)(c2.Sektionsgrupper)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Sektioner) < (0, _lib.nullToBlank)(c2.Sektioner)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Sektioner) > (0, _lib.nullToBlank)(c2.Sektioner)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Type) < (0, _lib.nullToBlank)(c2.Type)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Type) > (0, _lib.nullToBlank)(c2.Type)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Pointsystem) < (0, _lib.nullToBlank)(c2.Pointsystem)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Pointsystem) > (0, _lib.nullToBlank)(c2.Pointsystem)) return 1;
                        if ((0, _lib.nullToBlank)(c1.Pointsystem2) < (0, _lib.nullToBlank)(c2.Pointsystem2)) return -1;
                        if ((0, _lib.nullToBlank)(c1.Pointsystem2) > (0, _lib.nullToBlank)(c2.Pointsystem2)) return 1;
                        if (c1.RecNr < c2.RecNr) return -1;
                        if (c1.RecNr > c2.RecNr) return 1;
                        return 0;
                    }).toArray().map(function (champ) {
                        var sections = (0, _lib.CompressList)(champ.Sektioner);
                        var groups = (0, _lib.CompressList)(champ.Sektionsgrupper);
                        return _react2.default.createElement(
                            'tr',
                            { key: champ.RecNr, id: 'row-' + champ.RecNr, onClick: function onClick() {
                                    _this2.props.updateSelection([champ.RecNr], _this2.props.selectedRaces.indexOf(champ.RecNr) < 0);
                                } },
                            _react2.default.createElement(
                                'th',
                                { scope: 'row' },
                                _react2.default.createElement('input', { type: 'checkbox', checked: _this2.props.selectedRaces.indexOf(champ.RecNr) >= 0 })
                            ),
                            _react2.default.createElement(
                                'td',
                                { onClick: function onClick(e) {
                                        e.stopPropagation();
                                        _this2.props.updateSelection(_this2.props.admin.championships.filter(function (otherChamp) {
                                            return otherChamp.Nr === champ.Nr;
                                        }).map(function (champ) {
                                            return champ.RecNr;
                                        }).toArray(), _this2.props.selectedRaces.indexOf(champ.RecNr) < 0);
                                    } },
                                _react2.default.createElement(
                                    'a',
                                    { href: 'javascript:void(0)' },
                                    champ.Nr
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                champ.Titel
                            ),
                            _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                null,
                                groups.items.join(',')
                            ) : null,
                            _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                null,
                                sections.items.join(',')
                            ) : null,
                            _react2.default.createElement(
                                'td',
                                null,
                                champ.Type
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                champ.Pointsystem
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                champ.Pointsystem2
                            )
                        );
                    })
                )
            ) : null;

            return result;
        }
    }]);

    return ChampionshipListList;
}(_react2.default.Component);

ChampionshipListList.propTypes = {
    selectedChampionships: _propTypes2.default.array.isRequired,
    updateSelection: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            championships: state.admin.championships,
            isChampionshipsRead: state.admin.isChampionshipsRead
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ChampionshipListList);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonMemberStats = function (_React$Component) {
    _inherits(SeasonMemberStats, _React$Component);

    function SeasonMemberStats(props) {
        _classCallCheck(this, SeasonMemberStats);

        var _this = _possibleConstructorReturn(this, (SeasonMemberStats.__proto__ || Object.getPrototypeOf(SeasonMemberStats)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            var options = {
                club: _this.state.club === '' ? null : _this.state.club,
                pigeonhole: _this.state.pigeonhole === '' ? null : _this.state.pigeonhole,
                allPigeons: _this.state.allPigeons,
                onlyDdB: _this.state.onlyDdB,
                onlySection: _this.state.onlySection,
                order: _this.state.order
            };

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            club: _this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _this.props.auth.currentEntity : '',
            pigeonhole: '',
            allPigeons: true,
            onlyDdB: false,
            onlySection: false,
            order: 'race'
        });
        return _this;
    }

    _createClass(SeasonMemberStats, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));else if (!this.props.admin.isClubsRead) this.props.dispatch(AdminActions.getClubs());
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                { className: "season-member-stats reports-inner-box report-options" },
                _react2.default.createElement(
                    "table",
                    null,
                    _react2.default.createElement(
                        "tbody",
                        null,
                        _react2.default.createElement(
                            "tr",
                            null,
                            this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                "td",
                                { style: { width: '100px' } },
                                _react2.default.createElement(
                                    "label",
                                    { htmlFor: "club" },
                                    "Forening"
                                )
                            ),
                            _react2.default.createElement(
                                "td",
                                null,
                                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: "field100p", containerClassName: "display-inline-block field100p",
                                    name: "club", id: "club", value: this.state.club, options: this.props.admin.clubs ? this.props.admin.clubs.filter(function (c) {
                                        return c.Sektionsnr !== '99' && (_this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id || c.Sektionsnr === _this2.props.auth.currentEntity);
                                    }).sort(function (c1, c2) {
                                        return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                    }).map(function (club) {
                                        return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                    }).toArray() : [],
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: function onChange(e) {
                                        _this2.setState({ club: e.target.value, pigeonhole: '' });
                                        _this2.props.dispatch(AdminActions.getClub(e.target.value));
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                { style: { width: '100px' } },
                                _react2.default.createElement(
                                    "label",
                                    { className: this.state.club === '' ? 'disabled' : '', htmlFor: "pigeonhole" },
                                    "Slag"
                                )
                            ),
                            _react2.default.createElement(
                                "td",
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: "field100p", containerClassName: "display-inline-block field100p", disabled: this.state.club === '',
                                    name: "pigeonhole", id: "pigeonhole", value: this.state.pigeonhole, options: this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(function (p) {
                                        return p.Foreningsnr === _this2.state.club;
                                    }).sort(function (p1, p2) {
                                        return p1.Slagnr < p2.Slagnr ? -1 : p1.Slagnr > p2.Slagnr ? 1 : 0;
                                    }).map(function (pigeonHole) {
                                        return { key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn) };
                                    }).toArray() : [],
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement("div", { className: "options-separator" }),
                _react2.default.createElement(
                    "div",
                    { className: "options-group" },
                    _react2.default.createElement("input", { id: "allPigeons", name: "allPigeons", type: "checkbox", checked: this.state.allPigeons, onClick: function onClick(e) {
                            return _this2.setState({ allPigeons: !_this2.state.allPigeons });
                        } }),
                    " ",
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "allPigeons" },
                        "Alle duer"
                    )
                ),
                _react2.default.createElement("div", { className: "options-separator" }),
                _react2.default.createElement(
                    "div",
                    { className: "options-group" },
                    _react2.default.createElement("input", { id: "onlyDdB", name: "onlyDdB", type: "checkbox", checked: this.state.onlyDdB, onClick: function onClick(e) {
                            return _this2.setState({ onlyDdB: !_this2.state.onlyDdB, onlySection: !_this2.state.onlyDdB ? false : _this2.state.onlySection });
                        } }),
                    " ",
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "onlyDdB" },
                        "Kun DdB-flyvninger"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "options-group" },
                    _react2.default.createElement("input", { id: "onlySection", name: "onlySection", type: "checkbox", checked: this.state.onlySection, onClick: function onClick(e) {
                            return _this2.setState({ onlySection: !_this2.state.onlySection, onlyDdB: !_this2.state.onlySection ? false : _this2.state.onlyDdB });
                        } }),
                    " ",
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "onlySection" },
                        "Kun sektionsflyvninger"
                    )
                ),
                _react2.default.createElement("div", { className: "options-separator" }),
                _react2.default.createElement(
                    "div",
                    { className: "options-group" },
                    _react2.default.createElement("input", { id: "orderRace", name: "order", type: "radio", checked: this.state.order === 'race', onClick: function onClick(e) {
                            return _this2.setState({ order: 'race' });
                        } }),
                    " ",
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "orderRace" },
                        "Sorter efter uge/kapflyvning"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "options-group" },
                    _react2.default.createElement("input", { id: "orderPigeon", name: "order", type: "radio", checked: this.state.order === 'pigeon', onClick: function onClick(e) {
                            return _this2.setState({ order: 'pigeon' });
                        } }),
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "orderPigeon" },
                        "Sorter efter ringnummer"
                    )
                )
            );
        }
    }]);

    return SeasonMemberStats;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isClubsRead: state.admin.isClubsRead,
            clubs: state.admin.clubs,
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonMemberStats);

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonRaceStats = function (_React$Component) {
    _inherits(SeasonRaceStats, _React$Component);

    function SeasonRaceStats(props) {
        _classCallCheck(this, SeasonRaceStats);

        var _this = _possibleConstructorReturn(this, (SeasonRaceStats.__proto__ || Object.getPrototypeOf(SeasonRaceStats)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            var options = {
                level: _this.state.level,
                fromGroup: _this.state.fromGroup === '' ? null : _this.state.fromGroup,
                toGroup: _this.state.toGroup === '' ? null : _this.state.toGroup,
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub,
                fromWeek: _this.state.fromWeek === '' ? null : Number(_this.state.fromWeek),
                toWeek: _this.state.toWeek === '' ? null : Number(_this.state.toWeek),
                raceCode: _this.state.raceCode === '' ? null : _this.state.raceCode,
                LMU: _this.state.LMU === '' ? null : _this.state.LMU,
                noCalculated: _this.state.noCalculated === '' ? null : _this.state.noCalculated,
                groupSections: _this.state.groupSections,
                onlyDdB: _this.state.onlyDdB,
                onlySection: _this.state.onlySection
            };

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            level: _this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'club' : _this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? 'section' : 'country',
            fromGroup: '',
            toGroup: '',
            fromSection: '',
            toSection: '',
            fromClub: '',
            toClub: '',
            fromWeek: '',
            toWeek: '',
            raceCode: '',
            LMU: '',
            noCalculated: '',
            groupSections: false,
            onlyDdB: false,
            onlySection: false
        });
        return _this;
    }

    _createClass(SeasonRaceStats, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-race-stats reports-inner-box report-options' },
                _react2.default.createElement(
                    'table',
                    { style: { maxWidth: '900px' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                'td',
                                { style: { width: '33%', verticalAlign: 'top' }, rowSpan: 8 },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'OPSTILLING'
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'levelCountry', name: 'level', type: 'radio', checked: this.state.level === 'country', onClick: function onClick(e) {
                                            return _this2.setState({ level: 'country' });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'levelCountry' },
                                        'Land'
                                    )
                                ) : null,
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'levelGroup', name: 'level', type: 'radio', checked: this.state.level === 'group', onClick: function onClick(e) {
                                            return _this2.setState({ level: 'group' });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'levelGroup' },
                                        'Gruppe'
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'levelSection', name: 'level', type: 'radio', checked: this.state.level === 'section', onClick: function onClick(e) {
                                            return _this2.setState({ level: 'section' });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'levelSection' },
                                        'Sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'levelClub', name: 'level', type: 'radio', checked: this.state.level === 'club', onClick: function onClick(e) {
                                            return _this2.setState({ level: 'club' });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'levelClub' },
                                        'Forening'
                                    )
                                )
                            ),
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromGroup' },
                                    'Fra gruppe'
                                )
                            ) : this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromClub' },
                                    'Fra forening'
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromGroup', id: 'fromGroup', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1}" }], value: this.state.fromGroup,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ) : this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromClub', id: 'fromClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.fromClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[4].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0'), toClub: _this2.state.toClub === '' ? _this2.state.fromClub.padStart(3, '0') : _this2.state.toClub });else if (/^[0-9]{3}$/.test(_this2.state.fromClub) && _this2.state.toClub === '') _this2.setState({ toClub: _this2.state.fromClub });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toGroup' },
                                    'Til gruppe'
                                )
                            ) : this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toClub' },
                                    'Til forening'
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toGroup', id: 'toGroup', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1}" }], value: this.state.toGroup,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            ) : this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toClub', id: 'toClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.toClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[5].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                })
                            ) : null
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromSection' },
                                    'Fra sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromSection', id: 'fromSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.fromSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toSection' },
                                    'Til sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toSection', id: 'toSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.toSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            )
                        ) : null,
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromClub' },
                                    'Fra forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromClub', id: 'fromClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.fromClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[4].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0'), toClub: _this2.state.toClub === '' ? _this2.state.fromClub.padStart(3, '0') : _this2.state.toClub });else if (/^[0-9]{3}$/.test(_this2.state.fromClub) && _this2.state.toClub === '') _this2.setState({ toClub: _this2.state.fromClub });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toClub' },
                                    'Til forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toClub', id: 'toClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.toClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[5].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                })
                            )
                        ) : null,
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromWeek' },
                                    'Fra uge'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromWeek', id: 'fromWeek', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.fromWeek,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toWeek' },
                                    'Til uge'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toWeek', id: 'toWeek', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.toWeek,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[7] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'raceCode' },
                                    'KFK'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'raceCode', id: 'raceCode', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.raceCode,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[8] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'LMU' },
                                    'LMU'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field100', containerClassName: 'display-inline-block field100p',
                                    name: 'LMU', id: 'LMU', value: this.state.LMU, options: [{ key: '', value: 'Alle' }, { key: 'L', value: 'Lang' }, { key: 'M', value: 'Mellem' }, { key: 'U', value: 'Unge' }, { key: 'O', value: 'O' }],
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[9] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '49.5%' }, colSpan: 3 },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'noCalculated' },
                                    'Medtag antal eller procent (afslut med %) beregnede duer'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '16.5%' } },
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                    name: 'noCalculated', id: 'noCalculated', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]+%?" }], value: this.state.noCalculated,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[10] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'td',
                                { style: { width: '33%' } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'groupSections', name: 'groupSections', type: 'checkbox', checked: this.state.groupSections, onClick: function onClick(e) {
                                            return _this2.setState({ groupSections: !_this2.state.groupSections });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'groupSections' },
                                        'Sektionsvist'
                                    )
                                )
                            ) : null,
                            _react2.default.createElement(
                                'td',
                                { style: { width: '33%' }, colSpan: 2 },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'onlyDdB', name: 'onlyDdB', type: 'checkbox', checked: this.state.onlyDdB, onClick: function onClick(e) {
                                            return _this2.setState({ onlyDdB: !_this2.state.onlyDdB, onlySection: !_this2.state.onlyDdB ? false : _this2.state.onlySection });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'onlyDdB' },
                                        'Kun DdB-flyvninger'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '33%' }, colSpan: 2 },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'options-group' },
                                    _react2.default.createElement('input', { id: 'onlySection', name: 'onlySection', type: 'checkbox', checked: this.state.onlySection, onClick: function onClick(e) {
                                            return _this2.setState({ onlySection: !_this2.state.onlySection, onlyDdB: !_this2.state.onlySection ? false : _this2.state.onlyDdB });
                                        } }),
                                    ' ',
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'onlySection' },
                                        'Kun sektionsflyvninger'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SeasonRaceStats;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonRaceStats);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonEquipStats = function (_React$Component) {
    _inherits(SeasonEquipStats, _React$Component);

    function SeasonEquipStats(props) {
        _classCallCheck(this, SeasonEquipStats);

        var _this = _possibleConstructorReturn(this, (SeasonEquipStats.__proto__ || Object.getPrototypeOf(SeasonEquipStats)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            var options = {
                fromWeek: _this.state.fromWeek === '' ? null : Number(_this.state.fromWeek),
                toWeek: _this.state.toWeek === '' ? null : Number(_this.state.toWeek),
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                showClubs: _this.state.showClubs
            };

            return {
                errors: errors,
                options: options
            };
        };

        _this.state = Object.assign({
            fromWeek: '',
            toWeek: '',
            fromSection: '',
            toSection: '',
            showClubs: false
        });
        return _this;
    }

    _createClass(SeasonEquipStats, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-equip-stats reports-inner-box report-options' },
                _react2.default.createElement(
                    'table',
                    { style: { maxWidth: '500px' } },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromWeek' },
                                    'Fra uge'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromWeek', id: 'fromWeek', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.fromWeek,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toWeek' },
                                    'Til uge'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toWeek', id: 'toWeek', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.toWeek,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromSection' },
                                    'Fra sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromSection', id: 'fromSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.fromSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toSection' },
                                    'Til sektion'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toSection', id: 'toSection', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.toSection,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            )
                        ) : null
                    )
                ),
                _react2.default.createElement('div', { className: 'options-separator' }),
                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                    'div',
                    { className: 'options-group' },
                    _react2.default.createElement('input', { id: 'showClubs', name: 'showClubs', type: 'checkbox', checked: this.state.showClubs, onClick: function onClick(e) {
                            return _this2.setState({ showClubs: !_this2.state.showClubs });
                        } }),
                    ' ',
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'showClubs' },
                        'Vis foreninger'
                    )
                )
            );
        }
    }]);

    return SeasonEquipStats;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonEquipStats);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonSeats = function (_React$Component) {
    _inherits(SeasonSeats, _React$Component);

    function SeasonSeats(props) {
        _classCallCheck(this, SeasonSeats);

        var _this = _possibleConstructorReturn(this, (SeasonSeats.__proto__ || Object.getPrototypeOf(SeasonSeats)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            var options = {
                report: _this.state.report,
                seatsForSection: _this.state.seatsForSection === '' ? null : Number(_this.state.seatsForSection),
                seatsForMainBoard: _this.state.seatsForMainBoard === '' ? null : Number(_this.state.seatsForMainBoard),
                fromClub: _this.state.fromClub === '' ? null : _this.state.fromClub,
                toClub: _this.state.toClub === '' ? null : _this.state.toClub
            };

            return {
                errors: errors,
                isErrors: !isValid,
                options: options
            };
        };

        _this.state = Object.assign({
            report: 'club', // club, group, delegate, active-members
            seatsForSection: props.admin.generalSection ? props.admin.generalSection.AntalMandaterSektioner === null ? '50' : String(props.admin.generalSection.AntalMandaterSektioner) : '',
            seatsForMainBoard: props.admin.generalSection ? props.admin.generalSection.AntalMandaterHovedbestyrelse === null ? '9' : String(props.admin.generalSection.AntalMandaterHovedbestyrelse) : '',
            fromClub: '',
            toClub: ''
        });
        return _this;
    }

    _createClass(SeasonSeats, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getGeneral());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                seatsForSection: nextProps.admin.generalSection ? nextProps.admin.generalSection.AntalMandaterSektioner === null ? '' : String(nextProps.admin.generalSection.AntalMandaterSektioner) : '',
                seatsForMainBoard: nextProps.admin.generalSection ? nextProps.admin.generalSection.AntalMandaterHovedbestyrelse === null ? '' : String(nextProps.admin.generalSection.AntalMandaterHovedbestyrelse) : ''
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-seats reports-inner-box report-options' },
                _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { maxWidth: '25px', width: '25px' } },
                                _react2.default.createElement('input', { id: 'reportClub', name: 'report', type: 'radio', checked: this.state.report === 'club', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'club' });
                                    } })
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportClub' },
                                    'Pr. forening'
                                )
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { maxWidth: '25px', width: '25px' } },
                                _react2.default.createElement('input', { id: 'reportGroup', name: 'report', type: 'radio', checked: this.state.report === 'group', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'group' });
                                    } })
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportGroup' },
                                    'Pr. gruppe'
                                )
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { maxWidth: '25px', width: '25px' } },
                                _react2.default.createElement('input', { id: 'reportDelegate', name: 'report', type: 'radio', checked: this.state.report === 'delegate', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'delegate' });
                                    } })
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportDelegate' },
                                    'Delegeretm\xF8de'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { style: { maxWidth: '25px', width: '25px' } }),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '250px' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'seatsForSection' },
                                    'Mandater til sektioner'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'seatsForSection', id: 'seatsForSection', value: this.state.seatsForSection,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { style: { maxWidth: '25px', width: '25px' } }),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '250px' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'seatsForMainBoard' },
                                    'Mandater til hovedbestyrelsen'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'seatsForMainBoard', id: 'seatsForMainBoard', value: this.state.seatsForMainBoard,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement('tr', { className: 'options-separator' }),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { maxWidth: '25px', width: '25px' } },
                                _react2.default.createElement('input', { id: 'reportActiveMembers', name: 'report', type: 'radio', checked: this.state.report === 'active-members', onClick: function onClick(e) {
                                        return _this2.setState({ report: 'active-members' });
                                    } })
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'reportActiveMembers' },
                                    'Sorter efter ringnummer'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { style: { maxWidth: '25px', width: '25px' } }),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '250px' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'fromClub' },
                                    'Fra forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'fromClub', id: 'fromClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.fromClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[2].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.fromClub)) _this2.setState({ fromClub: _this2.state.fromClub.padStart(3, '0'), toClub: _this2.state.toClub === '' ? _this2.state.fromClub.padStart(3, '0') : _this2.state.toClub });else if (/^[0-9]{3}$/.test(_this2.state.fromClub) && _this2.state.toClub === '') _this2.setState({ toClub: _this2.state.fromClub });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', { style: { maxWidth: '25px', width: '25px' } }),
                            _react2.default.createElement(
                                'td',
                                { style: { width: '250px' } },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'toClub' },
                                    'Til forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                    name: 'toClub', id: 'toClub', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.toClub,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[3].setState({ focused: false, visited: true });
                                        if (/^[0-9]{1,2}$/.test(_this2.state.toClub)) _this2.setState({ toClub: _this2.state.toClub.padStart(3, '0') });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SeasonSeats;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            generalSection: state.admin.generalSection
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonSeats);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _RaceList = __webpack_require__(79);

var _RaceList2 = _interopRequireDefault(_RaceList);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeasonPrices = function (_React$Component) {
    _inherits(SeasonPrices, _React$Component);

    function SeasonPrices(props) {
        _classCallCheck(this, SeasonPrices);

        var _this = _possibleConstructorReturn(this, (SeasonPrices.__proto__ || Object.getPrototypeOf(SeasonPrices)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
            return {
                errors: errors,
                options: {
                    raceType: _this.state.raceType,
                    reportType: _this.state.reportType,
                    sectionFrom: _this.state.sectionFrom === '' ? null : _this.state.sectionFrom,
                    sectionTo: _this.state.sectionTo === '' ? null : _this.state.sectionTo,
                    clubFrom: _this.state.clubFrom === '' ? null : _this.state.clubFrom,
                    clubTo: _this.state.clubTo === '' ? null : _this.state.clubTo,
                    weekFrom: _this.state.weekFrom === '' ? null : Number(_this.state.weekFrom),
                    weekTo: _this.state.weekTo === '' ? null : Number(_this.state.weekTo)
                }
            };
        };

        _this.state = Object.assign({
            raceType: props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? 'section' : props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'ddb' : 'all',
            reportType: 'club',
            sectionFrom: '',
            sectionTo: props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? '69' : '',
            clubFrom: '',
            clubTo: props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? '299' : '',
            weekFrom: '',
            weekTo: ''
        });
        return _this;
    }

    _createClass(SeasonPrices, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-prices report-options' },
                _react2.default.createElement(
                    'div',
                    { className: 'left-pane' },
                    this.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons-title' },
                            'Kapflyvningstype'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-type-all', type: 'radio', checked: this.state.raceType === 'all', onClick: function onClick() {
                                    return _this2.setState({ raceType: 'all' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-type-all' },
                                'Alle flyvninger'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-type-ddb', type: 'radio', checked: this.state.raceType === 'ddb', onClick: function onClick() {
                                    return _this2.setState({ raceType: 'ddb', sectionFrom: /^[0-9]{2}$/.test(_this2.state.sectionFrom) ? _this2.state.sectionFrom : '', sectionTo: /^[0-9]{2}$/.test(_this2.state.sectionTo) ? _this2.state.sectionTo : '' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-type-ddb' },
                                'DDB-flyvninger'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-type-section', type: 'radio', checked: this.state.raceType === 'section', onClick: function onClick() {
                                    return _this2.setState({ raceType: 'section' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-type-section' },
                                'Sektionsflyvninger'
                            )
                        )
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons-title' },
                            'Layout'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-club', type: 'radio', checked: this.state.reportType === 'club', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'club' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-club' },
                                'Foreningsopdelt'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'report-type-club-summary', type: 'radio', checked: this.state.reportType === 'club-summary', onClick: function onClick() {
                                    return _this2.setState({ reportType: 'club-summary' });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'report-type-club-summary' },
                                'Foreningstotaler'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'right-pane' },
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: this.state.raceType !== 'ddb' ? '' : 'disabled' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'sectionFrom' },
                                        'Fra sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block', enabled: this.state.raceType !== 'ddb',
                                        name: 'sectionFrom', id: 'sectionFrom', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionFrom,
                                        disabled: this.state.raceType === 'ddb', autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[0].setState({ focused: false, visited: true });
                                            if (/^[0-9]{2}$/.test(_this2.state.sectionFrom) && _this2.state.sectionTo === '') _this2.setState({ sectionTo: _this2.state.sectionFrom });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: this.state.raceType !== 'ddb' ? '' : 'disabled' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'sectionTo' },
                                        'Til sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block', enabled: this.state.raceType !== 'ddb',
                                        name: 'sectionTo', id: 'sectionTo', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.sectionTo,
                                        disabled: this.state.raceType === 'ddb', autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'separator' },
                                _react2.default.createElement('td', { colSpan: 2 })
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'clubFrom' },
                                        'Fra forening'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'clubFrom', id: 'clubFrom', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubFrom,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[2].setState({ focused: false, visited: true });
                                            if (/^[0-9]{1,2}$/.test(_this2.state.clubFrom)) _this2.setState({ clubFrom: _this2.state.clubFrom.padStart(3, '0'), clubTo: _this2.state.clubTo === '' ? _this2.state.clubFrom.padStart(3, '0') : _this2.state.clubTo });else if (/^[0-9]{3}$/.test(_this2.state.clubFrom) && _this2.state.clubTo === '') _this2.setState({ clubTo: _this2.state.clubFrom });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'clubTo' },
                                        'Til forening'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'clubTo', id: 'clubTo', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.clubTo,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[3].setState({ focused: false, visited: true });
                                            if (/^[0-9]{1,2}$/.test(_this2.state.clubTo)) _this2.setState({ clubTo: _this2.state.clubTo.padStart(3, '0') });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                )
                            ) : null,
                            this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? _react2.default.createElement(
                                'tr',
                                { className: 'separator' },
                                _react2.default.createElement('td', { colSpan: 2 })
                            ) : null,
                            _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'weekFrom' },
                                        'Fra uge'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'weekFrom', id: 'weekFrom', value: this.state.weekFrom,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'weekTo' },
                                        'Til uge'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 field100', containerClassName: 'display-inline-block',
                                        name: 'weekTo', id: 'weekTo', value: this.state.weekTo,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SeasonPrices;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonPrices);

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = {
    listType: 0,
    fromSection: '',
    toSection: '',
    championshipNo: '',
    rank: '',
    week: '',
    colourCode: '',
    signature: false,
    sortByGender: false,
    sortBySection: false,
    areaWinners: false
};

var SeasonDiplomas = function (_React$Component) {
    _inherits(SeasonDiplomas, _React$Component);

    function SeasonDiplomas(props) {
        _classCallCheck(this, SeasonDiplomas);

        var _this = _possibleConstructorReturn(this, (SeasonDiplomas.__proto__ || Object.getPrototypeOf(SeasonDiplomas)).call(this, props));

        _this.fields = [];

        _this.onDigitInputFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeNonDigits)(e.target.value)));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getReportOptions = function () {
            var errors = [];
            var isValid = _this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg.');
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }

            if (_this.state.fromSection !== '' && _this.state.toSection !== '' && _this.state.fromSection > _this.state.toSection) errors.push('Fra sektion kan ikke v\xE6re st\xF8rre end Til sektion.');

            var options = {
                listType: _this.state.listType,
                fromSection: _this.state.fromSection === '' ? null : _this.state.fromSection,
                toSection: _this.state.toSection === '' ? null : _this.state.toSection,
                championshipNo: _this.state.listType > 1 ? null : _this.state.championshipNo,
                rank: _this.state.listType > 1 || _this.state.rank === '' ? null : _this.state.rank,
                signature: _this.state.signature,
                week: _this.state.listType <= 1 || _this.state.week === '' ? null : _this.state.week,
                colourCode: _this.state.listType <= 1 || _this.state.colourCode === '' ? null : _this.state.colourCode,
                sortByGender: _this.state.listType === 1 ? _this.state.sortByGender : null,
                sortBySection: _this.state.listType === 1 ? _this.state.sortBySection : null,
                areaWinners: _this.state.listType === 2 ? _this.state.areaWinners : null
            };
            return {
                errors: errors,
                options: options
            };
        };

        _this.state = defaultState;
        return _this;
    }

    _createClass(SeasonDiplomas, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, snapshot) {
            //if(this.state.listType !== prevState.listType) {
            //    this.setState(Object.assign(defaultState, {listType: this.state.listType}))
            //}
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'season-diplomas' },
                _react2.default.createElement(
                    'div',
                    { className: 'upper-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'radio-buttons-container column-gap' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'championships', type: 'radio', checked: this.state.listType === 0, onChange: function onChange() {
                                    return _this2.setState({ listType: 0 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'championships' },
                                'Mesterskaber'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'pigeon-championships', type: 'radio', checked: this.state.listType === 1, onChange: function onChange() {
                                    return _this2.setState({ listType: 1 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'pigeon-championships' },
                                'ES-due'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'race-winners', type: 'radio', checked: this.state.listType === 2, onChange: function onChange() {
                                    return _this2.setState({ listType: 2 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race-winners' },
                                this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? 'Sektionsvindere' : this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'Foreningsvindere' : 'Område/sektionsvindere'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'div',
                            { className: 'radio-button-container' },
                            _react2.default.createElement('input', { id: 'region-winners', type: 'radio', checked: this.state.listType === 3, onChange: function onChange() {
                                    return _this2.setState({ listType: 3 });
                                } }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'region-winners' },
                                'Regionsvindere'
                            )
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-fields' },
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'div',
                            { className: 'attribute-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair left-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Fra sektion'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 very-small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'fromSection',
                                    id: 'fromSection',
                                    maxLength: '2',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                    value: this.state.fromSection,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair right-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    'Til sektion'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 very-small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'toSection',
                                    id: 'toSection',
                                    maxLength: '2',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                    value: this.state.toSection,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                })
                            )
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'attribute-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair left-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    this.state.listType > 1 ? 'Uge' : 'Mesterskabskode'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 very-small-field',
                                    containerClassName: 'display-inline-block',
                                    name: this.state.listType > 1 ? 'week' : 'championshipNo',
                                    id: this.state.listType > 1 ? 'week' : 'championshipNo',
                                    maxLength: this.state.listType > 1 ? 2 : 3,
                                    required: this.state.listType > 1 ? false : true,
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{' + (this.state.listType > 1 ? '0,2' : 3) + '}' }],
                                    value: this.state.listType > 1 ? this.state.week : this.state.championshipNo,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[2].setState({ focused: false, visited: true });
                                        if (_this2.state.listType <= 1) {
                                            if (/^[0-9]{1,2}$/.test(_this2.state.championshipNo)) _this2.setState({ championshipNo: _this2.state.championshipNo.padStart(3, '0') });
                                        }
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'attribute-pair right-pair' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    this.state.listType > 1 ? 'Farvekode' : 'Placering'
                                ),
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 very-small-field',
                                    containerClassName: 'display-inline-block',
                                    name: this.state.listType > 1 ? 'colourCode' : 'rank',
                                    id: this.state.listType > 1 ? 'colourCode' : 'rank',
                                    maxLength: this.state.listType > 1 ? 2 : 3,
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: '[0-9]{' + (this.state.listType > 1 ? 2 : '1,3') + '}' }],
                                    value: this.state.listType > 1 ? this.state.colourCode : this.state.rank,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onDigitInputFieldChange,
                                    onBlur: function onBlur() {
                                        _this2.fields[3].setState({ focused: false, visited: true });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'lower-container options-group' },
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { id: 'signature', name: 'signature', type: 'checkbox', checked: this.state.signature, onClick: function onClick(e) {
                                return _this2.setState({ signature: !_this2.state.signature });
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'signature' },
                            'Vis signatur'
                        )
                    ) : null,
                    this.state.listType === 1 ? [_react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { id: 'sortByGender', name: 'sortByGender', type: 'checkbox', checked: this.state.sortByGender,
                            onClick: function onClick(e) {
                                return _this2.setState({ sortByGender: !_this2.state.sortByGender });
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'sortByGender' },
                            'Udskriv k\xF8nsvist'
                        )
                    ), this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { id: 'sortBySection', name: 'sortBySection', type: 'checkbox', checked: this.state.sortBySection,
                            onClick: function onClick(e) {
                                return _this2.setState({ sortBySection: !_this2.state.sortBySection });
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'sortBySection' },
                            'Udskriv sektionsvist'
                        )
                    ) : null] : null,
                    this.state.listType === 2 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { id: 'areaWinners', name: 'areaWinners', type: 'checkbox', checked: this.state.areaWinners,
                            onClick: function onClick(e) {
                                return _this2.setState({ areaWinners: !_this2.state.areaWinners });
                            } }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'areaWinners' },
                            'Vis omr\xE5devindere'
                        )
                    ) : null
                )
            );
        }
    }]);

    return SeasonDiplomas;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SeasonDiplomas);

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _client = __webpack_require__(78);

var _client2 = _interopRequireDefault(_client);

var _reactRedux = __webpack_require__(3);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

var _routeconstants = __webpack_require__(11);

var _reactRouterRedux = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignInPage = function (_React$Component) {
    _inherits(SignInPage, _React$Component);

    _createClass(SignInPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_SIGNIN;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return []; // empty means allowed for all
        }
    }]);

    function SignInPage(props) {
        _classCallCheck(this, SignInPage);

        var _this = _possibleConstructorReturn(this, (SignInPage.__proto__ || Object.getPrototypeOf(SignInPage)).call(this, props));

        _this.onUsernameChanged = function (e) {
            _this.setState({
                username: e.target.value,
                showInvalidCredentialsWarning: false
            });
        };

        _this.onPasswordChanged = function (e) {
            _this.setState({
                password: e.target.value,
                showInvalidCredentialsWarning: false
            });
        };

        _this.changeMode = function (e) {
            e.preventDefault();
            _this.setState({
                forgotPasswordMode: !_this.state.forgotPasswordMode,
                showInvalidCredentialsWarning: false
            });
        };

        _this.login = function (e) {
            e.preventDefault();

            var dispatch = _this.props.dispatch;

            var username = _this.state.username.trim();
            var password = _this.state.password.trim();

            var redirectRoute = void 0;
            if (_this.props.location.query && _this.props.location.query.next) {
                redirectRoute = _this.props.location.query.next;
            } else {
                redirectRoute = '/';
            }
            dispatch(AuthActions.loginUser(username, password, redirectRoute, _this.onInvalidCredentials));
        };

        _this.resetPassword = function (e) {
            e.preventDefault();

            var dispatch = _this.props.dispatch;

            var username = _this.state.username.trim();

            dispatch(AuthActions.requestPasswordReset(username, function (email) {
                _this.setState({ forgotPasswordMode: false, passwordResetMailSent: true, passwordResetEmail: email, password: "" });
                _reactNotifications.NotificationManager.success("Your can now be reset.", "Email send", 4000);
            }));
        };

        _this.onInvalidCredentials = function () {
            _this.setState({ showInvalidCredentialsWarning: true });
        };

        _this.state = {
            username: props.user.username ? props.user.username : "", // fill up username if the user was redirected here after sign up
            password: "",
            forgotPasswordMode: false,
            passwordResetMailSent: false,
            passwordResetEmail: "", // The e-mail address the password reset mail was sent to
            showInvalidCredentialsWarning: false
        };
        return _this;
    }

    _createClass(SignInPage, [{
        key: 'render',
        value: function render() {

            var invalidCredentialsWarning = !this.state.showInvalidCredentialsWarning ? "" : _react2.default.createElement(
                'div',
                { style: { color: "red", marginTop: "10px" } },
                'Wrong user name or password.'
            );

            var submitButtonDisabled = this.state.username == "";

            var passwordResetMailInfoHtml = this.state.passwordResetMailSent ? _react2.default.createElement(
                'div',
                { style: { marginTop: "10px" } },
                'You can now reset your password. An email has been send to ',
                _react2.default.createElement(
                    'b',
                    null,
                    this.state.passwordResetEmail
                ),
                ' containing a link you can use to reset your password. The link will be functional for half an hour.'
            ) : "";

            var titleText = this.state.forgotPasswordMode ? "Reset password" : "Login";
            var submitButtonText = this.state.forgotPasswordMode ? "Send mail" : "Log in";
            var changeModeButtonText = this.state.forgotPasswordMode ? "Back" : "Forgotten your password?";
            var hidePasswordFieldStyle = this.state.forgotPasswordMode ? { visibility: "hidden" } : {};

            // TODO: Remove fake login buttons.
            return _react2.default.createElement(
                'div',
                { className: 'signin-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signin-button' },
                        _react2.default.createElement(
                            'button',
                            { onClick: function onClick(event) {
                                    event.preventDefault();
                                    window.location = '/login/drupal';
                                }, className: 'btn-primary', type: 'submit' },
                            'Log p\xE5'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'signin-message' },
                        this.props.auth.isAuthenticated && !this.props.auth.isMainAdmin && !this.props.auth.isClubAdmin ? _react2.default.createElement(
                            'p',
                            null,
                            'Du er logget p\xE5 som ',
                            _react2.default.createElement(
                                'b',
                                null,
                                this.props.auth.displayName
                            ),
                            ', men er hverken oprettet som foreningsadministrator, sektionsadministrator eller hovedadministrator.'
                        ) : null
                    )
                )
            );
            /*return (
                <div className="signin-page">
                    <div className="page-title">
                        <h1>{titleText}</h1>
                    </div>
                    <div className="page-content">
                        <form className="user-form">
                            <div className="content-box editor-container">
                                <div className="sub-container">
                                    <div className="field-row">
                                        <label htmlFor="username">User name</label>
                                        <div><input className="field-1" type="text" id="username" placeholder="Enter email" value={this.state.username} onChange={this.onUsernameChanged} /></div>
                                    </div>
                                    <div className="field-row" style={hidePasswordFieldStyle}>
                                        <label htmlFor="password">Password</label>
                                        <div><input className="field-1" type="password" id="password" placeholder="Enter password" value={this.state.password} onChange={this.onPasswordChanged} /></div>
                                    </div>
                                </div>
                                 <div>
                                    <button type="button" className="btn-transparent" onClick={this.changeMode}>
                                        {changeModeButtonText}
                                    </button>
                                    <button type="submit" className="btn-primary btn-login" disabled={submitButtonDisabled} onClick={this.state.forgotPasswordMode ? this.resetPassword : this.login}>
                                        {submitButtonText}
                                    </button>
                                </div>
                                 {invalidCredentialsWarning}
                                 <div style={{clear:"both"}} />
                                 {passwordResetMailInfoHtml}
                                 <p>
                                    Not yes a member? <Link to={ROUTE_SIGNUP}>Register here</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            );*/
        }
    }]);

    return SignInPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isAuthenticated: state.auth.isAuthenticated,
            isAuthenticating: state.auth.isAuthenticating,
            statusText: state.auth.statusText,
            displayName: state.auth.displayName,
            isMainAdmin: state.auth.isMainAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.displayName
        },
        user: {
            username: state.user.username
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SignInPage);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _ProfileForm = __webpack_require__(163);

var _ProfileForm2 = _interopRequireDefault(_ProfileForm);

var _user = __webpack_require__(98);

var UserActions = _interopRequireWildcard(_user);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignUpPage = function (_React$Component) {
    _inherits(SignUpPage, _React$Component);

    function SignUpPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignUpPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpPage.__proto__ || Object.getPrototypeOf(SignUpPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (userProfile) {
            if (_this.props.user.isSaving) return;
            var onSuccess = function onSuccess() {
                return _reactNotifications.NotificationManager.success("Thanks for registering.", "Registration completed", 4000);
            };
            _this.props.dispatch(UserActions.userCreate(userProfile, onSuccess));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignUpPage, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'signup-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Create profile'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(_ProfileForm2.default, { profile: null, onSubmit: this.handleSubmit, submitButtonText: 'Register', params: this.props.location.query })
                )
            );
        }
    }], [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_SIGNUP;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return []; // empty means allowed for all
        }
    }]);

    return SignUpPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.user
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SignUpPage);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var base64StringToByteSize = exports.base64StringToByteSize = function base64StringToByteSize(base64) {
    return 3 * Math.ceil(base64.length / 4); // 4 base64-chars = 3 bytes.  (each base64-char is 6 bits, each byte is 8 bits)
};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _Avatar = __webpack_require__(380);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _user = __webpack_require__(98);

var UserActions = _interopRequireWildcard(_user);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfilePage = function (_React$Component) {
    _inherits(ProfilePage, _React$Component);

    _createClass(ProfilePage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_PROFILE;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            //return [UserRoles.USER, UserRoles.ADMIN];
            return []; // empty means allowed for all
        }
    }]);

    function ProfilePage(props) {
        _classCallCheck(this, ProfilePage);

        var _this = _possibleConstructorReturn(this, (ProfilePage.__proto__ || Object.getPrototypeOf(ProfilePage)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            user: null
        };
        return _this;
    }

    _createClass(ProfilePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadUser(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.userId !== this.props.params.userId) this.loadUser(nextProps);else {
                var userId = this.getUserId(nextProps);
                var user = nextProps.user.users.get(userId);
                if (user) this.setState({ user: user });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var user = this.state.user;
            return _react2.default.createElement(
                'div',
                { className: 'user-profile-page' },
                user ? [_react2.default.createElement(
                    'div',
                    { className: 'sub-page-title', key: 'title' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'User profile'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'actions' },
                        user.id === this.props.auth.userId || this.props.auth.roleId & _UserRoles2.default.ADMIN.id ? _react2.default.createElement(
                            'button',
                            { type: 'submit', className: 'btn-primary', onClick: function onClick(e) {
                                    e.preventDefault();
                                    if (user.id == _this2.props.auth.userId) _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_EDIT_PROFILE_CURRENT));else _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_EDIT_PROFILE.replace(":userId", user.id)));
                                } },
                            'Edit'
                        ) : ''
                    )
                ), _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content', key: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'column half-width' },
                        _react2.default.createElement(
                            'p',
                            null,
                            user.firstName + ' ' + user.lastName
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'Email: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:' + user.email },
                                user.email
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'column half-width' },
                        _react2.default.createElement(_Avatar2.default, { userId: user.id, size: 'big', link: false })
                    )
                )] : ''
            );
        }
    }]);

    return ProfilePage;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.loadUser = function (props) {
        var userId = _this3.getUserId(props);
        var user = _this3.props.user.users.get(userId);
        if (!user) {
            _this3.props.dispatch(UserActions.getUser(userId, _this3.props.auth.roleId & _UserRoles2.default.ADMIN.id));
            _this3.setState({ user: null });
        } else _this3.setState({ user: user });
    };

    this.getUserId = function (newestProps) {
        var userId = Number(newestProps.params.userId) || newestProps.auth.userId || null;
        if (userId === null) console.error("user not detected"); // should never happen during normal flow (maybe redirect to login-page in that case?)
        return userId;
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: {
            users: state.user.users
        },
        auth: state.auth
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProfilePage);

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _routeconstants = __webpack_require__(11);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

var _user = __webpack_require__(98);

var UserActions = _interopRequireWildcard(_user);

var _system = __webpack_require__(384);

var SystemActions = _interopRequireWildcard(_system);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactNotifications = __webpack_require__(8);

var _ProfileForm = __webpack_require__(163);

var _ProfileForm2 = _interopRequireDefault(_ProfileForm);

var _reactRouterRedux = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditProfilePage = function (_React$Component) {
    _inherits(EditProfilePage, _React$Component);

    _createClass(EditProfilePage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_EDIT_PROFILE;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [];
        }
    }]);

    function EditProfilePage(props) {
        _classCallCheck(this, EditProfilePage);

        var _this = _possibleConstructorReturn(this, (EditProfilePage.__proto__ || Object.getPrototypeOf(EditProfilePage)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            user: null
        };
        return _this;
    }

    _createClass(EditProfilePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadUser(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.userId !== this.props.params.userId) this.loadUser(nextProps);else {
                var userId = this.getUserId(nextProps);
                var user = nextProps.user.users.get(userId);
                if (user && typeof user.photo != 'undefined') this.setState({ user: user });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var user = this.state.user;
            return _react2.default.createElement(
                'div',
                { className: 'edit-user-profile-page' },
                user ? [_react2.default.createElement(
                    'div',
                    { className: 'sub-page-title', key: 'title' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Edit profile'
                    )
                ), _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content', key: 'content' },
                    user.id === this.props.auth.userId || this.props.auth.roleId & _UserRoles2.default.ADMIN.id ? _react2.default.createElement(_ProfileForm2.default, { profile: user, onSubmit: this.handleSubmit, submitButtonText: 'Save',
                        params: this.props.location.query }) : _react2.default.createElement(
                        'div',
                        { className: 'page-error' },
                        'No access'
                    )
                )] : ''
            );
        }
    }]);

    return EditProfilePage;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.loadUser = function (props) {
        var userId = _this2.getUserId(props);
        var user = _this2.props.user.users.get(userId);
        if (!user || typeof user.photo == 'undefined') {
            _this2.props.dispatch(UserActions.getUser(userId, true));
            _this2.setState({ user: null });
        } else _this2.setState({ user: user });
    };

    this.handleSubmit = function (userProfile) {
        if (_this2.props.user.isSaving) return;
        var userId = _this2.getUserId(_this2.props);
        var onSuccess = function onSuccess() {
            if (userId === _this2.props.auth.userId) _reactNotifications.NotificationManager.success("Your profile has been updated.", "Profile updated", 4000);else _reactNotifications.NotificationManager.success("The user has been updated.", "User updated", 4000);
            _this2.props.dispatch(SystemActions.updateImageCacheBreakerValue());
            if (userId == _this2.props.auth.userId) _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_PROFILE_CURRENT));else _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_PROFILE.replace(":userId", userId)));
        };
        if (userId === _this2.props.auth.userId) _this2.props.dispatch(AuthActions.updateProfile(userProfile, onSuccess));else _this2.props.dispatch(UserActions.updateUser(userId, userProfile, onSuccess));
    };

    this.getUserId = function (newestProps) {
        var userId = Number(newestProps.params.userId) || newestProps.auth.userId || null;
        if (userId === null) console.error("user not detected"); // should never happen during normal flow (maybe redirect to login-page in that case?)
        return userId;
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: {
            users: state.user.users,
            isSaving: state.user.isSaving
        },
        auth: state.auth
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditProfilePage);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactNotifications = __webpack_require__(8);

var _routeconstants = __webpack_require__(11);

var _ProfileForm = __webpack_require__(163);

var _ProfileForm2 = _interopRequireDefault(_ProfileForm);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordPage = function (_React$Component) {
    _inherits(ResetPasswordPage, _React$Component);

    function ResetPasswordPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ResetPasswordPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordPage.__proto__ || Object.getPrototypeOf(ResetPasswordPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (newPassword) {
            var userId = Number(_this.props.location.query.u);
            var resetCode = _this.props.location.query.c;

            _this.props.dispatch(AuthActions.resetPassword({
                userId: userId,
                resetCode: resetCode,
                newPassword: newPassword
            }, function () {
                _reactNotifications.NotificationManager.success("Your password has been reset.", "Password reset", 4000);
                //dispatch(push('/signin'));
            }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ResetPasswordPage, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'reset-password-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title', key: 'title' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Reset password'
                    )
                ),
                ',',
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content', key: 'content' },
                    _react2.default.createElement(_ProfileForm2.default, { profile: null, resetPassword: true, onSubmit: this.handleSubmit, submitButtonText: 'Reset password',
                        params: this.props.location.query })
                )
            );
        }
    }], [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_RESET_PASSWORD;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return []; // empty means allowed for all
        }
    }]);

    return ResetPasswordPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResetPasswordPage);

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _lib = __webpack_require__(18);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClubsPage = function (_React$Component) {
    _inherits(ClubsPage, _React$Component);

    _createClass(ClubsPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_CLUBS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function ClubsPage(props) {
        _classCallCheck(this, ClubsPage);

        var _this = _possibleConstructorReturn(this, (ClubsPage.__proto__ || Object.getPrototypeOf(ClubsPage)).call(this, props));

        _this.timeoutHandler = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.state = {
            filter: '',
            showInactive: 0,
            sort: 'Foreningsnr'
        };
        return _this;
    }

    _createClass(ClubsPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getClubs());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.admin.isClubsRead ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Foreninger'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Foreningsnr' });
                                        } },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Sektionsnr' });
                                        } },
                                    'Sektion'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Navn' });
                                        } },
                                    'Navn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Kommune'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.admin.clubs.sort(function (c1, c2) {
                                return c1.Foreningsnr < c2.Foreningsnr ? -1 : 1;
                            }).filter(function (c) {
                                return (_this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr !== '99' && (_this2.state.showInactive || c.Sektionsnr === _this2.props.auth.currentEntity) || _this2.props.auth.currentRole !== _UserRoles2.default.SECTION_ADMIN.id && (_this2.state.showInactive || c.Sektionsnr !== '99')) && (_this2.state.filter === '' || (0, _lib.nullToBlank)(c.Foreningsnr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(c.Sektionsnr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(c.Navn).toUpperCase().search(_this2.state.filter) >= 0);
                            }).sort(function (c1, c2) {
                                var comp = (c1[_this2.state.sort] === null ? '' : c1[_this2.state.sort].trim()).localeCompare(c2[_this2.state.sort] === null ? '' : c2[_this2.state.sort].trim(), 'da-DK');
                                return comp === 0 ? c1.Foreningsnr < c2.Foreningsnr ? -1 : 1 : comp;
                            }).toArray().map(function (club) {
                                var updates = club.UpdateRequests.find(function (update) {
                                    return update.type === 'club';
                                }) || null;
                                return _react2.default.createElement(
                                    'tr',
                                    { key: club.Foreningsnr, className: updates === null ? club.UpdateRequests.length > 0 ? 'updated' : '' : updates.key === null ? 'new' : updates.deleted ? 'deleted' : 'updated', onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        club.Foreningsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        club.Sektionsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        club.Navn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        club.Kommune
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'edit') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Rediger forening' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash pointer" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? ' clickable' : ' disabled'), title: 'Slet forening', disabled: _this2.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id, onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) {
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette forening ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            club.Foreningsnr,
                                                            ' (',
                                                            club.Navn,
                                                            ')'
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deleteClub(club.Foreningsnr, function () {
                                                            _reactNotifications.NotificationManager.success("Forening " + club.Foreningsnr + " (" + club.Navn + ") er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                }
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { className: "btn-primary" + (this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? '' : ' disabled'), to: this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _routeconstants.ROUTE_CLUB.replace(':clubNo', 'new').replace(':subpage', 'general').replace(':mode', 'create') : '', title: 'Opret ny forening' },
                        'Ny'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'filter' },
                        'Filter'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast s\xF8gev\xE6rdi', className: 'field-1 large-field',
                        name: 'filter', id: 'filter',
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value.toUpperCase();
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                _this2.setState({ filter: val });
                            }, 500);
                        }
                    }),
                    _react2.default.createElement('input', { id: 'showInactive', name: 'showInactive', type: 'checkbox', checked: this.state.showInactive, onChange: function onChange(e) {
                            _this2.setState({ showInactive: e.target.checked ? -1 : 0 });
                        } }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'showInactive' },
                        this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? "Vis alle" : "Vis inaktive"
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort' },
                        'Sortering'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field-1 large-field',
                        name: 'sort', id: 'sort', value: this.state.sort, options: [{ key: 'Foreningsnr', value: 'Foreningsnr' }, { key: 'Sektionsnr', value: 'Sektionsnr' }, { key: 'Navn', value: 'Navn' }],
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: this.onStandardFieldChange
                    }),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn-primary', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id, title: 'S\xE6t junior/pensionist-markeringer automatisk fra medlem(er) for alle foreninger', onClick: function onClick() {
                                (0, _confirmDialog.confirm)("Opdater junior/pensionist", _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xD8nsker du at opdatere junior/pensionist-markeringer for alle slag i ',
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'alle'
                                    ),
                                    ' foreninger p\xE5 basis af medlemsregistreringer?'
                                ), function () {
                                    _this2.props.dispatch(AdminActions.setJuniorPensioner(function () {
                                        _reactNotifications.NotificationManager.success("Junior/pensionist-markeringer er opdateret for alle slag.", "Opdatering", 4000);
                                    }));
                                });
                            } },
                        'S\xE6t junior/pensionist-markeringer'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn-primary', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id, title: 'Nulstil begyndermarkeringer for alle foreninger', onClick: function onClick() {
                                (0, _confirmDialog.confirm)("Nulstil begynder", _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xD8nsker du at nulstille begyndermarkeringer for alle slag i ',
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'alle'
                                    ),
                                    ' foreninger?'
                                ), function () {
                                    _this2.props.dispatch(AdminActions.resetBeginners(function () {
                                        _reactNotifications.NotificationManager.success("Alle begyndermarkeringer er nulkstillet.", "Opdatering", 4000);
                                    }));
                                });
                            } },
                        'Nulstil begyndermarkeringer'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn-primary', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id, title: 'Nulstil alle markeringer for adresse\xE6ndring og tilmelding', onClick: function onClick() {
                                (0, _confirmDialog.confirm)("Nulstil markeringer", _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xD8nsker du at nulstille alle markeringer for adresse\xE6ndring og tilmelding?'
                                ), function () {
                                    _this2.props.dispatch(AdminActions.resetUpdateMarkings(function () {
                                        _reactNotifications.NotificationManager.success("Alle ændringsmarkeringer er fjernet.", "Opdatering", 4000);
                                    }));
                                });
                            } },
                        'Nulstil \xE6ndringsmarkeringer'
                    )
                )
            ) : null;
        }
    }]);

    return ClubsPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isClubsRead: state.admin.isClubsRead,
            clubs: state.admin.clubs
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClubsPage);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _ClubGeneral = __webpack_require__(786);

var _ClubGeneral2 = _interopRequireDefault(_ClubGeneral);

var _ClubContacts = __webpack_require__(790);

var _ClubContacts2 = _interopRequireDefault(_ClubContacts);

var _StationSelection = __webpack_require__(386);

var _StationSelection2 = _interopRequireDefault(_StationSelection);

var _Util = __webpack_require__(62);

var _arrayUtil = __webpack_require__(387);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClubPage = function (_React$Component) {
    _inherits(ClubPage, _React$Component);

    _createClass(ClubPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_CLUB;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function ClubPage(props) {
        _classCallCheck(this, ClubPage);

        var _this = _possibleConstructorReturn(this, (ClubPage.__proto__ || Object.getPrototypeOf(ClubPage)).call(this, props));

        _this.loadClub = function (newestProps) {
            if (newestProps.params.clubNo.toLowerCase() !== 'new') newestProps.dispatch(AdminActions.getClub(newestProps.params.clubNo, function () {
                _this.forceUpdate();
            }));
        };

        _this.subForm = null;
        _this.fields = [];

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.saveRingSerie = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Medlemsnr: _this.state.ringMedlemsnr,
                    Foreningsnr: _this.state.ringForeningsnr,
                    Aar: _this.state.ringAar,
                    Fra: _this.state.ringFra,
                    Til: _this.state.ringTil,
                    Supplerende: _this.state.ringSupplerende ? 'X' : null
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createRingSerie(_this.props.params.clubNo, entity, function (series) {
                    var serieIx = series.findIndex(function (serie) {
                        return serie.Aar === entity.Aar && serie.Medlemsnr === entity.Medlemsnr && serie.Fra === entity.Fra && serie.Til === entity.Til;
                    });
                    _reactNotifications.NotificationManager.success("Ringserien er oprettet.", "Oprettelse", 4000);
                    _this.setState({ editId: null });
                    if (serieIx >= 0) setTimeout(function () {
                        var currentRow = document.getElementById("row-" + series[serieIx].Nr);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateRingSerie(_this.props.params.clubNo, _this.state.editId, entity, function (series) {
                    var serieIx = series.findIndex(function (serie) {
                        return serie.Aar === entity.Aar && serie.Medlemsnr === entity.Medlemsnr && serie.Fra === entity.Fra && serie.Til === entity.Til;
                    });
                    _reactNotifications.NotificationManager.success("Ringserien er opdateret.", "Opdatering", 4000);
                    _this.setState({ editId: null });
                    if (serieIx >= 0) setTimeout(function () {
                        var currentRow = document.getElementById("row-" + series[serieIx].Nr);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        var now = new Date();
        var yrFull = (now.getFullYear() + (now.getMonth() >= 9 ? 1 : 0)).toString();
        _this.state = {
            ringYear: yrFull.substr(yrFull.length - 2),
            editId: null
        };
        return _this;
    }

    _createClass(ClubPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadClub(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.clubNo !== this.props.params.clubNo) this.loadClub(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var disabled = this.props.params.subpage === 'ring-series' && this.state.editId !== null;

            // Get club from Redux state.
            var clubNo = this.props.params.clubNo;
            var club = clubNo.toLowerCase() === 'new' || !this.props.admin.clubs ? null : this.props.admin.clubs.get(clubNo) || null;
            if (clubNo.toLowerCase() !== 'new' && (club === null || typeof club.isFullLoaded === 'undefined')) return null;

            if (!(this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentEntity === this.props.params.clubNo)) return _react2.default.createElement(
                'div',
                { className: 'unauthorized' },
                'Du har ingen rettigheder til denne side'
            );

            var now = new Date();
            var mth = now.getMonth();
            var yr = (now.getFullYear() + (mth >= 9 ? 1 : 0)).toString();
            var openYear = mth <= 1 || mth >= 9 ? yr.substr(yr.length - 2) : "";

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_ClubGeneral2.default, { club: club, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case "contacts":
                    subPage = _react2.default.createElement(_ClubContacts2.default, { club: club, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'members':
                    subPage = _react2.default.createElement(
                        'table',
                        { className: 'data-table pigeon-members-list' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row' },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Fornavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Efternavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Slag'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Telefon'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Email'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            club === null ? [] : this.props.admin.members.filter(function (member) {
                                return member.Foreningsnr === clubNo;
                            }).sort(function (m1, m2) {
                                return m1.Medlemsnr < m2.Medlemsnr ? -1 : 1;
                            }).toArray().map(function (member) {
                                var updates = club === null ? null : club.UpdateRequests.find(function (update) {
                                    return update.type === 'member' && update.key === member.Medlemsnr;
                                }) || null;
                                return _react2.default.createElement(
                                    'tr',
                                    { key: member.Medlemsnr, className: updates === null ? '' : updates.key === null ? 'new' : updates.deleted ? 'deleted' : 'updated', onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        member.Medlemsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member.Fornavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member.Efternavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member.Slagnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member.Tlf === null ? null : _react2.default.createElement(
                                            'a',
                                            { href: 'tel:' + member.Tlf },
                                            member.Tlf
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member.Email === null ? null : _react2.default.createElement(
                                            'a',
                                            { href: 'mailto:' + member.Email },
                                            member.Email
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'edit') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Rediger medlem' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? ' clickable' : ' disabled'), title: 'Slet medlem', onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr) {
                                                    var fname = member.Fornavn === null ? '' : member.Fornavn;
                                                    var lname = member.Efternavn === null ? '' : member.Efternavn;
                                                    var name = fname + (fname !== '' && lname !== '' ? ' ' : '') + lname;
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette medlem ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            member.Medlemsnr + (name === '' ? '' : " (" + name + ")")
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deleteMember(clubNo, member.Medlemsnr, function () {
                                                            _reactNotifications.NotificationManager.success("Medlem " + member.Medlemsnr + (name === '' ? '' : " (" + name + ")") + " er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                }
                                            } })
                                    )
                                );
                            }),
                            club === null ? [] : club.UpdateRequests.filter(function (req) {
                                return req.type === 'member' && req.key === null;
                            }).sort(function (m1, m2) {
                                return m1.newKey < m2.newKey ? -1 : 1;
                            }).map(function (newMember, ix) {
                                var member = JSON.parse(newMember.updates);
                                return _react2.default.createElement(
                                    'tr',
                                    { key: 'n' + ix, className: 'new' },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        member.Medlemsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof member.Fornavn === 'undefined' ? null : member.Fornavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof member.Efternavn === 'undefined' ? null : member.Efternavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof member.Slagnr === 'undefined' ? null : member.Slagnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof member.Tlf === 'undefined' || member.Tlf === null ? null : _react2.default.createElement(
                                            'a',
                                            { href: 'tel:' + member.Tlf },
                                            member.Tlf
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof member.Email === 'undefined' || member.Email === null ? null : _react2.default.createElement(
                                            'a',
                                            { href: 'mailto:' + member.Email },
                                            member.Email
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', 'new' + newMember.newKey).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', 'new' + newMember.newKey).replace(':subpage', 'general').replace(':mode', 'edit') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Rediger medlem' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? ' clickable' : ' disabled'), title: 'Slet medlem', disabled: _this2.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id, onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr) {
                                                    var fname = typeof member.Fornavn === 'undefined' || member.Fornavn === null ? '' : member.Fornavn;
                                                    var lname = typeof member.Efternavn === 'undefined' || member.Efternavn === null ? '' : member.Efternavn;
                                                    var name = fname + (fname !== '' && lname !== '' ? ' ' : '') + lname;
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette medlem',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            name === '' ? '' : ' ' + name
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deleteMember(clubNo, 'new' + newMember.newKey, function () {
                                                            _reactNotifications.NotificationManager.success("Medlem " + (name === '' ? '' : name + ' ') + "er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                }
                                            } })
                                    )
                                );
                            })
                        )
                    );
                    break;

                case 'pigeon-holes':
                    subPage = _react2.default.createElement(
                        'table',
                        { className: 'data-table pigeon-holes-list' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row' },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Slagnavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Medlem'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Omr\xE5de'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Lag'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'CHR'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Markeringer'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            club === null ? [] : this.props.admin.pigeonHoles.filter(function (hole) {
                                return hole.Foreningsnr === clubNo;
                            }).sort(function (s1, s2) {
                                return s1.Slagnr < s2.Slagnr ? -1 : 1;
                            }).toArray().map(function (hole) {
                                var updates = club.UpdateRequests.find(function (update) {
                                    return update.type === 'pigeonhole' && update.key === hole.Slagnr;
                                }) || null;
                                var oldMembers = _this2.props.admin.members.filter(function (member) {
                                    return member.Foreningsnr === clubNo && member.Slagnr === hole.Slagnr;
                                }).toArray();
                                var newMembers = club.UpdateRequests.filter(function (req) {
                                    if (req.type !== 'member' || req.newKey === null) return false;
                                    var values = req.updates === null ? {} : JSON.parse(req.updates);
                                    return typeof values.Slagnr !== 'undefined' && values.Slagnr === hole.Slagnr && (typeof values.Fornavn !== 'undefined' && values.Fornavn !== null || typeof values.Efternavn !== 'undefined' && values.Efternavn !== null);
                                }).map(function (member) {
                                    return JSON.parse(member.updates);
                                });
                                var members = (0, _arrayUtil.flatten)(oldMembers.map(function (member, ix) {
                                    return [_react2.default.createElement(
                                        'span',
                                        { className: 'list-item existing-item', key: 'o' + ix },
                                        member.Medlemsnr + (member.Fornavn === null && member.Efternavn === null ? '' : ' ') + member.Fornavn + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + member.Efternavn
                                    ), _react2.default.createElement(
                                        'span',
                                        { className: 'list-item-separator', key: 'os' + ix },
                                        ', '
                                    )];
                                }).concat(newMembers.map(function (member, ix) {
                                    return [_react2.default.createElement(
                                        'span',
                                        { className: 'list-item new-item', key: 'n' + ix },
                                        (typeof member.Fornavn === 'undefined' ? '' : member.Fornavn) + (typeof member.Fornavn === 'undefined' || typeof member.Efternavn === 'undefined' || member.Fornavn === null || member.Efternavn === null ? '' : ' ') + (typeof member.Efternavn === 'undefined' ? '' : member.Efternavn)
                                    ), _react2.default.createElement(
                                        'span',
                                        { className: 'list-item-separator', key: 'ns' + ix },
                                        ', '
                                    )];
                                })));
                                if (members.length > 0) members.splice(members.length - 1, 1);
                                return _react2.default.createElement(
                                    'tr',
                                    { key: hole.Slagnr, className: updates === null ? '' : updates.key === null ? 'new' : updates.deleted ? 'deleted' : 'updated', onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', hole.Slagnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        hole.Slagnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        hole.Slagnavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        members
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        hole.Omraadenr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        hole.LagMellem
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        hole.CHR
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        hole.Markering1,
                                        hole.Markering2
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', hole.Slagnr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', hole.Slagnr).replace(':subpage', 'general').replace(':mode', 'edit') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Rediger slag' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? ' clickable' : ' disabled'), title: 'Slet slag', disabled: _this2.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && (_this2.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentEntity !== club.Foreningsnr), onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr) {
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette slag ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            hole.Slagnr + (hole.Slagnavn === null ? '' : " (" + hole.Slagnavn + ")")
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deletePigeonHole(clubNo, hole.Slagnr, function () {
                                                            _reactNotifications.NotificationManager.success("Slag " + hole.Slagnr + (hole.Slagnavn === null ? '' : " (" + hole.Slagnavn + ")") + " er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                }
                                            } })
                                    )
                                );
                            }),
                            club === null ? [] : club.UpdateRequests.filter(function (req) {
                                return req.type === 'pigeonhole' && req.key === null;
                            }).sort(function (m1, m2) {
                                return m1.newKey < m2.newKey ? -1 : 1;
                            }).map(function (newHole) {
                                var hole = JSON.parse(newHole.updates);
                                var oldMembers = _this2.props.admin.members.filter(function (member) {
                                    return member.Foreningsnr === clubNo && member.Slagnr === hole.Slagnr;
                                }).toArray();
                                var newMembers = club.UpdateRequests.filter(function (req) {
                                    if (req.type !== 'member' || req.newKey === null) return false;
                                    var values = req.updates === null ? {} : JSON.parse(req.updates);
                                    return typeof values.Slagnr !== 'undefined' && values.Slagnr === hole.Slagnr && (typeof values.Fornavn !== 'undefined' && values.Fornavn !== null || typeof values.Efternavn !== 'undefined' && values.Efternavn !== null);
                                }).map(function (member) {
                                    return JSON.parse(member.updates);
                                });
                                var members = (0, _arrayUtil.flatten)(oldMembers.map(function (member, ix) {
                                    return [_react2.default.createElement(
                                        'span',
                                        { className: 'list-item existing-item', key: 'o' + ix },
                                        member.Medlemsnr + (member.Fornavn === null && member.Efternavn === null ? '' : ' ') + member.Fornavn + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + member.Efternavn
                                    ), _react2.default.createElement(
                                        'span',
                                        { className: 'list-item-separator', key: 'os' + ix },
                                        ', '
                                    )];
                                }).concat(newMembers.map(function (member, ix) {
                                    return [_react2.default.createElement(
                                        'span',
                                        { className: 'list-item new-item', key: 'n' + ix },
                                        (typeof member.Fornavn === 'undefined' ? '' : member.Fornavn) + (typeof member.Fornavn === 'undefined' || typeof member.Efternavn === 'undefined' || member.Fornavn === null || member.Efternavn === null ? '' : ' ') + (typeof member.Efternavn === 'undefined' ? '' : member.Efternavn)
                                    ), _react2.default.createElement(
                                        'span',
                                        { className: 'list-item-separator', key: 'ns' + ix },
                                        ', '
                                    )];
                                })));
                                if (members.length > 0) members.splice(members.length - 1, 1);
                                return _react2.default.createElement(
                                    'tr',
                                    { key: 'n' + hole.Slagnr, className: 'new' },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        hole.Slagnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof hole.Slagnavn === 'undefined' ? null : hole.Slagnavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        members
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof hole.Omraadenr === 'undefined' ? null : hole.Omraadenr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof hole.LagMellem === 'undefined' ? null : hole.LagMellem
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        typeof hole.Markering1 === 'undefined' ? null : hole.Markering1,
                                        typeof hole.Markering2 === 'undefined' ? null : hole.Markering2
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', 'new' + hole.Slagnr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', 'new' + hole.Slagnr).replace(':subpage', 'general').replace(':mode', 'edit') : '', className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? '' : 'disabled', title: 'Rediger slag' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr ? ' clickable' : ' disabled'), title: 'Slet slag', disabled: _this2.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && (_this2.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentEntity !== club.Foreningsnr), onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === club.Foreningsnr) {
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette slag ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            hole.Slagnr + (typeof hole.Slagnavn === 'undefined' || hole.Slagnavn === null ? '' : " (" + hole.Slagnavn + ")")
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deletePigeonHole(clubNo, 'new' + hole.Slagnr, function () {
                                                            _reactNotifications.NotificationManager.success("Slag " + hole.Slagnr + (typeof hole.Slagnavn === 'undefined' || hole.Slagnavn === null ? '' : " (" + hole.Slagnavn + ")") + " er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                }
                                            } })
                                    )
                                );
                            })
                        )
                    );
                    break;

                case 'ring-series':
                    var member = this.props.admin.members.get(this.state.ringMedlemsnr);
                    subPage = _react2.default.createElement(
                        'table',
                        { className: 'data-table pigeon-members-list' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    '\xC5r'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Foreningsnr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Medlemsnr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Navn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Fra'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Til'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Suppl.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Kompagniskab'
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement('th', null) : null
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            club === null ? [] : club.ringSeries.filter(function (ringSerie) {
                                return _this2.state.ringYear === '' ? true : ringSerie.Aar === _this2.state.ringYear;
                            }).sort(function (rs1, rs2) {
                                if (rs1.Aar < rs2.Aar) return -1;
                                if (rs1.Aar > rs2.Aar) return 1;
                                if (rs1.Medlemsnr < rs2.Medlemsnr) return -1;
                                if (rs1.Medlemsnr > rs2.Medlemsnr) return 1;
                                if (rs1.Foreningsnr == _this2.props.params.clubNo && rs2.Foreningsnr != _this2.props.params.clubNo) return -1;
                                if (rs1.Foreningsnr != _this2.props.params.clubNo && rs2.Foreningsnr == _this2.props.params.clubNo) return 1;
                                if (rs1.Foreningsnr < rs2.Foreningsnr) return -1;
                                if (rs1.Foreningsnr > rs2.Foreningsnr) return 1;
                                if (rs1.Fra < rs2.Fra) return -1;
                                if (rs1.Fra > rs2.Fra) return 1;
                                if (rs1.Nr < rs2.Nr) return -1;
                                if (rs1.Nr > rs2.Nr) return 1;
                                return 0;
                            }).concat(this.state.editId === 'new' ? [{ Nr: 'new' }] : []).map(function (ringSerie, ix) {
                                if (_this2.state.editId === null || ringSerie.Nr !== _this2.state.editId) return _react2.default.createElement(
                                    'tr',
                                    { key: ix, id: 'row-' + ringSerie.Nr },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Aar
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Foreningsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Medlemsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Medlemsnavn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Fra
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Til
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Supplerende
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        ringSerie.Kompagniskab
                                    ),
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && ringSerie.Aar === openYear && ringSerie.Foreningsnr === clubNo ? _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger fodringserie', onClick: function onClick() {
                                                if (_this2.state.editId === null) {
                                                    if (!_this2.props.admin.members.get(ringSerie.Medlemsnr)) _this2.props.dispatch(AdminActions.getMember(ringSerie.Medlemsnr));
                                                    _this2.setState({
                                                        editId: ringSerie.Nr,
                                                        ringAar: ringSerie.Aar,
                                                        ringForeningsnr: ringSerie.Foreningsnr,
                                                        ringMedlemsnr: ringSerie.Medlemsnr,
                                                        ringFra: ringSerie.Fra === null ? '' : ringSerie.Fra,
                                                        ringTil: ringSerie.Til === null ? '' : ringSerie.Til,
                                                        ringSupplerende: ringSerie.Supplerende === null ? false : true
                                                    });
                                                }
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet fodringserie', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette fodringserien for ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        ringSerie.Medlemsnr,
                                                        '-',
                                                        ringSerie.Medlemsnavn
                                                    ),
                                                    ' \xE5r ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        ringSerie.Aar
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteRingSerie(clubNo, ringSerie.Nr, function () {
                                                        _reactNotifications.NotificationManager.success("Fodringserien er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    ) : null
                                );else return _react2.default.createElement(
                                    'tr',
                                    { key: ix },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'ringAar', id: 'ringAar', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.ringAar,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[10] = instance;
                                            }
                                        }) : _this2.state.ringAar
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'ringForeningsnr', id: 'ringForeningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.ringForeningsnr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: function onChange(e) {
                                                var val = e.target.value;
                                                if (val.length === 3 && !_this2.props.admin.clubs.get(val)) _this2.props.dispatch(AdminActions.getClubs());
                                                _this2.setState({ ringForeningsnr: val });
                                            },
                                            onBlur: function onBlur() {
                                                _this2.fields[11].setState({ focused: false, visited: true });
                                                if (/^[0-9]{1,2}$/.test(_this2.state.ringForeningsnr)) _this2.setState({ ringForeningsnr: _this2.state.ringForeningsnr.padStart(3, '0') }, function () {
                                                    if (!_this2.props.admin.clubs.get(_this2.state.ringForeningsnr)) _this2.props.dispatch(AdminActions.getClubs());
                                                });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[11] = instance;
                                            }
                                        }) : _this2.state.ringForeningsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: _this2.state.ringMedlemsnr === "" ? "-- Vælg --" : false, className: 'field100', containerClassName: 'display-inline-block',
                                            name: 'ringMedlemsnr', id: 'ringMedlemsnr', maxLength: '6', options: _this2.props.admin.members.filter(function (member) {
                                                return member.Foreningsnr === clubNo;
                                            }).sort(function (m1, m2) {
                                                return m1.Medlemsnr < m2.Medlemsnr ? -1 : 1;
                                            }).toArray().map(function (member) {
                                                return {
                                                    key: member.Medlemsnr,
                                                    value: member.Medlemsnr + " - " + member.Fornavn + (member.Fornavn !== '' && member.Efternavn !== '' ? " " : '') + member.Efternavn
                                                };
                                            }), value: _this2.state.ringMedlemsnr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: function onChange(e) {
                                                var val = e.target.value;
                                                if (val.length === 6 && !_this2.props.admin.members.get(val)) _this2.props.dispatch(AdminActions.getMember(val));
                                                _this2.setState({ ringMedlemsnr: val });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[12] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member ? member.Fornavn + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + member.Efternavn : ''
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field60', containerClassName: 'display-inline-block',
                                            name: 'ringFra', id: 'ringFra', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.ringFra,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            onBlur: function onBlur() {
                                                _this2.fields[13].setState({ focused: false, visited: true });
                                                if (/^[0-9]{1,3}$/.test(_this2.state.ringFra)) _this2.setState({ ringFra: _this2.state.ringFra.padStart(4, '0') });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[13] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field60', containerClassName: 'display-inline-block',
                                            name: 'ringTil', id: 'ringTil', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.ringTil,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            onBlur: function onBlur() {
                                                _this2.fields[14].setState({ focused: false, visited: true });
                                                if (/^[0-9]{1,3}$/.test(_this2.state.ringTil)) _this2.setState({ ringTil: _this2.state.ringTil.padStart(4, '0') });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[14] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement('input', { type: 'checkbox', checked: _this2.state.ringSupplerende, onClick: function onClick() {
                                                return _this2.setState({ ringSupplerende: !_this2.state.ringSupplerende });
                                            } })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        member && _this2.props.admin.members.filter(function (mem) {
                                            return mem.Foreningsnr === clubNo && mem.Slagnr === member.Slagnr;
                                        }).size > 1 ? 'K' : ''
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem fodringserie', onClick: function onClick() {
                                                _this2.saveRingSerie();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    );
                    break;

                case 'stations':
                    subPage = _react2.default.createElement(_StationSelection2.default, { targetId: clubNo });
                    break;
            }

            var updateReq = club === null ? null : club.UpdateRequests.find(function (req) {
                return req.type === 'club';
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        clubNo.toLowerCase() === 'new' ? 'Ny forening' : 'Forening ' + clubNo + ' - ' + club.Navn
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _ClubGeneral.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'contacts' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _ClubContacts.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "contacts").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Kontakter'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'members' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled')) + (club !== null && club.UpdateRequests.findIndex(function (req) {
                                    return req.type === 'member';
                                }) >= 0 ? ' has-updates' : ''), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "members").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Medlemmer'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'pigeon-holes' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled')) + (club !== null && club.UpdateRequests.findIndex(function (req) {
                                    return req.type === 'pigeonhole';
                                }) >= 0 ? ' has-updates' : ''), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "pigeon-holes").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Slag'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'ring-series' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "ring-series").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Ringserier'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'stations' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CLUB.replace(":clubNo", clubNo).replace(":subpage", "stations").replace(":mode", "view") : '' },
                            'Stationsvalg'
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page', id: 'sub-page-content' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' || this.props.params.subpage === 'contacts' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger forening', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && (this.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentEntity !== clubNo), onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ) : null,
                        this.props.params.subpage === 'members' ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: "btn-primary" + (this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr ? '' : ' disabled'), to: this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_MEMBER.replace(':clubNo', clubNo).replace(':memberNo', 'new').replace(':subpage', 'general').replace(':mode', 'create') : '', title: 'Opret nyt medlem' },
                            'Ny'
                        ) : null,
                        this.props.params.subpage === 'pigeon-holes' ? [_react2.default.createElement(
                            _reactRouter.Link,
                            { key: 0, className: "btn-primary" + (this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr ? '' : ' disabled'), to: this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr ? _routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', 'new').replace(':subpage', 'general').replace(':mode', 'create') : '', title: 'Opret nyt slag' },
                            'Ny'
                        ), _react2.default.createElement(
                            'button',
                            { key: 1, className: 'btn-primary', title: 'S\xE6t junior/pensionist-markeringer automatisk fra medlem(er) for hele foreningen', onClick: function onClick() {
                                    (0, _confirmDialog.confirm)("Opdater junior/pensionist", _react2.default.createElement(
                                        'span',
                                        null,
                                        '\xD8nsker du at opdatere alle junior/pensionist-markeringer i forening ',
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            clubNo,
                                            ' ',
                                            club.Navn
                                        ),
                                        ' p\xE5 basis af medlemsregistreringer?'
                                    ), function () {
                                        _this2.props.dispatch(AdminActions.setJuniorPensionerForClub(clubNo, function () {
                                            _reactNotifications.NotificationManager.success("Junior/pensionist-markeringer er opdateret for alle slag i forening " + clubNo + " " + club.Navn + ".", "Opdatering", 4000);
                                        }));
                                    });
                                } },
                            'S\xE6t junior/pensionist-markeringer'
                        ), _react2.default.createElement(
                            'button',
                            { key: 2, className: 'btn-primary', title: 'Nulstil begyndermarkeringer for hele foreningen', onClick: function onClick() {
                                    (0, _confirmDialog.confirm)("Nulstil begynder", _react2.default.createElement(
                                        'span',
                                        null,
                                        '\xD8nsker du at nulstille alle begyndermarkeringer i forening ',
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            clubNo,
                                            ' ',
                                            club.Navn
                                        ),
                                        '?'
                                    ), function () {
                                        _this2.props.dispatch(AdminActions.resetBeginnersForClub(clubNo, function () {
                                            _reactNotifications.NotificationManager.success("Alle begyndermarkeringer er nulstillet i forening " + clubNo + " " + club.Navn + ".", "Opdatering", 4000);
                                        }));
                                    });
                                } },
                            'Nulstil begyndermarkeringer'
                        )] : null,
                        this.props.params.subpage === 'ring-series' ? [_react2.default.createElement(
                            'label',
                            { key: 1, htmlFor: 'ringYear', className: this.state.editId === null ? '' : 'disabled' },
                            '\xC5r'
                        ), _react2.default.createElement(_UserFieldElement2.default, { key: 2, dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block', disabled: this.state.editId !== null,
                            name: 'ringYear', id: 'ringYear', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.ringYear,
                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                            onChange: this.onStandardFieldChange,
                            ref: function ref(instance) {
                                _this2.fields[0] = instance;
                            }
                        }), this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.state.ringYear === openYear ? _react2.default.createElement(
                            'button',
                            { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret ny ringserie', onClick: function onClick() {
                                    if (_this2.state.editId === null) {
                                        _this2.setState({
                                            editId: 'new',
                                            ringAar: _this2.state.ringYear,
                                            ringForeningsnr: _this2.props.params.clubNo,
                                            ringMedlemsnr: '',
                                            ringFra: '',
                                            ringTil: '',
                                            ringSupplerende: false
                                        });
                                        setTimeout(function () {
                                            var content = document.getElementById("sub-page-content");
                                            content.scrollTop = content.scrollHeight;
                                        });
                                    }
                                } },
                            'Ny'
                        ) : null] : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: "btn-primary" + (disabled ? ' disabled' : ''), to: disabled ? '' : _routeconstants.ROUTE_CLUBS, title: 'Vis alle foreninger' },
                            'Foreninger'
                        )
                    )] : [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (clubNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _this2.props.params.clubNo.toLowerCase() === 'new' ? "Foreningen er oprettet" : "Foreningen er opdateret." : "Ændringer er lagt til godkendelse.", _this2.props.params.clubNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (clubNo.toLowerCase() === 'new') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUBS));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return ClubPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            members: state.admin.members,
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClubPage);

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _Util = __webpack_require__(62);

var _MemberGeneral = __webpack_require__(385);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Foreningsnr: '',
    Sektionsnr: '',
    Navn: '',
    Kommune: '',
    Adresse: '',
    Postnr: '',
    Tlf: '',
    Email: '',
    Stiftet: '',
    WebSite: '',
    Bank: '',
    Regnr: '',
    Kontonr: '',
    KoerselKm: '',
    TaurisVersion: ''
};

var ClubGeneral = function (_React$Component) {
    _inherits(ClubGeneral, _React$Component);

    function ClubGeneral(props) {
        _classCallCheck(this, ClubGeneral);

        var _this = _possibleConstructorReturn(this, (ClubGeneral.__proto__ || Object.getPrototypeOf(ClubGeneral)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Navn: _this.state.Navn,
                    Kommune: _this.state.Kommune === '' ? null : _this.state.Kommune,
                    Adresse: _this.state.Adresse === '' ? null : _this.state.Adresse,
                    Postnr: _this.state.Postnr === '' ? null : _this.state.Postnr,
                    Tlf: _this.state.Tlf === '' ? null : _this.state.Tlf,
                    Email: _this.state.Email === '' ? null : _this.state.Email,
                    Stiftet: _this.state.Stiftet === '' ? null : (0, _moment2.default)(_this.state.Stiftet, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    WebSite: _this.state.WebSite === '' ? null : _this.state.WebSite,
                    Bank: _this.state.Bank === '' ? null : _this.state.Bank,
                    Regnr: _this.state.Regnr === '' ? null : _this.state.Regnr,
                    Kontonr: _this.state.Kontonr === '' ? null : _this.state.Kontonr,
                    KoerselKm: _this.state.KoerselKm === '' ? null : Number(_this.state.KoerselKm),
                    TaurisVersion: _this.state.TaurisVersion === '' ? null : Number(_this.state.TaurisVersion)
                };
                if (_this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) {
                    entity.Foreningsnr = _this.state.Foreningsnr;
                    entity.Sektionsnr = _this.state.Sektionsnr === '' ? null : _this.state.Sektionsnr;
                }
                if (_this.props.club === null) _this.props.dispatch(AdminActions.createClub(entity, onSuccess));else _this.props.dispatch(AdminActions.updateClub(_this.props.club.Foreningsnr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(ClubGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.club === null && this.props.club !== null || nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.club === null) return defaultState;else {
                var club = props.club;
                var updateReq = club.UpdateRequests.find(function (req) {
                    return req.type === 'club';
                }) || null;
                var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
                return {
                    Foreningsnr: isUndefined(updates.Foreningsnr) ? club.Foreningsnr === null ? '' : club.Foreningsnr : updates.Foreningsnr === null ? '' : updates.Foreningsnr,
                    Sektionsnr: isUndefined(updates.Sektionsnr) ? club.Sektionsnr === null ? '' : club.Sektionsnr : updates.Sektionsnr === null ? '' : updates.Sektionsnr,
                    Navn: isUndefined(updates.Navn) ? club.Navn === null ? '' : club.Navn : updates.Navn === null ? '' : updates.Navn,
                    Kommune: isUndefined(updates.Kommune) ? club.Kommune === null ? '' : club.Kommune : updates.Kommune === null ? '' : updates.Kommune,
                    Adresse: isUndefined(updates.Adresse) ? club.Adresse === null ? '' : club.Adresse : updates.Adresse === null ? '' : updates.Adresse,
                    Postnr: isUndefined(updates.Postnr) ? club.Postnr === null ? '' : club.Postnr : updates.Postnr === null ? '' : updates.Postnr,
                    Tlf: isUndefined(updates.Tlf) ? club.Tlf === null ? '' : club.Tlf : updates.Tlf === null ? '' : updates.Tlf,
                    Email: isUndefined(updates.Email) ? club.Email === null ? '' : club.Email : updates.Email === null ? '' : updates.Email,
                    Stiftet: isUndefined(updates.Stiftet) ? club.Stiftet === null ? '' : (0, _moment2.default)(club.Stiftet).format(_config2.default.formats.dateFormat) : updates.Stiftet === null ? '' : (0, _moment2.default)(updates.Stiftet).format(_config2.default.formats.dateFormat),
                    WebSite: isUndefined(updates.WebSite) ? club.WebSite === null ? '' : club.WebSite : updates.WebSite === null ? '' : updates.WebSite,
                    Bank: isUndefined(updates.Bank) ? club.Bank === null ? '' : club.Bank : updates.Bank === null ? '' : updates.Bank,
                    Regnr: isUndefined(updates.Regnr) ? club.Regnr === null ? '' : club.Regnr : updates.Regnr === null ? '' : updates.Regnr,
                    Kontonr: isUndefined(updates.Kontonr) ? club.Kontonr === null ? '' : club.Kontonr : updates.Kontonr === null ? '' : updates.Kontonr,
                    KoerselKm: isUndefined(updates.KoerselKm) ? club.KoerselKm === null ? '' : String(club.KoerselKm) : updates.KoerselKm === null ? '' : String(updates.KoerselKm),
                    TaurisVersion: isUndefined(updates.TaurisVersion) ? club.TaurisVersion === null ? '' : String(club.TaurisVersion) : updates.TaurisVersion === null ? '' : String(updates.TaurisVersion)
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(function (req) {
                return req.type === 'club';
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            var editMode = this.props.editMode;
            return _react2.default.createElement(
                'div',
                { className: "form-page club-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Foreningsnr' },
                                        'Foreningsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                editMode && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Foreningsnr,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                    //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                    , onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Foreningsnr
                                ),
                                isUndefined(updates.Foreningsnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Foreningsnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Sektionsnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Sektionsnr' },
                                        'Sektionsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Sektionsnr) ? "" : " updated") },
                                editMode && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Sektionsnr', id: 'Sektionsnr', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.Sektionsnr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true
                                    //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-200px', zIndex: 99999}}}
                                    , onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Sektionsnr
                                ),
                                isUndefined(updates.Sektionsnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Sektionsnr) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Navn) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Navn' },
                                        'Foreningsnavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Navn) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Navn', id: 'Navn', maxLength: '17', value: this.state.Navn,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                    /*errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-200px', zIndex: 99999}}}*/
                                    , onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Navn
                                ),
                                isUndefined(updates.Navn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Navn) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Kommune) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kommune' },
                                        'Kommune'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Kommune) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Kommune', id: 'Kommune', maxLength: '20', value: this.state.Kommune,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kommune
                                ),
                                isUndefined(updates.Kommune) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Kommune) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Adresse) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Adresse' },
                                        'Adresse'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Adresse) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Adresse', id: 'Adresse', maxLength: '50', value: this.state.Adresse,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Adresse
                                ),
                                isUndefined(updates.Adresse) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Adresse) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Postnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Postnr' },
                                        'Postnr/By'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Postnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Postnr', id: 'Postnr', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: this.state.Postnr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Postnr
                                ),
                                isUndefined(updates.Postnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'value-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Postnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.props.admin.isBasicsRead && this.props.admin.zipCodes.get(this.state.Postnr) ? this.props.admin.zipCodes.get(this.state.Postnr).By : null
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Tlf) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Tlf' },
                                        'Telefon'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Tlf) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Tlf', id: 'Tlf', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{8}" }], value: this.state.Tlf,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Tlf
                                ),
                                isUndefined(updates.Tlf) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Tlf) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Email) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Email' },
                                        'Email'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Email) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Email', id: 'Email', maxLength: '50', value: this.state.Email,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[7] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Email
                                ),
                                isUndefined(updates.Email) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Email) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Stiftet) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Stiftet' },
                                        'Stiftet'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Stiftet) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Stiftet', id: 'Stiftet', maxLength: '10', value: this.state.Stiftet,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[8] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Stiftet
                                ),
                                isUndefined(updates.Stiftet) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.club.Stiftet === null ? (0, _dataUtil.formatNullable)(null) : (0, _moment2.default)(this.props.club.Stiftet).format(_config2.default.formats.dateFormat)) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.WebSite) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'WebSite' },
                                        'Hjemmeside'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.WebSite) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'WebSite', id: 'WebSite', maxLength: '50', value: this.state.WebSite,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[9] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.WebSite
                                ),
                                isUndefined(updates.WebSite) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.WebSite) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Bank) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Bank' },
                                        'Bank'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Bank) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Bank', id: 'Bank', maxLength: '35', value: this.state.Bank,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[10] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bank
                                ),
                                isUndefined(updates.Bank) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Bank) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Regnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Regnr' },
                                        'Reg.nr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Regnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Regnr', id: 'Regnr', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: this.state.Regnr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[11] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Regnr
                                ),
                                isUndefined(updates.Regnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Regnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Kontonr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kontonr' },
                                        'Kontonr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Kontonr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Kontonr', id: 'Kontonr', maxLength: '14', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,14}" }], value: this.state.Kontonr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[12] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kontonr
                                ),
                                isUndefined(updates.Kontonr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Kontonr) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.TaurisVersion) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'TaurisVersion' },
                                        'Tauris-version'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.TaurisVersion) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'TaurisVersion', id: 'TaurisVersion', maxLength: '4', value: this.state.TaurisVersion,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[13] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.TaurisVersion
                                ),
                                isUndefined(updates.TaurisVersion) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.club.TaurisVersion === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.club.TaurisVersion)) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.KoerselKm) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'KoerselKm' },
                                        'K\xF8rsel KM'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.KoerselKm) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'KoerselKm', id: 'KoerselKm', maxLength: '14', value: this.state.KoerselKm,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[14] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.KoerselKm
                                ),
                                isUndefined(updates.KoerselKm) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.club.KoerselKm === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.club.KoerselKm)) + ')'
                                )]
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ClubGeneral;
}(_react2.default.Component);

ClubGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    club: _propTypes2.default.object
};
ClubGeneral.defaultProps = {
    editMode: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isBasicsRead: state.admin.isBasicsRead,
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ClubGeneral);

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(788);
moment.tz.load(__webpack_require__(789));


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.34
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(0)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.34",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Formand: '',
    Kasserer: '',
    Loeslader: '',
    Kontrolformand: ''
};

var ClubContacts = function (_React$Component) {
    _inherits(ClubContacts, _React$Component);

    function ClubContacts(props) {
        _classCallCheck(this, ClubContacts);

        var _this = _possibleConstructorReturn(this, (ClubContacts.__proto__ || Object.getPrototypeOf(ClubContacts)).call(this, props));

        _this.fields = [];

        _this.onMemberNumberFieldChange = function (e) {
            if (e.target.value.length === 6) {
                var member = _this.props.admin.members.get(e.target.value) || null;
                if (member === null) _this.props.dispatch(AdminActions.getMember(e.target.value));
            }
            _this.onStandardFieldChange(e);
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Formand: _this.state.Formand === '' ? null : _this.state.Formand,
                    Kasserer: _this.state.Kasserer === '' ? null : _this.state.Kasserer,
                    Kontrolformand: _this.state.Kontrolformand === '' ? null : _this.state.Kontrolformand,
                    Loeslader: _this.state.Loeslader === '' ? null : _this.state.Loeslader
                };
                if (_this.props.club === null) _this.props.dispatch(AdminActions.createClub(entity, onSuccess));else _this.props.dispatch(AdminActions.updateClub(_this.props.club.Foreningsnr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(ClubContacts, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.club === null && this.props.club !== null || nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.club === null) return defaultState;else {
                var club = props.club;
                var updateReq = club.UpdateRequests.find(function (req) {
                    return req.type === 'club';
                }) || null;
                var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
                return {
                    Formand: isUndefined(updates.Formand) ? club.Formand === null ? '' : club.Formand : updates.Formand === null ? '' : updates.Formand,
                    Kasserer: isUndefined(updates.Kasserer) ? club.Kasserer === null ? '' : club.Kasserer : updates.Kasserer === null ? '' : updates.Kasserer,
                    Loeslader: isUndefined(updates.Loeslader) ? club.Loeslader === null ? '' : club.Loeslader : updates.Loeslader === null ? '' : updates.Loeslader,
                    Kontrolformand: isUndefined(updates.Kontrolformand) ? club.Kontrolformand === null ? '' : club.Kontrolformand : updates.Kontrolformand === null ? '' : updates.Kontrolformand
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var getContactInfo = function getContactInfo(memberNo) {
                var member = _this2.props.admin.members.get(memberNo) || null;
                var city = member === null || member.Postnr === null ? null : _this2.props.admin.zipCodes.get(member.Postnr) || null;
                return [_react2.default.createElement(
                    'td',
                    { key: 'address', style: { width: "50%" } },
                    _react2.default.createElement(
                        'div',
                        { className: 'address-container' },
                        [member === null || member.Fornavn === null && member.Efternavn === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line1' },
                            (0, _dataUtil.formatNullable)(member.Fornavn, '') + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Efternavn, '')
                        ), member === null || member.Adr === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line3' },
                            member.Adr + (member.Husnr === null && member.Husbogstav === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Husnr, '') + (0, _dataUtil.formatNullable)(member.Husbogstav, '') + (member.Etage === null && member.Placering === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Etage, '') + (0, _dataUtil.formatNullable)(member.Placering, '')
                        ), member === null || member.C_O_adresse === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line2' },
                            member.C_O_adresse
                        ), member === null || member.Postboks === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line4' },
                            'Postboks ',
                            member.Postboks
                        ), member === null || member.Postnr === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line5' },
                            member.Postnr + (city === null || city.By === null ? '' : ' ' + city.By)
                        )]
                    )
                ), _react2.default.createElement(
                    'td',
                    { key: 'contact', style: { width: "50%" } },
                    _react2.default.createElement(
                        'div',
                        { className: 'address-container' },
                        [member === null || member.Kontaktnavn === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line1' },
                            member.Kontaktnavn
                        ), member === null || member.Tlf === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line2' },
                            'Tlf. ',
                            _react2.default.createElement(
                                'a',
                                { href: 'tel:' + member.Tlf, tabIndex: -1 },
                                member.Tlf
                            )
                        ), member === null || member.Email === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line3' },
                            'Email. ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:' + member.Email, tabIndex: -1 },
                                member.Email
                            )
                        )]
                    )
                )];
            };

            var updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(function (req) {
                return req.type === 'club';
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            var editMode = this.props.editMode;
            var formand = getContactInfo(this.state.Formand);
            var kasserer = getContactInfo(this.state.Kasserer);
            var kontrolFormand = getContactInfo(this.state.Kontrolformand);
            var loeslader = getContactInfo(this.state.Loeslader);
            return _react2.default.createElement(
                'div',
                { className: "form-page club-contacts " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Formand) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Formand' },
                                        'Formand'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Formand) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Formand', id: 'Formand', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Formand,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Formand
                                ),
                                isUndefined(updates.Formand) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Formand) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            formand
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Kasserer) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kasserer' },
                                        'Kasserer'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Kasserer) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Kasserer', id: 'Kasserer', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Kasserer,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kasserer
                                ),
                                isUndefined(updates.Kasserer) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Kasserer) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            kasserer
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Kontrolformand) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kontrolformand' },
                                        'Edb-kontakt'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Kontrolformand) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Kontrolformand', id: 'Kontrolformand', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Kontrolformand,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kontrolformand
                                ),
                                isUndefined(updates.Kontrolformand) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Kontrolformand) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            kontrolFormand
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Loeslader) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Loeslader' },
                                        'Kontrolformand'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Loeslader) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Loeslader', id: 'Loeslader', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Loeslader,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Loeslader
                                ),
                                isUndefined(updates.Loeslader) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.club.Loeslader) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            loeslader
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ClubContacts;
}(_react2.default.Component);

ClubContacts.propTypes = {
    editMode: _propTypes2.default.bool,
    club: _propTypes2.default.object
};
ClubContacts.defaultProps = {
    editMode: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            members: state.admin.members,
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ClubContacts);

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _lib = __webpack_require__(18);

var _confirmDialog = __webpack_require__(12);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MembersPage = function (_React$Component) {
    _inherits(MembersPage, _React$Component);

    _createClass(MembersPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_MEMBERS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function MembersPage(props) {
        _classCallCheck(this, MembersPage);

        var _this = _possibleConstructorReturn(this, (MembersPage.__proto__ || Object.getPrototypeOf(MembersPage)).call(this, props));

        _this.timeoutHandler = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.state = {
            filter: '',
            showInactive: 0,
            sort: 'Medlemsnr',
            maxRows: 250
        };
        return _this;
    }

    _createClass(MembersPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.admin.isMembersRead) this.props.dispatch(AdminActions.getMembers());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.admin.isMembersRead ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Medlemmer'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Medlemsnr' });
                                        } },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Foreningsnr' });
                                        } },
                                    'Foreningsnr.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Foreningsnavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Fornavn' });
                                        } },
                                    'Fornavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Efternavn' });
                                        } },
                                    'Efternavn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Postnr' });
                                        } },
                                    'Postnr.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Slag'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.admin.members.filter(function (m) {
                                return (_this2.state.showInactive || m.Foreningsnr != '999') && (_this2.state.filter === '' || (0, _lib.nullToBlank)(m.Efternavn).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(m.Fornavn).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(m.Medlemsnr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(m[_this2.state.sort]).toUpperCase().search(_this2.state.filter) >= 0);
                            }).sort(function (m1, m2) {
                                var comp = (m1[_this2.state.sort] === null ? '' : m1[_this2.state.sort].trim()).localeCompare(m2[_this2.state.sort] === null ? '' : m2[_this2.state.sort].trim(), 'da-DK');
                                return comp === 0 ? m1.Medlemsnr < m2.Medlemsnr ? -1 : 1 : comp;
                            }).toArray().map(function (member, ix) {
                                if (ix < _this2.state.maxRows) {
                                    var club = _this2.props.admin.clubs.get(member.Foreningsnr) || null;
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: member.Medlemsnr, onDoubleClick: function onDoubleClick() {
                                                _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                            } },
                                        _react2.default.createElement(
                                            'th',
                                            { scope: 'row' },
                                            member.Medlemsnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            member.Foreningsnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            club ? club.Navn : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            member.Fornavn
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            member.Efternavn
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            member.Postnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            member.Slagnr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                {
                                                    to: _routeconstants.ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view'),
                                                    title: 'Vis detaljer' },
                                                _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                            ),
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                {
                                                    to: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === member.Foreningsnr ? _routeconstants.ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'edit') : '',
                                                    className: _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === member.Foreningsnr ? '' : 'disabled',
                                                    title: 'Rediger medlem' },
                                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                            ),
                                            _react2.default.createElement('i', { className: "fa fa-trash" + (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === member.Foreningsnr ? ' clickable' : ' disabled'),
                                                title: 'Slet medlem', onClick: function onClick() {
                                                    if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && _this2.props.auth.currentEntity === member.Foreningsnr) {
                                                        var fname = member.Fornavn === null ? '' : member.Fornavn;
                                                        var lname = member.Efternavn === null ? '' : member.Efternavn;
                                                        var name = fname + (fname !== '' && lname !== '' ? ' ' : '') + lname;
                                                        (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            '\xD8nsker du at slette medlem ',
                                                            _react2.default.createElement(
                                                                'b',
                                                                null,
                                                                member.Medlemsnr + (name === '' ? '' : " (" + name + ")")
                                                            ),
                                                            '?'
                                                        ), function () {
                                                            _this2.props.dispatch(AdminActions.deleteMember(member.Foreningsnr, member.Medlemsnr, function () {
                                                                _reactNotifications.NotificationManager.success("Medlem " + member.Medlemsnr + (name === '' ? '' : " (" + name + ")") + " er slettet.", "Sletning", 4000);
                                                            }));
                                                        });
                                                    }
                                                } })
                                        )
                                    );
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { className: 'btn-primary', to: _routeconstants.ROUTE_MEMBER.replace(':clubNo', 'undefined').replace(':memberNo', 'new').replace(':subpage', 'general').replace(':mode', 'create'), title: 'Opret nyt medlem' },
                        'Ny'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'filter' },
                        'Filter'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast s\xF8gev\xE6rdi', className: 'field-1 large-field',
                        name: 'filter', id: 'filter',
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value.toUpperCase();
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                _this2.setState({ filter: val });
                            }, 500);
                        }
                    }),
                    _react2.default.createElement('input', { id: 'showInactive', name: 'showInactive', type: 'checkbox', checked: this.state.showInactive, onChange: function onChange(e) {
                            _this2.setState({ showInactive: e.target.checked ? -1 : 0 });
                        } }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'showInactive' },
                        'Vis inaktive'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort' },
                        'Sortering'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field-1 large-field',
                        name: 'sort', id: 'sort', value: this.state.sort, options: [{ key: 'Medlemsnr', value: 'Medlemsnr' }, { key: 'Fornavn', value: 'Fornavn' }, { key: 'Efternavn', value: 'Efternavn' }, { key: 'Foreningsnr', value: 'Foreningsnr' }, { key: 'Postnr', value: 'Postnr' }],
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: this.onStandardFieldChange
                    }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'maxRows' },
                        'Antal r\xE6kker'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: this.state.maxRows, className: 'field-1 medium-field',
                        name: 'maxRows', id: 'maxRows',
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value;
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                if (/^[0-9]+$/.test(val)) _this2.setState({ maxRows: Number(val) });
                            }, 500);
                        }
                    })
                )
            ) : null;
        }
    }]);

    return MembersPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isClubsRead: state.admin.isClubsRead,
            clubs: state.admin.clubs,
            isMembersRead: state.admin.isMembersRead,
            members: state.admin.members
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MembersPage);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _reactNotifications = __webpack_require__(8);

var _MemberGeneral = __webpack_require__(385);

var _MemberGeneral2 = _interopRequireDefault(_MemberGeneral);

var _MemberMarkings = __webpack_require__(793);

var _MemberMarkings2 = _interopRequireDefault(_MemberMarkings);

var _Util = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MemberPage = function (_React$Component) {
    _inherits(MemberPage, _React$Component);

    _createClass(MemberPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_MEMBER;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function MemberPage(props) {
        _classCallCheck(this, MemberPage);

        var _this = _possibleConstructorReturn(this, (MemberPage.__proto__ || Object.getPrototypeOf(MemberPage)).call(this, props));

        _this.loadMember = function (newestProps) {
            if (newestProps.params.clubNo !== 'undefined' && newestProps.params.clubNo !== 'new') {
                var club = newestProps.admin.clubs ? newestProps.admin.clubs.get(newestProps.params.clubNo) || null : null;
                if (club === null || typeof club.isFullLoaded === 'undefined') newestProps.dispatch(AdminActions.getClub(newestProps.params.clubNo));
            }
            if (!newestProps.params.memberNo.toLowerCase().startsWith('new')) newestProps.dispatch(AdminActions.getMember(newestProps.params.memberNo));
        };

        return _this;
    }

    _createClass(MemberPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadMember(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.clubNo !== this.props.params.clubNo || nextProps.params.memberNo !== this.props.params.memberNo) this.loadMember(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var clubNo = this.props.params.clubNo;
            var club = clubNo.toLowerCase() === 'undefined' || clubNo.toLowerCase() === 'new' || !this.props.admin.clubs ? null : this.props.admin.clubs.get(clubNo) || null;
            var memberNo = this.props.params.memberNo.toLowerCase().startsWith('new') ? this.props.params.memberNo.substring(3) : this.props.params.memberNo;
            var member = memberNo === '' ? null : this.props.params.memberNo.toLowerCase().startsWith('new') ? club === null ? null : club.UpdateRequests.find(function (req) {
                return req.type === 'member' && req.newKey === memberNo;
            }) || null : !this.props.admin.members ? null : this.props.admin.members.get(memberNo) || null;
            if (this.props.params.memberNo.toLowerCase().startsWith('new') && member !== null) member = JSON.parse(member.updates);
            if (memberNo !== '' && (member === null || !this.props.params.memberNo.toLowerCase().startsWith('new') && typeof member.isFullLoaded === 'undefined')) return null;

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_MemberGeneral2.default, { club: club, member: member, isNew: this.props.params.memberNo.toLowerCase().startsWith('new'), editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        }, newMemberNumber: memberNo });
                    break;
                case 'markings':
                    subPage = _react2.default.createElement(_MemberMarkings2.default, { club: club, member: member, isNew: this.props.params.memberNo.toLowerCase().startsWith('new'), editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        }, newMemberNumber: memberNo });
                    break;
            }

            var updateReq = this.props.params.memberNo.toLowerCase().startsWith('new') || club === null ? null : club.UpdateRequests.find(function (req) {
                return req.type === 'member' && req.key === memberNo;
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        (memberNo === '' ? 'Nyt medlem' : 'Medlem ' + memberNo + ' - ' + (member === null || typeof member.Fornavn === 'undefined' ? '' : member.Fornavn) + ' ' + (typeof member.Efternavn === 'undefined' ? '' : member.Efternavn)) + (club === null ? '' : ' (Forening ' + clubNo + ', ' + club.Navn + ')')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _MemberGeneral.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_MEMBER.replace(":clubNo", clubNo).replace(":memberNo", this.props.params.memberNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'markings' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _MemberMarkings.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_MEMBER.replace(":clubNo", clubNo).replace(":memberNo", this.props.params.memberNo).replace(":subpage", "markings").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Markeringer'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' || this.props.params.subpage === 'markings' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger medlem', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && (this.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentEntity !== clubNo), onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', _this2.props.params.memberNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ) : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(":subpage", "members").replace(":mode", "view"), title: "Vis forening " + clubNo },
                            'Forening ',
                            clubNo
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_CLUBS, title: 'Vis alle foreninger' },
                            'Foreninger'
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_MEMBERS, title: 'Vis alle medlemmer' },
                            'Medlemmer'
                        ) : null
                    )] : [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (clubNo, memberNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _this2.props.params.memberNo.toLowerCase() === 'new' ? "Medlemmet er oprettet" : "Medlemmet er opdateret." : (_this2.props.params.memberNo.toLowerCase() === 'new' ? "Nyt medlem" : "Ændringer") + " er lagt til godkendelse.", _this2.props.params.memberNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        var memberNo1 = _this2.props.params.memberNo.toLowerCase().startsWith('new') ? _this2.props.params.memberNo.substring(3) : _this2.props.params.memberNo;
                                        var memberNo2 = memberNo.toLowerCase().startsWith('new') ? memberNo.substring(3) : memberNo;
                                        var memberUrl = _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? memberNo2 : _this2.props.params.memberNo.toLowerCase().startsWith('new') ? memberNo.toLowerCase().startsWith('new') ? memberNo : 'new' + memberNo : memberNo1;
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', memberUrl).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (memberNo === '') {
                                        if (clubNo === 'undefined' || clubNo === 'new') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_MEMBERS));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', 'members').replace(':mode', 'view')));
                                    } else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', _this2.props.params.memberNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return MemberPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            members: state.admin.members,
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MemberPage);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _optionsDialog = __webpack_require__(794);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Foedselsdato: '',
    Pensionsmarkering: '',
    Indmeldelsesdato: '',
    Udmeldelsesdato: '',
    Bemaerkninger: '',
    Passiv: 0,
    ModtagerIkkeBrevduen: -1,
    ModtagMetode: null,
    SMSabonnement: 0,
    Modtagernr: null,
    MobilAbonnement: 0,
    DDB_Tauris: 0,
    UNIKON_SMS: 0,
    Inaktiv: 0,
    DataOnWeb: -1,
    TlfOnWeb: -1,
    AdrOnWeb: -1,
    Dispensation: 0,
    DispensationTekst: ''
};

var MemberMarkings = function (_React$Component) {
    _inherits(MemberMarkings, _React$Component);

    function MemberMarkings(props) {
        _classCallCheck(this, MemberMarkings);

        var _this = _possibleConstructorReturn(this, (MemberMarkings.__proto__ || Object.getPrototypeOf(MemberMarkings)).call(this, props));

        _this.fields = [];

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Foedselsdato: _this.state.Foedselsdato === '' ? null : (0, _moment2.default)(_this.state.Foedselsdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Pensionsmarkering: _this.state.Pensionsmarkering === '' ? null : _this.state.Pensionsmarkering,
                    Indmeldelsesdato: _this.state.Indmeldelsesdato === '' ? null : (0, _moment2.default)(_this.state.Indmeldelsesdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Udmeldelsesdato: _this.state.Udmeldelsesdato === '' ? null : (0, _moment2.default)(_this.state.Udmeldelsesdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Bemaerkninger: _this.state.Bemaerkninger === '' ? null : _this.state.Bemaerkninger,
                    Passiv: _this.state.Passiv,
                    ModtagerIkkeBrevduen: _this.state.ModtagerIkkeBrevduen,
                    ModtagMetode: _this.state.ModtagMetode,
                    SMSabonnement: _this.state.SMSabonnement,
                    Modtagernr: _this.state.Modtagernr,
                    MobilAbonnement: _this.state.MobilAbonnement,
                    DDB_Tauris: _this.state.DDB_Tauris,
                    UNIKON_SMS: _this.state.UNIKON_SMS,
                    Inaktiv: _this.state.Inaktiv,
                    DataOnWeb: _this.state.DataOnWeb,
                    TlfOnWeb: _this.state.TlfOnWeb,
                    AdrOnWeb: _this.state.AdrOnWeb,
                    Dispensation: _this.state.Dispensation,
                    DispensationTekst: _this.state.DispensationTekst === '' ? null : _this.state.DispensationTekst
                };
                if (_this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && entity.Udmeldelsesdato !== null && entity.Udmeldelsesdato > entity.Indmeldelsesdato && (_this.props.club === null || _this.props.club.Foreningsnr !== '999')) {
                    (0, _optionsDialog.optionsDialog)("Udmelding", "Medlemmet er udmeldt. Vil du flytte medlemmet til forening 999?", ['Ja', 'Nej'], function (choice) {
                        switch (choice) {
                            case 'Ja':
                                entity.Foreningsnr = '999';
                                break;
                            case 'Nej':
                                break;
                        }
                        if (_this.props.member === null) _this.props.dispatch(AdminActions.createMember(entity, onSuccess));else _this.props.dispatch(AdminActions.updateMember(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + (typeof _this.props.member.Medlemsnr === 'undefined' ? _this.props.newMemberNumber : _this.props.member.Medlemsnr), entity, onSuccess));
                    });
                } else {
                    if (_this.props.member === null) _this.props.dispatch(AdminActions.createMember(entity, onSuccess));else _this.props.dispatch(AdminActions.updateMember(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + (typeof _this.props.member.Medlemsnr === 'undefined' ? _this.props.newMemberNumber : _this.props.member.Medlemsnr), entity, onSuccess));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(MemberMarkings, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.club === null && this.props.club !== null || nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr) || nextProps.member === null && this.props.member !== null || nextProps.member !== null && (this.props.member === null || this.props.member.Medlemsnr !== nextProps.member.Medlemsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.member === null) return Object.assign({}, defaultState, {
                Indmeldelsesdato: (0, _moment2.default)(new Date()).format(_config2.default.formats.dateFormat)
            });else {
                var club = props.club;
                var member = props.member;
                var updateReq = props.isNew || club === null ? null : club.UpdateRequests.find(function (req) {
                    return req.type === 'member' && req.key === props.member.Medlemsnr;
                }) || null;
                var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
                return {
                    Foedselsdato: isUndefined(updates.Foedselsdato) ? isUndefined(member.Foedselsdato) || member.Foedselsdato === null ? '' : (0, _moment2.default)(member.Foedselsdato).format(_config2.default.formats.dateFormat) : updates.Foedselsdato === null ? '' : (0, _moment2.default)(updates.Foedselsdato).format(_config2.default.formats.dateFormat),
                    Pensionsmarkering: isUndefined(updates.Pensionsmarkering) ? isUndefined(member.Pensionsmarkering) || member.Pensionsmarkering === null ? '' : member.Pensionsmarkering : updates.Pensionsmarkering === null ? '' : updates.Pensionsmarkering,
                    Indmeldelsesdato: isUndefined(updates.Indmeldelsesdato) ? isUndefined(member.Indmeldelsesdato) || member.Indmeldelsesdato === null ? (0, _moment2.default)(new Date()).format(_config2.default.formats.dateFormat) : (0, _moment2.default)(member.Indmeldelsesdato).format(_config2.default.formats.dateFormat) : updates.Indmeldelsesdato === null ? (0, _moment2.default)(new Date()).format(_config2.default.formats.dateFormat) : (0, _moment2.default)(updates.Indmeldelsesdato).format(_config2.default.formats.dateFormat),
                    Udmeldelsesdato: isUndefined(updates.Udmeldelsesdato) ? isUndefined(member.Udmeldelsesdato) || member.Udmeldelsesdato === null ? '' : (0, _moment2.default)(member.Udmeldelsesdato).format(_config2.default.formats.dateFormat) : updates.Udmeldelsesdato === null ? '' : (0, _moment2.default)(updates.Udmeldelsesdato).format(_config2.default.formats.dateFormat),
                    Bemaerkninger: isUndefined(updates.Bemaerkninger) ? isUndefined(member.Bemaerkninger) || member.Bemaerkninger === null ? '' : member.Bemaerkninger : updates.Bemaerkninger === null ? '' : updates.Bemaerkninger,
                    Passiv: isUndefined(updates.Passiv) ? isUndefined(member.Passiv) || member.Passiv === null ? 0 : member.Passiv : updates.Passiv === null ? 0 : updates.Passiv,
                    ModtagerIkkeBrevduen: isUndefined(updates.ModtagerIkkeBrevduen) ? isUndefined(member.ModtagerIkkeBrevduen) || member.ModtagerIkkeBrevduen === null ? -1 : member.ModtagerIkkeBrevduen : updates.ModtagerIkkeBrevduen === null ? -1 : updates.ModtagerIkkeBrevduen,
                    ModtagMetode: isUndefined(updates.ModtagMetode) ? isUndefined(member.ModtagMetode) || member.ModtagMetode === null ? null : member.ModtagMetode : updates.ModtagMetode === null ? null : updates.ModtagMetode,
                    SMSabonnement: isUndefined(updates.SMSabonnement) ? isUndefined(member.SMSabonnement) || member.SMSabonnement === null ? 0 : member.SMSabonnement : updates.SMSabonnement === null ? 0 : updates.SMSabonnement,
                    Modtagernr: isUndefined(updates.Modtagernr) ? isUndefined(member.Modtagernr) || member.Modtagernr === null ? null : member.Modtagernr : updates.Modtagernr === null ? null : updates.Modtagernr,
                    MobilAbonnement: isUndefined(updates.MobilAbonnement) ? isUndefined(member.MobilAbonnement) || member.MobilAbonnement === null ? 0 : member.MobilAbonnement : updates.MobilAbonnement === null ? 0 : updates.MobilAbonnement,
                    DDB_Tauris: isUndefined(updates.DDB_Tauris) ? isUndefined(member.DDB_Tauris) || member.DDB_Tauris === null ? 0 : member.DDB_Tauris : updates.DDB_Tauris === null ? 0 : updates.DDB_Tauris,
                    UNIKON_SMS: isUndefined(updates.UNIKON_SMS) ? isUndefined(member.UNIKON_SMS) || member.UNIKON_SMS === null ? 0 : member.UNIKON_SMS : updates.UNIKON_SMS === null ? 0 : updates.UNIKON_SMS,
                    Inaktiv: isUndefined(updates.Inaktiv) ? isUndefined(member.Inaktiv) || member.Inaktiv === null ? 0 : member.Inaktiv : updates.Inaktiv === null ? 0 : updates.Inaktiv,
                    DataOnWeb: isUndefined(updates.DataOnWeb) ? isUndefined(member.DataOnWeb) || member.DataOnWeb === null ? -1 : member.DataOnWeb : updates.DataOnWeb === null ? -1 : updates.DataOnWeb,
                    TlfOnWeb: isUndefined(updates.TlfOnWeb) ? isUndefined(member.TlfOnWeb) || member.TlfOnWeb === null ? -1 : member.TlfOnWeb : updates.TlfOnWeb === null ? -1 : updates.TlfOnWeb,
                    AdrOnWeb: isUndefined(updates.AdrOnWeb) ? isUndefined(member.AdrOnWeb) || member.AdrOnWeb === null ? -1 : member.AdrOnWeb : updates.AdrOnWeb === null ? -1 : updates.AdrOnWeb,
                    Dispensation: isUndefined(updates.Dispensation) ? isUndefined(member.Dispensation) || member.Dispensation === null ? 0 : member.Dispensation : updates.Dispensation === null ? 0 : updates.Dispensation,
                    DispensationTekst: isUndefined(updates.DispensationTekst) ? isUndefined(member.DispensationTekst) || member.DispensationTekst === null ? '' : member.DispensationTekst : updates.DispensationTekst === null ? '' : updates.DispensationTekst
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var updateReq = this.props.isNew || this.props.club === null || this.props.member === null ? null : this.props.club.UpdateRequests.find(function (req) {
                return req.type === 'member' && req.key === _this2.props.member.Medlemsnr;
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            var editMode = this.props.editMode;
            var receivMethods = [{ key: 1, value: 'Modtag med post' }, { key: 2, value: 'Modtag via forening' }, { key: 3, value: 'Modtag elektronisk' }];
            var smsReceivers = [{ key: 1, value: 'Send til medlem tlf' }, { key: 2, value: 'Send til slag tlf' }];
            return _react2.default.createElement(
                'div',
                { className: "form-page member-markings " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Foedselsdato) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Foedselsdato' },
                                        'F\xF8dselsdato'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Foedselsdato) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Foedselsdato', id: 'Foedselsdato', maxLength: '10', value: this.state.Foedselsdato,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Foedselsdato
                                ),
                                isUndefined(updates.Foedselsdato) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Foedselsdato === null ? (0, _dataUtil.formatNullable)(null) : (0, _moment2.default)(this.props.member.Foedselsdato).format(_config2.default.formats.dateFormat)) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Pensionsmarkering) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Pensionsmarkering' },
                                        'Pens.markering'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Pensionsmarkering) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', title: 'Tilladt v\xE6rdi: I',
                                    name: 'Pensionsmarkering', id: 'Pensionsmarkering', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "I" }], value: this.state.Pensionsmarkering,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true, errorMessageOverride: 'Tilladte v\xE6rdier er I',
                                    onChange: this.onUpperCaseFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Pensionsmarkering
                                ),
                                isUndefined(updates.Pensionsmarkering) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Pensionsmarkering) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Indmeldelsesdato) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Indmeldelsesdato' },
                                        'Indmeldelsesdato'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Indmeldelsesdato) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Indmeldelsesdato', id: 'Indmeldelsesdato', maxLength: '10', value: this.state.Indmeldelsesdato,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Indmeldelsesdato
                                ),
                                isUndefined(updates.Indmeldelsesdato) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Indmeldelsesdato === null ? (0, _dataUtil.formatNullable)(null) : (0, _moment2.default)(this.props.member.Indmeldelsesdato).format(_config2.default.formats.dateFormat)) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Udmeldelsesdato) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Udmeldelsesdato' },
                                        'Udmeldelsesdato'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Udmeldelsesdato) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Udmeldelsesdato', id: 'Udmeldelsesdato', maxLength: '10', value: this.state.Udmeldelsesdato,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Udmeldelsesdato
                                ),
                                isUndefined(updates.Udmeldelsesdato) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Udmeldelsesdato === null ? (0, _dataUtil.formatNullable)(null) : (0, _moment2.default)(this.props.member.Udmeldelsesdato).format(_config2.default.formats.dateFormat)) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'title-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Bemaerkninger) ? "" : " updated"), colSpan: 4 },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Bemaerkninger' },
                                        'Bem\xE6rkninger'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'editor-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Bemaerkninger) ? "" : " updated"), colSpan: 4, style: { height: '125px' } },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.text, placeholder: '', className: 'field-1', style: { height: '100px' },
                                    name: 'Bemaerkninger', id: 'Bemaerkninger', maxLength: '255', value: this.state.Bemaerkninger,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bemaerkninger
                                ),
                                isUndefined(updates.Bemaerkninger) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.Bemaerkninger) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'Passiv', name: 'Passiv', type: 'checkbox', checked: this.state.Passiv, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ Passiv: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Passiv' },
                                        'Passivt medlem'
                                    )
                                ),
                                isUndefined(updates.Passiv) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Passiv === 0 ? 'Nej' : 'Ja') + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell data-cell" + (isUndefined(updates.ModtagerIkkeBrevduen) ? "" : " updated"), colSpan: 2 },
                                _react2.default.createElement('input', { id: 'ModtagerIkkeBrevduen', name: 'ModtagerIkkeBrevduen', type: 'checkbox', checked: this.state.ModtagerIkkeBrevduen === 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ ModtagerIkkeBrevduen: e.target.checked ? 0 : -1, ModtagMetode: e.target.checked ? _this2.state.ModtagMetode : null });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'ModtagerIkkeBrevduen' },
                                        'Modtager Brevduen'
                                    )
                                ),
                                isUndefined(updates.ModtagerIkkeBrevduen) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.ModtagerIkkeBrevduen === 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell data-cell" + (isUndefined(updates.ModtagMetode) ? "" : " updated"), colSpan: 2 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, placeholder: '', className: 'field-1 option-buttons',
                                    name: 'ModtagMetode', id: 'ModtagMetode', value: this.state.ModtagMetode, options: receivMethods,
                                    autoCheckErrors: true, required: this.state.ModtagerIkkeBrevduen === 0, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: function onChange(e) {
                                        _this2.setState({ ModtagerIkkeBrevduen: 0, ModtagMetode: Number(e.target.id.split('|')[1]) });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.ModtagMetode === null ? '' : receivMethods.find(function (method) {
                                        return method.key === _this2.state.ModtagMetode;
                                    }).value
                                ),
                                isUndefined(updates.ModtagMetode) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.ModtagMetode === null ? (0, _dataUtil.formatNullable)(null) : receivMethods.find(function (method) {
                                        return method.key === _this2.props.member.ModtagMetode;
                                    }).value) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell data-cell" + (isUndefined(updates.SMSabonnement) ? "" : " updated"), colSpan: 2 },
                                _react2.default.createElement('input', { id: 'SMSabonnement', name: 'SMSabonnement', type: 'checkbox', checked: this.state.SMSabonnement !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ SMSabonnement: e.target.checked ? -1 : 0, Modtagernr: e.target.checked ? _this2.state.Modtagernr : null });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'SMSabonnement' },
                                        'SMS-abonnement'
                                    )
                                ),
                                isUndefined(updates.SMSabonnement) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.SMSabonnement !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell data-cell" + (isUndefined(updates.Modtagernr) ? "" : " updated"), colSpan: 2 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, placeholder: '', className: 'field-1 option-buttons',
                                    name: 'Modtagernr', id: 'Modtagernr', value: this.state.Modtagernr, options: smsReceivers,
                                    autoCheckErrors: true, required: this.state.SMSabonnement !== 0, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: function onChange(e) {
                                        _this2.setState({ SMSabonnement: -1, Modtagernr: Number(e.target.id.split('|')[1]) });
                                    },
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Modtagernr === null ? '' : smsReceivers.find(function (method) {
                                        return method.key === _this2.state.Modtagernr;
                                    }).value
                                ),
                                isUndefined(updates.Modtagernr) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Modtagernr === null ? (0, _dataUtil.formatNullable)(null) : smsReceivers.find(function (method) {
                                        return method.key === _this2.props.member.Modtagernr;
                                    }).value) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'Inaktiv', name: 'Inaktiv', type: 'checkbox', checked: this.state.Inaktiv === 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ Inaktiv: e.target.checked ? 0 : -1 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Inaktiv' },
                                        'Aktiv'
                                    )
                                ),
                                isUndefined(updates.Inaktiv) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Inaktiv === 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'MobilAbonnement', name: 'MobilAbonnement', type: 'checkbox', checked: this.state.MobilAbonnement, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ MobilAbonnement: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'MobilAbonnement' },
                                        'SIM-kort'
                                    )
                                ),
                                isUndefined(updates.MobilAbonnement) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.MobilAbonnement === 0 ? 'Nej' : 'Ja') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'DDB_Tauris', name: 'DDB_Tauris', type: 'checkbox', checked: this.state.DDB_Tauris !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ DDB_Tauris: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'DDB_Tauris' },
                                        'DDB-Tauris'
                                    )
                                ),
                                isUndefined(updates.DDB_Tauris) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.DDB_Tauris !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'UNIKON_SMS', name: 'UNIKON_SMS', type: 'checkbox', checked: this.state.UNIKON_SMS !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ UNIKON_SMS: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'UNIKON_SMS' },
                                        'UNIKON-SMS'
                                    )
                                ),
                                isUndefined(updates.UNIKON_SMS) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.UNIKON_SMS !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'DataOnWeb', name: 'DataOnWeb', type: 'checkbox', checked: this.state.DataOnWeb !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ DataOnWeb: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'DataOnWeb' },
                                        'Data p\xE5 internet'
                                    )
                                ),
                                isUndefined(updates.DataOnWeb) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.DataOnWeb !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'TlfOnWeb', name: 'TlfOnWeb', type: 'checkbox', checked: this.state.TlfOnWeb !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ TlfOnWeb: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'TlfOnWeb' },
                                        'Tlf. p\xE5 internet'
                                    )
                                ),
                                isUndefined(updates.TlfOnWeb) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.TlfOnWeb !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'AdrOnWeb', name: 'AdrOnWeb', type: 'checkbox', checked: this.state.AdrOnWeb !== 0, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState({ AdrOnWeb: e.target.checked ? -1 : 0 });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'AdrOnWeb' },
                                        'Adr. p\xE5 internet'
                                    )
                                ),
                                isUndefined(updates.AdrOnWeb) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.AdrOnWeb !== 0 ? 'Ja' : 'Nej') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Opdater publiseringsvalg for alle medlemmer i foreningen', disabled: editMode || this.props.club === null, onClick: function onClick() {
                                            if (_this2.props.club !== null) (0, _confirmDialog.confirm)("Opdater medlemmer", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at s\xE6tte publiseringsvalg for alle medlemmer i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    _this2.props.club.Foreningsnr,
                                                    ' ',
                                                    _this2.props.club.Navn
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.dispatch(AdminActions.setWebPublishingForClub(_this2.props.club.Foreningsnr, {
                                                    DataOnWeb: _this2.state.DataOnWeb,
                                                    TlfOnWeb: _this2.state.TlfOnWeb,
                                                    AdrOnWeb: _this2.state.AdrOnWeb
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Datapubliceringsvalgene er kopieret til alle medlemmer i forening " + _this2.props.club.Foreningsnr + " " + _this2.props.club.Navn + ".", "Opdatering", 4000);
                                                    if (!_this2.props.isNew) _this2.props.dispatch(AdminActions.getMember(_this2.props.member.Medlemsnr));
                                                }));
                                            });
                                        } },
                                    'S\xE6t i forening'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell data-cell' },
                                _react2.default.createElement('input', { id: 'Dispensation', name: 'Dispensation', type: 'checkbox', checked: this.state.Dispensation, disabled: !editMode, onChange: function onChange(e) {
                                        _this2.setState(e.target.checked ? { Dispensation: -1 } : { Dispensation: 0, DispensationTekst: '' });
                                    } }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Dispensation' },
                                        'Dispensation'
                                    )
                                ),
                                isUndefined(updates.Dispensation) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (this.props.member.Dispensation === 0 ? 'Nej' : 'Ja') + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.DispensationTekst) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast \xE5rsag til dispensation', className: 'field-1 field100p',
                                    name: 'DispensationTekst', id: 'DispensationTekst', maxLength: '30', value: this.state.DispensationTekst, disabled: !this.state.Dispensation,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[7] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.DispensationTekst
                                ),
                                isUndefined(updates.DispensationTekst) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.member.DispensationTekst) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    'Tidligere forening'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'data-cell' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    typeof this.props.member.Tidl_forening === 'undefined' ? null : this.props.member.Tidl_forening
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    'Sidst rettet'
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'data-cell' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    typeof this.props.member.Sidst_aendret === 'undefined' || this.props.member.Sidst_aendret === null ? null : (0, _moment2.default)(this.props.member.Sidst_aendret).format(_config2.default.formats.dateFormat)
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return MemberMarkings;
}(_react2.default.Component);

MemberMarkings.propTypes = {
    editMode: _propTypes2.default.bool,
    club: _propTypes2.default.object,
    member: _propTypes2.default.object,
    isNew: _propTypes2.default.bool,
    newMemberNumber: _propTypes2.default.string
};
MemberMarkings.defaultProps = {
    editMode: false,
    isNew: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(MemberMarkings);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.optionsDialogGeneral = optionsDialogGeneral;
exports.optionsDialog = optionsDialog;

var _reactConfirm = __webpack_require__(88);

var _OptionsDialog = __webpack_require__(795);

var _OptionsDialog2 = _interopRequireDefault(_OptionsDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Taken from the react-confirm manual: https://www.npmjs.com/package/react-confirm

// create confirm function
var confirmation = (0, _reactConfirm.createConfirmation)(_OptionsDialog2.default);

// This is optional. But I recommend to define your confirm function easy to call.
function optionsDialogGeneral(title, text, choices) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirmation(_extends({ title: title, text: text, choices: choices, options: options }, options));
}

// A version of the confirm function, which is a little easier to use in the normal use-case (We don't have to write ".then(...)").
function optionsDialog(title, text, choices, onOk) {
    var onCancel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (onCancel == null) onCancel = function onCancel() {};
    return optionsDialogGeneral(title, text, choices, options).then(onOk, onCancel);
}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactConfirm = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Do not use this component directly. Use it with utils/optionsDialog.js instead.
 *  (This might not be the redux way of doing it, but in this case i think it is ok, since the redux way seems overly complex (can't put callbacks in the store, so how to react to ok/cancel, for example).
 */

// See the react-confirm manual: https://www.npmjs.com/package/react-confirm. (Note: This function is a *stateless* react component).
var OptionsDialog = function OptionsDialog(_ref) {
    var show = _ref.show,
        proceed = _ref.proceed,
        dismiss = _ref.dismiss,
        cancel = _ref.cancel,
        title = _ref.title,
        text = _ref.text,
        choices = _ref.choices,
        options = _ref.options;
    return _react2.default.createElement(
        _reactModal2.default,
        { isOpen: show, shouldCloseOnOverlayClick: false, style: modalDialogStyles },
        _react2.default.createElement(
            'div',
            { className: 'modalDialogContent optionsDialog' },
            _react2.default.createElement(
                'h2',
                null,
                title
            ),
            _react2.default.createElement(
                'p',
                { style: Object.assign({ paddingTop: "14px", paddingBottom: "20px", maxHeight: "400px", overflowY: "auto" }, options.textAlign ? { textAlign: options.textAlign } : {}) },
                text
            ),
            choices.map(function (option, ix) {
                return _react2.default.createElement(
                    'button',
                    { type: 'submit', key: ix, className: 'btn-secondary', onClick: function onClick() {
                            return proceed(option);
                        } },
                    option
                );
            }),
            _react2.default.createElement(
                'button',
                { type: 'submit', className: 'btn-primary', onClick: function onClick() {
                        return cancel('this is an argument for the cancel callback!');
                    } },
                'Annuller'
            )
        )
    );
};

OptionsDialog.propTypes = {
    show: _propTypes2.default.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: _propTypes2.default.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: _propTypes2.default.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: _propTypes2.default.func, // from confirmable. call to only close the dialog.
    title: _propTypes2.default.string, // arguments of your confirm function
    text: _propTypes2.default.node, // arguments of your confirm function
    choices: _propTypes2.default.array, // arguments of your confirm function
    options: _propTypes2.default.object // arguments of your confirm function
};

var modalDialogStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 99999
    },
    content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: "0px",
        background: "none",
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '0px',
        outline: 'none',
        padding: '20px',
        textAlign: "center"
    }
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
exports.default = (0, _reactConfirm.confirmable)(OptionsDialog);

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _PigeonHoleGeneral = __webpack_require__(797);

var _PigeonHoleGeneral2 = _interopRequireDefault(_PigeonHoleGeneral);

var _PigeonHolePigeons = __webpack_require__(798);

var _PigeonHolePigeons2 = _interopRequireDefault(_PigeonHolePigeons);

var _PigeonHoleVaccination = __webpack_require__(799);

var _PigeonHoleVaccination2 = _interopRequireDefault(_PigeonHoleVaccination);

var _Util = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PigeonHolePage = function (_React$Component) {
    _inherits(PigeonHolePage, _React$Component);

    _createClass(PigeonHolePage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_PIGEON_HOLE;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function PigeonHolePage(props) {
        _classCallCheck(this, PigeonHolePage);

        var _this = _possibleConstructorReturn(this, (PigeonHolePage.__proto__ || Object.getPrototypeOf(PigeonHolePage)).call(this, props));

        _this.loadPigeonHole = function (newestProps) {
            var club = newestProps.admin.clubs ? newestProps.admin.clubs.get(newestProps.params.clubNo) || null : null;
            if (club === null || typeof club.isFullLoaded === 'undefined') newestProps.dispatch(AdminActions.getClub(newestProps.params.clubNo));
            if (!newestProps.params.holeNo.toLowerCase().startsWith('new')) newestProps.dispatch(AdminActions.getPigeonHole(newestProps.params.clubNo, newestProps.params.holeNo));
        };

        return _this;
    }

    _createClass(PigeonHolePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadPigeonHole(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.clubNo !== this.props.params.clubNo || nextProps.params.holeNo !== this.props.params.holeNo) this.loadPigeonHole(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var clubNo = this.props.params.clubNo;
            var club = clubNo.toLowerCase() === 'new' || !this.props.admin.clubs ? null : this.props.admin.clubs.get(clubNo) || null;
            var holeNo = this.props.params.holeNo.toLowerCase().startsWith('new') ? this.props.params.holeNo.substring(3) : this.props.params.holeNo;
            var hole = holeNo === '' ? null : this.props.params.holeNo.toLowerCase().startsWith('new') ? club === null ? null : club.UpdateRequests.find(function (req) {
                return req.type === 'pigeonhole' && req.newKey === holeNo;
            }) || null : !this.props.admin.pigeonHoles ? null : this.props.admin.pigeonHoles.get(clubNo + '-' + holeNo) || null;
            if (this.props.params.holeNo.toLowerCase().startsWith('new') && hole !== null) hole = JSON.parse(hole.updates);
            if (club === null || holeNo !== '' && (hole === null || !this.props.params.holeNo.toLowerCase().startsWith('new') && typeof hole.isFullLoaded === 'undefined')) return null;

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_PigeonHoleGeneral2.default, { club: club, pigeonhole: hole, isNew: this.props.params.holeNo.toLowerCase().startsWith('new'), editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'pigeons':
                    subPage = _react2.default.createElement(_PigeonHolePigeons2.default, { club: club, pigeonhole: hole, isNew: this.props.params.holeNo.toLowerCase().startsWith('new'), editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'vaccination':
                    subPage = _react2.default.createElement(_PigeonHoleVaccination2.default, { club: club, pigeonhole: hole, isNew: this.props.params.holeNo.toLowerCase().startsWith('new'), editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
            }

            var updateReq = this.props.params.holeNo.toLowerCase().startsWith('new') || club === null ? null : club.UpdateRequests.find(function (req) {
                return req.type === 'pigeonhole' && req.key === holeNo;
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        holeNo.toLowerCase() === 'new' ? 'Nyt slag' : 'Slag ' + holeNo + ' - ' + (hole === null || typeof hole.Slagnavn === 'undefined' ? '' : hole.Slagnavn),
                        ' (',
                        'Forening ' + clubNo + ', ' + club.Navn,
                        ')'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _PigeonHoleGeneral.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'pigeons' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _PigeonHoleGeneral.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "pigeons").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Duebestand'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'vaccination' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + ((0, _Util.hasCommonProps)(updates, _PigeonHoleGeneral.defaultState) ? ' has-updates' : ''), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "vaccination").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Vaccination'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger slag', disabled: this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && (this.props.auth.currentRole !== _UserRoles2.default.CLUB_ADMIN.id || this.props.auth.currentEntity !== clubNo), onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', _this2.props.params.holeNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ) : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(":subpage", "pigeon-holes").replace(":mode", "view"), title: "Vis forening " + clubNo },
                            'Forening ',
                            clubNo
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_CLUBS, title: 'Vis alle foreninger' },
                            'Foreninger'
                        )
                    )] : [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (clubNo, holeNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _this2.props.params.holeNo.toLowerCase() === 'new' ? "Slaget er oprettet" : "Slaget er opdateret." : (_this2.props.params.holeNo.toLowerCase() === 'new' ? "Nyt slag" : "Ændringer") + " er lagt til godkendelse.", _this2.props.params.holeNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        var holeNo1 = _this2.props.params.holeNo.toLowerCase().startsWith('new') ? _this2.props.params.holeNo.substring(3) : _this2.props.params.holeNo;
                                        var holeNo2 = holeNo.toLowerCase().startsWith('new') ? holeNo.substring(3) : holeNo;
                                        var holeUrl = _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? holeNo2 : _this2.props.params.holeNo.toLowerCase().startsWith('new') ? holeNo.toLowerCase().startsWith('new') ? holeNo : 'new' + holeNo : holeNo1;
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(':holeNo', holeUrl).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (holeNo === '') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', 'pigeon-holes').replace(':mode', 'view')));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', _this2.props.params.holeNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return PigeonHolePage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            members: state.admin.members,
            pigeonHoles: state.admin.pigeonHoles
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PigeonHolePage);

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Foreningsnr: '',
    Slagnr: '',
    Slagnavn: '',
    Omraadenr: '',
    CHR: '',
    LagMellem: '',
    Markering1: '',
    Markering2: '',
    Laengde_grader: '',
    Laengde_min: '',
    Laengde_sek: '',
    Laengde_100_dele_sek: '',
    Laengde_1000_dele_min: '',
    Bredde_grader: '',
    Bredde_min: '',
    Bredde_sek: '',
    Bredde_100_dele_sek: '',
    Bredde_1000_dele_min: ''
};

var PigeonHoleGeneral = function (_React$Component) {
    _inherits(PigeonHoleGeneral, _React$Component);

    function PigeonHoleGeneral(props) {
        _classCallCheck(this, PigeonHoleGeneral);

        var _this = _possibleConstructorReturn(this, (PigeonHoleGeneral.__proto__ || Object.getPrototypeOf(PigeonHoleGeneral)).call(this, props));

        _this.fields = [];

        _this.onClubNumberFieldChange = function (e) {
            if (e.target.value.length === 3) {
                var club = _this.props.admin.clubs.get(e.target.value) || null;
                if (club === null || typeof club.isFullLoaded === 'undefined') _this.props.dispatch(AdminActions.getClub(e.target.value));
            }
            _this.onStandardFieldChange(e);
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Foreningsnr: _this.state.Foreningsnr === '' ? null : _this.state.Foreningsnr,
                    Slagnr: _this.state.Slagnr === '' ? null : _this.state.Slagnr,
                    Slagnavn: _this.state.Slagnavn === '' ? null : _this.state.Slagnavn,
                    Omraadenr: _this.state.Omraadenr === '' ? null : _this.state.Omraadenr,
                    CHR: _this.state.CHR === '' ? null : _this.state.CHR,
                    LagMellem: _this.state.LagMellem === '' ? null : _this.state.LagMellem,
                    Markering1: _this.state.Markering1 === '' ? null : _this.state.Markering1,
                    Markering2: _this.state.Markering2 === '' ? null : _this.state.Markering2,
                    Laengde_grader: _this.state.Laengde_grader === '' ? null : Number(_this.state.Laengde_grader),
                    Laengde_min: _this.state.Laengde_min === '' ? null : Number(_this.state.Laengde_min),
                    Laengde_sek: _this.state.Laengde_sek === '' ? null : Number(_this.state.Laengde_sek),
                    Laengde_100_dele_sek: _this.state.Laengde_100_dele_sek === '' ? null : Number(_this.state.Laengde_100_dele_sek),
                    Laengde_1000_dele_min: _this.state.Laengde_1000_dele_min === '' ? null : Number(_this.state.Laengde_1000_dele_min),
                    Bredde_grader: _this.state.Bredde_grader === '' ? null : Number(_this.state.Bredde_grader),
                    Bredde_min: _this.state.Bredde_min === '' ? null : Number(_this.state.Bredde_min),
                    Bredde_sek: _this.state.Bredde_sek === '' ? null : Number(_this.state.Bredde_sek),
                    Bredde_100_dele_sek: _this.state.Bredde_100_dele_sek === '' ? null : Number(_this.state.Bredde_100_dele_sek),
                    Bredde_1000_dele_min: _this.state.Bredde_1000_dele_min === '' ? null : Number(_this.state.Bredde_1000_dele_min)
                };
                if (_this.props.pigeonhole === null) _this.props.dispatch(AdminActions.createPigeonHole(entity, onSuccess));else _this.props.dispatch(AdminActions.updatePigeonHole(_this.props.club.Foreningsnr, (_this.props.isNew ? 'new' : '') + _this.props.pigeonhole.Slagnr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(PigeonHoleGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.club === null && this.props.club !== null || nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr) || nextProps.pigeonhole === null && this.props.pigeonhole !== null || nextProps.pigeonhole !== null && (this.props.pigeonhole === null || this.props.pigeonhole.Slagnr !== nextProps.pigeonhole.Slagnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.pigeonhole === null) return Object.assign({}, defaultState, {
                Foreningsnr: props.club && props.club.Foreningsnr !== null ? props.club.Foreningsnr : ''
            });else {
                var club = props.club;
                var pigeonhole = props.pigeonhole;
                var updateReq = props.isNew ? null : club.UpdateRequests.find(function (req) {
                    return req.type === 'pigeonhole' && req.key === props.pigeonhole.Slagnr;
                }) || null;
                var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
                return {
                    Foreningsnr: isUndefined(updates.Foreningsnr) ? isUndefined(pigeonhole.Foreningsnr) || pigeonhole.Foreningsnr === null ? '' : pigeonhole.Foreningsnr : updates.Foreningsnr === null ? '' : updates.Foreningsnr,
                    Slagnr: isUndefined(updates.Slagnr) ? isUndefined(pigeonhole.Slagnr) || pigeonhole.Slagnr === null ? '' : pigeonhole.Slagnr : updates.Slagnr === null ? '' : updates.Slagnr,
                    Slagnavn: isUndefined(updates.Slagnavn) ? isUndefined(pigeonhole.Slagnavn) || pigeonhole.Slagnavn === null ? '' : pigeonhole.Slagnavn : updates.Slagnavn === null ? '' : updates.Slagnavn,
                    Omraadenr: isUndefined(updates.Omraadenr) ? isUndefined(pigeonhole.Omraadenr) || pigeonhole.Omraadenr === null ? '' : pigeonhole.Omraadenr : updates.Omraadenr === null ? '' : updates.Omraadenr,
                    CHR: isUndefined(updates.CHR) ? isUndefined(pigeonhole.CHR) || pigeonhole.CHR === null ? '' : pigeonhole.CHR : updates.CHR === null ? '' : updates.CHR,
                    LagMellem: isUndefined(updates.LagMellem) ? isUndefined(pigeonhole.LagMellem) || pigeonhole.LagMellem === null ? '' : pigeonhole.LagMellem : updates.LagMellem === null ? '' : updates.LagMellem,
                    Markering1: isUndefined(updates.Markering1) ? isUndefined(pigeonhole.Markering1) || pigeonhole.Markering1 === null ? '' : pigeonhole.Markering1 : updates.Markering1 === null ? '' : updates.Markering1,
                    Markering2: isUndefined(updates.Markering2) ? isUndefined(pigeonhole.Markering2) || pigeonhole.Markering2 === null ? '' : pigeonhole.Markering2 : updates.Markering2 === null ? '' : updates.Markering2,
                    Laengde_grader: isUndefined(updates.Laengde_grader) ? isUndefined(pigeonhole.Laengde_grader) || pigeonhole.Laengde_grader === null ? '' : String(pigeonhole.Laengde_grader) : updates.Laengde_grader === null ? '' : String(updates.Laengde_grader),
                    Laengde_min: isUndefined(updates.Laengde_min) ? isUndefined(pigeonhole.Laengde_min) || pigeonhole.Laengde_min === null ? '' : String(pigeonhole.Laengde_min) : updates.Laengde_min === null ? '' : String(updates.Laengde_min),
                    Laengde_sek: isUndefined(updates.Laengde_sek) ? isUndefined(pigeonhole.Laengde_sek) || pigeonhole.Laengde_sek === null ? '' : String(pigeonhole.Laengde_sek) : updates.Laengde_sek === null ? '' : String(updates.Laengde_sek),
                    Laengde_100_dele_sek: isUndefined(updates.Laengde_100_dele_sek) ? isUndefined(pigeonhole.Laengde_100_dele_sek) || pigeonhole.Laengde_100_dele_sek === null ? '' : String(pigeonhole.Laengde_100_dele_sek) : updates.Laengde_100_dele_sek === null ? '' : String(updates.Laengde_100_dele_sek),
                    Laengde_1000_dele_min: isUndefined(updates.Laengde_1000_dele_min) ? isUndefined(pigeonhole.Laengde_1000_dele_min) || pigeonhole.Laengde_1000_dele_min === null ? '' : String(pigeonhole.Laengde_1000_dele_min) : updates.Laengde_1000_dele_min === null ? '' : String(updates.Laengde_1000_dele_min),
                    Bredde_grader: isUndefined(updates.Bredde_grader) ? isUndefined(pigeonhole.Bredde_grader) || pigeonhole.Bredde_grader === null ? '' : String(pigeonhole.Bredde_grader) : updates.Bredde_grader === null ? '' : String(updates.Bredde_grader),
                    Bredde_min: isUndefined(updates.Bredde_min) ? isUndefined(pigeonhole.Bredde_min) || pigeonhole.Bredde_min === null ? '' : String(pigeonhole.Bredde_min) : updates.Bredde_min === null ? '' : String(updates.Bredde_min),
                    Bredde_sek: isUndefined(updates.Bredde_sek) ? isUndefined(pigeonhole.Bredde_sek) || pigeonhole.Bredde_sek === null ? '' : String(pigeonhole.Bredde_sek) : updates.Bredde_sek === null ? '' : String(updates.Bredde_sek),
                    Bredde_100_dele_sek: isUndefined(updates.Bredde_100_dele_sek) ? isUndefined(pigeonhole.Bredde_100_dele_sek) || pigeonhole.Bredde_100_dele_sek === null ? '' : String(pigeonhole.Bredde_100_dele_sek) : updates.Bredde_100_dele_sek === null ? '' : String(updates.Bredde_100_dele_sek),
                    Bredde_1000_dele_min: isUndefined(updates.Bredde_1000_dele_min) ? isUndefined(pigeonhole.Bredde_1000_dele_min) || pigeonhole.Bredde_1000_dele_min === null ? '' : String(pigeonhole.Bredde_1000_dele_min) : updates.Bredde_1000_dele_min === null ? '' : String(updates.Bredde_1000_dele_min)
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var updateReq = this.props.isNew || this.props.pigeonhole === null ? null : this.props.club.UpdateRequests.find(function (req) {
                return req.type === 'pigeonhole' && req.key === _this2.props.pigeonhole.Slagnr;
            }) || null;
            var updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            var editMode = this.props.editMode;
            return _react2.default.createElement(
                'div',
                { className: "form-page pigeon-hole-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Foreningsnr' },
                                        'Foreningsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated") },
                                editMode && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Foreningsnr,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onClubNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Foreningsnr
                                ),
                                isUndefined(updates.Foreningsnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Foreningsnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 2 },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.props.admin.clubs.get(this.state.Foreningsnr) ? this.props.admin.clubs.get(this.state.Foreningsnr).Navn : null
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagnr' },
                                        'Slagnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Slagnr', id: 'Slagnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Slagnr,
                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagnr
                                ),
                                isUndefined(updates.Slagnr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Slagnr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'LagMellem' },
                                        'Lag'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagnr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'LagMellem', id: 'LagMellem', maxLength: '1', value: this.state.LagMellem,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.LagMellem
                                ),
                                isUndefined(updates.LagMellem) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.LagMellem) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Omraadenr) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Omraadenr' },
                                        'Omr\xE5de'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Omraadenr) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Omraadenr', id: 'Omraadenr', maxLength: '5', value: this.state.Omraadenr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    isError: this.state.Omraadenr !== "" && !this.props.admin.ranges.get(this.state.Omraadenr), errorMessageOverride: 'Omr\xE5denummer er ikke oprettet',
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Omraadenr
                                ),
                                isUndefined(updates.Omraadenr) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'value-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Omraadenr) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.CHR) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'CHR' },
                                        'CHR'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.CHR) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'CHR', id: 'CHR', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{5,6}" }], value: this.state.CHR,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.CHR
                                ),
                                isUndefined(updates.CHR) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'value-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.CHR) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Slagnavn) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Slagnavn' },
                                        'Slagnavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Slagnavn) ? "" : " updated"), colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Slagnavn', id: 'Slagnavn', maxLength: '50', value: this.state.Slagnavn,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Slagnavn
                                ),
                                isUndefined(updates.Slagnavn) ? null : [editMode ? null : _react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Slagnavn) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Markering1) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Markering1' },
                                        'Junior/Pensionist'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Markering1) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', title: 'J eller P',
                                    name: 'Markering1', id: 'Markering1', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "J|P" }], value: this.state.Markering1,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onUpperCaseFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[6] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Markering1
                                ),
                                isUndefined(updates.Markering1) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Markering1) + ')'
                                )]
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Markering2) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Markering2' },
                                        'Begynder'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" + (isUndefined(updates.Markering2) ? "" : " updated") },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', title: 'Tilladt v\xE6rdi: B',
                                    name: 'Markering2', id: 'Markering2', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "B" }], value: this.state.Markering2,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onUpperCaseFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[7] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Markering2
                                ),
                                isUndefined(updates.Markering2) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                    'span',
                                    { className: 'original-value', key: 'original' },
                                    '(' + (0, _dataUtil.formatNullable)(this.props.pigeonhole.Markering2) + ')'
                                )]
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('td', null),
                            _react2.default.createElement(
                                'td',
                                { className: 'label-cell', colSpan: 3 },
                                _react2.default.createElement(
                                    'span',
                                    { className: "label-text coordinate-field" + (isUndefined(updates.Laengde_grader) && isUndefined(updates.Bredde_grader) ? "" : " updated") },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_grader' },
                                        'Grader'
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "label-text coordinate-field" + (isUndefined(updates.Laengde_min) && isUndefined(updates.Bredde_min) ? "" : " updated") },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_min' },
                                        'Min.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "label-text coordinate-field" + (isUndefined(updates.Laengde_sek) && isUndefined(updates.Bredde_sek) ? "" : " updated") },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_sek' },
                                        'Sek.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "label-text coordinate-field" + (isUndefined(updates.Laengde_100_dele_sek) && isUndefined(updates.Bredde_100_dele_sek) ? "" : " updated") },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_100_dele_sek' },
                                        '100-dele sek.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "label-text coordinate-field" + (isUndefined(updates.Laengde_1000_dele_min) && isUndefined(updates.Bredde_1000_dele_min) ? "" : " updated") },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_100_dele_sek' },
                                        '1000-dele min.'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Laengde_grader) && isUndefined(updates.Laengde_min) && isUndefined(updates.Laengde_sek) && isUndefined(updates.Laengde_100_dele_sek) && isUndefined(updates.Laengde_100_dele_sek) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Laengde_grader' },
                                        'L\xE6ngde'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'data-cell', colSpan: 3 },
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Laengde_grader) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Laengde_grader', id: 'Laengde_grader', maxLength: '3', value: this.state.Laengde_grader,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[8] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Laengde_grader
                                    ),
                                    isUndefined(updates.Laengde_grader) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Laengde_grader === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Laengde_grader)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Laengde_min) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Laengde_min', id: 'Laengde_min', maxLength: '3', value: this.state.Laengde_min,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[9] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Laengde_min
                                    ),
                                    isUndefined(updates.Laengde_min) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Laengde_min === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Laengde_min)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Laengde_sek) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Laengde_sek', id: 'Laengde_sek', maxLength: '3', value: this.state.Laengde_sek,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[10] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Laengde_sek
                                    ),
                                    isUndefined(updates.Laengde_sek) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Laengde_sek === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Laengde_sek)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Laengde_100_dele_sek) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Laengde_100_dele_sek', id: 'Laengde_100_dele_sek', maxLength: '3', value: this.state.Laengde_100_dele_sek,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[11] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Laengde_100_dele_sek
                                    ),
                                    isUndefined(updates.Laengde_100_dele_sek) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Laengde_100_dele_sek === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Laengde_100_dele_sek)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Laengde_1000_dele_min) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Laengde_1000_dele_min', id: 'Laengde_1000_dele_min', maxLength: '3', value: this.state.Laengde_1000_dele_min,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[12] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Laengde_1000_dele_min
                                    ),
                                    isUndefined(updates.Laengde_1000_dele_min) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Laengde_1000_dele_min === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Laengde_1000_dele_min)) + ')'
                                    )]
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" + (isUndefined(updates.Bredde_grader) && isUndefined(updates.Bredde_min) && isUndefined(updates.Bredde_sek) && isUndefined(updates.Bredde_100_dele_sek) && isUndefined(updates.Bredde_100_dele_sek) ? "" : " updated") },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Bredde_grader' },
                                        'Bredde'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'data-cell', colSpan: 3 },
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Bredde_grader) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Bredde_grader', id: 'Bredde_grader', maxLength: '3', value: this.state.Bredde_grader,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[13] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Bredde_grader
                                    ),
                                    isUndefined(updates.Bredde_grader) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Bredde_grader === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Bredde_grader)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Bredde_min) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Bredde_min', id: 'Bredde_min', maxLength: '3', value: this.state.Bredde_min,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[14] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Bredde_min
                                    ),
                                    isUndefined(updates.Bredde_min) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Bredde_min === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Bredde_min)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Bredde_sek) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Bredde_sek', id: 'Bredde_sek', maxLength: '3', value: this.state.Bredde_sek,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[15] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Bredde_sek
                                    ),
                                    isUndefined(updates.Bredde_sek) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Bredde_sek === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Bredde_sek)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Bredde_100_dele_sek) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Bredde_100_dele_sek', id: 'Bredde_100_dele_sek', maxLength: '3', value: this.state.Bredde_100_dele_sek,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[16] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Bredde_100_dele_sek
                                    ),
                                    isUndefined(updates.Bredde_100_dele_sek) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Bredde_100_dele_sek === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Bredde_100_dele_sek)) + ')'
                                    )]
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: "coordinate-field" + (isUndefined(updates.Bredde_1000_dele_min) ? "" : " updated") },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block',
                                        name: 'Bredde_1000_dele_min', id: 'Bredde_1000_dele_min', maxLength: '3', value: this.state.Bredde_1000_dele_min,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[17] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Bredde_1000_dele_min
                                    ),
                                    isUndefined(updates.Bredde_1000_dele_min) ? null : [_react2.default.createElement('br', { key: 'lf' }), _react2.default.createElement(
                                        'span',
                                        { className: 'original-value', key: 'original' },
                                        '(' + (this.props.pigeonhole.Bredde_1000_dele_min === null ? (0, _dataUtil.formatNullable)(null) : String(this.props.pigeonhole.Bredde_1000_dele_min)) + ')'
                                    )]
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PigeonHoleGeneral;
}(_react2.default.Component);

PigeonHoleGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    club: _propTypes2.default.object,
    pigeonhole: _propTypes2.default.object,
    isNew: _propTypes2.default.bool
};
PigeonHoleGeneral.defaultProps = {
    editMode: false,
    isNew: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            ranges: state.admin.ranges
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(PigeonHoleGeneral);

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PigeonHolePigeons = function (_React$Component) {
    _inherits(PigeonHolePigeons, _React$Component);

    function PigeonHolePigeons(props) {
        _classCallCheck(this, PigeonHolePigeons);

        var _this = _possibleConstructorReturn(this, (PigeonHolePigeons.__proto__ || Object.getPrototypeOf(PigeonHolePigeons)).call(this, props));

        _this.pigeonFields = [];
        _this.seriesFields = [];
        _this.groupFields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onRingChange = function (e) {
            var stateVariable = e.target.name;
            if (new RegExp("^[0-9]{9}$").test(e.target.value)) {
                _this.setState(_defineProperty({}, stateVariable, e.target.value.substr(0, 3) + "-" + e.target.value.substr(3, 2) + "-" + e.target.value.substr(-4)));
            } else _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onGenderKeyPress = function (e) {
            var stateVariable = e.target.name;
            switch (e.key) {
                case 'a':
                case 'A':
                    console.log("AAAA");
                    _this.setState(_defineProperty({}, stateVariable, "A"));
                    e.preventDefault();
                    break;
                case 'u':
                case 'U':
                    _this.setState(_defineProperty({}, stateVariable, "U"));
                    e.preventDefault();
                    break;
                case 'x':
                case 'X':
                    _this.setState(_defineProperty({}, stateVariable, "X"));
                    e.preventDefault();
                    break;
                case ' ':
                    if (_this.state[stateVariable] === "A") _this.setState(_defineProperty({}, stateVariable, "U"));else if (_this.state[stateVariable] === "U") _this.setState(_defineProperty({}, stateVariable, "X"));else _this.setState(_defineProperty({}, stateVariable, "A"));
                    e.preventDefault();
                    break;
            }
            console.log("Event", e.key);
        };

        _this.allInputValid = function (fields) {
            var result = true;
            fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.saveRow = function () {
            if (_this.allInputValid(_this.pigeonFields)) {
                var entity = {
                    Ringnummer: _this.state.Ringnummer,
                    Koen: _this.state.Koen
                };
                if (_this.state.editIx === 'new') {
                    entity.Foreningsnr = _this.props.pigeonhole.Foreningsnr;
                    entity.Slagnr = _this.props.pigeonhole.Slagnr;
                    _this.props.dispatch(AdminActions.createPigeon(entity, function () {
                        _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er oprettet.", "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                    }));
                } else _this.props.dispatch(AdminActions.updatePigeon(_this.state.editIx, entity, function () {
                    _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                }));
            } else {
                _this.pigeonFields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.createRings = function () {
            if (_this.allInputValid(_this.seriesFields)) {
                _this.props.dispatch(AdminActions.createPigeons(_this.props.pigeonhole.Foreningsnr, _this.props.pigeonhole.Slagnr, _this.state.serieFrom, _this.state.serieTo, function () {
                    _reactNotifications.NotificationManager.success("Ringserien er oprettet.", "Oprettelse", 4000);
                }));
            } else {
                _this.seriesFields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.updateRings = function () {
            if (_this.allInputValid(_this.groupFields)) {
                var rings = _this.props.pigeonhole.Duer.filter(function (pigeon) {
                    return !_this.state.defaultSelected === _this.state.selected.includes(pigeon.Ringnummer);
                }).map(function (pigeon) {
                    return pigeon.Ringnummer;
                });
                (0, _confirmDialog.confirm)("Opdatering", _react2.default.createElement(
                    'span',
                    null,
                    '\xD8nsker du at opdatere ',
                    rings.length,
                    ' duer?'
                ), function () {
                    var input = {
                        Data: {},
                        Ringnumre: rings
                    };
                    if (_this.state.gender !== "") input.Data.Koen = _this.state.gender;
                    _this.props.dispatch(AdminActions.updatePigeons(_this.props.pigeonhole.Foreningsnr, _this.props.pigeonhole.Slagnr, input, function () {
                        _reactNotifications.NotificationManager.success(rings.length + " duer er opdateret.", "Opdatering", 4000);
                    }));
                });
            } else {
                _this.groupFields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.deleteRings = function () {
            var rings = _this.props.pigeonhole.Duer.filter(function (pigeon) {
                return !_this.state.defaultSelected === _this.state.selected.includes(pigeon.Ringnummer);
            }).map(function (pigeon) {
                return pigeon.Ringnummer;
            });
            (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                'span',
                null,
                '\xD8nsker du at slette ',
                rings.length,
                ' ringnumre?'
            ), function () {
                _this.props.dispatch(AdminActions.deletePigeons(_this.props.pigeonhole.Foreningsnr, _this.props.pigeonhole.Slagnr, {
                    Ringnumre: rings
                }, function () {
                    _reactNotifications.NotificationManager.success(rings.length + " ringnummre er slettet.", "Sletning", 4000);
                    if (!_this.state.defaultSelected) _this.setState({ selected: [] });
                }));
            });
        };

        _this.createNew = function () {
            _this.setState({
                Ringnummer: '',
                Koen: 'X',
                editIx: 'new'
            });
            setTimeout(function () {
                var content = document.getElementById("data-table");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
        };

        _this.state = {
            editIx: null,
            selected: [],
            defaultSelected: false,
            serieFrom: "",
            serieTo: "",
            gender: ""
        };
        return _this;
    }

    _createClass(PigeonHolePigeons, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "form-page pigeon-hole-pigeons" },
                _react2.default.createElement(
                    'div',
                    { className: "left-panel" },
                    _react2.default.createElement(
                        'div',
                        { id: "data-table", className: "top-panel" },
                        _react2.default.createElement(
                            'table',
                            { className: 'data-table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement('th', null),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Ringnummer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'K\xF8n'
                                ),
                                _react2.default.createElement('th', null)
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.props.pigeonhole.Duer.sort(function (p1, p2) {
                                    var result = p1.Ringnummer.substr(-4).localeCompare(p2.Ringnummer.substr(-4), "da-DK");
                                    if (result !== 0) return result;
                                    return p1.Ringnummer.localeCompare(p2.Ringnummer, "da-DK");
                                }).concat(this.state.editIx === 'new' ? [{ Ringnummer: 'new', Koen: 'X' }] : []).map(function (pigeon) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: pigeon.Ringnummer, id: 'row-' + pigeon.Ringnummer },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { type: 'checkbox', checked: !_this2.state.defaultSelected === _this2.state.selected.includes(pigeon.Ringnummer), disabled: _this2.state.editIx !== null, onChange: function onChange(e) {
                                                    var ix = _this2.state.selected.indexOf(pigeon.Ringnummer);
                                                    if (ix > -1) _this2.state.selected.splice(ix, 1);else _this2.state.selected.push(pigeon.Ringnummer);
                                                    _this2.forceUpdate();
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field150', containerClassName: 'display-inline-block',
                                                name: 'Ringnummer', id: 'Ringnummer', maxLength: '11', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "^[0-9]{3}-[0-9]{2}-[0-9]{4}$" }], value: _this2.state.Ringnummer,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: _this2.onRingChange,
                                                ref: function ref(instance) {
                                                    _this2.pigeonFields[0] = instance;
                                                }
                                            }) : pigeon.Ringnummer
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block', title: "A=Han, U=Hun, X=Unge",
                                                name: 'Koen', id: 'Koen', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "^[AUX]$" }], value: _this2.state.Koen,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: _this2.onUpperCaseFieldChange,
                                                onKeyPress: _this2.onGenderKeyPress,
                                                ref: function ref(instance) {
                                                    _this2.pigeonFields[1] = instance;
                                                }
                                            }) : pigeon.Koen
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem due', onClick: _this2.saveRow }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger due', onClick: function onClick() {
                                                    if (_this2.state.editIx === null) {
                                                        _this2.setState({
                                                            Ringnummer: pigeon.Ringnummer,
                                                            Koen: pigeon.Koen,
                                                            editIx: pigeon.Ringnummer
                                                        });
                                                    }
                                                } }), _react2.default.createElement('i', { key: 1,
                                                className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet due', onClick: function onClick() {
                                                    if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette ringnummer ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            pigeon.Ringnummer
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deletePigeon(pigeon.Ringnummer, function () {
                                                            _reactNotifications.NotificationManager.success("Ringnummer " + pigeon.Ringnummer + " er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                } })]
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "bottom-panel" },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Opret ny due', disabled: this.state.editIx !== null, onClick: this.createNew },
                            'Ny'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: "right-panel" },
                    _react2.default.createElement(
                        'div',
                        { className: "first-section counters" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal duer'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal aktive'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Aktiv !== null;
                                        }).length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal unger'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Koen === "X";
                                        }).length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal aktive unger'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Aktiv !== null && pigeon.Koen === "X";
                                        }).length
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "middle-section group-updates" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    { className: "header-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colspan: 2 },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Nummerserier'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'serieFrom' },
                                            'Start'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                            name: 'serieFrom', id: 'serieFrom', maxLength: '4',
                                            autoCheckErrors: false, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            isError: !new RegExp("^[0-9]{1,4}$").test(this.state.serieFrom) || parseInt(this.state.serieFrom) < 1 || parseInt(this.state.serieFrom) > 9999,
                                            errorMessageOverride: 'Skal v\xE6re et heltal mellem 1 og 9999.',
                                            onChange: this.onStandardFieldChange, value: this.state.serieFrom,
                                            ref: function ref(instance) {
                                                _this2.seriesFields[0] = instance;
                                            }
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'serieTo' },
                                            'Slut'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                            name: 'serieTo', id: 'serieTo', maxLength: '4',
                                            autoCheckErrors: false, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            isError: !new RegExp("^[0-9]{1,4}$").test(this.state.serieTo) || parseInt(this.state.serieTo) < 1 || parseInt(this.state.serieTo) > 9999 || new RegExp("^[0-9]{1,4}$").test(this.state.serieFrom) && parseInt(this.state.serieFrom) > parseInt(this.state.serieTo),
                                            errorMessageOverride: "Skal være et heltal mellem " + (new RegExp("^[0-9]{1,4}$").test(this.state.serieFrom) ? parseInt(this.state.serieFrom) : 1) + " og 9999.",
                                            onChange: this.onStandardFieldChange, value: this.state.serieTo,
                                            ref: function ref(instance) {
                                                _this2.seriesFields[1] = instance;
                                            }
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "action-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 2 },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-primary', title: 'Opret nummerserie', disabled: this.state.editIx !== null, onClick: this.createRings },
                                            'Opret ringnumre'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "last-section group-updates" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    { className: "header-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 2 },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Gruppeopdatering'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'gender' },
                                            'K\xF8n'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block', title: "A=Han, U=Hun, X=Unge",
                                            name: 'gender', id: 'gender', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "^[AUX]$" }], value: this.state.gender,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onUpperCaseFieldChange,
                                            onKeyPress: this.onGenderKeyPress,
                                            ref: function ref(instance) {
                                                _this2.groupFields[0] = instance;
                                            }
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "action-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 2 },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-primary', title: this.state.defaultSelected ? "Fjern alle duemarkeringer" : "Marker alle duer", onClick: function onClick() {
                                                    _this2.setState({
                                                        defaultSelected: !_this2.state.defaultSelected,
                                                        selected: []
                                                    });
                                                } },
                                            this.state.defaultSelected ? "Fjern markeringer" : "Marker alle"
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-primary', title: 'Opdater alle markerede duer',
                                                disabled: this.state.editIx !== null || this.state.gender === "" || this.state.defaultSelected && this.state.selected.length >= this.props.pigeonhole.Duer.length || !this.state.defaultSelected && this.state.selected.length <= 0, onClick: this.updateRings },
                                            'Opdater markerede'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-dangerous', title: 'Slet alle markerede duer',
                                                disabled: this.state.editIx !== null || this.state.defaultSelected && this.state.selected.length >= this.props.pigeonhole.Duer.length || !this.state.defaultSelected && this.state.selected.length <= 0, onClick: this.deleteRings },
                                            'Slet markerede'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PigeonHolePigeons;
}(_react2.default.Component);

PigeonHolePigeons.propTypes = {
    pigeonhole: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(PigeonHolePigeons);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PigeonHoleVaccination = function (_React$Component) {
    _inherits(PigeonHoleVaccination, _React$Component);

    function PigeonHoleVaccination(props) {
        _classCallCheck(this, PigeonHoleVaccination);

        var _this = _possibleConstructorReturn(this, (PigeonHoleVaccination.__proto__ || Object.getPrototypeOf(PigeonHoleVaccination)).call(this, props));

        _this.pigeonFields = [];
        _this.groupFields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? -1 : 0));
        };

        _this.allInputValid = function (fields) {
            var result = true;
            fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.saveRow = function () {
            if (_this.allInputValid(_this.pigeonFields)) {
                var entity = {
                    VaccDato1: _this.state.VaccDato1 === "" ? null : (0, _moment2.default)(_this.state.VaccDato1, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    VaccKontrollant1: _this.state.VaccKontrollant1 === "" ? null : _this.state.VaccKontrollant1,
                    Aktiv: _this.state.Aktiv === 0 ? null : "X"
                };
                _this.props.dispatch(AdminActions.updatePigeon(_this.state.editIx, entity, function () {
                    _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                }));
            } else {
                _this.pigeonFields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.updateRings = function () {
            if (_this.allInputValid(_this.groupFields)) {
                var rings = _this.props.pigeonhole.Duer.filter(function (pigeon) {
                    return !_this.state.defaultSelected === _this.state.selected.includes(pigeon.Ringnummer) && (_this.state.ageFilter === "all" || _this.state.ageFilter === "young" && pigeon.Koen === "X" || _this.state.ageFilter === "old" && pigeon.Koen !== "X");
                }).map(function (pigeon) {
                    return pigeon.Ringnummer;
                });
                (0, _confirmDialog.confirm)("Opdatering", _react2.default.createElement(
                    'span',
                    null,
                    '\xD8nsker du at opdatere ',
                    rings.length,
                    ' duer?'
                ), function () {
                    var input = {
                        Data: {},
                        Ringnumre: rings
                    };
                    if (_this.state.vaccDateEnabled) input.Data.VaccDato1 = _this.state.vaccDate === "" ? null : (0, _moment2.default)(_this.state.vaccDate, _config2.default.formats.dateFormat).format('YYYY-MM-DD');
                    if (_this.state.vaccControllerEnabled) input.Data.VaccKontrollant1 = _this.state.vaccController === "" ? null : _this.state.vaccController;
                    if (_this.state.activeEnabled) input.Data.Aktiv = _this.state.active === 0 ? null : "X";
                    _this.props.dispatch(AdminActions.updatePigeons(_this.props.pigeonhole.Foreningsnr, _this.props.pigeonhole.Slagnr, input, function () {
                        _reactNotifications.NotificationManager.success(rings.length + " duer er opdateret.", "Opdatering", 4000);
                    }));
                });
            } else {
                _this.groupFields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.deleteInactive = function () {
            var rings = _this.props.pigeonhole.Duer.filter(function (pigeon) {
                return pigeon.VaccDato1 === null && (_this.state.ageFilter === "all" || _this.state.ageFilter === "young" && pigeon.Koen === "X" || _this.state.ageFilter === "old" && pigeon.Koen !== "X");
            }).map(function (pigeon) {
                return pigeon.Ringnummer;
            });
            (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                'span',
                null,
                '\xD8nsker du at slette ',
                rings.length,
                ' ringnumre?'
            ), function () {
                _this.props.dispatch(AdminActions.deletePigeons(_this.props.pigeonhole.Foreningsnr, _this.props.pigeonhole.Slagnr, {
                    Ringnumre: rings
                }, function () {
                    _reactNotifications.NotificationManager.success(rings.length + " ringnummre er slettet.", "Sletning", 4000);
                    _this.setState({ selected: _this.state.selected.filter(function (ring) {
                            return !rings.includes(ring);
                        }) });
                }));
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
        };

        var now = new Date();
        var yr = now.getFullYear().toString();
        _this.state = {
            editIx: null,
            selected: [],
            defaultSelected: false,
            vaccDateEnabled: 0,
            vaccDate: "",
            vaccControllerEnabled: 0,
            vaccController: "",
            activeEnabled: 0,
            active: 0,
            year: yr.substr(yr.length - 2),
            ageFilter: "all"
        };
        return _this;
    }

    _createClass(PigeonHoleVaccination, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var pigeons = this.props.pigeonhole.Duer.filter(function (pigeon) {
                return _this2.state.ageFilter === "all" || _this2.state.ageFilter === "young" && pigeon.Koen === "X" || _this2.state.ageFilter === "old" && pigeon.Koen !== "X";
            }).sort(function (p1, p2) {
                var result = p1.Ringnummer.substr(-4).localeCompare(p2.Ringnummer.substr(-4), "da-DK");
                if (result !== 0) return result;
                return p1.Ringnummer.localeCompare(p2.Ringnummer, "da-DK");
            });
            var selectedRings = pigeons.map(function (pigeon) {
                return pigeon.Ringnummer;
            }).filter(function (ring) {
                return _this2.state.selected.includes(ring);
            });
            return _react2.default.createElement(
                'div',
                { className: "form-page pigeon-hole-vaccination" },
                _react2.default.createElement(
                    'div',
                    { className: "left-panel" },
                    _react2.default.createElement(
                        'div',
                        { id: "data-table", className: "top-panel" },
                        _react2.default.createElement(
                            'table',
                            { className: 'data-table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement('th', null),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Ringnummer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'K\xF8n'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Vaccinationsdato'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Kontrollant'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Aktiv'
                                ),
                                _react2.default.createElement('th', null)
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                pigeons.map(function (pigeon) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: pigeon.Ringnummer, id: 'row-' + pigeon.Ringnummer },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { type: 'checkbox', checked: !_this2.state.defaultSelected === _this2.state.selected.includes(pigeon.Ringnummer), disabled: _this2.state.editIx !== null, onChange: function onChange(e) {
                                                    var ix = _this2.state.selected.indexOf(pigeon.Ringnummer);
                                                    if (ix > -1) _this2.state.selected.splice(ix, 1);else _this2.state.selected.push(pigeon.Ringnummer);
                                                    _this2.forceUpdate();
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            pigeon.Ringnummer
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            pigeon.Koen
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                                name: 'VaccDato1', id: 'VaccDato1', maxLength: '10', value: _this2.state.VaccDato1,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                                onChange: _this2.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.pigeonFields[0] = instance;
                                                }
                                            }) : pigeon.VaccDato1 === null ? null : (0, _moment2.default)(pigeon.VaccDato1).format(_config2.default.formats.dateFormat)
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                                name: 'VaccKontrollant1', id: 'VaccKontrollant1', maxLength: '25', value: _this2.state.VaccKontrollant1,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: _this2.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.pigeonFields[1] = instance;
                                                }
                                            }) : pigeon.VaccKontrollant1
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'center' },
                                            _this2.state.editIx === pigeon.Ringnummer ? _react2.default.createElement('input', { type: 'checkbox', name: 'Aktiv', id: 'Aktiv', checked: _this2.state.Aktiv !== 0, onChange: _this2.onCheckFieldChange }) : pigeon.Aktiv
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this2.state.editIx === pigeon.Ringnummer ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem due', onClick: _this2.saveRow }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger due', onClick: function onClick() {
                                                    if (_this2.state.editIx === null) {
                                                        _this2.setState({
                                                            VaccDato1: pigeon.VaccDato1 === null ? "" : (0, _moment2.default)(pigeon.VaccDato1).format(_config2.default.formats.dateFormat),
                                                            VaccKontrollant1: pigeon.VaccKontrollant1,
                                                            Aktiv: pigeon.Aktiv === null ? 0 : -1,
                                                            editIx: pigeon.Ringnummer
                                                        });
                                                    }
                                                } })]
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "bottom-panel" },
                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, placeholder: '', className: 'field-1 option-buttons',
                            name: 'ageFilter', id: 'ageFilter', value: this.state.ageFilter, options: [{ key: "all", value: "Vis alle" }, { key: "old", value: "Vis kun gamle" }, { key: "young", value: "Vis kun unger" }],
                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                            onChange: this.onStandardFieldChange
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: "right-panel" },
                    _react2.default.createElement(
                        'div',
                        { className: "first-section counters" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal duer'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal aktive'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Aktiv !== null;
                                        }).length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal unger'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Koen === "X";
                                        }).length
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label" },
                                        'Antal aktive unger'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "value" },
                                        this.props.pigeonhole.Duer.filter(function (pigeon) {
                                            return pigeon.Aktiv !== null && pigeon.Koen === "X";
                                        }).length
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "last-section group-updates" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    { className: "header-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 2 },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Gruppeopdatering'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement('input', { type: 'checkbox', name: 'vaccDateEnabled', id: 'vaccDateEnabled', checked: this.state.vaccDateEnabled !== 0, onChange: this.onCheckFieldChange }),
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'vaccDateEnabled' },
                                            'Vaccinationsdato'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                            name: 'vaccDate', id: 'vaccDate', maxLength: '10', value: this.state.vaccDate,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            onKeyPress: this.onGenderKeyPress,
                                            disabled: this.state.vaccDateEnabled === 0,
                                            ref: function ref(instance) {
                                                _this2.groupFields[0] = instance;
                                            }
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement('input', { type: 'checkbox', name: 'vaccControllerEnabled', id: 'vaccControllerEnabled', checked: this.state.vaccControllerEnabled !== 0, onChange: this.onCheckFieldChange }),
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'vaccControllerEnabled' },
                                            'Kontrollant'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                            name: 'vaccController', id: 'vaccController', maxLength: '25', value: this.state.vaccController,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            onKeyPress: this.onGenderKeyPress,
                                            disabled: this.state.vaccControllerEnabled === 0,
                                            ref: function ref(instance) {
                                                _this2.groupFields[1] = instance;
                                            }
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "form-row" },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement('input', { type: 'checkbox', name: 'activeEnabled', id: 'activeEnabled', checked: this.state.activeEnabled !== 0, onChange: this.onCheckFieldChange }),
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'activeEnabled' },
                                            'Aktiv'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement('input', { type: 'checkbox', name: 'active', id: 'active', checked: this.state.active !== 0, onChange: this.onCheckFieldChange, disabled: this.state.activeEnabled === 0 })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: "action-row" },
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 2 },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-primary', title: this.state.defaultSelected ? "Fjern alle duemarkeringer" : "Marker alle duer", onClick: function onClick() {
                                                    _this2.setState({
                                                        defaultSelected: !_this2.state.defaultSelected,
                                                        selected: []
                                                    });
                                                } },
                                            this.state.defaultSelected ? "Fjern markeringer" : "Marker alle"
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-primary', title: 'Opdater alle markerede duer',
                                                disabled: this.state.editIx !== null || !this.state.vaccDateEnabled && !this.state.vaccControllerEnabled && !this.state.activeEnabled || this.state.defaultSelected && selectedRings.length >= pigeons.length || !this.state.defaultSelected && selectedRings.length <= 0, onClick: this.updateRings },
                                            'Opdater markerede'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn-dangerous', title: 'Slet alle ikke vaccinerede duer',
                                                disabled: this.state.editIx !== null || !pigeons.some(function (pigeon) {
                                                    return pigeon.VaccDato1 === null;
                                                }), onClick: this.deleteInactive },
                                            'Slet ikke vaccinerede'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PigeonHoleVaccination;
}(_react2.default.Component);

PigeonHoleVaccination.propTypes = {
    pigeonhole: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(PigeonHoleVaccination);

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionsPage = function (_React$Component) {
    _inherits(SectionsPage, _React$Component);

    _createClass(SectionsPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_SECTIONS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function SectionsPage(props) {
        _classCallCheck(this, SectionsPage);

        return _possibleConstructorReturn(this, (SectionsPage.__proto__ || Object.getPrototypeOf(SectionsPage)).call(this, props));
    }

    _createClass(SectionsPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getSections());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.admin.isSectionsRead ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Sektioner'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row' },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Navn'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.admin.sections.sort(function (c1, c2) {
                                return c1.Sektionsnr < c2.Sektionsnr ? -1 : 1;
                            }).toArray().map(function (section) {
                                //const updates = section.UpdateRequests.find(update => update.type === 'club') || null;
                                return _react2.default.createElement(
                                    'tr',
                                    { key: section.Sektionsnr /*className={updates === null ? '' : (updates.key === null ? 'new' : (updates.deleted ? 'deleted' : 'updated'))}*/, onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        section.Sektionsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        section.Navn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'edit'), title: 'Rediger sektion' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash pointer", title: 'Slet sektion', onClick: function onClick() {
                                                (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette sektion ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        section.Sektionsnr,
                                                        ' (',
                                                        section.Navn,
                                                        ')'
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteSection(section.Sektionsnr, function () {
                                                        _reactNotifications.NotificationManager.success("Sektion " + section.Sektionsnr + " (" + section.Navn + ") er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { className: "btn-primary", to: _routeconstants.ROUTE_SECTION.replace(':sectionNo', 'new').replace(':subpage', 'general').replace(':mode', 'create'), title: 'Opret ny sektion' },
                        'Ny'
                    )
                )
            ) : null;
        }
    }]);

    return SectionsPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            isSectionsRead: state.admin.isSectionsRead,
            sections: state.admin.sections
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SectionsPage);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _SectionGeneral = __webpack_require__(802);

var _SectionGeneral2 = _interopRequireDefault(_SectionGeneral);

var _SectionContacts = __webpack_require__(803);

var _SectionContacts2 = _interopRequireDefault(_SectionContacts);

var _StationSelection = __webpack_require__(386);

var _StationSelection2 = _interopRequireDefault(_StationSelection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionPage = function (_React$Component) {
    _inherits(SectionPage, _React$Component);

    _createClass(SectionPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_SECTION;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function SectionPage(props) {
        _classCallCheck(this, SectionPage);

        var _this = _possibleConstructorReturn(this, (SectionPage.__proto__ || Object.getPrototypeOf(SectionPage)).call(this, props));

        _this.loadSection = function (newestProps) {
            if (newestProps.params.sectionNo.toLowerCase() !== 'new') {
                newestProps.dispatch(AdminActions.getSection(newestProps.params.sectionNo, function () {
                    _this.forceUpdate();
                }));
            }
        };

        _this.subForm = null;
        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        var now = new Date();
        var yrFull = (now.getFullYear() + (now.getMonth() >= 9 ? 1 : 0)).toString();
        _this.state = {
            stationMode: 'section'
        };
        return _this;
    }

    _createClass(SectionPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadSection(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.sectionNo !== this.props.params.sectionNo) this.loadSection(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // Get club from Redux state.
            var sectionNo = this.props.params.sectionNo;
            var section = sectionNo.toLowerCase() === 'new' || !this.props.admin.sections ? null : this.props.admin.sections.get(sectionNo) || null;
            if (sectionNo.toLowerCase() !== 'new' && (section === null || typeof section.isFullLoaded === 'undefined')) return null;
            var subPage = null;

            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_SectionGeneral2.default, { section: section, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;

                case "contacts":
                    subPage = _react2.default.createElement(_SectionContacts2.default, { section: section, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;

                case 'clubs':
                    subPage = _react2.default.createElement(
                        'table',
                        { className: 'data-table section-clubs-list' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row' },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Navn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Kommune'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            section === null ? [] : this.props.admin.clubs.filter(function (club) {
                                return club.Sektionsnr === sectionNo;
                            }).sort(function (m1, m2) {
                                return m1.Foreningsnr < m2.Foreningsnr ? -1 : 1;
                            }).toArray().map(function (club) {
                                return _react2.default.createElement(
                                    'tr',
                                    { key: club.Foreningsnr },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        club.Foreningsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        club.Navn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        club.Kommune
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'edit'), title: 'Rediger medlem' },
                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash pointer", title: 'Slet forening', onClick: function onClick() {
                                                (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette forening ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        club.Foreningsnr + ' (' + club.Navn + ')'
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteClub(club.Foreningsnr, function () {
                                                        _reactNotifications.NotificationManager.success('Forening ' + club.Foreningsnr + ' (' + club.Navn + ') er slettet', "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                );
                            })
                        )
                    );
                    break;

                case 'stations':
                    subPage = _react2.default.createElement(_StationSelection2.default, { targetId: sectionNo });
                    break;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        sectionNo.toLowerCase() === 'new' ? 'Ny sektion' : 'Sektion ' + sectionNo + ' - ' + section.Navn
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'contacts' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "contacts").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Kontakter'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'clubs' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "clubs").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Foreninger'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'stations' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SECTION.replace(":sectionNo", sectionNo).replace(":subpage", "stations").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Stationsvalg'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' || this.props.params.subpage === 'contacts' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger sektion', disabled: !this.props.auth.isMainAdmin && (!this.props.auth.isClubAdmin || this.props.auth.clubNumber !== sectionNo), onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ) : null,
                        this.props.params.subpage === 'clubs' ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: "btn-primary", to: _routeconstants.ROUTE_CLUB.replace(':clubNo', 'new').replace(':subpage', 'general').replace(':mode', 'create'), title: 'Opret ny forening' },
                            'Ny'
                        ) : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_SECTIONS, title: 'Vis alle sektioner' },
                            'Sektioner'
                        )
                    )] : [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (sectionNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.params.sectionNo.toLowerCase() === 'new' ? "Sektionen er oprettet" : "Sektionen er opdateret.", _this2.props.params.sectionNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (sectionNo.toLowerCase() === 'new') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SECTIONS));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SECTION.replace(':sectionNo', sectionNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return SectionPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isClubAdmin: state.auth.isClubAdmin,
            isMainAdmin: state.auth.isMainAdmin
        },
        admin: {
            sections: state.admin.sections,
            clubs: state.admin.clubs,
            stations: state.admin.stations
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SectionPage);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _Util = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Sektionsnr: '',
    Navn: '',
    WebSite: '',
    Bank: '',
    Regnr: '',
    Kontonr: ''
};

var SectionGeneral = function (_React$Component) {
    _inherits(SectionGeneral, _React$Component);

    function SectionGeneral(props) {
        _classCallCheck(this, SectionGeneral);

        var _this = _possibleConstructorReturn(this, (SectionGeneral.__proto__ || Object.getPrototypeOf(SectionGeneral)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Sektionsnr: _this.state.Sektionsnr,
                    Navn: _this.state.Navn,
                    WebSite: _this.state.WebSite === '' ? null : _this.state.WebSite,
                    Bank: _this.state.Bank === '' ? null : _this.state.Bank,
                    Regnr: _this.state.Regnr === '' ? null : _this.state.Regnr,
                    Kontonr: _this.state.Kontonr === '' ? null : _this.state.Kontonr
                };
                if (_this.props.section === null) _this.props.dispatch(AdminActions.createSection(entity, onSuccess));else _this.props.dispatch(AdminActions.updateSection(_this.props.section.Sektionsnr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SectionGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.section.Sektionsnr !== nextProps.section.Sektionsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section === null) return defaultState;else {
                var section = props.section;
                return {
                    Sektionsnr: section.Sektionsnr === null ? '' : section.Sektionsnr,
                    Navn: section.Navn === null ? '' : section.Navn,
                    WebSite: section.WebSite === null ? '' : section.WebSite,
                    Bank: section.Bank === null ? '' : section.Bank,
                    Regnr: section.Regnr === null ? '' : section.Regnr,
                    Kontonr: section.Kontonr === null ? '' : section.Kontonr
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            /*     const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
                 const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);*/
            var editMode = this.props.editMode;
            return _react2.default.createElement(
                'div',
                { className: "form-page club-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Sektionsnr' },
                                        'Sektionsnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'Sektionsnr',
                                    id: 'Sektionsnr',
                                    maxLength: '2',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }],
                                    value: this.state.Sektionsnr,
                                    autoCheckErrors: true,
                                    required: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Sektionsnr
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Navn' },
                                        'Sektionsnavn'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.string,
                                    placeholder: '',
                                    className: 'field-1 medium-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'Navn',
                                    id: 'Navn',
                                    value: this.state.Navn,
                                    autoCheckErrors: true,
                                    required: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Navn
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Navn' },
                                        'Hjemmeside'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell", colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.string,
                                    placeholder: '',
                                    className: 'field-1 large-field',
                                    name: 'WebSite',
                                    id: 'WebSite',
                                    value: this.state.WebSite,
                                    autoCheckErrors: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.WebSite
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Bank' },
                                        'Bank'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell", colSpan: 3 },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 large-field',
                                    name: 'Bank', id: 'Bank', maxLength: '35', value: this.state.Bank,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bank
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Regnr' },
                                        'Reg.nr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 small-field', containerClassName: 'display-inline-block',
                                    name: 'Regnr', id: 'Regnr', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: this.state.Regnr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Regnr
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kontonr' },
                                        'Kontonr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-field', containerClassName: 'display-inline-block',
                                    name: 'Kontonr', id: 'Kontonr', maxLength: '14', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,14}" }], value: this.state.Kontonr,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kontonr
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SectionGeneral;
}(_react2.default.Component);

SectionGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    section: _propTypes2.default.object
};
SectionGeneral.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SectionGeneral);

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Formand: '',
    Kasserer: '',
    Loeslader: '',
    Edb: ''
};

var SectionContacts = function (_React$Component) {
    _inherits(SectionContacts, _React$Component);

    function SectionContacts(props) {
        _classCallCheck(this, SectionContacts);

        var _this = _possibleConstructorReturn(this, (SectionContacts.__proto__ || Object.getPrototypeOf(SectionContacts)).call(this, props));

        _this.fields = [];

        _this.onMemberNumberFieldChange = function (e) {
            if (e.target.value.length === 6) {
                var member = _this.props.admin.members.get(e.target.value) || null;
                if (member === null) _this.props.dispatch(AdminActions.getMember(e.target.value));
            }
            _this.onStandardFieldChange(e);
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Formand: _this.state.Formand === '' ? null : _this.state.Formand,
                    Kasserer: _this.state.Kasserer === '' ? null : _this.state.Kasserer,
                    Edb: _this.state.Edb === '' ? null : _this.state.Edb,
                    Loeslader: _this.state.Loeslader === '' ? null : _this.state.Loeslader
                };
                if (_this.props.section === null) _this.props.dispatch(AdminActions.createSection(entity, onSuccess));else _this.props.dispatch(AdminActions.updateSection(_this.props.section.Sektionsnr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SectionContacts, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.section.Foreningsnr !== nextProps.section.Foreningsnr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section === null) return defaultState;else {
                var section = props.section;
                return {
                    Formand: section.Formand === null ? '' : section.Formand,
                    Kasserer: section.Kasserer === null ? '' : section.Kasserer,
                    Loeslader: section.Loeslader === null ? '' : section.Loeslader,
                    Edb: section.Edb === null ? '' : section.Edb
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var getContactInfo = function getContactInfo(memberNo) {
                var member = _this2.props.admin.members.get(memberNo) || null;
                var city = member === null || member.Postnr === null ? null : _this2.props.admin.zipCodes.get(member.Postnr) || null;
                return [_react2.default.createElement(
                    'td',
                    { key: 'address', style: { width: "50%" } },
                    _react2.default.createElement(
                        'div',
                        { className: 'address-container' },
                        [member === null || member.Fornavn === null && member.Efternavn === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line1' },
                            (0, _dataUtil.formatNullable)(member.Fornavn, '') + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Efternavn, '')
                        ), member === null || member.C_O_adresse === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line2' },
                            'CO. ',
                            member.C_O_adresse
                        ), member === null || member.Adr === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line3' },
                            member.Adr + (member.Husnr === null && member.Husbogstav === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Husnr, '') + (0, _dataUtil.formatNullable)(member.Husbogstav, '') + (member.Etage === null && member.Placering === null ? '' : ' ') + (0, _dataUtil.formatNullable)(member.Etage, '') + (0, _dataUtil.formatNullable)(member.Placering, '')
                        ), member === null || member.Postboks === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line4' },
                            'Postboks ',
                            member.Postboks
                        ), member === null || member.Postnr === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line5' },
                            member.Postnr + (city === null || city.By === null ? '' : ' ' + city.By)
                        )]
                    )
                ), _react2.default.createElement(
                    'td',
                    { key: 'contact', style: { width: "50%" } },
                    _react2.default.createElement(
                        'div',
                        { className: 'address-container' },
                        [member === null || member.Kontaktnavn === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line1' },
                            member.Kontaktnavn
                        ), member === null || member.Tlf === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line2' },
                            'Tlf. ',
                            _react2.default.createElement(
                                'a',
                                { href: 'tel:' + member.Tlf, tabIndex: -1 },
                                member.Tlf
                            )
                        ), member === null || member.Email === null ? null : _react2.default.createElement(
                            'div',
                            { key: 'line3' },
                            'Email. ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:' + member.Email, tabIndex: -1 },
                                member.Email
                            )
                        )]
                    )
                )];
            };

            var editMode = this.props.editMode;
            var formand = getContactInfo(this.state.Formand);
            var kasserer = getContactInfo(this.state.Kasserer);
            var edb = getContactInfo(this.state.Edb);
            var loeslader = getContactInfo(this.state.Loeslader);
            return _react2.default.createElement(
                'div',
                { className: "form-page club-contacts " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Formand' },
                                        'Formand'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Formand', id: 'Formand', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Formand,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Formand
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            formand
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kasserer' },
                                        'Kasserer'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Kasserer', id: 'Kasserer', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Kasserer,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kasserer
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            kasserer
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Edb-kontakt' },
                                        'Edb-kontakt'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Edb', id: 'Edb', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Edb,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Edb
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            edb
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'address-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Loeslader' },
                                        'L\xF8slader'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 medium-small-field', containerClassName: 'display-inline-block',
                                    name: 'Loeslader', id: 'Loeslader', maxLength: '6', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{6}" }], value: this.state.Loeslader,
                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                    onChange: this.onMemberNumberFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Loeslader
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(
                                    'table',
                                    null,
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            loeslader
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SectionContacts;
}(_react2.default.Component);

SectionContacts.propTypes = {
    editMode: _propTypes2.default.bool,
    section: _propTypes2.default.object
};
SectionContacts.defaultProps = {
    editMode: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            members: state.admin.members,
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SectionContacts);

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _confirmDialog = __webpack_require__(12);

var _lib = __webpack_require__(18);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacesPage = function (_React$Component) {
    _inherits(RacesPage, _React$Component);

    _createClass(RacesPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_RACES;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function RacesPage(props) {
        _classCallCheck(this, RacesPage);

        var _this = _possibleConstructorReturn(this, (RacesPage.__proto__ || Object.getPrototypeOf(RacesPage)).call(this, props));

        _this.state = {
            initialized: false
        };
        return _this;
    }

    _createClass(RacesPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(RaceActions.getRaces());
            this.props.dispatch(AdminActions.getListItems('station'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var week = (0, _lib.isDefined)(this.props.location.query.week) && /^[0-9]{1,2}$/.test(this.props.location.query.week) ? Number(this.props.location.query.week) : (0, _moment2.default)(new Date()).isoWeek();
            var raceWeek = null;
            var raceId = null;
            var result = this.props.race.isRacesRead ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Kapflyvninger'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row' },
                                    'Uge'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Farvekode'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Regi'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'LMU'
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'th',
                                    null,
                                    'Grupper'
                                ) : null,
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sektioner'
                                ) : null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Station'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Navn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Slipdato'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sliptid'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Duer'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.race.races.sort(function (r1, r2) {
                                if (r1.Uge < r2.Uge) return -1;
                                if (r1.Uge > r2.Uge) return 1;
                                if (r1.Farvekode < r2.Farvekode) return -1;
                                if (r1.Farvekode > r2.Farvekode) return 1;
                                if ((0, _lib.nullToBlank)(r1.Sektion) < (0, _lib.nullToBlank)(r2.Sektion)) return -1;
                                if ((0, _lib.nullToBlank)(r1.Sektion) > (0, _lib.nullToBlank)(r2.Sektion)) return 1;
                                if ((0, _lib.nullToBlank)(r1.Sektionsgrupper) < (0, _lib.nullToBlank)(r2.Sektionsgrupper)) return -1;
                                if ((0, _lib.nullToBlank)(r1.Sektionsgrupper) > (0, _lib.nullToBlank)(r2.Sektionsgrupper)) return 1;
                                if ((0, _lib.nullToBlank)(r1.Sektioner) < (0, _lib.nullToBlank)(r2.Sektioner)) return -1;
                                if ((0, _lib.nullToBlank)(r1.Sektioner) > (0, _lib.nullToBlank)(r2.Sektioner)) return 1;
                                return 0;
                            }).toArray().map(function (race) {
                                if (raceWeek === null || race.Uge <= week) {
                                    raceWeek = race.Uge;
                                    raceId = race.Nr;
                                }
                                var kfk = race.Farvekode.substr(0, 2);
                                var sections = (0, _lib.CompressList)(race.Sektioner);
                                var groups = (0, _lib.CompressList)(race.Sektionsgrupper);
                                var station = _this2.props.admin.stations.get(race.Station);
                                return _react2.default.createElement(
                                    'tr',
                                    { key: race.Nr, id: 'row-' + race.Nr, onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        race.Uge
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.Farvekode
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        kfk >= '97' || kfk < '88' ? 'Privat' : kfk >= '95' && kfk <= '96' ? 'Sektion' : 'DdB'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.LMU
                                    ),
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'td',
                                        null,
                                        groups.items.join(',')
                                    ) : null,
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'td',
                                        null,
                                        sections.items.join(',')
                                    ) : null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.Station
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station ? station.Navn : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.SlipDato === null ? null : (0, _moment2.default)(race.SlipDato).format(_config2.default.formats.dateFormat)
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.Sliptid
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        race.AntalDuer
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                            _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                        ),
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(kfk) === 'DdB' ? '' : _routeconstants.ROUTE_RACE.replace(':raceNo', race.Nr).replace(':subpage', 'general').replace(':mode', 'edit'), title: 'Rediger kapflyvning' },
                                            _react2.default.createElement('i', { className: "fa fa-pencil" + (_this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(kfk) === 'DdB' ? ' disabled' : '') })
                                        ),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(kfk) === 'DdB' || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && (0, _lib.getRegi)(kfk) !== 'Privat' || race.Sektion !== null ? 'disabled' : 'pointer clickable'), title: 'Slet kapflyvning', disabled: true, onClick: function onClick() {
                                                if (_this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(kfk) === 'DdB' || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && (0, _lib.getRegi)(kfk) !== 'Privat') return;
                                                (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette kapflyvning ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        race.Farvekode
                                                    ),
                                                    ' i uge ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        race.Uge
                                                    ),
                                                    race.Sektion === null ? '' : _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        ', Sektion ',
                                                        race.Sektion
                                                    ),
                                                    groups.items.length === 0 ? '' : _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        ', Gruppe ',
                                                        groups.items.join(',')
                                                    ),
                                                    sections.items.length === 0 ? '' : _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        ', Sektion ',
                                                        sections.items.join(',')
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(RaceActions.deleteRace(race.Nr, function () {
                                                        _reactNotifications.NotificationManager.success("Kapflyvning " + race.Farvekode + " i uge " + race.Uge + " er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { className: 'btn-primary', to: _routeconstants.ROUTE_RACE.replace(':raceNo', 'new').replace(':subpage', 'general').replace(':mode', 'create'), title: 'Opret ny kapflyvning' },
                        'Ny'
                    )
                )
            ) : null;

            // Scroll to relevant week.
            if (!this.state.initialized && raceId !== null) setTimeout(function () {
                var currentRow = document.getElementById("row-" + raceId);
                currentRow.scrollIntoView(false);
                this.setState({ initialized: true });
                this.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_RACES));
            }.bind(this));

            return result;
        }
    }]);

    return RacesPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole
        },
        admin: {
            stations: state.admin.stations
        },
        race: {
            isRacesRead: state.race.isRacesRead,
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RacesPage);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _lib = __webpack_require__(18);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _RaceGeneral = __webpack_require__(806);

var _RaceGeneral2 = _interopRequireDefault(_RaceGeneral);

var _RaceSignup = __webpack_require__(807);

var _RaceSignup2 = _interopRequireDefault(_RaceSignup);

var _RaceArrival = __webpack_require__(810);

var _RaceArrival2 = _interopRequireDefault(_RaceArrival);

var _RaceWatch = __webpack_require__(812);

var _RaceWatch2 = _interopRequireDefault(_RaceWatch);

var _RaceMemberComp = __webpack_require__(813);

var _RaceMemberComp2 = _interopRequireDefault(_RaceMemberComp);

var _RacePrices = __webpack_require__(814);

var _RacePrices2 = _interopRequireDefault(_RacePrices);

var _RaceDecay = __webpack_require__(816);

var _RaceDecay2 = _interopRequireDefault(_RaceDecay);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacePage = function (_React$Component) {
    _inherits(RacePage, _React$Component);

    _createClass(RacePage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_RACE;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function RacePage(props) {
        _classCallCheck(this, RacePage);

        var _this = _possibleConstructorReturn(this, (RacePage.__proto__ || Object.getPrototypeOf(RacePage)).call(this, props));

        _this.loadRace = function (newestProps) {
            if (newestProps.params.raceNo.toLowerCase() !== 'new') newestProps.dispatch(RaceActions.getRace(newestProps.params.raceNo, function () {
                _this.forceUpdate();
            }));
        };

        _this.subForm = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.setEditMode = function (mode) {
            return _this.setState({ editMode: mode });
        };

        _this.setAllowNew = function (mode) {
            return _this.setState({ allowNew: mode });
        };

        _this.state = {
            editMode: false,
            allowNew: false
        };
        return _this;
    }

    _createClass(RacePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadRace(this.props);
            if (this.props.admin.stations.size === 0) this.props.dispatch(AdminActions.getListItems('station'));
            if (this.props.admin.sections.size === 0) this.props.dispatch(AdminActions.getSections());
            if (!this.props.admin.isClubsRead) this.props.dispatch(AdminActions.getClubs());
            if (this.props.race.deposits.size === 0 || this.props.race.markings.size === 0) this.props.dispatch(RaceActions.getBasics());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.raceNo !== this.props.params.raceNo) this.loadRace(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // Get race from Redux state.
            var raceNo = this.props.params.raceNo;
            var race = raceNo.toLowerCase() === 'new' || !this.props.race.races ? null : this.props.race.races.get(Number(raceNo)) || null;
            if (raceNo.toLowerCase() !== 'new' && (race === null || typeof race.isFullLoaded === 'undefined')) return null;

            var groups = (0, _lib.CompressList)(race === null ? null : race.Sektionsgrupper);
            var sections = (0, _lib.CompressList)(race === null ? null : race.Sektioner);

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    if (this.props.admin.sections.size > 0) subPage = _react2.default.createElement(_RaceGeneral2.default, { race: race, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'signup':
                    subPage = _react2.default.createElement(_RaceSignup2.default, { race: race, setEditMode: this.setEditMode, setAllowNew: this.setAllowNew, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'watch':
                    subPage = _react2.default.createElement(_RaceWatch2.default, { race: race, setEditMode: this.setEditMode, setAllowNew: this.setAllowNew, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'arrival':
                    subPage = _react2.default.createElement(_RaceArrival2.default, { race: race, setEditMode: this.setEditMode, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'member-comp':
                    subPage = _react2.default.createElement(_RaceMemberComp2.default, { race: race, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'prices':
                    subPage = _react2.default.createElement(_RacePrices2.default, { race: race, setEditMode: this.setEditMode, setAllowNew: this.setAllowNew, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'decay':
                    subPage = _react2.default.createElement(_RaceDecay2.default, { race: race, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        raceNo.toLowerCase() === 'new' ? 'Ny kapflyvning' : 'Kapflyvning ' + race.Farvekode + ' i uge ' + String(race.Uge) + (race.Sektion === null ? '' : ', Sektion ' + race.Sektion) + (groups.items.length === 0 ? '' : ', Gruppe ' + groups.items.join(',')) + (sections.items.length === 0 ? '' : ', Sektion ' + sections.items.join(','))
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'signup' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "signup").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Anmeld'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'watch' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "watch").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Ure'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'arrival' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "arrival").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Hjemkomst'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && race !== null && (0, _lib.getRegi)(race.Farvekode) !== 'Sektion' ? null : _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'member-comp' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "member-comp").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Slagspil'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && race !== null && (0, _lib.getRegi)(race.Farvekode) !== 'Sektion' ? null : _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'prices' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "prices").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Pr\xE6mier'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && race !== null ? null : _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'decay' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'), to: this.props.params.mode === 'view' && !this.state.editMode ? _routeconstants.ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "decay").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Forfald'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' && !this.state.editMode ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger kapflyvning', onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ) : null,
                        this.props.params.subpage === 'signup' || this.props.params.subpage === 'watch' || this.props.params.subpage === 'prices' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: this.props.params.subpage === 'watch' ? 'Opret ur' : 'Opret deltager', disabled: !this.state.allowNew, onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().createNew();
                                } },
                            'Ny'
                        ) : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-primary', to: _routeconstants.ROUTE_RACES + '?week=' + race.Uge, title: 'Vis alle kapflyvninger' },
                            'Kapflyvninger'
                        )
                    )] : [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    if (_this2.props.params.subpage === 'general') _this2.subForm.getWrappedInstance().save(function (raceNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.params.raceNo.toLowerCase() === 'new' ? "Kapflyvningen er oprettet" : "Kapflyvningen er opdateret.", _this2.props.params.raceNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });else if (_this2.props.params.subpage === 'signup' || _this2.props.params.subpage === 'watch' || _this2.props.params.subpage === 'arrival' || _this2.props.params.subpage === 'prices') _this2.subForm.getWrappedInstance().save();
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (_this2.props.params.subpage === 'general') {
                                        if (raceNo.toLowerCase() === 'new') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_RACES));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    } else if (_this2.props.params.subpage === 'signup' || _this2.props.params.subpage === 'watch' || _this2.props.params.subpage === 'arrival' || _this2.props.params.subpage === 'prices') _this2.subForm.getWrappedInstance().cancelEdit();
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return RacePage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            stations: state.admin.stations,
            sections: state.admin.sections,
            isClubsRead: state.admin.isClubsRead,
            clubs: state.admin.clubs
        },
        race: {
            races: state.race.races,
            deposits: state.race.deposits,
            markings: state.race.markings
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RacePage);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _lib = __webpack_require__(18);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Uge: '',
    Farvekode: '',
    LMU: 'M',
    Sektion: '',
    Forening: '',
    Sektionsgrupper: '',
    Sektioner: '',
    Station: '',
    SlipDato: '',
    Sliptid: '',
    Gebyr: '0',
    TillaegFastForening: '0',
    TillaegPrDueForening: '0',
    AntalGratisDuer: '0',
    MaxAntDuer: '',
    MaxAntSport: '',
    MaxAntMark: '',
    MaxAntDM: '',
    BudgetAntDuer1: '',
    BudgetAntDuer2: '',
    BudgetAntDuer3: '',
    BudgetAntDuer4: '',
    BudgetAntDuer5: '',
    BudgetAntDuer6: '',
    PraemierPrSektion: 0,
    Kontantpraemier: 0,
    Slagpraemier: 0,
    SlagspilS: 0,
    KlP: 0,
    KlE: 0,
    KlZ: 0,
    KlR: 0,
    KunEnKontantpraemiePrSlag: 0,
    SeriepraemierMinAntalDuer: '',
    SeriepraemierAntalDuer: '',
    SeriepraemierSport: 0,
    SeriepraemierKunSlagspil: 0,
    SeriepraemierProcent: '',
    Kommentarer: '',
    Slip: []
};

var RaceGeneral = function (_React$Component) {
    _inherits(RaceGeneral, _React$Component);

    function RaceGeneral(props) {
        _classCallCheck(this, RaceGeneral);

        var _this = _possibleConstructorReturn(this, (RaceGeneral.__proto__ || Object.getPrototypeOf(RaceGeneral)).call(this, props));

        _this.getReleaseState = function (groups, sections, release) {
            var result = [];
            var singleGroups = (0, _lib.SimpleList)(groups, false);
            var singleSections = (0, _lib.SimpleList)(sections, false);
            if (!singleGroups.isErrors && !singleSections.isErrors && singleGroups.items.length === 0 && singleSections.items.length === 0) {
                _this.props.admin.sections.filter(function (section) {
                    return section.Sektionsnr < '70';
                }).forEach(function (section) {
                    var ix = release.findIndex(function (release) {
                        return release.Sektionsnr === section.Sektionsnr;
                    });
                    result.push({
                        Sektionsnr: section.Sektionsnr,
                        Slipdato: ix < 0 ? '' : release[ix].Slipdato,
                        Sliptid: ix < 0 ? '' : release[ix].Sliptid
                    });
                });
            } else {
                if (!singleGroups.isErrors) {
                    singleGroups.items.forEach(function (group) {
                        _this.props.admin.sections.filter(function (section) {
                            return section.Sektionsnr.substr(0, 1) === group;
                        }).forEach(function (section) {
                            var ix = release.findIndex(function (release) {
                                return release.Sektionsnr === section.Sektionsnr;
                            });
                            result.push({
                                Sektionsnr: section.Sektionsnr,
                                Slipdato: ix < 0 ? '' : release[ix].Slipdato,
                                Sliptid: ix < 0 ? '' : release[ix].Sliptid
                            });
                        });
                    });
                }
                if (!singleSections.isErrors) {
                    singleSections.items.forEach(function (section) {
                        if (result.findIndex(function (release) {
                            return release.Sektionsnr === section;
                        }) < 0) {
                            var ix = release.findIndex(function (release) {
                                return release.Sektionsnr === section;
                            });
                            result.push({
                                Sektionsnr: section,
                                Slipdato: ix < 0 ? '' : release[ix].Slipdato,
                                Sliptid: ix < 0 ? '' : release[ix].Sliptid
                            });
                        }
                    });
                }
            }
            result.forEach(function (section) {
                if (result.findIndex(function (release) {
                    return release.Sektionsnr === section.Sektionsnr.substr(0, 1);
                }) < 0) {
                    var ix = release.findIndex(function (release) {
                        return release.Sektionsnr === section.Sektionsnr.substr(0, 1);
                    });
                    result.push({
                        Sektionsnr: section.Sektionsnr.substr(0, 1),
                        Slipdato: ix < 0 ? '' : release[ix].Slipdato,
                        Sliptid: ix < 0 ? '' : release[ix].Sliptid
                    });
                }
            });
            return result.sort(function (s1, s2) {
                if (s1.Sektionsnr < s2.Sektionsnr) return -1;
                if (s1.Sektionsnr > s2.Sektionsnr) return 1;
                return 0;
            });
        };

        _this.isListError = function (txt) {
            var validateItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var items = (0, _lib.SimpleList)(txt, false, validateItem);
            return items.isErrors;
        };

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Uge: Number(_this.state.Uge),
                    Farvekode: _this.state.Farvekode,
                    LMU: _this.state.LMU,
                    Sektion: (_this.state.Farvekode < '88' || _this.state.Farvekode >= '95') && _this.state.Sektion !== '' ? _this.state.Sektion : null,
                    Sektionsgrupper: _this.state.Farvekode >= '88' && _this.state.Farvekode < '95' && _this.state.Sektionsgrupper !== '' ? (0, _lib.SimpleList)(_this.state.Sektionsgrupper).items.join(',') : null,
                    Sektioner: _this.state.Farvekode >= '88' && _this.state.Farvekode < '95' && _this.state.Sektioner !== '' ? (0, _lib.SimpleList)(_this.state.Sektioner).items.join(',') : null,
                    Forening: _this.state.Forening !== '' ? _this.state.Forening : null,
                    Station: _this.state.Station === '' ? null : _this.state.Station,
                    SlipDato: _this.state.SlipDato === '' ? null : (0, _moment2.default)(_this.state.SlipDato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Sliptid: _this.state.Sliptid === '' ? null : _this.state.Sliptid,
                    Slip: _this.state.Slip.filter(function (section) {
                        return section.Sektionsnr.length === 2 && section.Slipdato !== '' || section.Sliptid !== '';
                    }).map(function (section) {
                        return {
                            Sektionsnr: section.Sektionsnr,
                            Slipdato: section.Slipdato === '' ? null : (0, _moment2.default)(section.Slipdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                            Sliptid: section.Sliptid === '' ? null : section.Sliptid
                        };
                    }),
                    Gebyr: Number(_this.state.Gebyr),
                    TillaegFastForening: Number(_this.state.TillaegFastForening),
                    TillaegPrDueForening: Number(_this.state.TillaegPrDueForening),
                    AntalGratisDuer: Number(_this.state.AntalGratisDuer),
                    MaxAntDuer: _this.state.MaxAntDuer === '' ? null : Number(_this.state.MaxAntDuer),
                    MaxAntSport: _this.state.MaxAntSport === '' ? null : Number(_this.state.MaxAntSport),
                    MaxAntMark: _this.state.MaxAntMark === '' ? null : Number(_this.state.MaxAntMark),
                    MaxAntDM: _this.state.MaxAntDM === '' ? null : Number(_this.state.MaxAntDM),
                    BudgetAntDuer1: _this.state.BudgetAntDuer1 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '1';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer1),
                    BudgetAntDuer2: _this.state.BudgetAntDuer2 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '2';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer2),
                    BudgetAntDuer3: _this.state.BudgetAntDuer3 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '3';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer3),
                    BudgetAntDuer4: _this.state.BudgetAntDuer4 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '4';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer4),
                    BudgetAntDuer5: _this.state.BudgetAntDuer5 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '5';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer5),
                    BudgetAntDuer6: _this.state.BudgetAntDuer6 === '' || _this.state.Slip.findIndex(function (section) {
                        return section.Sektionsnr === '6';
                    }) < 0 ? null : Number(_this.state.BudgetAntDuer6),
                    PraemierPrSektion: _this.state.PraemierPrSektion,
                    Kontantpraemier: _this.state.Kontantpraemier,
                    Slagpraemier: _this.state.Slagpraemier,
                    SlagspilS: _this.state.SlagspilS,
                    KlP: _this.state.KlP,
                    KlE: _this.state.KlE,
                    KlZ: _this.state.KlZ,
                    KlR: _this.state.KlR,
                    KunEnKontantpraemiePrSlag: _this.state.KunEnKontantpraemiePrSlag,
                    Kommentarer: _this.state.Kommentarer === '' ? null : _this.state.Kommentarer
                };
                if (_this.props.race === null) _this.props.dispatch(RaceActions.createRace(entity, onSuccess));else _this.props.dispatch(RaceActions.updateRace(_this.props.race.Nr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(RaceGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.race === null && this.props.race !== null || nextProps.race !== null && (this.props.race === null || this.props.race.Nr !== nextProps.race.Nr)) this.setState(this.getStateFromStore(nextProps));else if (nextProps.editMode && nextProps.race === null) {
                var updates = {};
                if (this.props.settings.deposits.size === 0 && nextProps.settings.deposits.size > 0 || this.props.settings.markings.size === 0 && nextProps.settings.markings.size > 0) {
                    var id = nextProps.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? null : nextProps.auth.currentEntity;
                    var deposit = nextProps.settings.deposits.has(id) ? nextProps.settings.deposits.get(id) : null;
                    var marking = nextProps.settings.markings.has(id) ? nextProps.settings.markings.get(id) : null;
                    if (nextProps.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && deposit !== null) {
                        if (this.state.TillaegFastForening === defaultState.TillaegFastForening) updates.TillaegFastForening = String(deposit.TillaegFastForening);
                        if (this.state.TillaegPrDueForening === defaultState.TillaegPrDueForening) updates.TillaegPrDueForening = String(deposit.TillaegPrDueForening);
                    }
                    if (marking !== null) {
                        if (this.state.KunEnKontantpraemiePrSlag === defaultState.KunEnKontantpraemiePrSlag) updates.KunEnKontantpraemiePrSlag = marking.KunEnKontantpraemiePrSlag;
                    }
                }
                this.setState(updates);
            }
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.race === null) {
                var id = props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? null : props.auth.currentEntity;
                var deposit = props.settings.deposits.has(id) ? props.settings.deposits.get(id) : null;
                var marking = props.settings.markings.has(id) ? props.settings.markings.get(id) : null;
                return Object.assign({}, defaultState, props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id ? { Sektion: props.auth.currentEntity } : {}, props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? { Forening: props.auth.currentEntity, PraemierPrSektion: -1 } : {}, props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && deposit !== null ? {
                    TillaegFastForening: String(deposit.TillaegFastForening),
                    TillaegPrDueForening: String(deposit.TillaegPrDueForening)
                } : {}, marking !== null ? {
                    KunEnKontantpraemiePrSlag: marking.KunEnKontantpraemiePrSlag
                } : {});
            } else {
                var race = props.race;
                var groups = (0, _lib.CompressList)(race.Sektionsgrupper);
                var sections = (0, _lib.CompressList)(race.Sektioner);
                var state = {
                    Uge: race.Uge === null ? '' : String(race.Uge),
                    Farvekode: race.Farvekode === null ? '' : race.Farvekode,
                    LMU: race.LMU === null ? 'M' : race.LMU,
                    Sektion: race.Sektion === null ? '' : race.Sektion,
                    Forening: race.Forening === null ? '' : race.Forening,
                    Sektionsgrupper: groups.items.join(','),
                    Sektioner: sections.items.join(','),
                    Station: race.Station === null ? '' : race.Station,
                    SlipDato: race.SlipDato === null ? '' : (0, _moment2.default)(race.SlipDato).format(_config2.default.formats.dateFormat),
                    Sliptid: race.Sliptid === null ? '' : race.Sliptid,
                    Gebyr: race.Gebyr === null ? '0' : String(race.Gebyr),
                    TillaegFastForening: race.TillaegFastForening === null ? '0' : String(race.TillaegFastForening),
                    TillaegPrDueForening: race.TillaegPrDueForening === null ? '0' : String(race.TillaegPrDueForening),
                    AntalGratisDuer: race.AntalGratisDuer === null ? '0' : String(race.AntalGratisDuer),
                    MaxAntDuer: race.MaxAntDuer === null ? '' : String(race.MaxAntDuer),
                    MaxAntSport: race.MaxAntSport === null ? '' : String(race.MaxAntSport),
                    MaxAntMark: race.MaxAntMark === null ? '' : String(race.MaxAntMark),
                    MaxAntDM: race.MaxAntDM === null ? '' : String(race.MaxAntDM),
                    BudgetAntDuer1: race.BudgetAntDuer1 === null ? '' : String(race.BudgetAntDuer1),
                    BudgetAntDuer2: race.BudgetAntDuer2 === null ? '' : String(race.BudgetAntDuer2),
                    BudgetAntDuer3: race.BudgetAntDuer3 === null ? '' : String(race.BudgetAntDuer3),
                    BudgetAntDuer4: race.BudgetAntDuer4 === null ? '' : String(race.BudgetAntDuer4),
                    BudgetAntDuer5: race.BudgetAntDuer5 === null ? '' : String(race.BudgetAntDuer5),
                    BudgetAntDuer6: race.BudgetAntDuer6 === null ? '' : String(race.BudgetAntDuer6),
                    PraemierPrSektion: race.PraemierPrSektion === null ? 0 : race.PraemierPrSektion,
                    Kontantpraemier: race.Kontantpraemier === null ? 0 : race.Kontantpraemier,
                    Slagpraemier: race.Slagpraemier === null ? 0 : race.Slagpraemier,
                    SlagspilS: race.SlagspilS === null ? 0 : race.SlagspilS,
                    KlP: race.KlP === null ? 0 : race.KlP,
                    KlE: race.KlE === null ? 0 : race.KlE,
                    KlZ: race.KlZ === null ? 0 : race.KlZ,
                    KlR: race.KlR === null ? 0 : race.KlR,
                    KunEnKontantpraemiePrSlag: race.KunEnKontantpraemiePrSlag === null ? 0 : race.KunEnKontantpraemiePrSlag,
                    SeriepraemierMinAntalDuer: race.SeriepraemierMinAntalDuer === null ? '' : String(race.SeriepraemierMinAntalDuer),
                    SeriepraemierAntalDuer: race.SeriepraemierAntalDuer === null ? '' : String(race.SeriepraemierAntalDuer),
                    SeriepraemierSport: race.SeriepraemierSport === null ? 0 : race.SeriepraemierSport,
                    SeriepraemierKunSlagspil: race.SeriepraemierKunSlagspil === null ? 0 : race.SeriepraemierKunSlagspil,
                    SeriepraemierProcent: race.SeriepraemierProcent === null ? '' : String(race.SeriepraemierProcent),
                    Kommentarer: race.Kommentarer === null ? '' : race.Kommentarer,
                    Slip: race.Farvekode !== null && race.Farvekode >= '88' && race.Farvekode < '95' ? this.getReleaseState(groups.items.join(','), sections.items.join(','), race.Slip.map(function (release) {
                        return {
                            Sektionsnr: release.Sektionsnr,
                            Slipdato: release.Slipdato === null ? '' : (0, _moment2.default)(release.Slipdato).format(_config2.default.formats.dateFormat),
                            Sliptid: release.Sliptid === null ? '' : release.Sliptid
                        };
                    })) : []
                };
                return state;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editMode;
            var kfk = this.state.Farvekode;
            var canEditAll = editMode && (this.props.race === null || this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && (0, _lib.getRegi)(kfk) === 'DdB' || this.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && ((0, _lib.getRegi)(kfk) === 'Sektion' || (0, _lib.getRegi)(kfk) === 'Privat') || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && (0, _lib.getRegi)(kfk) === 'Privat' && this.state.Sektion === '');
            var station = this.props.admin.stations.get(this.state.Station);
            var groups = this.state.Slip.filter(function (section) {
                return section.Sektionsnr.length === 1;
            });
            var checkWeek = function checkWeek(dtStr) {
                if (/^[0-9]{1,2}$/.test(_this2.state.Uge) && dtStr !== '') {
                    var dt = (0, _moment2.default)(dtStr, _config2.default.formats.dateFormat, true);
                    if (dt.isValid()) return String(dt.isoWeek()) === _this2.state.Uge || String(dt.isoWeek() - 1) === _this2.state.Uge && dt.isoWeekday() <= 3;
                }
                return true;
            };
            return _react2.default.createElement(
                'div',
                { className: "form-page race-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'left-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'four-columns' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Uge' },
                                                'Uge'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.Uge,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                                //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                , onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            }) : this.state.Uge
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Regi'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _lib.getRegi)(kfk)
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Farvekode' },
                                                'Farvekode'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: 3 },
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', tabIndex: 1,
                                                name: 'Farvekode', id: 'Farvekode', value: this.state.Farvekode, options: [{ key: '81 - Privat', value: '81 - Privat' }, { key: '82 - Privat', value: '82 - Privat' }, { key: '83 - Privat', value: '83 - Privat' }, { key: '84 - Privat', value: '84 - Privat' }, { key: '85 - Privat', value: '85 - Privat' }, { key: '88 - DDB', value: '88 - DDB' }, { key: '89 - Grå skema', value: '89 - Grå skema' }, { key: '90 - Sport', value: '90 - Sport' }, { key: '91 - Orange skema', value: '91 - Orange skema' }, { key: '92 - Grøn skema', value: '92 - Grøn skema' }, { key: '93 - Hvid skema', value: '93 - Hvid skema' }, { key: '94 - Rød skema', value: '94 - Rød skema' }, { key: '95 - Blå skema', value: '95 - Blå skema' }, { key: '96 - Gul skema', value: '96 - Gul skema' }, { key: '97 - Privat', value: '97 - Privat' }, { key: '98 - Privat', value: '98 - Privat' }, { key: '99 - Privat', value: '99 - Privat' }].filter(function (kfk) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && (0, _lib.getRegi)(kfk.key) === 'DdB' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && ((0, _lib.getRegi)(kfk.key) === 'Sektion' || (0, _lib.getRegi)(kfk.key) === 'Privat') || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && (0, _lib.getRegi)(kfk.key) === 'Privat';
                                                }),
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({
                                                        Farvekode: e.target.value,
                                                        Slip: e.target.value >= '88' && e.target.value < '95' ? _this2.getReleaseState(_this2.state.Sektionsgrupper, _this2.state.Sektioner, _this2.state.Slip) : []
                                                    });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[1] = instance;
                                                }
                                            }) : this.state.Farvekode
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Station' },
                                                'Station'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: 3 },
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', tabIndex: 1,
                                                name: 'Station', id: 'Station', value: this.state.Station, options: this.props.admin.stations.sort(function (s1, s2) {
                                                    return s1.Stationsnr < s2.Stationsnr ? -1 : s1.Stationsnr > s2.Stationsnr ? 1 : 0;
                                                }).map(function (station) {
                                                    return { key: station.Stationsnr, value: station.Stationsnr + ' - ' + station.Navn };
                                                }).toArray(),
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[2] = instance;
                                                }
                                            }) : this.state.Station + ' - ' + (station ? station.Navn : '')
                                        )
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && (0, _lib.getRegi)(kfk) !== null && (0, _lib.getRegi)(kfk) !== 'DdB' ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Sektion' },
                                                'Sektion'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Sektion', id: 'Sektion', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: this.state.Sektion,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[3] = instance;
                                                }
                                            }) : this.state.Sektion
                                        )
                                    ) : this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Sektionsgrupper' },
                                                'Sek.grupper'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Sektionsgrupper', id: 'Sektionsgrupper', maxLength: '25', value: this.state.Sektionsgrupper,
                                                autoCheckErrors: false, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                isError: this.isListError(this.state.Sektionsgrupper, function (group) {
                                                    return group.length === 1;
                                                }),
                                                errorMessageOverride: 'Ugyldigt format. Indtast sektionsgrupper adskilt med komma.',
                                                onChange: this.onStandardFieldChange,
                                                onBlur: function onBlur() {
                                                    _this2.fields[4].setState({ focused: false, visited: true });
                                                    var groups = (0, _lib.SimpleList)(_this2.state.Sektionsgrupper, false, function (group) {
                                                        return group.length === 1;
                                                    });
                                                    var sections = (0, _lib.SimpleList)(_this2.state.Sektioner, false, function (group) {
                                                        return group.length === 2;
                                                    });
                                                    if (!groups.isErrors && !sections.isErrors) _this2.setState({
                                                        Sektionsgrupper: (0, _lib.CompressList)(groups.items.join(',')).items.join(','),
                                                        Slip: _this2.state.Farvekode >= '88' && _this2.state.Farvekode < '95' ? _this2.getReleaseState(_this2.state.Sektionsgrupper, _this2.state.Sektioner, _this2.state.Slip) : []
                                                    });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[4] = instance;
                                                }
                                            }) : this.state.Sektionsgrupper
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Sektioner' },
                                                'Sektioner'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Sektioner', id: 'Sektioner', maxLength: '25', value: this.state.Sektioner,
                                                autoCheckErrors: false, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                isError: this.isListError(this.state.Sektioner, function (section) {
                                                    return section.length === 2;
                                                }),
                                                errorMessageOverride: 'Ugyldigt format. Indtast sektioner adskilt med komma.',
                                                onChange: this.onStandardFieldChange,
                                                onBlur: function onBlur() {
                                                    _this2.fields[5].setState({ focused: false, visited: true });
                                                    var groups = (0, _lib.SimpleList)(_this2.state.Sektionsgrupper, false, function (group) {
                                                        return group.length === 1;
                                                    });
                                                    var sections = (0, _lib.SimpleList)(_this2.state.Sektioner, false, function (group) {
                                                        return group.length === 2;
                                                    });
                                                    if (!groups.isErrors && !sections.isErrors) _this2.setState({
                                                        Sektioner: (0, _lib.CompressList)(sections.items.join(',')).items.join(','),
                                                        Slip: _this2.state.Farvekode >= '88' && _this2.state.Farvekode < '95' ? _this2.getReleaseState(_this2.state.Sektionsgrupper, _this2.state.Sektioner, _this2.state.Slip) : []
                                                    });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[5] = instance;
                                                }
                                            }) : this.state.Sektioner
                                        )
                                    ) : _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Slipdato' },
                                                'Slipdato'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'SlipDato', id: 'SlipDato', maxLength: '10', value: this.state.SlipDato,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                isError: !checkWeek(this.state.SlipDato), errorMessageOverride: !checkWeek(this.state.SlipDato) ? 'Dato ligger i forkert uge.' : '',
                                                onChange: this.onStandardFieldChange,
                                                onBlur: function onBlur(e) {
                                                    _this2.fields[6].setState({ focused: false, visited: true });
                                                    var value = (0, _lib.fullfillDate)(_this2.state.SlipDato);
                                                    if (value !== 'error') _this2.setState({ SlipDato: value });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[6] = instance;
                                                }
                                            }) : this.state.SlipDato
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Sliptid' },
                                                'Sliptid'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Sliptid', id: 'Sliptid', maxLength: '5', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]" }], value: this.state.Sliptid,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                onBlur: function onBlur(e) {
                                                    _this2.fields[7].setState({ focused: false, visited: true });
                                                    var value = (0, _lib.fullfillTime)(_this2.state.Sliptid);
                                                    if (value !== 'error') _this2.setState({ Sliptid: value });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[7] = instance;
                                                }
                                            }) : this.state.Sliptid
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                        'div',
                        { className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table three-columns race-releases' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            { scope: 'row' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'header' },
                                                'Sektion/Gruppe'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'release' },
                                                'Standard'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'header' },
                                                'Dato'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'release' },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                    name: 'SlipDato', id: 'SlipDato', maxLength: '10', value: this.state.SlipDato,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    isError: !checkWeek(this.state.SlipDato), errorMessageOverride: !checkWeek(this.state.SlipDato) ? 'Dato ligger i forkert uge.' : '',
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur(e) {
                                                        _this2.fields[6].setState({ focused: false, visited: true });
                                                        var value = (0, _lib.fullfillDate)(_this2.state.SlipDato);
                                                        if (value !== 'error') _this2.setState({ SlipDato: value });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[6] = instance;
                                                    }
                                                }) : this.state.SlipDato
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'header' },
                                                'Klokkeslet'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'release' },
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                    name: 'Sliptid', id: 'Sliptid', maxLength: '5', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]" }], value: this.state.Sliptid,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: this.onStandardFieldChange,
                                                    onBlur: function onBlur(e) {
                                                        _this2.fields[7].setState({ focused: false, visited: true });
                                                        var value = (0, _lib.fullfillTime)(_this2.state.Sliptid);
                                                        if (value !== 'error') _this2.setState({ Sliptid: value });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[7] = instance;
                                                    }
                                                }) : this.state.Sliptid
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.Slip.map(function (section) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: section.Sektionsnr },
                                            _react2.default.createElement(
                                                'th',
                                                { scope: 'row' },
                                                (section.Sektionsnr.length === 1 ? 'Gruppe ' : 'Sektion ') + section.Sektionsnr
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                    name: "Slipdato" + section.Sektionsnr, id: "Slipdato" + section.Sektionsnr, maxLength: '10', value: section.Slipdato,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    isError: !checkWeek(section.Slipdato), errorMessageOverride: !checkWeek(section.Slipdato) ? 'Dato ligger i forkert uge.' : '',
                                                    onChange: function onChange(e) {
                                                        _this2.state.Slip.forEach(function (sect) {
                                                            if (sect.Sektionsnr === section.Sektionsnr) sect.Slipdato = e.target.value;
                                                        });
                                                        _this2.forceUpdate();
                                                    },
                                                    onBlur: function onBlur(e) {
                                                        var fldRef = _this2.fields[section.Sektionsnr.length === 1 ? 100 + Number(section.Sektionsnr) : 200 + Number(section.Sektionsnr)];
                                                        fldRef.setState({ focused: false, visited: true });
                                                        var value = (0, _lib.fullfillDate)(section.Slipdato);
                                                        if (value !== '' && value !== 'error') {
                                                            _this2.state.Slip.forEach(function (sect) {
                                                                if (sect.Sektionsnr.substr(0, section.Sektionsnr.length) === section.Sektionsnr) sect.Slipdato = value;
                                                            });
                                                            _this2.forceUpdate();
                                                        }
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[section.Sektionsnr.length === 1 ? 100 + Number(section.Sektionsnr) : 200 + Number(section.Sektionsnr)] = instance;
                                                    }
                                                }) : section.Slipdato
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                    name: "Sliptid" + section.Sektionsnr, id: "Sliptid" + section.Sektionsnr, maxLength: '5', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]" }], value: section.Sliptid,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: function onChange(e) {
                                                        _this2.state.Slip.forEach(function (sect) {
                                                            if (sect.Sektionsnr === section.Sektionsnr) sect.Sliptid = e.target.value;
                                                        });
                                                        _this2.forceUpdate();
                                                    },
                                                    onBlur: function onBlur(e) {
                                                        var fldRef = _this2.fields[section.Sektionsnr.length === 1 ? 300 + Number(section.Sektionsnr) : 400 + Number(section.Sektionsnr)];
                                                        fldRef.setState({ focused: false, visited: true });
                                                        var value = (0, _lib.fullfillTime)(section.Sliptid);
                                                        if (value !== '' && value !== 'error') {
                                                            _this2.state.Slip.forEach(function (sect) {
                                                                if (sect.Sektionsnr.substr(0, section.Sektionsnr.length) === section.Sektionsnr) sect.Sliptid = value;
                                                            });
                                                            _this2.forceUpdate();
                                                        }
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[section.Sektionsnr.length === 1 ? 300 + Number(section.Sektionsnr) : 400 + Number(section.Sektionsnr)] = instance;
                                                    }
                                                }) : section.Sliptid
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'right-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'four-columns' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Gebyr' },
                                                'Gebyr i \xF8re'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'Gebyr', id: 'Gebyr', value: this.state.Gebyr,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[8] = instance;
                                                }
                                            }) : this.state.Gebyr
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 0 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[0].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[0].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 0 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[0].Sektionsnr, id: "BudgetAntDuer" + groups[0].Sektionsnr, value: this.state["BudgetAntDuer" + groups[0].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[9] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[0].Sektionsnr] : null
                                        )
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'TillaegPrDueForening' },
                                                'Till\xE6g pr. due i \xF8re'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'TillaegPrDueForening', id: 'TillaegPrDueForening', value: this.state.TillaegPrDueForening,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[10] = instance;
                                                }
                                            }) : this.state.TillaegPrDueForening
                                        )
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'TillaegFastForening' },
                                                'Fast till\xE6g i \xF8re'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'TillaegFastForening', id: 'TillaegFastForening', value: this.state.TillaegFastForening,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[11] = instance;
                                                }
                                            }) : this.state.TillaegFastForening
                                        )
                                    ) : null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'AntalGratisDuer' },
                                                'Antal gratis duer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'AntalGratisDuer', id: 'TillaegFastForening', value: this.state.AntalGratisDuer,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[12] = instance;
                                                }
                                            }) : this.state.AntalGratisDuer
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'LMU' },
                                                'Type (L/M/U/O)'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field75p', containerClassName: 'display-inline-block field100p', tabIndex: 1,
                                                name: 'LMU', id: 'LMU', value: this.state.LMU, options: [{ key: 'L', value: 'Lang' }, { key: 'M', value: 'Mellem' }, { key: 'U', value: 'Unge' }, { key: 'O', value: 'O' }],
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[13] = instance;
                                                }
                                            }) : this.state.LMU
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 1 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[1].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[1].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 1 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[1].Sektionsnr, id: "BudgetAntDuer" + groups[1].Sektionsnr, value: this.state["BudgetAntDuer" + groups[1].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[14] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[1].Sektionsnr] : null
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxAntDuer' },
                                                'Max. antal duer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'MaxAntDuer', id: 'MaxAntDuer', value: this.state.MaxAntDuer,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[15] = instance;
                                                }
                                            }) : this.state.MaxAntDuer
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 2 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[2].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[2].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 2 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[2].Sektionsnr, id: "BudgetAntDuer" + groups[2].Sektionsnr, value: this.state["BudgetAntDuer" + groups[2].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[16] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[2].Sektionsnr] : null
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxAntSport' },
                                                'Max. antal sportsduer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'MaxAntSport', id: 'MaxAntSport', value: this.state.MaxAntSport,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[17] = instance;
                                                }
                                            }) : this.state.MaxAntSport
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 3 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[3].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[3].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 3 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[3].Sektionsnr, id: "BudgetAntDuer" + groups[3].Sektionsnr, value: this.state["BudgetAntDuer" + groups[3].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[18] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[3].Sektionsnr] : null
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxAntMark' },
                                                'Max. antal duemark.'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'MaxAntMark', id: 'MaxAntMark', value: this.state.MaxAntMark,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[19] = instance;
                                                }
                                            }) : this.state.MaxAntMark
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 4 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[4].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[4].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 4 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[4].Sektionsnr, id: "BudgetAntDuer" + groups[4].Sektionsnr, value: this.state["BudgetAntDuer" + groups[4].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[20] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[4].Sektionsnr] : null
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxAntDM' },
                                                'Max. antal DM-duer'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            canEditAll ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 1,
                                                name: 'MaxAntDM', id: 'MaxAntDM', value: this.state.MaxAntDM,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[21] = instance;
                                                }
                                            }) : this.state.MaxAntDM
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 5 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'label',
                                                { htmlFor: "BudgetAntDuer" + groups[5].Sektionsnr },
                                                'Budget duer gr. ',
                                                groups[5].Sektionsnr
                                            ) : null
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            groups.length > 5 && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75p', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: "BudgetAntDuer" + groups[5].Sektionsnr, id: "BudgetAntDuer" + groups[5].Sektionsnr, value: this.state["BudgetAntDuer" + groups[5].Sektionsnr],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[22] = instance;
                                                }
                                            }) : this.state["BudgetAntDuer" + groups[5].Sektionsnr] : null
                                        )
                                    ),
                                    _react2.default.createElement('tr', { className: 'separator' }),
                                    this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? [_react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Kontantpraemier' },
                                                'Kontantpr\xE6mier'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'Kontantpraemier', name: 'Kontantpraemier', type: 'checkbox', checked: this.state.Kontantpraemier !== 0, disabled: !editMode, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ Kontantpraemier: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Slagpraemier' },
                                                'Slagpr\xE6mier'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'Slagpraemier', name: 'Slagpraemier', type: 'checkbox', checked: this.state.Slagpraemier !== 0, disabled: !editMode, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ Slagpraemier: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), this.state.Farvekode === '' || (0, _lib.getRegi)(this.state.Farvekode) === 'Privat' && this.state.Sektion === '' ? _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunEnKontantpraemiePrSlag' },
                                                '\xC9n kontantpr\xE6mie pr. slag'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KunEnKontantpraemiePrSlag', name: 'KunEnKontantpraemiePrSlag', type: 'checkbox', checked: this.state.KunEnKontantpraemiePrSlag !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KunEnKontantpraemiePrSlag: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ) : _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunEnKontantpraemiePrSlag' },
                                                '\xC9n kontantpr\xE6mie pr. slag'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KunEnKontantpraemiePrSlag', name: 'KunEnKontantpraemiePrSlag', type: 'checkbox', checked: this.state.KunEnKontantpraemiePrSlag !== 0, disabled: !editMode, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KunEnKontantpraemiePrSlag: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SlagspilS' },
                                                'Slagspil'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'SlagspilS', name: 'SlagspilS', type: 'checkbox', checked: this.state.SlagspilS !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ SlagspilS: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), this.state.Farvekode === '' || (0, _lib.getRegi)(this.state.Farvekode) === 'Privat' && this.state.Sektion === '' ? null : _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlP' },
                                                'Kl. P'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlP', name: 'KlP', type: 'checkbox', checked: this.state.KlP !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlP: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlE' },
                                                'Kl. E'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlE', name: 'KlE', type: 'checkbox', checked: this.state.KlE !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlE: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), this.state.Farvekode === '' || (0, _lib.getRegi)(this.state.Farvekode) === 'Privat' && this.state.Sektion === '' ? null : _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlZ' },
                                                'Kl. Z'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlZ', name: 'KlZ', type: 'checkbox', checked: this.state.KlZ !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlZ: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlR' },
                                                'DM'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlR', name: 'KlR', type: 'checkbox', checked: this.state.KlR !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlR: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    )] : [_react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'PraemierPrSektion' },
                                                'Omr\xE5depr\xE6mier'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'PraemierPrSektion', name: 'PraemierPrSektion', type: 'checkbox', checked: this.state.PraemierPrSektion === 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ PraemierPrSektion: e.target.checked ? 0 : -1 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Kontantpraemier' },
                                                'Kontantpr\xE6mier'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'Kontantpraemier', name: 'Kontantpraemier', type: 'checkbox', checked: this.state.Kontantpraemier !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ Kontantpraemier: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Slagpraemier' },
                                                'Slagpr\xE6mier'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'Slagpraemier', name: 'Slagpraemier', type: 'checkbox', checked: this.state.Slagpraemier !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ Slagpraemier: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SlagspilS' },
                                                'Slagspil'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'SlagspilS', name: 'SlagspilS', type: 'checkbox', checked: this.state.SlagspilS !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ SlagspilS: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlP' },
                                                'Kl. P'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlP', name: 'KlP', type: 'checkbox', checked: this.state.KlP !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlP: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlE' },
                                                'Kl. E'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlE', name: 'KlE', type: 'checkbox', checked: this.state.KlE !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlE: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlZ' },
                                                'Kl. Z'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlZ', name: 'KlZ', type: 'checkbox', checked: this.state.KlZ !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlZ: e.target.checked ? -1 : 0 });
                                                } })
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KlR' },
                                                'DM'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KlR', name: 'KlR', type: 'checkbox', checked: this.state.KlR !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KlR: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    ), _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunEnKontantpraemiePrSlag' },
                                                '\xC9n kontantpr\xE6mie pr. slag'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement('input', { id: 'KunEnKontantpraemiePrSlag', name: 'KunEnKontantpraemiePrSlag', type: 'checkbox', checked: this.state.KunEnKontantpraemiePrSlag !== 0, disabled: !canEditAll, tabIndex: 3, onChange: function onChange(e) {
                                                    _this2.setState({ KunEnKontantpraemiePrSlag: e.target.checked ? -1 : 0 });
                                                } })
                                        )
                                    )],
                                    _react2.default.createElement('tr', { className: 'separator' }),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: 4 },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Kommentarer' },
                                                'Kommentarer'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: 4 },
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.text, placeholder: '', className: 'field100p', containerClassName: 'display-inline-block field100p', tabIndex: 3,
                                                name: 'Kommentarer', id: 'Kommentarer', maxLength: '255', value: this.state.Kommentarer,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[23] = instance;
                                                }
                                            }) : this.state.Kommentarer
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceGeneral;
}(_react2.default.Component);

RaceGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    race: _propTypes2.default.object
};
RaceGeneral.defaultProps = {
    editMode: false
};


var isUndefined = function isUndefined(value) {
    return typeof value === "undefined";
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            stations: state.admin.stations,
            sections: state.admin.sections
        },
        settings: {
            deposits: state.race.deposits,
            markings: state.race.markings
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceGeneral);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _lib2 = __webpack_require__(808);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceSignup = function (_React$Component) {
    _inherits(RaceSignup, _React$Component);

    function RaceSignup(props) {
        _classCallCheck(this, RaceSignup);

        var _this = _possibleConstructorReturn(this, (RaceSignup.__proto__ || Object.getPrototypeOf(RaceSignup)).call(this, props));

        _this.fields = [];

        _this.getRingError = function () {
            if (!/^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$/.test(_this.state.Ringnummer)) return "Ugyldigt format. Ringnumre skal angives i formatet ###-##-####.";
            var activePigeons = _this.props.racePigeons.get(_this.props.race.Nr + '/' + _this.state.club).pigeonholes.get(_this.state.pigeonhole).activePigeons;
            if (!activePigeons.has(_this.state.Ringnummer)) return "Ringnummer er ikke oprettet i det valgte slag.";
            if (activePigeons.get(_this.state.Ringnummer).Aktiv === null) return "Duen er ikke aktiv.";
            return null;
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? -1 : 0));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.createNew = function () {
            _this.setState({
                Ringnummer: '',
                Koen: '',
                Sportsdue: 0,
                SektionA: '',
                SektionB: '',
                GruppeA: '',
                GruppeB: '',
                Pulje: 0,
                Elite: 0,
                Z_Spil: 0,
                DM: 0,
                DueMarkering: 0,
                ForeningskrydsT: '',
                editIx: 'new'
            });
            _this.props.setEditMode(true);
            setTimeout(function () {
                var content = document.getElementById("data-table");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
            _this.props.setEditMode(false);
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Ringnummer: _this.state.Ringnummer === '' ? null : _this.state.Ringnummer,
                    Koen: _this.state.Koen === '' ? null : _this.state.Koen,
                    Sportsdue: _this.state.Sportsdue,
                    SektionA: _this.state.SektionA === '' ? 0 : Number(_this.state.SektionA),
                    SektionB: _this.state.SektionB === '' ? 0 : Number(_this.state.SektionB),
                    GruppeA: _this.state.GruppeA === '' ? 0 : Number(_this.state.GruppeA),
                    GruppeB: _this.state.GruppeB === '' ? 0 : Number(_this.state.GruppeB),
                    Pulje: _this.state.Pulje,
                    Elite: _this.state.Elite,
                    Z_Spil: _this.state.Z_Spil,
                    DM: _this.state.DM,
                    DueMarkering: _this.state.DueMarkering,
                    ForeningskrydsT: _this.ForeningskrydsT === '' ? null : _this.state.ForeningskrydsT
                };
                if (_this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) entity.RgnManAendret = -1;
                if (_this.state.editIx === 'new') {
                    entity.Kapflyvningsnr = _this.props.race.Nr;
                    entity.Foreningsnr = _this.state.club;
                    entity.Slagnr = _this.state.pigeonhole;
                    _this.props.dispatch(RaceActions.createRacePigeon(_this.props.race.Nr, _this.state.club, _this.state.pigeonhole, entity, function () {
                        _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er oprettet.", "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                        _this.props.setEditMode(false);
                        setTimeout(function () {
                            var currentRow = document.getElementById("row-" + this.state.Ringnummer);
                            currentRow.scrollIntoView(false);
                        });
                    }));
                } else _this.props.dispatch(RaceActions.updateRacePigeon(_this.props.race.Nr, _this.state.club, _this.state.pigeonhole, _this.state.oldRingnummer, entity, function () {
                    _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    _this.props.setEditMode(false);
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + this.state.Ringnummer);
                        currentRow.scrollIntoView(false);
                    }.bind(_this));
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            club: props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            pigeonhole: '',
            editIx: null
        };
        return _this;
    }

    _createClass(RaceSignup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.state.club !== '' && this.state.pigeonhole !== '') {
                var maxPigeons = (0, _lib2.nullToZero)(nextProps.race.MaxAntDuer);
                var countPigeons = nextProps.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.size;
                if (maxPigeons > 0 && countPigeons >= maxPigeons) nextProps.setAllowNew(false);else nextProps.setAllowNew(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var validA = [];
            var validB = [];
            var deposits = null;
            var markingsDdB = this.props.markings.has(null) ? this.props.markings.get(null) : null;
            var markingsSekt = this.props.race.Sektion !== null && this.props.markings.has(this.props.race.Sektion) ? this.props.markings.get(this.props.race.Sektion) : null;
            var markingsForen = this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && this.props.markings.has(this.props.auth.currentEntity) ? this.props.markings.get(this.props.auth.currentEntity) : null;
            var maxPigeons = (0, _lib2.nullToZero)(this.props.race.MaxAntDuer);
            var maxMark = (0, _lib2.nullToZero)(this.props.race.MaxAntMark);
            var maxDM = (0, _lib2.nullToZero)(this.props.race.MaxAntMark !== null ? this.props.race.MaxAntMark : markingsDdB === null ? 0 : this.props.race.LMU === 'O' ? markingsDdB.MaxDM_marathon : this.props.race.LMU === 'L' ? markingsDdB.MaxDM_lang : this.props.race.LMU === 'M' ? markingsDdB.MaxDM_mellem : 0);
            var maxSport = this.props.race.MaxAntSport;
            if (this.props.race.Forening !== null && this.props.race.Sektion === null && (0, _lib.getRegi)(this.props.race.Farvekode) === 'Privat') {
                deposits = this.props.deposits.get(this.props.race.Forening);
                if (maxSport === null) maxSport = (0, _lib2.nullToZero)(markingsForen === null ? 0 : markingsForen.SportForening);
            } else {
                deposits = this.props.deposits.get(this.props.race.Sektion);
                if (maxSport === null) {
                    if ((0, _lib.getRegi)(this.props.race.Farvekode) === 'DdB') {
                        if (this.props.race.LMU === 'L') maxSport = (0, _lib2.nullToZero)(markingsDdB === null ? 0 : markingsDdB.SportDdB_L);else if (this.props.race.LMU === 'M') maxSport = (0, _lib2.nullToZero)(markingsDdB === null ? 0 : markingsDdB.SportDdB_M);else maxSport = (0, _lib2.nullToZero)(markingsDdB === null ? 0 : markingsDdB.SportDdB);
                    } else if (markingsSekt === null) maxSport = (0, _lib2.nullToZero)(markingsDdB === null ? 0 : markingsDdB.SportSektion);else maxSport = (0, _lib2.nullToZero)(markingsSekt.SportSektion);
                }
            }
            if (deposits) {
                for (var i = 1; i < 7; i++) {
                    if (deposits['A_Klasse' + String(i)] !== null && deposits['A_Klasse' + String(i)] !== 0) validA.push(i);
                    if (deposits['B_Klasse' + String(i)] !== null && deposits['B_Klasse' + String(i)] !== 0) validB.push(i);
                }
            }
            var countPigeons = this.state.club === '' || this.state.pigeonhole === '' ? 0 : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.size;
            var countSport = this.state.club === '' || this.state.pigeonhole === '' ? 0 : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.filter(function (pigeon) {
                return pigeon.Sportsdue === -1;
            }).size;
            var countMark = this.state.club === '' || this.state.pigeonhole === '' ? 0 : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.filter(function (pigeon) {
                return pigeon.DueMarkering === -1;
            }).size;
            var countDM = this.state.club === '' || this.state.pigeonhole === '' ? 0 : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.filter(function (pigeon) {
                return pigeon.DM === -1;
            }).size;

            return _react2.default.createElement(
                'div',
                { className: "form-page race-signup " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'top-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                null,
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'disabled' : '', htmlFor: 'club' },
                                                'Forening'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id,
                                                name: 'club', id: 'club', value: this.state.club, options: this.props.admin.clubs.filter(function (c) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this2.props.auth.currentEntity || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && c.Foreningsnr === _this2.props.auth.currentEntity;
                                                }).sort(function (c1, c2) {
                                                    return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                                }).map(function (club) {
                                                    return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                                }).toArray(),
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({ club: e.target.value, pigeonhole: '' });
                                                    _this2.props.setAllowNew(false);
                                                    _this2.props.dispatch(RaceActions.getRacePigeons(_this2.props.race.Nr, e.target.value));
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.state.club === '' || this.state.editIx !== null ? 'disabled' : '', htmlFor: 'pigeonhole', disabled: this.state.club === '' },
                                                'Slag'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.club === '' || this.state.editIx !== null,
                                                name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort(function (s1, s2) {
                                                    return s1.Slagnr < s2.Slagnr ? -1 : s1.Slagnr > s2.Slagnr ? 1 : 0;
                                                }).map(function (pigeonhole) {
                                                    return { key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn) };
                                                }).toArray() : [],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({ pigeonhole: e.target.value });
                                                    if (e.target.value !== '') {
                                                        if (_this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) {
                                                            var _maxPigeons = (0, _lib2.nullToZero)(_this2.props.race.MaxAntDuer);
                                                            var _countPigeons = _this2.props.racePigeons.get(_this2.props.race.Nr + '/' + _this2.state.club).pigeonholes.get(e.target.value).pigeons.size;
                                                            if (_maxPigeons > 0 && _countPigeons >= _maxPigeons) _this2.props.setAllowNew(false);else _this2.props.setAllowNew(true);
                                                        } else if (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) _this2.props.setAllowNew(true);else if (_this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion') _this2.props.setAllowNew(true);
                                                    } else _this2.props.setAllowNew(false);
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[1] = instance;
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            { scope: 'row' },
                                            'Ringnummer',
                                            maxPigeons > 0 ? [_react2.default.createElement('br', null), _react2.default.createElement(
                                                'span',
                                                { className: 'small' },
                                                countPigeons,
                                                ' / ',
                                                maxPigeons
                                            )] : null
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'K\xF8n'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Sportsdue',
                                            maxSport > 0 ? [_react2.default.createElement('br', null), _react2.default.createElement(
                                                'span',
                                                { className: 'small' },
                                                countSport,
                                                ' / ',
                                                maxSport
                                            )] : null
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Sek. A'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Sek. B'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Grp. A'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Grp. B'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Pulje'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Elite'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Zone'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'DM',
                                            maxDM > 0 ? [_react2.default.createElement('br', null), _react2.default.createElement(
                                                'span',
                                                { className: 'small' },
                                                countDM,
                                                ' / ',
                                                maxDM
                                            )] : null
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Markering',
                                            maxMark > 0 ? [_react2.default.createElement('br', null), _react2.default.createElement(
                                                'span',
                                                { className: 'small' },
                                                countMark,
                                                ' / ',
                                                maxMark
                                            )] : null
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Forening'
                                        ),
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.club === '' || this.state.pigeonhole === '' ? [] : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.sort(function (p1, p2) {
                                        return p1.Ringnummer < p2.Ringnummer ? -1 : p1.Ringnummer > p2.Ringnummer ? 1 : 0;
                                    }).concat(this.state.editIx === 'new' ? [['new', { Ringnummer: 'new' }]] : []).map(function (pigeon, ix, rows) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: pigeon.Ringnummer, id: 'row-' + pigeon.Ringnummer },
                                            _react2.default.createElement(
                                                'th',
                                                { scope: 'row' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field150', containerClassName: 'display-inline-block',
                                                    name: 'Ringnummer', id: 'Ringnummer', maxLength: '11', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}" }], value: _this2.state.Ringnummer,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    isError: _this2.getRingError() !== null,
                                                    errorMessageOverride: _this2.getRingError(),
                                                    onChange: _this2.onStandardFieldChange,
                                                    onBlur: function onBlur() {
                                                        _this2.fields[2].setState({ focused: false, visited: true });
                                                        var ringnummer = '';
                                                        var activePigeons = _this2.props.racePigeons.get(_this2.props.race.Nr + '/' + _this2.state.club).pigeonholes.get(_this2.state.pigeonhole).activePigeons;
                                                        if (/^[0-9]{9}$/.test(_this2.state.Ringnummer)) ringnummer = _this2.state.Ringnummer.substr(0, 3) + '-' + _this2.state.Ringnummer.substr(3, 2) + '-' + _this2.state.Ringnummer.substr(5, 4);else if (/^[0-9]{6}$/.test(_this2.state.Ringnummer)) ringnummer = _this2.state.club + '-' + _this2.state.Ringnummer.substr(0, 2) + '-' + _this2.state.Ringnummer.substr(2, 4);else if (/^[0-9]{1,4}$/.test(_this2.state.Ringnummer)) {
                                                            var no = _this2.state.Ringnummer.padStart(4, '0');
                                                            var activePigeon = activePigeons.filter(function (pigeon) {
                                                                return pigeon.Ringnummer.substr(-4) === no && pigeon.Aktiv !== null;
                                                            });
                                                            if (activePigeon.size === 1) ringnummer = activePigeon.first().Ringnummer;
                                                        }
                                                        if (ringnummer !== '') _this2.setState({ Ringnummer: ringnummer });
                                                        ringnummer = ringnummer === '' ? _this2.state.Ringnummer : ringnummer;
                                                        if (activePigeons.has(ringnummer)) _this2.setState({ Koen: activePigeons.get(ringnummer).Koen });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                }) : pigeon.Ringnummer
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _this2.state.Koen
                                                /*<UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                                  name="Koen" id="Koen" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[AUX]"}]} value={this.state.Koen}
                                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  onChange={this.onUpperCaseFieldChange}
                                                                  ref={instance => { this.fields[3] = instance; }}
                                                />*/
                                                : pigeon.Koen
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'Sportsdue', id: 'Sportsdue', checked: _this2.state.Sportsdue !== 0, disabled: _this2.state.Sportsdue === 0 && countSport >= maxSport, onChange: _this2.onCheckFieldChange }) : pigeon.Sportsdue === null || pigeon.Sportsdue === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'SektionA', id: 'SektionA', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[" + validA.join(',') + "]" }], value: _this2.state.SektionA,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    errorMessageOverride: 'Tilladte klasser: ' + validA.join(','), disabled: _this2.state.SektionA === '' && validA.length === 0,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[4] = instance;
                                                    }
                                                }) : pigeon.SektionA === null || pigeon.SektionA === 0 ? '' : pigeon.SektionA
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'SektionB', id: 'SektionB', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[" + validB.join(',') + "]" }], value: _this2.state.SektionB,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    errorMessageOverride: 'Tilladte klasser: ' + validB.join(','), disabled: _this2.state.SektionB === '' && validB.length === 0,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[5] = instance;
                                                    }
                                                }) : pigeon.SektionB === null || pigeon.SektionB === 0 ? '' : pigeon.SektionB
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'GruppeA', id: 'GruppeA', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[" + validA.join(',') + "]" }], value: _this2.state.GruppeA,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    errorMessageOverride: 'Tilladte klasser: ' + validA.join(','), disabled: _this2.state.GruppeA === '' && (validA.length === 0 || (0, _lib.getRegi)(_this2.props.race.Farvekode) !== 'DdB'),
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[6] = instance;
                                                    }
                                                }) : pigeon.GruppeA === null || pigeon.GruppeA === 0 ? '' : pigeon.GruppeA
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'GruppeB', id: 'GruppeB', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[" + validB.join(',') + "]" }], value: _this2.state.GruppeB,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    errorMessageOverride: 'Tilladte klasser: ' + validB.join(','), disabled: _this2.state.GruppeB === '' && (validA.length === 0 || (0, _lib.getRegi)(_this2.props.race.Farvekode) !== 'DdB'),
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[7] = instance;
                                                    }
                                                }) : pigeon.GruppeB === null || pigeon.GruppeB === 0 ? '' : pigeon.GruppeB
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'Pulje', id: 'Pulje', checked: _this2.state.Pulje !== 0, disabled: _this2.state.Pulje === 0 && (_this2.props.race.KlP === 0 || _this2.props.race.KlP === null), onChange: _this2.onCheckFieldChange }) : pigeon.Pulje === null || pigeon.Pulje === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'Elite', id: 'Elite', checked: _this2.state.Elite !== 0, disabled: _this2.state.Elite === 0 && (_this2.props.race.KlE === 0 || _this2.props.race.KlE === null), onChange: _this2.onCheckFieldChange }) : pigeon.Elite === null || pigeon.Elite === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'Z_Spil', id: 'Z_Spil', checked: _this2.state.Z_Spil !== 0, disabled: _this2.state.Z_Spil === 0 && (_this2.props.race.KlZ === 0 || _this2.props.race.KlZ === null), onChange: _this2.onCheckFieldChange }) : pigeon.Z_Spil === null || pigeon.Z_Spil === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'DM', id: 'DM', checked: _this2.state.DM !== 0, disabled: _this2.state.DM === 0 && (_this2.props.race.KlR === 0 || _this2.props.race.KlR === null || countDM >= maxDM), onChange: _this2.onCheckFieldChange }) : pigeon.DM === null || pigeon.DM === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement('input', { type: 'checkbox', name: 'DueMarkering', id: 'DueMarkering', checked: _this2.state.DueMarkering !== null && _this2.state.DueMarkering !== 0, disabled: _this2.state.DueMarkering === 0 && countMark >= maxMark, onChange: _this2.onCheckFieldChange }) : pigeon.DueMarkering === null || pigeon.DueMarkering === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'ForeningskrydsT', id: 'ForeningskrydsT', maxLength: '10', value: _this2.state.ForeningskrydsT,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[8] = instance;
                                                    }
                                                }) : pigeon.ForeningskrydsT
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem kapflyvningsdeltager', onClick: _this2.save }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion') ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                        if (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion')) {
                                                            _this2.setState({
                                                                oldRingnummer: pigeon.Ringnummer === null ? '' : pigeon.Ringnummer,
                                                                Ringnummer: pigeon.Ringnummer === null ? '' : pigeon.Ringnummer,
                                                                Koen: pigeon.Koen === null ? '' : pigeon.Koen,
                                                                Sportsdue: pigeon.Sportsdue === null || pigeon.Sportsdue === 0 ? 0 : -1,
                                                                SektionA: pigeon.SektionA === null || pigeon.SektionA === 0 ? '' : String(pigeon.SektionA),
                                                                SektionB: pigeon.SektionB === null || pigeon.SektionB === 0 ? '' : String(pigeon.SektionB),
                                                                GruppeA: pigeon.GruppeA === null || pigeon.GruppeA === 0 ? '' : String(pigeon.GruppeA),
                                                                GruppeB: pigeon.GruppeB === null || pigeon.GruppeB === 0 ? '' : String(pigeon.GruppeB),
                                                                Pulje: pigeon.Pulje === null || pigeon.Pulje === 0 ? 0 : -1,
                                                                Elite: pigeon.Elite === null || pigeon.Elite === 0 ? 0 : -1,
                                                                Z_Spil: pigeon.Z_Spil === null || pigeon.Z_Spil === 0 ? 0 : -1,
                                                                DM: pigeon.DM === null || pigeon.DM === 0 ? 0 : -1,
                                                                DueMarkering: pigeon.DueMarkering === null || pigeon.DueMarkering === 0 ? 0 : -1,
                                                                ForeningskrydsT: pigeon.ForeningskrydsT === null ? '' : pigeon.ForeningskrydsT,
                                                                editIx: ix
                                                            });
                                                            _this2.props.setEditMode(true);
                                                        }
                                                    } }), _react2.default.createElement('i', { key: 1, className: "fa fa-trash " + (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion') ? 'clickable' : 'disabled'), title: 'Slet anmeldelse', onClick: function onClick() {
                                                        if (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion')) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            '\xD8nsker du at slette anmeldelsen af ringnummer ',
                                                            _react2.default.createElement(
                                                                'b',
                                                                null,
                                                                pigeon.Ringnummer
                                                            ),
                                                            '?'
                                                        ), function () {
                                                            _this2.props.dispatch(RaceActions.deleteRacePigeon(_this2.props.race.Nr, _this2.state.club, _this2.state.pigeonhole, pigeon.Ringnummer, function () {
                                                                _reactNotifications.NotificationManager.success("Ringnummer " + pigeon.Ringnummer + " er slettet fra flyvningen.", "Sletning", 4000);
                                                            }));
                                                        });
                                                    } })]
                                            )
                                        );
                                    }).toArray()
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceSignup;
}(_react2.default.Component);

RaceSignup.propTypes = {
    race: _propTypes2.default.object,
    setEditMode: _propTypes2.default.func.isRequired,
    setAllowNew: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs
        },
        racePigeons: state.race.racePigeons,
        deposits: state.race.deposits,
        markings: state.race.markings
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceSignup);

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceDotsWithCommas = exports.renderDDMMYYYY = exports.removeNonDigits = exports.removeCommaWhitespace = exports.mergeFunction = exports.fullfillTime = exports.fullfillDate = exports.CompressList = exports.SimpleList = exports.scanPropsAsync = exports.scanProps = exports.getRegi = exports.currentWeek = exports.isSetAndTrue = exports.isSet = exports.blankToNull = exports.zeroToNull = exports.nullAndZeroToFalse = exports.nullToHtmlBlank = exports.nullToBlank = exports.nullToZero = exports.undefinedToNull = exports.isDefined = undefined;

var _bluebird = __webpack_require__(161);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(809);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _asyncToGenerator(fn) {
    return function () {
        var gen = fn.apply(this, arguments);return new _bluebird2.default(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);var value = info.value;
                } catch (error) {
                    reject(error);return;
                }if (info.done) {
                    resolve(value);
                } else {
                    return _bluebird2.default.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }return step("next");
        });
    };
}

var isDefined = exports.isDefined = function (val) {
    return typeof val !== 'undefined';
};
var undefinedToNull = exports.undefinedToNull = function (val) {
    return typeof val === 'undefined' ? null : val;
};
var nullToZero = exports.nullToZero = function (val) {
    return val === null ? 0 : val;
};
var nullToBlank = exports.nullToBlank = function (val) {
    return val === null ? '' : val;
};
var nullToHtmlBlank = exports.nullToHtmlBlank = function (val) {
    return val === null ? _react2.default.createElement("span", null, "\xA0") : val;
};
var nullAndZeroToFalse = exports.nullAndZeroToFalse = function (val) {
    return val !== null && val !== 0;
};
var zeroToNull = exports.zeroToNull = function (val) {
    return val === 0 ? null : val;
};
var blankToNull = exports.blankToNull = function (val) {
    return val === '' ? null : val;
};
var isSet = exports.isSet = function (obj, prop) {
    return typeof obj[prop] !== 'undefined';
};
var isSetAndTrue = exports.isSetAndTrue = function (prop) {
    return typeof prop !== 'undefined' && prop;
};

var currentWeek = exports.currentWeek = function () {
    var now = new Date();
    var week = (0, _moment2.default)(now).isoWeekday() > 3 ? (0, _moment2.default)(now).isoWeek() : (0, _moment2.default)(now).isoWeek() - 1;
    return week;
};

var getRegi = exports.getRegi = function (kfk) {
    if (!/^[0-9]{2}/.test(kfk)) return null;
    if (kfk >= '97' || kfk < '88') return 'Privat';
    if (kfk >= '95' && kfk < '97') return 'Sektion';
    return 'DdB';
};

// Scan all properties with a specified prefix of an object.
var scanProps = exports.scanProps = function (obj, prefix, cb) {
    for (var propName in obj) {
        if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) cb(obj[propName], propName);
    }
};
var scanPropsAsync = exports.scanPropsAsync = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(obj, prefix, cb) {
        var props, propName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        props = [];

                        for (propName in obj) {
                            if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) props.push({
                                name: propName,
                                value: obj[propName]
                            });
                        }
                        _context2.next = 4;
                        return _bluebird2.default.all(props.map(function () {
                            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(prop) {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _context.next = 2;
                                                return cb(prop.value, prop.name);

                                            case 2:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, this);
                            }));

                            return function (_x4) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));

                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function scanPropsAsync(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

// Create a simple list of numbers (n1-nx replaced n1, n2... nx) from a compressed list.
var SimpleList = exports.SimpleList = function (txt) {
    var allowDuplicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var validateItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var allowRanges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var result = [];
    var isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        var items = txt.split(',');
        items.forEach(function (item) {
            var endPoints = item.split('-');
            switch (endPoints.length) {
                case 1:
                    var n = item.trim();
                    if (/^[0-9]+$/.test(n)) {
                        if (!allowDuplicates && result.indexOf(n) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(n)) isErrors = true;else result.push(n);
                    } else isErrors = true;
                    break;
                case 2:
                    if (allowRanges) {
                        var n1 = endPoints[0].trim();
                        var n2 = endPoints[1].trim();
                        if (/^[0-9]+$/.test(n1) && /^[0-9]+$/.test(n2)) {
                            if (Number(n1) > Number(n2)) isErrors = true;else for (var _n = Number(n1); _n <= Number(n2); _n++) {
                                if (!allowDuplicates && result.indexOf(String(_n)) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(String(_n))) isErrors = true;else result.push(String(_n));
                            }
                        } else isErrors = true;
                    } else isErrors = true;
                    break;
                default:
                    isErrors = true;
            }
        });
    }
    return {
        items: result.sort(function (n1, n2) {
            return Number(n1) - Number(n2);
        }),
        isErrors: isErrors
    };
};

// Create a compressed list (n1, n2... nx replaced by n1-nx) from a simple list of numbers.
var CompressList = exports.CompressList = function (txt) {
    var result = [];
    var isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        var items = txt.split(',').map(function (item) {
            return item.trim();
        });
        if (items.findIndex(function (item) {
            return !/^[0-9]+$/.test(item);
        }) >= 0) isErrors = true;else {
            var n1 = null;
            items.sort(function (n1, n2) {
                return Number(n1) - Number(n2);
            }).filter(function (item, ix, items) {
                return ix === 0 || items[ix] !== items[ix - 1];
            }).forEach(function (item, ix) {
                var n = Number(item);
                if (ix === 0 || n !== Number(items[ix - 1]) + 1) n1 = n;
                if (ix === items.length - 1 || n !== Number(items[ix + 1]) - 1) {
                    if (n1 === n) result.push(String(n));else result.push(String(n1) + '-' + String(n));
                }
            });
        }
    }
    return {
        items: result,
        isErrors: isErrors
    };
};

// Fullfill date entry.
var fullfillDate = exports.fullfillDate = function (txt) {
    if (txt === null || txt === '') return txt;
    var now = new Date();
    var yr = String(now.getFullYear());
    var d = '';
    var m = '';
    var y = '';
    if (txt.indexOf('-') >= 0) {
        var parts = txt.split('-');
        d = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        y = parts.length > 2 ? parts[2].trim() : '';
    } else {
        var trimTxt = txt.trim();
        if (/^[0-9]{2}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 1);
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 2);
        } else if (/^[0-9]{7}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 4);
        } else if (/^[0-9]{8}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 4);
        }
    }
    if (/^[0-9]{1}$/.test(d)) d = '0' + d;
    if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (y === '') y = yr;else if (/^[0-9]{2}$/.test(y)) y = yr.substr(0, 2) + y;
    if (!/^[0-9]{2}$/.test(d) || !/^[0-9]{2}$/.test(m) || !/^[0-9]{4}$/.test(y)) return 'error';
    if (!(0, _moment2.default)(d + '-' + m + '-' + y, _config2.default.formats.dateFormat, true).isValid()) return 'error';
    return d + '-' + m + '-' + y;
};

// Fullfill time entry.
var fullfillTime = exports.fullfillTime = function (txt) {
    var includeSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (txt === null || txt === '') return txt;
    var h = '';
    var m = '';
    var s = '';
    if (txt.indexOf(':') >= 0) {
        var parts = txt.split(':');
        h = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        s = parts.length > 2 ? parts[2].trim() : '';
    } else {
        var trimTxt = txt.trim();
        if (/^[0-9]{1}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{2}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
            s = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            s = trimTxt.substr(4, 2);
        }
    }
    if (/^[0-9]{1}$/.test(h)) h = '0' + h;
    if (m === '') m = '00';else if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (s === '') s = '00';else if (/^[0-9]{1}$/.test(s)) s = '0' + s;
    if (!/^([0-1][0-9]|20|21|22|23)$/.test(h) || !/^[0-5][0-9]$/.test(m) || !/^[0-5][0-9]$/.test(s)) return 'error';
    return includeSeconds ? h + ':' + m + ':' + s : h + ':' + m;
};

// Default reducer merge function to combine original entity with new properties read or updated from database.
var mergeFunction = exports.mergeFunction = function (original, updated) {
    var result = Object.assign({}, original);
    for (var prop in updated) {
        if (updated.hasOwnProperty(prop)) {
            result[prop] = updated[prop];
        }
    }
    return result;
};

var removeCommaWhitespace = exports.removeCommaWhitespace = function (string) {
    // removing all white space between a comma and any letter
    return string.replace(/\s*,\s*/g, ",");
};

var removeNonDigits = exports.removeNonDigits = function (string) {
    return string.replace(/\D/g, '');
};

var renderDDMMYYYY = exports.renderDDMMYYYY = function (date) {
    if (date === null) return null;
    var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return da + "-" + mo + "-" + ye;
};

var replaceDotsWithCommas = exports.replaceDotsWithCommas = function (float) {
    return float.toString().replace('.', ',');
};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var env = __webpack_require__(379);

// Note: Seems that library code assumes NODE_ENV can only be "development" or "production", not "staging" etc, so we have defined our own APP_ENV which can take on more values.
var config = function () {
    var app_env = process.env.APP_ENV || 'development';
    var config = env[app_env];
    if (typeof config === "undefined") throw "No config exists for " + app_env + " in environment-config.js! Check your APP_ENV environment variable!";
    return config;
}();

module.exports = config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _reactNotifications = __webpack_require__(8);

var _lib = __webpack_require__(18);

var _raceUtil = __webpack_require__(382);

var _common = __webpack_require__(811);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceArrival = function (_React$Component) {
    _inherits(RaceArrival, _React$Component);

    function RaceArrival(props) {
        _classCallCheck(this, RaceArrival);

        var _this = _possibleConstructorReturn(this, (RaceArrival.__proto__ || Object.getPrototypeOf(RaceArrival)).call(this, props));

        _this.fields = [];

        _this.calcSpeed = function () {
            var pigeonhole = _this.props.racePigeons.get(_this.props.race.Nr + '/' + _this.state.club).pigeonholes.get(_this.state.pigeonhole);
            var club = _this.props.admin.clubs.get(_this.state.club);
            var race = _this.props.races.get(_this.props.race.Nr);
            var releaseIx = club && race && race.Slip ? race.Slip.findIndex(function (release) {
                return release.Sektionsnr === club.Sektionsnr;
            }) : -1;
            var watch = pigeonhole ? pigeonhole.watches.get(Number(_this.state.Urnr)) : null;
            var speed = (0, _raceUtil.calcMpm)(pigeonhole ? pigeonhole.Afstand : null, releaseIx >= 0 && race.Slip[releaseIx].Slipdato !== null ? new Date(race.Slip[releaseIx].Slipdato) : race && race.SlipDato !== null ? new Date(race.SlipDato) : null, releaseIx >= 0 && race.Slip[releaseIx].Sliptid !== null ? race.Slip[releaseIx].Sliptid : race ? race.Sliptid : null, _this.state.Doegn === '' ? null : Number(_this.state.Doegn), /^([0-1][0-9]|20|21|22|23):[0-5][0-9]:[0-5][0-9]$/.test(_this.state.Hjemkomst) ? new Date(_common.nullDate.year, _common.nullDate.month - 1, _common.nullDate.day, Number(_this.state.Hjemkomst.substr(0, 2)), Number(_this.state.Hjemkomst.substr(3, 2)), Number(_this.state.Hjemkomst.substr(6, 2))) : null, pigeonhole ? _this.props.racePigeons.get(_this.props.race.Nr + '/' + _this.state.club).night.Start : null, pigeonhole ? _this.props.racePigeons.get(_this.props.race.Nr + '/' + _this.state.club).night.Slut : null, watch && watch.Startdato !== null ? new Date(watch.Startdato) : null, watch ? watch.Starttid : null, watch && watch.Kontroldato !== null ? new Date(watch.Kontroldato) : null, watch ? watch.Kontroltid : null, watch ? watch.FejlgangPrSek : null);
            _this.setState({
                MeterPrMin: speed.mpm,
                KorrigeretHjemkomst: speed.correctedHomeTime
            });
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.createNew = function () {
            _this.setState({
                editIx: 'new'
            });
            _this.props.setEditMode(true);
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
            _this.props.setEditMode(false);
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Hjemkomst: _this.state.Hjemkomst === '' ? null : _this.state.Hjemkomst,
                    Doegn: _this.state.Doegn === '' ? null : Number(_this.state.Doegn),
                    Urnr: _this.state.Urnr === '' ? null : Number(_this.state.Urnr)
                };
                if (_this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) entity.ResManAendret = -1;
                _this.props.dispatch(RaceActions.updateRacePigeon(_this.props.race.Nr, _this.state.club, _this.state.pigeonhole, _this.state.oldRingnummer, entity, function () {
                    _reactNotifications.NotificationManager.success("Ringnummer " + _this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    _this.props.setEditMode(false);
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            club: props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            pigeonhole: '',
            editIx: null
        };
        return _this;
    }

    _createClass(RaceArrival, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "form-page race-arrival " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'top-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                null,
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'disabled' : '', htmlFor: 'club' },
                                                'Forening'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id,
                                                name: 'club', id: 'club', value: this.state.club, options: this.props.admin.clubs.filter(function (c) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this2.props.auth.currentEntity || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && c.Foreningsnr === _this2.props.auth.currentEntity;
                                                }).sort(function (c1, c2) {
                                                    return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                                }).map(function (club) {
                                                    return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                                }).toArray(),
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({ club: e.target.value, pigeonhole: '' });
                                                    _this2.props.dispatch(RaceActions.getRacePigeons(_this2.props.race.Nr, e.target.value));
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.state.club === '' || this.state.editIx !== null ? 'disabled' : '', htmlFor: 'pigeonhole', disabled: this.state.club === '' },
                                                'Slag'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.club === '' || this.state.editIx !== null,
                                                name: 'pigeonhole', id: 'pigeonhole', value: this.state.pigeonhole, options: this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort(function (s1, s2) {
                                                    return s1.Slagnr < s2.Slagnr ? -1 : s1.Slagnr > s2.Slagnr ? 1 : 0;
                                                }).map(function (pigeonhole) {
                                                    return { key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn) };
                                                }).toArray() : [],
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({ pigeonhole: e.target.value });
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[1] = instance;
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            { scope: 'row' },
                                            'Ringnummer'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Sportsdue'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Hjemkomst'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'D\xF8gn'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Urnr.'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Meter / min.'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Korrigeret hjemkomst'
                                        ),
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.club === '' || this.state.pigeonhole === '' ? [] : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.sort(function (p1, p2) {
                                        return p1.Ringnummer < p2.Ringnummer ? -1 : p1.Ringnummer > p2.Ringnummer ? 1 : 0;
                                    }).toArray().map(function (pigeon, ix, rows) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: pigeon.Ringnummer, id: 'row-' + pigeon.Ringnummer },
                                            _react2.default.createElement(
                                                'th',
                                                { scope: 'row' },
                                                pigeon.Ringnummer
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                pigeon.Sportsdue === null || pigeon.Sportsdue === 0 ? '' : 'X'
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'Hjemkomst', id: 'Hjemkomst', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]" }], value: _this2.state.Hjemkomst,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    onBlur: function onBlur(e) {
                                                        _this2.fields[2].setState({ focused: false, visited: true });
                                                        var value = (0, _lib.fullfillTime)(_this2.state.Hjemkomst, true);
                                                        if (value !== 'error') _this2.setState({ Hjemkomst: value }, function () {
                                                            return _this2.calcSpeed();
                                                        });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                }) : pigeon.Hjemkomst === null ? null : _moment2.default.utc(pigeon.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss')
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'Doegn', id: 'Doegn', value: _this2.state.Doegn,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    onBlur: function onBlur(e) {
                                                        _this2.fields[3].setState({ focused: false, visited: true }, function () {
                                                            return _this2.calcSpeed();
                                                        });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[3] = instance;
                                                    }
                                                }) : pigeon.Doegn
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'center' },
                                                _this2.state.editIx === ix ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                    name: 'Urnr', id: 'Urnr', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-3]" }], value: _this2.state.Urnr,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    onBlur: function onBlur(e) {
                                                        _this2.fields[4].setState({ focused: false, visited: true }, function () {
                                                            return _this2.calcSpeed();
                                                        });
                                                    },
                                                    ref: function ref(instance) {
                                                        _this2.fields[4] = instance;
                                                    }
                                                }) : pigeon.Urnr
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix ? _this2.state.MeterPrMin === null ? null : _this2.state.MeterPrMin.toFixed(2).replace('.', ',') : pigeon.MeterPrMin === null ? null : pigeon.MeterPrMin.toFixed(2).replace('.', ',')
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix ? _this2.state.KorrigeretHjemkomst === null ? null : _this2.state.KorrigeretHjemkomst : pigeon.KorrigeretHjemkomst === null ? null : _moment2.default.utc(pigeon.KorrigeretHjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss')
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === ix || _this2.state.editIx === 'new' && ix === rows.length - 1 ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem kapflyvningsdeltager',
                                                    onClick: _this2.save }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller',
                                                    onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0,
                                                    className: "fa fa-pencil " + (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion') ? 'clickable' : 'disabled'),
                                                    title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                        if (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && (0, _lib.getRegi)(_this2.props.race.Farvekode) === 'Sektion')) {
                                                            _this2.setState({
                                                                oldRingnummer: pigeon.Ringnummer === null ? '' : pigeon.Ringnummer,
                                                                Hjemkomst: pigeon.Hjemkomst === null ? '' : _moment2.default.utc(pigeon.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                                                Doegn: pigeon.Doegn === null ? '' : String(pigeon.Doegn),
                                                                Urnr: pigeon.Urnr === null ? '' : String(pigeon.Urnr),
                                                                MeterPrMin: pigeon.MeterPrMin,
                                                                KorrigeretHjemkomst: pigeon.KorrigeretHjemkomst === null ? '' : _moment2.default.utc(pigeon.KorrigeretHjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                                                editIx: ix
                                                            });
                                                            _this2.props.setEditMode(true);
                                                        }
                                                    } })]
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceArrival;
}(_react2.default.Component);

RaceArrival.propTypes = {
    race: _propTypes2.default.object,
    setEditMode: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs
        },
        races: state.race.races,
        racePigeons: state.race.racePigeons
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceArrival);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var nullDate = exports.nullDate = {
    year: 1899,
    month: 12,
    day: 30
};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _reactNotifications = __webpack_require__(8);

var _lib = __webpack_require__(18);

var _confirmDialog = __webpack_require__(12);

var _alertDialog = __webpack_require__(89);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceWatch = function (_React$Component) {
    _inherits(RaceWatch, _React$Component);

    function RaceWatch(props) {
        _classCallCheck(this, RaceWatch);

        var _this = _possibleConstructorReturn(this, (RaceWatch.__proto__ || Object.getPrototypeOf(RaceWatch)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.createNew = function () {
            _this.setState({
                Slagnr: '',
                Slagnavn: '',
                Urnr: '',
                Startdato: '',
                Starttid: '',
                Kontroldato: '',
                Kontroltid: '',
                Udvisen: '',
                editIx: 'new/new'
            });
            _this.props.setEditMode(true);
            setTimeout(function () {
                var content = document.getElementById("data-table");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
            _this.props.setEditMode(false);
        };

        _this.save = function () {
            var doSave = function doSave() {
                var entity = {
                    Slagnr: _this.state.Slagnr === '' ? null : _this.state.Slagnr,
                    Urnr: _this.state.Urnr === '' ? null : Number(_this.state.Urnr),
                    Startdato: _this.state.Startdato === '' ? null : (0, _moment2.default)(_this.state.Startdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Starttid: _this.state.Starttid === '' ? null : _this.state.Starttid,
                    Kontroldato: _this.state.Kontroldato === '' ? null : (0, _moment2.default)(_this.state.Kontroldato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                    Kontroltid: _this.state.Kontroltid === '' ? null : _this.state.Kontroltid,
                    Udvisen: _this.state.Udvisen === '' ? null : _this.state.Udvisen
                };
                if (_this.state.editIx === 'new/new') {
                    entity.Ugenr = _this.props.race.Uge;
                    entity.Foreningsnr = _this.state.club;
                    _this.props.dispatch(RaceActions.createWatch(_this.props.race.Nr, _this.state.club, entity.Slagnr, entity, function () {
                        _reactNotifications.NotificationManager.success("Ur " + _this.state.Urnr + " er oprettet for slag " + entity.Slagnr + ".", "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                        _this.props.setEditMode(false);
                        setTimeout(function () {
                            var currentRow = document.getElementById("row-" + this.state.Slagnr + "-" + this.state.Urnr);
                            currentRow.scrollIntoView(false);
                        }.bind(_this));
                    }));
                } else _this.props.dispatch(RaceActions.updateWatch(_this.props.race.Nr, _this.props.race.Uge, _this.state.club, _this.state.oldSlagnr, _this.state.oldUrnr, entity, function () {
                    _reactNotifications.NotificationManager.success("Ur " + _this.state.Urnr + " for slag " + _this.state.Slagnr + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    _this.props.setEditMode(false);
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + this.state.Slagnr + "-" + this.state.Urnr);
                        currentRow.scrollIntoView(false);
                    }.bind(_this));
                }));
            };

            if (_this.allInputValid()) {
                var sDt = (0, _moment2.default)(_this.state.Startdato, _config2.default.formats.dateFormat).toDate();
                var cDt = (0, _moment2.default)(_this.state.Kontroldato, _config2.default.formats.dateFormat).toDate();
                if (cDt.getTime() < sDt.getTime() || cDt.getTime() === sDt.getTime() && _this.state.Kontroltid <= _this.state.Starttid) {
                    (0, _alertDialog.alert)('Fejl', _react2.default.createElement(
                        'span',
                        null,
                        'Kontroltid ligger f\xF8r starttid.'
                    ), function () {});
                    return;
                }
                var startSecond = 3600 * Number(_this.state.Starttid.substr(0, 2)) + 60 * Number(_this.state.Starttid.substr(3, 2)) + Number(_this.state.Starttid.substr(6, 2));
                var controlSecond = (cDt.getTime() - sDt.getTime()) / 1000 + 3600 * Number(_this.state.Kontroltid.substr(0, 2)) + 60 * Number(_this.state.Kontroltid.substr(3, 2)) + Number(_this.state.Kontroltid.substr(6, 2)) - startSecond;
                var measuredSecond = (cDt.getTime() - sDt.getTime()) / 1000 + 3600 * Number(_this.state.Udvisen.substr(0, 2)) + 60 * Number(_this.state.Udvisen.substr(3, 2)) + Number(_this.state.Udvisen.substr(6, 2)) - startSecond;
                var error = (controlSecond - measuredSecond) / controlSecond;
                if (error > 1 / 7200) {
                    (0, _confirmDialog.confirm)("Fejlgang", _react2.default.createElement(
                        'span',
                        null,
                        'Fejlgangen overstiger 1 / 7200. Kan uroplysningerne alligevel accepteres?'
                    ), function () {
                        doSave();
                    }, null, { okText: 'Ja', cancelText: 'Nej' });
                } else doSave();
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            club: props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            editIx: null
        };
        return _this;
    }

    _createClass(RaceWatch, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) {
                this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
                this.props.setAllowNew(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var checkStartWeek = function checkStartWeek(dtStr) {
                var dt = (0, _moment2.default)(dtStr, _config2.default.formats.dateFormat, true);
                if (dt.isValid()) return dt.isoWeek() === _this2.props.race.Uge || dt.isoWeek() === _this2.props.race.Uge - 1 && dt.isoWeekday() >= 7;
                return true;
            };
            var checkControlWeek = function checkControlWeek(dtStr) {
                var dt = (0, _moment2.default)(dtStr, _config2.default.formats.dateFormat, true);
                if (dt.isValid()) return dt.isoWeek() === _this2.props.race.Uge || dt.isoWeek() === _this2.props.race.Uge + 1 && dt.isoWeekday() <= 4;
                return true;
            };
            return _react2.default.createElement(
                'div',
                { className: "form-page race-watch " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'top-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                null,
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'disabled' : '', htmlFor: 'club' },
                                                'Forening'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.state.editIx !== null || this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id,
                                                name: 'club', id: 'club', value: this.state.club, options: this.props.admin.clubs.filter(function (c) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this2.props.auth.currentEntity || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && c.Foreningsnr === _this2.props.auth.currentEntity;
                                                }).sort(function (c1, c2) {
                                                    return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                                }).map(function (club) {
                                                    return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                                }).toArray(),
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({ club: e.target.value });
                                                    _this2.props.setAllowNew((_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) && e.target.value !== '');
                                                    _this2.props.dispatch(RaceActions.getRacePigeons(_this2.props.race.Nr, e.target.value));
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            { scope: 'row' },
                                            'Slagnr'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Slagnavn'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'center' },
                                            'Urnr'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Startdato'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Starttid'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Kontroldato'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Kontroltid'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Udviser'
                                        ),
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.club === '' || typeof this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club) === 'undefined' ? [] : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort(function (p1, p2) {
                                        return p1.Slagnr < p2.Slagnr ? -1 : p1.Slagnr > p2.Slagnr ? 1 : 0;
                                    }).concat(this.state.editIx === 'new/new' ? [['new', { Slagnr: 'new', watches: [{ Urnr: 'new' }] }]] : []).toArray().map(function (pigeonhole, pix, prows) {
                                        return (pigeonhole.Slagnr === 'new' ? pigeonhole.watches : pigeonhole.watches.sort(function (w1, w2) {
                                            return w1.Urnr < w2.Urnr ? -1 : w1.Urnr > w2.Urnr ? 1 : 0;
                                        }).toArray()).map(function (watch, wix, wrows) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: pigeonhole.Slagnr + '/' + watch.Urnr, id: 'row-' + pigeonhole.Slagnr + '-' + watch.Urnr },
                                                _react2.default.createElement(
                                                    'th',
                                                    { scope: 'row' },
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                                        name: 'Slagnr', id: 'Slagnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slagnr,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[1].setState({ focused: false, visited: true });
                                                            var value = _this2.state.Slagnr.padStart(3, '0');
                                                            var pigeonhole = _this2.props.racePigeons.get(_this2.props.race.Nr + '/' + _this2.state.club).pigeonholes.get(value);
                                                            _this2.setState({
                                                                Slagnr: value,
                                                                Slagnavn: pigeonhole ? pigeonhole.Slagnavn : null
                                                            });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[1] = instance;
                                                        }
                                                    }) : pigeonhole.Slagnr
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _this2.state.Slagnavn : pigeonhole.Slagnavn
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'center' },
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                                        name: 'Urnr', id: 'Urnr', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-3]" }], value: _this2.state.Urnr,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        ref: function ref(instance) {
                                                            _this2.fields[2] = instance;
                                                        }
                                                    }) : watch.Urnr
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field125', containerClassName: 'display-inline-block',
                                                        name: 'Startdato', id: 'Startdato', value: _this2.state.Startdato,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        isError: !checkStartWeek(_this2.state.Startdato), errorMessageOverride: !checkStartWeek(_this2.state.Startdato) ? 'Dato ligger i forkert uge.' : '',
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[3].setState({ focused: false, visited: true });
                                                            var value = (0, _lib.fullfillDate)(_this2.state.Startdato);
                                                            if (value !== 'error') _this2.setState({ Startdato: value });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[3] = instance;
                                                        }
                                                    }) : (0, _moment2.default)(watch.Startdato).format(_config2.default.formats.dateFormat)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                        name: 'Starttid', id: 'Starttid', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]" }], value: _this2.state.Starttid,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[4].setState({ focused: false, visited: true });
                                                            var value = (0, _lib.fullfillTime)(_this2.state.Starttid, true);
                                                            if (value !== 'error') _this2.setState({ Starttid: value });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[4] = instance;
                                                        }
                                                    }) : watch.Starttid
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field125', containerClassName: 'display-inline-block',
                                                        name: 'Kontroldato', id: 'Kontroldato', value: _this2.state.Kontroldato,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        isError: !checkControlWeek(_this2.state.Kontroldato), errorMessageOverride: !checkControlWeek(_this2.state.Kontroldato) ? 'Dato ligger i forkert uge.' : '',
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[5].setState({ focused: false, visited: true });
                                                            var value = (0, _lib.fullfillDate)(_this2.state.Kontroldato);
                                                            if (value !== 'error') _this2.setState({ Kontroldato: value });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[5] = instance;
                                                        }
                                                    }) : (0, _moment2.default)(watch.Kontroldato).format(_config2.default.formats.dateFormat)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                        name: 'Kontroltid', id: 'Kontroltid', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]" }], value: _this2.state.Kontroltid,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[6].setState({ focused: false, visited: true });
                                                            var value = (0, _lib.fullfillTime)(_this2.state.Kontroltid, true);
                                                            if (value !== 'error') _this2.setState({ Kontroltid: value });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[6] = instance;
                                                        }
                                                    }) : watch.Kontroltid
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                        name: 'Udvisen', id: 'Udvisen', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]" }], value: _this2.state.Udvisen,
                                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        onBlur: function onBlur(e) {
                                                            _this2.fields[7].setState({ focused: false, visited: true });
                                                            var value = (0, _lib.fullfillTime)(_this2.state.Udvisen, true);
                                                            if (value !== 'error') _this2.setState({ Udvisen: value });
                                                        },
                                                        ref: function ref(instance) {
                                                            _this2.fields[7] = instance;
                                                        }
                                                    }) : watch.Udvisen
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _this2.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem uroplysninger', onClick: _this2.save }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                            if (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id)) {
                                                                _this2.setState({
                                                                    oldSlagnr: pigeonhole.Slagnr,
                                                                    oldUrnr: watch.Urnr,
                                                                    Slagnr: pigeonhole.Slagnr,
                                                                    Slagnavn: pigeonhole.Slagnavn,
                                                                    Urnr: String(watch.Urnr),
                                                                    Startdato: watch.Startdato === null ? '' : (0, _moment2.default)(watch.Startdato).format(_config2.default.formats.dateFormat),
                                                                    Starttid: watch.Starttid === null ? '' : watch.Starttid,
                                                                    Kontroldato: watch.Kontroldato === null ? '' : (0, _moment2.default)(watch.Kontroldato).format(_config2.default.formats.dateFormat),
                                                                    Kontroltid: watch.Kontroltid === null ? '' : watch.Kontroltid,
                                                                    Udvisen: watch.Udvisen === null ? '' : watch.Udvisen,
                                                                    editIx: pigeonhole.Slagnr + '/' + watch.Urnr
                                                                });
                                                                _this2.props.setEditMode(true);
                                                            }
                                                        } }), _react2.default.createElement('i', { key: 1,
                                                        className: "fa fa-trash " + (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) ? 'clickable' : 'disabled'), title: 'Slet ur', onClick: function onClick() {
                                                            if (_this2.state.editIx === null && (_this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id)) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                                'span',
                                                                null,
                                                                '\xD8nsker du at slette ur ',
                                                                _react2.default.createElement(
                                                                    'b',
                                                                    null,
                                                                    watch.Urnr
                                                                ),
                                                                ' for slag ',
                                                                _react2.default.createElement(
                                                                    'b',
                                                                    null,
                                                                    pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' ' + pigeonhole.Slagnavn)
                                                                ),
                                                                '?'
                                                            ), function () {
                                                                _this2.props.dispatch(RaceActions.deleteWatch(_this2.props.race.Nr, _this2.props.race.Uge, _this2.state.club, pigeonhole.Slagnr, watch.Urnr, function () {
                                                                    _reactNotifications.NotificationManager.success("Ur " + watch.Urnr + " er slettet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' ' + pigeonhole.Slagnavn) + ".", "Sletning", 4000);
                                                                }));
                                                            });
                                                        } })]
                                                )
                                            );
                                        });
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceWatch;
}(_react2.default.Component);

RaceWatch.propTypes = {
    race: _propTypes2.default.object,
    setEditMode: _propTypes2.default.func.isRequired,
    setAllowNew: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs
        },
        racePigeons: state.race.racePigeons
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceWatch);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _reactNotifications = __webpack_require__(8);

var _confirmDialog = __webpack_require__(12);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceMemberComp = function (_React$Component) {
    _inherits(RaceMemberComp, _React$Component);

    function RaceMemberComp(props) {
        _classCallCheck(this, RaceMemberComp);

        var _this = _possibleConstructorReturn(this, (RaceMemberComp.__proto__ || Object.getPrototypeOf(RaceMemberComp)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.state = {
            club: props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            selectedToAdd: [],
            selectedToRemove: []
        };
        return _this;
    }

    _createClass(RaceMemberComp, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var pigeonholes = this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort(function (s1, s2) {
                return s1.Slagnr < s2.Slagnr ? -1 : s1.Slagnr > s2.Slagnr ? 1 : 0;
            }).toArray() : [];
            return _react2.default.createElement(
                'div',
                { className: "form-page race-member-comp" },
                _react2.default.createElement(
                    'div',
                    { className: 'top-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                null,
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'disabled' : '', htmlFor: 'club' },
                                                'Forening'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id,
                                                name: 'club', id: 'club', value: this.state.club, options: this.props.admin.clubs.filter(function (c) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this2.props.auth.currentEntity || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && c.Foreningsnr === _this2.props.auth.currentEntity;
                                                }).sort(function (c1, c2) {
                                                    return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                                }).map(function (club) {
                                                    return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                                }).toArray(),
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({
                                                        club: e.target.value,
                                                        selectedToAdd: [],
                                                        selectedToRemove: []
                                                    });
                                                    _this2.props.dispatch(RaceActions.getRacePigeons(_this2.props.race.Nr, e.target.value));
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement('th', { scope: 'row' }),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Slagnr.'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Slagnavn'
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    pigeonholes.map(function (pigeonhole) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: pigeonhole.Slagnr, className: !pigeonhole.Slagspil && (_this2.props.race.SlagspilS === null || _this2.props.race.SlagspilS === 0) ? 'disabled' : '', onDoubleClick: function onDoubleClick() {
                                                    if (pigeonhole.Slagspil || _this2.props.race.SlagspilS !== null && _this2.props.race.SlagspilS !== 0) {
                                                        if (pigeonhole.Slagspil) _this2.props.dispatch(RaceActions.removeMemberGames(_this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                            _reactNotifications.NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er afmeldt slagspil.", "Slagspil", 4000);
                                                        }));else _this2.props.dispatch(RaceActions.addMemberGames(_this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                            _reactNotifications.NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er tilmeldt slagspil.", "Slagspil", 4000);
                                                        }));
                                                    }
                                                } },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox', checked: pigeonhole.Slagspil, onChange: function onChange() {
                                                        if (pigeonhole.Slagspil || _this2.props.race.SlagspilS !== null && _this2.props.race.SlagspilS !== 0) {
                                                            if (pigeonhole.Slagspil) _this2.props.dispatch(RaceActions.removeMemberGames(_this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                                _reactNotifications.NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er afmeldt slagspil.", "Slagspil", 4000);
                                                            }));else _this2.props.dispatch(RaceActions.addMemberGames(_this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                                _reactNotifications.NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er tilmeldt slagspil.", "Slagspil", 4000);
                                                            }));
                                                        }
                                                    } })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                pigeonhole.Slagnr
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                pigeonhole.Slagnavn
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceMemberComp;
}(_react2.default.Component);

RaceMemberComp.propTypes = {
    race: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs
        },
        racePigeons: state.race.racePigeons
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceMemberComp);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _reactNotifications = __webpack_require__(8);

var _confirmDialog = __webpack_require__(12);

var _PriceAdditionsDialog = __webpack_require__(815);

var _PriceAdditionsDialog2 = _interopRequireDefault(_PriceAdditionsDialog);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RacePrices = function (_React$Component) {
    _inherits(RacePrices, _React$Component);

    function RacePrices(props) {
        _classCallCheck(this, RacePrices);

        var _this = _possibleConstructorReturn(this, (RacePrices.__proto__ || Object.getPrototypeOf(RacePrices)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onPoolPriceClick = function (e) {
            var stateVariable = e.target.name;
            _this.props.dispatch(RaceActions.updateRace(_this.props.race.Nr, _defineProperty({}, e.target.name, e.target.checked ? -1 : 0), function () {
                _reactNotifications.NotificationManager.success("Indstillingen for puljepræmier er gemt.", "Opdatering", 4000);
            }));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.createNew = function () {
            _this.setState({
                Antal: '1',
                Vaerdi: '',
                Sektion: '',
                editIx: 'new/new'
            });
            _this.props.setEditMode(true);
            setTimeout(function () {
                var content = document.getElementById("data-table");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
            _this.props.setEditMode(false);
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Antal: _this.state.Antal === '' ? null : Number(_this.state.Antal),
                    Vaerdi: _this.state.Vaerdi === '' ? null : Number(_this.state.Vaerdi.replace(',', '.')),
                    Sektion: _this.state.Sektion
                };
                if (_this.state.editIx === 'new/new') {
                    entity.Kapflyvningsnr = _this.props.race.Nr;
                    _this.props.dispatch(RaceActions.createPrice(_this.state.priceType, entity, function () {
                        _reactNotifications.NotificationManager.success("Præmien på " + _this.state.Vaerdi + " DKK" + (_this.state.Sektion === '' ? '' : ' for sektion ' + _this.state.Sektion) + " er oprettet.", "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                        _this.props.setEditMode(false);
                        setTimeout(function () {
                            var currentRow = document.getElementById("row-" + this.state.Sektion + "-" + this.state.Vaerdi);
                            currentRow.scrollIntoView(false);
                        }.bind(_this));
                    }));
                } else _this.props.dispatch(RaceActions.updatePrice(_this.state.priceType, _this.props.race.Nr, _this.state.oldSektion, _this.state.oldVaerdi, entity, function () {
                    _reactNotifications.NotificationManager.success("Præmien på " + _this.state.Vaerdi + " DKK" + (_this.state.Sektion === '' ? '' : ' for sektion ' + _this.state.Sektion) + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    _this.props.setEditMode(false);
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + this.state.Sektion + "-" + this.state.Vaerdi);
                        currentRow.scrollIntoView(false);
                    }.bind(_this));
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            priceType: null,
            editIx: null
        };
        return _this;
    }

    _createClass(RacePrices, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(RaceActions.getPrices(this.props.race.Nr));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "form-page race-prices " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'top-left-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.options, className: '', containerClassName: 'display-inline-block', disabled: this.state.editIx !== null,
                                name: 'priceType', id: 'priceType', value: this.state.priceType, options: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? [{ key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null || this.props.race.Kontantpraemier === null || this.props.race.Kontantpraemier === 0 }, { key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null || this.props.race.Slagpraemier === null || this.props.race.Slagpraemier === 0 }] : [{ key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null || this.props.race.Kontantpraemier === null || this.props.race.Kontantpraemier === 0 }, { key: 'slagspil', value: 'Slagspilspræmier', disabled: this.state.editIx !== null || this.props.race.SlagspilS === null || this.props.race.SlagspilS === 0 }, { key: 'espil', value: 'E-splispræmier', disabled: this.state.editIx !== null || this.props.race.KlE === null || this.props.race.KlE === 0 }, { key: 'pspil', value: 'P-spilspræmier', disabled: this.state.editIx !== null || this.props.race.KlP === null || this.props.race.KlP === 0 }, { key: 'zspil', value: 'Z-spilspræmier', disabled: this.state.editIx !== null || this.props.race.KlZ === null || this.props.race.KlZ === 0 }, { key: 'dm', value: 'DM-præmier', disabled: this.state.editIx !== null || this.props.race.KlR === null || this.props.race.KlR === 0 }, { key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null || this.props.race.Slagpraemier === null || this.props.race.Slagpraemier === 0 }],
                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                onChange: function onChange(e) {
                                    _this2.setState({ priceType: e.target.value });
                                    _this2.props.setAllowNew(true);
                                },
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'top-right-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Antal'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'V\xE6rdi'
                                        ),
                                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                            'th',
                                            null,
                                            'Sektion'
                                        ) : null,
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.priceType !== null && this.props.racePrices.get(this.props.race.Nr) ? this.props.racePrices.get(this.props.race.Nr)[this.state.priceType].sort(function (p1, p2) {
                                        if (p1.Sektion < p2.Sektion) return -1;
                                        if (p1.Sektion > p2.Sektion) return 1;
                                        if (p1.Vaerdi > p2.Vaerdi) return -1;
                                        if (p1.Vaerdi < p2.Vaerdi) return 1;
                                        return 0;
                                    }).concat(this.state.editIx === 'new/new' ? [['new/new', { Sektion: 'new', Vaerdi: 'new' }]] : []).toArray().map(function (price) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: price.Sektion + '/' + price.Vaerdi, id: 'row-' + price.Sektion + '-' + price.Vaerdi },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === price.Sektion + '/' + price.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                                    name: 'Antal', id: 'Antal', value: _this2.state.Antal,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                }) : price.Antal
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === price.Sektion + '/' + price.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.float, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'Vaerdi', id: 'Vaerdi', value: _this2.state.Vaerdi,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                }) : String(price.Vaerdi).replace('.', ',')
                                            ),
                                            _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === price.Sektion + '/' + price.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'Sektion', id: 'Sektion', maxLength: '6', value: _this2.state.Sektion,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[3] = instance;
                                                    }
                                                }) : price.Sektion
                                            ) : null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === price.Sektion + '/' + price.Vaerdi ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem pr\xE6mie', onClick: _this2.save }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                        if (_this2.state.editIx === null) _this2.setState({
                                                            Sektion: price.Sektion,
                                                            Vaerdi: String(price.Vaerdi).replace('.', ','),
                                                            Antal: price.Antal === null ? '' : String(price.Antal),
                                                            oldSektion: String(price.Sektion),
                                                            oldVaerdi: String(price.Vaerdi),
                                                            editIx: price.Sektion + '/' + price.Vaerdi
                                                        });
                                                        _this2.props.setEditMode(true);
                                                    } }), _react2.default.createElement('i', { key: 1,
                                                    className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet pr\xE6mie', onClick: function onClick() {
                                                        if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            '\xD8nsker du at slette pr\xE6mien p\xE5 ',
                                                            _react2.default.createElement(
                                                                'b',
                                                                null,
                                                                price.Vaerdi,
                                                                ' DKK'
                                                            ),
                                                            price.Sektion === '' ? '' : _react2.default.createElement(
                                                                'span',
                                                                null,
                                                                ' for sektion ',
                                                                _react2.default.createElement(
                                                                    'b',
                                                                    null,
                                                                    price.Sektion
                                                                )
                                                            ),
                                                            '?'
                                                        ), function () {
                                                            _this2.props.dispatch(RaceActions.deletePrice(_this2.state.priceType, _this2.props.race.Nr, price.Sektion, price.Vaerdi, function () {
                                                                _reactNotifications.NotificationManager.success("Præmien på " + price.Vaerdi + ' DKK' + (price.Sektion === '' ? '' : ' for sektion ' + price.Sektion) + " er slettet.", "Sletning", 4000);
                                                            }));
                                                        });
                                                    } })]
                                            )
                                        );
                                    }) : null
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-left-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            'Pr\xE6miepulje kan ikke overstige samlede indskud'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-right-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : _react2.default.createElement(
                                'span',
                                { className: 'pool-prices' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pool-prices-option' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'PuljePuljepraemier', className: this.props.race.KlP === null || this.props.race.KlP === 0 ? 'disabled' : '' },
                                        'Pulje'
                                    ),
                                    _react2.default.createElement('input', { id: 'PuljePuljepraemier', name: 'PuljePuljepraemier', type: 'checkbox', checked: this.props.race.PuljePuljepraemier !== null && this.props.race.PuljePuljepraemier !== 0,
                                        disabled: this.props.race.KlP === null || this.props.race.KlP === 0, onChange: this.onPoolPriceClick })
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pool-prices-option' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'ElitePuljepraemier', className: this.props.race.KlE === null || this.props.race.KlE === 0 ? 'disabled' : '' },
                                        'Elite'
                                    ),
                                    _react2.default.createElement('input', { id: 'ElitePuljepraemier', name: 'ElitePuljepraemier', type: 'checkbox', checked: this.props.race.ElitePuljepraemier !== null && this.props.race.ElitePuljepraemier !== 0,
                                        disabled: this.props.race.KlE === null || this.props.race.KlE === 0, onChange: this.onPoolPriceClick })
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pool-prices-option' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Z_Puljepraemier', className: this.props.race.KlZ === null || this.props.race.KlZ === 0 ? 'disabled' : '' },
                                        'Z-spil'
                                    ),
                                    _react2.default.createElement('input', { id: 'Z_Puljepraemier', name: 'Z_Puljepraemier', type: 'checkbox', checked: this.props.race.Z_Puljepraemier !== null && this.props.race.Z_Puljepraemier !== 0,
                                        disabled: this.props.race.KlZ === null || this.props.race.KlZ === 0, onChange: this.onPoolPriceClick })
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pool-prices-option' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'R_Puljepraemier', className: this.props.race.KlR === null || this.props.race.KlR === 0 ? 'disabled' : '' },
                                        'DM'
                                    ),
                                    _react2.default.createElement('input', { id: 'R_Puljepraemier', name: 'R_Puljepraemier', type: 'checkbox', checked: this.props.race.R_Puljepraemier !== null && this.props.race.R_Puljepraemier !== 0,
                                        disabled: this.props.race.KlR === null || this.props.race.KlR === 0, onChange: this.onPoolPriceClick })
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'actions' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Opret standardpr\xE6mier som konfigureret under indstillinger', disabled: this.state.editIx !== null || this.state.priceType === null, onClick: function onClick() {
                                            _this2.props.dispatch(RaceActions.resetPrices(_this2.state.priceType, _this2.props.race.Nr, function () {
                                                _reactNotifications.NotificationManager.success("Præmierne er nulstillet.", "Nulstilling", 4000);
                                            }));
                                        } },
                                    'Standard'
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? null : [_react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Beregn pr\xE6mier', disabled: this.state.editIx !== null || this.state.priceType !== 'pspil' && this.state.priceType !== 'zspil' && this.state.priceType !== 'serie' && (this.state.priceType !== 'kontant' || this.props.race.LMU !== 'O'), onClick: function onClick() {
                                            _this2.props.dispatch(RaceActions.calcPrices(_this2.state.priceType, _this2.props.race.Nr, function () {
                                                _reactNotifications.NotificationManager.success("Præmierne er beregnet.", "Beregning", 4000);
                                            }));
                                        } },
                                    'Beregn'
                                ), _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Beregn pr\xE6mietill\xE6g  ', disabled: this.state.editIx !== null || this.state.priceType !== 'kontant' || this.props.race.LMU !== 'O', onClick: function onClick() {
                                            _this2.setState({ showPriceAdditionsDialog: true });
                                        } },
                                    'Pr\xE6mietill\xE6g'
                                )]
                            )
                        )
                    )
                ),
                this.state.showPriceAdditionsDialog ? _react2.default.createElement(_PriceAdditionsDialog2.default, { onClose: function onClose() {
                        _this2.setState({ showPriceAdditionsDialog: false });
                    }, onSuccess: function onSuccess() {},
                    raceId: this.props.race.Nr, priceType: this.state.priceType, sections: this.props.admin.sections.filter(function (section) {
                        return section.Sektionsnr < '7';
                    }).map(function (section) {
                        var addition = _this2.state.priceType !== null && _this2.props.racePrices.get(_this2.props.race.Nr) && _this2.props.racePrices.get(_this2.props.race.Nr)[_this2.state.priceType + 'Additions'] ? _this2.props.racePrices.get(_this2.props.race.Nr)[_this2.state.priceType + 'Additions'].get(section.Sektionsnr) : null;
                        return {
                            Sektionsnr: section.Sektionsnr,
                            Beloeb: addition ? addition.Beloeb : null
                        };
                    }).toArray()
                }) : null
            );
        }
    }]);

    return RacePrices;
}(_react2.default.Component);

RacePrices.propTypes = {
    race: _propTypes2.default.object,
    setEditMode: _propTypes2.default.func.isRequired,
    setAllowNew: _propTypes2.default.func.isRequired,
    showPriceAdditionsDialog: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs,
            sections: state.admin.sections
        },
        racePrices: state.race.racePrices
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RacePrices);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(30);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PriceAdditionsDialog = function (_React$Component) {
    _inherits(PriceAdditionsDialog, _React$Component);

    function PriceAdditionsDialog(props) {
        _classCallCheck(this, PriceAdditionsDialog);

        var _this = _possibleConstructorReturn(this, (PriceAdditionsDialog.__proto__ || Object.getPrototypeOf(PriceAdditionsDialog)).call(this, props));

        _this.fields = [];

        _this.onSave = function () {
            if (_this.allInputValid()) {
                var additions = _this.props.sections.filter(function (section) {
                    return _this.state['Section' + section.Sektionsnr] !== '';
                }).map(function (section) {
                    return {
                        Sektionsnr: section.Sektionsnr,
                        Beloeb: Number(_this.state['Section' + section.Sektionsnr].replace(',', '.'))
                    };
                });
                _this.props.dispatch(RaceActions.updatePriceAdditions(_this.props.priceType, _this.props.raceId, additions, function () {
                    _reactNotifications.NotificationManager.success("Præmietillæggene er opdateret. Husk at genberegne præmierne.", "Opdatering", 4000);
                    _this.props.onClose();
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.state = Object.assign({}, _this.getStateFromProps(props));
        return _this;
    }

    _createClass(PriceAdditionsDialog, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState(this.getStateFromProps(nextProps));
        }
    }, {
        key: 'getStateFromProps',
        value: function getStateFromProps(props) {
            var state = {};
            props.sections.forEach(function (section) {
                state['Section' + section.Sektionsnr] = section.Beloeb === null ? '' : String(section.Beloeb).replace('.', ',');
            });
            return state;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactModal2.default,
                    {
                        isOpen: true,
                        onRequestClose: function onRequestClose() {
                            _this2.props.onClose();
                        },
                        style: {
                            overlay: {
                                zIndex: 10
                            },
                            content: {
                                width: '500px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                top: '100px',
                                bottom: '100px'
                            }
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-title' },
                            'Pr\xE6mietill\xE6g'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'dialog-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'dialog-inner-body' },
                                _react2.default.createElement(
                                    'table',
                                    { className: 'fields data-table' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Sektion'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Till\xE6g'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.props.sections.sort(function (s1, s2) {
                                            return s1.Sektionsnr < s2.Sektionsnr ? -1 : s1.Sektionsnr > s2.Sektionsnr ? 1 : 0;
                                        }).map(function (section, ix) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: section.Sektionsnr },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    'Sektion ',
                                                    section.Sektionsnr
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.float, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                        name: 'Section' + section.Sektionsnr, id: 'Section' + section.Sektionsnr, value: _this2.state['Section' + section.Sektionsnr],
                                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                        onChange: _this2.onStandardFieldChange,
                                                        ref: function ref(instance) {
                                                            _this2.fields[ix] = instance;
                                                        }
                                                    })
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'actions-row' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-primary', onClick: this.onSave },
                                'Opdater'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn-secondary float-right', onClick: function onClick() {
                                        _this2.props.onClose();
                                    } },
                                'Annuller'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PriceAdditionsDialog;
}(_react2.default.Component);

PriceAdditionsDialog.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func,
    raceId: _propTypes2.default.number.isRequired,
    priceType: _propTypes2.default.string.isRequired,
    sections: _propTypes2.default.array.isRequired
};
PriceAdditionsDialog.defaultProps = {
    onSuccess: null
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PriceAdditionsDialog);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _reactNotifications = __webpack_require__(8);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaceDecay = function (_React$Component) {
    _inherits(RaceDecay, _React$Component);

    function RaceDecay(props) {
        _classCallCheck(this, RaceDecay);

        var _this = _possibleConstructorReturn(this, (RaceDecay.__proto__ || Object.getPrototypeOf(RaceDecay)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.state = {
            club: props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? props.auth.currentEntity : ''
        };
        return _this;
    }

    _createClass(RaceDecay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var pigeonholes = this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort(function (s1, s2) {
                return s1.Slagnr < s2.Slagnr ? -1 : s1.Slagnr > s2.Slagnr ? 1 : 0;
            }).toArray() : [];
            return _react2.default.createElement(
                'div',
                { className: "form-page race-member-comp" },
                _react2.default.createElement(
                    'div',
                    { className: 'top-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'top-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                null,
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'label',
                                                { className: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id ? 'disabled' : '', htmlFor: 'club' },
                                                'Forening'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: '-- Vælg --', className: 'field100p', containerClassName: 'display-inline-block field100p', disabled: this.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id,
                                                name: 'club', id: 'club', value: this.state.club, options: this.props.admin.clubs.filter(function (c) {
                                                    return _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this2.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this2.props.auth.currentEntity || _this2.props.auth.currentRole === _UserRoles2.default.CLUB_ADMIN.id && c.Foreningsnr === _this2.props.auth.currentEntity;
                                                }).sort(function (c1, c2) {
                                                    return c1.Foreningsnr < c2.Foreningsnr ? -1 : c1.Foreningsnr > c2.Foreningsnr ? 1 : 0;
                                                }).map(function (club) {
                                                    return { key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn) };
                                                }).toArray(),
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: function onChange(e) {
                                                    _this2.setState({
                                                        club: e.target.value
                                                    });
                                                    _this2.props.dispatch(RaceActions.getRacePigeons(_this2.props.race.Nr, e.target.value));
                                                },
                                                ref: function ref(instance) {
                                                    _this2.fields[0] = instance;
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'bottom-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement('th', { scope: 'row' }),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Slagnr.'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Slagnavn'
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    pigeonholes.map(function (pigeonhole) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: pigeonhole.Slagnr, onDoubleClick: function onDoubleClick() {
                                                    if (pigeonhole.Forfald) _this2.props.dispatch(RaceActions.removeDecays(_this2.props.race.Uge, _this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                        _reactNotifications.NotificationManager.success("Forfald er fjernet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                                    }));else _this2.props.dispatch(RaceActions.addDecays(_this2.props.race.Uge, _this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                        _reactNotifications.NotificationManager.success("Forfald er registreret for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " .", "Forfald", 4000);
                                                    }));
                                                } },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox', checked: pigeonhole.Forfald, onChange: function onChange() {
                                                        if (pigeonhole.Forfald) _this2.props.dispatch(RaceActions.removeDecays(_this2.props.race.Uge, _this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                            _reactNotifications.NotificationManager.success("Forfald er fjernet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                                        }));else _this2.props.dispatch(RaceActions.addDecays(_this2.props.race.Uge, _this2.props.race.Nr, _this2.state.club, [pigeonhole.Slagnr], function () {
                                                            _reactNotifications.NotificationManager.success("Forfald er registreret for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                                        }));
                                                    } })
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                pigeonhole.Slagnr
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                pigeonhole.Slagnavn
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RaceDecay;
}(_react2.default.Component);

RaceDecay.propTypes = {
    race: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            clubs: state.admin.clubs
        },
        racePigeons: state.race.racePigeons
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(RaceDecay);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _lib = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StationsPage = function (_React$Component) {
    _inherits(StationsPage, _React$Component);

    _createClass(StationsPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_STATIONS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.CLUB_ADMIN, _UserRoles2.default.SECTION_ADMIN]; // empty means allowed for all
        }
    }]);

    function StationsPage(props) {
        _classCallCheck(this, StationsPage);

        var _this = _possibleConstructorReturn(this, (StationsPage.__proto__ || Object.getPrototypeOf(StationsPage)).call(this, props));

        _this.fields = [];
        _this.timeoutHandler = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var stationsNr = _this.state.Stationsnr;
                var entity = {
                    Stationsnr: _this.state.Stationsnr,
                    Navn: _this.state.Navn === '' ? null : _this.state.Navn,
                    Laengde_grader: _this.state.Laengde_grader === '' ? null : Number(_this.state.Laengde_grader),
                    Laengde_min: _this.state.Laengde_min === '' ? null : Number(_this.state.Laengde_min),
                    Laengde_sek: _this.state.Laengde_sek === '' ? null : Number(_this.state.Laengde_sek),
                    Laengde_100_dele_sek: _this.state.Laengde_100_dele_sek === '' ? null : Number(_this.state.Laengde_100_dele_sek),
                    Laengde_1000_dele_min: _this.state.Laengde_1000_dele_min === '' ? null : Number(_this.state.Laengde_1000_dele_min),
                    Bredde_grader: _this.state.Bredde_grader === '' ? null : Number(_this.state.Bredde_grader),
                    Bredde_min: _this.state.Bredde_min === '' ? null : Number(_this.state.Bredde_min),
                    Bredde_sek: _this.state.Bredde_sek === '' ? null : Number(_this.state.Bredde_sek),
                    Bredde_100_dele_sek: _this.state.Bredde_100_dele_sek === '' ? null : Number(_this.state.Bredde_100_dele_sek),
                    Bredde_1000_dele_min: _this.state.Bredde_1000_dele_min === '' ? null : Number(_this.state.Bredde_1000_dele_min)
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createListItemItem('station', entity, function (id) {
                    _reactNotifications.NotificationManager.success("Station " + id + " (" + _this.state.Navn + ") er oprettet.", "Oprettelse", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + stationsNr);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateListItem('station', _this.state.editId, entity, function (id) {
                    _reactNotifications.NotificationManager.success("Station " + id + " (" + _this.state.Navn + ") er opdateret.", "Opdatering", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + stationsNr);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null,
            filter: '',
            sort: 'Stationsnr'
        };
        return _this;
    }

    _createClass(StationsPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getListItems('station'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.stations ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Stationer'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sub-page-content', className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: this.state.editId === null ? "clickable" : "", onClick: function onClick() {
                                            if (_this2.state.editId === null) _this2.setState({ sort: 'Stationsnr' });
                                        } },
                                    'Nr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: this.state.editId === null ? "clickable" : "", onClick: function onClick() {
                                            if (_this2.state.editId === null) _this2.setState({ sort: 'Navn' });
                                        } },
                                    'Navn'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'L-grader'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'L-min'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'L-sek'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'L-sek/100'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'L-min/1000'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'B-grader'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'B-min'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'B-sek'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'B-sek/100'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'B-min/1000'
                                ),
                                _react2.default.createElement('th', { className: 'commands-column' })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.stations.filter(function (s) {
                                return _this2.state.filter === '' ? true : (0, _lib.nullToBlank)(s.Stationsnr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(s.Navn).toUpperCase().search(_this2.state.filter) >= 0;
                            }).sort(function (s1, s2) {
                                if (s1.Stationsnr === '') return 1;
                                if (s2.Stationsnr === '') return -1;
                                var comp = (s1[_this2.state.sort] === null ? '' : s1[_this2.state.sort].trim()).localeCompare(s2[_this2.state.sort] === null ? '' : s2[_this2.state.sort].trim(), 'da-DK');
                                return comp === 0 ? s1.Stationsnr < s2.Stationsnr ? -1 : s1.Stationsnr > s2.Stationsnr ? 1 : 0 : comp;
                            }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(function (station) {
                                return _this2.state.editId === null || station.Stationsnr !== _this2.state.editId && typeof station.editId === 'undefined' ? _react2.default.createElement(
                                    'tr',
                                    { key: station.Stationsnr, id: 'row-' + station.Stationsnr },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        station.Stationsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Navn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Laengde_grader
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Laengde_min
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Laengde_sek
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Laengde_100_dele_sek
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Laengde_1000_dele_min
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Bredde_grader
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Bredde_min
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Bredde_sek
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Bredde_100_dele_sek
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        station.Bredde_1000_dele_min
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'clickable' : 'disabled'), title: 'Rediger station', onClick: function onClick() {
                                                if (_this2.state.editId === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) _this2.setState({
                                                    editId: station.Stationsnr,
                                                    Stationsnr: station.Stationsnr,
                                                    Navn: station.Navn === null ? '' : station.Navn,
                                                    Laengde_grader: station.Laengde_grader === null ? '' : String(station.Laengde_grader),
                                                    Laengde_min: station.Laengde_min === null ? '' : String(station.Laengde_min),
                                                    Laengde_sek: station.Laengde_sek === null ? '' : String(station.Laengde_sek),
                                                    Laengde_100_dele_sek: station.Laengde_100_dele_sek === null ? '' : String(station.Laengde_100_dele_sek),
                                                    Laengde_1000_dele_min: station.Laengde_1000_dele_min === null ? '' : String(station.Laengde_1000_dele_min),
                                                    Bredde_grader: station.Bredde_grader === null ? '' : String(station.Bredde_grader),
                                                    Bredde_min: station.Bredde_min === null ? '' : String(station.Bredde_min),
                                                    Bredde_sek: station.Bredde_sek === null ? '' : String(station.Bredde_sek),
                                                    Bredde_100_dele_sek: station.Bredde_100_dele_sek === null ? '' : String(station.Bredde_100_dele_sek),
                                                    Bredde_1000_dele_min: station.Bredde_1000_dele_min === null ? '' : String(station.Bredde_1000_dele_min)
                                                });
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'clickable' : 'disabled'), title: 'Slet station', onClick: function onClick() {
                                                if (_this2.state.editId === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette station ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        station.Stationsnr,
                                                        ' (',
                                                        station.Navn,
                                                        ')'
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteListItem('station', station.Stationsnr, function () {
                                                        _reactNotifications.NotificationManager.success("Station " + station.Stationsnr + " (" + station.Navn + ") er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                ) : _react2.default.createElement(
                                    'tr',
                                    { key: 'editor', id: 'row-editor', className: 'edit-row' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Stationsnr', id: 'Stationsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Stationsnr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                            //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                            , onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: '', containerClassName: '',
                                            name: 'Navn', id: 'Navn', maxLength: '25', value: _this2.state.Navn,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Laengde_grader', id: 'Laengde_grader', maxLength: '3', value: _this2.state.Laengde_grader,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[2] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Laengde_min', id: 'Laengde_min', maxLength: '3', value: _this2.state.Laengde_min,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[3] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Laengde_sek', id: 'Laengde_sek', maxLength: '3', value: _this2.state.Laengde_sek,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[4] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Laengde_100_dele_sek', id: 'Laengde_100_dele_sek', maxLength: '3', value: _this2.state.Laengde_100_dele_sek,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[5] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Laengde_1000_dele_min', id: 'Laengde_1000_dele_min', maxLength: '3', value: _this2.state.Laengde_1000_dele_min,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[6] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Bredde_grader', id: 'Bredde_grader', maxLength: '3', value: _this2.state.Bredde_grader,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[7] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Bredde_min', id: 'Bredde_min', maxLength: '3', value: _this2.state.Bredde_min,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[8] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Bredde_sek', id: 'Bredde_sek', maxLength: '3', value: _this2.state.Bredde_sek,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[9] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Bredde_100_dele_sek', id: 'Bredde_100_dele_sek', maxLength: '3', value: _this2.state.Bredde_100_dele_sek,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[10] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Bredde_1000_dele_min', id: 'Bredde_1000_dele_min', maxLength: '3', value: _this2.state.Bredde_1000_dele_min,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[11] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                                _this2.save();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'button',
                        { className: "btn-primary" + (this.state.editId === null && this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? '' : ' disabled'), title: 'Opret ny station', onClick: function onClick() {
                                if (_this2.state.editId === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) {
                                    _this2.setState({
                                        editId: 'new',
                                        Stationsnr: '',
                                        Navn: '',
                                        Laengde_grader: '',
                                        Laengde_min: '',
                                        Laengde_sek: '',
                                        Laengde_100_dele_sek: '',
                                        Laengde_1000_dele_min: '',
                                        Bredde_grader: '',
                                        Bredde_min: '',
                                        Bredde_sek: '',
                                        Bredde_100_dele_sek: '',
                                        Bredde_1000_dele_min: ''
                                    });
                                    setTimeout(function () {
                                        var content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            } },
                        'Ny'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'filter', className: this.state.editId === null ? "" : "disabled" },
                        'Filter'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast s\xF8gev\xE6rdi', className: 'field-1 large-field',
                        name: 'filter', id: 'filter', disabled: this.state.editId !== null,
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value.toUpperCase();
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                _this2.setState({ filter: val });
                            }, 500);
                        }
                    }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort', className: this.state.editId === null ? "" : "disabled" },
                        'Sortering'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field-1 large-field',
                        name: 'sort', id: 'sort', disabled: this.state.editId !== null, value: this.state.sort, options: [{ key: 'Stationsnr', value: 'Stationsnr' }, { key: 'Navn', value: 'Navn' }],
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: this.onStandardFieldChange
                    })
                )
            ) : null;
        }
    }]);

    return StationsPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole
        },
        stations: state.admin.stations
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StationsPage);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangesPage = function (_React$Component) {
    _inherits(RangesPage, _React$Component);

    _createClass(RangesPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_RANGES;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function RangesPage(props) {
        _classCallCheck(this, RangesPage);

        var _this = _possibleConstructorReturn(this, (RangesPage.__proto__ || Object.getPrototypeOf(RangesPage)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var rangeNr = _this.state.Omraadenr;
                var entity = {
                    Omraadenr: _this.state.Omraadenr,
                    Navn: _this.state.Navn === '' ? null : _this.state.Navn
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createListItemItem('omraade', entity, function (id) {
                    _reactNotifications.NotificationManager.success('Omr\xE5de ' + id + ' er oprettet.', "Oprettelse", 4000);

                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + rangeNr);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateListItem('omraade', _this.state.editId, entity, function (id) {
                    _reactNotifications.NotificationManager.success('Omr\xE5de ' + id + ' er opdateret.', "Opdatering", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + rangeNr);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null,
            sortField: 'no'
        };
        return _this;
    }

    _createClass(RangesPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getListItems('omraade'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.ranges ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Omr\xE5der'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sub-page-content', className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'no' });
                                        } },
                                    'Omr\xE5denr'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'name' });
                                        } },
                                    'Navn'
                                ),
                                _react2.default.createElement('th', { className: 'commands-column' })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.ranges.sort(function (s1, s2) {
                                if (s1.Omraadenr === '') return 1;
                                if (s2.Omraadenr === '') return -1;
                                return _this2.state.sortField === 'no' ? s1.Omraadenr < s2.Omraadenr ? -1 : 1 : s1.Navn.localeCompare(s2.Navn, 'da-DK');
                            }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(function (range) {
                                return _this2.state.editId === null || range.Omraadenr !== _this2.state.editId && typeof range.editId === 'undefined' ? _react2.default.createElement(
                                    'tr',
                                    { key: range.Omraadenr, id: 'row-' + range.Omraadenr },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        range.Omraadenr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        range.Navn
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger omr\xE5de', onClick: function onClick() {
                                                if (_this2.state.editId === null) _this2.setState({
                                                    editId: range.Omraadenr,
                                                    Omraadenr: range.Omraadenr,
                                                    Navn: range.Navn === null ? '' : range.Navn
                                                });
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet omr\xE5de', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette omr\xE5de ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        range.Omraadenr
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteListItem('omraade', range.Omraadenr, function () {
                                                        _reactNotifications.NotificationManager.success('Omr\xE5de ' + range.Omraadenr + ' er slettet.', "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                ) : _react2.default.createElement(
                                    'tr',
                                    { key: 'editor', id: 'row-editor', className: 'edit-row' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Omraadenr', id: 'Omraadenr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Omraadenr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                            //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                            , onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: '', containerClassName: '',
                                            name: 'Navn', id: 'Navn', maxLength: '25', value: _this2.state.Navn,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem omr\xE5de', onClick: function onClick() {
                                                _this2.save();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'button',
                        { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret nyt omr\xE5de', onClick: function onClick() {
                                if (_this2.state.editId === null) {
                                    _this2.setState({
                                        editId: 'new',
                                        Omraadenr: '',
                                        Navn: ''
                                    });
                                    setTimeout(function () {
                                        var content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            } },
                        'Ny'
                    )
                )
            ) : null;
        }
    }]);

    return RangesPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        ranges: state.admin.ranges
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RangesPage);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _lib = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZipCodesPage = function (_React$Component) {
    _inherits(ZipCodesPage, _React$Component);

    _createClass(ZipCodesPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_ZIPS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function ZipCodesPage(props) {
        _classCallCheck(this, ZipCodesPage);

        var _this = _possibleConstructorReturn(this, (ZipCodesPage.__proto__ || Object.getPrototypeOf(ZipCodesPage)).call(this, props));

        _this.fields = [];
        _this.timeoutHandler = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var Postnr = _this.state.Postnr;
                var entity = {
                    Postnr: _this.state.Postnr,
                    By: _this.state.By === '' ? null : _this.state.By
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createListItemItem('postnr', entity, function (id) {
                    _reactNotifications.NotificationManager.success("Postnummeret " + id + " (" + _this.state.By + ") er oprettet.", "Oprettelse", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + Postnr);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateListItem('postnr', _this.state.editId, entity, function (id) {
                    _reactNotifications.NotificationManager.success("Postnummeret " + id + " (" + _this.state.By + ") er opdateret.", "Opdatering", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + Postnr);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null,
            filter: '',
            sort: 'Postnr'
        };
        return _this;
    }

    _createClass(ZipCodesPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getListItems('postnr'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.zipCodes ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Postnumre'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sub-page-content', className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: this.state.editId === null ? "clickable" : "", onClick: function onClick() {
                                            if (_this2.state.editId === null) _this2.setState({ sort: 'Postnr' });
                                        } },
                                    'Postnummer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: this.state.editId === null ? "clickable" : "", onClick: function onClick() {
                                            if (_this2.state.editId === null) _this2.setState({ sort: 'By' });
                                        } },
                                    'By'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.zipCodes.filter(function (p) {
                                return _this2.state.filter === '' ? true : (0, _lib.nullToBlank)(p.Postnr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(p.By).toUpperCase().search(_this2.state.filter) >= 0;
                            }).sort(function (p1, p2) {
                                if (p1.Postnr === '') return 1;
                                if (p2.Postnr === '') return -1;
                                var comp = (p1[_this2.state.sort] === null ? '' : p1[_this2.state.sort].trim()).localeCompare(p2[_this2.state.sort] === null ? '' : p2[_this2.state.sort].trim(), 'da-DK');
                                return comp === 0 ? p1.Postnr < p2.Postnr ? -1 : p1.Postnr > p2.Postnr ? 1 : 0 : comp;
                            }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(function (zipCodeObj) {
                                return _this2.state.editId === null || zipCodeObj.Postnr !== _this2.state.editId && typeof zipCodeObj.editId === 'undefined' ? _react2.default.createElement(
                                    'tr',
                                    { key: zipCodeObj.Postnr, id: 'row-' + zipCodeObj.Postnr },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        zipCodeObj.Postnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        zipCodeObj.By
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger postnummer', onClick: function onClick() {
                                                if (_this2.state.editId === null) _this2.setState({
                                                    editId: zipCodeObj.Postnr,
                                                    Postnr: zipCodeObj.Postnr,
                                                    By: zipCodeObj.By === null ? '' : zipCodeObj.By
                                                });
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet postnummer', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette postnummeret ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        zipCodeObj.Postnr,
                                                        ' (',
                                                        zipCodeObj.By,
                                                        ')'
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteListItem('postnr', zipCodeObj.Postnr, function () {
                                                        _reactNotifications.NotificationManager.success("Postnummeret " + zipCodeObj.Postnr + " (" + zipCodeObj.By + ") er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                ) : _react2.default.createElement(
                                    'tr',
                                    { key: 'editor', id: 'row-editor', className: 'edit-row' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field60', containerClassName: 'display-inline-block',
                                            name: 'Postnr', id: 'Postnr', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.Postnr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                            //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                            , onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: '', containerClassName: '',
                                            name: 'By', id: 'By', maxLength: '25', value: _this2.state.By,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem postnummer', onClick: function onClick() {
                                                _this2.save();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'button',
                        { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret ny postnummer', onClick: function onClick() {
                                if (_this2.state.editId === null) {
                                    _this2.setState({
                                        editId: 'new',
                                        Postnr: '',
                                        By: ''
                                    });
                                    setTimeout(function () {
                                        var content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            } },
                        'Ny'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'filter', className: this.state.editId === null ? "" : "disabled" },
                        'Filter'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast s\xF8gev\xE6rdi', className: 'field-1 large-field',
                        name: 'filter', id: 'filter', disabled: this.state.editId !== null,
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value.toUpperCase();
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                _this2.setState({ filter: val });
                            }, 500);
                        }
                    }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort', className: this.state.editId === null ? "" : "disabled" },
                        'Sortering'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field-1 large-field',
                        name: 'sort', id: 'sort', disabled: this.state.editId !== null, value: this.state.sort, options: [{ key: 'Postnr', value: 'Postnr' }, { key: 'By', value: 'By' }],
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: this.onStandardFieldChange
                    })
                )
            ) : null;
        }
    }]);

    return ZipCodesPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        zipCodes: state.admin.zipCodes
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ZipCodesPage);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NightTimesPage = function (_React$Component) {
    _inherits(NightTimesPage, _React$Component);

    _createClass(NightTimesPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_NIGHT_TIMES;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function NightTimesPage(props) {
        _classCallCheck(this, NightTimesPage);

        var _this = _possibleConstructorReturn(this, (NightTimesPage.__proto__ || Object.getPrototypeOf(NightTimesPage)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var Uge = _this.state.Uge;
                var entity = {
                    Uge: Number(_this.state.Uge),
                    Start: _this.state.Start === '' ? null : Number(_this.state.Start),
                    Slut: _this.state.Slut === '' ? null : Number(_this.state.Slut),
                    Afsluttet: _this.state.Afsluttet === '' ? null : _this.state.Afsluttet === "Ja" ? true : false
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createListItemItem('nattid', entity, function (id) {
                    _reactNotifications.NotificationManager.success('Nattiden for uge ' + id + ' er oprettet.', "Oprettelse", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + Uge);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateListItem('nattid', _this.state.editId, entity, function (id) {
                    _reactNotifications.NotificationManager.success('Nattiden for uge ' + id + ' er oprettet.', "Opdatering", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + Uge);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null,
            sortField: 'no'
        };
        return _this;
    }

    _createClass(NightTimesPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getListItems('nattid'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.nightTimes ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Nattider'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sub-page-content', className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'no' });
                                        } },
                                    'Uge'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'zip' });
                                        } },
                                    'Start'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Slut'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Afsluttet'
                                ),
                                _react2.default.createElement('th', { className: 'commands-column' })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.nightTimes.sort(function (s1, s2) {
                                if (s1.Uge === '') return 1;
                                if (s2.Uge === '') return -1;
                                return _this2.state.sortField === 'no' ? s1.Uge < s2.Uge ? -1 : 1 : s1.Start.toString().localeCompare(s2.Start.toString(), 'da-DK');
                            }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(function (nightTime) {
                                return _this2.state.editId === null || nightTime.Uge !== _this2.state.editId && typeof nightTime.editId === 'undefined' ? _react2.default.createElement(
                                    'tr',
                                    { key: nightTime.Uge, id: 'row-' + nightTime.Uge },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        nightTime.Uge
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        nightTime.Start
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        nightTime.Slut
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        nightTime.Afsluttet ? 'Ja' : 'Nej'
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger nattid', onClick: function onClick() {
                                                if (_this2.state.editId === null) _this2.setState({
                                                    editId: nightTime.Uge,
                                                    Uge: nightTime.Uge,
                                                    Start: nightTime.Start === null ? '' : nightTime.Start,
                                                    Slut: nightTime.Slut === null ? '' : nightTime.Slut,
                                                    Afsluttet: nightTime.Afsluttet === null ? '' : nightTime.Afsluttet
                                                });
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet nattid', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette nattiden for uge ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        nightTime.Uge
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteListItem('nattid', nightTime.Uge, function () {
                                                        _reactNotifications.NotificationManager.success('Nattiden for uge ' + nightTime.Uge + ' er slettet.', "Sletning", 4000);;
                                                    }));
                                                });
                                            } })
                                    )
                                ) : _react2.default.createElement(
                                    'tr',
                                    { key: 'editor', id: 'row-editor', className: 'edit-row' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.Uge.toString(),
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                            //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                            , onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: '', containerClassName: 'display-inline-block',
                                            name: 'Start', id: 'Start', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3,4}" }], value: _this2.state.Start.toString(),
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: '', containerClassName: 'display-inline-block',
                                            name: 'Slut', id: 'Slut', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3,4}" }], value: _this2.state.Slut.toString(),
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[2] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: false, className: '', containerClassName: 'display-inline-block',
                                            name: 'Afsluttet', id: 'Afsluttet', options: [{ key: "Ja", value: "Ja" }, { key: "Nej", value: "Nej" }], defaultValue: Number(nightTime.Afsluttet) ? 'Ja' : 'Nej',
                                            autoCheckErrors: false, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[3] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem nattid', onClick: function onClick() {
                                                _this2.save();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'button',
                        { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret ny nattid', onClick: function onClick() {
                                if (_this2.state.editId === null) {
                                    _this2.setState({
                                        editId: 'new',
                                        Uge: '',
                                        Start: '',
                                        Slut: '',
                                        Afsluttet: 0
                                    });
                                    setTimeout(function () {
                                        var content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            } },
                        'Ny'
                    )
                )
            ) : null;
        }
    }]);

    return NightTimesPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        nightTimes: state.admin.nightTimes
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NightTimesPage);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _reactRedux = __webpack_require__(3);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _reactRouter = __webpack_require__(19);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DerbysPage = function (_React$Component) {
    _inherits(DerbysPage, _React$Component);

    _createClass(DerbysPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_DERBYS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN]; // empty means allowed for all
        }
    }]);

    function DerbysPage(props) {
        _classCallCheck(this, DerbysPage);

        var _this = _possibleConstructorReturn(this, (DerbysPage.__proto__ || Object.getPrototypeOf(DerbysPage)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Foreningsnr: _this.state.Foreningsnr,
                    Aar: _this.state.Aar === '' ? null : _this.state.Aar,
                    Fra: _this.state.Fra === '' ? null : _this.state.Fra,
                    Til: _this.state.Til === '' ? null : _this.state.Til,
                    Alder: _this.state.Alder === '' ? null : Number(_this.state.Alder)
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createListItemItem('derby', entity, function (id) {
                    _reactNotifications.NotificationManager.success('Derby\'et i forening ' + _this.state.Foreningsnr + ' (\xE5r: ' + _this.state.Aar + ') er oprettet', "Oprettelse", 4000);
                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + id);
                        currentRow.scrollIntoView(false);
                    });
                }));else _this.props.dispatch(AdminActions.updateListItem('derby', _this.state.editId, entity, function (id) {
                    _reactNotifications.NotificationManager.success('Derby\'et i forening ' + _this.state.Foreningsnr + ' (\xE5r: ' + _this.state.Aar + ') er opdateret', "Opdatering", 4000);

                    _this.setState({ editId: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + id);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null,
            sortField: 'no'
        };
        return _this;
    }

    _createClass(DerbysPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getListItems('derby'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.derby ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Derbyer'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'sub-page-content', className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'no' });
                                        } },
                                    'Foreningsnr.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sortField: 'name' });
                                        } },
                                    '\xC5rgang'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Fra'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Til'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Alder'
                                ),
                                _react2.default.createElement('th', { className: 'commands-column' })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.derby.sort(function (s1, s2) {
                                if (s1.Foreningsnr === '') return 1;
                                if (s2.Foreningsnr === '') return -1;
                                return _this2.state.sortField === 'no' ? s1.Foreningsnr < s2.Foreningsnr ? -1 : 1 : s1.Aar.toString().localeCompare(s2.Aar.toString(), 'da-DK');
                            }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(function (derby) {
                                return _this2.state.editId === null || derby.Nr !== _this2.state.editId && typeof derby.editId === 'undefined' ? _react2.default.createElement(
                                    'tr',
                                    { key: derby.Nr, id: 'row-' + derby.Nr },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        derby.Foreningsnr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        derby.Aar
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        derby.Fra
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        derby.Til
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        derby.Alder
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger derby', onClick: function onClick() {
                                                if (_this2.state.editId === null) _this2.setState({
                                                    editId: derby.Nr,
                                                    Foreningsnr: derby.Foreningsnr,
                                                    Aar: derby.Aar === null ? '' : derby.Aar,
                                                    Fra: derby.Fra === null ? '' : String(derby.Fra),
                                                    Til: derby.Til === null ? '' : String(derby.Til),
                                                    Alder: derby.Alder === null ? '' : String(derby.Alder)
                                                });
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet derby', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette derby\'et for forening ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        derby.Foreningsnr,
                                                        ' (\xE5r: ',
                                                        derby.Aar,
                                                        ')'
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteListItem('derby', derby.Nr, function () {
                                                        _reactNotifications.NotificationManager.success('Derby\'et i forening ' + derby.Foreningsnr + ' (\xE5r: ' + derby.Foreningsnr + ') er slettet', "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                ) : _react2.default.createElement(
                                    'tr',
                                    { key: 'editor', id: 'row-editor', className: 'edit-row' },
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true
                                            //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                            , onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[0] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Aar', id: 'Aar', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.Aar,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field60', containerClassName: 'display-inline-block',
                                            name: 'Fra', id: 'Fra', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.Fra,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[2] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field60', containerClassName: 'display-inline-block',
                                            name: 'Til', id: 'Til', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.Til,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[3] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                            name: 'Alder', id: 'Alder', maxLength: '2', value: _this2.state.Alder,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[4] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'commands-column' },
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem derby', onClick: function onClick() {
                                                _this2.save();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'button',
                        { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret ny derby', onClick: function onClick() {
                                if (_this2.state.editId === null) {
                                    _this2.setState({
                                        editId: 'new',
                                        Foreningsnr: '',
                                        Aar: '',
                                        Fra: '',
                                        Til: '',
                                        Alder: ''
                                    });
                                    setTimeout(function () {
                                        var content = document.getElementById("sub-page-content");
                                        content.scrollTop = content.scrollHeight;
                                    });
                                }
                            } },
                        'Ny'
                    )
                )
            ) : null;
        }
    }]);

    return DerbysPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        derby: state.admin.derby
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DerbysPage);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _lib = __webpack_require__(18);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _Signups = __webpack_require__(823);

var _Signups2 = _interopRequireDefault(_Signups);

var _Watches = __webpack_require__(824);

var _Watches2 = _interopRequireDefault(_Watches);

var _Membergames = __webpack_require__(825);

var _Membergames2 = _interopRequireDefault(_Membergames);

var _Financials = __webpack_require__(826);

var _Financials2 = _interopRequireDefault(_Financials);

var _Submissions = __webpack_require__(827);

var _Submissions2 = _interopRequireDefault(_Submissions);

var _Pigeons = __webpack_require__(828);

var _Pigeons2 = _interopRequireDefault(_Pigeons);

var _Rings = __webpack_require__(829);

var _Rings2 = _interopRequireDefault(_Rings);

var _DM = __webpack_require__(830);

var _DM2 = _interopRequireDefault(_DM);

var _Status = __webpack_require__(831);

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorListsPage = function (_React$Component) {
    _inherits(ErrorListsPage, _React$Component);

    _createClass(ErrorListsPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_ERROR_LISTS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN]; // empty means allowed for all
        }
    }]);

    function ErrorListsPage(props) {
        _classCallCheck(this, ErrorListsPage);

        var _this = _possibleConstructorReturn(this, (ErrorListsPage.__proto__ || Object.getPrototypeOf(ErrorListsPage)).call(this, props));

        _this.loadErrorList = function (newestProps) {
            newestProps.dispatch(AdminActions.getErrorListItems(newestProps.params.subpage, _this.state.week, _this.state.club));
        };

        _this.subForm = null;

        _this.setEditMode = function (mode) {
            return _this.setState({ editMode: mode });
        };

        _this.updateRow = function (key, updates, onSuccess) {
            return _this.props.dispatch(AdminActions.updateErrorListItem(_this.props.params.subpage, key, updates, onSuccess));
        };

        _this.deleteRow = function (key, onSuccess) {
            return _this.props.dispatch(AdminActions.deleteErrorListItem(_this.props.params.subpage, key, onSuccess));
        };

        _this.acceptRow = function (key, onSuccess) {
            return _this.props.dispatch(AdminActions.acceptErrorListItem(_this.props.params.subpage, key, onSuccess));
        };

        var week = (0, _lib.currentWeek)();
        _this.state = {
            week: props.params.subpage === 'pigeons' || props.params.subpage === 'rings' || props.params.subpage === 'dm' ? 'blank' : String(week),
            selectedWeek: String(week),
            club: props.params.subpage === 'pigeons' || props.params.subpage === 'rings' || props.params.subpage === 'dm' || props.params.subpage === 'status' ? 'all' : 'blank',
            selectedClub: 'blank',
            editMode: false
        };
        return _this;
    }

    _createClass(ErrorListsPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getClubs());
            this.loadErrorList(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.params.subpage !== this.props.params.subpage) {
                this.setState({
                    week: nextProps.params.subpage === 'pigeons' || nextProps.params.subpage === 'rings' || nextProps.params.subpage === 'dm' ? 'blank' : this.state.selectedWeek,
                    club: this.state.selectedClub === 'blank' && (nextProps.params.subpage === 'pigeons' || nextProps.params.subpage === 'rings' || nextProps.params.subpage === 'dm' || nextProps.params.subpage === 'status') ? 'all' : this.state.selectedClub
                }, function () {
                    return _this2.loadErrorList(nextProps);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var showRow = function showRow(week, club) {
                return (_this3.state.week === 'all' || _this3.state.week === 'blank' && (week === null || week === '') || _this3.state.week === week) && (_this3.state.club === 'all' || _this3.state.club === 'blank' && (club === null || club === '') || _this3.state.club === club);
            };

            // Skip until ready.
            if (!this.props.admin.isClubsRead) return null;

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'signups':
                    subPage = _react2.default.createElement(_Signups2.default, { data: this.props.admin.errorLists.signups.filter(function (row) {
                            return showRow(row.Uge, row.Forening);
                        }).sort(function (row1, row2) {
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            if (row1.Forening < row2.Forening) return -1;
                            if (row1.Forening > row2.Forening) return 1;
                            if (row1.KFK < row2.KFK) return -1;
                            if (row1.KFK > row2.KFK) return 1;
                            if (row1.Slag < row2.Slag) return -1;
                            if (row1.Slag > row2.Slag) return 1;
                            if (row1.Ringnummer < row2.Ringnummer) return -1;
                            if (row1.Ringnummer > row2.Ringnummer) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'watches':
                    subPage = _react2.default.createElement(_Watches2.default, { data: this.props.admin.errorLists.watches.filter(function (row) {
                            return showRow(row.Ugenr, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (Number(row1.Ugenr) < Number(row2.Ugenr)) return -1;
                            if (Number(row1.Ugenr) > Number(row2.Ugenr)) return 1;
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Slagnr < row2.Slagnr) return -1;
                            if (row1.Slagnr > row2.Slagnr) return 1;
                            if (row1.Urnr < row2.Urnr) return -1;
                            if (row1.Urnr > row2.Urnr) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'membergames':
                    subPage = _react2.default.createElement(_Membergames2.default, { data: this.props.admin.errorLists.membergames.filter(function (row) {
                            return showRow(row.Uge, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Slag < row2.Slag) return -1;
                            if (row1.Slag > row2.Slag) return 1;
                            if (row1.KFK < row2.KFK) return -1;
                            if (row1.KFK > row2.KFK) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'financials':
                    subPage = _react2.default.createElement(_Financials2.default, { data: this.props.admin.errorLists.financials.filter(function (row) {
                            return showRow(row.Uge, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Sektion < row2.Sektion) return -1;
                            if (row1.Sektion > row2.Sektion) return 1;
                            if (row1.KFK < row2.KFK) return -1;
                            if (row1.KFK > row2.KFK) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'submissions':
                    subPage = _react2.default.createElement(_Submissions2.default, { data: this.props.admin.errorLists.submissions.filter(function (row) {
                            return showRow(row.Uge, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.KFK < row2.KFK) return -1;
                            if (row1.KFK > row2.KFK) return 1;
                            if (row1.Slagnr < row2.Slagnr) return -1;
                            if (row1.Slagnr > row2.Slagnr) return 1;
                            if (row1.Indleveret < row2.Indleveret) return -1;
                            if (row1.Indleveret > row2.Indleveret) return 1;
                            return 0;
                        }).toArray(),
                        deleteRow: this.deleteRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'pigeons':
                    subPage = _react2.default.createElement(_Pigeons2.default, { data: this.props.admin.errorLists.pigeons.filter(function (row) {
                            return showRow(null, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Slagnr < row2.Slagnr) return -1;
                            if (row1.Slagnr > row2.Slagnr) return 1;
                            if (row1.Ringnummer < row2.Ringnummer) return -1;
                            if (row1.Ringnummer > row2.Ringnummer) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case "rings":
                    subPage = _react2.default.createElement(_Rings2.default, { data: this.props.admin.errorLists.rings.filter(function (row) {
                            return showRow(null, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Slagnr < row2.Slagnr) return -1;
                            if (row1.Slagnr > row2.Slagnr) return 1;
                            if (row1.Aar < row2.Aar) return -1;
                            if (row1.Aar > row2.Aar) return 1;
                            if (row1.Fra < row2.Fra) return -1;
                            if (row1.Fra > row2.Fra) return 1;
                            if (row1.Til < row2.Til) return -1;
                            if (row1.Til > row2.Til) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'dm':
                    subPage = _react2.default.createElement(_DM2.default, { data: this.props.admin.errorLists.dm.filter(function (row) {
                            return showRow(null, row.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (row1.Slag < row2.Slag) return -1;
                            if (row1.Slag > row2.Slag) return 1;
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            if (row1.KFK < row2.KFK) return -1;
                            if (row1.KFK > row2.KFK) return 1;
                            return 0;
                        }).toArray(),
                        setEditMode: this.setEditMode, updateRow: this.updateRow, deleteRow: this.deleteRow, acceptRow: this.acceptRow,
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
                case 'status':
                    var hasWeeks = this.props.admin.errorLists.status.toArray().findIndex(function (status) {
                        return status.Uge !== '0';
                    }) >= 0;
                    subPage = _react2.default.createElement(_Status2.default, { data: this.props.admin.errorLists.status.filter(function (status) {
                            return (_this3.state.week === 'all' && (!hasWeeks || status.Uge !== '') || _this3.state.week === 'blank' && status.Uge === '' || _this3.state.week !== 'all' && _this3.state.week !== 'blank' && _this3.state.week === status.Uge) && (_this3.state.club === 'all' || _this3.state.club !== 'blank' && _this3.state.club === status.Foreningsnr);
                        }).sort(function (row1, row2) {
                            if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                            if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                            if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                            if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                            return 0;
                        }).toArray(),
                        ref: function ref(instance) {
                            _this3.subForm = instance;
                        }
                    });
                    break;
            }
            var editMode = this.state.editMode;

            var clubList = this.props.admin.clubs.filter(function (c) {
                return _this3.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id && c.Sektionsnr !== '99' || _this3.props.auth.currentRole === _UserRoles2.default.SECTION_ADMIN.id && c.Sektionsnr === _this3.props.auth.currentEntity;
            }).sort(function (c1, c2) {
                return c1.Foreningsnr < c2.Foreningsnr ? -1 : 1;
            }).map(function (club) {
                return { key: club.Foreningsnr, value: club.Foreningsnr + ' ' + club.Navn };
            }).toArray();
            clubList.unshift({ key: 'all', value: 'Alle' });
            clubList.unshift({ key: 'blank', value: 'Ingen' });

            var weekList = [].concat(_toConsumableArray(Array(53).keys())).map(function (wk) {
                return { key: String(wk + 1), value: String(wk + 1) };
            });
            weekList.unshift({ key: 'all', value: 'Alle' });
            weekList.unshift({ key: 'blank', value: 'Ukendt' });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Fejllister'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'signups' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "signups") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Tilmeld'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'watches' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "watches") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Ure'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'membergames' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "membergames") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Slagspil'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'financials' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "financials") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Regnskab'
                            )
                        ),
                        this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'submissions' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "submissions") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Indlevering'
                            )
                        ) : null,
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: (this.props.params.subpage === 'status' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : ''), to: editMode ? '' : _routeconstants.ROUTE_ERROR_LISTS.replace(":subpage", "status") },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Status'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'week', disabled: editMode },
                                'Uge'
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field100', containerClassName: 'display-inline-block',
                                name: 'week', id: 'week', value: this.state.week, options: weekList, disabled: editMode,
                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                onChange: function onChange(e) {
                                    _this3.setState({
                                        week: e.target.value,
                                        selectedWeek: e.target.value
                                    }, function () {
                                        return _this3.loadErrorList(_this3.props);
                                    });
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'club', disabled: editMode },
                                'Forening'
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field250', containerClassName: 'display-inline-block',
                                name: 'club', id: 'club', value: this.state.club, options: clubList, disabled: editMode,
                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                onChange: function onChange(e) {
                                    _this3.setState({
                                        club: e.target.value,
                                        selectedClub: e.target.value
                                    }, function () {
                                        return _this3.loadErrorList(_this3.props);
                                    });
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Accepter alle viste r\xE6kker', disabled: editMode || this.props.params.subpage === 'submissions' || this.props.params.subpage === 'status' || this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && this.props.params.subpage !== 'signups' && this.props.params.subpage !== 'membergames' && this.props.params.subpage !== 'financials', onClick: function onClick() {
                                    if (!editMode && _this3.props.params.subpage !== 'status' && (_this3.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this3.props.params.subpage === 'signups' || _this3.props.params.subpage === 'membergames' || _this3.props.params.subpage === 'financials')) {
                                        var keys = _this3.subForm.getWrappedInstance().getAllKeys();
                                        if (keys.length > 0) (0, _confirmDialog.confirm)("Accepter alle rækker", _react2.default.createElement(
                                            'span',
                                            null,
                                            '\xD8nsker du at acceptere alle viste r\xE6kker?'
                                        ), function () {
                                            _this3.props.dispatch(AdminActions.acceptErrorListItem(_this3.props.params.subpage, keys, function (response) {
                                                if (response.accepted.length > 0) _reactNotifications.NotificationManager.success(String(response.accepted.length) + " række" + (response.accepted.length > 1 ? 'r' : '') + " blev accepteret.", "Accept", 4000);
                                                if (response.failed.length > 0) _reactNotifications.NotificationManager.warning(String(response.failed.length) + " række" + (response.failed.length > 1 ? 'r' : '') + " kunne ikke accepteres jfr. nye fejlbeskeder." + (response.accepted.length === 0 ? " Ingen rækker blev accepteret." : ""), "Fejl", 0);
                                            }));
                                        });
                                    }
                                } },
                            'Accepter alle'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Slet alle viste r\xE6kker', disabled: editMode || this.props.params.subpage === 'status' || this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && this.props.params.subpage !== 'signups' && this.props.params.subpage !== 'membergames' && this.props.params.subpage !== 'financials', onClick: function onClick() {
                                    if (!editMode && _this3.props.params.subpage !== 'status' && (_this3.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this3.props.params.subpage === 'signups' || _this3.props.params.subpage === 'membergames' || _this3.props.params.subpage === 'financials')) {
                                        var keys = _this3.subForm.getWrappedInstance().getAllKeys();
                                        if (keys.length > 0) (0, _confirmDialog.confirm)("Slet alle rækker", _react2.default.createElement(
                                            'span',
                                            null,
                                            '\xD8nsker du at slette alle viste r\xE6kker?'
                                        ), function () {
                                            _this3.props.dispatch(AdminActions.deleteErrorListItem(_this3.props.params.subpage, keys, function (response) {
                                                _reactNotifications.NotificationManager.success(String(response.deleted.length) + " række" + (response.deleted.length > 1 ? 'r' : '') + " blev slettet.", "Sletning", 4000);
                                            }));
                                        });
                                    }
                                } },
                            'Slet alle'
                        )
                    )
                )
            );
        }
    }]);

    return ErrorListsPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            errorLists: state.admin.errorLists,
            isClubsRead: state.admin.isClubsRead,
            clubs: state.admin.clubs
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ErrorListsPage);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Signups = function (_React$Component) {
    _inherits(Signups, _React$Component);

    function Signups(props) {
        _classCallCheck(this, Signups);

        var _this = _possibleConstructorReturn(this, (Signups.__proto__ || Object.getPrototypeOf(Signups)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.onCheckFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.checked ? -1 : 0));
        };

        _this.onSecGrpChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value >= '1' && e.target.value <= '6' ? e.target.value : ''));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Key: row.Key
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Signups, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'KFK'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Due'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'K\xF8n'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Sport'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Sek.A'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Sek.B'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Grp.A'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Grp.B'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Pulje'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Elite'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Zone'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'DM'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Mark.'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Forening'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Hjemk.'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'D\xF8gn'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Ur'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({ Key: row.Key }, {
                                                    Uge: _this2.state.Uge === '' ? null : _this2.state.Uge,
                                                    Forening: _this2.state.Forening === '' ? null : _this2.state.Forening,
                                                    KFK: _this2.state.KFK === '' ? null : _this2.state.KFK,
                                                    Slag: _this2.state.Slag === '' ? null : _this2.state.Slag,
                                                    Ringnummer: _this2.state.Ringnummer === '' ? null : _this2.state.Ringnummer,
                                                    Koen: _this2.state.Koen === '' ? null : _this2.state.Koen,
                                                    Sportsdue: _this2.state.Sportsdue,
                                                    SektionA: _this2.state.SektionA === '' ? 0 : Number(_this2.state.SektionA),
                                                    SektionB: _this2.state.SektionB === '' ? 0 : Number(_this2.state.SektionB),
                                                    GruppeA: _this2.state.GruppeA === '' ? 0 : Number(_this2.state.GruppeA),
                                                    GruppeB: _this2.state.GruppeB === '' ? 0 : Number(_this2.state.GruppeB),
                                                    Pulje: _this2.state.Pulje,
                                                    Elite: _this2.state.Elite,
                                                    Z_Spil: _this2.state.Z_Spil,
                                                    DM: _this2.state.DM,
                                                    DueMarkering: _this2.state.DueMarkering,
                                                    DueMarkeringT: _this2.state.DueMarkering === null || _this2.state.DueMarkering === 0 ? null : row.DueMarkeringT === null || row.DueMarkeringT === '' ? 'X' : row.DueMarkeringT,
                                                    ForeningskrydsT: _this2.state.ForeningskrydsT === '' ? null : _this2.state.ForeningskrydsT,
                                                    Hjemkomst: _this2.state.Hjemkomst,
                                                    Doegn: _this2.state.Doegn === '' ? null : Number(_this2.state.Doegn),
                                                    Urnr: _this2.state.Urnr === '' ? null : Number(_this2.state.Urnr)
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Rækken " + _this2.state.Ringnummer + " (KFK " + _this2.state.KFK + "/Uge " + _this2.state.Uge + ") er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: _this2.state.Uge,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Forening', id: 'Forening', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Forening,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'KFK', id: 'KFK', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.KFK,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slag', id: 'Slag', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slag,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { minWidth: '100px' } },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field150', containerClassName: 'display-inline-block',
                                        name: 'Ringnummer', id: 'Ringnummer', maxLength: '11', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}" }], value: _this2.state.Ringnummer,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Koen', id: 'Koen', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[AUX]" }], value: _this2.state.Koen,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onUpperCaseFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Sportsdue', id: 'Sportsdue', checked: _this2.state.Sportsdue !== null && _this2.state.Sportsdue !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'SektionA', id: 'SektionA', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-6]" }], value: _this2.state.SektionA,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onSecGrpChange,
                                        ref: function ref(instance) {
                                            _this2.fields[6] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'SektionB', id: 'SektionB', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-6]" }], value: _this2.state.SektionB,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onSecGrpChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'GruppeA', id: 'GruppeA', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-6]" }], value: _this2.state.GruppeA,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onSecGrpChange,
                                        ref: function ref(instance) {
                                            _this2.fields[8] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'GruppeB', id: 'GruppeB', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[1-6]" }], value: _this2.state.GruppeB,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onSecGrpChange,
                                        ref: function ref(instance) {
                                            _this2.fields[9] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Pulje', id: 'Pulje', checked: _this2.state.Pulje !== null && _this2.state.Pulje !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Elite', id: 'Elite', checked: _this2.state.Elite !== null && _this2.state.Elite !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Z_Spil', id: 'Z_Spil', checked: _this2.state.Z_Spil !== null && _this2.state.Z_Spil !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'DM', id: 'DM', checked: _this2.state.DM !== null && _this2.state.DM !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Duemarkering', id: 'Duemarkering', checked: _this2.state.Duemarkering !== null && _this2.state.Duemarkering !== 0, onChange: _this2.onCheckFieldChange })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'ForeningskrydsT', id: 'ForeningskrydsT', maxLength: '10', value: _this2.state.ForeningskrydsT,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[10] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'Hjemkomst', id: 'Hjemkomst', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}" }], value: _this2.state.Hjemkomst,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[11] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Doegn', id: 'Doegn', value: _this2.state.Doegn,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[12] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Urnr', id: 'Urnr', value: _this2.state.Urnr,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[13] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Uge: row.Uge === null ? '' : row.Uge,
                                                Forening: row.Forening === null ? '' : row.Forening,
                                                KFK: row.KFK === null ? '' : row.KFK,
                                                Slag: row.Slag === null ? '' : row.Slag,
                                                Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                                Koen: row.Koen === null ? '' : row.Koen,
                                                Sportsdue: row.Sportsdue,
                                                SektionA: row.SektionA === null || row.SektionA === 0 ? '' : String(row.SektionA),
                                                SektionB: row.SektionB === null || row.SektionB === 0 ? '' : String(row.SektionB),
                                                GruppeA: row.GruppeA === null || row.GruppeA === 0 ? '' : String(row.GruppeA),
                                                GruppeB: row.GruppeB === null || row.GruppeB === 0 ? '' : String(row.GruppeB),
                                                Pulje: row.Pulje,
                                                Elite: row.Elite,
                                                Z_Spil: row.Z_Spil,
                                                DM: row.DM,
                                                DueMarkering: row.DueMarkering,
                                                ForeningskrydsT: row.ForeningskrydsT === null ? '' : row.ForeningskrydsT,
                                                Hjemkomst: row.Hjemkomst === null ? '' : _moment2.default.utc(row.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                                Doegn: row.Doegn === null ? '' : String(row.Doegn),
                                                Urnr: row.Urnr === null ? '' : String(row.Urnr),
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette r\xE6kken ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Ringnummer,
                                                    ' (KFK ',
                                                    row.KFK,
                                                    '/Uge ',
                                                    row.Uge,
                                                    ')'
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{ Key: row.Key }], function () {
                                                    _reactNotifications.NotificationManager.success("Rækken " + row.Ringnummer + " (KFK " + row.KFK + "/Uge " + row.Uge + ") er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere r\xE6kken ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Ringnummer,
                                                    ' (KFK ',
                                                    row.KFK,
                                                    '/Uge ',
                                                    row.Uge,
                                                    ')'
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{ Key: row.Key }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Rækken " + row.Ringnummer + " (KFK " + row.KFK + "/Uge " + row.Uge + ") er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : row.Uge
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Forening === null ? '' : row.Forening
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.KFK === null ? '' : row.KFK
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slag === null ? '' : row.Slag
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { minWidth: '100px' } },
                                    row.Ringnummer === null ? '' : row.Ringnummer
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Koen === null ? '' : row.Koen
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Sportsdue === 0 || row.Sportsdue === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.SektionA === 0 || row.SektionA === null ? '' : row.SektionA
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.SektionB === 0 || row.SektionB === null ? '' : row.SektionB
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.GruppeA === 0 || row.GruppeA === null ? '' : row.GruppeA
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.GruppeB === 0 || row.GruppeB === null ? '' : row.GruppeB
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Pulje === 0 || row.Pulje === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Elite === 0 || row.Elite === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Z_Spil === 0 || row.Z_Spil === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.DM === 0 || row.DM === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.DueMarkering === 0 || row.DueMarkering === null ? '' : 'X'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.ForeningskrydsT === null ? '' : row.ForeningskrydsT
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Hjemkomst === null ? '' : _moment2.default.utc(row.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss')
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Doegn === null ? '' : String(row.Doegn)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Urnr === null ? '' : String(row.Urnr)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Signups;
}(_react2.default.Component);

Signups.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Signups);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Watches = function (_React$Component) {
    _inherits(Watches, _React$Component);

    function Watches(props) {
        _classCallCheck(this, Watches);

        var _this = _possibleConstructorReturn(this, (Watches.__proto__ || Object.getPrototypeOf(Watches)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Foreningsnr: row.Foreningsnr,
                    Slagnr: row.Slagnr,
                    Ugenr: row.Ugenr,
                    Urnr: row.Urnr
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Watches, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Ur'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Startdato'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Starttid'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Kontroldato'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Kontroltid'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Udviser'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slagnr: row.Slagnr,
                                                    Ugenr: row.Ugenr,
                                                    Urnr: row.Urnr
                                                }, {
                                                    Ugenr: _this2.state.Ugenr === '' ? null : _this2.state.Ugenr,
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Slagnr: _this2.state.Slagnr === '' ? null : _this2.state.Slagnr,
                                                    Urnr: _this2.state.Urnr === '' ? null : Number(_this2.state.Urnr),
                                                    Startdato: _this2.state.Startdato === '' ? null : (0, _moment2.default)(_this2.state.Startdato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                                                    Starttid: _this2.state.Starttid === '' ? null : _this2.state.Starttid,
                                                    Kontroldato: _this2.state.Kontroldato === '' ? null : (0, _moment2.default)(_this2.state.Kontroldato, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                                                    Kontroltid: _this2.state.Kontroltid === '' ? null : _this2.state.Kontroltid,
                                                    Udvisen: _this2.state.Udvisen === '' ? null : _this2.state.Udvisen
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Urnummer " + String(_this2.state.Urnr) + " for slag " + _this2.state.Slagnr + " i forening " + _this2.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Ugenr', id: 'Ugenr', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: _this2.state.Ugenr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slagnr', id: 'Slagnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slagnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Urnr', id: 'Urnr', value: _this2.state.Urnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field125',
                                        name: 'Startdato', id: 'Startdato', maxLength: '10', value: _this2.state.Startdato,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'Starttid', id: 'Starttid', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}" }], value: _this2.state.Starttid,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field125', containerClassName: 'display-inline-block',
                                        name: 'Kontroldato', id: 'Kontroldato', maxLength: '10', value: _this2.state.Kontroldato,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[6] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'Kontroltid', id: 'Kontroltid', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}" }], value: _this2.state.Kontroltid,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'Udvisen', id: 'Udvisen', maxLength: '8', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}" }], value: _this2.state.Udvisen,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[8] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) {
                                                _this2.setState({
                                                    Ugenr: row.Ugenr === null ? '' : row.Ugenr,
                                                    Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                    Slagnr: row.Slagnr === null ? '' : row.Slagnr,
                                                    Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                                    Urnr: row.Urnr === null ? '' : String(row.Urnr),
                                                    Startdato: row.Startdato === null ? '' : (0, _moment2.default)(row.Startdato).format(_config2.default.formats.dateFormat),
                                                    Starttid: row.Starttid === null ? '' : row.Starttid,
                                                    Kontroldato: row.Kontroldato === null ? '' : (0, _moment2.default)(row.Kontroldato).format(_config2.default.formats.dateFormat),
                                                    Kontroltid: row.Kontroltid === null ? '' : row.Kontroltid,
                                                    Udvisen: row.Udvisen === null ? '' : row.Udvisen,
                                                    editIx: ix
                                                });
                                                _this2.props.setEditMode(true);
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette urnummer ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Urnr
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slagnr
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slagnr: row.Slagnr,
                                                    Ugenr: row.Ugenr,
                                                    Urnr: row.Urnr
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("Urnummer " + String(row.Urnr) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere urnummer ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Urnr
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slagnr
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slagnr: row.Slagnr,
                                                    Ugenr: row.Ugenr,
                                                    Urnr: row.Urnr
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Urnummer " + String(row.Urnr) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Ugenr === null ? '' : row.Ugenr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slagnr === null ? '' : row.Slagnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Urnr === null ? '' : String(row.Urnr)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Startdato === null ? '' : (0, _moment2.default)(row.Startdato).format(_config2.default.formats.dateFormat)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Starttid === null ? '' : row.Starttid
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Kontroldato === null ? '' : (0, _moment2.default)(row.Kontroldato).format(_config2.default.formats.dateFormat)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Kontroltid === null ? '' : row.Kontroltid
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Udvisen === null ? '' : row.Udvisen
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Watches;
}(_react2.default.Component);

Watches.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Watches);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Membergames = function (_React$Component) {
    _inherits(Membergames, _React$Component);

    function Membergames(props) {
        _classCallCheck(this, Membergames);

        var _this = _possibleConstructorReturn(this, (Membergames.__proto__ || Object.getPrototypeOf(Membergames)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Uge: row.Uge,
                    Foreningsnr: row.Foreningsnr,
                    Slag: row.Slag,
                    KFK: row.KFK
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Membergames, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'KFK'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Uge: row.Uge,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    KFK: row.KFK
                                                }, {
                                                    Uge: _this2.state.Uge === '' ? null : _this2.state.Uge,
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Slag: _this2.state.Slag === '' ? null : _this2.state.Slag,
                                                    KFK: _this2.state.KFK === '' ? null : _this2.state.KFK
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Slagspil for slag " + _this2.state.Slag + " i forening " + _this2.state.Foreningsnr + " på flyvning " + _this2.state.KFK + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: _this2.state.Uge,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slag', id: 'Slag', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slag,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'KFK', id: 'KFK', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.KFK,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Uge: row.Uge === null ? '' : row.Uge,
                                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                Slag: row.Slag === null ? '' : row.Slag,
                                                KFK: row.KFK === null ? '' : row.KFK,
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette slagspil for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Uge: row.Uge,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    KFK: row.KFK
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("Slagspil for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere slagspil for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Uge: row.Uge,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    KFK: row.KFK
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Slagspil for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : row.Uge
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slag === null ? '' : row.Slag
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.KFK === null ? '' : row.KFK
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Membergames;
}(_react2.default.Component);

Membergames.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Membergames);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Financials = function (_React$Component) {
    _inherits(Financials, _React$Component);

    function Financials(props) {
        _classCallCheck(this, Financials);

        var _this = _possibleConstructorReturn(this, (Financials.__proto__ || Object.getPrototypeOf(Financials)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Uge: row.Uge,
                    KFK: row.KFK,
                    Foreningsnr: row.Foreningsnr,
                    Sektion: row.Sektion
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Financials, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Sektion'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'KFK'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'right' },
                                'Bel\xF8b'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Uge: row.Uge,
                                                    KFK: row.KFK,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Sektion: row.Sektion
                                                }, {
                                                    Uge: _this2.state.Uge === '' ? null : _this2.state.Uge,
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Sektion: _this2.state.Sektion === '' ? null : _this2.state.Sektion,
                                                    KFK: _this2.state.KFK === '' ? null : _this2.state.KFK,
                                                    Beloeb: _this2.state.Beloeb === '' ? null : Number(_this2.state.Beloeb)
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Regnskab for forening " + _this2.state.Foreningsnr + " på flyvning " + _this2.state.KFK + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: _this2.state.Uge,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Sektion', id: 'Sektion', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.Sektion,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'KFK', id: 'KFK', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.KFK,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'right' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                        name: 'Beloeb', id: 'Beloeb', value: _this2.state.Beloeb,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Uge: row.Uge === null ? '' : row.Uge,
                                                KFK: row.KFK === null ? '' : row.KFK,
                                                Sektion: row.Sektion === null ? '' : row.Sektion,
                                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                Beloeb: row.Beloeb === null ? '' : String(row.Beloeb),
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette regnskab for forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Uge: row.Uge,
                                                    KFK: row.KFK,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Sektion: row.Sektion
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("Regnskab for forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere regnskab for forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Uge: row.Uge,
                                                    KFK: row.KFK,
                                                    Foreningsnr: row.Foreningsnr,
                                                    Sektion: row.Sektion
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Regnskab for forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : row.Uge
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Sektion === null ? '' : row.Sektion
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.KFK === null ? '' : row.KFK
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'right' },
                                    row.Beloeb === null ? '' : String(row.Beloeb)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Financials;
}(_react2.default.Component);

Financials.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Financials);

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Membergames = function (_React$Component) {
    _inherits(Membergames, _React$Component);

    function Membergames(props) {
        _classCallCheck(this, Membergames);

        var _this = _possibleConstructorReturn(this, (Membergames.__proto__ || Object.getPrototypeOf(Membergames)).call(this, props));

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Key: row.Key
                };
            });
        };

        _this.state = {
            expanded: []
        };
        return _this;
    }

    _createClass(Membergames, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Info'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'KFK'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Slagnavn'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        data.map(function (row, ix) {
                            return ix === 0 || data[ix - 1].Uge !== row.Uge || data[ix - 1].Foreningsnr !== row.Foreningsnr || data[ix - 1].Slagnr !== row.Slagnr || data[ix - 1].KFK !== row.KFK ? _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _this2.state.expanded.findIndex(function (exp) {
                                        return exp.Uge === row.Uge && exp.Foreningsnr === row.Foreningsnr && exp.Slagnr === row.Slagnr && exp.KFK === row.KFK;
                                    }) < 0 ? _react2.default.createElement('i', { className: 'fa fa-plus clickable', title: '\xC5bn alle indleveringer', onClick: function onClick() {
                                            _this2.state.expanded.push({
                                                Uge: row.Uge,
                                                Foreningsnr: row.Foreningsnr,
                                                KFK: row.KFK,
                                                Slagnr: row.Slagnr
                                            });
                                            _this2.forceUpdate();
                                        } }) : _react2.default.createElement('i', { className: 'fa fa-minus clickable', title: 'Luk alle indleveringer', onClick: function onClick() {
                                            _this2.setState({
                                                expanded: _this2.state.expanded.filter(function (exp) {
                                                    return exp.Uge !== row.Uge || exp.Foreningsnr !== row.Foreningsnr || exp.Slagnr !== row.Slagnr || exp.KFK !== row.KFK;
                                                })
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-trash clickable', title: 'Slet r\xE6kke', onClick: function onClick() {
                                            (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette indleveringer for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slagnr
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow(_this2.props.data.filter(function (row2) {
                                                    return row2.Uge === row.Uge && row2.Foreningsnr === row.Foreningsnr && row2.Slagnr === row.Slagnr && row2.KFK === row.KFK;
                                                }).map(function (row) {
                                                    return {
                                                        Key: row.Key
                                                    };
                                                }), function () {
                                                    _reactNotifications.NotificationManager.success("Indleveringer for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst,
                                    _this2.state.expanded.findIndex(function (exp) {
                                        return exp.Uge === row.Uge && exp.Foreningsnr === row.Foreningsnr && exp.Slagnr === row.Slagnr && exp.KFK === row.KFK;
                                    }) < 0 ? null : _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'thead',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement('th', null),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Ringnummer'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    null,
                                                    'Indleveret'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            data.filter(function (row2) {
                                                return row2.Uge === row.Uge && row2.Foreningsnr === row.Foreningsnr && row2.Slagnr === row.Slagnr && row2.KFK === row.KFK;
                                            }).map(function (row) {
                                                return _react2.default.createElement(
                                                    'tr',
                                                    null,
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        row.Markering
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        row.Ringnummer
                                                    ),
                                                    _react2.default.createElement(
                                                        'td',
                                                        null,
                                                        _moment2.default.utc(row.Indleveret).tz("Europe/Copenhagen").format('DD-MM HH:mm:ss')
                                                    )
                                                );
                                            })
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : row.Uge
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.KFK === null ? '' : row.KFK
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slagnr === null ? '' : row.Slagnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Slagnavn === null ? '' : row.Slagnavn
                                )
                            ) : null;
                        })
                    )
                )
            );
        }
    }]);

    return Membergames;
}(_react2.default.Component);

Membergames.propTypes = {
    data: _propTypes2.default.array.isRequired,
    deleteRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Membergames);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pigeons = function (_React$Component) {
    _inherits(Pigeons, _React$Component);

    function Pigeons(props) {
        _classCallCheck(this, Pigeons);

        var _this = _possibleConstructorReturn(this, (Pigeons.__proto__ || Object.getPrototypeOf(Pigeons)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onUpperCaseFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value.toUpperCase()));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Foreningsnr: row.Foreningsnr,
                    Ringnummer: row.Ringnummer
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Pigeons, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Ringnr.'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Aktiv'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'K\xF8n'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vacc.dato'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vacc.kontrollant'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Foreningsnr: row.Foreningsnr,
                                                    Ringnummer: row.Ringnummer
                                                }, {
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Slagnr: _this2.state.Slagnr === '' ? null : _this2.state.Slagnr,
                                                    Ringnummer: _this2.state.Ringnummer === '' ? null : _this2.state.Ringnummer,
                                                    Aktiv: _this2.state.Aktiv,
                                                    Koen: _this2.state.Koen === '' ? null : _this2.state.Koen,
                                                    VaccDato1: _this2.state.VaccDato1 === '' ? null : (0, _moment2.default)(_this2.state.VaccDato1, _config2.default.formats.dateFormat).format('YYYY-MM-DD'),
                                                    VaccKontrollant1: _this2.state.VaccKontrollant1 === '' ? null : _this2.state.VaccKontrollant1
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Urnummer " + String(_this2.state.Urnr) + " for slag " + _this2.state.Slagnr + " i forening " + _this2.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slagnr', id: 'Slagnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slagnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { minWidth: '100px' } },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field150', containerClassName: 'display-inline-block',
                                        name: 'Ringnummer', id: 'Ringnummer', maxLength: '11', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}" }], value: _this2.state.Ringnummer,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Aktiv', id: 'Aktiv', checked: _this2.state.Aktiv === 'X' || _this2.state.Aktiv === 'x', onChange: function onChange(e) {
                                            _this2.setState({ Aktiv: e.target.checked ? 'X' : null });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Koen', id: 'Koen', maxLength: '1', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[AUX]" }], value: _this2.state.Koen,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onUpperCaseFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.date, placeholder: '', className: 'field125', containerClassName: 'display-inline-block',
                                        name: 'VaccDato1', id: 'VaccDato1', maxLength: '10', value: _this2.state.VaccDato1,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: false, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field200', containerClassName: 'display-inline-block',
                                        name: 'VaccKontrollant1', id: 'VaccKontrollant1', maxLength: '25', value: _this2.state.VaccKontrollant1,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                Slagnr: row.Slagnr === null ? '' : row.Slagnr,
                                                Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                                Aktiv: row.Aktiv,
                                                Koen: row.Koen === null ? '' : row.Koen,
                                                VaccDato1: row.VaccDato1 === null ? '' : (0, _moment2.default)(row.VaccDato1).format(_config2.default.formats.dateFormat),
                                                VaccKontrollant1: row.VaccKontrollant1 === null ? '' : row.VaccKontrollant1,
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette ringnummer ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Ringnummer
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slagnr
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Foreningsnr: row.Foreningsnr,
                                                    Ringnummer: row.Ringnummer
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("Ringnummer " + String(row.Ringnummer) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere ringnummer ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Ringnummer
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slagnr
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Foreningsnr: row.Foreningsnr,
                                                    Ringnummer: row.Ringnummer
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Ringnummer " + String(row.Ringnummer) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slagnr === null ? '' : row.Slagnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Ringnummer === null ? '' : row.Ringnummer
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Aktiv === null ? '' : row.Aktiv
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Koen === null ? '' : row.Koen
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.VaccDato1 === null ? '' : (0, _moment2.default)(row.VaccDato1).format(_config2.default.formats.dateFormat)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.VaccKontrollant1 === null ? '' : row.VaccKontrollant1
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Pigeons;
}(_react2.default.Component);

Pigeons.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Pigeons);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rings = function (_React$Component) {
    _inherits(Rings, _React$Component);

    function Rings(props) {
        _classCallCheck(this, Rings);

        var _this = _possibleConstructorReturn(this, (Rings.__proto__ || Object.getPrototypeOf(Rings)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Nr: row.Nr
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(Rings, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                '\xC5r'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Fra'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Til'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Suppl'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Nr: row.Nr
                                                }, {
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Slag: _this2.state.Slag === '' ? null : _this2.state.Slag,
                                                    Aar: _this2.state.Aar === '' ? null : _this2.state.Aar,
                                                    Fra: _this2.state.Fra === '' ? null : _this2.state.Fra,
                                                    Til: _this2.state.Til === '' ? null : _this2.state.Til,
                                                    Supplerende: _this2.state.Supplerende
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("Ringserien " + _this2.state.Fra + "-" + _this2.state.Til + " for slag " + _this2.state.Slag + " i forening " + _this2.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slag', id: 'Slag', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slag,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Aar', id: 'Aar', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.Aar,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                        name: 'Fra', id: 'Fra', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.Fra,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                        name: 'Til', id: 'Til', maxLength: '4', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }], value: _this2.state.Til,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement('input', { type: 'checkbox', name: 'Supplerende', id: 'Supplerende', checked: _this2.state.Supplerende === 'X' || _this2.state.Supplerende === 'x', onChange: function onChange(e) {
                                            _this2.setState({ Supplerende: e.target.checked ? 'X' : null });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                Slag: row.Slag === null ? '' : row.Slag,
                                                Aar: row.Aar === null ? '' : row.Aar,
                                                Fra: row.Fra === null ? '' : row.Fra,
                                                Til: row.Til === null ? '' : row.Til,
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette ringserien ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Fra,
                                                    '-',
                                                    row.Til
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Nr: row.Nr
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("Ringserien " + row.Fra + "-" + row.Til + " for slag " + row.Slag + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere ringserien ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Fra,
                                                    '-',
                                                    row.Til
                                                ),
                                                ' for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Nr: row.Nr
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("Ringserien " + row.Fra + "-" + row.Til + " for slag " + row.Slag + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slag === null ? '' : row.Slag
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Aar === null ? '' : row.Aar
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Fra === null ? '' : row.Fra
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Til === null ? '' : row.Til
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Supplerende === null ? '' : row.Supplerende
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Rings;
}(_react2.default.Component);

Rings.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Rings);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _globalerror = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DM = function (_React$Component) {
    _inherits(DM, _React$Component);

    function DM(props) {
        _classCallCheck(this, DM);

        var _this = _possibleConstructorReturn(this, (DM.__proto__ || Object.getPrototypeOf(DM)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.getAllKeys = function () {
            return _this.props.data.map(function (row) {
                return {
                    Mesterskab: 'DM',
                    Foreningsnr: row.Foreningsnr,
                    Slag: row.Slag,
                    Uge: row.Uge,
                    KFK: row.KFK
                };
            });
        };

        _this.state = {
            editIx: null
        };
        return _this;
    }

    _createClass(DM, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement('th', null),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fejltekst'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Slag'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center' },
                                'KFK'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Vers.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.props.data.map(function (row, ix) {
                            return ix === _this2.state.editIx ? _react2.default.createElement(
                                'tr',
                                { key: ix, className: 'edit-row' },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem station', onClick: function onClick() {
                                            if (_this2.allInputValid()) {
                                                _this2.props.updateRow({
                                                    Mesterskab: 'DM',
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    Uge: row.Uge,
                                                    KFK: row.KFK
                                                }, {
                                                    Foreningsnr: _this2.state.Foreningsnr === '' ? null : _this2.state.Foreningsnr,
                                                    Slag: _this2.state.Slag === '' ? null : _this2.state.Slag,
                                                    Uge: _this2.state.Uge === '' ? null : _this2.state.Uge,
                                                    KFK: _this2.state.KFK === '' ? null : _this2.state.KFK
                                                }, function () {
                                                    _reactNotifications.NotificationManager.success("DM-tilmelding for slag " + _this2.state.Slag + " i forening " + _this2.state.Foreningsnr + " på flyvning " + _this2.state.KFK + " i uge " + _this2.state.Uge + " er opdateret.", "Opdatering", 4000);
                                                    _this2.setState({ editIx: null });
                                                    _this2.props.setEditMode(false);
                                                });
                                            } else {
                                                _this2.fields.forEach(function (field) {
                                                    field.setState({ visited: true });
                                                });
                                            }
                                        } }),
                                    _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                            _this2.setState({ editIx: null });
                                            _this2.props.setEditMode(false);
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Foreningsnr', id: 'Foreningsnr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Foreningsnr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Slag', id: 'Slag', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: _this2.state.Slag,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'Uge', id: 'Uge', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: _this2.state.Uge,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field50', containerClassName: 'display-inline-block',
                                        name: 'KFK', id: 'KFK', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{2}" }], value: _this2.state.KFK,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: _this2.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            ) : _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', style: { minWidth: '80px' } },
                                    _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) _this2.setState({
                                                Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                                Slag: row.Slag === null ? '' : row.Slag,
                                                Uge: row.Uge === null ? '' : row.Uge,
                                                KFK: row.KFK === null ? '' : row.KFK,
                                                editIx: ix
                                            });
                                            _this2.props.setEditMode(true);
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at slette DM-tilmelding for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                ' i uge ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Uge
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.deleteRow([{
                                                    Mesterskab: 'DM',
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    Uge: row.Uge,
                                                    KFK: row.KFK
                                                }], function () {
                                                    _reactNotifications.NotificationManager.success("DM-tilmelding for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " i uge " + _this2.state.Uge + " er slettet.", "Sletning", 4000);
                                                });
                                            });
                                        } }),
                                    _react2.default.createElement('i', { className: "fa fa-check " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Accepter r\xE6kke', onClick: function onClick() {
                                            if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Accepter", _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xD8nsker du at acceptere DM-tilmelding for slag ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Slag
                                                ),
                                                ' i forening ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Foreningsnr
                                                ),
                                                ' p\xE5 flyvning ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.KFK
                                                ),
                                                ' i uge ',
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    row.Uge
                                                ),
                                                '?'
                                            ), function () {
                                                _this2.props.acceptRow([{
                                                    Mesterskab: 'DM',
                                                    Foreningsnr: row.Foreningsnr,
                                                    Slag: row.Slag,
                                                    Uge: row.Uge,
                                                    KFK: row.KFK
                                                }], function (response) {
                                                    if (response.failed.length > 0) _this2.props.dispatch((0, _globalerror.addGlobalError)('Fejl ved accept', response.failed[0].msg, -1));else _reactNotifications.NotificationManager.success("DM-tilmelding for slag " + row.Slag + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " i uge " + _this2.state.Uge + " er accepteret.", "Accept", 4000);
                                                });
                                            });
                                        } })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Fejltekst === null ? '' : row.Fejltekst
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Slag === null ? '' : row.Slag
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : row.Uge
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.KFK === null ? '' : row.KFK
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Programversion === null ? '' : row.Programversion
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return DM;
}(_react2.default.Component);

DM.propTypes = {
    data: _propTypes2.default.array.isRequired,
    setEditMode: _propTypes2.default.func.isRequired,
    updateRow: _propTypes2.default.func.isRequired,
    deleteRow: _propTypes2.default.func.isRequired,
    acceptRow: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(DM);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _confirmDialog = __webpack_require__(12);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Status = function (_React$Component) {
    _inherits(Status, _React$Component);

    function Status(props) {
        _classCallCheck(this, Status);

        var _this = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));

        _this.handleReloadResponse = function (response, successText, club, week) {
            if (successText !== null) {
                if (response.length === 0) _reactNotifications.NotificationManager.success(successText, "Opdatering", 4000);else _reactNotifications.NotificationManager.warning(_react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        successText
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xF8lgende beskeder/advarsler/fejl er modtaget:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        response.map(function (msg, ix) {
                            return _react2.default.createElement(
                                'li',
                                { key: ix },
                                msg
                            );
                        })
                    )
                ), "Opdatering", 0);
                _this.props.dispatch(AdminActions.getErrorListItems('status', week, club));
            }
        };

        _this.state = {
            expanded: []
        };
        return _this;
    }

    _createClass(Status, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var cellStyle = { minWidth: '100px', width: '100px' };
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'table',
                    { className: 'data-table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'center', style: cellStyle },
                                'Foren'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Navn'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center', style: cellStyle },
                                'Uge'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center', style: cellStyle },
                                'Regnskab'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center', style: cellStyle },
                                'Resultet'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'center', style: cellStyle },
                                'Lands-flyv.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        data.map(function (row, ix) {
                            return _react2.default.createElement(
                                'tr',
                                { key: ix },
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Foreningsnr === null ? '' : row.Foreningsnr
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    row.Foreningsnavn === null ? '' : row.Foreningsnavn
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center' },
                                    row.Uge === null ? '' : String(row.Uge)
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center position-relative' },
                                    row.isSignupsReceived && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-left', style: { width: '35%', textAlign: 'right' } },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_IMPORT_FILE.replace(':fileType', 'signups').replace(':club', row.Foreningsnr).replace(':week', String(row.Uge)), target: '_blank', style: { color: 'inherit' }, title: '\xC5bn regnskabsfil' },
                                            _react2.default.createElement('i', { className: 'fa fa-download' })
                                        ),
                                        _react2.default.createElement('i', { className: 'fa fa-repeat clickable', style: { marginLeft: '5px' }, title: 'Genindl\xE6s regnskabsfil', onClick: function onClick() {
                                                (0, _confirmDialog.confirm)("Genindlæs", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at genindl\xE6se regnskabsfilen for forening ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        row.Foreningsnr
                                                    ),
                                                    ' i uge ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        String(row.Uge)
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.reloadImportFile('signups', row.Foreningsnr, String(row.Uge), _this2.handleReloadResponse, 'Regnskabsfil for forening ' + row.Foreningsnr + ' i uge ' + String(row.Uge) + ' er blevet indlæst.'));
                                                });
                                            } })
                                    ) : null,
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        row.Uge === null ? null : row.Signups === null ? _react2.default.createElement('i', { className: 'fa fa-minus error-text' }) : _react2.default.createElement('i', { className: 'fa fa-check success-text' })
                                    ),
                                    row.ErrorSignups !== null && row.ErrorSignups !== '' ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-right', style: { width: '35%', textAlign: 'left' } },
                                        _react2.default.createElement('i', { className: 'fa fa-info-circle error-text', title: row.ErrorSignups })
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center position-relative' },
                                    row.isResultsReceived && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-left', style: { width: '35%', textAlign: 'right' } },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_IMPORT_FILE.replace(':fileType', 'results').replace(':club', row.Foreningsnr).replace(':week', String(row.Uge)), target: '_blank', style: { color: 'inherit' }, title: '\xC5bn resultatfil' },
                                            _react2.default.createElement('i', { className: 'fa fa-download' })
                                        ),
                                        _react2.default.createElement('i', { className: 'fa fa-repeat clickable', style: { marginLeft: '5px' }, title: 'Genindl\xE6s resultatfil', onClick: function onClick() {
                                                (0, _confirmDialog.confirm)("Genindlæs", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at genindl\xE6se resultatfilen for forening ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        row.Foreningsnr
                                                    ),
                                                    ' i uge ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        String(row.Uge)
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.reloadImportFile('results', row.Foreningsnr, String(row.Uge), _this2.handleReloadResponse, 'Resultatfil for forening ' + row.Foreningsnr + ' i uge ' + String(row.Uge) + ' er blevet indlæst.'));
                                                });
                                            } })
                                    ) : null,
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        row.Uge === null ? null : row.Results === null ? _react2.default.createElement('i', { className: 'fa fa-minus error-text' }) : _react2.default.createElement('i', { className: 'fa fa-check success-text' })
                                    ),
                                    row.ErrorResults !== null && row.ErrorResults !== '' ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-right', style: { width: '35%', textAlign: 'left' } },
                                        _react2.default.createElement('i', { className: 'fa fa-info-circle error-text', title: row.ErrorResults })
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: 'center position-relative' },
                                    row.isResults91Received && _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-left', style: { width: '35%', textAlign: 'right' } },
                                        _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: _routeconstants.ROUTE_IMPORT_FILE.replace(':fileType', 'results91').replace(':club', row.Foreningsnr).replace(':week', String(row.Uge)), target: '_blank', style: { color: 'inherit' }, title: '\xC5bn landsresultatfil' },
                                            _react2.default.createElement('i', { className: 'fa fa-download' })
                                        ),
                                        _react2.default.createElement('i', { className: 'fa fa-repeat clickable', style: { marginLeft: '5px' }, title: 'Genindl\xE6s landsresultatfil', onClick: function onClick() {
                                                (0, _confirmDialog.confirm)("Genindlæs", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at genindl\xE6se landsflyvningsresultater for forening ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        row.Foreningsnr
                                                    ),
                                                    ' i uge ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        String(row.Uge)
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.reloadImportFile('results91', row.Foreningsnr, String(row.Uge), _this2.handleReloadResponse, 'Landsflyvningsresultater for forening ' + row.Foreningsnr + ' i uge ' + String(row.Uge) + ' er blevet indlæst.'));
                                                });
                                            } })
                                    ) : null,
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        row.Uge === null ? null : row.Results91 === -1 ? null : row.Results91 === 1 ? _react2.default.createElement('i', { className: 'fa fa-check success-text' }) : row.Results91 === 2 ? _react2.default.createElement('i', { className: 'fa fa-check error-text' }) : row.Results === null ? null : _react2.default.createElement('i', { className: 'fa fa-minus error-text' })
                                    ),
                                    row.ErrorResults91 !== null && row.ErrorResults91 !== '' ? _react2.default.createElement(
                                        'span',
                                        { className: 'position-absolute-right', style: { width: '35%', textAlign: 'left' } },
                                        _react2.default.createElement('i', { className: 'fa fa-info-circle error-text', title: row.ErrorResults91 })
                                    ) : null
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Status;
}(_react2.default.Component);

Status.propTypes = {
    data: _propTypes2.default.array.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Status);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SettingsGeneral = __webpack_require__(833);

var _SettingsGeneral2 = _interopRequireDefault(_SettingsGeneral);

var _SettingsDeposits = __webpack_require__(834);

var _SettingsDeposits2 = _interopRequireDefault(_SettingsDeposits);

var _SettingsPrizes = __webpack_require__(835);

var _SettingsPrizes2 = _interopRequireDefault(_SettingsPrizes);

var _SettingsMarkings = __webpack_require__(836);

var _SettingsMarkings2 = _interopRequireDefault(_SettingsMarkings);

var _SettingsKilometers = __webpack_require__(837);

var _SettingsKilometers2 = _interopRequireDefault(_SettingsKilometers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionPage = function (_React$Component) {
    _inherits(SectionPage, _React$Component);

    _createClass(SectionPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_SECTION;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function SectionPage(props) {
        _classCallCheck(this, SectionPage);

        var _this = _possibleConstructorReturn(this, (SectionPage.__proto__ || Object.getPrototypeOf(SectionPage)).call(this, props));

        _this.loadSection = function (newestProps) {
            newestProps.dispatch(AdminActions.getGeneral(function () {
                _this.forceUpdate();
            }));
            //if (newestProps.params.sectionNo.toLowerCase() === 'ddb') {
            //    if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) newestProps.dispatch(AdminActions.getGeneral(() => {this.forceUpdate();}));
            //}
            if (newestProps.params.sectionNo.toLowerCase() !== 'ddb') {
                if (_this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id || _this.props.auth.currentEntity === _this.props.params.sectionNo) {
                    if (newestProps.params.sectionNo.length === 2) newestProps.dispatch(AdminActions.getSection(newestProps.params.sectionNo, function () {
                        _this.forceUpdate();
                    }));else if (newestProps.params.sectionNo.length === 3) newestProps.dispatch(AdminActions.getClub(newestProps.params.sectionNo, function () {
                        _this.forceUpdate();
                    }));
                }
            }
        };

        _this.loadSections = function (newestProps) {
            newestProps.dispatch(AdminActions.getSections(function () {
                _this.forceUpdate();
            }));
        };

        _this.subForm = null;
        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.setAllowNew = function (mode) {
            return _this.setState({ allowNew: mode });
        };

        _this.state = {
            allowNew: false
        };
        return _this;
    }

    _createClass(SectionPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadSection(this.props);
            this.loadSections(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {

            if (nextProps.params.subpage !== this.props.params.subpage) {
                this.setAllowNew(false);
            }

            if (nextProps.params.sectionNo !== this.props.params.sectionNo) {
                this.setAllowNew(false);
                this.loadSection(nextProps);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.auth.isAuthenticated) return _react2.default.createElement('div', null);

            var sectionNo = this.props.params.sectionNo;
            var section = sectionNo === "ddb" ? !this.props.admin.generalSection ? null : this.props.admin.generalSection : sectionNo.length === 2 ? !this.props.admin.sections ? null : this.props.admin.sections.get(sectionNo) || null : sectionNo.length === 3 ? !this.props.admin.clubs ? null : this.props.admin.clubs.get(sectionNo) || null : null;
            if (!this.props.admin.generalSection || section === null || typeof section.isFullLoaded === 'undefined') return null;

            if (this.props.auth.isAuthenticated && this.props.auth.currentRole !== _UserRoles2.default.MAIN_ADMIN.id && this.props.auth.currentEntity !== this.props.params.sectionNo) return _react2.default.createElement(
                'div',
                { className: 'unauthorized' },
                'Du har ingen rettigheder til denne side'
            );

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_SettingsGeneral2.default, { section: section, editMode: this.props.params.mode === "edit", sectionNo: sectionNo, isDDB: sectionNo === "ddb", isSection: sectionNo.length === 2, isClub: sectionNo !== "ddb" && sectionNo.length === 3, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'deposits':
                    subPage = _react2.default.createElement(_SettingsDeposits2.default, { section: section, editMode: this.props.params.mode === "edit", sectionNo: sectionNo, isDDB: sectionNo === "ddb", isSection: sectionNo.length === 2, isClub: sectionNo !== "ddb" && sectionNo.length === 3, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'prizes':
                    subPage = _react2.default.createElement(_SettingsPrizes2.default, { section: section, editMode: this.props.params.mode === "edit", sectionNo: sectionNo, setAllowNew: this.setAllowNew, isDDB: sectionNo === "ddb", isSection: sectionNo.length === 2, isClub: sectionNo !== "ddb" && sectionNo.length === 3, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'markings':
                    subPage = _react2.default.createElement(_SettingsMarkings2.default, { section: section, editMode: this.props.params.mode === "edit", sectionNo: sectionNo, isDDB: sectionNo === "ddb", isSection: sectionNo.length === 2, isClub: sectionNo !== "ddb" && sectionNo.length === 3, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'kilometers':
                    subPage = _react2.default.createElement(_SettingsKilometers2.default, { section: section, editMode: this.props.params.mode === "edit", sectionNo: sectionNo, setAllowNew: this.setAllowNew, isDDB: sectionNo === "ddb", isSection: sectionNo.length === 2, isClub: sectionNo !== "ddb" && sectionNo.length === 3, ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
            }

            var sectionList = this.props.admin.sections.map(function (section) {
                return { key: section.Sektionsnr, value: section.Sektionsnr + ' - ' + (section.Navn === null ? '' : section.Navn) };
            }).toArray();
            sectionList.unshift({ key: 'ddb', value: 'DDB' });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Indstillinger'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        sectionNo === "ddb" || sectionNo.length === 2 ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SETTINGS.replace(':subpage', 'general').replace(':sectionNo', sectionNo).replace(':mode', 'view') : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ) : null,
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'deposits' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SETTINGS.replace(':subpage', 'deposits').replace(':sectionNo', sectionNo).replace(':mode', 'view') : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Indskud'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'prizes' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SETTINGS.replace(':subpage', 'prizes').replace(':sectionNo', sectionNo).replace(':mode', 'view') : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Pr\xE6mier'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'markings' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SETTINGS.replace(':subpage', 'markings').replace(':sectionNo', sectionNo).replace(':mode', 'view') : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Markeringer'
                            )
                        ),
                        sectionNo === "ddb" || sectionNo.length === 2 ? _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'kilometers' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled'), to: this.props.params.mode === 'view' ? _routeconstants.ROUTE_SETTINGS.replace(':subpage', 'kilometers').replace(':sectionNo', sectionNo).replace(':mode', 'view') : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'KM-till\xE6g'
                            )
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: 'tab-page', className: 'tab-page' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? [_react2.default.createElement(
                        'span',
                        { key: 1 },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'week' },
                            'Sektion/DDB'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { key: 2 },
                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field250', containerClassName: 'display-inline-block',
                            name: 'sectionPicker', id: 'sectionPicker', value: sectionNo, options: sectionList,
                            autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                            onChange: function onChange(e) {
                                _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SETTINGS.replace(':subpage', _this2.props.params.subpage).replace(':sectionNo', e.target.value).replace(':mode', 'view')));
                            }
                        })
                    )] : null, _react2.default.createElement(
                        'span',
                        _defineProperty({ className: 'left-buttons', key: 'left' }, 'key', 3),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Rediger sektion', disabled: !this.props.auth.isMainAdmin && (!this.props.auth.isClubAdmin || this.props.auth.clubNumber !== sectionNo) || this.props.params.subpage === 'kilometers', onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SETTINGS.replace(':subpage', _this2.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ),
                        this.props.params.subpage === 'prizes' || this.props.params.subpage === 'kilometers' ? _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: this.props.params.subpage === 'prizes' ? 'Opret præmie' : 'Opret tillæg', disabled: !this.state.allowNew, onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().createNew();
                                } },
                            'Ny'
                        ) : null
                    )] : [_react2.default.createElement(
                        'span',
                        _defineProperty({ className: 'left-buttons', key: 'left' }, 'key', 4),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (sectionNo) {
                                        var message = _this2.props.params.subpage === 'general' ? 'Bankoplysningerne for ' + (sectionNo === "ddb" ? 'DDB' : 'sektion ' + sectionNo) + ' er opdateret.' : _this2.props.params.subpage === 'deposits' ? 'Indskud for ' + (sectionNo === "ddb" ? 'DDB' : 'sektion ' + sectionNo) + ' er opdateret.' : _this2.props.params.subpage === 'prizes' ? 'Pr\xE6mier for ' + (sectionNo === "ddb" ? 'DDB' : 'sektion ' + sectionNo) + ' er opdateret.' : /*this.props.params.subpage === 'markings' ?*/'Markeringer for ' + (sectionNo === "ddb" ? 'DDB' : 'sektion ' + sectionNo) + ' er opdateret.';
                                        _reactNotifications.NotificationManager.success(message, "Opdatering", 4000);
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SETTINGS.replace(':subpage', _this2.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        _defineProperty({ className: 'right-buttons', key: 'right' }, 'key', 5),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().forceUpdate(function () {
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_SETTINGS.replace(':subpage', _this2.props.params.subpage).replace(':sectionNo', sectionNo).replace(':mode', 'view')));
                                    });
                                } },
                            'Annuller'
                        )
                    )]
                )
            );
        }
    }]);

    return SectionPage;
}(_react2.default.Component);

SectionPage.propTypes = {
    section: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            isAuthenticated: state.auth.isAuthenticated,
            isClubAdmin: state.auth.isClubAdmin,
            isMainAdmin: state.auth.isMainAdmin,
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            sections: state.admin.sections,
            clubs: state.admin.clubs,
            generalSection: state.admin.generalSection
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SectionPage);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _Util = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Bank: '',
    Regnr: '',
    Kontonr: '',
    Bank_Adr: '',
    Bank_Postnr: '',
    Kontingent_dette_sem: '',
    Kontingent_naeste_sem: '',
    Passiv_kontingent_dette_sem: '',
    Passiv_kontingent_naeste_sem: '',
    KmSats: '',
    UNIKON_kontingent: '',
    SMS_kontingent: '',
    Mobil_kontingent: ''
};

var SettingsGeneral = function (_React$Component) {
    _inherits(SettingsGeneral, _React$Component);

    function SettingsGeneral(props) {
        _classCallCheck(this, SettingsGeneral);

        var _this = _possibleConstructorReturn(this, (SettingsGeneral.__proto__ || Object.getPrototypeOf(SettingsGeneral)).call(this, props));

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Bank: _this.state.Bank === '' ? null : _this.state.Bank,
                    Regnr: _this.state.Regnr === '' ? null : _this.state.Regnr,
                    Kontonr: _this.state.Kontonr === '' ? null : _this.state.Kontonr,
                    Bank_Adr: _this.state.Bank_Adr === '' ? null : _this.state.Bank_Adr,
                    Bank_Postnr: _this.state.Bank_Postnr === '' ? null : _this.state.Bank_Postnr
                };

                if (_this.props.isDDB) {
                    entity.Kontingent_dette_sem = _this.state.Kontingent_dette_sem === '' ? null : Number(_this.state.Kontingent_dette_sem.replace(',', '.'));
                    entity.Kontingent_naeste_sem = _this.state.Kontingent_naeste_sem === '' ? null : Number(_this.state.Kontingent_naeste_sem.replace(',', '.'));
                    entity.Passiv_kontingent_dette_sem = _this.state.Passiv_kontingent_dette_sem === '' ? null : Number(_this.state.Passiv_kontingent_dette_sem.replace(',', '.'));
                    entity.Passiv_kontingent_naeste_sem = _this.state.Passiv_kontingent_naeste_sem === '' ? null : Number(_this.state.Passiv_kontingent_naeste_sem.replace(',', '.'));
                    entity.KmSats = _this.state.KmSats === '' ? null : Number(_this.state.KmSats.replace(',', '.'));
                    entity.UNIKON_kontingent = _this.state.UNIKON_kontingent === '' ? null : Number(_this.state.UNIKON_kontingent.replace(',', '.'));
                    entity.SMS_kontingent = _this.state.SMS_kontingent === '' ? null : Number(_this.state.SMS_kontingent.replace(',', '.'));
                    entity.Mobil_kontingent = _this.state.Mobil_kontingent === '' ? null : Number(_this.state.Mobil_kontingent.replace(',', '.'));

                    _this.props.dispatch(AdminActions.updateGeneral(entity, onSuccess));
                } else {
                    _this.props.dispatch(AdminActions.updateSection(_this.props.section.Sektionsnr, entity, onSuccess));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.fields = [];

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SettingsGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section === null) return defaultState;else {
                var section = props.section;
                return {
                    Bank: section.Bank === null ? '' : section.Bank,
                    Regnr: section.Regnr === null ? '' : section.Regnr,
                    Kontonr: section.Kontonr === null ? '' : section.Kontonr,
                    Bank_Adr: section.Bank_Adr === null ? '' : section.Bank_Adr,
                    Bank_Postnr: section.Bank_Postnr === null ? '' : section.Bank_Postnr,
                    Kontingent_dette_sem: section.Kontingent_dette_sem === null ? '' : String(section.Kontingent_dette_sem).replace('.', ','),
                    Kontingent_naeste_sem: section.Kontingent_naeste_sem === null ? '' : String(section.Kontingent_naeste_sem).replace('.', ','),
                    Passiv_kontingent_dette_sem: section.Passiv_kontingent_dette_sem === null ? '' : String(section.Passiv_kontingent_dette_sem).replace('.', ','),
                    Passiv_kontingent_naeste_sem: section.Passiv_kontingent_naeste_sem === null ? '' : String(section.Passiv_kontingent_naeste_sem).replace('.', ','),
                    KmSats: section.KmSats === null ? '' : String(section.KmSats).replace('.', ','),
                    UNIKON_kontingent: section.UNIKON_kontingent === null ? '' : String(section.UNIKON_kontingent).replace('.', ','),
                    SMS_kontingent: section.SMS_kontingent === null ? '' : String(section.SMS_kontingent).replace('.', ','),
                    Mobil_kontingent: section.Mobil_kontingent === null ? '' : String(section.Mobil_kontingent).replace('.', ',')
                };
            }
        }

        // TODO: Should it be possible to not have a zipCode?

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _ref = this.state.Bank_Postnr === '' ? '' : this.props.admin.zipCodes.get(this.state.Bank_Postnr) || '',
                By = _ref.By;
            /*     const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
                 const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);*/


            var editMode = this.props.editMode;
            return _react2.default.createElement(
                'div',
                { className: "form-page settings-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'table',
                    { className: 'main-form-table' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Bank' },
                                        'Bank'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.string,
                                    placeholder: '',
                                    className: 'field-1 field400',
                                    containerClassName: 'display-inline-block',
                                    name: 'Bank',
                                    id: 'Bank',
                                    maxLength: '35',
                                    value: this.state.Bank,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bank
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Adresse' },
                                        'Adresse'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.string,
                                    placeholder: '',
                                    className: 'field-1 field400',
                                    containerClassName: 'display-inline-block',
                                    name: 'Bank_Adr',
                                    id: 'Bank_Adr',
                                    maxLength: '35',
                                    value: this.state.Bank_Adr,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[2] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bank_Adr
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Postnr' },
                                        'Postnr'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'Bank_Postnr',
                                    id: 'Bank_Postnr',
                                    maxLength: '4',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }],
                                    value: this.state.Bank_Postnr,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[3] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Bank_Postnr
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'By' },
                                        'By'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    By
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Regnr' },
                                        'Regnr.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1 small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'Regnr',
                                    id: 'Regnr',
                                    maxLength: '4',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{4}" }],
                                    value: this.state.Regnr,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[4] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Regnr
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            { className: 'normal-row' },
                            _react2.default.createElement(
                                'td',
                                { className: "label-cell" },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'label-text' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'Kontonr' },
                                        'Kontonr.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { colSpan: 3, className: "data-cell" },
                                editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field-1',
                                    containerClassName: 'display-inline-block',
                                    name: 'Kontonr',
                                    id: 'Kontonr',
                                    maxLength: '14',
                                    options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,14}" }],
                                    value: this.state.Kontonr,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[5] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.Kontonr
                                )
                            )
                        ),
                        this.props.isDDB ? _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Kontingent_dette_sem' },
                                            'Kontingent dette halv\xE5r'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Kontingent_dette_sem',
                                        id: 'Kontingent_dette_sem',
                                        value: this.state.Kontingent_dette_sem,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[6] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Kontingent_dette_sem
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Kontingent_naeste_sem' },
                                            'Kontingent n\xE6ste halv\xE5r'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Kontingent_naeste_sem',
                                        id: 'Kontingent_naeste_sem',
                                        value: this.state.Kontingent_naeste_sem,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Kontingent_naeste_sem
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Passiv_kontingent_dette_sem' },
                                            'Passivt kontingent dette halv\xE5r'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Passiv_kontingent_dette_sem',
                                        id: 'Passiv_kontingent_dette_sem',
                                        value: this.state.Passiv_kontingent_dette_sem,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[8] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Passiv_kontingent_dette_sem
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Passiv_kontingent_naeste_sem' },
                                            'Passivt kontingent n\xE6ste halv\xE5r'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Passiv_kontingent_naeste_sem',
                                        id: 'Passiv_kontingent_naeste_sem',
                                        value: this.state.Passiv_kontingent_naeste_sem,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[9] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Passiv_kontingent_naeste_sem
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'KmSats' },
                                            'Kilometersats'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'KmSats',
                                        id: 'KmSats',
                                        value: this.state.KmSats,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[10] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.KmSats
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'UNIKON_kontingent' },
                                            'Kontingent UNIKON/TAURIS-SMS'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'UNIKON_kontingent',
                                        id: 'UNIKON_kontingent',
                                        value: this.state.UNIKON_kontingent,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[11] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.UNIKON_kontingent
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'SMS_kontingent' },
                                            'Kontingent SMS-abonnement'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'SMS_kontingent',
                                        id: 'SMS_kontingent',
                                        value: this.state.SMS_kontingent,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[12] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.SMS_kontingent
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Mobil_kontingent' },
                                            'Kontingent SIM-kort-abonnement'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.float,
                                        placeholder: '',
                                        className: 'field-1 medium-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Mobil_kontingent',
                                        id: 'Mobil_kontingent',
                                        value: this.state.Mobil_kontingent,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[13] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Mobil_kontingent
                                    )
                                )
                            )
                        ) : null
                    )
                )
            );
        }
    }]);

    return SettingsGeneral;
}(_react2.default.Component);

SettingsGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    section: _propTypes2.default.object.isRequired,
    sectionNo: _propTypes2.default.string.isRequired,
    isDDB: _propTypes2.default.bool.isRequired,
    isSection: _propTypes2.default.bool.isRequired,
    isClub: _propTypes2.default.bool.isRequired
};
SettingsGeneral.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            zipCodes: state.admin.zipCodes
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SettingsGeneral);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _dataUtil = __webpack_require__(46);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _Util = __webpack_require__(62);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    A_Klasse1: '0',
    A_Klasse2: '0',
    A_Klasse3: '0',
    A_Klasse4: '0',
    A_Klasse5: '0',
    A_Klasse6: '0',
    B_Klasse1: '0',
    B_Klasse2: '0',
    B_Klasse3: '0',
    B_Klasse4: '0',
    B_Klasse5: '0',
    B_Klasse6: '0',
    KL_P: '0',
    KL_E: '0',
    Slagspil: '0',
    KL_Z: '0',
    KL_R: '0',
    Derby: '0',
    TillaegFastForening: '0',
    TillaegPrDueForening: '0'
};

var SettingsDeposits = function (_React$Component) {
    _inherits(SettingsDeposits, _React$Component);

    function SettingsDeposits(props) {
        _classCallCheck(this, SettingsDeposits);

        var _this = _possibleConstructorReturn(this, (SettingsDeposits.__proto__ || Object.getPrototypeOf(SettingsDeposits)).call(this, props));

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = _this.props.isClub ? {
                    TillaegFastForening: _this.state.TillaegFastForening === null ? 0 : Number(_this.state.TillaegFastForening),
                    TillaegPrDueForening: _this.state.TillaegPrDueForening === null ? 0 : Number(_this.state.TillaegPrDueForening)
                } : {
                    A_Klasse1: _this.state.A_Klasse1 === null ? 0 : Number(_this.state.A_Klasse1),
                    A_Klasse2: _this.state.A_Klasse2 === null ? 0 : Number(_this.state.A_Klasse2),
                    A_Klasse3: _this.state.A_Klasse3 === null ? 0 : Number(_this.state.A_Klasse3),
                    A_Klasse4: _this.state.A_Klasse4 === null ? 0 : Number(_this.state.A_Klasse4),
                    A_Klasse5: _this.state.A_Klasse5 === null ? 0 : Number(_this.state.A_Klasse5),
                    A_Klasse6: _this.state.A_Klasse6 === null ? 0 : Number(_this.state.A_Klasse6),
                    B_Klasse1: _this.state.B_Klasse1 === null ? 0 : Number(_this.state.B_Klasse1),
                    B_Klasse2: _this.state.B_Klasse2 === null ? 0 : Number(_this.state.B_Klasse2),
                    B_Klasse3: _this.state.B_Klasse3 === null ? 0 : Number(_this.state.B_Klasse3),
                    B_Klasse4: _this.state.B_Klasse4 === null ? 0 : Number(_this.state.B_Klasse4),
                    B_Klasse5: _this.state.B_Klasse5 === null ? 0 : Number(_this.state.B_Klasse5),
                    B_Klasse6: _this.state.B_Klasse6 === null ? 0 : Number(_this.state.B_Klasse6),
                    KL_P: _this.state.KL_P === null ? 0 : Number(_this.state.KL_P),
                    KL_E: _this.state.KL_E === null ? 0 : Number(_this.state.KL_E),
                    Slagspil: _this.state.Slagspil === null ? 0 : Number(_this.state.Slagspil),
                    KL_Z: _this.state.KL_Z === null ? 0 : Number(_this.state.KL_Z),
                    KL_R: _this.state.KL_R === null ? 0 : Number(_this.state.KL_R)
                };

                if (_this.props.isDDB) {
                    entity.Derby = _this.state.Derby === null ? null : Number(_this.state.Derby);
                }

                // Creating new row or updating existing
                if (!_this.props.section.Indskud) {
                    _this.props.dispatch(AdminActions.createDeposit(_this.props.isDDB ? 'ddb' : _this.props.isSection ? _this.props.section.Sektionsnr : _this.props.section.Foreningsnr, entity, onSuccess));
                } else {
                    _this.props.dispatch(AdminActions.updateDeposit(_this.props.isDDB ? 'ddb' : _this.props.isSection ? _this.props.section.Sektionsnr : _this.props.section.Foreningsnr, entity, onSuccess));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.fields = [];

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SettingsDeposits, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section.Indskud === null) return defaultState;else {
                var deposit = props.section.Indskud;
                return {
                    A_Klasse1: deposit.A_Klasse1 === null ? '0' : deposit.A_Klasse1.toString(),
                    A_Klasse2: deposit.A_Klasse2 === null ? '0' : deposit.A_Klasse2.toString(),
                    A_Klasse3: deposit.A_Klasse3 === null ? '0' : deposit.A_Klasse3.toString(),
                    A_Klasse4: deposit.A_Klasse4 === null ? '0' : deposit.A_Klasse4.toString(),
                    A_Klasse5: deposit.A_Klasse5 === null ? '0' : deposit.A_Klasse5.toString(),
                    A_Klasse6: deposit.A_Klasse6 === null ? '0' : deposit.A_Klasse6.toString(),
                    B_Klasse1: deposit.B_Klasse1 === null ? '0' : deposit.B_Klasse1.toString(),
                    B_Klasse2: deposit.B_Klasse2 === null ? '0' : deposit.B_Klasse2.toString(),
                    B_Klasse3: deposit.B_Klasse3 === null ? '0' : deposit.B_Klasse3.toString(),
                    B_Klasse4: deposit.B_Klasse4 === null ? '0' : deposit.B_Klasse4.toString(),
                    B_Klasse5: deposit.B_Klasse5 === null ? '0' : deposit.B_Klasse5.toString(),
                    B_Klasse6: deposit.B_Klasse6 === null ? '0' : deposit.B_Klasse6.toString(),
                    KL_P: deposit.KL_P === null ? '0' : deposit.KL_P.toString(),
                    KL_E: deposit.KL_E === null ? '0' : deposit.KL_E.toString(),
                    Slagspil: deposit.Slagspil === null ? '0' : deposit.Slagspil.toString(),
                    KL_Z: deposit.KL_Z === null ? '0' : deposit.KL_Z.toString(),
                    KL_R: deposit.KL_R === null ? '0' : deposit.KL_R.toString(),
                    Derby: deposit.Derby === null ? '0' : deposit.Derby.toString(),
                    TillaegFastForening: deposit.TillaegFastForening === null ? '0' : deposit.TillaegFastForening.toString(),
                    TillaegPrDueForening: deposit.TillaegPrDueForening === null ? '0' : deposit.TillaegPrDueForening.toString()
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editMode;
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: "form-page flex-center " + (editMode ? "editable" : "read-only") },
                    _react2.default.createElement(
                        'table',
                        { className: 'main-form-table deposit-table' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: "deposit-header" },
                                            'A-Spil'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse1' },
                                            '\xA0'
                                        )
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse1' },
                                            'Kl. 1'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse2' },
                                            'Kl. 2'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse3' },
                                            'Kl. 3'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse4' },
                                            'Kl. 4'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse5' },
                                            'Kl. 5'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse6' },
                                            'Kl. 6'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: this.props.isClub ? "" : "normal-row" },
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'DdB'
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse1',
                                        id: 'A_Klasse1',
                                        value: this.state.A_Klasse1,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse1 : this.state.A_Klasse1
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse2',
                                        id: 'A_Klasse2',
                                        value: this.state.A_Klasse2,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse2 : this.state.A_Klasse2
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse3',
                                        id: 'A_Klasse3',
                                        value: this.state.A_Klasse3,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[3] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse3 : this.state.A_Klasse3
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse4',
                                        id: 'A_Klasse4',
                                        value: this.state.A_Klasse4,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[4] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse4 : this.state.A_Klasse4
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse5',
                                        id: 'A_Klasse5',
                                        value: this.state.A_Klasse5,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse5 : this.state.A_Klasse5
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1',
                                        containerClassName: 'display-inline-block',
                                        name: 'A_Klasse6',
                                        id: 'A_Klasse6',
                                        value: this.state.A_Klasse6,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[6] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse6 : this.state.A_Klasse6
                                    )
                                )
                            ),
                            this.props.isClub ? _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'Sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse1
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse2
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse3
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse4
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse5
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse6
                                    )
                                )
                            ) : null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse1' },
                                            '\xA0'
                                        )
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'KL_P' },
                                            'Kl. P'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'KL_E' },
                                            'Kl. E'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Slagspil' },
                                            'Slagspil'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'KL_Z' },
                                            'Kl. Z'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'KL_R' },
                                            'DM'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: this.props.isClub ? "" : "normal-row" },
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'DdB'
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'KL_P',
                                        id: 'KL_P',
                                        value: this.state.KL_P,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.KL_P : this.state.KL_P
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'KL_E',
                                        id: 'KL_E',
                                        value: this.state.KL_E,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[8] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.KL_E : this.state.KL_E
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'Slagspil',
                                        id: 'Slagspil',
                                        value: this.state.Slagspil,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[9] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.Slagspil : this.state.Slagspil
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'KL_Z',
                                        id: 'KL_Z',
                                        value: this.state.KL_Z,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[10] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.KL_Z : this.state.KL_Z
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'KL_R',
                                        id: 'KL_R',
                                        value: this.state.KL_R,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[11] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.KL_R : this.state.KL_R
                                    )
                                )
                            ),
                            this.props.isClub ? _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'Sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_P
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_E
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.Slagspil
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_Z
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_R
                                    )
                                )
                            ) : null
                        )
                    ),
                    _react2.default.createElement(
                        'table',
                        { className: 'main-form-table deposit-table' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: "deposit-header" },
                                            'B-Spil'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'A_Klasse1' },
                                            '\xA0'
                                        )
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse1' },
                                            'Kl. 1'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse2' },
                                            'Kl. 2'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse3' },
                                            'Kl. 3'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse4' },
                                            'Kl. 4'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse5' },
                                            'Kl. 5'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'B_Klasse6' },
                                            'Kl. 6'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: this.props.isClub ? "" : "normal-row" },
                                this.props.isClub ? _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'DdB'
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse1',
                                        id: 'B_Klasse1',
                                        value: this.state.B_Klasse1,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[12] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse1 : this.state.B_Klasse1
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse2',
                                        id: 'B_Klasse2',
                                        value: this.state.B_Klasse2,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[13] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse2 : this.state.B_Klasse2
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse3',
                                        id: 'B_Klasse3',
                                        value: this.state.B_Klasse3,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[14] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse3 : this.state.B_Klasse3
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse4',
                                        id: 'B_Klasse4',
                                        value: this.state.B_Klasse4,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[15] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse4 : this.state.B_Klasse4
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse5',
                                        id: 'B_Klasse5',
                                        value: this.state.B_Klasse5,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[16] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse5 : this.state.B_Klasse5
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.regex,
                                        placeholder: '',
                                        className: 'field-1 ',
                                        containerClassName: 'display-inline-block',
                                        name: 'B_Klasse6',
                                        id: 'B_Klasse6',
                                        value: this.state.B_Klasse6,
                                        maxLength: '5',
                                        options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[17] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse6 : this.state.B_Klasse6
                                    )
                                )
                            ),
                            this.props.isClub ? _react2.default.createElement(
                                'tr',
                                { className: 'normal-row' },
                                _react2.default.createElement(
                                    'td',
                                    { className: "label-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'label-text' },
                                        'Sektion'
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse1
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse2
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse3
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse4
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse5
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { className: "data-cell" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse6
                                    )
                                )
                            ) : null,
                            this.props.isDDB ? _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Derby' },
                                                'Derby'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.regex,
                                            placeholder: '',
                                            className: 'field-1',
                                            containerClassName: 'display-inline-block',
                                            name: 'Derby',
                                            id: 'Derby',
                                            value: this.state.Derby,
                                            maxLength: '5',
                                            options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[18] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.Derby
                                        )
                                    )
                                )
                            ) : this.props.isClub ? _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 3, className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'TillaegPrDueForening' },
                                                'Till\xE6g pr. due i \xF8re'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 3, className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'TillaegFastForening' },
                                                'Fast till\xE6g i \xF8re'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 3, className: "data-cell" },
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.regex,
                                            placeholder: '',
                                            className: 'field-1',
                                            containerClassName: 'display-inline-block',
                                            name: 'TillaegPrDueForening',
                                            id: 'TillaegPrDueForening',
                                            value: this.state.TillaegPrDueForening,
                                            maxLength: '5',
                                            options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[18] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.TillaegPrDueForening
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: 3, className: "data-cell" },
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.regex,
                                            placeholder: '',
                                            className: 'field-1',
                                            containerClassName: 'display-inline-block',
                                            name: 'TillaegFastForening',
                                            id: 'TillaegFastForening',
                                            value: this.state.TillaegFastForening,
                                            maxLength: '5',
                                            options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,5}" }],
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[19] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.TillaegFastForening
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement('td', { className: "data-cell" })
                                )
                            ) : _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement('td', { className: "data-cell" })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: "form-page flex-center" },
                    _react2.default.createElement(
                        'label',
                        { className: "" },
                        'Alle indskud angives i hele kroner'
                    )
                )
            );
        }
    }]);

    return SettingsDeposits;
}(_react2.default.Component);

SettingsDeposits.propTypes = {
    editMode: _propTypes2.default.bool,
    section: _propTypes2.default.object.isRequired,
    sectionNo: _propTypes2.default.string.isRequired,
    isDDB: _propTypes2.default.bool.isRequired,
    isSection: _propTypes2.default.bool.isRequired,
    isClub: _propTypes2.default.bool.isRequired
};
SettingsDeposits.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            generalSection: state.admin.generalSection
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SettingsDeposits);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _reactNotifications = __webpack_require__(8);

var _confirmDialog = __webpack_require__(12);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import PriceAdditionsDialog from '../dialogs/PriceAdditionsDialog';

var defaultState = exports.defaultState = {
    MinPuljeTilFord: '0',
    Praemiefaktor_A: '5',
    Praemiefaktor_B: '10',
    PuljePuljepraemier: false,
    ElitePuljepraemier: false,
    Z_Puljepraemier: false,
    R_Puljepraemier: false,
    KunEnKontantpraemiePrSlag: false
};

var SettingsPrizes = function (_React$Component) {
    _inherits(SettingsPrizes, _React$Component);

    function SettingsPrizes(props) {
        _classCallCheck(this, SettingsPrizes);

        var _this = _possibleConstructorReturn(this, (SettingsPrizes.__proto__ || Object.getPrototypeOf(SettingsPrizes)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onPoolPriceClick = function (e) {
            _this.setState(_defineProperty({}, e.target.name, e.target.checked));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.saveRow = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Antal: _this.state.Antal === '' ? null : Number(_this.state.Antal),
                    Vaerdi: _this.state.Vaerdi === '' ? null : Number(_this.state.Vaerdi.replace(',', '.'))
                };

                if (_this.props.isDDB) {
                    entity.Sektionsnr = _this.state.Sektionsnr === '' ? null : _this.state.Sektionsnr;
                }

                if (_this.state.editIx === 'new/new') {
                    _this.props.dispatch(AdminActions.createSectionPrize(_this.props.sectionNo, _this.state.priceType, entity, function () {
                        _reactNotifications.NotificationManager.success("Præmien på " + _this.state.Vaerdi + " DKK" + (_this.state.Sektionsnr === '' ? '' : ' for sektion ' + _this.state.Sektionsnr) + " er oprettet.", "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                        /*setTimeout(function () {
                            const currentRow = document.getElementById("row-" + this.state.Sektionsnr + "-" + this.state.Vaerdi);
                            currentRow.scrollIntoView(false);
                        }.bind(this));*/
                    }));
                } else _this.props.dispatch(AdminActions.updateSectionPrize(_this.props.sectionNo, _this.state.priceType, _this.props.isDDB ? _this.state.oldSektion : 'null', _this.state.oldVaerdi, entity, function () {
                    _reactNotifications.NotificationManager.success("Præmien på " + _this.state.Vaerdi + " DKK" + (_this.state.Sektionsnr === '' ? '' : ' for sektion ' + _this.state.Sektionsnr) + " er opdateret.", "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    /*setTimeout(function () {
                        const currentRow = document.getElementById("row-" + this.state.Sektionsnr + "-" + this.state.Vaerdi);
                        currentRow.scrollIntoView(false);
                    }.bind(this));*/
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.createNew = function () {
            _this.setState({
                Antal: '1',
                Vaerdi: '',
                Sektionsnr: '',
                editIx: 'new/new'
            });
            setTimeout(function () {
                var content = document.getElementById("data-table");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    MinPuljeTilFord: _this.state.MinPuljeTilFord === null ? 0 : Number(_this.state.MinPuljeTilFord),
                    Praemiefaktor_A: _this.state.Praemiefaktor_A === null ? 5 : Number(_this.state.Praemiefaktor_A),
                    Praemiefaktor_B: _this.state.Praemiefaktor_B === null ? 10 : Number(_this.state.Praemiefaktor_B),
                    PuljePuljepraemier: _this.state.PuljePuljepraemier === null ? false : _this.state.PuljePuljepraemier ? -1 : 0,
                    ElitePuljepraemier: _this.state.ElitePuljepraemier === null ? false : _this.state.ElitePuljepraemier ? -1 : 0,
                    Z_Puljepraemier: _this.state.Z_Puljepraemier === null ? false : _this.state.Z_Puljepraemier ? -1 : 0,
                    R_Puljepraemier: _this.state.R_Puljepraemier === null ? false : _this.state.R_Puljepraemier ? -1 : 0,
                    KunEnKontantpraemiePrSlag: _this.state.KunEnKontantpraemiePrSlag === null ? false : _this.state.KunEnKontantpraemiePrSlag ? -1 : 0
                };

                // Creating new row or updating existing
                if (!_this.props.section.Markering) {
                    _this.props.dispatch(AdminActions.createMarking(_this.props.sectionNo, entity, onSuccess));
                } else {
                    _this.props.dispatch(AdminActions.updateMarking(_this.props.sectionNo, entity, onSuccess));
                }
            }
        };

        var additionalStates = {
            priceType: null,
            editIx: null
        };
        _this.state = Object.assign(additionalStates, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SettingsPrizes, [{
        key: 'componentDidMount',
        value: function componentDidMount(props) {
            this.props.dispatch(AdminActions.getSectionPrizes(this.props.sectionNo));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)) this.setState(this.getStateFromStore(nextProps));
            if (!nextProps.section.hasOwnProperty('sectionPrizesRead')) this.props.dispatch(AdminActions.getSectionPrizes(nextProps.sectionNo));
            if (this.state.priceType !== null) this.props.setAllowNew(true);
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section.Markering === null) return defaultState;else {
                var section = props.section;
                var marker = section.Markering;

                return {
                    MinPuljeTilFord: marker.MinPuljeTilFord === null ? '0' : marker.MinPuljeTilFord.toString(),
                    Praemiefaktor_A: marker.Praemiefaktor_A === null ? '5' : marker.Praemiefaktor_A.toString(),
                    Praemiefaktor_B: marker.Praemiefaktor_B === null ? '10' : marker.Praemiefaktor_B.toString(),
                    PuljePuljepraemier: marker.PuljePuljepraemier === null ? false : Boolean(marker.PuljePuljepraemier),
                    ElitePuljepraemier: marker.ElitePuljepraemier === null ? false : Boolean(marker.ElitePuljepraemier),
                    Z_Puljepraemier: marker.Z_Puljepraemier === null ? false : Boolean(marker.Z_Puljepraemier),
                    R_Puljepraemier: marker.R_Puljepraemier === null ? false : Boolean(marker.R_Puljepraemier),
                    KunEnKontantpraemiePrSlag: marker.KunEnKontantpraemiePrSlag === null ? false : Boolean(marker.KunEnKontantpraemiePrSlag),
                    sectionPrizesRead: section.hasOwnProperty('sectionPrizesRead') ? section.sectionPrizesRead : false
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "form-page race-prices settings " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'top-left-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.options,
                                className: '',
                                containerClassName: 'display-inline-block',
                                disabled: this.state.editIx !== null,
                                name: 'priceType',
                                id: 'priceType',
                                value: this.state.priceType,
                                options: this.props.isClub ? [{ key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null }, { key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null }] : [{ key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null }, { key: 'slagspil', value: 'Slagspilspræmier', disabled: this.state.editIx !== null }, { key: 'espil', value: 'E-spilspræmier', disabled: this.state.editIx !== null }, { key: 'pspil', value: 'P-spilspræmier', disabled: this.state.editIx !== null }, { key: 'zspil', value: 'Z-spilspræmier', disabled: this.state.editIx !== null }, { key: 'dm', value: 'DM-præmier', disabled: this.state.editIx !== null }, { key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null }],
                                autoCheckErrors: true,
                                required: false,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: function onChange(e) {
                                    _this2.setState({ priceType: e.target.value });
                                    _this2.props.setAllowNew(true);
                                },
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'top-right-panel' },
                    _react2.default.createElement(
                        'div',
                        { id: 'data-table', className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Antal'
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'V\xE6rdi'
                                        ),
                                        this.props.isDDB ? _react2.default.createElement(
                                            'th',
                                            null,
                                            'Sektion'
                                        ) : null,
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.state.priceType !== null && this.props.section[this.state.priceType] ? this.props.section[this.state.priceType].sort(function (p1, p2) {
                                        if (p1.Sektionsnr < p2.Sektionsnr) return -1;
                                        if (p1.Sektionsnr > p2.Sektionsnr) return 1;
                                        if (p1.Vaerdi > p2.Vaerdi) return -1;
                                        if (p1.Vaerdi < p2.Vaerdi) return 1;
                                        return 0;
                                    }).concat(this.state.editIx === 'new/new' ? [{ Sektionsnr: 'new', Vaerdi: 'new' }] : []).map(function (prize) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: prize.Sektionsnr + '/' + prize.Vaerdi, id: 'row-' + prize.Sektionsnr + '-' + prize.Vaerdi },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                                    name: 'Antal', id: 'Antal', value: _this2.state.Antal,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[1] = instance;
                                                    }
                                                }) : prize.Antal
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.float, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'Vaerdi', id: 'Vaerdi', value: _this2.state.Vaerdi,
                                                    autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[2] = instance;
                                                    }
                                                }) : String(prize.Vaerdi).replace('.', ',')
                                            ),
                                            _this2.props.isDDB ? _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                    name: 'Sektionsnr', id: 'Sektionsnr', maxLength: '6', value: _this2.state.Sektionsnr,
                                                    autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                    onChange: _this2.onStandardFieldChange,
                                                    ref: function ref(instance) {
                                                        _this2.fields[3] = instance;
                                                    }
                                                }) : prize.Sektionsnr
                                            ) : null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _this2.state.editIx === prize.Sektionsnr + '/' + prize.Vaerdi ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem pr\xE6mie', onClick: _this2.saveRow }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                        if (_this2.state.editIx === null) {
                                                            _this2.setState({
                                                                Sektionsnr: prize.Sektionsnr,
                                                                Vaerdi: String(prize.Vaerdi).replace('.', ','),
                                                                Antal: prize.Antal === null ? '' : String(prize.Antal),
                                                                oldSektion: String(prize.Sektionsnr),
                                                                oldVaerdi: String(prize.Vaerdi),
                                                                editIx: prize.Sektionsnr + '/' + prize.Vaerdi
                                                            });
                                                        }
                                                    } }), _react2.default.createElement('i', { key: 1,
                                                    className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet pr\xE6mie', onClick: function onClick() {
                                                        if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            '\xD8nsker du at slette pr\xE6mien p\xE5 ',
                                                            _react2.default.createElement(
                                                                'b',
                                                                null,
                                                                prize.Vaerdi,
                                                                ' DKK'
                                                            ),
                                                            prize.Sektionsnr === '' ? '' : _react2.default.createElement(
                                                                'span',
                                                                null,
                                                                ' for sektion ',
                                                                _react2.default.createElement(
                                                                    'b',
                                                                    null,
                                                                    prize.Sektionsnr
                                                                )
                                                            ),
                                                            '?'
                                                        ), function () {
                                                            _this2.props.dispatch(AdminActions.deleteSectionPrize(_this2.props.sectionNo, _this2.state.priceType, prize.Sektionsnr, prize.Vaerdi, function () {
                                                                _reactNotifications.NotificationManager.success("Præmien på " + prize.Vaerdi + ' DKK' + (prize.Sektionsnr === '' ? '' : ' for sektion ' + prize.Sektionsnr) + " er slettet.", "Sletning", 4000);
                                                            }));
                                                        });
                                                    } })]
                                            )
                                        );
                                    }) : null
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-left-settings-panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        this.props.isClub ? _react2.default.createElement(
                            'div',
                            { className: 'inner-content-lower flex' },
                            _react2.default.createElement(
                                'div',
                                { className: "normal-width" },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'KunEnKontantpraemiePrSlag' },
                                    'Uddel kun \xE9n kontantpr\xE6mie pr. slag'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('input', { id: 'KunEnKontantpraemiePrSlag', name: 'KunEnKontantpraemiePrSlag', type: 'checkbox', checked: this.state.KunEnKontantpraemiePrSlag,
                                        disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                )
                            )
                        ) : [_react2.default.createElement(
                            'div',
                            { className: 'inner-content-upper flex', style: { paddingBottom: "30px" } },
                            _react2.default.createElement(
                                'div',
                                { className: "normal-width" },
                                _react2.default.createElement(
                                    'label',
                                    { style: { paddingRight: "70px" } },
                                    'Minimum P-spil til fordeling:'
                                ),
                                this.props.editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.int,
                                    placeholder: '',
                                    className: 'field-1 very-small-field',
                                    containerClassName: 'display-inline-block',
                                    name: 'MinPuljeTilFord',
                                    id: 'MinPuljeTilFord',
                                    value: this.state.MinPuljeTilFord,
                                    autoCheckErrors: true,
                                    required: false,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onStandardFieldChange,
                                    ref: function ref(instance) {
                                        _this2.fields[1] = instance;
                                    }
                                }) : _react2.default.createElement(
                                    'span',
                                    { className: 'value-text' },
                                    this.state.MinPuljeTilFord
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Pr\xE6mier i A-spil ='
                                    ),
                                    this.props.editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.int,
                                        placeholder: '',
                                        className: 'field-1 very-small-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Praemiefaktor_A',
                                        id: 'Praemiefaktor_A',
                                        value: this.state.Praemiefaktor_A,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Praemiefaktor_A
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'gange indsats'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Pr\xE6mier i B-spil ='
                                    ),
                                    this.props.editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                        dataType: _UserFieldDataTypeEnum2.default.int,
                                        placeholder: '',
                                        className: 'field-1 very-small-field',
                                        containerClassName: 'display-inline-block',
                                        name: 'Praemiefaktor_B',
                                        id: 'Praemiefaktor_B',
                                        value: this.state.Praemiefaktor_B,
                                        autoCheckErrors: true,
                                        required: false,
                                        hideErrWhenFocused: true,
                                        hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Praemiefaktor_B
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'gange indsats'
                                    )
                                )
                            )
                        ), _react2.default.createElement(
                            'div',
                            { className: 'inner-content-lower ' },
                            _react2.default.createElement(
                                'div',
                                { className: 'flex' },
                                _react2.default.createElement(
                                    'div',
                                    { className: "normal-width" },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Pr\xE6miepulje kan ikke overstige samlede indskud'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'pool-prices' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'pool-prices-option' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'PuljePuljepraemier', className: !this.props.editMode ? 'disabled' : '' },
                                                'Pulje'
                                            ),
                                            _react2.default.createElement('input', { id: 'PuljePuljepraemier', name: 'PuljePuljepraemier', type: 'checkbox', checked: this.state.PuljePuljepraemier,
                                                disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'pool-prices-option' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'ElitePuljepraemier', className: !this.props.editMode ? 'disabled' : '' },
                                                'Elite'
                                            ),
                                            _react2.default.createElement('input', { id: 'ElitePuljepraemier', name: 'ElitePuljepraemier', type: 'checkbox', checked: this.state.ElitePuljepraemier,
                                                disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'pool-prices-option' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Z_Puljepraemier', className: !this.props.editMode ? 'disabled' : '' },
                                                'Z-spil'
                                            ),
                                            _react2.default.createElement('input', { id: 'Z_Puljepraemier', name: 'Z_Puljepraemier', type: 'checkbox', checked: this.state.Z_Puljepraemier,
                                                disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'pool-prices-option' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'R_Puljepraemier', className: !this.props.editMode ? 'disabled' : '' },
                                                'DM'
                                            ),
                                            _react2.default.createElement('input', { id: 'R_Puljepraemier', name: 'R_Puljepraemier', type: 'checkbox', checked: this.state.R_Puljepraemier,
                                                disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'flex' },
                                _react2.default.createElement(
                                    'div',
                                    { className: "normal-width" },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'pool-prices' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'pool-prices-option' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunEnKontantpraemiePrSlag' },
                                                'Uddel kun \xE9n kontantpr\xE6mie pr. slag'
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                _react2.default.createElement('input', { id: 'KunEnKontantpraemiePrSlag', name: 'KunEnKontantpraemiePrSlag', type: 'checkbox', checked: this.state.KunEnKontantpraemiePrSlag,
                                                    disabled: !this.props.editMode, onChange: this.onPoolPriceClick })
                                            )
                                        )
                                    )
                                )
                            )
                        )]
                    )
                )
            );
        }
    }]);

    return SettingsPrizes;
}(_react2.default.Component);

SettingsPrizes.propTypes = {
    section: _propTypes2.default.object.isRequired,
    sectionNo: _propTypes2.default.string.isRequired,
    editMode: _propTypes2.default.bool.isRequired,
    isDDB: _propTypes2.default.bool.isRequired,
    isSection: _propTypes2.default.bool.isRequired,
    isClub: _propTypes2.default.bool.isRequired,
    setAllowNew: _propTypes2.default.func.isRequired
};
SettingsPrizes.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SettingsPrizes);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Pointsystem: '0',
    SportDdB_L: '0',
    SportDdB_M: '0',
    SportDdB: '0',
    SportSektion: '0',
    SportForening: '0',
    MaxDM_marathon: '0',
    MaxDM_lang: '0',
    MaxDM_mellem: '0',
    Hastighed9192: '0',
    HastighedAndre: '0',
    MaxRegTidDiff: '0'
};

var SettingsMarkings = function (_React$Component) {
    _inherits(SettingsMarkings, _React$Component);

    function SettingsMarkings(props) {
        _classCallCheck(this, SettingsMarkings);

        var _this = _possibleConstructorReturn(this, (SettingsMarkings.__proto__ || Object.getPrototypeOf(SettingsMarkings)).call(this, props));

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = Object.assign({}, {
                    Pointsystem: _this.state.Pointsystem === 0 ? null : Number(_this.state.Pointsystem)
                }, _this.props.isDDB ? {
                    SportDdB_L: _this.state.SportDdB_L === 0 ? null : Number(_this.state.SportDdB_L),
                    SportDdB_M: _this.state.SportDdB_M === 0 ? null : Number(_this.state.SportDdB_M),
                    SportDdB: _this.state.SportDdB === 0 ? null : Number(_this.state.SportDdB),
                    MaxDM_marathon: _this.state.MaxDM_marathon === 0 ? null : Number(_this.state.MaxDM_marathon),
                    MaxDM_lang: _this.state.MaxDM_lang === 0 ? null : Number(_this.state.MaxDM_lang),
                    MaxDM_mellem: _this.state.MaxDM_mellem === 0 ? null : Number(_this.state.MaxDM_mellem),
                    MaxRegTidDiff: _this.state.MaxRegTidDiff === 0 ? null : Number(_this.state.MaxRegTidDiff)
                } : null, _this.props.isDDB || _this.props.isSection ? {
                    SportSektion: _this.state.SportSektion === 0 ? null : Number(_this.state.SportSektion),
                    Hastighed9192: _this.state.Hastighed9192 === 0 ? null : Number(_this.state.Hastighed9192.replace(',', '.')),
                    HastighedAndre: _this.state.HastighedAndre === 0 ? null : Number(_this.state.HastighedAndre.replace(',', '.'))
                } : null, _this.props.isClub ? {
                    SportForening: _this.state.SportForening === 0 ? null : Number(_this.state.SportForening)
                } : null);

                if (_this.props.section.Markering === null) {
                    _this.props.dispatch(AdminActions.createMarking(_this.props.isDDB ? 'ddb' : _this.props.isSection ? _this.props.section.Sektionsnr : _this.props.section.Foreningsnr, entity, onSuccess));
                } else {
                    _this.props.dispatch(AdminActions.updateMarking(_this.props.isDDB ? 'ddb' : _this.props.isSection ? _this.props.section.Sektionsnr : _this.props.section.Foreningsnr, entity, onSuccess));
                }
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.fields = [];

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(SettingsMarkings, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.section === null && this.props.section !== null || nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.section.Markering === null) return defaultState;else {
                var marking = props.section.Markering;
                var stateFromStore = {
                    Pointsystem: marking.Pointsystem === null ? '0' : marking.Pointsystem.toString(),
                    SportDdB_L: marking.SportDdB_L === null ? '0' : marking.SportDdB_L.toString(),
                    SportDdB_M: marking.SportDdB_M === null ? '0' : marking.SportDdB_M.toString(),
                    SportDdB: marking.SportDdB === null ? '0' : marking.SportDdB.toString(),
                    SportSektion: marking.SportSektion === null ? '0' : marking.SportSektion.toString(),
                    SportForening: marking.SportForening === null ? '0' : marking.SportForening.toString(),
                    MaxDM_marathon: marking.MaxDM_marathon === null ? '0' : marking.MaxDM_marathon.toString(),
                    MaxDM_lang: marking.MaxDM_lang === null ? '0' : marking.MaxDM_lang.toString(),
                    MaxDM_mellem: marking.MaxDM_mellem === null ? '0' : marking.MaxDM_mellem.toString(),
                    Hastighed9192: marking.Hastighed9192 === null ? '0' : marking.Hastighed9192.toString().replace('.', ','),
                    HastighedAndre: marking.HastighedAndre === null ? '0' : marking.HastighedAndre.toString().replace('.', ',')
                };
                if (props.isDDB) {
                    stateFromStore.MaxRegTidDiff = props.section.MaxRegTidDiff === null ? 0 : props.section.MaxRegTidDiff.toString();
                }
                return stateFromStore;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editMode;
            return _react2.default.createElement(
                'div',
                { className: "form-page settings-markings " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'block-content' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'header' },
                                'Pointsberegningssystem'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'points' },
                            _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.options,
                                className: '',
                                containerClassName: 'display-inline-block',
                                disabled: !this.props.editMode,
                                name: 'Pointsystem',
                                id: 'Pointsystem',
                                value: this.state.Pointsystem,
                                options: [{ key: '0', value: '1000-points', disabled: !this.props.editMode }, { key: '1', value: 'Placeringspoint', disabled: !this.props.editMode }],
                                autoCheckErrors: true,
                                required: false,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: function onChange(e) {
                                    _this2.setState({ Pointsystem: e.target.value });
                                },
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'content no-border' },
                    _react2.default.createElement(
                        'div',
                        { className: 'block-content' },
                        _react2.default.createElement(
                            'table',
                            { className: 'main-form-table num-of-pigeons' },
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SportDdB_L' },
                                                'Ddb lang'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SportDdB_M' },
                                                'Ddb mellem'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SportDdB' },
                                                'Ddb land'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SportSektion' },
                                                'Sektion'
                                            )
                                        )
                                    ),
                                    this.props.isClub ? _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'SportForening' },
                                                'Forening'
                                            )
                                        )
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { className: "topic-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Antal sportsduer for:'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'SportDdB_L',
                                            id: 'SportDdB_L',
                                            value: this.state.SportDdB_L,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[1] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.SportDdB_L : this.props.admin.generalSection.Markering.SportDdB_L
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'SportDdB_M',
                                            id: 'SportDdB_M',
                                            value: this.state.SportDdB_M,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[2] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.SportDdB_M : this.props.admin.generalSection.Markering.SportDdB_M
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'SportDdB',
                                            id: 'SportDdB',
                                            value: this.state.SportDdB,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[3] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.SportDdB : this.props.admin.generalSection.Markering.SportDdB
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'SportSektion',
                                            id: 'SportSektion',
                                            value: this.state.SportSektion,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[4] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            !this.props.isClub ? this.state.SportSektion : this.props.section.Sektion.Markering === null ? this.props.admin.generalSection.Markering.SportSektion : this.props.section.Sektion.Markering.SportSektion
                                        )
                                    ),
                                    this.props.isClub ? _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'SportForening',
                                            id: 'SportForening',
                                            value: this.state.SportForening,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[5] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.SportForening
                                        )
                                    ) : null
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxDM_marathon' },
                                                'Marathon'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxDM_lang' },
                                                'Lang'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'MaxDM_mellem' },
                                                'Mellem'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell topic-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Antal DM duer for:'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'MaxDM_marathon',
                                            id: 'MaxDM_marathon',
                                            value: this.state.MaxDM_marathon,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[6] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.MaxDM_marathon : this.props.admin.generalSection.Markering.MaxDM_marathon
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'MaxDM_lang',
                                            id: 'MaxDM_lang',
                                            value: this.state.MaxDM_lang,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[7] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.MaxDM_lang : this.props.admin.generalSection.Markering.MaxDM_lang
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && this.props.isDDB ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 very-small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'MaxDM_mellem',
                                            id: 'MaxDM_mellem',
                                            value: this.state.MaxDM_mellem,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[8] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.MaxDM_mellem : this.props.admin.generalSection.Markering.MaxDM_mellem
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'Hastighed9192' },
                                                'Lang'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "label-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'HastighedAndre' },
                                                'Mellem'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell topic-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Min. hastigheder for duer til beregning:'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.float,
                                            placeholder: '',
                                            className: 'field-1 small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'Hastighed9192',
                                            id: 'Hastighed9192',
                                            value: this.state.Hastighed9192,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[9] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            !this.props.isClub ? this.state.Hastighed9192 : this.props.admin.generalSection.Markering.Hastighed9192.toString().replace(".", ",")
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode && !this.props.isClub ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.float,
                                            placeholder: '',
                                            className: 'field-1 small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'HastighedAndre',
                                            id: 'HastighedAndre',
                                            value: this.state.HastighedAndre,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[10] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            !this.props.isClub ? this.state.HastighedAndre : this.props.admin.generalSection.Markering.HastighedAndre.toString().replace(".", ",")
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ),
                                this.props.isDDB ? _react2.default.createElement(
                                    'tr',
                                    { className: 'normal-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell topic-cell" },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'label-text' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Max. antal sekunder mellem registreringer:'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement(
                                        'td',
                                        { className: "data-cell" },
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, {
                                            dataType: _UserFieldDataTypeEnum2.default.int,
                                            placeholder: '',
                                            className: 'field-1 small-field',
                                            containerClassName: 'display-inline-block',
                                            name: 'MaxRegTidDiff',
                                            id: 'MaxRegTidDiff',
                                            value: this.state.MaxRegTidDiff,
                                            autoCheckErrors: true,
                                            required: false,
                                            hideErrWhenFocused: true,
                                            hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[11] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.props.isDDB ? this.state.MaxRegTidDiff : this.props.admin.generalSection.Markering.MaxRegTidDiff
                                        )
                                    ),
                                    _react2.default.createElement('td', { className: "label-cell" }),
                                    _react2.default.createElement('td', { className: "label-cell" })
                                ) : null
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bottom-content' },
                    _react2.default.createElement('div', { className: 'block-content' })
                )
            );
        }
    }]);

    return SettingsMarkings;
}(_react2.default.Component);

SettingsMarkings.propTypes = {
    editMode: _propTypes2.default.bool.isRequired,
    section: _propTypes2.default.object.isRequired,
    sectionNo: _propTypes2.default.string.isRequired,
    isDDB: _propTypes2.default.bool.isRequired,
    isSection: _propTypes2.default.bool.isRequired,
    isClub: _propTypes2.default.bool.isRequired
};
SettingsMarkings.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            generalSection: state.admin.generalSection
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SettingsMarkings);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _reactNotifications = __webpack_require__(8);

var _confirmDialog = __webpack_require__(12);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsKilometers = function (_React$Component) {
    _inherits(SettingsKilometers, _React$Component);

    function SettingsKilometers(props) {
        _classCallCheck(this, SettingsKilometers);

        var _this = _possibleConstructorReturn(this, (SettingsKilometers.__proto__ || Object.getPrototypeOf(SettingsKilometers)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field, ix) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.saveRow = function () {
            if (_this.allInputValid()) {
                var entity = {
                    KM: _this.state.Antal === '' ? 0 : Number(_this.state.KM),
                    Faktor: _this.state.Vaerdi === '' ? 0 : Number(_this.state.Faktor.replace(',', '.'))
                };
                if (_this.state.editIx === 'new/new') {
                    _this.props.dispatch(AdminActions.createKilometer(entity, function () {
                        _reactNotifications.NotificationManager.success('Till\xE6g for ' + _this.state.KM + ' KM (faktor ' + _this.state.Faktor + ') er oprettet.', "Oprettelse", 4000);
                        _this.setState({ editIx: null });
                        setTimeout(function () {
                            var currentRow = document.getElementById("row-" + this.state.KM + "-" + this.state.Faktor.replace(',', '.'));
                            currentRow.scrollIntoView(false);
                        }.bind(_this));
                    }));
                } else _this.props.dispatch(AdminActions.updateKilometer(_this.state.oldKM, entity, function () {
                    _reactNotifications.NotificationManager.success('Till\xE6g for ' + _this.state.KM + ' KM (faktor ' + _this.state.Faktor + ') er opdateret.', "Opdatering", 4000);
                    _this.setState({ editIx: null });
                    setTimeout(function () {
                        var currentRow = document.getElementById("row-" + this.state.KM + "-" + this.state.Faktor.replace(',', '.'));
                        currentRow.scrollIntoView(false);
                    }.bind(_this));
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
            _this.props.setAllowNew(true);
        };

        _this.createNew = function () {
            _this.props.setAllowNew(false);
            _this.setState({
                KM: '',
                Faktor: '',
                editIx: 'new/new'
            });
            setTimeout(function () {
                var content = document.getElementById("tab-page");
                content.scrollTop = content.scrollHeight;
            });
        };

        _this.cancelEdit = function () {
            _this.setState({ editIx: null });
            _this.props.setAllowNew(true);
        };

        _this.state = {
            priceType: null,
            editIx: null,
            KM: '0',
            Faktor: '0',
            factorPairsLoaded: false
        };
        _this.props.setAllowNew(true);
        return _this;
    }

    _createClass(SettingsKilometers, [{
        key: 'componentDidMount',
        value: function componentDidMount(props) {
            var _this2 = this;

            this.props.dispatch(AdminActions.getKilometers(function () {
                _this2.state = Object.assign(_this2.state, { factorPairsLoaded: true });
                _this2.forceUpdate();
            }));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {}
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.state.factorPairsLoaded) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: "form-page settings-kilometers " + (this.state.editIx !== null ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: "content" },
                    _react2.default.createElement(
                        'div',
                        { className: "inner-content" },
                        _react2.default.createElement(
                            'table',
                            { className: 'data-table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'KM'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Faktor'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.state.KM !== null ? this.props.admin.kmFactors.concat(this.state.editIx === 'new/new' ? [{ KM: 'new', Faktor: 'new' }] : []).map(function (factorPair) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: factorPair.KM + '/' + factorPair.Faktor, id: 'row-' + factorPair.KM + '-' + factorPair.Faktor },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this3.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                                name: 'KM', id: 'KM', value: _this3.state.KM,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: _this3.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this3.fields[0] = instance;
                                                }
                                            }) : factorPair.KM.toString()
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this3.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.float, placeholder: '', className: 'field100', containerClassName: 'display-inline-block',
                                                name: 'Faktor', id: 'Faktor', value: _this3.state.Faktor,
                                                autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: _this3.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this3.fields[1] = instance;
                                                }
                                            }) : factorPair.Faktor.toString().replace('.', ',')
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _this3.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem pr\xE6mie', onClick: _this3.saveRow }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this3.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this3.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                                    if (_this3.state.editIx === null) {
                                                        _this3.props.setAllowNew(false);
                                                        _this3.setState({
                                                            KM: factorPair.KM.toString(),
                                                            Faktor: factorPair.Faktor.toString().replace('.', ','),
                                                            oldKM: factorPair.KM,
                                                            editIx: factorPair.KM + '/' + factorPair.Faktor
                                                        });
                                                    }
                                                } }), _react2.default.createElement('i', { key: 1,
                                                className: "fa fa-trash " + (_this3.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet pr\xE6mie', onClick: function onClick() {
                                                    if (_this3.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette faktoren for ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            factorPair.KM,
                                                            ' KM'
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this3.props.dispatch(AdminActions.deleteKilometer(factorPair.KM, function () {
                                                            _reactNotifications.NotificationManager.success('Till\xE6g for ' + factorPair.KM + ' KM er slettet.', "Sletning", 4000);
                                                        }));
                                                    });
                                                } })]
                                        )
                                    );
                                }) : null
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SettingsKilometers;
}(_react2.default.Component);

SettingsKilometers.propTypes = {
    section: _propTypes2.default.object.isRequired,
    sectionNo: _propTypes2.default.string.isRequired,
    editMode: _propTypes2.default.bool.isRequired,
    isDDB: _propTypes2.default.bool.isRequired,
    isSection: _propTypes2.default.bool.isRequired,
    isClub: _propTypes2.default.bool.isRequired,
    setAllowNew: _propTypes2.default.func.isRequired
};
SettingsKilometers.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            kmFactors: state.admin.kmFactors
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(SettingsKilometers);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(19);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _lib = __webpack_require__(18);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChampionshipsPage = function (_React$Component) {
    _inherits(ChampionshipsPage, _React$Component);

    _createClass(ChampionshipsPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_CHAMPIONSHIPS;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function ChampionshipsPage(props) {
        _classCallCheck(this, ChampionshipsPage);

        var _this = _possibleConstructorReturn(this, (ChampionshipsPage.__proto__ || Object.getPrototypeOf(ChampionshipsPage)).call(this, props));

        _this.timeoutHandler = null;

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.state = {
            filter: '',
            sort: 'Nr'
        };
        return _this;
    }

    _createClass(ChampionshipsPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(AdminActions.getChampionships());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.admin.isChampionshipsRead ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Mesterskaber'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'table',
                        { className: 'data-table championships-overview' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    { scope: 'row', className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Nr' });
                                        } },
                                    'Kode'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Titel' });
                                        } },
                                    'Navn'
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sektionsgrupper'
                                ) : null,
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sektioner'
                                ) : null,
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'th',
                                    null,
                                    'Omr\xE5der'
                                ) : null,
                                _react2.default.createElement(
                                    'th',
                                    { className: 'clickable', onClick: function onClick() {
                                            _this2.setState({ sort: 'Type' });
                                        } },
                                    'Type'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Pointsystem'
                                ),
                                _react2.default.createElement('th', null),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Lag'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Juniorer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Begyndere'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sportsduer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Markerede'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'DM-duer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Kun markering'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    '\xC5rgang'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Duer pr slag'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Procent duer'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Antal flyvn.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Landsflyvn.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Maks'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Langflyvn.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Maks.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Mellemflyvn.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Maks.'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Diplomer'
                                ),
                                _react2.default.createElement('th', { className: 'sticky-actions-head' })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.admin.championships.filter(function (c) {
                                return _this2.state.filter === '' ? true : (0, _lib.nullToBlank)(c.Nr).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(c.Titel).toUpperCase().search(_this2.state.filter) >= 0 || (0, _lib.nullToBlank)(c.Type).toUpperCase().search(_this2.state.filter) >= 0;
                            }).sort(function (c1, c2) {
                                if (c1.Nr === null) return 1;
                                if (c2.Nr === null) return -1;
                                var comp = (c1[_this2.state.sort] === null ? '' : c1[_this2.state.sort].trim()).localeCompare(c2[_this2.state.sort] === null ? '' : c2[_this2.state.sort].trim(), 'da-DK');
                                return comp === 0 ? c1.Nr < c2.Nr ? -1 : c1.Nr > c2.Nr ? 1 : 0 : comp;
                            }).toArray().map(function (championship) {
                                var sections = (0, _lib.CompressList)(championship.Sektioner);
                                var groups = (0, _lib.CompressList)(championship.Sektionsgrupper);

                                return _react2.default.createElement(
                                    'tr',
                                    { key: championship.RecNr, className: "", onDoubleClick: function onDoubleClick() {
                                            _this2.props.dispatch((0, _reactRouterRedux.push)(_routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        } },
                                    _react2.default.createElement(
                                        'th',
                                        { scope: 'row' },
                                        championship.Nr
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Titel
                                    ),
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'td',
                                        null,
                                        groups.items.join(',')
                                    ) : null,
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'td',
                                        null,
                                        sections.items.join(',')
                                    ) : null,
                                    _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Omraader
                                    ) : null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Type
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Pointsystem
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Pointsystem2
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.LagMellem
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'boolean' },
                                        championship.KunJuniorer ? 'X' : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'boolean' },
                                        championship.KunBegyndere ? 'X' : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'boolean' },
                                        championship.KunSportsduer ? 'X' : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'boolean' },
                                        championship.KunDuemarkerede ? 'X' : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { className: 'boolean' },
                                        championship.KunDmDuer ? 'X' : null
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Foreningsmarkering1
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Aargang
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.AntalDuerPrSlag
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.MinPlacKoefficient
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.AntalFlyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.MinAntal91Flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Antal91Flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.MinAntal_L_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Antal_L_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.MinAntal_M_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.Antal_M_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        championship.AntalDiplomer
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'sticky-actions' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'actions-container' },
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { to: _routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'view'), title: 'Vis detaljer' },
                                                _react2.default.createElement('i', { className: 'fa fa-file-text-o' })
                                            ),
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { to: _routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'edit'), title: 'Rediger forening' },
                                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
                                            ),
                                            _react2.default.createElement('i', { className: "fa fa-trash pointer clickable", title: 'Slet forening', onClick: function onClick() {
                                                    (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        '\xD8nsker du at slette mesterskabet ',
                                                        _react2.default.createElement(
                                                            'b',
                                                            null,
                                                            championship.Titel,
                                                            ' (',
                                                            championship.Nr,
                                                            ')'
                                                        ),
                                                        '?'
                                                    ), function () {
                                                        _this2.props.dispatch(AdminActions.deleteChampionship(championship.RecNr, function () {
                                                            _reactNotifications.NotificationManager.success("Mesterskaber " + championship.Nr + " (" + championship.Titel + ") er slettet.", "Sletning", 4000);
                                                        }));
                                                    });
                                                } })
                                        )
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { className: "btn-primary", to: _routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', 'new').replace(':subpage', 'general').replace(':mode', 'create'), title: 'Opret nyt mesterskab' },
                        'Ny'
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'filter' },
                        'Filter'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: 'Indtast s\xF8gev\xE6rdi', className: 'field-1 large-field',
                        name: 'filter', id: 'filter',
                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: function onChange(e) {
                            var val = e.target.value.toUpperCase();
                            //this.onStandardFieldChange(e);
                            if (_this2.timeoutHandler !== null) clearTimeout(_this2.timeoutHandler);
                            _this2.timeoutHandler = setTimeout(function () {
                                _this2.setState({ filter: val });
                            }, 500);
                        }
                    }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort' },
                        'Sortering'
                    ),
                    _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field-1 large-field',
                        name: 'sort', id: 'sort', value: this.state.sort, options: [{ key: 'Nr', value: 'Kode' }, { key: 'Titel', value: 'Navn' }, { key: 'Type', value: 'Type' }],
                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                        onChange: this.onStandardFieldChange
                    })
                )
            ) : null;
        }
    }]);

    return ChampionshipsPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            isChampionshipsRead: state.admin.isChampionshipsRead,
            championships: state.admin.championships
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ChampionshipsPage);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(19);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _reactNotifications = __webpack_require__(8);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

var _routeconstants = __webpack_require__(11);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _confirmDialog = __webpack_require__(12);

var _Util = __webpack_require__(62);

var _arrayUtil = __webpack_require__(387);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _ChampionshipGeneral = __webpack_require__(840);

var _ChampionshipGeneral2 = _interopRequireDefault(_ChampionshipGeneral);

var _ChampionshipRaces = __webpack_require__(841);

var _ChampionshipRaces2 = _interopRequireDefault(_ChampionshipRaces);

var _ChampionshipPigeons = __webpack_require__(842);

var _ChampionshipPigeons2 = _interopRequireDefault(_ChampionshipPigeons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChampionshipPage = function (_React$Component) {
    _inherits(ChampionshipPage, _React$Component);

    _createClass(ChampionshipPage, null, [{
        key: 'getId',
        value: function getId() {
            return _routeconstants.ROUTE_CHAMPIONSHIP;
        }
    }, {
        key: 'getAllowedRoles',
        value: function getAllowedRoles() {
            return [_UserRoles2.default.MAIN_ADMIN, _UserRoles2.default.SECTION_ADMIN, _UserRoles2.default.CLUB_ADMIN]; // empty means allowed for all
        }
    }]);

    function ChampionshipPage(props) {
        _classCallCheck(this, ChampionshipPage);

        var _this = _possibleConstructorReturn(this, (ChampionshipPage.__proto__ || Object.getPrototypeOf(ChampionshipPage)).call(this, props));

        _this.loadChampionship = function (newestProps) {
            if (newestProps.params.championshipNo.toLowerCase() !== 'new') newestProps.dispatch(AdminActions.getChampionship(newestProps.params.championshipNo, function () {
                _this.forceUpdate();
            }));
        };

        _this.subForm = null;
        _this.fields = [];

        _this.allInputValid = function () {
            //return true;
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.championshipRacesButtonSuccess = function (type) {
            var string = type === 0 ? 'langdistance' : type === 1 ? 'mellemdistance (sport)' : type === 2 ? 'mellemdistance (åben)' : type === 3 ? 'mellem- og langdistance' : 'alle';
            _reactNotifications.NotificationManager.success('Kapflyvningerne i mesterskabet er opdateret med ' + string + ' kapflyvninger', "Opdatering", 4000);
        };

        _this.saveDistZone = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Titel: _this.state.zoneTitel === '' ? null : _this.state.zoneTitel,
                    Fra: _this.state.zoneFra === '' ? null : Number(_this.state.zoneFra),
                    Til: _this.state.zoneTil === '' ? null : Number(_this.state.zoneTil)
                };
                if (_this.state.editId === 'new') _this.props.dispatch(AdminActions.createChampionshipDistZone(_this.props.params.championshipNo, entity, function () {
                    _reactNotifications.NotificationManager.success("Afstandszonen er oprettet.", "Oprettelse", 4000);
                    _this.setState({ editId: null });
                }));else _this.props.dispatch(AdminActions.updateChampionshipDistZone(_this.props.params.championshipNo, _this.state.editId, entity, function () {
                    _reactNotifications.NotificationManager.success("Afstandszonen er opdateret.", "Opdatering", 4000);
                    _this.setState({ editId: null });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = {
            editId: null
        };
        return _this;
    }

    _createClass(ChampionshipPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadChampionship(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.params.championshipNo !== this.props.params.championshipNo) this.loadChampionship(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var disabled = this.props.params.subpage === 'dist-zones' && this.state.editId !== null;

            // Get club from Redux state.
            var championshipNo = this.props.params.championshipNo;
            var championship = championshipNo.toLowerCase() === 'new' || !this.props.admin.championships ? null : this.props.admin.championships.get(Number(championshipNo)) || null;
            if (championshipNo.toLowerCase() !== 'new' && (championship === null || typeof championship.isFullLoaded === 'undefined')) return null;

            var subPage = null;
            switch (this.props.params.subpage) {
                case 'general':
                    subPage = _react2.default.createElement(_ChampionshipGeneral2.default, { championship: championship, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'races':
                    subPage = _react2.default.createElement(_ChampionshipRaces2.default, { championship: championship, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'pigeons':
                    subPage = _react2.default.createElement(_ChampionshipPigeons2.default, { championship: championship, editMode: this.props.params.mode === 'edit' || this.props.params.mode === 'create', ref: function ref(instance) {
                            _this2.subForm = instance;
                        } });
                    break;
                case 'dist-zones':
                    subPage = _react2.default.createElement(
                        'table',
                        { className: 'data-table championship-dist-zones' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Titel'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Fra'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Til'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            championship === null ? [] : championship.MesterskabAfstZones.sort(function (z1, z2) {
                                if (z1.Zone < z2.Zone) return -1;
                                if (z1.Zone > z2.Zone) return 1;
                                if (z1.Fra === null && z2.Fra !== null) return -1;
                                if (z1.Fra !== null && z2.Fra === null) return 1;
                                if (z1.Fra !== null && z2.Fra !== null && z1.Fra < z2.Fra) return -1;
                                if (z1.Fra !== null && z2.Fra !== null && z1.Fra > z2.Fra) return 1;
                                if (z1.Til === null && z2.Til !== null) return -1;
                                if (z1.Til !== null && z2.Til === null) return 1;
                                if (z1.Til !== null && z2.Til !== null && z1.Til < z2.Til) return -1;
                                if (z1.Til !== null && z2.Til !== null && z1.Til > z2.Til) return 1;
                                if (z1.Titel === null && z2.Titel !== null) return -1;
                                if (z1.Titel !== null && z2.Titel === null) return 1;
                                if (z1.Titel !== null && z2.Titel !== null && z1.Titel < z2.Titel) return -1;
                                if (z1.Titel !== null && z2.Titel !== null && z1.Titel > z2.Titel) return 1;
                                return 0;
                            }).concat(this.state.editId === 'new' ? [{ Zone: 'new' }] : []).map(function (zone, ix) {
                                if (_this2.state.editId === null || zone.Zone !== _this2.state.editId) return _react2.default.createElement(
                                    'tr',
                                    { key: ix, id: 'row-' + zone.Zone },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        zone.Titel === null ? '' : zone.Titel
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        zone.Fra === null ? '' : zone.Fra
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        zone.Til === null ? '' : zone.Til
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement('i', { className: "fa fa-pencil " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Rediger afstandszone', onClick: function onClick() {
                                                if (_this2.state.editId === null) {
                                                    _this2.setState({
                                                        editId: zone.Zone,
                                                        zoneTitel: zone.Titel === null ? '' : zone.Titel,
                                                        zoneFra: zone.Fra === null ? '' : String(zone.Fra),
                                                        zoneTil: zone.Til === null ? '' : String(zone.Til)
                                                    });
                                                }
                                            } }),
                                        _react2.default.createElement('i', { className: "fa fa-trash " + (_this2.state.editId === null ? 'clickable' : 'disabled'), title: 'Slet afstandszone', onClick: function onClick() {
                                                if (_this2.state.editId === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    '\xD8nsker du at slette afstandszonen ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        zone.Titel
                                                    ),
                                                    '?'
                                                ), function () {
                                                    _this2.props.dispatch(AdminActions.deleteChampionshipDistZone(_this2.props.params.championshipNo, zone.Zone, function () {
                                                        _reactNotifications.NotificationManager.success("Afstandszonen er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            } })
                                    )
                                );else return _react2.default.createElement(
                                    'tr',
                                    { key: ix },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field200', containerClassName: 'display-inline-block',
                                            name: 'zoneTitel', id: 'zoneTitel', maxLength: '20', value: _this2.state.zoneTitel,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[10] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                            name: 'zoneFra', id: 'zoneFra', maxLength: '5', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,5}" }], value: _this2.state.zoneFra,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[11] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field75', containerClassName: 'display-inline-block',
                                            name: 'zoneTil', id: 'zoneTil', maxLength: '5', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,5}" }], value: _this2.state.zoneTil,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: _this2.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[12] = instance;
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        _react2.default.createElement('i', { className: 'fa fa-save clickable', title: 'Gem afstandszone', onClick: function onClick() {
                                                _this2.saveDistZone();
                                            } }),
                                        _react2.default.createElement('i', { className: 'fa fa-undo clickable', title: 'Annuller', onClick: function onClick() {
                                                _this2.setState({ editId: null });
                                            } })
                                    )
                                );
                            })
                        )
                    );
                    break;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-title' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        championshipNo.toLowerCase() === 'new' ? 'Nyt mesterskab' : 'Mesterskab ' + championship.Nr + ' - ' + championship.Titel
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-list' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "general").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Generelt'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'races' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "races").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Kapflyvninger'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'pigeons' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "pigeons").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Deltagende duer'
                            )
                        ),
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: this.props.params.subpage === 'dist-zones' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !disabled ? '' : ' disabled'), to: this.props.params.mode === 'view' && !disabled ? _routeconstants.ROUTE_CHAMPIONSHIP.replace(":championshipNo", championshipNo).replace(":subpage", "dist-zones").replace(":mode", "view") : '' },
                            _react2.default.createElement(
                                'span',
                                { className: 'tab-text' },
                                'Afstandszoner'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-page', id: 'sub-page-content' },
                        subPage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sub-page-actions' },
                    this.props.params.mode === 'view' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        this.props.params.subpage === 'general' ? [_react2.default.createElement(
                            'button',
                            { key: 0, className: 'btn-primary', title: 'Rediger forening', onClick: function onClick() {
                                    _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'edit')));
                                } },
                            'Rediger'
                        ), _react2.default.createElement(
                            'button',
                            { key: 1, className: 'btn-primary', title: 'Opdater kapflyvn.', disabled: this.props.params.mode === 'edit', onClick: function onClick() {
                                    if (_this2.props.params.mode !== 'edit') (0, _confirmDialog.confirm)("Opdater kapflyvninger", _react2.default.createElement(
                                        'span',
                                        null,
                                        '\xD8nsker du at overf\xF8re indstillingerne til kapflyvningerne i mesterskabet?'
                                    ), function () {
                                        _this2.props.dispatch(AdminActions.updateChampionshipRaces(championshipNo, function () {
                                            _reactNotifications.NotificationManager.success('Kapflyvningerne i mesterskaber er opdateret', "Opdatering", 4000);
                                        }));
                                    });
                                } },
                            'Opdater kapflyvn.'
                        )] : null,
                        this.props.params.subpage === 'races' ? [_react2.default.createElement(
                            'button',
                            { key: 0, className: 'btn-primary', title: 'Generer. langdist', onClick: function onClick() {
                                    _this2.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 0, function () {
                                        return _this2.championshipRacesButtonSuccess(0);
                                    }));
                                } },
                            'Generer. langdist'
                        ), _react2.default.createElement(
                            'button',
                            { key: 1, className: 'btn-primary', title: 'Mellemdist, (sport)', onClick: function onClick() {
                                    _this2.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 1, function () {
                                        return _this2.championshipRacesButtonSuccess(1);
                                    }));
                                } },
                            'Mellemdist, (sport)'
                        ), _react2.default.createElement(
                            'button',
                            { key: 2, className: 'btn-primary', title: 'Mellemdist, (\xE5ben)', onClick: function onClick() {
                                    _this2.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 2, function () {
                                        return _this2.championshipRacesButtonSuccess(2);
                                    }));
                                } },
                            'Mellemdist, (\xE5ben)'
                        ), _react2.default.createElement(
                            'button',
                            { key: 3, className: 'btn-primary', title: 'Generer jun./beg.', onClick: function onClick() {
                                    _this2.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 3, function () {
                                        return _this2.championshipRacesButtonSuccess(3);
                                    }));
                                } },
                            'Generer jun./beg.'
                        ), _react2.default.createElement(
                            'button',
                            { key: 4, className: 'btn-primary', title: 'Tilf\xF8j alle kapfl.', onClick: function onClick() {
                                    _this2.props.dispatch(AdminActions.createChampionshipRaces(championshipNo, 4, function () {
                                        return _this2.championshipRacesButtonSuccess(4);
                                    }));
                                } },
                            'Tilf\xF8j alle kapfl.'
                        )] : null,
                        this.props.params.subpage === 'dist-zones' ? _react2.default.createElement(
                            'button',
                            { className: "btn-primary" + (this.state.editId === null ? '' : ' disabled'), title: 'Opret ny ringserie', onClick: function onClick() {
                                    if (_this2.state.editId === null) {
                                        _this2.setState({
                                            editId: 'new',
                                            zoneTitel: '',
                                            zoneFra: '',
                                            zoneTil: ''
                                        });
                                        setTimeout(function () {
                                            var content = document.getElementById("sub-page-content");
                                            content.scrollTop = content.scrollHeight;
                                        });
                                    }
                                } },
                            'Ny'
                        ) : null
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { className: "btn-primary" + (disabled ? ' disabled' : ''), to: disabled ? '' : _routeconstants.ROUTE_CHAMPIONSHIPS, title: 'Vis alle mesterskaber' },
                            'Mesterskaber'
                        )
                    )] : this.props.params.subpage !== 'races' ? [_react2.default.createElement(
                        'span',
                        { className: 'left-buttons', key: 'left' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-primary', title: 'Gem \xE6ndringer', onClick: function onClick() {
                                    _this2.subForm.getWrappedInstance().save(function (championshipNo) {
                                        _reactNotifications.NotificationManager.success(_this2.props.params.championshipNo.toLowerCase() === 'new' ? "Mesterskabet er oprettet" : "Mesterskabet er opdateret.", _this2.props.params.championshipNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                        _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                    });
                                } },
                            'Gem'
                        )
                    ), _react2.default.createElement(
                        'span',
                        { className: 'right-buttons', key: 'right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn-secondary', title: 'Annuller \xE6ndringer', onClick: function onClick() {
                                    if (championshipNo.toLowerCase() === 'new') _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CHAMPIONSHIPS));else _this2.props.dispatch((0, _reactRouterRedux.replace)(_routeconstants.ROUTE_CHAMPIONSHIP.replace(':championshipNo', championshipNo).replace(':subpage', _this2.props.params.subpage).replace(':mode', 'view')));
                                } },
                            'Annuller'
                        )
                    )] : null
                )
            );
        }
    }]);

    return ChampionshipPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        admin: {
            championships: state.admin.championships
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ChampionshipPage);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _lib = __webpack_require__(18);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Nr: '',
    Sektionsgrupper: '',
    Sektioner: '',
    Titel: '',
    Omraader: '',
    Type: 'Point',
    Pointsystem: 'Land',
    Pointsystem2: '1000-point',
    LagMellem: '',
    Foreningsmarkering1: '',
    KunSportsduer: 0,
    KunDuemarkerede: 0,
    KunDmDuer: 0,
    KunJuniorer: 0,
    KunBegyndere: 0,
    AntalDuerPrSlag: '',
    MinPlacKoefficient: '',
    AntalFlyvninger: '',
    MinAntal91Flyvninger: '',
    Antal91Flyvninger: '',
    MinAntal_L_flyvninger: '',
    Antal_L_flyvninger: '',
    MinAntal_M_flyvninger: '',
    Antal_M_flyvninger: '',
    Aargang: '',
    AntalDiplomer: '',
    // The four attributes below are only relevant when Type = 'National cup'
    MinAntalDuer: '',
    Tillaeg_1afs_1hjem: '',
    Tillaeg_2afs_1hjem: '',
    Tillaeg_2afs_2hjem: ''
};

var ChampionshipGeneral = function (_React$Component) {
    _inherits(ChampionshipGeneral, _React$Component);

    function ChampionshipGeneral(props) {
        _classCallCheck(this, ChampionshipGeneral);

        var _this = _possibleConstructorReturn(this, (ChampionshipGeneral.__proto__ || Object.getPrototypeOf(ChampionshipGeneral)).call(this, props));

        _this.isListError = function (txt) {
            var validateItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var items = (0, _lib.SimpleList)(txt, false, validateItem);
            return items.isErrors;
        };

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onSectionFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, (0, _lib.removeCommaWhitespace)(e.target.value)));
        };

        _this.onCheckboxClick = function (e) {
            _this.setState(_defineProperty({}, e.target.name, e.target.checked ? 1 : 0));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            var onSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (_this.allInputValid()) {
                var entity = {
                    Nr: _this.state.Nr === '' ? null : _this.state.Nr,
                    Sektionsgrupper: _this.state.Sektionsgrupper === '' ? null : (0, _lib.SimpleList)(_this.state.Sektionsgrupper).items.join(','),
                    Sektioner: _this.state.Sektioner === '' ? null : (0, _lib.SimpleList)(_this.state.Sektioner).items.join(','),
                    Titel: _this.state.Titel === '' ? null : _this.state.Titel,
                    Omraader: _this.state.Omraader === '' ? null : (0, _lib.removeCommaWhitespace)(_this.state.Omraader),
                    Type: _this.state.Type === '' ? null : _this.state.Type,
                    Pointsystem: _this.state.Pointsystem === '' ? null : _this.state.Pointsystem,
                    Pointsystem2: _this.state.Pointsystem2 === '' ? null : _this.state.Pointsystem2,
                    LagMellem: _this.state.LagMellem === '' ? null : _this.state.LagMellem,
                    Foreningsmarkering1: _this.state.Foreningsmarkering1 === '' ? null : _this.state.Foreningsmarkering1,
                    KunSportsduer: _this.state.KunSportsduer === '' ? null : _this.state.KunSportsduer,
                    KunDuemarkerede: _this.state.KunDuemarkerede === '' ? null : _this.state.KunDuemarkerede,
                    KunDmDuer: _this.state.KunDmDuer === '' ? null : _this.state.KunDmDuer,
                    KunJuniorer: _this.state.KunJuniorer === '' ? null : _this.state.KunJuniorer,
                    KunBegyndere: _this.state.KunBegyndere === '' ? null : _this.state.KunBegyndere,
                    AntalDuerPrSlag: _this.state.AntalDuerPrSlag === '' ? null : Number(_this.state.AntalDuerPrSlag),
                    MinPlacKoefficient: _this.state.MinPlacKoefficient === '' ? null : Number(_this.state.MinPlacKoefficient),
                    AntalFlyvninger: _this.state.AntalFlyvninger === '' ? null : Number(_this.state.AntalFlyvninger),
                    MinAntal91Flyvninger: _this.state.MinAntal91Flyvninger === '' ? null : Number(_this.state.MinAntal91Flyvninger),
                    Antal91Flyvninger: _this.state.Antal91Flyvninger === '' ? null : Number(_this.state.Antal91Flyvninger),
                    MinAntal_L_flyvninger: _this.state.MinAntal_L_flyvninger === '' ? null : Number(_this.state.MinAntal_L_flyvninger),
                    Antal_L_flyvninger: _this.state.Antal_L_flyvninger === '' ? null : Number(_this.state.Antal_L_flyvninger),
                    MinAntal_M_flyvninger: _this.state.MinAntal_M_flyvninger === '' ? null : Number(_this.state.MinAntal_M_flyvninger),
                    Antal_M_flyvninger: _this.state.Antal_M_flyvninger === '' ? null : Number(_this.state.Antal_M_flyvninger),
                    Aargang: _this.state.Aargang === '' ? null : _this.state.Aargang,
                    AntalDiplomer: _this.state.AntalDiplomer === '' ? null : Number(_this.state.AntalDiplomer)
                };
                if (_this.state.Type === 'National cup') {
                    entity.MinAntalDuer = _this.state.MinAntalDuer === '' ? null : Number(_this.state.MinAntalDuer);
                    entity.Tillaeg_1afs_1hjem = _this.state.Tillaeg_1afs_1hjem === '' ? null : Number(_this.state.Tillaeg_1afs_1hjem);
                    entity.Tillaeg_2afs_1hjem = _this.state.Tillaeg_2afs_1hjem === '' ? null : Number(_this.state.Tillaeg_2afs_1hjem);
                    entity.Tillaeg_2afs_2hjem = _this.state.Tillaeg_2afs_2hjem === '' ? null : Number(_this.state.Tillaeg_2afs_2hjem);
                }
                if (_this.props.championship === null) _this.props.dispatch(AdminActions.createChampionship(entity, onSuccess));else _this.props.dispatch(AdminActions.updateChampionship(_this.props.championship.RecNr, entity, onSuccess));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = Object.assign({}, _this.getStateFromStore(props));
        return _this;
    }

    _createClass(ChampionshipGeneral, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.championship === null && this.props.championship !== null || nextProps.championship !== null && (this.props.championship === null || this.props.championship.RecNr !== nextProps.championship.RecNr)) this.setState(this.getStateFromStore(nextProps));
        }
    }, {
        key: 'getStateFromStore',
        value: function getStateFromStore(props) {
            if (props.championship === null) {
                return Object.assign(defaultState, this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? {} : { Pointsystem: 'Sektion' });
            } else {
                var championship = props.championship;
                var groups = (0, _lib.CompressList)(championship.Sektionsgrupper);
                var sections = (0, _lib.CompressList)(championship.Sektioner);
                return {
                    Nr: championship.Nr === null ? '' : championship.Nr,
                    Sektionsgrupper: groups.items.join(','),
                    Sektioner: sections.items.join(','),
                    Titel: championship.Titel === null ? '' : championship.Titel,
                    Omraader: championship.Omraader === null ? '' : championship.Omraader,
                    Type: championship.Type === null ? '' : championship.Type,
                    Pointsystem: championship.Pointsystem === null ? '' : championship.Pointsystem,
                    Pointsystem2: championship.Pointsystem2 === null ? '' : championship.Pointsystem2,
                    LagMellem: championship.LagMellem === null ? '' : championship.LagMellem,
                    Foreningsmarkering1: championship.Foreningsmarkering1 === null ? '' : championship.Foreningsmarkering1,
                    KunSportsduer: championship.KunSportsduer === null ? '' : championship.KunSportsduer,
                    KunDuemarkerede: championship.KunDuemarkerede === null ? '' : championship.KunDuemarkerede,
                    KunDmDuer: championship.KunDmDuer === null ? '' : championship.KunDmDuer,
                    KunJuniorer: championship.KunJuniorer === null ? '' : championship.KunJuniorer,
                    KunBegyndere: championship.KunBegyndere === null ? '' : championship.KunBegyndere,
                    AntalDuerPrSlag: championship.AntalDuerPrSlag === null ? '' : championship.AntalDuerPrSlag.toString(),
                    MinPlacKoefficient: championship.MinPlacKoefficient === null ? '' : championship.MinPlacKoefficient.toString(),
                    AntalFlyvninger: championship.AntalFlyvninger === null ? '' : championship.AntalFlyvninger.toString(),
                    MinAntal91Flyvninger: championship.MinAntal91Flyvninger === null ? '' : championship.MinAntal91Flyvninger.toString(),
                    Antal91Flyvninger: championship.Antal91Flyvninger === null ? '' : championship.Antal91Flyvninger.toString(),
                    MinAntal_L_flyvninger: championship.MinAntal_L_flyvninger === null ? '' : championship.MinAntal_L_flyvninger.toString(),
                    Antal_L_flyvninger: championship.Antal_L_flyvninger === null ? '' : championship.Antal_L_flyvninger.toString(),
                    MinAntal_M_flyvninger: championship.MinAntal_M_flyvninger === null ? '' : championship.MinAntal_M_flyvninger.toString(),
                    Antal_M_flyvninger: championship.Antal_M_flyvninger === null ? '' : championship.Antal_M_flyvninger.toString(),
                    Aargang: championship.Aargang === null ? '' : championship.Aargang,
                    AntalDiplomer: championship.AntalDiplomer === null ? '' : championship.AntalDiplomer.toString(),
                    // The four attributes below are only relevant when Type = 'National cup'
                    MinAntalDuer: championship.MinAntalDuer === null ? '' : championship.MinAntalDuer.toString(),
                    Tillaeg_1afs_1hjem: championship.Tillaeg_1afs_1hjem === null ? '' : championship.Tillaeg_1afs_1hjem.toString(),
                    Tillaeg_2afs_1hjem: championship.Tillaeg_2afs_1hjem === null ? '' : championship.Tillaeg_2afs_1hjem.toString(),
                    Tillaeg_2afs_2hjem: championship.Tillaeg_2afs_2hjem === null ? '' : championship.Tillaeg_2afs_2hjem.toString()
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editMode;

            var sections = (0, _lib.CompressList)(this.state.Sektioner);
            var groups = (0, _lib.CompressList)(this.state.Sektionsgrupper);

            return _react2.default.createElement(
                'div',
                { className: "form-page championship-basics championship-general " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'block-content' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'header' },
                                'Pointsberegningssystem'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'basics' },
                            _react2.default.createElement(
                                'div',
                                { className: 'basics-left' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Kode'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 1,
                                        name: 'Nr', id: 'Nr', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{3}" }], value: this.state.Nr,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[0] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Nr
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Sek.grupper'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 field125', containerClassName: 'display-inline-block', tabIndex: 2,
                                        name: 'Sektionsgrupper', id: 'Sektionsgrupper', maxLength: '25', value: this.state.Sektionsgrupper,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        isError: this.isListError(this.state.Sektionsgrupper, function (group) {
                                            return group.length === 1;
                                        }),
                                        errorMessageOverride: 'Ugyldigt format. Indtast sektionsgrupper adskilt med komma.',
                                        onChange: this.onStandardFieldChange,
                                        onBlur: function onBlur() {
                                            _this2.fields[1].setState({ focused: false, visited: true });
                                            var groups = (0, _lib.SimpleList)(_this2.state.Sektionsgrupper, false, function (group) {
                                                return group.length === 1;
                                            });
                                            if (!groups.isErrors) _this2.setState({
                                                Sektionsgrupper: (0, _lib.CompressList)(groups.items.join(',')).items.join(',')
                                            });
                                        },
                                        ref: function ref(instance) {
                                            _this2.fields[1] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Sektionsgrupper
                                    )
                                ) : null
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'basics-right' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Titel'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 field450', containerClassName: 'display-inline-block', tabIndex: 1,
                                        name: 'Titel', id: 'Titel', maxLength: '50', value: this.state.Titel,
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[2] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Titel
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'div',
                                    { className: 'basics-right-lower' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'attribute' },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Sektioner'
                                        ),
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 field125', containerClassName: 'display-inline-block', tabIndex: 2,
                                            name: 'Sektioner', id: 'Sektioner', maxLength: '25', value: this.state.Sektioner,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            isError: this.isListError(this.state.Sektioner, function (group) {
                                                return group.length === 2;
                                            }),
                                            errorMessageOverride: 'Ugyldigt format. Indtast sektioner adskilt med komma.',
                                            onChange: this.onStandardFieldChange,
                                            onBlur: function onBlur() {
                                                _this2.fields[3].setState({ focused: false, visited: true });
                                                var secions = (0, _lib.SimpleList)(_this2.state.Sektioner, false, function (section) {
                                                    return section.length === 2;
                                                });
                                                if (!secions.isErrors) _this2.setState({
                                                    Sektioner: (0, _lib.CompressList)(secions.items.join(',')).items.join(',')
                                                });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[3] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.Sektioner
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'attribute' },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Omr\xE5der'
                                        ),
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 field125', containerClassName: 'display-inline-block', tabIndex: 2,
                                            name: 'Omraader', id: 'Omraader', maxLength: '25', value: this.state.Omraader,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            onBlur: function onBlur() {
                                                _this2.fields[4].setState({ focused: false, visited: true });
                                                _this2.setState({
                                                    Omraader: _this2.state.Omraader.split(',').map(function (range) {
                                                        return range.trim();
                                                    }).join(',')
                                                });
                                            },
                                            ref: function ref(instance) {
                                                _this2.fields[4] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text' },
                                            this.state.Omraader
                                        )
                                    )
                                ) : null
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'block-content' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'header' },
                                'Deltagerkriterier'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'criterion' },
                            _react2.default.createElement(
                                'div',
                                { className: 'criterion-left' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Type'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field175', containerClassName: 'display-inline-block', tabIndex: 2,
                                        name: 'Type', id: 'Type', value: this.state.Type, options: [{ key: 'Point', value: 'Point' }, { key: 'Plac.koefficient', value: 'Plac.koefficient' }, { key: 'National cup', value: 'National cup' }, { key: 'Forening', value: 'Forening' }, { key: 'Due point', value: 'Due point' }, { key: 'Es-due-kilometer', value: 'Es-due-kilometer' }, { key: 'HB', value: 'HB' }, { key: 'Slag plac.koef.', value: 'Slag plac.koef.' }],
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[5] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Type
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Pointsystem'
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field175', containerClassName: 'display-inline-block', tabIndex: 2,
                                        name: 'Pointsystem', id: 'Pointsystem', value: this.state.Pointsystem, options: [{ key: 'Land', value: 'Land' }, { key: 'Gruppe', value: 'Gruppe' }, { key: 'Sektion', value: 'Sektion' }, { key: 'Område', value: 'Område' }, { key: 'Region', value: 'Region' }],
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[6] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text' },
                                        this.state.Pointsystem
                                    ) : editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field175', containerClassName: 'display-inline-block', tabIndex: 2,
                                        disabled: this.state.Type === 'Plac.koefficient' || this.state.Type === 'HB' || this.state.Type === 'Slag plac.koef.',
                                        name: 'Pointsystem2', id: 'Pointsystem2', value: this.state.Pointsystem2, options: [{ key: '1000-point', value: '1000-point' }, { key: 'Plac.point', value: 'Plac.point' }, { key: 'Plac.point U.M.', value: 'Plac.point U.M.' }, { key: 'Slag plac.point', value: 'Slag plac.point' }, { key: 'Slag sport plac.point', value: 'Slag sport plac.point' }],
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: "value-text" + (this.state.Type === 'Plac.koefficient' || this.state.Type === 'HB' || this.state.Type === 'Slag plac.koef.' ? ' disabled' : '') },
                                        this.state.Pointsystem2
                                    )
                                ),
                                this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement('label', { className: this.state.Type === 'Plac.koefficient' || this.state.Type === 'HB' || this.state.Type === 'Slag plac.koef.' ? 'disabled' : '' }),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.enum, placeholder: 'false', className: 'field175', containerClassName: 'display-inline-block', tabIndex: 2,
                                        disabled: this.state.Type === 'Plac.koefficient' || this.state.Type === 'HB' || this.state.Type === 'Slag plac.koef.',
                                        name: 'Pointsystem2', id: 'Pointsystem2', value: this.state.Pointsystem2, options: [{ key: '1000-point', value: '1000-point' }, { key: 'Plac.point', value: 'Plac.point' }, { key: 'Plac.point U.M.', value: 'Plac.point U.M.' }, { key: 'Slag plac.point', value: 'Slag plac.point' }, { key: 'Slag sport plac.point', value: 'Slag sport plac.point' }],
                                        autoCheckErrors: true, required: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[7] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: "value-text" + (this.state.Type === 'Plac.koefficient' || this.state.Type === 'HB' || this.state.Type === 'Slag plac.koef.' ? ' disabled' : '') },
                                        this.state.Pointsystem2
                                    )
                                ) : null,
                                this.state.Type === 'National cup' ? _react2.default.createElement(
                                    'div',
                                    { className: 'national-attributes' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'flex-gap90' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                'Antal duer'
                                            ),
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: 'MinAntalDuer', id: 'MinAntalDuer', value: this.state.MinAntalDuer,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[8] = instance;
                                                }
                                            }) : _react2.default.createElement(
                                                'span',
                                                { className: 'value-text very-small-field' },
                                                this.state.MinAntalDuer
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                '1 afs, 1 hjem'
                                            ),
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: 'Tillaeg_1afs_1hjem', id: 'Tillaeg_1afs_1hjem', value: this.state.Tillaeg_1afs_1hjem,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[9] = instance;
                                                }
                                            }) : _react2.default.createElement(
                                                'span',
                                                { className: 'value-text very-small-field' },
                                                this.state.Tillaeg_1afs_1hjem
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'flex-gap90' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                '2 afs, 1 hjem'
                                            ),
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: 'Tillaeg_2afs_1hjem', id: 'Tillaeg_2afs_1hjem', value: this.state.Tillaeg_2afs_1hjem,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[10] = instance;
                                                }
                                            }) : _react2.default.createElement(
                                                'span',
                                                { className: 'value-text very-small-field' },
                                                this.state.Tillaeg_2afs_1hjem
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                '2 afs, 2 hjem'
                                            ),
                                            editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                                name: 'Tillaeg_2afs_2hjem', id: 'Tillaeg_2afs_2hjem', value: this.state.Tillaeg_2afs_2hjem,
                                                autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                                onChange: this.onStandardFieldChange,
                                                ref: function ref(instance) {
                                                    _this2.fields[11] = instance;
                                                }
                                            }) : _react2.default.createElement(
                                                'span',
                                                { className: 'value-text very-small-field' },
                                                this.state.Tillaeg_2afs_2hjem
                                            )
                                        )
                                    )
                                ) : _react2.default.createElement('div', { className: 'no-national-attributes' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'flex-gap90' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'attribute' },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Markering'
                                        ),
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.string, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                            name: 'Foreningsmarkering1', id: 'Foreningsmarkering1', maxLength: '1', value: this.state.Foreningsmarkering1,
                                            autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[12] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text very-small-field' },
                                            this.state.Foreningsmarkering1
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'attribute' },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Lag'
                                        ),
                                        editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 2,
                                            name: 'LagMellem', id: 'LagMellem', maxLength: '1', value: this.state.LagMellem,
                                            autoCheckErrors: true, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                            onChange: this.onStandardFieldChange,
                                            ref: function ref(instance) {
                                                _this2.fields[13] = instance;
                                            }
                                        }) : _react2.default.createElement(
                                            'span',
                                            { className: 'value-text very-small-field' },
                                            this.state.LagMellem
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'booleans flex-gap100' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'boolean-column left' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute-boolean' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunSportsduer' },
                                                'Kun sportsduer'
                                            ),
                                            _react2.default.createElement('input', { id: 'KunSportsduer', name: 'KunSportsduer', type: 'checkbox', checked: this.state.KunSportsduer !== null && this.state.KunSportsduer !== 0, tabIndex: 2,
                                                disabled: !editMode, onChange: this.onCheckboxClick })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute-boolean' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunDmDuer' },
                                                'Kun DM-duer'
                                            ),
                                            _react2.default.createElement('input', { id: 'KunDmDuer', name: 'KunDmDuer', type: 'checkbox', checked: this.state.KunDmDuer !== null && this.state.KunDmDuer !== 0, tabIndex: 3,
                                                disabled: !editMode, onChange: this.onCheckboxClick })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute-boolean' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunJuniorer' },
                                                'Kun juniorer'
                                            ),
                                            _react2.default.createElement('input', { id: 'KunJuniorer', name: 'KunJuniorer', type: 'checkbox', checked: this.state.KunJuniorer !== null && this.state.KunJuniorer !== 0, tabIndex: 3,
                                                disabled: !editMode, onChange: this.onCheckboxClick })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'boolean-column right' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute-boolean' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunDuemarkerede' },
                                                'Kun markerede'
                                            ),
                                            _react2.default.createElement('input', { id: 'KunDuemarkerede', name: 'KunDuemarkerede', type: 'checkbox', checked: this.state.KunDuemarkerede !== null && this.state.KunDuemarkerede !== 0, tabIndex: 2,
                                                disabled: !editMode, onChange: this.onCheckboxClick })
                                        ),
                                        _react2.default.createElement('div', { className: 'attribute-boolean' }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'attribute-boolean' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'KunBegyndere' },
                                                'Kun begyndere'
                                            ),
                                            _react2.default.createElement('input', { id: 'KunBegyndere', name: 'KunBegyndere', type: 'checkbox', checked: this.state.KunBegyndere !== null && this.state.KunBegyndere !== 0, tabIndex: 3,
                                                disabled: !editMode, onChange: this.onCheckboxClick })
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'criterion-right' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? 'disabled' : '' },
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer',
                                        name: 'AntalDuerPrSlag', id: 'AntalDuerPrSlag', value: this.state.AntalDuerPrSlag,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[14] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: "value-text very-small-field" + (this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? ' disabled' : '') },
                                        this.state.AntalDuerPrSlag
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' + (this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? ' disabled' : '') },
                                        'due(r) pr. flyvning/slag'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        name: 'MinPlacKoefficient', id: 'MinPlacKoefficient', value: this.state.MinPlacKoefficient,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[15] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.MinPlacKoefficient
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' },
                                        'procent af afsendte duer'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: this.state.Type === 'National cup' ? 'disabled' : '' },
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'AntalFlyvninger', id: 'AntalFlyvninger', value: this.state.AntalFlyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[16] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.AntalFlyvninger
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        'kapflyvning(er) pr. ',
                                        this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? 'due' : 'slag'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: this.state.Type === 'National cup' ? 'disabled' : '' },
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'MinAntal91Flyvninger', id: 'MinAntal91Flyvninger', value: this.state.MinAntal91Flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[17] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.MinAntal91Flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'spacer' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        ' - '
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'Antal91Flyvninger', id: 'Antal91Flyvninger', value: this.state.Antal91Flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[18] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.Antal91Flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        'landsflyvning(er) pr. ',
                                        this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? 'due' : 'slag'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: this.state.Type === 'National cup' ? 'disabled' : '' },
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'MinAntal_L_flyvninger', id: 'MinAntal_L_flyvninger', value: this.state.MinAntal_L_flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[19] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.MinAntal_L_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'spacer' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        ' - '
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'Antal_L_flyvninger', id: 'Antal_L_flyvninger', value: this.state.Antal_L_flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[20] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.Antal_L_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        'langflyvning(er) pr. ',
                                        this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? 'due' : 'slag'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: this.state.Type === 'National cup' ? 'disabled' : '' },
                                        'Medtag'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'MinAntal_M_flyvninger', id: 'MinAntal_M_flyvninger', value: this.state.MinAntal_M_flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[21] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.MinAntal_M_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'spacer' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        ' - '
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.int, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        disabled: this.state.Type === 'National cup',
                                        name: 'Antal_M_flyvninger', id: 'Antal_M_flyvninger', value: this.state.Antal_M_flyvninger,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[22] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.Antal_M_flyvninger
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' + (this.state.Type === 'National cup' ? ' disabled' : '') },
                                        'mellemflyvning(er) pr. ',
                                        this.state.Type === 'Plac.koefficient' || this.state.Type === 'Due point' || this.state.Type === 'Es-due-kilometer' ? 'due' : 'slag'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Kun \xE5rgang'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        name: 'Aargang', id: 'Aargang', maxLength: '3', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{0,3}" }], value: this.state.Aargang,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[23] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.Aargang
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'criterion-ending-phrase' },
                                        'indg\xE5r'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'attribute' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'Antal diplomer'
                                    ),
                                    editMode ? _react2.default.createElement(_UserFieldElement2.default, { dataType: _UserFieldDataTypeEnum2.default.regex, placeholder: '', className: 'field-1 very-small-field', containerClassName: 'display-inline-block', tabIndex: 10,
                                        name: 'AntalDiplomer', id: 'AntalDiplomer', maxLength: '2', options: [{ key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}" }], value: this.state.AntalDiplomer,
                                        autoCheckErrors: true, required: false, hideErrWhenFocused: true, hideErrUntilFocused: true,
                                        onChange: this.onStandardFieldChange,
                                        ref: function ref(instance) {
                                            _this2.fields[24] = instance;
                                        }
                                    }) : _react2.default.createElement(
                                        'span',
                                        { className: 'value-text very-small-field' },
                                        this.state.AntalDiplomer
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ChampionshipGeneral;
}(_react2.default.Component);

ChampionshipGeneral.propTypes = {
    editMode: _propTypes2.default.bool,
    championship: _propTypes2.default.object
};
ChampionshipGeneral.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ChampionshipGeneral);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _lib = __webpack_require__(18);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Pointsystem: 'Land',
    KunSportsduer: 0,
    AntalDuerPrSlag: '',
    editIx: null
};

var ChampionshipRaces = function (_React$Component) {
    _inherits(ChampionshipRaces, _React$Component);

    function ChampionshipRaces(props) {
        _classCallCheck(this, ChampionshipRaces);

        var _this = _possibleConstructorReturn(this, (ChampionshipRaces.__proto__ || Object.getPrototypeOf(ChampionshipRaces)).call(this, props));

        _this.fields = [];

        _this.onStandardFieldChange = function (e) {
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, e.target.value));
        };

        _this.onCheckboxClick = function (e) {
            _this.setState(_defineProperty({}, e.target.name, e.target.checked ? 1 : 0));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.cancelEdit = function () {
            _this.setState(defaultState);
        };

        _this.saveRow = function (raceNo) {
            if (_this.allInputValid()) {
                var championship = _this.props.championship;
                var race = _this.props.race.races.get(raceNo);
                var station = _this.props.admin.stations.get(race.Station);
                var entity = {
                    Pointsystem: _this.state.Pointsystem === '' || _this.state.Pointsystem === null ? championship.Pointsystem : _this.state.Pointsystem,
                    KunSportsduer: _this.state.KunSportsduer === null ? championship.KunSportsduer : Number(_this.state.KunSportsduer),
                    AntalDuerPrSlag: _this.state.AntalDuerPrSlag === '' ? null : Number(_this.state.AntalDuerPrSlag)
                };
                _this.props.dispatch(AdminActions.updateChampionshipRace(championship.RecNr, raceNo, entity, function (entity) {
                    _reactNotifications.NotificationManager.success('Regler for mesterskabskapflyvningen ' + race.Uge + ' - ' + race.Farvekode + ' ' + station.Navn + ' er opdateret.', "Opdatering", 4000);
                    _this.setState({ editIx: null });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.state = defaultState;
        return _this;
    }

    _createClass(ChampionshipRaces, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch(RaceActions.getRaces());
            this.props.dispatch(AdminActions.getListItems('station'));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.championship === null && this.props.championship !== null || nextProps.championship !== null && (this.props.championship === null || this.props.championship.RecNr !== nextProps.championship.RecNr)) this.setState(defaultState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // To prevent calculations before races are read
            if (!this.props.race.isRacesRead || !this.props.admin.stations.size) return null;

            var editMode = this.props.editMode;

            var pickedRows = [];
            var unpickedRows = [];

            this.props.race.races.sort(function (r1, r2) {
                if (r1.Uge < r2.Uge) return -1;
                if (r1.Uge > r2.Uge) return 1;
                if (r1.Farvekode < r2.Farvekode) return -1;
                if (r1.Farvekode > r2.Farvekode) return 1;
                return 0;
            }).forEach(function (race) {
                var championshipRace = _this2.props.championship.Mesterskabsflyvnings.get(race.Nr);
                var station = _this2.props.admin.stations.get(race.Station);

                var sections = (0, _lib.CompressList)(race.Sektioner).items.join(',');
                var groups = (0, _lib.CompressList)(race.Sektionsgrupper).items.join(',');

                var sectionsString = race.Sektioner === '' || race.Sektioner === null ? null : ' Sektioner ' + sections;
                var sectionGroupsString = race.Sektionsgrupper === '' || race.Sektionsgrupper === null ? null : ' Grupper ' + groups;
                var raceString = race.Uge + ' - ' + race.Farvekode + ((0, _lib.isDefined)(station) ? ' (' + station.Navn + ')' : '') + (sectionsString === null ? '' : sectionsString) + (sectionGroupsString === null ? '' : sectionGroupsString);

                // if picked for championship
                if (championshipRace) {
                    pickedRows.push(_react2.default.createElement(
                        'tr',
                        { key: championshipRace.Kapflyvningsnr, id: 'picked-row-' + championshipRace.Kapflyvningsnr },
                        _react2.default.createElement(
                            'td',
                            null,
                            race.Uge
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            (0, _lib.removeNonDigits)(race.Farvekode)
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            race.LMU
                        ),
                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'td',
                            null,
                            race.Sektion
                        ) : null,
                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'td',
                            null,
                            groups
                        ) : null,
                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'td',
                            null,
                            sections
                        ) : null,
                        _react2.default.createElement(
                            'td',
                            null,
                            (0, _lib.isDefined)(station) ? station.Stationsnr + ' ' + station.Navn : ''
                        ),
                        _this2.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                            'td',
                            null,
                            _this2.state.editIx === championshipRace.Kapflyvningsnr ? _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.enum,
                                placeholder: 'false',
                                className: 'field175',
                                containerClassName: 'display-inline-block',
                                tabIndex: 1,
                                name: 'Pointsystem',
                                id: 'Pointsystem',
                                value: _this2.state.Pointsystem,
                                options: [{ key: 'Land', value: 'Land' }, { key: 'Gruppe', value: 'Gruppe' }, { key: 'Sektion', value: 'Sektion' }, { key: 'Område', value: 'Område' }, { key: 'Region', value: 'Region' }],
                                autoCheckErrors: true,
                                required: true,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: _this2.onStandardFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[0] = instance;
                                }

                            }) : championshipRace.Pointsystem
                        ) : null,
                        _react2.default.createElement(
                            'td',
                            { className: 'boolean' },
                            _this2.state.editIx === championshipRace.Kapflyvningsnr ? _react2.default.createElement('input', {
                                id: 'KunSportsduer',
                                name: 'KunSportsduer',
                                type: 'checkbox',
                                checked: _this2.state.KunSportsduer !== null && _this2.state.KunSportsduer !== 0,
                                onChange: _this2.onCheckboxClick
                            }) : championshipRace.KunSportsduer ? 'X' : ''
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _this2.state.editIx === championshipRace.Kapflyvningsnr ? _react2.default.createElement(_UserFieldElement2.default, {
                                dataType: _UserFieldDataTypeEnum2.default.int,
                                placeholder: '',
                                className: 'field-1 very-small-field',
                                containerClassName: 'display-inline-block',
                                name: 'AntalDuerPrSlag',
                                id: 'AntalDuerPrSlag',
                                value: _this2.state.AntalDuerPrSlag,
                                autoCheckErrors: true,
                                required: false,
                                hideErrWhenFocused: true,
                                hideErrUntilFocused: true,
                                onChange: _this2.onStandardFieldChange,
                                ref: function ref(instance) {
                                    _this2.fields[1] = instance;
                                }
                            }) : championshipRace.AntalDuerPrSlag === null ? '' : championshipRace.AntalDuerPrSlag
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _this2.state.editIx === championshipRace.Kapflyvningsnr ? [_react2.default.createElement('i', { key: 0, className: 'fa fa-save clickable', title: 'Gem kapflyvning', onClick: function onClick() {
                                    _this2.saveRow(championshipRace.Kapflyvningsnr);
                                } }), _react2.default.createElement('i', { key: 1, className: 'fa fa-undo clickable', title: 'Annuller', onClick: _this2.cancelEdit })] : [_react2.default.createElement('i', { key: 0, className: "fa fa-pencil " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Rediger r\xE6kke', onClick: function onClick() {
                                    if (_this2.state.editIx === null) {
                                        _this2.setState({
                                            Pointsystem: championshipRace.Pointsystem,
                                            KunSportsduer: championshipRace.KunSportsduer,
                                            AntalDuerPrSlag: championshipRace.AntalDuerPrSlag === null ? '' : championshipRace.AntalDuerPrSlag.toString(),
                                            editIx: championshipRace.Kapflyvningsnr
                                        });
                                    }
                                } }), _react2.default.createElement('i', { key: 1,
                                className: "fa fa-trash " + (_this2.state.editIx === null ? 'clickable' : 'disabled'), title: 'Slet fra mesterskab', onClick: function onClick() {
                                    if (_this2.state.editIx === null) (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                        'span',
                                        null,
                                        '\xD8nsker du at fjerne ',
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            raceString
                                        ),
                                        ' fra mesterskabet?'
                                    ), function () {
                                        _this2.props.dispatch(AdminActions.deleteChampionshipRace(championshipRace.MesterskabsId, championshipRace.Kapflyvningsnr, function () {
                                            _reactNotifications.NotificationManager.success('Kapflyvningen ' + raceString + ' er slettet fra mesterskabet', "Sletning", 4000);
                                            setTimeout(function () {
                                                var currentRow = document.getElementById('unpicked-row-' + championshipRace.Kapflyvningsnr);
                                                currentRow.scrollIntoView(false);
                                            });
                                        }));
                                    });
                                } })]
                        )
                    ));
                } else {
                    unpickedRows.push(_react2.default.createElement(
                        'div',
                        {
                            key: race.Nr,
                            id: "unpicked-row-" + race.Nr,
                            className: 'unpicked-row',
                            onDoubleClick: function onDoubleClick() {
                                _this2.props.dispatch(AdminActions.createChampionshipRace(_this2.props.championship.RecNr, race.Nr, function (entity) {
                                    _reactNotifications.NotificationManager.success('Kapflyvningen ' + raceString + ' er tilf\xF8jet til mesterskabet', "Oprettelse", 4000);
                                    setTimeout(function () {
                                        var currentRow = document.getElementById('picked-row-' + race.Nr);
                                        currentRow.scrollIntoView(false);
                                    });
                                }));
                            }
                        },
                        _react2.default.createElement(
                            'span',
                            { className: 'header' },
                            raceString
                        )
                    ));
                }
            });

            return _react2.default.createElement(
                'div',
                { className: "form-page championship-basics championship-races " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'outer-content upper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'inner-content unpicked-list' },
                        unpickedRows
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'outer-content lower' },
                    _react2.default.createElement(
                        'div',
                        { className: 'inner-content picked-table' },
                        _react2.default.createElement(
                            'table',
                            { className: 'data-table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Uge'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'KFK'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'LMU'
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sektion'
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sek.grupper'
                                    ) : null,
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sektioner'
                                    ) : null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Station'
                                    ),
                                    this.props.auth.currentRole === _UserRoles2.default.MAIN_ADMIN.id ? _react2.default.createElement(
                                        'th',
                                        null,
                                        'Pointsystem'
                                    ) : null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Sportsduer'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Duer pr slag'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                pickedRows
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ChampionshipRaces;
}(_react2.default.Component);

ChampionshipRaces.propTypes = {
    editMode: _propTypes2.default.bool,
    championship: _propTypes2.default.object.isRequired
};
ChampionshipRaces.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        auth: {
            currentRole: state.auth.currentRole,
            currentEntity: state.auth.currentEntity
        },
        admin: {
            stations: state.admin.stations
        },
        race: {
            isRacesRead: state.race.isRacesRead,
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ChampionshipRaces);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserFieldElement = __webpack_require__(6);

var _UserFieldElement2 = _interopRequireDefault(_UserFieldElement);

var _UserFieldDataTypeEnum = __webpack_require__(5);

var _UserFieldDataTypeEnum2 = _interopRequireDefault(_UserFieldDataTypeEnum);

var _admin = __webpack_require__(9);

var AdminActions = _interopRequireWildcard(_admin);

var _race = __webpack_require__(23);

var RaceActions = _interopRequireWildcard(_race);

var _lib = __webpack_require__(18);

var _confirmDialog = __webpack_require__(12);

var _reactNotifications = __webpack_require__(8);

var _reactRouterRedux = __webpack_require__(14);

var _routeconstants = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
    Ringnummer: ''
};

var ChampionshipPigeons = function (_React$Component) {
    _inherits(ChampionshipPigeons, _React$Component);

    function ChampionshipPigeons(props) {
        _classCallCheck(this, ChampionshipPigeons);

        var _this = _possibleConstructorReturn(this, (ChampionshipPigeons.__proto__ || Object.getPrototypeOf(ChampionshipPigeons)).call(this, props));

        _this.fields = [];

        _this.onRingNumberChange = function (e) {
            var string = /^[0-9]{9}$/.test(e.target.value) ? e.target.value.substr(0, 3) + '-' + e.target.value.substr(3, 2) + '-' + e.target.value.substr(5, 4) : e.target.value;
            var stateVariable = e.target.name;
            _this.setState(_defineProperty({}, stateVariable, string));
        };

        _this.allInputValid = function () {
            var result = true;
            _this.fields.forEach(function (field) {
                if (field && !field.isValid()) result = false;
            });
            return result;
        };

        _this.save = function () {
            if (_this.allInputValid()) {
                var entity = {
                    Ringnummer: _this.state.Ringnummer === '' ? null : _this.state.Ringnummer
                };
                _this.props.dispatch(AdminActions.createChampionshipPigeon(_this.props.championship.RecNr, entity, function () {
                    _this.fields[0].setState({ focused: false, visited: false });
                    _reactNotifications.NotificationManager.success('Ringnummeret ' + entity.Ringnummer + ' er tilmeldt mesterskabet.', "Oprettelse", 4000);
                    setTimeout(function () {
                        var currentRow = document.getElementById('pigeon-row-' + entity.Ringnummer);
                        currentRow.scrollIntoView(false);
                    });
                }));
            } else {
                _this.fields.forEach(function (field) {
                    field.setState({ visited: true });
                });
            }
        };

        _this.deleteAll = function () {
            (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                'span',
                null,
                '\xD8nsker du at slette alle ringnumre fra mesterskabet?'
            ), function () {
                _this.props.dispatch(AdminActions.deleteChampionshipPigeons(_this.props.championship.RecNr, function () {
                    _reactNotifications.NotificationManager.success('Ringnumre er slettet fra mesterskabet', "Sletning", 4000);
                }));
            });
        };

        _this.state = defaultState;
        return _this;
    }

    _createClass(ChampionshipPigeons, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.editMode || nextProps.championship === null && this.props.championship !== null || nextProps.championship !== null && (this.props.championship === null || this.props.championship.RecNr !== nextProps.championship.RecNr)) this.setState(defaultState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.championship) return null;

            var editMode = this.props.editMode;

            var pigeonRows = [];

            this.props.championship.MesterskabDues.sort(function (p1, p2) {
                if (p1.Ringnummer < p2.Ringnummer) return -1;
                if (p1.Ringnummer > p2.Ringnummer) return 1;
                return 0;
            }).forEach(function (pigeon) {
                pigeonRows.push(_react2.default.createElement(
                    'tr',
                    { key: pigeon.Ringnummer, id: 'pigeon-row-' + pigeon.Ringnummer },
                    _react2.default.createElement(
                        'td',
                        null,
                        pigeon.Ringnummer
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('i', { key: 0,
                            className: "fa fa-trash ", title: 'Slet fra mesterskab', onClick: function onClick() {
                                (0, _confirmDialog.confirm)("Slet", _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xD8nsker du at fjerne ringnummeret ',
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        pigeon.Ringnummer
                                    ),
                                    ' fra mesterskabet?'
                                ), function () {
                                    _this2.props.dispatch(AdminActions.deleteChampionshipPigeon(_this2.props.championship.RecNr, pigeon.Ringnummer, function () {
                                        _reactNotifications.NotificationManager.success('Ringnummeret ' + pigeon.Ringnummer + ' er slettet fra mesterskabet', "Sletning", 4000);
                                    }));
                                });
                            } })
                    )
                ));
            });

            return _react2.default.createElement(
                'div',
                {
                    className: "form-page championship-basics championship-pigeons " + (editMode ? "editable" : "read-only") },
                _react2.default.createElement(
                    'div',
                    { className: 'championship-pigeons-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'content left-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'block-content left-block' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Ringnummer'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form' },
                                _react2.default.createElement(_UserFieldElement2.default, {
                                    dataType: _UserFieldDataTypeEnum2.default.regex,
                                    placeholder: '',
                                    className: 'field150',
                                    containerClassName: 'display-inline-block',
                                    name: 'Ringnummer',
                                    id: 'Ringnummer',
                                    maxLength: '11',
                                    options: [{
                                        key: _UserFieldDataTypeEnum2.default.regex.REGEX_OPTION_KEY,
                                        value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}"
                                    }],
                                    value: this.state.Ringnummer,
                                    autoCheckErrors: true,
                                    required: true,
                                    hideErrWhenFocused: true,
                                    hideErrUntilFocused: true,
                                    onChange: this.onRingNumberChange,
                                    ref: function ref(instance) {
                                        _this2.fields[0] = instance;
                                    }
                                }),
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Tilf\xF8j ringnummer', onClick: this.save },
                                    'Tilf\xF8j'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'button-container' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn-primary', title: 'Slet alle ringnumre', onClick: this.deleteAll },
                                    'Slet alle'
                                )
                            )
                        )
                    ),
                    pigeonRows.length ? _react2.default.createElement(
                        'div',
                        { className: 'outer-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement(
                                'table',
                                { className: 'data-table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            'Deltagende ringnumre'
                                        ),
                                        _react2.default.createElement('th', null)
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    pigeonRows
                                )
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return ChampionshipPigeons;
}(_react2.default.Component);

ChampionshipPigeons.propTypes = {
    editMode: _propTypes2.default.bool,
    championship: _propTypes2.default.object.isRequired
};
ChampionshipPigeons.defaultProps = {
    editMode: false
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        race: {
            isRacesRead: state.race.isRacesRead,
            races: state.race.races
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(ChampionshipPigeons);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.requireAuthentication = requireAuthentication;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(14);

var _auth = __webpack_require__(61);

var AuthActions = _interopRequireWildcard(_auth);

var _globalerror = __webpack_require__(31);

var GlobalErrorActions = _interopRequireWildcard(_globalerror);

var _routeconstants = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
     On a page requiring login	Frontend logged in	Backend logged in	Expected behavior when auth.loginCheckSession called
     ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
     No				No			No			Nothing happens
     No				No			Yes			Nothing happens (or: frontend logs in)		        (reducer.LOGIN_USER_SUCCESS)				(This most often happens on: Page-reload)
     No				Yes			No			Nothing happens (or: frontend logs out)		        (reducer.LOGOUT_USER or LOGIN_USER_FAILURE)
     No				Yes			Yes			Nothing happens
     Yes			No			No			Redirect to signin
     Yes			No			Yes			Nothing happens + frontend logs in		        (reducer.LOGIN_USER_SUCCESS)				(This most often happens on: Page-reload)
     Yes			Yes			No			Redirect to signin + frontend logs out + shows dialog	(reducer.LOGOUT_USER or LOGIN_USER_FAILURE)
     Yes			Yes			Yes			Nothing happens

     Note: Only in the cases where "On a page requiring login" = "Yes", the code in class will be called.

     Also consider what happens, when a user is logged in and we get a response it 401 or 403 from an ajax call (see global error dialog) or if forceAuthRecheck discovers that the user is not logged in (the setInterval in app.js).
     In both cases it should logout the user and also display a dialog to the user that he has been logged out.
 */
function requireAuthentication(Component) {
    var AuthenticatedComponent = function (_React$Component) {
        _inherits(AuthenticatedComponent, _React$Component);

        function AuthenticatedComponent() {
            _classCallCheck(this, AuthenticatedComponent);

            return _possibleConstructorReturn(this, (AuthenticatedComponent.__proto__ || Object.getPrototypeOf(AuthenticatedComponent)).apply(this, arguments));
        }

        _createClass(AuthenticatedComponent, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var isOnServer = typeof window === "undefined"; // this is called server-side too - don't check auth during server-side rendering (it will fail). TODO: Make the authentication-check work with server-side-rendering too somehow
                if (!isOnServer) this.checkAuth(this.props.isAuthenticated, this.props.isAuthenticating, this.props.forceAuthRecheck, this.props.currentRole);
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                this.checkAuth(nextProps.isAuthenticated, nextProps.isAuthenticating, nextProps.forceAuthRecheck, nextProps.currentRole);
            }
        }, {
            key: 'checkAuth',
            value: function checkAuth(isAuthenticated, isAuthenticating, forceAuthRecheck, roleId) {
                var dispatch = this.props.dispatch;

                if (forceAuthRecheck) // always set this flag it back to false in the store if it was true
                    dispatch(AuthActions.setForceAuthRecheck(false));

                // if forceAuthRecheck, and the user has been logged out by the backend, display to the user that he has been logged out (and log him out of the frontend too)
                if (forceAuthRecheck && isAuthenticated && !isAuthenticating) {
                    // "!isAuthenticating" is a quick hack to avoid multiple dialogs from appearing at the same time (for each ajax request)
                    var onNotAuthenticated = function onNotAuthenticated() {
                        return dispatch(GlobalErrorActions.addGlobalError("Logget ud", "Du blev logget ud efter at have været inaktiv et stykke tid. Log venligst ind igen for at fortsætte."));
                    }; //("Logged out", "Sorry, you were logged out after being inactive for a while. Please log in again to continue.")); // TODO: Should also delete state (profile) if the user was forced-logged out (try going to signup page - the info from last logged in user is still there)
                    dispatch(AuthActions.loginCheckSession(onNotAuthenticated)); // if not authenticated anymore, we end back in this method (and become redirected to signin page)
                    return;
                }

                // if not logged in (according to the frontend), check the backend if user is actually logged in. If not logged in according to the backend either, redirect back to the login page.
                if (!isAuthenticated) {
                    var redirectAfterLogin = this.props.location.pathname;
                    var redirectSignInPage = redirectAfterLogin == "/" || redirectAfterLogin == "" ? _routeconstants.ROUTE_SIGNIN : _routeconstants.ROUTE_SIGNIN + ('?next=' + redirectAfterLogin);
                    // Check the backend-session and if the user is already logged in (according to the backend), log him in and automatically redirect
                    var _onNotAuthenticated = function _onNotAuthenticated() {
                        return dispatch((0, _reactRouterRedux.replace)(redirectSignInPage));
                    };
                    dispatch(AuthActions.loginCheckSession(_onNotAuthenticated));
                }

                // if authenticated, check if user has the role required to view the page. If not, redirect to the "home" page.
                var allowedRoles = Component.getAllowedRoles(); // empty array means allowed for everyone
                if (isAuthenticated && allowedRoles.length != 0 && !allowedRoles.some(function (r) {
                    return r.id & roleId;
                })) {
                    var _redirectAfterLogin = this.props.location.pathname;
                    var _redirectSignInPage = _redirectAfterLogin == "/" || _redirectAfterLogin == "" ? _routeconstants.ROUTE_SIGNIN : _routeconstants.ROUTE_SIGNIN + ('?next=' + _redirectAfterLogin);
                    // Check the backend-session and if the user is already logged in (according to the backend), log him in and automatically redirect
                    console.log("Not allowed!", roleId, allowedRoles);
                    dispatch((0, _reactRouterRedux.replace)(_redirectSignInPage)); // redirect to home
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    null,
                    this.props.isAuthenticated === true ? _react2.default.createElement(Component, this.props) : null
                );
            }
        }], [{
            key: 'getId',
            value: function getId() {
                return Component.getId();
            }
        }, {
            key: 'getAllowedRoles',
            value: function getAllowedRoles() {
                return Component.getAllowedRoles();
            }
        }]);

        return AuthenticatedComponent;
    }(_react2.default.Component);

    var mapStateToProps = function mapStateToProps(state) {
        return {
            roleId: state.auth.roleId,
            currentRole: state.auth.currentRole,
            isAuthenticated: state.auth.isAuthenticated,
            isAuthenticating: state.auth.isAuthenticating,
            forceAuthRecheck: state.auth.forceAuthRecheck,
            isMainAdmin: state.auth.isMainAdmin,
            isSectionAdmin: state.auth.isSectionAdmin,
            isClubAdmin: state.auth.isClubAdmin,
            clubNumber: state.auth.clubNumber
        };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(AuthenticatedComponent);
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(154);

var _reduxThunk = __webpack_require__(845);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _rootreducer = __webpack_require__(846);

var _rootreducer2 = _interopRequireDefault(_rootreducer);

var _reduxLogger = __webpack_require__(853);

var _reactRouterRedux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import loggerMiddleware from 'redux-logger';
function configureStore(history, initialState) {
    //const logger = loggerMiddleware();
    var logger = (0, _reduxLogger.createLogger)();
    var reactReduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);

    var middlewares = [_reduxThunk2.default, reactReduxRouterMiddleware];

    var isOnServer = typeof window === "undefined"; // to avoid having the store-updates spam the servers stdout (almost always makes debugging the server output harder, since there is so much noise in stdout)
    if (true && !isOnServer) {
        middlewares.push(logger);
    }

    var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, middlewares)(_redux.createStore);

    return createStoreWithMiddleware(_rootreducer2.default, initialState);
};

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(154);

var _reactRouterRedux = __webpack_require__(14);

var _actionconstants = __webpack_require__(35);

var _auth = __webpack_require__(847);

var _auth2 = _interopRequireDefault(_auth);

var _admin = __webpack_require__(848);

var _admin2 = _interopRequireDefault(_admin);

var _race = __webpack_require__(849);

var _race2 = _interopRequireDefault(_race);

var _user = __webpack_require__(850);

var _user2 = _interopRequireDefault(_user);

var _globalerror = __webpack_require__(851);

var _globalerror2 = _interopRequireDefault(_globalerror);

var _system = __webpack_require__(852);

var _system2 = _interopRequireDefault(_system);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducerWithoutLogout = (0, _redux.combineReducers)({
    routing: _reactRouterRedux.routerReducer,
    auth: _auth2.default,
    admin: _admin2.default,
    race: _race2.default,
    user: _user2.default,
    globalError: _globalerror2.default,
    system: _system2.default
});

var rootReducer = function rootReducer(state, action) {
    // see http://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
    if (action.type === _actionconstants.LOGOUT_USER) {
        var routing = state.routing;
        state = _initialstorestate2.default;
        state.routing = routing;
    }

    return rootReducerWithoutLogout(state, action);
};

exports.default = rootReducer;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducer;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

var _UserRoles = __webpack_require__(7);

var _UserRoles2 = _interopRequireDefault(_UserRoles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
//import {push} from 'redux-router';


var initialState = _initialstorestate2.default.auth;

exports.default = (0, _createreducer2.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actionconstants.LOGIN_USER_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isAuthenticating: true,
        statusText: null
    });
}), _defineProperty(_createReducer, _actionconstants.LOGIN_USER_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        isAuthenticating: false,
        isAuthenticated: true,
        roleId: payload.roleId,
        statusText: 'You have been successfully logged in.',
        // Drupal passport strategy.
        id: payload.id,
        displayName: payload.displayName,
        database: payload.database,
        emails: payload.emails,
        isMainAdmin: payload.isMainAdmin,
        isSectionAdmin: payload.isSectionAdmin,
        isClubAdmin: payload.isClubAdmin,
        clubNumber: payload.clubNumber,
        adminSections: payload.adminSections,
        adminClubs: payload.adminClubs,
        currentRole: payload.currentRole,
        currentEntity: payload.currentEntity
        // Local passport strategy.
        /*userId: payload.id,
        email: payload.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        photo: payload.photo,
        photoMimeType: payload.photoMimeType,*/
    });
}), _defineProperty(_createReducer, _actionconstants.LOGIN_USER_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        isAuthenticating: false,
        isAuthenticated: false,
        roleId: null,
        statusText: 'Authentication Error: ' + payload.status + ' ' + payload.statusText,
        // Drupal passport strategy.
        id: null,
        displayName: null,
        database: 'standard',
        emails: [],
        isMainAdmin: false,
        isSectionAdmin: false,
        isClubAdmin: false,
        clubNumber: null,
        adminSections: null,
        adminClubs: null,
        currentRole: null,
        currentEntity: null,
        // Local passport strategy.
        userId: null,
        email: null,
        firstName: "", // TODO: Or just copy from initial store state?
        lastName: "",
        photo: null,
        photoMimeType: null
    });
}), _defineProperty(_createReducer, _actionconstants.LOGOUT_USER, function (state, payload) {
    // This action is also handled in rootreducer.js to clear the state
    return Object.assign({}, state, {
        isAuthenticated: false,
        roleId: null,
        statusText: 'You have been successfully logged out.',
        // Drupal passport strategy.
        id: null,
        displayName: null,
        database: 'standard',
        emails: [],
        isMainAdmin: false,
        isSectionAdmin: false,
        isClubAdmin: false,
        clubNumber: null,
        adminSections: null,
        adminClubs: null,
        currentRole: null,
        currentEntity: null,
        // Local passport strategy.
        userId: null,
        email: null,
        firstName: "", // TODO: Or just copy from initial store state?
        lastName: "",
        photo: null,
        photoMimeType: null
    });
}), _defineProperty(_createReducer, _actionconstants.FORCE_AUTH_RECHECK, function (state, payload) {
    return Object.assign({}, state, {
        forceAuthRecheck: payload.mustRecheck
    });
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_GET_REQUEST, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_GET_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        userId: payload.id,
        email: payload.email,
        roleId: payload.roleId,
        firstName: payload.firstName,
        lastName: payload.lastName,
        photo: payload.photo,
        photoMimeType: payload.photoMimeType
    });
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_GET_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        statusText: payload.statusText,
        status: payload.status
    });
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_UPDATE_REQUEST, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_UPDATE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        userId: payload.id,
        email: payload.email,
        roleId: payload.roleId,
        firstName: payload.firstName,
        lastName: payload.lastName,
        photo: payload.photo,
        photoMimeType: payload.photoMimeType
    });
}), _defineProperty(_createReducer, _actionconstants.USER_PROFILE_UPDATE_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        statusText: payload.statusText,
        status: payload.status
    });
}), _defineProperty(_createReducer, _actionconstants.USER_CHANGE_PASSWORD_REQUEST, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_CHANGE_PASSWORD_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_CHANGE_PASSWORD_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        statusText: payload.statusText,
        status: payload.status
    });
}), _defineProperty(_createReducer, _actionconstants.USER_RESET_PASSWORD_REQUEST, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_RESET_PASSWORD_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {});
}), _defineProperty(_createReducer, _actionconstants.USER_RESET_PASSWORD_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        statusText: payload.statusText,
        status: payload.status
    });
}), _defineProperty(_createReducer, _actionconstants.ADMIN_SELECT_USER_ROLE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        currentRole: payload === "m" ? _UserRoles2.default.MAIN_ADMIN.id : payload.substr(0, 1) === "s" ? _UserRoles2.default.SECTION_ADMIN.id : payload.substr(0, 1) === "c" ? _UserRoles2.default.CLUB_ADMIN.id : null,
        currentEntity: payload === "m" ? null : payload.substr(0, 1) === "s" ? payload.substr(-2) : payload.substr(0, 1) === "c" ? payload.substr(-3) : null,
        database: "standard"
    });
}), _defineProperty(_createReducer, _actionconstants.ADMIN_SELECT_DATABASE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        database: payload
    });
}), _createReducer));

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducers;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

var _lib = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _initialstorestate2.default.user;

var updateSection = function updateSection(state, payload) {
    return Object.assign({}, state, {
        sections: state.sections.merge(_immutable2.default.Map([[payload.section.Sektionsnr, Object.assign({}, payload.section)]])),
        members: state.members.filter(function (member) {
            return member.Foreningsnr !== payload.contacts.Foreningsnr || payload.contacts.findIndex(function (sectionMember) {
                return sectionMember.Medlemsnr === member.Medlemsnr;
            }) >= 0;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.contacts.map(function (contact) {
            return [contact.Medlemsnr, Object.assign({}, contact)];
        }))),
        //.merge(Immutable.Map(typeof(payload.contacts) === 'undefined' ? [] : [[payload.contacts.Medlemsnr, Object.assign({}, payload.contacts)]])),
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.clubs.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        })))
    });
};

var updateSectionParameters = function updateSectionParameters(state, payload, sectionNo) {
    var stateSection = state.sections.get(sectionNo);
    return Object.assign({}, state, {
        sections: state.sections.merge(_immutable2.default.Map([[sectionNo, Object.assign({}, stateSection, payload)]]))
    });
};

var updateClubParameters = function updateClubParameters(state, payload, clubNo) {
    var stateClub = state.clubs.get(clubNo);
    return Object.assign({}, state, {
        clubs: state.clubs.merge(_immutable2.default.Map([[clubNo, Object.assign({}, stateClub, payload)]]))
    });
};

var updateSectionPrize = function updateSectionPrize(state, _ref) {
    var data = _ref.data,
        id = _ref.id;

    // if DDB
    if (id === 'ddb') {
        return Object.assign({}, state, {
            generalSection: Object.assign({}, state.generalSection, data)
        });
        // If regular section
    } else if (id.length === 2) {
        return updateSectionParameters(state, data, id);
    } else if (id.length === 3) {
        return updateClubParameters(state, data, id);
    }
};

var updateChampionship = function updateChampionship(state, payload) {
    payload.Mesterskabsflyvnings = _immutable2.default.Map(payload.Mesterskabsflyvnings.map(function (championshipRace) {
        return [championshipRace.Kapflyvningsnr, Object.assign({}, championshipRace)];
    }));
    payload.MesterskabDues = _immutable2.default.Map(payload.MesterskabDues.map(function (pigeon) {
        return [pigeon.Ringnummer, Object.assign({}, pigeon)];
    }));
    return Object.assign({}, state, {
        championships: state.championships.merge(_immutable2.default.Map([[payload.RecNr, Object.assign({}, payload)]]))
    });
};

var updateClub = function updateClub(state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.merge(_immutable2.default.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        members: state.members.filter(function (member) {
            return member.Foreningsnr !== payload.club.Foreningsnr || payload.members.findIndex(function (clubMember) {
                return clubMember.Medlemsnr === member.Medlemsnr;
            }) >= 0;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.members.map(function (member) {
            return [member.Medlemsnr, Object.assign({}, member)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.contacts.map(function (contact) {
            return [contact.Medlemsnr, Object.assign({}, contact)];
        }))).merge(_immutable2.default.Map(typeof payload.member === 'undefined' ? [] : [[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
        pigeonHoles: state.pigeonHoles.filter(function (hole) {
            return hole.Foreningsnr !== payload.club.Foreningsnr || payload.pigeonHoles.findIndex(function (clubHole) {
                return clubHole.Slagnr === hole.Slagnr;
            }) >= 0;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.pigeonHoles.map(function (hole) {
            return [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)];
        }))).merge(_immutable2.default.Map(typeof payload.pigeonHole === 'undefined' ? [] : [[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]]))
    });
};

var updatePigeons = function updatePigeons(state, payload) {
    return Object.assign({}, state, {
        pigeonHoles: state.pigeonHoles.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.Foreningsnr + '-' + payload.Slagnr, Object.assign({}, payload)]]))
    });
};

var updateOriginalAndNewClub = function updateOriginalAndNewClub(state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.merge(_immutable2.default.Map([[payload.originalClub.club.Foreningsnr, Object.assign({}, payload.originalClub.club)]])).merge(_immutable2.default.Map([[payload.newClub.club.Foreningsnr, Object.assign({}, payload.newClub.club)]])),
        members: state.members.filter(function (member) {
            return member.Foreningsnr !== payload.originalClub.club.Foreningsnr && member.Foreningsnr !== payload.newClub.club.Foreningsnr;
        } || payload.originalClub.members.findIndex(function (clubMember) {
            return clubMember.Medlemsnr === member.Medlemsnr;
        }) >= 0 || payload.newClub.members.findIndex(function (clubMember) {
            return clubMember.Medlemsnr === member.Medlemsnr;
        }) >= 0).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.originalClub.members.map(function (member) {
            return [member.Medlemsnr, Object.assign({}, member)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.originalClub.contacts.map(function (contact) {
            return [contact.Medlemsnr, Object.assign({}, contact)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.newClub.members.map(function (member) {
            return [member.Medlemsnr, Object.assign({}, member)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.newClub.contacts.map(function (contact) {
            return [contact.Medlemsnr, Object.assign({}, contact)];
        }))).merge(_immutable2.default.Map(typeof payload.member === 'undefined' ? [] : [[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
        pigeonHoles: state.pigeonHoles.filter(function (hole) {
            return hole.Foreningsnr !== payload.originalClub.club.Foreningsnr && hole.Foreningsnr !== payload.newClub.club.Foreningsnr;
        } || hole.Foreningsnr === payload.originalClub.club.Foreningsnr && payload.originalClub.pigeonHoles.findIndex(function (clubHole) {
            return clubHole.Foreningsnr === member.Foreningsnr && clubHole.Slagnr === member.Slagnr;
        }) >= 0 || hole.Foreningsnr === payload.newClub.club.Foreningsnr && payload.newClub.pigeonHoles.findIndex(function (clubHole) {
            return clubHole.Foreningsnr === member.Foreningsnr && clubHole.Slagnr === member.Slagnr;
        }) >= 0).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.originalClub.pigeonHoles.map(function (hole) {
            return [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.newClub.pigeonHoles.map(function (hole) {
            return [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)];
        }))).merge(_immutable2.default.Map(typeof payload.pigeonHole === 'undefined' ? [] : [[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]]))
    });
};

exports.default = (0, _createreducer2.default)(initialState, (_createReducers = {}, _defineProperty(_createReducers, _actionconstants.ADMIN_GET_BASICS_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isBasicsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_BASICS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        sections: state.sections.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.sections.map(function (section) {
            return [section.Sektionsnr, Object.assign({}, section)];
        }))).sort(function (s1, s2) {
            return s1.Sektionsnr < s2.Sektionsnr ? -1 : 1;
        }),
        ranges: state.ranges.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.ranges.map(function (range) {
            return [range.Omraadenr, Object.assign({}, range)];
        }))).sort(function (s1, s2) {
            return s1.Omraadenr < s2.Omraadenr ? -1 : 1;
        }),
        zipCodes: state.zipCodes.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.zipCodes.map(function (zip) {
            return [zip.Postnr, Object.assign({}, zip)];
        }))).sort(function (z1, z2) {
            return z1.Postnr < z2.Postnr ? -1 : 1;
        }),
        userRoles: payload.userRoles,
        isBasicsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CLUBS_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CLUBS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        }))),
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CLUB_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_MEMBERS_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isMembersRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_MEMBERS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.clubs.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        }))),
        isClubsRead: true,
        members: state.members.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.members.map(function (member) {
            return [member.Medlemsnr, Object.assign({}, member)];
        }))),
        isMembersRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_MEMBER_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, payload.club === null ? _immutable2.default.Map([]) : _immutable2.default.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        members: state.members.merge(_immutable2.default.Map([[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
        pigeonHoles: payload.pigeonHole === null ? state.pigeonHoles : state.pigeonHoles.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_PIGEON_HOLE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, payload.club === null ? _immutable2.default.Map([]) : _immutable2.default.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        pigeonHoles: state.pigeonHoles.merge(_immutable2.default.Map([[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CLUB_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.merge(_immutable2.default.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_CLUB_SUCCESS, function (state, payload) {
    return Object.assign({}, state, payload.originalClubNo === payload.club.Foreningsnr ? updateClub(state, payload) : {
        clubs: state.clubs.delete(payload.originalClubNo).merge(_immutable2.default.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        members: state.members.filter(function (member) {
            return member.Foreningsnr !== payload.originalClubNo && member.Foreningsnr !== payload.club.Foreningsnr;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.members.map(function (member) {
            return [member.Medlemsnr, Object.assign({}, member)];
        }))).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.contacts.map(function (contact) {
            return [contact.Medlemsnr, Object.assign({}, contact)];
        }))),
        pigeonHoles: state.pigeonHoles.filter(function (hole) {
            return hole.Foreningsnr !== payload.originalClubNo && hole.Foreningsnr !== payload.club.Foreningsnr;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.pigeonHoles.map(function (hole) {
            return [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)];
        })))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CLUB_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.delete(payload),
        members: state.members.filter(function (member) {
            return member.Foreningsnr !== payload;
        }),
        pigeonHoles: state.pigeonHoles.filter(function (hole) {
            return hole.Foreningsnr !== payload;
        })
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_MEMBER_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_MEMBER_SUCCESS, function (state, payload) {
    if (typeof payload.originalClub === 'undefined') return updateClub(state, payload);else return updateOriginalAndNewClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_MEMBER_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_PIGEONHOLE_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_PIGEONHOLE_SUCCESS, function (state, payload) {
    if (typeof payload.originalClub === 'undefined') return updateClub(state, payload);else return updateOriginalAndNewClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_PIGEONHOLE_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_PIGEON_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_PIGEON_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_PIGEON_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_PIGEONS_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_PIGEONS_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_PIGEONS_SUCCESS, function (state, payload) {
    return updatePigeons(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_RINGSERIE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.club, { ringSeries: payload.rings }]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_RINGSERIE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.club, { ringSeries: payload.rings }]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_RINGSERIE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: state.clubs.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.club, { ringSeries: payload.rings }]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_STATION_SELECTIONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        stations: state.stations.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.stations.map(function (station) {
            return [station.Stationsnr, Object.assign({}, station)];
        }))),
        stationSelections: state.stationSelections.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.selections.map(function (selection) {
            return [selection.target + '|' + selection.station, Object.assign({}, selection)];
        })))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SELECT_STATIONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        stationSelections: state.stationSelections.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.map(function (selection) {
            return [selection.target + '|' + selection.station, Object.assign({}, selection)];
        })))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UNSELECT_STATIONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        stationSelections: state.stationSelections.filter(function (selection) {
            return payload.findIndex(function (deleted) {
                return deleted.target === selection.target && deleted.station === selection.station;
            }) < 0;
        })
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: _immutable2.default.Map(payload.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        })),
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: _immutable2.default.Map(payload.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        })),
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: _immutable2.default.Map(payload.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        })),
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS, function (state, payload) {
    return updateClub(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_RESET_UPDATE_MARKINGS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        clubs: _immutable2.default.Map(payload.map(function (club) {
            return [club.Foreningsnr, Object.assign({}, club)];
        })),
        isClubsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_SECTIONS_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isSectionsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_SECTIONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        sections: state.sections.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.map(function (section) {
            return [section.Sektionsnr, Object.assign({}, section)];
        }))),
        isSectionsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_SECTION_SUCCESS, function (state, payload) {
    return updateSection(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_SECTION_SUCCESS, function (state, payload) {
    return updateSection(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_SECTION_SUCCESS, function (state, payload) {
    return updateSection(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_SECTION_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        sections: state.sections.delete(payload)
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_GENERAL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_GENERAL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_LIST_ITEMS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, _defineProperty({}, payload.state, state[payload.state].mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.data.map(function (entity) {
        return [entity[payload.key], Object.assign({}, entity)];
    })))));
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, _defineProperty({}, payload.state, state[payload.state].merge(_immutable2.default.Map([[payload.entity[payload.key], Object.assign({}, payload.entity)]]))));
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, _defineProperty({}, payload.state, state[payload.state].delete(payload.oldKeyValue).merge(_immutable2.default.Map([[payload.entity[payload.key], Object.assign({}, payload.entity)]]))));
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, _defineProperty({}, payload.state, state[payload.state].delete(payload.keyValue)));
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        errorLists: Object.assign({}, state.errorLists, _defineProperty({}, payload.state, state.errorLists[payload.state].mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.data.map(function (entity) {
            return [entity.id, Object.assign({}, entity)];
        })))))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        errorLists: Object.assign({}, state.errorLists, _defineProperty({}, payload.state, state.errorLists[payload.state].delete(payload.oldKey).merge(_immutable2.default.Map([[payload.data.id, Object.assign({}, payload.data)]]))))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        errorLists: Object.assign({}, state.errorLists, _defineProperty({}, payload.state, state.errorLists[payload.state].filter(function (entity) {
            return payload.deleted.indexOf(entity.id) < 0;
        })))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        errorLists: Object.assign({}, state.errorLists, _defineProperty({}, payload.state, state.errorLists[payload.state].filter(function (entity) {
            return payload.accepted.indexOf(entity.id) < 0;
        }).mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.failed.map(function (entity) {
            return [entity.data.id, Object.assign({}, entity.data)];
        })))))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_DEPOSIT_SUCCESS, function (state, payload) {
    if (payload.hasOwnProperty('section')) return updateSection(state, payload);else if (payload.hasOwnProperty('club')) return updateClub(state, payload);else return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_DEPOSIT_SUCCESS, function (state, payload) {
    if (payload.hasOwnProperty('section')) return updateSection(state, payload);else if (payload.hasOwnProperty('club')) return updateClub(state, payload);else return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_MARKING_SUCCESS, function (state, payload) {
    if (payload.hasOwnProperty('section')) return updateSection(state, payload);else if (payload.hasOwnProperty('club')) return updateClub(state, payload);else return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_MARKING_SUCCESS, function (state, payload) {
    if (payload.hasOwnProperty('section')) return updateSection(state, payload);else if (payload.hasOwnProperty('club')) return updateClub(state, payload);else return Object.assign({}, state, {
        generalSection: payload,
        isGeneralSectionRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_SECTION_PRIZE_SUCCESS, function (state, payload) {
    return updateSectionPrize(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_SECTION_PRIZE_SUCCESS, function (state, payload) {
    return updateSectionPrize(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_SECTION_PRIZE_SUCCESS, function (state, payload) {
    return updateSectionPrize(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_SECTION_PRIZE_SUCCESS, function (state, payload) {
    return updateSectionPrize(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_KILOMETERS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        kmFactors: payload
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_KILOMETER_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        kmFactors: payload
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_KILOMETER_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        kmFactors: payload
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_KILOMETER_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        kmFactors: payload
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CHAMPIONSHIPS_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isChampionshipsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CHAMPIONSHIPS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        championships: state.championships.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.map(function (championship) {
            return [championship.RecNr, Object.assign({}, championship)];
        }))),
        isChampionshipsRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_CHAMPIONSHIP_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        championships: state.championships.merge(_immutable2.default.Map([[payload.RecNr, Object.assign({}, payload)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        championships: state.championships.delete(payload)
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS, function (state, payload) {
    var championshipRaces = state.championships.get(payload.MesterskabsId).Mesterskabsflyvnings.merge(_immutable2.default.Map([[payload.Kapflyvningsnr, Object.assign({}, payload)]]));

    // creating a copy of the state, so it will not be directly modified
    var championships = state.championships;
    championships.get(payload.MesterskabsId).Mesterskabsflyvnings = championshipRaces;

    return Object.assign({}, state, {
        championships: championships
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS, function (state, payload) {
    var championshipRaces = state.championships.get(payload.MesterskabsId).Mesterskabsflyvnings.merge(_immutable2.default.Map([[payload.Kapflyvningsnr, Object.assign({}, payload)]]));

    // creating a copy of the state, so it will not be directly modified
    var championships = state.championships;
    championships.get(payload.MesterskabsId).Mesterskabsflyvnings = championshipRaces;

    return Object.assign({}, state, {
        championships: championships
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS, function (state, _ref2) {
    var championshipNo = _ref2.championshipNo,
        raceNo = _ref2.raceNo;

    var championshipRaces = state.championships.get(championshipNo).Mesterskabsflyvnings.delete(raceNo);

    // creating a copy of the state, so it will not be directly modified
    var championships = state.championships;
    championships.get(championshipNo).Mesterskabsflyvnings = championshipRaces;

    return Object.assign({}, state, {
        championships: championships
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS, function (state, payload) {
    var championshipRaces = state.championships.get(payload.MesterskabsId).MesterskabDues.merge(_immutable2.default.Map([[payload.Ringnummer, Object.assign({}, payload)]]));

    // creating a copy of the state, so it will not be directly modified
    var championships = state.championships;
    championships.get(payload.MesterskabsId).MesterskabDues = championshipRaces;

    return Object.assign({}, state, {
        championships: championships
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS, function (state, _ref3) {
    var championshipNo = _ref3.championshipNo,
        ringNo = _ref3.ringNo;

    var ringNumbers = state.championships.get(championshipNo).MesterskabDues.delete(ringNo);

    // creating a copy of the state, so it will not be directly modified
    var championships = state.championships;
    championships.get(championshipNo).MesterskabDues = ringNumbers;

    return Object.assign({}, state, {
        championships: championships
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS, function (state, payload) {
    return updateChampionship(state, payload);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_GET_DASHBOARD_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        archives: payload.archives.sort(function (db1, db2) {
            return db1 < db2 ? 1 : db1 > db2 ? -1 : 0;
        })
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_START_SEASON_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        isChampionshipsRead: false,
        championships: new _immutable2.default.Map()
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CALC_SEATS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        generalSection: Object.assign({}, state.generalSection, payload)
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SELECT_USER_ROLE_SUCCESS, function (state, _ref4) {
    var championshipNo = _ref4.championshipNo,
        ringNo = _ref4.ringNo;

    return Object.assign({}, _initialstorestate2.default.admin, { archives: state.archives, userRoles: state.userRoles });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SELECT_DATABASE_SUCCESS, function (state, _ref5) {
    var championshipNo = _ref5.championshipNo,
        ringNo = _ref5.ringNo;

    return Object.assign({}, _initialstorestate2.default.admin, { archives: state.archives, userRoles: state.userRoles });
}), _createReducers));

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducers;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

var _lib = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _initialstorestate2.default.race;

exports.default = (0, _createreducer2.default)(initialState, (_createReducers = {}, _defineProperty(_createReducers, _actionconstants.RACE_GET_ALL_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isRacesRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_GET_ALL_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        races: state.races.mergeWith(_lib.mergeFunction, _immutable2.default.Map(payload.map(function (race) {
            return [race.Nr, Object.assign({}, race)];
        }))),
        isRacesRead: true
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_GET_DETAILS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        races: state.races.mergeWith(_lib.mergeFunction, _immutable2.default.Map([[payload.race.Nr, Object.assign({}, payload.race)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CREATE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        races: state.races.merge(_immutable2.default.Map([[payload.race.Nr, Object.assign({}, payload.race)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        races: state.races.merge(_immutable2.default.Map([[payload.race.Nr, Object.assign({}, payload.race)]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_DELETE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        races: state.races.delete(payload)
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_GET_PIGEONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, {
            night: payload.racePigeons.night,
            pigeonholes: _immutable2.default.Map(payload.racePigeons.pigeonholes.map(function (pigeonhole) {
                return [pigeonhole.Slagnr, {
                    Slagnr: pigeonhole.Slagnr,
                    Slagnavn: pigeonhole.Slagnavn,
                    Afstand: pigeonhole.Afstand,
                    Slagspil: pigeonhole.Slagspil,
                    Forfald: pigeonhole.Forfald,
                    pigeons: _immutable2.default.Map(pigeonhole.pigeons.map(function (pigeon) {
                        return [pigeon.Ringnummer, pigeon];
                    })),
                    activePigeons: _immutable2.default.Map(pigeonhole.activePigeons.map(function (pigeon) {
                        return [pigeon.Ringnummer, pigeon];
                    })),
                    watches: _immutable2.default.Map(pigeonhole.watches.map(function (watch) {
                        return [watch.Urnr, watch];
                    }))
                }];
            }))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CREATE_PIGEON_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.merge(_immutable2.default.Map([[payload.pigeon.Ringnummer, payload.pigeon]]))
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_PIGEON_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.delete(payload.originalRing).merge(_immutable2.default.Map([[payload.pigeon.Ringnummer, payload.pigeon]]))
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_DELETE_PIGEON_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.delete(payload.ring)
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CREATE_WATCH_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.merge(_immutable2.default.Map([[payload.watch.Urnr, payload.watch]]))
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_WATCH_SUCCESS, function (state, payload) {
    if (payload.originalPigeonhole === payload.pigeonhole) return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.delete(payload.originalWatch).merge(_immutable2.default.Map([[payload.watch.Urnr, payload.watch]]))
            })]]))
        })]]))
    });else return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.originalPigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.originalPigeonhole), {
                watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.originalPigeonhole).watches.delete(payload.originalWatch)
            })], [payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.merge(_immutable2.default.Map([[payload.watch.Urnr, payload.watch]]))
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_DELETE_WATCH_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(_immutable2.default.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.delete(payload.watch)
            })]]))
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_ADD_MEMBER_GAMES_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(function (pigeonhole) {
                return Object.assign({}, pigeonhole, {
                    Slagspil: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Slagspil : true
                });
            })
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_REMOVE_MEMBER_GAMES_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(function (pigeonhole) {
                return Object.assign({}, pigeonhole, {
                    Slagspil: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Slagspil : false
                });
            })
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_ADD_DECAYS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(function (pigeonhole) {
                return Object.assign({}, pigeonhole, {
                    Forfald: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Forfald : true
                });
            })
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_REMOVE_DECAYS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePigeons: state.racePigeons.merge(_immutable2.default.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
            pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(function (pigeonhole) {
                return Object.assign({}, pigeonhole, {
                    Forfald: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Forfald : false
                });
            })
        })]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_GET_PRICES_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, {
            kontant: _immutable2.default.Map(payload.prices.kontant.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            slagspil: _immutable2.default.Map(payload.prices.slagspil.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            espil: _immutable2.default.Map(payload.prices.espil.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            pspil: _immutable2.default.Map(payload.prices.pspil.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            zspil: _immutable2.default.Map(payload.prices.zspil.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            dm: _immutable2.default.Map(payload.prices.dm.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            slag: _immutable2.default.Map(payload.prices.slag.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            serie: _immutable2.default.Map(payload.prices.serie.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            derby: _immutable2.default.Map(payload.prices.derby.map(function (price) {
                return [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal
                }];
            })),
            kontantAdditions: _immutable2.default.Map(payload.prices.kontantAdditions.map(function (price) {
                return [price.Sektionsnr, price];
            }))
        }]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CREATE_PRICE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type, state.racePrices.get(payload.race)[payload.type].merge(_immutable2.default.Map([[payload.price.Sektion + '/' + payload.price.Vaerdi, payload.price]]))))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_PRICE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type, state.racePrices.get(payload.race)[payload.type].delete(payload.originalSection + '/' + payload.originalValue).merge(_immutable2.default.Map([[payload.price.Sektion + '/' + payload.price.Vaerdi, payload.price]]))))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_DELETE_PRICE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type, state.racePrices.get(payload.race)[payload.type].delete(payload.section + '/' + payload.value)))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_PRICE_ADDITIONS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type + 'Additions', _immutable2.default.Map(payload.prices.map(function (price) {
            return [price.Sektionsnr, price];
        }))))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_RESET_PRICES_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type, _immutable2.default.Map(payload.prices.map(function (price) {
            return [price.Sektion + '/' + price.Vaerdi, price];
        }))))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CALC_PRICES_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        racePrices: state.racePrices.merge(_immutable2.default.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), _defineProperty({}, payload.type, _immutable2.default.Map(payload.prices.map(function (price) {
            return [price.Sektion + '/' + price.Vaerdi, price];
        }))))]]))
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_GET_BASICS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        deposits: _immutable2.default.Map(payload.deposits.map(function (deposit) {
            return [deposit.Sektionsnr, Object.assign({}, deposit)];
        })),
        markings: _immutable2.default.Map(payload.markings.map(function (marking) {
            return [marking.Sektionsnr, Object.assign({}, marking)];
        }))
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_DEPOSIT_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        deposits: new _immutable2.default.Map()
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_DEPOSIT_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        deposits: new _immutable2.default.Map()
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_CREATE_MARKING_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        markings: new _immutable2.default.Map()
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_UPDATE_MARKING_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        markings: new _immutable2.default.Map()
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_START_DEVICE_IMPORT_REQUEST, function (state, payload) {
    if (payload.input.requestType === 'version') return Object.assign({}, state, {
        deviceImporterVersion: null,
        deviceComPorts: ''
    });else return Object.assign({}, state);
}), _defineProperty(_createReducers, _actionconstants.RACE_START_DEVICE_IMPORT_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        deviceImports: state.deviceImports.merge([[payload.id, payload]])
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_UPDATE_DEVICE_IMPORT_SUCCESS, function (state, payload) {
    if (payload.info === "cancelled") return Object.assign({}, state, {
        deviceImports: state.deviceImports.delete(payload.id)
    });else return Object.assign({}, state);
}), _defineProperty(_createReducers, _actionconstants.RACE_CHECK_DEVICE_IMPORT_SUCCESS, function (state, payload) {
    if (payload.ended === null) return Object.assign({}, state);else if (payload.requestType === 'version') return Object.assign({}, state, {
        deviceImports: state.deviceImports.delete(payload.id),
        deviceImporterVersion: payload.info === "success" ? payload.data.split(' ')[0] : "-",
        deviceComPorts: payload.info === "success" && payload.data.includes(' ') ? ':' + payload.data.split(' ')[1].toLowerCase() + ':' : ''
    });else return Object.assign({}, state, {
        deviceImports: state.deviceImports.delete(payload.id)
    });
}), _defineProperty(_createReducers, _actionconstants.RACE_CHECK_DEVICE_IMPORT_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        deviceImports: state.deviceImports.delete(payload.id)
    });
}), _defineProperty(_createReducers, _actionconstants.ADMIN_START_SEASON_SUCCESS, function (state, _ref) {
    var championshipNo = _ref.championshipNo,
        ringNo = _ref.ringNo;

    return Object.assign({}, _initialstorestate2.default.race);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SELECT_USER_ROLE_SUCCESS, function (state, _ref2) {
    var championshipNo = _ref2.championshipNo,
        ringNo = _ref2.ringNo;

    return Object.assign({}, _initialstorestate2.default.race);
}), _defineProperty(_createReducers, _actionconstants.ADMIN_SELECT_DATABASE_SUCCESS, function (state, _ref3) {
    var championshipNo = _ref3.championshipNo,
        ringNo = _ref3.ringNo;

    return Object.assign({}, _initialstorestate2.default.race);
}), _createReducers));

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducers;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _initialstorestate2.default.user;

exports.default = (0, _createreducer2.default)(initialState, (_createReducers = {}, _defineProperty(_createReducers, _actionconstants.USER_CREATE_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isCreating: true,
        isCreated: false,
        isSaving: true,
        statusText: null,
        username: null
    });
}), _defineProperty(_createReducers, _actionconstants.USER_CREATE_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        isCreating: false,
        isCreated: true,
        isSaving: false,
        username: payload.username,
        statusText: 'Your account has been created.'
    });
}), _defineProperty(_createReducers, _actionconstants.USER_CREATE_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        isCreating: false,
        isCreated: false,
        isSaving: false,
        statusText: payload.statusText,
        username: null
    });
}), _defineProperty(_createReducers, _actionconstants.USER_PROFILE_UPDATE_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isSaving: true
    });
}), _defineProperty(_createReducers, _actionconstants.USER_PROFILE_UPDATE_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        isSaving: false
    });
}), _defineProperty(_createReducers, _actionconstants.USER_PROFILE_UPDATE_SUCCESS, function (state, payload) {
    // NOTE!! This is both here and in the Auth reducer. Needed to update the user sub-store after editing when returning to the profile page. (This is probably a hack? In a hurry...)
    return Object.assign({}, state, {
        users: state.users.mergeWith(function (oldData, newData) {
            return Object.assign(oldData, newData);
        }, _immutable2.default.Map([[payload.id, payload]])),
        isSaving: false
    });
}), _defineProperty(_createReducers, _actionconstants.USER_UPDATE_REQUEST, function (state, payload) {
    return Object.assign({}, state, {
        isSaving: true
    });
}), _defineProperty(_createReducers, _actionconstants.USER_UPDATE_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        isSaving: false
    });
}), _defineProperty(_createReducers, _actionconstants.USER_UPDATE_SUCCESS, function (state, payload) {
    // Same as above
    return Object.assign({}, state, {
        users: state.users.mergeWith(function (oldData, newData) {
            return Object.assign(oldData, newData);
        }, _immutable2.default.Map([[payload.id, payload]])),
        isSaving: false
    });
}), _defineProperty(_createReducers, _actionconstants.USER_GET_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        users: state.users.mergeWith(function (oldData, newData) {
            return Object.assign(oldData, newData);
        }, _immutable2.default.Map([[payload.id, payload]]))
    });
}), _defineProperty(_createReducers, _actionconstants.USER_GET_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        statusText: payload.statusText,
        status: payload.status
    });
}), _defineProperty(_createReducers, _actionconstants.CHECK_EMAIL_EXISTS_REQUEST, function (state) {
    return Object.assign({}, state, {
        emailExists: { name: null, exists: false }
    });
}), _defineProperty(_createReducers, _actionconstants.CHECK_EMAIL_EXISTS_SUCCESS, function (state, payload) {
    return Object.assign({}, state, {
        emailExists: { name: payload.name, exists: payload.exists }
    });
}), _defineProperty(_createReducers, _actionconstants.CHECK_EMAIL_EXISTS_FAILURE, function (state, payload) {
    return Object.assign({}, state, {
        emailExists: { name: null, exists: false },
        statusText: payload.statusText,
        status: payload.status
    });
}), _createReducers));

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducers;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _initialstorestate2.default.globalError;

exports.default = (0, _createreducer2.default)(initialState, (_createReducers = {}, _defineProperty(_createReducers, _actionconstants.ADD_GLOBAL_ERROR, function (state, payload) {
    return Object.assign({}, state, {
        errors: state.errors.push(payload)
    });
}), _defineProperty(_createReducers, _actionconstants.REMOVE_GLOBAL_ERROR, function (state, payload) {
    var errorIdToRemove = payload.errorId;
    return Object.assign({}, state, {
        errors: state.errors.filter(function (e) {
            return e.errorId != errorIdToRemove;
        }) // remove the error with errorId = payload.errorId from the list
    });
}), _defineProperty(_createReducers, _actionconstants.REMOVE_ALL_GLOBAL_ERRORS, function (state, payload) {
    return Object.assign({}, state, {
        errors: new _immutable2.default.List()
    });
}), _createReducers));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createReducers;

var _immutable = __webpack_require__(45);

var _immutable2 = _interopRequireDefault(_immutable);

var _createreducer = __webpack_require__(90);

var _createreducer2 = _interopRequireDefault(_createreducer);

var _actionconstants = __webpack_require__(35);

var _initialstorestate = __webpack_require__(63);

var _initialstorestate2 = _interopRequireDefault(_initialstorestate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _initialstorestate2.default.system;

exports.default = (0, _createreducer2.default)(initialState, (_createReducers = {}, _defineProperty(_createReducers, _actionconstants.SYSTEM_LOCATION_CHANGED, function (state, payload) {
    return Object.assign({}, state, {
        locationPath: payload.location.pathname
    });
}), _defineProperty(_createReducers, _actionconstants.SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE, function (state, payload) {
    return Object.assign({}, state, {
        imageCacheBreaker: payload.value
    });
}), _createReducers));

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// removed by extract-text-webpack-plugin


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js